webpackJsonp([0,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(0);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(441);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(325));
__export(__webpack_require__(324));
__export(__webpack_require__(327));
__export(__webpack_require__(82));
__export(__webpack_require__(185));
__export(__webpack_require__(81));
__export(__webpack_require__(326));
__export(__webpack_require__(43));
__export(__webpack_require__(328));
__export(__webpack_require__(188));
__export(__webpack_require__(332));
__export(__webpack_require__(333));
__export(__webpack_require__(330));
__export(__webpack_require__(329));
__export(__webpack_require__(337));
__export(__webpack_require__(340));
__export(__webpack_require__(341));
__export(__webpack_require__(338));
__export(__webpack_require__(339));
__export(__webpack_require__(335));
__export(__webpack_require__(334));
__export(__webpack_require__(336));
__export(__webpack_require__(186));
__export(__webpack_require__(187));
__export(__webpack_require__(190));
__export(__webpack_require__(342));
__export(__webpack_require__(189));
__export(__webpack_require__(343));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(25);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(108);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(438);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(233);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.CONSTANTS = {
    ALL: 'ALL',
    CREATED: 'CREATED',
    FINISHED: 'FINISHED',
    DELETED: 'DELETED',
    SUCCESS: 'SUCCESS',
    REJECTED: 'REJECTED',
    CONFORME: 'CONFORME',
    NOTCONFORME: 'NOTCONFORME',
    RESERVED: 'RESERVED',
    FAVORABLE: 'FAVORABLE',
    NOTFAVORABLE: 'NOTFAVORABLE',
    AWAITING: 'AWAITING',
    CONFIRMED: 'CONFIRMED',
    DESISTED: 'DESISTED',
    CIVILITE: 'CIVILITE',
    SCOLARITE: 'SCOLARITE',
    FORMATION: 'FORMATION',
    PIECES: 'PIECES',
    RESULTAT: 'RESULTAT',
    TYPE_EI: 'TYPE_EI',
    AVIS: 'AVIS',
    PREAVIS: 'TYPE_PREAVIS',
    ETAT: 'ETAT',
    AUTRE: 'AUTRE',
    AUTRES: 'AUTRES',
    FC: 'FC',
    MASTER: 'MASTER',
    CPES: 'CPES',
    DIPLOME: 'DIPLOME',
    INTERNATIONAL: 'INTERNATIONAL',
    GENERAL: 'GENERAL',
    SERVICE: 'SERVICE',
    REGISTER_CONFIRMATION: 'register_confirmation',
    FAQ: 'FAQ',
    COMMENTAIRE: 'COMMENTAIRE',
    ECHELON: 'ECHELON',
    STATUT_ENSCOL: 'STATUT_ENSCOL',
    CONFIRMATION: 'CONFIRMATION',
    ESPACECANDIDAT: 'espaceCandidat',
    ESPACE_CONNEXION: 'ESPACE_CONNEXION',
    VDIP_ANNEE: 'VDIP_ANNEE',
    DISCIPLINE_ECH_INT: 'DISCIPLINE_ECH_INT',
    CANDIDATURES: 'candidatures',
    CANDIDATURE: 'candidature',
    FORMATIONS: 'formations',
    NIVEAU: 'NIVEAU',
    MENTION: 'MENTION',
    PARCOURS: 'PARCOURS',
    DISCIPLINE: 'DISCIPLINE',
    FORMULAIRE_RECOMMANDATION: 'FormulaireRecommandationENS',
    PROGRAMME_EM_LYON_ID: 9996,
    DOUBLE_CURSUS_ID: 9997,
    DOUBLE_CURSUS_HUMANITES_ID: 9995,
    ECHANGE_INTERNATIONAL_ID: 9998,
    CONTACT_PEDAGO: 'CONTACT_PEDAGO',
    CONTACT_ADMIN: 'CONTACT_ADMIN',
    NONE: 'NONE',
    CASPARTICULIER: 'CASPARTICULIER',
    NON_CONCERNE: 0,
    EN_ECHANGE: 1,
    HORS_ECHANGE: 2,
    MENTION_ATTENTE_RESULTAT_CODE: 0,
    URL_EN_SAVOIR_PLUS_DIPLOME: "URL_EN_SAVOIR_PLUS_DIPLOME"
};
exports.CodeTypeEtablissement = [
    'FRANCAIS', 'EFE', 'ETRANGER'
];


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(71));
__export(__webpack_require__(70));
__export(__webpack_require__(25));
__export(__webpack_require__(160));
__export(__webpack_require__(161));
__export(__webpack_require__(163));
__export(__webpack_require__(277));
__export(__webpack_require__(274));
__export(__webpack_require__(275));
__export(__webpack_require__(278));
__export(__webpack_require__(72));
__export(__webpack_require__(279));
__export(__webpack_require__(165));
__export(__webpack_require__(162));
__export(__webpack_require__(164));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(443);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(175));
__export(__webpack_require__(75));
__export(__webpack_require__(174));
__export(__webpack_require__(304));
__export(__webpack_require__(173));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TypeNationaliteEnumeration;
(function (TypeNationaliteEnumeration) {
    TypeNationaliteEnumeration[TypeNationaliteEnumeration["Unknown"] = 0] = "Unknown";
    TypeNationaliteEnumeration[TypeNationaliteEnumeration["France"] = 1] = "France";
    TypeNationaliteEnumeration[TypeNationaliteEnumeration["EuropeNonFrance"] = 2] = "EuropeNonFrance";
    TypeNationaliteEnumeration[TypeNationaliteEnumeration["NonEurope"] = 3] = "NonEurope";
})(TypeNationaliteEnumeration = exports.TypeNationaliteEnumeration || (exports.TypeNationaliteEnumeration = {}));
var CandidatureFormation = (function () {
    // noinspection JSUnusedGlobalSymbols
    function CandidatureFormation(id, oldId, oldCfId, libelle, pageEdition, fc, ects, ordre, responseRang, avisRang, dateCreation, dateModification, dateSuppression, dateValidation, dateSortieLC, dateConfirmation, dateDesistement, userId, formationId, categorieFormationId, categorieFormation, commissionId, commission, responseId, response, conformeId, conforme, commentaireId, commentaire, commentaireLibre, persId, avisId, avis, statutId, statut, mentionId, parcoursId, disciplineId, discipline, niveauId, candidatureId, candidat, bourse, echelon, nom, prenom, civilite, dateNaissance, paysNationalite, typeNationalite, reinscription, email, telephoneFixe, dernierCursus, niveauAccessDiplomeLibelle, saved, ei, reponseMajorDiscipline, controleIdentiteAdmis, choixConfirmation, indicBourseExcellence, bourseExcellence, 
        // sont chargés dynamiquement si nécessaire
        formation, reponses, listePreavis, ordreModifiable, userEnEchange, inscriptionsEnscol, inscriptionsEnscolString, statutEnscol) {
        this.id = id;
        this.oldId = oldId;
        this.oldCfId = oldCfId;
        this.libelle = libelle;
        this.pageEdition = pageEdition;
        this.fc = fc;
        this.ects = ects;
        this.ordre = ordre;
        this.responseRang = responseRang;
        this.avisRang = avisRang;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
        this.dateSuppression = dateSuppression;
        this.dateValidation = dateValidation;
        this.dateSortieLC = dateSortieLC;
        this.dateConfirmation = dateConfirmation;
        this.dateDesistement = dateDesistement;
        this.userId = userId;
        this.formationId = formationId;
        this.categorieFormationId = categorieFormationId;
        this.categorieFormation = categorieFormation;
        this.commissionId = commissionId;
        this.commission = commission;
        this.responseId = responseId;
        this.response = response;
        this.conformeId = conformeId;
        this.conforme = conforme;
        this.commentaireId = commentaireId;
        this.commentaire = commentaire;
        this.commentaireLibre = commentaireLibre;
        this.persId = persId;
        this.avisId = avisId;
        this.avis = avis;
        this.statutId = statutId;
        this.statut = statut;
        this.mentionId = mentionId;
        this.parcoursId = parcoursId;
        this.disciplineId = disciplineId;
        this.discipline = discipline;
        this.niveauId = niveauId;
        this.candidatureId = candidatureId;
        this.candidat = candidat;
        this.bourse = bourse;
        this.echelon = echelon;
        this.nom = nom;
        this.prenom = prenom;
        this.civilite = civilite;
        this.dateNaissance = dateNaissance;
        this.paysNationalite = paysNationalite;
        this.typeNationalite = typeNationalite;
        this.reinscription = reinscription;
        this.email = email;
        this.telephoneFixe = telephoneFixe;
        this.dernierCursus = dernierCursus;
        this.niveauAccessDiplomeLibelle = niveauAccessDiplomeLibelle;
        this.saved = saved;
        this.ei = ei;
        this.reponseMajorDiscipline = reponseMajorDiscipline;
        this.controleIdentiteAdmis = controleIdentiteAdmis;
        this.choixConfirmation = choixConfirmation;
        this.indicBourseExcellence = indicBourseExcellence;
        this.bourseExcellence = bourseExcellence;
        this.formation = formation;
        this.reponses = reponses;
        this.listePreavis = listePreavis;
        this.ordreModifiable = ordreModifiable;
        this.userEnEchange = userEnEchange;
        this.inscriptionsEnscol = inscriptionsEnscol;
        this.inscriptionsEnscolString = inscriptionsEnscolString;
        this.statutEnscol = statutEnscol;
    }
    return CandidatureFormation;
}());
exports.CandidatureFormation = CandidatureFormation;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(281));
__export(__webpack_require__(280));
__export(__webpack_require__(291));
__export(__webpack_require__(166));
__export(__webpack_require__(282));
__export(__webpack_require__(284));
__export(__webpack_require__(283));
__export(__webpack_require__(285));
__export(__webpack_require__(293));
__export(__webpack_require__(295));
__export(__webpack_require__(297));
__export(__webpack_require__(296));
__export(__webpack_require__(292));
__export(__webpack_require__(286));
__export(__webpack_require__(287));
__export(__webpack_require__(289));
__export(__webpack_require__(290));
__export(__webpack_require__(294));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(251);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
exports.CALENDAR_FR = {
    'firstDayOfWeek': 1,
    'dayNames': ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    'dayNamesShort': ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    'dayNamesMin': ['D', 'L', 'MA', 'ME', 'J', 'V', 'S'],
    'monthNames': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    'monthNamesShort': ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec']
};
exports.CALENDAR_EN = {
    'firstDayOfWeek': 1,
    'dayNames': ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
    'dayNamesShort': ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    'dayNamesMin': ['SU', 'M', 'TU', 'W', 'TH', 'F', 'SA'],
    'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'monthNamesShort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(398);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(78);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var cadens_constants_1 = __webpack_require__(8);
var candidature_formation_order_model_1 = __webpack_require__(131);
var CandidatureFormationService = (function () {
    function CandidatureFormationService(http) {
        this.http = http;
        this.resourceUrl = 'api/candidature-formations';
        this.resourceQuestionUrl = 'api/candidature-formations/questions';
        this.candidatureOrdreUrl = 'api/candidature-formations-order';
        this.resourceReinscritsUrl = 'api/lastFormation';
        this.resourceCommissions = 'api/candidature-formations/commissions';
        this.resourceVerification = 'api/candidature-formations/verification';
        this.generatepdf = '/generatepdf';
        this.genererContratEtudeInternationalUrl = '/genererContratEtudeInternational';
        this.genererLettreAdmissionUrl = '/genererLettreAdmission';
        this.status = '-status';
        this.order = '-order';
        this.exportPdfNormal = 1;
        this.exportPdfRentree = 2;
    }
    CandidatureFormationService.prototype.create = function (candidature) {
        var copy = Object.assign({}, candidature);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.update = function (candidatureFormation, forceTransmit, fullValidation) {
        var copy = Object.assign({}, candidatureFormation);
        copy.dateModification = new Date();
        return this.http.put(this.resourceUrl + "/" + forceTransmit + "/" + fullValidation, copy).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.verifierCandidature = function (candidatureFormationId, envoyerException) {
        return this.http.get(this.resourceVerification + "/" + candidatureFormationId + "/" + envoyerException).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.updateCandidaturesStatus = function (candidatureFormations, options) {
        var copy = candidatureFormations.splice(0);
        copy.forEach(function (cf) {
            cf.dateModification = new Date();
            //ajout du choix du user: attestation honneur ou de démission
            if (options && options.choix) {
                cf.choixConfirmation = options.choix;
            }
            if (options && options.response) {
                cf.response = options.response;
            }
            if (options && options.avis) {
                cf.avis = options.avis;
            }
            if (options && options.commentaire) {
                cf.commentaire = options.commentaire;
            }
            if (options && options.avisRang) {
                cf.avisRang = options.avisRang;
            }
            if (options && options.conforme) {
                cf.conforme = options.conforme;
            }
            if (options && options.statut) {
                cf.statut = options.statut;
                if (options.statut == cadens_constants_1.CONSTANTS.DESISTED) {
                    cf.dateDesistement = new Date();
                }
                else if (options.statut == cadens_constants_1.CONSTANTS.CONFIRMED) {
                    cf.dateConfirmation = new Date();
                }
            }
        });
        return this.http.put(this.resourceUrl + this.status, copy).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.updateCandidaturesOrder = function (candidatureFormations) {
        var orderList = [];
        candidatureFormations.forEach(function (candidatureFormations) {
            var orderModifie = new candidature_formation_order_model_1.CandidatureFormationOrder();
            orderModifie.id = candidatureFormations.id;
            orderModifie.ordre = candidatureFormations.ordre;
            orderList.push(orderModifie);
        });
        return this.http.put(this.resourceUrl + this.order, orderList).map(function (res) {
            return res.json();
        });
    };
    /**
     * Generate the PDF file of ONE candidature from the candidatureFormation ID
     */
    CandidatureFormationService.prototype.generatePDF = function (id, isUser, pdfType) {
        var params = new http_1.URLSearchParams();
        params.set('isUser', isUser + '');
        params.set('pdfType', pdfType + '');
        return this.http.get(this.resourceUrl + '/' + id + this.generatepdf, { search: params, responseType: http_1.ResponseContentType.Blob }).map(function (res) {
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    /**
     * Generate the ZIP of the pdf files of EACH candidatures from the candidatureFormation IDs
     */
    CandidatureFormationService.prototype.generatePDFs = function (ids, isUser, pdfType) {
        var params = new http_1.URLSearchParams();
        params.set('isUser', isUser + '');
        params.set('pdfType', pdfType + '');
        params.set('ids', ids + '');
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/zip; charset=utf-8');
        headers.append('Accept', 'application/zip');
        return this.http.get(this.resourceUrl + this.generatepdf, {
            // headers: headers,
            search: params,
            responseType: http_1.ResponseContentType.Blob
        }).map(function (res) { return new Blob([res.blob()], { type: 'application/zip' }); });
    };
    CandidatureFormationService.prototype.find = function (id, recalculateEi) {
        var params = new http_1.URLSearchParams();
        params.set('recalculateEi', recalculateEi.toString());
        return this.http.get(this.resourceUrl + "/" + id, { search: params }).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.findQuestions = function (candidatureId) {
        var params = new http_1.URLSearchParams();
        params.set('candidatureId', candidatureId.toString());
        return this.http.get(this.resourceQuestionUrl + "/" + candidatureId, { search: params }).map(function (res) {
            return res;
        });
    };
    CandidatureFormationService.prototype.findLastFormationENS = function (id) {
        return this.http.get(this.resourceReinscritsUrl + "/" + id).map(function (res) {
            return res.text();
        });
    };
    CandidatureFormationService.prototype.findCommissionPourCandidature = function (ouverteUniquement, candidatureFormationId) {
        return this.http.get(this.resourceCommissions + "/" + ouverteUniquement + "/" + candidatureFormationId).map(function (res) {
            return res.json();
        });
    };
    CandidatureFormationService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.referentId) {
            params.set('referentId', req.referentId);
        }
        if (req && req.enseignantId) {
            params.set('enseignantId', req.enseignantId);
        }
        if (req && req.statut) {
            params.set('statut', req.statut);
        }
        if (req && req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req && req.dateSuppression != null) {
            params.set('dateSuppression', req.dateSuppression);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    CandidatureFormationService.prototype.findCandidatureOrdre = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.candidatureOrdreUrl, { search: params });
    };
    CandidatureFormationService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    /**
     * Genere le contrat d'étude pour echange international
     */
    CandidatureFormationService.prototype.genererContratEtudeInternational = function (id) {
        return this.http.get(this.resourceUrl + '/' + id + this.genererContratEtudeInternationalUrl, { responseType: http_1.ResponseContentType.Blob }).map(function (res) {
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    /**
     * Genere la lettre d'admission
     */
    CandidatureFormationService.prototype.genererLettreAdmission = function (id, pourReponseCode, sortieListeComplementaire) {
        var params = new http_1.URLSearchParams();
        params.set('sortieLC', sortieListeComplementaire == true ? "true" : "false");
        params.set('pourReponseCode', pourReponseCode);
        return this.http.get(this.resourceUrl + '/' + id + this.genererLettreAdmissionUrl, { search: params, responseType: http_1.ResponseContentType.Blob }).map(function (res) {
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    //Renvoi vrai si la candidature est echange international
    CandidatureFormationService.isCandidatureEchange = function (candi) {
        return candi.formationId === cadens_constants_1.CONSTANTS.ECHANGE_INTERNATIONAL_ID;
    };
    return CandidatureFormationService;
}());
CandidatureFormationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], CandidatureFormationService);
exports.CandidatureFormationService = CandidatureFormationService;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var primeng_1 = __webpack_require__(10);
var _1 = __webpack_require__(54);
var user_echange_modal_service_1 = __webpack_require__(55);
var prettyPrint_1 = __webpack_require__(102);
var CadensAdminModule = (function () {
    function CadensAdminModule() {
    }
    return CadensAdminModule;
}());
CadensAdminModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            primeng_1.DialogModule,
            primeng_1.DataTableModule,
            primeng_1.ConfirmDialogModule,
            primeng_1.FileUploadModule,
            router_1.RouterModule.forRoot(_1.adminState, { useHash: true }),
            primeng_1.CalendarModule
        ],
        declarations: [
            _1.AuditsComponent,
            _1.UserMgmtComponent,
            _1.UserDialogComponent,
            _1.UserDeleteDialogComponent,
            _1.UserMgmtDetailComponent,
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.UserEchangeMgmtComponent,
            _1.UserEchangeDialogComponent,
            _1.UserEchangeDeleteDialogComponent,
            _1.UserEchangeMgmtDetailComponent,
            _1.UserEchangeMgmtDialogComponent,
            _1.UserEchangeMgmtDeleteDialogComponent,
            _1.AideComponent,
            _1.LogsComponent,
            _1.JhiConfigurationComponent,
            prettyPrint_1.PrettyPrintPipe,
            _1.JhiArchiveComponent,
            _1.TreeView,
            _1.JhiHealthCheckComponent,
            _1.JhiHealthModalComponent,
            _1.JhiDocsComponent,
            _1.JhiMetricsMonitoringComponent,
            _1.JhiMetricsMonitoringModalComponent
        ],
        entryComponents: [
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.UserEchangeMgmtDialogComponent,
            _1.UserEchangeMgmtDeleteDialogComponent,
            _1.JhiHealthModalComponent,
            _1.JhiMetricsMonitoringModalComponent,
        ],
        providers: [
            _1.AuditsService,
            _1.JhiConfigurationService,
            _1.JhiArchiveService,
            _1.JhiHealthService,
            _1.JhiMetricsService,
            _1.LogsService,
            _1.UserResolvePagingParams,
            _1.UserResolve,
            _1.UserModalService,
            user_echange_modal_service_1.UserEchangeModalService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensAdminModule);
exports.CadensAdminModule = CadensAdminModule;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var information_component_1 = __webpack_require__(246);
var choix_component_1 = __webpack_require__(242);
var question_component_1 = __webpack_require__(249);
var reponse_component_1 = __webpack_require__(250);
var demande_modif_component_1 = __webpack_require__(244);
var demande_modif_service_1 = __webpack_require__(37);
var parametre_component_1 = __webpack_require__(247);
var piece_component_1 = __webpack_require__(248);
var commission_component_1 = __webpack_require__(243);
var CadensBlocksModule = (function () {
    function CadensBlocksModule() {
    }
    return CadensBlocksModule;
}());
CadensBlocksModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            primeng_1.FileUploadModule,
            primeng_1.InputTextModule,
            primeng_1.CalendarModule,
            primeng_1.InputSwitchModule,
            primeng_1.EditorModule,
            primeng_1.RadioButtonModule,
            primeng_1.CheckboxModule,
            primeng_1.SharedModule,
            primeng_1.ConfirmDialogModule
        ],
        declarations: [
            information_component_1.InformationComponent,
            question_component_1.QuestionComponent,
            reponse_component_1.ReponseComponent,
            demande_modif_component_1.DemandeModifComponent,
            parametre_component_1.ParametreComponent,
            piece_component_1.PieceComponent,
            commission_component_1.CommissionComponent,
            choix_component_1.ChoixComponent
        ],
        entryComponents: [],
        exports: [
            information_component_1.InformationComponent,
            question_component_1.QuestionComponent,
            reponse_component_1.ReponseComponent,
            demande_modif_component_1.DemandeModifComponent,
            parametre_component_1.ParametreComponent,
            piece_component_1.PieceComponent,
            commission_component_1.CommissionComponent,
            choix_component_1.ChoixComponent
        ],
        providers: [
            demande_modif_service_1.DemandeModifService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensBlocksModule);
exports.CadensBlocksModule = CadensBlocksModule;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(310));
__export(__webpack_require__(312));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var rxjs_1 = __webpack_require__(14);
var FormationComponentService = (function () {
    function FormationComponentService() {
        // Observable sources
        this.formationChangedSource = new rxjs_1.Subject();
        // Observable sources
        this.formationChangedFc = new rxjs_1.Subject();
        // Observable string streams
        this.formationChanged$ = this.formationChangedSource.asObservable();
        // Observable string streams
        this.fcChanged$ = this.formationChangedFc.asObservable();
    }
    // When a formation is updated
    FormationComponentService.prototype.changeFormation = function (formationId) {
        this.formationChangedSource.next(formationId);
    };
    // When a formation continue is updated
    FormationComponentService.prototype.changeFc = function (fc) {
        this.formationChangedFc.next(fc);
    };
    return FormationComponentService;
}());
FormationComponentService = __decorate([
    core_1.Injectable()
], FormationComponentService);
exports.FormationComponentService = FormationComponentService;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ListeChoixService = (function () {
    function ListeChoixService(http) {
        this.http = http;
        this.resourceUrl = 'api/liste-choix';
    }
    ListeChoixService.prototype.create = function (listeChoix) {
        var copy = Object.assign({}, listeChoix);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ListeChoixService.prototype.update = function (listeChoix) {
        var copy = Object.assign({}, listeChoix);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ListeChoixService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ListeChoixService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.type) {
            params.set('type', req.type.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    ListeChoixService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ListeChoixService.prototype.toLabelValue = function (listeChoix) {
        var liste = [];
        listeChoix.forEach(function (choix) { return liste.push({ label: choix.libelle, value: choix.code }); });
        return liste;
    };
    ListeChoixService.prototype.toLabelValueInteger = function (listeChoix) {
        var liste = [];
        listeChoix.forEach(function (choix) { return liste.push({ label: choix.libelle, value: Number.parseInt(choix.code) }); });
        return liste;
    };
    ListeChoixService.prototype.toLabelLabel = function (listeChoix) {
        var liste = [];
        listeChoix.forEach(function (choix) { return liste.push({ label: choix.libelle, value: choix.libelle }); });
        return liste;
    };
    ListeChoixService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ListeChoixService;
}());
ListeChoixService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ListeChoixService);
exports.ListeChoixService = ListeChoixService;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(2);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var FormationService = FormationService_1 = (function () {
    function FormationService(http) {
        this.http = http;
        this.resourceUrl = 'api/formations';
        this.formationsCampagneUrl = 'api/formationsCampagne';
        this.resourceNewFormationUrl = 'api/newFormationsComposants';
        this.disciplinesFormationsUrl = 'api/formationsDisciplines';
        this.servicesFormationsUrl = 'api/formationServices';
        this.autresFormationsUrl = 'api/formationsAutres';
    }
    FormationService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            if (req.mentionId) {
                params.set('mentionId', req.mentionId);
            }
            if (req.parcoursId) {
                params.set('parcoursId', req.parcoursId);
            }
            if (req.niveauId) {
                params.set('niveauId', req.niveauId);
            }
            if (req.disciplineId) {
                params.set('disciplineId', req.disciplineId);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    FormationService.prototype.create = function (formation) {
        var copy = Object.assign({}, formation);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.update = function (formation) {
        // On modifie les données dépendantes pour plus de cohérence
        if (formation.lc === false) {
            formation.rang = false;
        }
        if (formation.rang === false) {
            formation.affichageRang = false;
            formation.rangAuto = false;
        }
        if (formation.rangAuto === false) {
            formation.surbooking = false;
        }
        if (formation.surbooking === false) {
            formation.nbPlacesSurbooking = 0;
            formation.nbDesistementsSurbooking = 0;
        }
        var copy = Object.assign({}, formation);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.updateService = function (formations, serviceId) {
        var copy = formations.splice(0);
        copy.forEach(function (formation) {
            formation.serviceId = serviceId;
        });
        return this.http.put(this.servicesFormationsUrl, copy).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.findPourEtudiant = function (id, etudiantId) {
        return this.http.get(this.resourceUrl + "/" + id + "/" + etudiantId).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.findFormationCampagne = function (idCampagne) {
        return this.http.get(this.formationsCampagneUrl + "/" + idCampagne).map(function (res) {
            return res.json();
        });
    };
    FormationService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.campagneId) {
            params.set('campagneId', req.campagneId);
        }
        if (req && req.pasCampagneId) {
            params.set('pasCampagneId', req.pasCampagneId);
        }
        if (req && req.mentionId) {
            params.set('mentionId', req.mentionId);
        }
        if (req && req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        if (req && req.parcoursId) {
            params.set('parcoursId', req.parcoursId);
        }
        if (req && req.niveauId) {
            params.set('niveauId', req.niveauId);
        }
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.supprimee) {
            params.set('supprimee', req.supprimee);
        }
        else {
            params.set('supprimee', false.toString());
        }
        if (req && req.ids) {
            params.set('ids', req.ids);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    FormationService.prototype.queryDisciplinesFormations = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.niveau) {
            params.set('niveau', req.niveau);
        }
        if (req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req.userId != null) {
            params.set('userId', req.userId);
        }
        if (req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        return this.http.get(this.disciplinesFormationsUrl, { search: params });
    };
    FormationService.prototype.queryNewFormationsComposant = function (req) {
        var options = FormationService_1.createRequestOption(req);
        return this.http.get(this.resourceNewFormationUrl, options);
    };
    FormationService.prototype.queryAutresFormations = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        return this.http.get(this.autresFormationsUrl, { search: params });
    };
    FormationService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    return FormationService;
}());
FormationService = FormationService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], FormationService);
exports.FormationService = FormationService;
var FormationService_1;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var platform_browser_1 = __webpack_require__(17);
var PieceJointeService = (function () {
    function PieceJointeService(http, dateUtils, sanitizer) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.sanitizer = sanitizer;
        this.resourceUrl = 'api/piece-jointes';
        this.publicResourceUrl = 'api/public/piece-jointes';
        this.resourceDownloadUrl = 'api/download';
    }
    PieceJointeService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    PieceJointeService.prototype.create = function (pieceJointe) {
        var copy = Object.assign({}, pieceJointe);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    PieceJointeService.prototype.update = function (pieceJointe) {
        var copy = Object.assign({}, pieceJointe);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    PieceJointeService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return _this.buildPieceJointe(res);
        });
    };
    PieceJointeService.prototype.findByReferent = function (referentId, referentKey, pieceId, candidatureId) {
        var _this = this;
        return this.http.get(this.publicResourceUrl + "/referent/" + referentId + "/" + pieceId + "/" + candidatureId + "/" + referentKey)
            .map(function (res) {
            return _this.buildPieceJointe(res);
        });
    };
    PieceJointeService.prototype.buildPieceJointe = function (res) {
        var jsonResponse = res.json();
        jsonResponse.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateCreation);
        jsonResponse.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateModification);
        jsonResponse.dateConformite = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateConformite);
        return jsonResponse;
    };
    PieceJointeService.prototype.openFile = function (name) {
        var params = new http_1.URLSearchParams();
        params.set('name', name);
        return this.http.get(this.resourceDownloadUrl, { search: params, responseType: http_1.ResponseContentType.Blob }).map(function (res) {
            name = name.toLowerCase();
            if (name.endsWith('.pdf')) {
                return new Blob([res.blob()], { type: 'application/pdf' });
            }
            else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
                return new Blob([res.blob()], { type: 'image/jpeg' });
            }
            else if (name.endsWith('.docx') || name.endsWith('.doc')) {
                return new Blob([res.blob()], { type: 'application/msword' });
            }
            else if (name.endsWith('.png')) {
                return new Blob([res.blob()], { type: 'image/png' });
            }
        });
    };
    PieceJointeService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    PieceJointeService.prototype.findPieceIdentite = function (candidatureFormationId) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        params.set('candidatureFormationId', String(candidatureFormationId));
        return this.http.get(this.resourceUrl + '/pieceIdentite', { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    PieceJointeService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    PieceJointeService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
            jsonResponse[i].dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateModification);
            jsonResponse[i].dateConformite = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateConformite);
        }
        res._body = jsonResponse;
        return res;
    };
    PieceJointeService.prototype.initPDFOrImageFile = function (blob, piece) {
        var fileURL = URL.createObjectURL(blob);
        var name = piece.nom.toLowerCase();
        if (name.endsWith('.pdf')) {
            piece.content = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        }
        else if (name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg')) {
            piece.image = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        }
    };
    return PieceJointeService;
}());
PieceJointeService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils, platform_browser_1.DomSanitizer])
], PieceJointeService);
exports.PieceJointeService = PieceJointeService;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var CampagneService = CampagneService_1 = (function () {
    function CampagneService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/campagnes';
        this.resourceFormationsUrl = 'api/campagnes-formations';
    }
    CampagneService.copyCampagne = function (campagne) {
        if (campagne.heureFermeture != null) {
            campagne.dateFermeture = new Date(campagne.dateFermeture.getFullYear(), campagne.dateFermeture.getMonth(), campagne.dateFermeture.getDate(), campagne.heureFermeture.getHours(), campagne.heureFermeture.getMinutes(), campagne.heureFermeture.getSeconds());
        }
        if (campagne.heureOuverture != null) {
            campagne.dateOuverture = new Date(campagne.dateOuverture.getFullYear(), campagne.dateOuverture.getMonth(), campagne.dateOuverture.getDate(), campagne.heureOuverture.getHours(), campagne.heureOuverture.getMinutes(), campagne.heureOuverture.getSeconds());
        }
        return campagne;
    };
    CampagneService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            if (req && req.restrictionEmail) {
                params.set('restrictionEmail', req.restrictionEmail);
            }
            options.search = params;
        }
        return options;
    };
    CampagneService.prototype.create = function (campagne) {
        var _this = this;
        var copy = Object.assign({}, campagne);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, CampagneService_1.copyCampagne(copy)).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    CampagneService.prototype.update = function (campagne) {
        var _this = this;
        var copy = Object.assign({}, campagne);
        return this.http.put(this.resourceUrl, CampagneService_1.copyCampagne(copy)).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    CampagneService.prototype.updateFormations = function (campagnes) {
        var copy = campagnes.splice(0);
        return this.http.put(this.resourceFormationsUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CampagneService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CampagneService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateCreation = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateCreation);
            jsonResponse.dateModification = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateModification);
            jsonResponse.dateSuppression = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateSuppression);
            return _this.convertHeures(jsonResponse);
        });
    };
    CampagneService.prototype.query = function (req) {
        var _this = this;
        var options = CampagneService_1.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    CampagneService.prototype.campagnesAnneeCourante = function () {
        var _this = this;
        return this.http.get(this.resourceUrl + '/anneecourante')
            .map(function (res) { return _this.convertResponse(res); });
    };
    CampagneService.prototype.convertHeures = function (campagne) {
        campagne.dateOuverture = this.dateUtils
            .convertDateTimeFromServer(campagne.dateOuverture);
        campagne.dateFermeture = this.dateUtils
            .convertDateTimeFromServer(campagne.dateFermeture);
        campagne.heureFermeture = campagne.dateFermeture;
        campagne.heureOuverture = campagne.dateOuverture;
        return campagne;
    };
    CampagneService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateOuverture = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateOuverture);
            jsonResponse[i].dateFermeture = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateFermeture);
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
            jsonResponse[i].dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateModification);
            jsonResponse[i].dateSuppression = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateSuppression);
        }
        res._body = jsonResponse;
        return res;
    };
    return CampagneService;
}());
CampagneService = CampagneService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], CampagneService);
exports.CampagneService = CampagneService;
var CampagneService_1;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var cadens_constants_1 = __webpack_require__(8);
var ReponseService = (function () {
    function ReponseService(http) {
        this.http = http;
        this.resourceUrl = 'api/reponses';
        this.resourcemajordisciplineUrl = 'api/reponses/majordiscipline';
        this.resourcePublicUrl = 'api/public/reponses';
        this.resourceAllReponsesCandidature = 'api/reponses/reponsesparcandidature';
    }
    ReponseService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    ReponseService.prototype.update = function (questions) {
        return this.updateAvecReferent(questions, null);
    };
    ReponseService.prototype.updateAvecReferent = function (questions, referentKey) {
        if (questions == null) {
            return null;
        }
        var params = new http_1.URLSearchParams();
        if (referentKey) {
            params.set('referentKey', referentKey);
        }
        var copy = questions.filter(function (q) { return q.typeReponse !== cadens_constants_1.CONSTANTS.CASPARTICULIER; }).slice(0);
        return this.http.put(this.resourcePublicUrl, copy, { search: params }).map(function (res) {
            return res.json();
        });
    };
    /*    find(id: number): Observable<Reponse> {
            return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
                return res.json();
            });
        }*/
    ReponseService.prototype.findMajorDiscipline = function () {
        return this.http.get("" + this.resourcemajordisciplineUrl).map(function (res) {
            return res.json();
        });
    };
    ReponseService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        if (req && req.referentId) {
            params.set('referentId', req.referentId);
        }
        if (req && req.referentKey) {
            params.set('referentKey', req.referentKey);
        }
        return this.http.get(this.resourcePublicUrl, { search: params });
    };
    ReponseService.prototype.getAllReponsesCandidature = function () {
        return this.http.get(this.resourceAllReponsesCandidature).map(function (res) {
            return res;
        });
    };
    return ReponseService;
}());
ReponseService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ReponseService);
exports.ReponseService = ReponseService;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(42));
__export(__webpack_require__(134));
__export(__webpack_require__(130));
__export(__webpack_require__(132));
__export(__webpack_require__(133));
__export(__webpack_require__(135));
__export(__webpack_require__(144));
__export(__webpack_require__(128));
__export(__webpack_require__(147));
__export(__webpack_require__(149));
__export(__webpack_require__(148));
__export(__webpack_require__(139));
__export(__webpack_require__(64));
__export(__webpack_require__(142));
__export(__webpack_require__(141));
__export(__webpack_require__(146));
__export(__webpack_require__(145));
__export(__webpack_require__(143));
__export(__webpack_require__(60));
__export(__webpack_require__(41));
__export(__webpack_require__(254));
__export(__webpack_require__(63));
__export(__webpack_require__(323));
__export(__webpack_require__(23));
__export(__webpack_require__(18));
__export(__webpack_require__(136));
__export(__webpack_require__(12));
__export(__webpack_require__(131));
__export(__webpack_require__(257));
__export(__webpack_require__(28));
__export(__webpack_require__(22));
__export(__webpack_require__(129));
__export(__webpack_require__(61));
__export(__webpack_require__(62));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var keyedCollection_1 = __webpack_require__(190);
var HistoriqueService = (function () {
    function HistoriqueService(http, dateUtils, userService) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.userService = userService;
        this.resourceUrl = 'api/historiques';
    }
    HistoriqueService.prototype.create = function (historique) {
        var copy = Object.assign({}, historique);
        copy.dateCreation = this.dateUtils.toDate(historique.dateCreation);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    HistoriqueService.prototype.update = function (historique) {
        var copy = Object.assign({}, historique);
        copy.dateCreation = this.dateUtils.toDate(historique.dateCreation);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    HistoriqueService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateCreation = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateCreation);
            return jsonResponse;
        });
    };
    HistoriqueService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    HistoriqueService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    HistoriqueService.prototype.fillUser = function (listHistoriques) {
        var _this = this;
        if (listHistoriques != null) {
            var userDictionary_1 = new keyedCollection_1.KeyedCollection();
            listHistoriques.forEach(function (historique) {
                if (historique.userId != null && !userDictionary_1.ContainsKey(historique.userId.toString())) {
                    userDictionary_1.Add(historique.userId.toString(), historique.userId);
                }
            });
            userDictionary_1.Values().forEach(function (userId) {
                _this.userService.findById(userId).subscribe(function (user) {
                    if (user != null) {
                        listHistoriques.forEach(function (historique) {
                            if (historique.userId != null && historique.userId == user.id) {
                                historique.user = user;
                            }
                        });
                    }
                });
            });
        }
    };
    HistoriqueService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
        }
        res._body = jsonResponse;
        return res;
    };
    HistoriqueService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('candidatureId', req.candidatureId);
            params.set('candidatureFormationId', req.candidatureFormationId);
            params.set('code', req.code);
            options.search = params;
        }
        return options;
    };
    return HistoriqueService;
}());
HistoriqueService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        ng_jhipster_1.DateUtils,
        shared_1.UserService])
], HistoriqueService);
exports.HistoriqueService = HistoriqueService;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_ng2_page_scroll_directive__ = __webpack_require__(196);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PageScroll", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ng2_page_scroll_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ng2_page_scroll_service__ = __webpack_require__(83);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PageScrollService", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2_page_scroll_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__ = __webpack_require__(46);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "EasingLogic", function() { return __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PageScrollConfig", function() { return __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_ng2_page_scroll_instance__ = __webpack_require__(195);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PageScrollInstance", function() { return __WEBPACK_IMPORTED_MODULE_3__src_ng2_page_scroll_instance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ng2_page_scroll_util_service__ = __webpack_require__(47);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PageScrollUtilService", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ng2_page_scroll_util_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_ng2_page_scroll_module__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ng2PageScrollModule", function() { return __WEBPACK_IMPORTED_MODULE_5__src_ng2_page_scroll_module__["a"]; });








/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(66));
__export(__webpack_require__(151));
__export(__webpack_require__(67));
__export(__webpack_require__(150));
__export(__webpack_require__(261));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(180));
__export(__webpack_require__(76));
__export(__webpack_require__(26));
__export(__webpack_require__(178));
__export(__webpack_require__(176));
__export(__webpack_require__(177));
__export(__webpack_require__(179));
__export(__webpack_require__(306));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(442);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(9);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var DemandeModifService = DemandeModifService_1 = (function () {
    function DemandeModifService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/demande-modifs';
        this.resourceUrlForEntity = 'api/demande-modifs/entity';
        this.resourceUrlForEntityType = 'api/demande-modifs/entityType';
    }
    DemandeModifService.convertResponse = function (res) {
        res._body = res.json();
        return res;
    };
    DemandeModifService.prototype.create = function (demandeModif) {
        var copy = Object.assign({}, demandeModif);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    DemandeModifService.prototype.update = function (demandeModif) {
        var copyList = [];
        demandeModif.forEach(function (c) {
            var copy = Object.assign({}, c);
            copyList.push(copy);
        });
        if (copyList != null && copyList.length > 0) {
            return this.http.put(this.resourceUrl, copyList).map(function (res) {
                return res.json();
            });
        }
        return null;
    };
    DemandeModifService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    DemandeModifService.prototype.query = function (req) {
        if (req.candidatureFormationId != null) {
            return this.http.get(this.resourceUrlForEntity + "/" + req.candidatureFormationId)
                .map(function (res) { return DemandeModifService_1.convertResponse(res); });
        }
        else {
            if (req.entityType != null) {
                return this.http.get(this.resourceUrlForEntityType + "/" + req.entityType)
                    .map(function (res) { return DemandeModifService_1.convertResponse(res); });
            }
        }
    };
    DemandeModifService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    return DemandeModifService;
}());
DemandeModifService = DemandeModifService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], DemandeModifService);
exports.DemandeModifService = DemandeModifService;
var DemandeModifService_1;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var campagne_model_1 = __webpack_require__(40);
var campagne_popup_service_1 = __webpack_require__(39);
var campagne_service_1 = __webpack_require__(27);
var formation_1 = __webpack_require__(9);
var CampagneFormationsDialogComponent = (function () {
    function CampagneFormationsDialogComponent(activeModal, jhiLanguageService, alertService, formationService, campagneService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.formationService = formationService;
        this.campagneService = campagneService;
        this.eventManager = eventManager;
        this.campagnes = [];
        this.selectedFormations = [];
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
    }
    CampagneFormationsDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = true;
        var pasCampagneId = null;
        if (this.campagne instanceof Array) {
            this.campagnes = this.campagne;
        }
        else {
            this.campagnes.push(new campagne_model_1.Campagne(this.campagne.id));
            pasCampagneId = this.campagne.id;
        }
        this.formationService.query({
            supprimee: false,
            pasCampagneId: pasCampagneId
        }).subscribe(function (res) {
            _this.isSaving = false;
            _this.formationListe = res.json();
            _this.assignCopy();
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
            _this.isSaving = false;
        });
    };
    CampagneFormationsDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    CampagneFormationsDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        // Rattacher les formations sélectionnées aux campagnes sélectionnées
        this.campagnes.forEach(function (campagne) {
            campagne.formations = _this.selectedFormations;
        });
        this.campagneService.updateFormations(this.campagnes).subscribe(function (res) {
            _this.onSaveSuccess(res);
        }, function (res) { return _this.onSaveError(res.json()); });
    };
    CampagneFormationsDialogComponent.prototype.assignCopy = function () {
        this.filteredList = Object.assign([], this.formationListe);
    };
    CampagneFormationsDialogComponent.prototype.filterFormations = function (value) {
        if (!value) {
            this.assignCopy();
        }
        this.filteredList = Object.assign([], this.formationListe).filter(function (item) { return item.libelle.toLowerCase().indexOf(value.toLowerCase()) > -1; });
    };
    CampagneFormationsDialogComponent.prototype.selectFormation = function (event, formation, index) {
        // In popup Rattacher des formations, selections des formations!
        if (event.shiftKey && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastRowIndex < index) {
                for (var i = this.lastRowIndex + 1; i <= index; i++) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
            else if (this.lastRowIndex > index) {
                for (var i = this.lastRowIndex - 1; i >= index; i--) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
        }
        else {
            this.addSelectedFormation(formation, index);
            this.lastRowIndex = index;
        }
    };
    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param formation sélectionnée
     * @param index de la formation dans la liste
     */
    CampagneFormationsDialogComponent.prototype.addSelectedFormation = function (formation, index) {
        var _this = this;
        if (formation.id) {
            this.pushToSelectedFormations(formation.id);
        }
        else {
            this.formationService.create(formation).subscribe(function (ff) {
                _this.filteredList[index] = ff;
                _this.pushToSelectedFormations(ff.id);
            });
        }
    };
    /**
     * Sélectionner / Déselectionner une formation dans la liste
     * @param id de la formation
     */
    CampagneFormationsDialogComponent.prototype.pushToSelectedFormations = function (id) {
        if (this.selectedFormations.indexOf(id) < 0) {
            this.selectedFormations.push(id);
        }
        else {
            this.selectedFormations.splice(this.selectedFormations.indexOf(id), 1);
        }
    };
    CampagneFormationsDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'campagneFormationsModification', content: result });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    CampagneFormationsDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    CampagneFormationsDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return CampagneFormationsDialogComponent;
}());
CampagneFormationsDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne-formations-dialog',
        template: __webpack_require__(414)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        formation_1.FormationService,
        campagne_service_1.CampagneService,
        ng_jhipster_1.EventManager])
], CampagneFormationsDialogComponent);
exports.CampagneFormationsDialogComponent = CampagneFormationsDialogComponent;
var CampagneFormationsPopupComponent = (function () {
    function CampagneFormationsPopupComponent(route, campagnePopupService) {
        this.route = route;
        this.campagnePopupService = campagnePopupService;
    }
    CampagneFormationsPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            var campagnes = params['campagnes'];
            _this.modalRef = _this.campagnePopupService
                .open(CampagneFormationsDialogComponent, campagnes);
        });
    };
    CampagneFormationsPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return CampagneFormationsPopupComponent;
}());
CampagneFormationsPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne-formations-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        campagne_popup_service_1.CampagnePopupService])
], CampagneFormationsPopupComponent);
exports.CampagneFormationsPopupComponent = CampagneFormationsPopupComponent;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var common_1 = __webpack_require__(24);
var campagne_model_1 = __webpack_require__(40);
var campagne_service_1 = __webpack_require__(27);
var CampagnePopupService = (function () {
    function CampagnePopupService(datePipe, modalService, router, campagneService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.campagneService = campagneService;
        this.isOpen = false;
    }
    CampagnePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id && id instanceof Array) {
            return this.campagneModalRef(component, id);
        }
        else if (id) {
            this.campagneService.find(id).subscribe(function (campagne) {
                campagne.dateOuverture = _this.datePipe.transform(campagne.dateOuverture, 'yyyy-MM-ddThh:mm');
                campagne.dateFermeture = _this.datePipe.transform(campagne.dateFermeture, 'yyyy-MM-ddThh:mm');
                campagne.dateCreation = _this.datePipe.transform(campagne.dateCreation, 'yyyy-MM-ddThh:mm');
                campagne.dateModification = _this.datePipe.transform(campagne.dateModification, 'yyyy-MM-ddThh:mm');
                campagne.dateSuppression = _this.datePipe.transform(campagne.dateSuppression, 'yyyy-MM-ddThh:mm');
                _this.campagneModalRef(component, campagne);
            });
        }
        else {
            return this.campagneModalRef(component, new campagne_model_1.Campagne());
        }
    };
    CampagnePopupService.prototype.campagneModalRef = function (component, campagne) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.campagne = campagne;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return CampagnePopupService;
}());
CampagnePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        campagne_service_1.CampagneService])
], CampagnePopupService);
exports.CampagnePopupService = CampagnePopupService;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Campagne = (function () {
    function Campagne(id, libelle, dateOuverture, heureOuverture, dateFermeture, heureFermeture, reinscription, ei, restrictionEmail, restrictionPieces, dateCreation, dateModification, dateSuppression, formations, commissions) {
        this.id = id;
        this.libelle = libelle;
        this.dateOuverture = dateOuverture;
        this.heureOuverture = heureOuverture;
        this.dateFermeture = dateFermeture;
        this.heureFermeture = heureFermeture;
        this.reinscription = reinscription;
        this.ei = ei;
        this.restrictionEmail = restrictionEmail;
        this.restrictionPieces = restrictionPieces;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
        this.dateSuppression = dateSuppression;
        this.formations = formations;
        this.commissions = commissions;
    }
    return Campagne;
}());
exports.Campagne = Campagne;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var AdresseService = AdresseService_1 = (function () {
    function AdresseService(http) {
        this.http = http;
        this.resourceUrl = 'api/adresses';
    }
    AdresseService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    AdresseService.empty = function (stringValue) {
        return typeof stringValue == 'undefined' || !stringValue || stringValue.length == 0;
    };
    AdresseService.clean = function (copy) {
        if (AdresseService_1.empty(copy.pays)) {
            copy.pays = null;
        }
        if (AdresseService_1.empty(copy.departement)) {
            copy.departement = null;
        }
        if (AdresseService_1.empty(copy.ville)) {
            copy.ville = null;
        }
    };
    AdresseService.prototype.create = function (adresse) {
        var copy = Object.assign({}, adresse);
        AdresseService_1.clean(copy);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    AdresseService.prototype.update = function (adresse) {
        var copy = Object.assign({}, adresse);
        AdresseService_1.clean(copy);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    AdresseService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    AdresseService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    AdresseService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    return AdresseService;
}());
AdresseService = AdresseService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AdresseService);
exports.AdresseService = AdresseService;
var AdresseService_1;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Candidature = (function () {
    function Candidature(id, nomPatronymique, nomUsuel, prenom, prenom2, dateNaissance, telephoneFixe, telephonePortable, bacTypeEtablissement, bacAnnee, bac, bacMention, bacPays, bacDept, bacEtab, bacEtablissementAutre, bacVille, paysNaissance, villeNaissance, deptNaissance, paysNationalite, paysNationalite2, civilite, navigator, userId, ines, bourse, echelon, bourseExcellence, indicBourseExcellence, bacSpec1LibelleCourt, bacSpec2LibelleCourt) {
        this.id = id;
        this.nomPatronymique = nomPatronymique;
        this.nomUsuel = nomUsuel;
        this.prenom = prenom;
        this.prenom2 = prenom2;
        this.dateNaissance = dateNaissance;
        this.telephoneFixe = telephoneFixe;
        this.telephonePortable = telephonePortable;
        this.bacTypeEtablissement = bacTypeEtablissement;
        this.bacAnnee = bacAnnee;
        this.bac = bac;
        this.bacMention = bacMention;
        this.bacPays = bacPays;
        this.bacDept = bacDept;
        this.bacEtab = bacEtab;
        this.bacEtablissementAutre = bacEtablissementAutre;
        this.bacVille = bacVille;
        this.paysNaissance = paysNaissance;
        this.villeNaissance = villeNaissance;
        this.deptNaissance = deptNaissance;
        this.paysNationalite = paysNationalite;
        this.paysNationalite2 = paysNationalite2;
        this.civilite = civilite;
        this.navigator = navigator;
        this.userId = userId;
        this.ines = ines;
        this.bourse = bourse;
        this.echelon = echelon;
        this.bourseExcellence = bourseExcellence;
        this.indicBourseExcellence = indicBourseExcellence;
        this.bacSpec1LibelleCourt = bacSpec1LibelleCourt;
        this.bacSpec2LibelleCourt = bacSpec2LibelleCourt;
    }
    Candidature.areSpecialitesBacObligatoires = function (candidature) {
        return candidature.bacTypeEtablissement && candidature.bacTypeEtablissement !== 'ETRANGER'
            && candidature.bacAnnee && candidature.bacAnnee >= 2021;
    };
    return Candidature;
}());
exports.Candidature = Candidature;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(466);
var account_service_1 = __webpack_require__(185);
/*
    "ROLE_USER": "Utilisateur / Candidat",
    "ROLE_SYSTEM": "Administrateur SI",
    "ROLE_ADMIN": "Administrateur fonctionnel",
    "ROLE_GEST": "Gestionnaire",
    "ROLE_REFERENT": "Responsable de formation",
    "ROLE_DELEGATE": "Enseignant",
*/
var Principal = Principal_1 = (function () {
    function Principal(account) {
        this.account = account;
        this.authenticated = false;
        this.authenticationState = new Subject_1.Subject();
        this.backOfficeAuthorities = ['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'];
    }
    Principal.isAuthorityInListe = function (authorityAVerifier, authoritiesListe) {
        return authorityAVerifier != null && authoritiesListe && authoritiesListe.indexOf(authorityAVerifier) !== -1;
    };
    Principal.isAnyAuthorityInListe = function (authorityAVerifier, authoritiesListe) {
        for (var i = 0; i < authoritiesListe.length; i++) {
            if (authorityAVerifier.indexOf(authoritiesListe[i]) !== -1) {
                return true;
            }
        }
        return false;
    };
    Principal.isAdmin = function (authorityAVerifier) {
        return Principal_1.isAnyAuthorityInListe(authorityAVerifier, ['ROLE_ADMIN']);
    };
    Principal.isAdminOrGestionnaire = function (authorityAVerifier) {
        return Principal_1.isAnyAuthorityInListe(authorityAVerifier, ['ROLE_ADMIN', 'ROLE_GEST']);
    };
    Principal.isAdminOrGestionnaireOrSystem = function (authorityAVerifier) {
        return Principal_1.isAnyAuthorityInListe(authorityAVerifier, ['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_GEST']);
    };
    Principal.isGestionnaire = function (authorityAVerifier) {
        return Principal_1.isAnyAuthorityInListe(authorityAVerifier, ['ROLE_GEST']);
    };
    Principal.isResponsableFormation = function (authorityAVerifier) {
        return Principal_1.isAnyAuthorityInListe(['ROLE_REFERENT'], authorityAVerifier);
    };
    Principal.isOnlyResponsableFormation = function (authorityAVerifier) {
        if (Principal_1.isAdminOrGestionnaire(authorityAVerifier)) {
            return false;
        }
        else {
            return Principal_1.isAnyAuthorityInListe(['ROLE_REFERENT'], authorityAVerifier);
        }
    };
    Principal.isOnlyEnseignant = function (authorityAVerifier) {
        if (Principal_1.isAdminOrGestionnaire(authorityAVerifier)) {
            return false;
        }
        else {
            return Principal_1.isAnyAuthorityInListe(['ROLE_DELEGATE'], authorityAVerifier);
        }
    };
    Principal.isEnseignantOrResponsableFormation = function (authorityAVerifier) {
        if (Principal_1.isAdminOrGestionnaire(authorityAVerifier)) {
            return false;
        }
        else {
            return Principal_1.isAnyAuthorityInListe(authorityAVerifier, ['ROLE_DELEGATE', 'ROLE_REFERENT']);
        }
    };
    Principal.prototype.authenticate = function (identity) {
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
    };
    Principal.prototype.hasAnyAuthority = function (authorities) {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return Promise.resolve(false);
        }
        for (var i = 0; i < authorities.length; i++) {
            if (this.userIdentity.authorities.indexOf(authorities[i]) !== -1) {
                return Promise.resolve(true);
            }
        }
        return Promise.resolve(false);
    };
    Principal.prototype.hasAuthority = function (authorityRechercher) {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }
        return this.identity().then(function (user) {
            return Promise.resolve(Principal_1.isAuthorityInListe(authorityRechercher, user.authorities));
        }, function () {
            return Promise.resolve(false);
        });
    };
    Principal.prototype.rootUrl = function () {
        if (this.authenticated) {
            return this.hasAnyAuthority(this.backOfficeAuthorities).then(function (result) {
                if (result) {
                    return '/candidature';
                }
                else {
                    return '/espaceCandidat';
                }
            });
        }
        else {
            return Promise.resolve('/login');
        }
    };
    Principal.prototype.getId = function () {
        if (this.userIdentity) {
            return this.userIdentity.id;
        }
        else {
            return this.userIdentity.id;
        }
    };
    Principal.prototype.getIdentityName = function () {
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity.firstName + ' ' + this.userIdentity.lastName.toLocaleUpperCase());
        }
        else {
            return this.account.get().toPromise().then(function (account) {
                if (account) {
                    return account.firstName + ' ' + account.lastName.toLocaleUpperCase();
                }
                else {
                    return '';
                }
            });
        }
    };
    Principal.prototype.getIdentityLogin = function () {
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity.login);
        }
        else {
            return this.account.get().toPromise().then(function (account) {
                if (account) {
                    return account.login;
                }
                else {
                    return '';
                }
            });
        }
    };
    Principal.prototype.identity = function (force) {
        var _this = this;
        if (force === true) {
            this.userIdentity = undefined;
        }
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.account.get().toPromise().then(function (account) {
            if (account) {
                _this.userIdentity = account;
                _this.authenticated = true;
            }
            else {
                _this.userIdentity = null;
                _this.authenticated = false;
            }
            _this.authenticationState.next(_this.userIdentity);
            return _this.userIdentity;
        }).catch(function () {
            _this.userIdentity = null;
            _this.authenticated = false;
            _this.authenticationState.next(_this.userIdentity);
            return null;
        });
    };
    Principal.prototype.isAuthenticated = function () {
        return this.authenticated;
    };
    Principal.prototype.isIdentityResolved = function () {
        return this.userIdentity !== undefined;
    };
    Principal.prototype.getAuthenticationState = function () {
        return this.authenticationState.asObservable();
    };
    Principal.prototype.getImageUrl = function () {
        return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
    };
    Principal.prototype.getAuthorities = function () {
        return this.userIdentity.then(function (user) {
            return user.authorities;
        });
    };
    return Principal;
}());
Principal = Principal_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [account_service_1.AccountService])
], Principal);
exports.Principal = Principal;
var Principal_1;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var JsUtil = (function () {
    function JsUtil() {
    }
    JsUtil.setMultiSelectLabel = function (multiselectId, translation) {
        this.waitForMultiSelectLabel(multiselectId).then(function () {
            (document.getElementById(multiselectId)
                .getElementsByClassName('ui-multiselect-label-container')[0]
                .getElementsByClassName('ui-multiselect-label')[0]).textContent = translation;
        });
    };
    JsUtil.waitForMultiSelectLabel = function (componentMultiselectId) {
        return __awaiter(this, void 0, void 0, function () {
            var timeBetweenTriesInMilliseconds, maxNbTries, nbTries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timeBetweenTriesInMilliseconds = 500;
                        maxNbTries = 30;
                        nbTries = 0;
                        _a.label = 1;
                    case 1:
                        if (!(!document.getElementById(componentMultiselectId) && (nbTries++ < maxNbTries))) return [3 /*break*/, 3];
                        return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, timeBetweenTriesInMilliseconds); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return JsUtil;
}());
exports.JsUtil = JsUtil;


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EasingLogic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageScrollConfig; });
var EasingLogic = (function () {
    function EasingLogic() {
    }
    return EasingLogic;
}());

var PageScrollConfig = (function () {
    function PageScrollConfig() {
    }
    Object.defineProperty(PageScrollConfig, "defaultEasingLogic", {
        // Getter and setter to avoid auto completion to suggest calling the method
        get: function () {
            return PageScrollConfig._easingLogic;
        },
        set: function (easingLogic) {
            PageScrollConfig._easingLogic = easingLogic;
        },
        enumerable: true,
        configurable: true
    });
    return PageScrollConfig;
}());

/**
 * The number of milliseconds to wait till updating the scroll position again.
 * Small amounts may produce smoother animations but require more processing power.
 * @type {number}
 * @private
 */
PageScrollConfig._interval = 10;
/**
 * The amount of pixels that need to be between the current scrollTop/scrollLeft position
 * and the target position the cause a scroll animation. In case distance is below
 * this threshold, an immediate jump will be performed.
 * Due to dpi or rounding irregularities in browsers floating point numbers as scrollTop/scrollLeft values
 * are possible, making an === comparison or current scrollTop or scrollLeft and target scrollPosition error-prone.
 * @type {number}
 * @private
 */
PageScrollConfig._minScrollDistance = 2;
/**
 * Name of the default namespace.
 * @type {string}
 * @private
 */
PageScrollConfig._defaultNamespace = 'default';
/**
 * Whether by default the scrolling should happen in vertical direction (by manipulating the scrollTop property)
 * (= true; default) or in horizontal direction (by manipulating the scrollLeft property) (= false
 * @type {boolean}
 */
PageScrollConfig.defaultIsVerticalScrolling = true;
/**
 * How many console logs should be emitted.
 * 0: None
 * 2: If animation could not be started due to missing target, "already at destination" or similar reasons
 * 5: All scroll position values that get set
 * @type {boolean}
 * @private
 */
PageScrollConfig._logLevel = 2;
/**
 * The duration how long a scrollTo animation should last by default.
 * May be overridden using the page-scroll-duration attribute on a single ng2PageScroll instance.
 * @type {number}
 */
PageScrollConfig.defaultDuration = 1250;
/**
 * The distance in pixels above scroll target where the animation should stop. Setting a positive number results in
 * the scroll target being more in the middle of the screen, negative numbers will produce scrolling "too far"
 * @type {number}
 */
PageScrollConfig.defaultScrollOffset = 0;
/**
 * Whether by default for inline scroll animations the advanced offset calculation should take place (true) or
 * not (false). Default is false.
 * The advanced offset calculation will traverse the DOM tree upwards, starting at the scrollTarget, until it finds
 * the scrollingView container element. Along the way the offset positions of the relative positioned
 * (position: relative) elements will be taken into account for calculating the target elements position.
 * @type {boolean}
 */
PageScrollConfig.defaultAdvancedInlineOffsetCalculation = false;
/**
 * The events that are listened to on the body to decide whether a scroll animation has been interfered/interrupted by the user
 * @type {string[]}
 * @private
 */
PageScrollConfig._interruptEvents = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchmove'];
/**
 * The keys that are considered to interrupt a scroll animation (mainly the arrow keys). All other key presses will not stop the
 * scroll animation.
 * @type {number[]}
 * @private
 */
PageScrollConfig._interruptKeys = [33, 34, 35, 36, 38, 40];
/**
 * Whether a scroll animation should be interruptible by user interaction (true) or not (false). If the user performs an
 * interrupting event while a scroll animation takes place, the scroll animation stops.
 * @type {boolean}
 */
PageScrollConfig.defaultInterruptible = true;
PageScrollConfig._easingLogic = {
    ease: function (t, b, c, d) {
        // Linear easing
        return c * t / d + b;
    }
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageScrollUtilService; });
/**
 * Created by sebastianfuss on 02.09.16.
 */
var PageScrollUtilService = (function () {
    function PageScrollUtilService() {
    }
    /**
     * Util method to check whether a given variable is either undefined or null
     * @param variable
     * @returns {boolean} true the variable is undefined or null
     */
    PageScrollUtilService.isUndefinedOrNull = function (variable) {
        return (typeof variable === 'undefined') || variable === undefined || variable === null;
    };
    PageScrollUtilService.extractElementPosition = function (document, scrollTargetElement) {
        var body = document.body;
        var docEl = document.documentElement;
        var windowPageYOffset = document.defaultView && document.defaultView.pageYOffset || undefined;
        var windowPageXOffset = document.defaultView && document.defaultView.pageXOffset || undefined;
        var scrollTop = windowPageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = windowPageXOffset || docEl.scrollLeft || body.scrollLeft;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;
        if (PageScrollUtilService.isUndefinedOrNull(scrollTargetElement)) {
            // No element found, so return the current position to not cause any change in scroll position
            return { top: scrollTop, left: scrollLeft };
        }
        var box = scrollTargetElement.getBoundingClientRect();
        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;
        return { top: Math.round(top), left: Math.round(left) };
    };
    return PageScrollUtilService;
}());



/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(1);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
var _VERSION = '0.0.0'; // This value will be overwritten by webpack
var _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "5.4.0";
_DEBUG_INFO_ENABLED = false;
exports.VERSION = _VERSION;
exports.DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(84));
__export(__webpack_require__(85));
__export(__webpack_require__(209));
__export(__webpack_require__(92));
__export(__webpack_require__(213));
__export(__webpack_require__(93));
__export(__webpack_require__(214));
__export(__webpack_require__(88));
__export(__webpack_require__(89));
__export(__webpack_require__(211));
__export(__webpack_require__(90));
__export(__webpack_require__(91));
__export(__webpack_require__(212));
__export(__webpack_require__(95));
__export(__webpack_require__(94));
__export(__webpack_require__(51));
__export(__webpack_require__(215));
__export(__webpack_require__(86));
__export(__webpack_require__(87));
__export(__webpack_require__(210));
__export(__webpack_require__(96));
__export(__webpack_require__(97));
__export(__webpack_require__(217));
__export(__webpack_require__(216));
__export(__webpack_require__(98));
__export(__webpack_require__(218));
__export(__webpack_require__(208));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var Register = (function () {
    function Register(http) {
        this.http = http;
    }
    Register.prototype.save = function (account) {
        account.birthDate = new Date(Date.UTC(account.birthDate.getFullYear(), account.birthDate.getMonth(), account.birthDate.getDate()));
        return this.http.post('api/register', account);
    };
    Register.prototype.query = function () {
        return this.http.get('api/register');
    };
    return Register;
}());
Register = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Register);
exports.Register = Register;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var archive_model_1 = __webpack_require__(221);
var fichier_model_1 = __webpack_require__(101);
var statusArchivage_model_1 = __webpack_require__(223);
var ng_jhipster_1 = __webpack_require__(1);
var JhiArchiveService = JhiArchiveService_1 = (function () {
    function JhiArchiveService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
    }
    JhiArchiveService.creeStatusArchivage = function (res) {
        var status = new statusArchivage_model_1.StatusArchivage();
        status.enCours = res.json().enCours;
        if (res.json().dateDeLancement != null) {
            status.dateDeLancement = new Date(res.json().dateDeLancement);
        }
        return status;
    };
    JhiArchiveService.creeArchive = function (res) {
        var archive = new archive_model_1.Archive();
        archive.label = res.json().label;
        archive.fichier = fichier_model_1.Fichier.creeFichier(res.json().fichier);
        archive.annee = res.json().annee;
        archive.anneeCourante = res.json().anneeCourante;
        return archive;
    };
    JhiArchiveService.prototype.get = function (annee) {
        return this.http.get('api/archive/' + annee).map(function (res) {
            return JhiArchiveService_1.creeArchive(res);
        });
    };
    JhiArchiveService.prototype.archiveAnneecourante = function () {
        return this.http.put('api/archive/anneecourante', new archive_model_1.Archive()).map(function (res) {
            return res;
        });
    };
    JhiArchiveService.prototype.getStatusArchivage = function () {
        return this.http.get('api/archivestatus/', new statusArchivage_model_1.StatusArchivage()).map(function (res) {
            return JhiArchiveService_1.creeStatusArchivage(res);
        });
    };
    JhiArchiveService.prototype.getFile = function (file) {
        var params = new http_1.URLSearchParams();
        params.set('nomarchive', file.nom);
        var options = new http_1.RequestOptions({ responseType: http_1.ResponseContentType.Blob });
        return this.http.put('api/archive/fichier', file.nom, options).map(function (res) {
            var name = file.nom.toLowerCase();
            if (name.endsWith('.pdf')) {
                return new Blob([res.json()], { type: 'application/pdf' });
            }
            else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
                return new Blob([res.json()], { type: 'image/jpeg' });
            }
            else if (name.endsWith('.docx') || name.endsWith('.doc')) {
                return new Blob([res.json()], { type: 'application/msword' });
            }
            else if (name.endsWith('.png')) {
                return new Blob([res.json()], { type: 'image/png' });
            }
        });
    };
    JhiArchiveService.prototype.deleteRepertoire = function (repertoire) {
        var params = new http_1.URLSearchParams();
        params.set('nomRepertoire', repertoire.nom);
        return this.http.put('api/archive/delete', {}, { search: params }).map(function (res) { });
    };
    return JhiArchiveService;
}());
JhiArchiveService = JhiArchiveService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], JhiArchiveService);
exports.JhiArchiveService = JhiArchiveService;
var JhiArchiveService_1;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var JhiHealthService = (function () {
    function JhiHealthService(http) {
        this.http = http;
        this.separator = '.';
    }
    JhiHealthService.prototype.checkHealth = function () {
        return this.http.get('management/health').map(function (res) { return res.json(); });
    };
    JhiHealthService.prototype.transformHealthData = function (data) {
        var response = [];
        this.flattenHealthData(response, null, data);
        return response;
    };
    JhiHealthService.prototype.getBaseName = function (name) {
        if (name) {
            var split = name.split('.');
            return split[0];
        }
    };
    JhiHealthService.prototype.getSubSystemName = function (name) {
        if (name) {
            var split = name.split('.');
            split.splice(0, 1);
            var remainder = split.join('.');
            return remainder ? ' - ' + remainder : '';
        }
    };
    /* private methods */
    JhiHealthService.prototype.addHealthObject = function (result, isLeaf, healthObject, name) {
        var status;
        var error;
        var healthData = {
            'name': name,
            'error': error,
            'status': status
        };
        var details = {};
        var hasDetails = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                }
                else {
                    if (!this.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            }
        }
        // Add the details
        if (hasDetails) {
            healthData.details = details;
        }
        // Only add nodes if they provide additional information
        if (isLeaf || hasDetails || healthData.error) {
            result.push(healthData);
        }
        return healthData;
    };
    JhiHealthService.prototype.flattenHealthData = function (result, path, data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var value = data[key];
                if (this.isHealthObject(value)) {
                    if (this.hasSubSystem(value)) {
                        this.addHealthObject(result, false, value, this.getModuleName(path, key));
                        this.flattenHealthData(result, this.getModuleName(path, key), value);
                    }
                    else {
                        this.addHealthObject(result, true, value, this.getModuleName(path, key));
                    }
                }
            }
        }
        return result;
    };
    JhiHealthService.prototype.getModuleName = function (path, name) {
        var result;
        if (path && name) {
            result = path + this.separator + name;
        }
        else if (path) {
            result = path;
        }
        else if (name) {
            result = name;
        }
        else {
            result = '';
        }
        return result;
    };
    JhiHealthService.prototype.hasSubSystem = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (value && value.status) {
                    result = true;
                }
            }
        }
        return result;
    };
    JhiHealthService.prototype.isHealthObject = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                if (key === 'status') {
                    result = true;
                }
            }
        }
        return result;
    };
    return JhiHealthService;
}());
JhiHealthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiHealthService);
exports.JhiHealthService = JhiHealthService;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(103));
__export(__webpack_require__(104));
__export(__webpack_require__(227));
__export(__webpack_require__(226));
__export(__webpack_require__(225));
__export(__webpack_require__(105));
__export(__webpack_require__(106));
__export(__webpack_require__(228));
__export(__webpack_require__(102));
__export(__webpack_require__(101));
__export(__webpack_require__(224));
__export(__webpack_require__(100));
__export(__webpack_require__(52));
__export(__webpack_require__(222));
__export(__webpack_require__(107));
__export(__webpack_require__(229));
__export(__webpack_require__(109));
__export(__webpack_require__(108));
__export(__webpack_require__(53));
__export(__webpack_require__(230));
__export(__webpack_require__(111));
__export(__webpack_require__(112));
__export(__webpack_require__(231));
__export(__webpack_require__(110));
__export(__webpack_require__(114));
__export(__webpack_require__(113));
__export(__webpack_require__(115));
__export(__webpack_require__(232));
__export(__webpack_require__(122));
__export(__webpack_require__(120));
__export(__webpack_require__(121));
__export(__webpack_require__(123));
__export(__webpack_require__(234));
__export(__webpack_require__(118));
__export(__webpack_require__(116));
__export(__webpack_require__(117));
__export(__webpack_require__(119));
__export(__webpack_require__(233));
__export(__webpack_require__(99));
__export(__webpack_require__(220));
__export(__webpack_require__(56));
__export(__webpack_require__(219));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var user_en_echange_1 = __webpack_require__(21);
var UserEchangeModalService = (function () {
    function UserEchangeModalService(modalService, router, userEchangeService) {
        this.modalService = modalService;
        this.router = router;
        this.userEchangeService = userEchangeService;
        this.isOpen = false;
    }
    UserEchangeModalService.prototype.open = function (component, id, typeEtudiant) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.userEchangeService.find(id).subscribe(function (user) { return _this.userModalRef(component, user); });
        }
        else {
            var user = new user_en_echange_1.UserEnEchange();
            user.typeEtudiant = typeEtudiant;
            return this.userModalRef(component, user);
        }
    };
    UserEchangeModalService.prototype.userModalRef = function (component, user) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.user = user;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return UserEchangeModalService;
}());
UserEchangeModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        user_en_echange_1.UserEnEchangeService])
], UserEchangeModalService);
exports.UserEchangeModalService = UserEchangeModalService;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var shared_1 = __webpack_require__(2);
var UserModalService = (function () {
    function UserModalService(modalService, router, userService) {
        this.modalService = modalService;
        this.router = router;
        this.userService = userService;
        this.isOpen = false;
    }
    UserModalService.prototype.open = function (component, login) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (login) {
            this.userService.find(login).subscribe(function (user) { return _this.userModalRef(component, user); });
        }
        else {
            return this.userModalRef(component, new shared_1.User());
        }
    };
    UserModalService.prototype.userModalRef = function (component, user) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.user = user;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return UserModalService;
}());
UserModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        shared_1.UserService])
], UserModalService);
exports.UserModalService = UserModalService;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var shared_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(5);
var PaginationConfig = (function () {
    function PaginationConfig(config) {
        this.config = config;
        config.boundaryLinks = true;
        config.maxSize = 5;
        config.pageSize = shared_1.ITEMS_PER_PAGE;
        config.size = 'sm';
    }
    return PaginationConfig;
}());
PaginationConfig = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbPaginationConfig])
], PaginationConfig);
exports.PaginationConfig = PaginationConfig;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_webstorage_1 = __webpack_require__(35);
var AdmisService = (function () {
    function AdmisService(localStorageService) {
        this.localStorageService = localStorageService;
        this.admisCache = 'CADENS_ADMIS_CACHE';
        this.indexAdmisCache = 'CADENS_INDEX_ADMIS_CACHE';
    }
    AdmisService.prototype.initCandidatures = function (cfs) {
        this.localStorageService.store(this.admisCache, cfs);
        this.localStorageService.store(this.indexAdmisCache, 0);
    };
    AdmisService.prototype.getCurrentCandidature = function () {
        var candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        var indexCandidatureEnTraitement = this.localStorageService.retrieve(this.indexAdmisCache);
        if (!candidaturesEnTraitement || candidaturesEnTraitement.length === 0 ||
            indexCandidatureEnTraitement >= candidaturesEnTraitement.length) {
            return null;
        }
        return candidaturesEnTraitement[indexCandidatureEnTraitement];
    };
    AdmisService.prototype.getIndexCandidatureEnTraitement = function () {
        return this.localStorageService.retrieve(this.indexAdmisCache);
    };
    AdmisService.prototype.getNbCandidaturesEnTraitement = function () {
        var candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        return candidaturesEnTraitement ? candidaturesEnTraitement.length : 0;
    };
    AdmisService.prototype.previous = function () {
        var candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        var index = this.localStorageService.retrieve(this.indexAdmisCache);
        if (index !== undefined && candidaturesEnTraitement && index > 0 && index < candidaturesEnTraitement.length) {
            this.localStorageService.store(this.indexAdmisCache, index - 1);
        }
    };
    AdmisService.prototype.next = function () {
        var candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        var index = this.localStorageService.retrieve(this.indexAdmisCache);
        if (index !== undefined && candidaturesEnTraitement && index >= 0 && index < candidaturesEnTraitement.length - 1) {
            this.localStorageService.store(this.indexAdmisCache, index + 1);
        }
    };
    return AdmisService;
}());
AdmisService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_webstorage_1.LocalStorageService])
], AdmisService);
exports.AdmisService = AdmisService;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(40));
__export(__webpack_require__(39));
__export(__webpack_require__(27));
__export(__webpack_require__(126));
__export(__webpack_require__(38));
__export(__webpack_require__(125));
__export(__webpack_require__(127));
__export(__webpack_require__(252));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Adresse = (function () {
    function Adresse(id, adresse, adresse2, codePostal, ville, pays, departement, candidatureId) {
        this.id = id;
        this.adresse = adresse;
        this.adresse2 = adresse2;
        this.codePostal = codePostal;
        this.ville = ville;
        this.pays = pays;
        this.departement = departement;
        this.candidatureId = candidatureId;
    }
    return Adresse;
}());
exports.Adresse = Adresse;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var candidature_formation_service_1 = __webpack_require__(18);
var candidature_formation_model_1 = __webpack_require__(12);
var CandidaturePopupService = (function () {
    function CandidaturePopupService(modalService, router, candidatureFormationService) {
        this.modalService = modalService;
        this.router = router;
        this.candidatureFormationService = candidatureFormationService;
        this.isOpen = false;
    }
    CandidaturePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.candidatureFormationService.find(id, false).subscribe(function (candidatureFormation) {
                _this.candidatureModalRef(component, candidatureFormation);
            });
        }
        else {
            return this.candidatureModalRef(component, new candidature_formation_model_1.CandidatureFormation());
        }
    };
    CandidaturePopupService.prototype.candidatureModalRef = function (component, candidatureFormation) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.candidatureFormation = candidatureFormation;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return CandidaturePopupService;
}());
CandidaturePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        candidature_formation_service_1.CandidatureFormationService])
], CandidaturePopupService);
exports.CandidaturePopupService = CandidaturePopupService;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var calendar_constants_1 = __webpack_require__(15);
var candidature_formation_service_1 = __webpack_require__(18);
var candidature_popup_service_1 = __webpack_require__(61);
var cadens_constants_1 = __webpack_require__(8);
var formation_1 = __webpack_require__(9);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var CandidatureTraitementDialogComponent = (function () {
    function CandidatureTraitementDialogComponent(activeModal, jhiLanguageService, alertService, router, candidatureFormationService, eventManager, formationService, confirmationService, translateService) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.router = router;
        this.candidatureFormationService = candidatureFormationService;
        this.eventManager = eventManager;
        this.formationService = formationService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.Constants = cadens_constants_1.CONSTANTS;
        this.listeConformites = [cadens_constants_1.CONSTANTS.CONFORME, cadens_constants_1.CONSTANTS.NOTCONFORME];
        this.listeResultats = [cadens_constants_1.CONSTANTS.SUCCESS, cadens_constants_1.CONSTANTS.REJECTED];
        this.affichageRang = false;
        this.rangAuto = false;
        this.jhiLanguageService.setLocations(['candidature']);
    }
    CandidatureTraitementDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.formationService.findPourEtudiant(this.candidatureFormation.formationId, this.candidatureFormation.userId).subscribe(function (res) {
            if (res.lc === true) {
                _this.listeResultats.push(cadens_constants_1.CONSTANTS.AWAITING);
            }
            if (res.rang === true) {
                _this.affichageRang = true;
                _this.rangAuto = res.rangAuto;
            }
        });
    };
    CandidatureTraitementDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    CandidatureTraitementDialogComponent.prototype.save = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.candidature.confirmSave.message'),
            header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
            icon: 'fa fa-check-circle-o',
            key: 'traiter',
            accept: function () {
                _this.isSaving = true;
                _this.candidatureFormationService.updateCandidaturesStatus([_this.candidatureFormation], {
                    response: _this.candidatureFormation.response,
                    conforme: _this.candidatureFormation.conforme
                }).subscribe(function (res) {
                    _this.onSaveSuccess(res);
                }, function (res) { return _this.onSaveError(res.json()); });
            }
        });
    };
    CandidatureTraitementDialogComponent.prototype.selectReponse = function (response) {
        this.candidatureFormation.response = (this.candidatureFormation.response === response) ? null : response;
        if (this.candidatureFormation.response !== cadens_constants_1.CONSTANTS.AWAITING) {
            this.candidatureFormation.responseRang = null;
        }
    };
    CandidatureTraitementDialogComponent.prototype.selectConformite = function (conformite) {
        this.candidatureFormation.conforme = (this.candidatureFormation.conforme === conformite) ? null : conformite;
    };
    CandidatureTraitementDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'candidatureListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
        this.router.navigate(['/candidature/' + result.id]);
    };
    CandidatureTraitementDialogComponent.prototype.onSaveError = function (error) {
        this.eventManager.broadcast({ name: 'candidatureListModification', content: 'NOK' });
        this.isSaving = false;
        this.onError(error);
    };
    CandidatureTraitementDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return CandidatureTraitementDialogComponent;
}());
CandidatureTraitementDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-candidature-traitement-dialog',
        template: __webpack_require__(419)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        router_1.Router,
        candidature_formation_service_1.CandidatureFormationService,
        ng_jhipster_1.EventManager,
        formation_1.FormationService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService])
], CandidatureTraitementDialogComponent);
exports.CandidatureTraitementDialogComponent = CandidatureTraitementDialogComponent;
var CandidatureTraitementPopupComponent = (function () {
    function CandidatureTraitementPopupComponent(route, candidaturePopupService) {
        this.route = route;
        this.candidaturePopupService = candidaturePopupService;
    }
    CandidatureTraitementPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.candidaturePopupService
                    .open(CandidatureTraitementDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.candidaturePopupService
                    .open(CandidatureTraitementDialogComponent);
            }
        });
    };
    CandidatureTraitementPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return CandidatureTraitementPopupComponent;
}());
CandidatureTraitementPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-candidature-traitement-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        candidature_popup_service_1.CandidaturePopupService])
], CandidatureTraitementPopupComponent);
exports.CandidatureTraitementPopupComponent = CandidatureTraitementPopupComponent;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ConcoursService = (function () {
    function ConcoursService(http) {
        this.http = http;
        this.resourceUrl = 'api/concours';
    }
    ConcoursService.prototype.create = function (concours) {
        var copy = Object.assign({}, concours);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ConcoursService.prototype.update = function (concours) {
        var copy = concours.slice(0);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ConcoursService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ConcoursService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.candidatureId) {
            params.set('candidatureId', req.candidatureId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    ConcoursService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ConcoursService.prototype.areConcoursValid = function (concours) {
        var d = new Date();
        var yearMax = d.getFullYear() + 1;
        for (var i = 0; concours.length > i; i++) {
            if (concours[i].passage == null) {
                return 'passage';
            }
            if (concours[i].passage === true && concours[i].resultat == null) {
                return 'resultat';
            }
            if (concours[i].passage === true && (concours[i].annee < 999 || concours[i].annee > yearMax)) {
                return 'annee';
            }
        }
        return null;
    };
    ConcoursService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ConcoursService;
}());
ConcoursService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ConcoursService);
exports.ConcoursService = ConcoursService;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var Rx_1 = __webpack_require__(14);
var cadens_constants_1 = __webpack_require__(8);
var ng_jhipster_1 = __webpack_require__(1);
var CursusService = CursusService_1 = (function () {
    function CursusService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/cursuses';
        this.resourceMaxNiveauUrl = 'api/maxniveaucursuses';
    }
    CursusService.prototype.create = function (cursus) {
        var copy = Object.assign({}, cursus);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        copy.dateDebut = CursusService_1.convertDate(copy.dateDebut);
        copy.dateFin = CursusService_1.convertDate(copy.dateFin);
        copy.dateObtentionDiplome = CursusService_1.convertDate(copy.dateObtentionDiplome);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CursusService.prototype.update = function (cursus) {
        var _this = this;
        var copy = [];
        cursus.forEach(function (c) {
            var cursusCopy = __assign({}, c);
            // this.convertDates(cursusCopy) ;
            // if (cursusCopy.dateDebut != null && cursusCopy.dateFin != null && cursusCopy.interruption != null) {
            if (!cursusCopy.dateCreation) {
                cursusCopy.dateCreation = new Date();
            }
            cursusCopy.dateModification = new Date();
            cursusCopy.dateDebut = CursusService_1.convertDate(c.dateDebut);
            cursusCopy.dateFin = CursusService_1.convertDate(c.dateFin);
            cursusCopy.dateObtentionDiplome = CursusService_1.convertDate(c.dateObtentionDiplome);
            copy.push(cursusCopy);
            // }
        });
        if (copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map(function (res) { return _this.convertCursusResponse(res); });
        }
        return Rx_1.Observable.of([]);
    };
    CursusService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            _this.convertDates(jsonResponse);
            return jsonResponse;
        });
    };
    CursusService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req.candidatureId) {
            params.set('candidatureId', req.candidatureId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertCursusResponse(res); });
    };
    CursusService.prototype.findMaxNiveau = function () {
        var _this = this;
        return this.http.get(this.resourceMaxNiveauUrl)
            .map(function (res) { return _this.convertCursusResponse(res); });
    };
    CursusService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CursusService.areCursusesValid = function (cursus, reinscription) {
        for (var i = 0; cursus.length > i; i++) {
            if (cursus[i].dateDebut == null) {
                return 'dateDebut';
            }
            if (cursus[i].dateFin == null) {
                return 'dateFin';
            }
            if (cursus[i].interruption == null) {
                return 'interruption';
            }
            if (cursus[i].interruption === false && cursus[i].pays === '100' && cursus[i].etablissement == null) {
                return 'etablissement';
            }
            if (!reinscription && cursus[i].interruption === false && cursus[i].anneeSanctionnee == null) {
                return 'anneeSanctionnee';
            }
            // mise date obtention diplome à null si en attente résultat diplome
            if (cursus[i].mention == cadens_constants_1.CONSTANTS.MENTION_ATTENTE_RESULTAT_CODE.toString()) {
                cursus[i].dateObtentionDiplome = null;
            }
            if (!reinscription && cursus[i].anneeSanctionnee === true
                && (cursus[i].dateObtentionDiplome == null && cursus[i].mention != cadens_constants_1.CONSTANTS.MENTION_ATTENTE_RESULTAT_CODE.toString())) {
                return 'dateObtentionDiplome';
            }
            var d = new Date();
            if (reinscription && cursus[i].dateDebut.getFullYear() < d.getFullYear() - 2) {
                return 'dateDebutReinscription';
            }
        }
        return null;
    };
    CursusService.prototype.convertCursusResponse = function (res) {
        if (res.json != null && typeof res.json != "undefined") {
            var jsonResponse = res.json();
            for (var i = 0; i < jsonResponse.length; i++) {
                this.convertDates(jsonResponse[i]);
            }
            res._body = jsonResponse;
        }
        return res;
    };
    CursusService.prototype.convertDates = function (jsonCursus) {
        jsonCursus.dateDebut = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateDebut);
        jsonCursus.dateFin = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateFin);
        jsonCursus.dateObtentionDiplome = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateObtentionDiplome);
        jsonCursus.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonCursus.dateCreation);
        jsonCursus.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonCursus.dateModification);
    };
    CursusService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.candidatureId) {
                params.set('candidatureId', req.candidatureId);
            }
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    CursusService.convertDate = function (date) {
        if (date == null) {
            return null;
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    };
    return CursusService;
}());
CursusService = CursusService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], CursusService);
exports.CursusService = CursusService;
var CursusService_1;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var Rx_1 = __webpack_require__(14);
var ng_jhipster_1 = __webpack_require__(1);
var PreavisService = (function () {
    function PreavisService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/preavis';
    }
    PreavisService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            if (req.candidatureId) {
                params.set('candidatureId', req.candidatureId);
            }
            options.search = params;
        }
        return options;
    };
    PreavisService.convertDate = function (date) {
        if (date == null) {
            return null;
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    };
    PreavisService.prototype.create = function (preavis) {
        var copy = Object.assign({}, preavis);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    PreavisService.prototype.update = function (preavis) {
        var _this = this;
        var copy = [];
        preavis.forEach(function (c) {
            var preavisCopy = __assign({}, c);
            if (!preavisCopy.dateCreation) {
                preavisCopy.dateCreation = new Date();
            }
            preavisCopy.dateModification = new Date();
            copy.push(preavisCopy);
        });
        if (copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map(function (res) { return _this.convertPreavisResponse(res); });
        }
        return Rx_1.Observable.of([]);
    };
    PreavisService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            _this.convertDates(jsonResponse);
            return jsonResponse;
        });
    };
    PreavisService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertPreavisResponse(res); });
    };
    PreavisService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    PreavisService.prototype.convertPreavisResponse = function (res) {
        if (res.json != null && typeof res.json != 'undefined') {
            var jsonResponse = res.json();
            for (var i = 0; i < jsonResponse.length; i++) {
                this.convertDates(jsonResponse[i]);
            }
            res._body = jsonResponse;
        }
        return res;
    };
    PreavisService.prototype.convertDates = function (jsonPreavis) {
        jsonPreavis.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonPreavis.dateCreation);
        jsonPreavis.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonPreavis.dateModification);
    };
    return PreavisService;
}());
PreavisService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], PreavisService);
exports.PreavisService = PreavisService;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Commission = (function () {
    function Commission(id, libelle, dateCommission, heureCommission, datePublication, heurePublication, dateCoupure, heureCoupure, dateLimiteAvis, heureLimiteAvis, dateLimiteConfirmation, heureLimiteConfirmation, campagnes) {
        this.id = id;
        this.libelle = libelle;
        this.dateCommission = dateCommission;
        this.heureCommission = heureCommission;
        this.datePublication = datePublication;
        this.heurePublication = heurePublication;
        this.dateCoupure = dateCoupure;
        this.heureCoupure = heureCoupure;
        this.dateLimiteAvis = dateLimiteAvis;
        this.heureLimiteAvis = heureLimiteAvis;
        this.dateLimiteConfirmation = dateLimiteConfirmation;
        this.heureLimiteConfirmation = heureLimiteConfirmation;
        this.campagnes = campagnes;
    }
    Commission.isCommissionValid = function (commission) {
        return commission.libelle != null && commission.libelle.trim().length > 0 &&
            commission.dateLimiteAvis != null && commission.heureLimiteAvis != null &&
            commission.dateCommission != null && commission.heureCommission != null &&
            commission.datePublication != null && commission.heurePublication != null &&
            commission.dateLimiteConfirmation != null && commission.heureLimiteConfirmation != null;
    };
    Commission.prototype.formatDateLimiteConfirmation = function (lang) {
        if (!this.dateLimiteConfirmation)
            return null;
        var date = new Date(this.dateLimiteConfirmation);
        if (lang === 'fr') {
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
        else {
            return date.toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        }
    };
    return Commission;
}());
exports.Commission = Commission;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var CommissionService = CommissionService_1 = (function () {
    function CommissionService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/commissions';
    }
    CommissionService.getTime = function (date) {
        return date != null ? new Date(date).getTime() : 0;
    };
    CommissionService.copyCommission = function (commission) {
        if (commission.heureCommission != null) {
            commission.dateCommission = new Date(commission.dateCommission.getFullYear(), commission.dateCommission.getMonth(), commission.dateCommission.getDate(), commission.heureCommission.getHours(), commission.heureCommission.getMinutes(), commission.heureCommission.getSeconds());
        }
        if (commission.heureCoupure != null) {
            commission.dateCoupure = new Date(commission.dateCoupure.getFullYear(), commission.dateCoupure.getMonth(), commission.dateCoupure.getDate(), commission.heureCoupure.getHours(), commission.heureCoupure.getMinutes(), commission.heureCoupure.getSeconds());
        }
        if (commission.heurePublication != null) {
            commission.datePublication = new Date(commission.datePublication.getFullYear(), commission.datePublication.getMonth(), commission.datePublication.getDate(), commission.heurePublication.getHours(), commission.heurePublication.getMinutes(), commission.heurePublication.getSeconds());
        }
        if (commission.heureLimiteAvis != null) {
            commission.dateLimiteAvis = new Date(commission.dateLimiteAvis.getFullYear(), commission.dateLimiteAvis.getMonth(), commission.dateLimiteAvis.getDate(), commission.heureLimiteAvis.getHours(), commission.heureLimiteAvis.getMinutes(), commission.heureLimiteAvis.getSeconds());
        }
        if (commission.heureLimiteConfirmation != null) {
            commission.dateLimiteConfirmation = new Date(commission.dateLimiteConfirmation.getFullYear(), commission.dateLimiteConfirmation.getMonth(), commission.dateLimiteConfirmation.getDate(), commission.heureLimiteConfirmation.getHours(), commission.heureLimiteConfirmation.getMinutes(), commission.heureLimiteConfirmation.getSeconds());
        }
        return commission;
    };
    CommissionService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    CommissionService.prototype.create = function (commission) {
        var _this = this;
        var copy = Object.assign({}, commission);
        return this.http.post(this.resourceUrl, CommissionService_1.copyCommission(copy)).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    CommissionService.prototype.update = function (commissions) {
        var _this = this;
        var copy = commissions.splice(0);
        copy.map(function (c) { return CommissionService_1.copyCommission(c); });
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            var comms = res.json();
            comms.map(function (c) { return _this.convertHeures(c); });
            return comms;
        });
    };
    CommissionService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            return _this.convertHeures(jsonResponse);
        });
    };
    CommissionService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req && req.campagneId) {
            params.set('campagneId', req.campagneId);
        }
        if (req && req.commissionListIds) {
            params.set('commissionListIds', req.commissionListIds);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    CommissionService.prototype.delete = function (ids) {
        var _this = this;
        if (ids != null) {
            var response_1 = null;
            ids.forEach(function (id) {
                response_1 = _this.http.delete(_this.resourceUrl + "/" + id);
            });
            return response_1;
        }
        return null;
    };
    CommissionService.prototype.convertHeures = function (commission) {
        commission.dateCommission = this.dateUtils.convertDateTimeFromServer(commission.dateCommission);
        commission.datePublication = this.dateUtils.convertDateTimeFromServer(commission.datePublication);
        commission.dateCoupure = this.dateUtils.convertDateTimeFromServer(commission.dateCoupure);
        commission.dateLimiteAvis = this.dateUtils.convertDateTimeFromServer(commission.dateLimiteAvis);
        commission.dateLimiteConfirmation = this.dateUtils.convertDateTimeFromServer(commission.dateLimiteConfirmation);
        commission.heureCoupure = commission.dateCoupure;
        commission.heurePublication = commission.datePublication;
        commission.heureLimiteAvis = commission.dateLimiteAvis;
        commission.heureCommission = commission.dateCommission;
        commission.heureLimiteConfirmation = commission.dateLimiteConfirmation;
        return commission;
    };
    CommissionService.prototype.formatDateLimiteConfirmation = function (commission, lang) {
        if (!commission.dateLimiteConfirmation)
            return null;
        var date = new Date(commission.dateLimiteConfirmation);
        if (lang === 'fr') {
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
        else {
            return date.toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        }
    };
    CommissionService.prototype.toOrderedLabelValue = function (commission) {
        return commission.sort(function (a, b) {
            return CommissionService_1.getTime(b.dateCommission) - CommissionService_1.getTime(a.dateCommission);
        }).map(function (comm) { return ({
            'label': comm.libelle,
            'value': comm.id
        }); });
    };
    CommissionService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCommission = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCommission);
            jsonResponse[i].datePublication = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].datePublication);
            jsonResponse[i].dateCoupure = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCoupure);
            jsonResponse[i].dateLimiteAvis = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateLimiteAvis);
            jsonResponse[i].dateLimiteConfirmation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateLimiteConfirmation);
        }
        res._body = jsonResponse;
        return res;
    };
    return CommissionService;
}());
CommissionService = CommissionService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], CommissionService);
exports.CommissionService = CommissionService;
var CommissionService_1;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var EntityAuditEventService = (function () {
    function EntityAuditEventService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/entity-audit-events';
        this.resourceLogCandidatureUrl = 'api/entity-audit-events/candidatureFormation';
    }
    EntityAuditEventService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.modifiedDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.modifiedDate);
            return jsonResponse;
        });
    };
    EntityAuditEventService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    EntityAuditEventService.prototype.findLogCandidatureFormation = function (idCandidatureFormation) {
        var _this = this;
        return this.http.get(this.resourceLogCandidatureUrl + "/" + idCandidatureFormation)
            .map(function (res) { return _this.convertResponse(res); });
    };
    EntityAuditEventService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].modifiedDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].modifiedDate);
        }
        res._body = jsonResponse;
        return res;
    };
    EntityAuditEventService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return EntityAuditEventService;
}());
EntityAuditEventService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], EntityAuditEventService);
exports.EntityAuditEventService = EntityAuditEventService;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var parametrage_1 = __webpack_require__(11);
var ng2_translate_1 = __webpack_require__(7);
var FaqComponent = (function () {
    function FaqComponent(jhiLanguageService, translate, parametrageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.translate = translate;
        this.parametrageService = parametrageService;
        this.parametrages = [];
        this.jhiLanguageService.setLocations(['global', 'faq']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    FaqComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.queryPageFaq().subscribe(function (res) {
            _this.parametrages = res.json();
            _this.parametrage = _this.parametrages[0];
        });
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    };
    return FaqComponent;
}());
FaqComponent = __decorate([
    core_1.Component({
        selector: 'jhi-faq',
        template: __webpack_require__(439)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng2_translate_1.TranslateService,
        parametrage_1.ParametrageService])
], FaqComponent);
exports.FaqComponent = FaqComponent;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var formation_model_1 = __webpack_require__(71);
var formation_service_1 = __webpack_require__(25);
var FormationPopupService = (function () {
    function FormationPopupService(modalService, router, formationService) {
        this.modalService = modalService;
        this.router = router;
        this.formationService = formationService;
        this.isOpen = false;
    }
    FormationPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.formationService.find(id).subscribe(function (formation) {
                _this.formationModalRef(component, formation);
            });
        }
        else {
            return this.formationModalRef(component, new formation_model_1.Formation());
        }
    };
    FormationPopupService.prototype.formationModalRef = function (component, formation) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.formation = formation;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return FormationPopupService;
}());
FormationPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        formation_service_1.FormationService])
], FormationPopupService);
exports.FormationPopupService = FormationPopupService;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Formation = (function () {
    function Formation(id, libelle, libelleCourt, libelleGrade, libelleMention, libelleParcours, lc, fc, rang, affichageRang, rangAuto, surbooking, nbPlacesSurbooking, nbDesistementsSurbooking, avecPreavis, nombreReferents, nombreReferentsContact, nombreReferentsObligatoires, nombrePlaces, typePiece, mentionId, parcoursId, disciplineId, niveauId, mentionCode, parcoursCode, niveauCode, serviceId, campagneId, users, lecteurs, campagnes, demandeModifs, dateSuppression, venueConfirmable) {
        this.id = id;
        this.libelle = libelle;
        this.libelleCourt = libelleCourt;
        this.libelleGrade = libelleGrade;
        this.libelleMention = libelleMention;
        this.libelleParcours = libelleParcours;
        this.lc = lc;
        this.fc = fc;
        this.rang = rang;
        this.affichageRang = affichageRang;
        this.rangAuto = rangAuto;
        this.surbooking = surbooking;
        this.nbPlacesSurbooking = nbPlacesSurbooking;
        this.nbDesistementsSurbooking = nbDesistementsSurbooking;
        this.avecPreavis = avecPreavis;
        this.nombreReferents = nombreReferents;
        this.nombreReferentsContact = nombreReferentsContact;
        this.nombreReferentsObligatoires = nombreReferentsObligatoires;
        this.nombrePlaces = nombrePlaces;
        this.typePiece = typePiece;
        this.mentionId = mentionId;
        this.parcoursId = parcoursId;
        this.disciplineId = disciplineId;
        this.niveauId = niveauId;
        this.mentionCode = mentionCode;
        this.parcoursCode = parcoursCode;
        this.niveauCode = niveauCode;
        this.serviceId = serviceId;
        this.campagneId = campagneId;
        this.users = users;
        this.lecteurs = lecteurs;
        this.campagnes = campagnes;
        this.demandeModifs = demandeModifs;
        this.dateSuppression = dateSuppression;
        this.venueConfirmable = venueConfirmable;
        this.lc = false;
        this.rang = false;
        this.affichageRang = false;
    }
    return Formation;
}());
exports.Formation = Formation;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var PieceService = (function () {
    function PieceService(http) {
        this.http = http;
        this.resourceUrl = 'api/pieces';
        this.publicResourceUrl = 'api/public/pieces';
    }
    PieceService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    PieceService.prototype.update = function (piece) {
        var copy = piece.slice(0);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    PieceService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    PieceService.prototype.findByCode = function (code) {
        return this.http.get(this.publicResourceUrl + "/code/" + code).map(function (res) {
            return res.json();
        });
    };
    PieceService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.categorieFormationIdList) {
            params.set('categorieFormationIdList', req.categorieFormationIdList);
        }
        if (req.formationId) {
            params.set('formationId', req.formationId);
        }
        if (req.isFormationContinue) {
            params.set('isFormationContinue', req.isFormationContinue);
        }
        if (req.etudiantId) {
            params.set('etudiantId', req.etudiantId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    PieceService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    return PieceService;
}());
PieceService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PieceService);
exports.PieceService = PieceService;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var common_1 = __webpack_require__(24);
var historique_model_1 = __webpack_require__(171);
var historique_service_1 = __webpack_require__(30);
var HistoriquePopupService = (function () {
    function HistoriquePopupService(datePipe, modalService, router, historiqueService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.historiqueService = historiqueService;
        this.isOpen = false;
    }
    HistoriquePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.historiqueService.find(id).subscribe(function (historique) {
                historique.dateCreation = _this.datePipe.transform(historique.dateCreation, 'yyyy-MM-ddThh:mm');
                _this.historiqueModalRef(component, historique);
            });
        }
        else {
            return this.historiqueModalRef(component, new historique_model_1.Historique());
        }
    };
    HistoriquePopupService.prototype.historiqueModalRef = function (component, historique) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.historique = historique;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return HistoriquePopupService;
}());
HistoriquePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        historique_service_1.HistoriqueService])
], HistoriquePopupService);
exports.HistoriquePopupService = HistoriquePopupService;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var LegalComponent = (function () {
    function LegalComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['legal']);
    }
    LegalComponent.prototype.ngOnInit = function () {
    };
    return LegalComponent;
}());
LegalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-legal',
        template: __webpack_require__(449)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], LegalComponent);
exports.LegalComponent = LegalComponent;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var cadens_constants_1 = __webpack_require__(8);
var ParametrageService = (function () {
    function ParametrageService(http) {
        this.http = http;
        this.resourceUrl = 'api/parametrages';
        this.resourceUrlWithCode = 'api/parametrages/withCode';
        this.resourceParametragePageAllUrl = 'api/public/getParametragePageAll';
        this.ResourceParametragePageEspaceConnexion = 'api/public/getParametragePageEspaceConnexion';
        this.resourceParametragePageFaqUrl = 'api/public/getParametragePageFaq';
        this.parametrageFileUrl = 'api/parametragesFile';
        this.parametrageSuppressFileUrl = 'api/parametragesSuppressFile';
        this.parametrageFileNameUrl = 'api/parametragesFileName';
    }
    ParametrageService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    ParametrageService.prototype.create = function (parametrage) {
        var copy = Object.assign({}, parametrage);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ParametrageService.prototype.update = function (parametrages) {
        var copy = parametrages.splice(0);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ParametrageService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ParametrageService.prototype.queryAgeLimiteBourseExc = function () {
        return this.queryAvecCode(cadens_constants_1.CONSTANTS.INTERNATIONAL, cadens_constants_1.CONSTANTS.INTERNATIONAL, "AGE_LIMITE_BOURSE_EXC");
    };
    ParametrageService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.rubrique) {
            params.set('rubrique', req.rubrique.toUpperCase());
        }
        else if (req.page) {
            params.set('page', req.page.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    ParametrageService.prototype.queryAvecCode = function (rubrique, page, code) {
        var params = new http_1.URLSearchParams();
        params.set('rubrique', rubrique.toUpperCase());
        params.set('page', page.toUpperCase());
        params.set('code', code.toUpperCase());
        return this.http.get(this.resourceUrlWithCode, { search: params });
    };
    ParametrageService.prototype.queryPageEspaceConnexion = function () {
        return this.http.get(this.ResourceParametragePageEspaceConnexion);
    };
    ParametrageService.prototype.queryPageAll = function () {
        return this.http.get(this.resourceParametragePageAllUrl);
    };
    ParametrageService.prototype.queryPageFaq = function () {
        return this.http.get(this.resourceParametragePageFaqUrl);
    };
    ParametrageService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ParametrageService.prototype.parametresArrayToObject = function (params) {
        var object = {};
        params.forEach(function (param) {
            object[param.code + ''] = param;
        });
        return object;
    };
    ParametrageService.prototype.queryVDipAnnee = function () {
        return this.queryAvecCode(cadens_constants_1.CONSTANTS.GENERAL, cadens_constants_1.CONSTANTS.ALL, cadens_constants_1.CONSTANTS.VDIP_ANNEE);
    };
    ParametrageService.prototype.queryURLenSavoirPlusDiplome = function () {
        return this.queryAvecCode(cadens_constants_1.CONSTANTS.GENERAL, cadens_constants_1.CONSTANTS.PIECES, cadens_constants_1.CONSTANTS.URL_EN_SAVOIR_PLUS_DIPLOME);
    };
    ParametrageService.prototype.getFile = function (parametreCategorie, parametre) {
        var params = new http_1.URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        var requestOption = new http_1.RequestOptions({
            responseType: http_1.ResponseContentType.Blob
        });
        return this.http.get(this.parametrageFileUrl, { search: params, responseType: http_1.ResponseContentType.Blob }).map(function (res) {
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    ParametrageService.prototype.getFileName = function (parametreCategorie, parametre) {
        var params = new http_1.URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        return this.http.get(this.parametrageFileNameUrl, { search: params });
    };
    ParametrageService.prototype.suppressFile = function (parametreCategorie, parametre) {
        var params = new http_1.URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        var options = new http_1.RequestOptions({ search: params });
        return this.http.delete(this.parametrageFileUrl, options);
    };
    return ParametrageService;
}());
ParametrageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ParametrageService);
exports.ParametrageService = ParametrageService;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var common_1 = __webpack_require__(24);
var piece_jointe_model_1 = __webpack_require__(180);
var piece_jointe_service_1 = __webpack_require__(26);
var PieceJointePopupService = (function () {
    function PieceJointePopupService(datePipe, modalService, router, pieceJointeService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.pieceJointeService = pieceJointeService;
        this.isOpen = false;
    }
    PieceJointePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.pieceJointeService.find(id).subscribe(function (pieceJointe) {
                pieceJointe.dateCreation = _this.datePipe.transform(pieceJointe.dateCreation, 'yyyy-MM-ddThh:mm');
                pieceJointe.dateModification = _this.datePipe.transform(pieceJointe.dateModification, 'yyyy-MM-ddThh:mm');
                pieceJointe.dateConformite = _this.datePipe.transform(pieceJointe.dateConformite, 'yyyy-MM-ddThh:mm');
                _this.pieceJointeModalRef(component, pieceJointe);
            });
        }
        else {
            return this.pieceJointeModalRef(component, new piece_jointe_model_1.PieceJointe());
        }
    };
    PieceJointePopupService.prototype.pieceJointeModalRef = function (component, pieceJointe) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.pieceJointe = pieceJointe;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return PieceJointePopupService;
}());
PieceJointePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        piece_jointe_service_1.PieceJointeService])
], PieceJointePopupService);
exports.PieceJointePopupService = PieceJointePopupService;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(307));
__export(__webpack_require__(182));
__export(__webpack_require__(181));
__export(__webpack_require__(309));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(313));
__export(__webpack_require__(315));
__export(__webpack_require__(314));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(183));
__export(__webpack_require__(316));
__export(__webpack_require__(319));
__export(__webpack_require__(317));
__export(__webpack_require__(321));
__export(__webpack_require__(320));
__export(__webpack_require__(322));
__export(__webpack_require__(80));
__export(__webpack_require__(184));
__export(__webpack_require__(318));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var profile_info_model_1 = __webpack_require__(184);
var ProfileService = (function () {
    function ProfileService(http) {
        this.http = http;
        this.profileInfoUrl = 'api/profile-info';
    }
    ProfileService.prototype.getProfileInfo = function () {
        return this.http.get(this.profileInfoUrl)
            .map(function (res) {
            var data = res.json();
            var pi = new profile_info_model_1.ProfileInfo();
            pi.activeProfiles = data.activeProfiles;
            pi.ribbonEnv = data.ribbonEnv;
            pi.inProduction = data.activeProfiles.indexOf('prod') !== -1;
            pi.inTest = data.activeProfiles.indexOf('test') !== -1;
            pi.swaggerEnabled = data.activeProfiles.indexOf('swagger') !== -1;
            return pi;
        });
    };
    return ProfileService;
}());
ProfileService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ProfileService);
exports.ProfileService = ProfileService;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var AuthServerProvider = (function () {
    function AuthServerProvider(http) {
        this.http = http;
    }
    AuthServerProvider.prototype.login = function (credentials) {
        var data = 'j_email=' + encodeURIComponent(credentials.email) +
            '&j_password=' + encodeURIComponent(credentials.password) +
            '&remember-me=' + credentials.rememberMe + '&submit=Login';
        var headers = new http_1.Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return this.http.post('api/authentication', data, {
            headers: headers
        });
    };
    AuthServerProvider.prototype.logout = function () {
        var _this = this;
        // logout from the server
        return this.http.post('api/logout', {}).map(function (response) {
            // to get a new csrf token call the api
            _this.http.get('api/account').subscribe(function () { }, function () { });
            return response;
        });
    };
    return AuthServerProvider;
}());
AuthServerProvider = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuthServerProvider);
exports.AuthServerProvider = AuthServerProvider;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_webstorage_1 = __webpack_require__(35);
var StateStorageService = (function () {
    function StateStorageService($sessionStorage) {
        this.$sessionStorage = $sessionStorage;
    }
    StateStorageService.prototype.getPreviousState = function () {
        return this.$sessionStorage.retrieve('previousState');
    };
    StateStorageService.prototype.resetPreviousState = function () {
        this.$sessionStorage.clear('previousState');
    };
    StateStorageService.prototype.storePreviousState = function (previousStateName, previousStateParams) {
        var previousState = { 'name': previousStateName, 'params': previousStateParams };
        this.$sessionStorage.store('previousState', previousState);
    };
    StateStorageService.prototype.getDestinationState = function () {
        return this.$sessionStorage.retrieve('destinationState');
    };
    StateStorageService.prototype.storeDestinationState = function (destinationState, destinationStateParams, fromState) {
        var destinationInfo = {
            'destination': {
                'name': destinationState.name,
                'data': destinationState.data,
            },
            'params': destinationStateParams,
            'from': {
                'name': fromState.name,
            }
        };
        this.$sessionStorage.store('destinationState', destinationInfo);
    };
    return StateStorageService;
}());
StateStorageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_webstorage_1.SessionStorageService])
], StateStorageService);
exports.StateStorageService = StateStorageService;


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__ = __webpack_require__(47);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageScrollService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageScrollService = PageScrollService_1 = (function () {
    function PageScrollService() {
        var _this = this;
        this.runningInstances = [];
        this.onInterrupted = {
            report: function (event, pageScrollInstance) {
                if (!pageScrollInstance.interruptible) {
                    // Non-interruptible anyway, so do not stop anything
                    return;
                }
                var shouldStop = true;
                if (event.type === 'keyup') {
                    // Only stop if specific keys have been pressed, for all others don't stop anything
                    if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._interruptKeys.indexOf(event.keyCode) === -1) {
                        // The pressed key is not in the list of interrupting keys
                        shouldStop = false;
                    }
                }
                else if (event.type === 'mousedown') {
                    // For mousedown events we only stop the scroll animation of the mouse has
                    // been clicked inside the scrolling container
                    if (!pageScrollInstance.scrollingViews.some(function (scrollingView) { return scrollingView.contains(event.target); })) {
                        // Mouse clicked an element which is not inside any of the the scrolling containers
                        shouldStop = false;
                    }
                }
                if (shouldStop) {
                    _this.stopAll(pageScrollInstance.namespace);
                }
            }
        };
        if (PageScrollService_1.instanceCounter > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
            console.warn('An instance of PageScrollService already exists, usually ' +
                'including one provider should be enough, so double check.');
        }
        PageScrollService_1.instanceCounter++;
    }
    PageScrollService.prototype.stopInternal = function (interrupted, pageScrollInstance) {
        var index = this.runningInstances.indexOf(pageScrollInstance);
        if (index >= 0) {
            this.runningInstances.splice(index, 1);
        }
        if (pageScrollInstance.interruptListenersAttached) {
            pageScrollInstance.detachInterruptListeners();
        }
        if (pageScrollInstance.timer) {
            // Clear/Stop the timer
            clearInterval(pageScrollInstance.timer);
            // Clear the reference to this timer
            pageScrollInstance.timer = undefined;
            pageScrollInstance.fireEvent(!interrupted);
            return true;
        }
        return false;
    };
    /**
     * Start a scroll animation. All properties of the animation are stored in the given {@link PageScrollInstance} object.
     *
     * This is the core functionality of the whole library.
     *
     * @param pageScrollInstance
     */
    PageScrollService.prototype.start = function (pageScrollInstance) {
        var _this = this;
        // Stop all possibly running scroll animations in the same namespace
        this.stopAll(pageScrollInstance.namespace);
        if (pageScrollInstance.scrollingViews === null || pageScrollInstance.scrollingViews.length === 0) {
            // No scrollingViews specified, thus we can't animate anything
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                console.warn('No scrollingViews specified, this ng2-page-scroll does not know which DOM elements to scroll');
            }
            return;
        }
        var startScrollPositionFound = false;
        // Get the start scroll position from the scrollingViews (e.g. if the user already scrolled down the content)
        pageScrollInstance.scrollingViews.forEach(function (scrollingView) {
            if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(scrollingView)) {
                return;
            }
            // Get the scrollTop or scrollLeft value of the first scrollingView that returns a value for its "scrollTop"
            // or "scrollLeft" property that is not undefined and unequal to 0
            var scrollPosition = pageScrollInstance.getScrollPropertyValue(scrollingView);
            if (!startScrollPositionFound && scrollPosition) {
                // We found a scrollingView that does not have scrollTop or scrollLeft 0
                // Return the scroll position value, as this will be our startScrollPosition
                pageScrollInstance.startScrollPosition = scrollPosition;
                startScrollPositionFound = true;
            }
        });
        var pageScrollOffset = pageScrollInstance.getCurrentOffset();
        // Calculate the target position that the scroll animation should go to
        var scrollTargetPosition = pageScrollInstance.extractScrollTargetPosition();
        pageScrollInstance.targetScrollPosition = Math.round((pageScrollInstance.verticalScrolling ? scrollTargetPosition.top : scrollTargetPosition.left) - pageScrollOffset);
        // Calculate the distance we need to go in total
        pageScrollInstance.distanceToScroll = pageScrollInstance.targetScrollPosition - pageScrollInstance.startScrollPosition;
        if (isNaN(pageScrollInstance.distanceToScroll)) {
            // We weren't able to find the target position, maybe the element does not exist?
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                console.log('Scrolling not possible, as we can\'t find the specified target');
            }
            pageScrollInstance.fireEvent(false);
            return;
        }
        // We're at the final destination already
        // OR we need to scroll down but are already at the end
        // OR we need to scroll up but are at the top already
        var allReadyAtDestination = Math.abs(pageScrollInstance.distanceToScroll) < __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._minScrollDistance;
        // We should go there directly, as our "animation" would have one big step
        // only anyway and this way we save the interval stuff
        var tooShortInterval = pageScrollInstance.duration <= __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._interval;
        if (allReadyAtDestination || tooShortInterval) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                if (allReadyAtDestination) {
                    console.log('Scrolling not possible, as we can\'t get any closer to the destination');
                }
                else {
                    console.log('Scroll duration shorter that interval length, jumping to target');
                }
            }
            pageScrollInstance.setScrollPosition(pageScrollInstance.targetScrollPosition);
            pageScrollInstance.fireEvent(true);
            return;
        }
        // Register the interrupt listeners if we want an interruptible scroll animation
        if (pageScrollInstance.interruptible ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(pageScrollInstance.interruptible) && __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultInterruptible)) {
            pageScrollInstance.attachInterruptListeners(this.onInterrupted);
        }
        // Let's get started, get the start time...
        pageScrollInstance.startTime = new Date().getTime();
        // .. and calculate the end time (when we need to finish at last)
        pageScrollInstance.endTime = pageScrollInstance.startTime + pageScrollInstance.duration;
        pageScrollInstance.timer = setInterval(function (_pageScrollInstance) {
            // Take the current time
            var currentTime = new Date().getTime();
            // Determine the new scroll position
            var newScrollPosition;
            var stopNow = false;
            if (_pageScrollInstance.endTime <= currentTime) {
                // We're over the time already, so go the targetScrollPosition (aka destination)
                newScrollPosition = _pageScrollInstance.targetScrollPosition;
                stopNow = true;
            }
            else {
                // Calculate the scroll position based on the current time using the easing function
                newScrollPosition = Math.round(_pageScrollInstance.easingLogic.ease(currentTime - _pageScrollInstance.startTime, _pageScrollInstance.startScrollPosition, _pageScrollInstance.distanceToScroll, _pageScrollInstance.duration));
            }
            // Set the new scrollPosition to all scrollingViews elements
            if (!_pageScrollInstance.setScrollPosition(newScrollPosition)) {
                // Setting the new scrollTop/scrollLeft value failed for all ScrollingViews
                // early stop the scroll animation to save resources
                stopNow = true;
            }
            // At the end do the internal stop maintenance and fire the pageScrollFinish event
            // (otherwise the event might arrive at "too early")
            if (stopNow) {
                _this.stopInternal(false, _pageScrollInstance);
            }
        }, __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._interval, pageScrollInstance);
        // Register the instance as running one
        this.runningInstances.push(pageScrollInstance);
    };
    /**
     * Stop all running scroll animations. Optionally limit to stop only the ones of specific namespace.
     *
     * @param namespace
     * @returns {boolean}
     */
    PageScrollService.prototype.stopAll = function (namespace) {
        if (this.runningInstances.length > 0) {
            var stoppedSome = false;
            for (var i = 0; i < this.runningInstances.length; ++i) {
                var pageScrollInstance = this.runningInstances[i];
                if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(namespace) || namespace.length === 0 ||
                    pageScrollInstance.namespace === namespace) {
                    stoppedSome = true;
                    this.stopInternal(true, pageScrollInstance);
                    // Decrease the counter, as we removed an item from the array we iterate over
                    i--;
                }
            }
            return stoppedSome;
        }
        return false;
    };
    PageScrollService.prototype.stop = function (pageScrollInstance) {
        return this.stopInternal(true, pageScrollInstance);
    };
    return PageScrollService;
}());
PageScrollService.instanceCounter = 0;
PageScrollService = PageScrollService_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [])
], PageScrollService);

var PageScrollService_1;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var activate_service_1 = __webpack_require__(85);
var ActivateComponent = (function () {
    function ActivateComponent(jhiLanguageService, activate, route, router) {
        this.jhiLanguageService = jhiLanguageService;
        this.activate = activate;
        this.route = route;
        this.router = router;
        this.jhiLanguageService.setLocations(['activate', 'global']);
    }
    ActivateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.activate.get(params['key']).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function (error) {
                _this.success = null;
                _this.error = 'ERROR';
            });
        });
    };
    ActivateComponent.prototype.login = function () {
        this.router.navigate(['/login']);
    };
    return ActivateComponent;
}());
ActivateComponent = __decorate([
    core_1.Component({
        selector: 'jhi-activate',
        template: __webpack_require__(375)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        activate_service_1.Activate,
        router_1.ActivatedRoute,
        router_1.Router])
], ActivateComponent);
exports.ActivateComponent = ActivateComponent;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var Activate = (function () {
    function Activate(http) {
        this.http = http;
    }
    Activate.prototype.get = function (key) {
        var params = new http_1.URLSearchParams();
        params.set('key', key);
        return this.http.get('api/activate', {
            search: params
        }).map(function (res) { return res; });
    };
    return Activate;
}());
Activate = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Activate);
exports.Activate = Activate;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var shared_1 = __webpack_require__(2);
var login_service_1 = __webpack_require__(87);
var parametrage_1 = __webpack_require__(11);
var JhiLoginComponent = (function () {
    function JhiLoginComponent(eventManager, languageService, loginService, stateStorageService, elementRef, renderer, principal, router, parametrageService, translate) {
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.loginService = loginService;
        this.stateStorageService = stateStorageService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.principal = principal;
        this.router = router;
        this.parametrageService = parametrageService;
        this.translate = translate;
        this.languageService.setLocations(['global', 'login']);
        this.credentials = {};
    }
    JhiLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.queryPageEspaceConnexion().subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.currentLang = '' + this.languageService.currentLang;
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    };
    JhiLoginComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    JhiLoginComponent.prototype.cancel = function () {
        this.credentials = {
            email: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
    };
    JhiLoginComponent.prototype.login = function () {
        var _this = this;
        this.loginService.login({
            email: this.email,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(function () {
            _this.authenticationError = false;
            if (_this.router.url === '/register' || _this.router.url === '/activate' ||
                _this.router.url === '/finishReset' || _this.router.url === '/requestReset') {
                _this.router.navigate(['']);
            }
            _this.eventManager.broadcast({
                name: 'authenticationSuccess',
                content: 'Sending Authentication Success'
            });
            // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // // since login is succesful, go to stored previousState and clear previousState
            var previousState = _this.stateStorageService.getPreviousState();
            if (previousState) {
                _this.stateStorageService.resetPreviousState();
                _this.router.navigate([previousState.name], { queryParams: previousState.params });
            }
            _this.principal.rootUrl().then(function (rootUrl) {
                _this.router.navigate([rootUrl]);
            });
        }).catch(function () {
            _this.authenticationError = true;
        });
    };
    JhiLoginComponent.prototype.register = function () {
        this.router.navigate(['/register']);
    };
    JhiLoginComponent.prototype.requestResetPassword = function () {
        this.router.navigate(['/reset', 'request']);
    };
    JhiLoginComponent.prototype.getConnexionMessage = function (langue) {
        if (langue && langue === 'en') {
            return this.parametrage.MESSAGE_CONNEXION.libelleEn;
        }
        else {
            return this.parametrage.MESSAGE_CONNEXION.libelle;
        }
    };
    return JhiLoginComponent;
}());
JhiLoginComponent = __decorate([
    core_1.Component({
        selector: 'jhi-login',
        template: __webpack_require__(376)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        login_service_1.LoginService,
        shared_1.StateStorageService,
        core_1.ElementRef,
        core_1.Renderer,
        shared_1.Principal,
        router_1.Router,
        parametrage_1.ParametrageService,
        ng2_translate_1.TranslateService])
], JhiLoginComponent);
exports.JhiLoginComponent = JhiLoginComponent;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var principal_service_1 = __webpack_require__(43);
var auth_session_service_1 = __webpack_require__(81);
var LoginService = (function () {
    function LoginService(languageService, principal, authServerProvider) {
        this.languageService = languageService;
        this.principal = principal;
        this.authServerProvider = authServerProvider;
    }
    LoginService.prototype.login = function (credentials, callback) {
        var _this = this;
        var cb = callback || function () { };
        return new Promise(function (resolve, reject) {
            _this.authServerProvider.login(credentials).subscribe(function (data) {
                _this.principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        _this.languageService.changeLanguage(account.langKey);
                    }
                    resolve(data);
                });
                return cb();
            }, function (err) {
                _this.logout();
                reject(err);
                return cb(err);
            });
        });
    };
    LoginService.prototype.logout = function () {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
    };
    return LoginService;
}());
LoginService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        principal_service_1.Principal,
        auth_session_service_1.AuthServerProvider])
], LoginService);
exports.LoginService = LoginService;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_finish_service_1 = __webpack_require__(89);
var PasswordResetFinishComponent = (function () {
    function PasswordResetFinishComponent(jhiLanguageService, passwordResetFinish, route, router, elementRef, renderer) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetFinish = passwordResetFinish;
        this.route = route;
        this.router = router;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetFinishComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    };
    PasswordResetFinishComponent.prototype.ngAfterViewInit = function () {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    };
    PasswordResetFinishComponent.prototype.finishReset = function () {
        var _this = this;
        this.doNotMatch = null;
        this.error = null;
        if (this.resetAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.passwordResetFinish.save({ key: this.key, newPassword: this.resetAccount.password }).subscribe(function () {
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    PasswordResetFinishComponent.prototype.login = function () {
        this.router.navigate(['/login']);
    };
    return PasswordResetFinishComponent;
}());
PasswordResetFinishComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-reset-finish',
        template: __webpack_require__(377)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_finish_service_1.PasswordResetFinish,
        router_1.ActivatedRoute,
        router_1.Router,
        core_1.ElementRef, core_1.Renderer])
], PasswordResetFinishComponent);
exports.PasswordResetFinishComponent = PasswordResetFinishComponent;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var PasswordResetFinish = (function () {
    function PasswordResetFinish(http) {
        this.http = http;
    }
    PasswordResetFinish.prototype.save = function (keyAndPassword) {
        return this.http.post('api/account/reset_password/finish', keyAndPassword);
    };
    return PasswordResetFinish;
}());
PasswordResetFinish = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetFinish);
exports.PasswordResetFinish = PasswordResetFinish;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_init_service_1 = __webpack_require__(91);
var PasswordResetInitComponent = (function () {
    function PasswordResetInitComponent(jhiLanguageService, passwordResetInit, elementRef, renderer) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetInit = passwordResetInit;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetInitComponent.prototype.ngOnInit = function () {
        this.resetAccount = {};
    };
    PasswordResetInitComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    PasswordResetInitComponent.prototype.requestReset = function () {
        var _this = this;
        this.error = null;
        this.errorEmailNotExists = null;
        this.passwordResetInit.save(this.resetAccount.email).subscribe(function () {
            _this.success = 'OK';
        }, function (response) {
            _this.success = null;
            if (response.status === 400 && response.text().indexOf('registered') > 0) {
                _this.errorEmailNotExists = 'ERROR';
            }
            else {
                _this.error = 'ERROR';
            }
        });
    };
    return PasswordResetInitComponent;
}());
PasswordResetInitComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-reset-init',
        template: __webpack_require__(378)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_init_service_1.PasswordResetInit,
        core_1.ElementRef,
        core_1.Renderer])
], PasswordResetInitComponent);
exports.PasswordResetInitComponent = PasswordResetInitComponent;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var PasswordResetInit = (function () {
    function PasswordResetInit(http) {
        this.http = http;
    }
    PasswordResetInit.prototype.save = function (mail) {
        return this.http.post('api/account/reset_password/init', mail);
    };
    return PasswordResetInit;
}());
PasswordResetInit = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetInit);
exports.PasswordResetInit = PasswordResetInit;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var password_service_1 = __webpack_require__(93);
var PasswordComponent = (function () {
    function PasswordComponent(jhiLanguageService, passwordService, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordService = passwordService;
        this.principal = principal;
        this.passwordChangeAllowed = true;
        this.jhiLanguageService.setLocations(['password']);
    }
    PasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
            if (_this.account.email.indexOf('@ens-lyon.fr') > 0) {
                _this.passwordChangeAllowed = false;
            }
        });
    };
    PasswordComponent.prototype.changePassword = function () {
        var _this = this;
        if (this.password !== this.confirmPassword) {
            this.error = null;
            this.success = null;
            this.doNotMatch = 'ERROR';
        }
        else {
            this.doNotMatch = null;
            this.passwordService.save(this.password).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    return PasswordComponent;
}());
PasswordComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password',
        template: __webpack_require__(379)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_service_1.Password,
        shared_1.Principal])
], PasswordComponent);
exports.PasswordComponent = PasswordComponent;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var Password = (function () {
    function Password(http) {
        this.http = http;
    }
    Password.prototype.save = function (newPassword) {
        return this.http.post('api/account/change_password', newPassword);
    };
    return Password;
}());
Password = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Password);
exports.Password = Password;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var register_service_1 = __webpack_require__(51);
var RegisterConfirmationComponent = (function () {
    function RegisterConfirmationComponent(languageService, register) {
        this.languageService = languageService;
        this.register = register;
        this.languageService.setLocations(['register']);
    }
    RegisterConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.register.query().subscribe(function (res) {
            _this.parametrage = res.json();
        });
    };
    return RegisterConfirmationComponent;
}());
RegisterConfirmationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-register-confirmation',
        template: __webpack_require__(380)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        register_service_1.Register])
], RegisterConfirmationComponent);
exports.RegisterConfirmationComponent = RegisterConfirmationComponent;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var register_service_1 = __webpack_require__(51);
var router_1 = __webpack_require__(3);
var calendar_constants_1 = __webpack_require__(15);
var parametrage_1 = __webpack_require__(11);
var RegisterComponent = (function () {
    function RegisterComponent(languageService, registerService, elementRef, renderer, router, activatedRoute, parametrageService, translate) {
        this.languageService = languageService;
        this.registerService = registerService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.parametrageService = parametrageService;
        this.translate = translate;
        this.createUser = false;
        this.languageService.setLocations(['register']);
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.success = false;
        this.registerAccount = {};
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.activatedRoute.params.subscribe(function (params) {
            _this.createUser = params['createUser'];
        });
        this.parametrageService.queryPageEspaceConnexion().subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.currentLang = '' + this.languageService.currentLang;
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    };
    RegisterComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    RegisterComponent.prototype.register = function () {
        var _this = this;
        if (this.registerAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.doNotMatch = null;
            this.error = null;
            this.errorEmailExists = null;
            this.languageService.getCurrent().then(function (key) {
                _this.registerAccount.langKey = key;
                _this.registerAccount.login = _this.registerAccount.email;
                _this.registerService.save(_this.registerAccount).subscribe(function () {
                    _this.router.navigate(['/register-confirmation']);
                    _this.success = true;
                }, function (response) { return _this.processError(response); });
            });
        }
    };
    RegisterComponent.prototype.openLogin = function () {
        this.router.navigate(['/login']);
    };
    RegisterComponent.prototype.processError = function (response) {
        this.success = null;
        if (response.status === 400 && response._body === 'userexists') {
            this.errorEmailExists = 'ERROR';
        }
        else {
            if (response._body.toUpperCase().indexOf('SENDFAILEDEXCEPTION') >= 0) {
                this.errorTestEmail = 'ERROR';
            }
            else {
                this.error = 'ERROR';
            }
        }
    };
    RegisterComponent.prototype.getConnexionMessage = function (langue) {
        if (langue && langue === 'en') {
            return this.parametrage.MESSAGE_INSCRIPTION.libelleEn;
        }
        else {
            return this.parametrage.MESSAGE_INSCRIPTION.libelle;
        }
    };
    return RegisterComponent;
}());
RegisterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-register',
        template: __webpack_require__(381)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        register_service_1.Register,
        core_1.ElementRef,
        core_1.Renderer,
        router_1.Router,
        router_1.ActivatedRoute,
        parametrage_1.ParametrageService,
        ng2_translate_1.TranslateService])
], RegisterComponent);
exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var sessions_service_1 = __webpack_require__(97);
var shared_1 = __webpack_require__(2);
var SessionsComponent = (function () {
    function SessionsComponent(jhiLanguageService, sessionsService, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.sessionsService = sessionsService;
        this.principal = principal;
        this.jhiLanguageService.setLocations(['sessions']);
    }
    SessionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sessionsService.findAll().subscribe(function (sessions) { return _this.sessions = sessions; });
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
    };
    SessionsComponent.prototype.invalidate = function (series) {
        var _this = this;
        this.sessionsService.delete(encodeURIComponent(series)).subscribe(function (response) {
            if (response.status === 200) {
                _this.error = null;
                _this.success = 'OK';
                _this.sessionsService.findAll().subscribe(function (sessions) { return _this.sessions = sessions; });
            }
            else {
                _this.success = null;
                _this.error = 'ERROR';
            }
        });
    };
    return SessionsComponent;
}());
SessionsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-sessions',
        template: __webpack_require__(382)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        sessions_service_1.SessionsService,
        shared_1.Principal])
], SessionsComponent);
exports.SessionsComponent = SessionsComponent;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var SessionsService = (function () {
    function SessionsService(http) {
        this.http = http;
        this.resourceUrl = 'api/account/sessions/';
    }
    SessionsService.prototype.findAll = function () {
        return this.http.get(this.resourceUrl).map(function (res) { return res.json(); });
    };
    SessionsService.prototype.delete = function (series) {
        return this.http.delete("" + this.resourceUrl + series);
    };
    return SessionsService;
}());
SessionsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], SessionsService);
exports.SessionsService = SessionsService;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var calendar_constants_1 = __webpack_require__(15);
var SettingsComponent = (function () {
    function SettingsComponent(account, principal, languageService, languageHelper) {
        this.account = account;
        this.principal = principal;
        this.languageService = languageService;
        this.languageHelper = languageHelper;
        this.languageService.setLocations(['settings']);
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            account.birthDate = account.birthDate != null ? new Date(account.birthDate) : null;
            _this.settingsAccount = account;
        });
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.fr = calendar_constants_1.CALENDAR_FR;
    };
    SettingsComponent.prototype.save = function () {
        var _this = this;
        this.account.save(this.settingsAccount).subscribe(function () {
            _this.error = null;
            _this.success = 'OK';
            _this.principal.identity(true).then(function (account) {
                account.birthDate = account.birthDate != null ? new Date(account.birthDate) : null;
                _this.settingsAccount = account;
            });
            _this.languageService.getCurrent().then(function (current) {
                if (_this.settingsAccount.langKey !== current) {
                    _this.languageService.changeLanguage(_this.settingsAccount.langKey);
                }
            });
        }, function () {
            _this.success = null;
            _this.error = 'ERROR';
        });
    };
    return SettingsComponent;
}());
SettingsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-settings',
        template: __webpack_require__(383)
    }),
    __metadata("design:paramtypes", [shared_1.AccountService,
        shared_1.Principal,
        ng_jhipster_1.JhiLanguageService,
        shared_1.JhiLanguageHelper])
], SettingsComponent);
exports.SettingsComponent = SettingsComponent;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var parametrage_1 = __webpack_require__(11);
var ng2_translate_1 = __webpack_require__(7);
var AideComponent = AideComponent_1 = (function () {
    function AideComponent(jhiLanguageService, authorityService, alertService, principal, eventManager, parametrageService, confirmationService, translateService) {
        this.jhiLanguageService = jhiLanguageService;
        this.authorityService = authorityService;
        this.alertService = alertService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.parametrageService = parametrageService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.userRolesList = new shared_1.KeyedCollection();
        this.aidePresente = false;
        this.maxSize = 10000000;
        this.jhiLanguageService.setLocations(['user-management', 'global', 'aide']);
    }
    AideComponent.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    AideComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.isGestionnaire = shared_1.Principal.isAnyAuthorityInListe(['ROLE_GEST', 'ROLE_SYSTEM', 'ROLE_ADMIN'], account.authorities);
            _this.loadAll();
        });
    };
    AideComponent.prototype.loadAll = function () {
        var _this = this;
        this.authorityService.getAllAuthorities().subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res); });
    };
    AideComponent.prototype.supprimeAide = function (nomRole) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('aide.suppression.message'),
            header: this.translateService.instant('aide.suppression.titre'),
            icon: 'fa fa-trash',
            key: 'confirmAide',
            accept: function () {
                _this.parametrageService.suppressFile(AideComponent_1.categorieAide, nomRole).subscribe(function (response) {
                    _this.loadAll();
                }, function (response) {
                    _this.onError(response);
                });
            }
        });
    };
    AideComponent.prototype.onSuccess = function (roleListe, headers) {
        var _this = this;
        roleListe.forEach(function (role) {
            _this.userRolesList.Add(role.name, {
                'nomRole': role.name,
                rolePresent: false,
                userRole: false,
                'nomFichierAide': null
            });
        });
        this.determinePresenceAide();
    };
    AideComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    AideComponent.prototype.determinePresenceAide = function () {
        var _this = this;
        if (this.currentAccount.authorities != null && this.currentAccount.authorities.length > 0) {
            this.userRolesList.Keys().forEach(function (authority) {
                if (_this.currentAccount.authorities != null &&
                    _this.currentAccount.authorities.length > 0 &&
                    (_this.isGestionnaire || shared_1.Principal.isAuthorityInListe(authority.toString(), _this.currentAccount.authorities))) {
                    _this.userRolesList.Item(authority).rolePresent = true;
                    _this.userRolesList.Item(authority).userRole = _this.userRolesList.ContainsKey(authority);
                    _this.rechercheNomFichierAide(authority);
                }
            });
            // on enleve les roles absents
            if (!this.isGestionnaire) {
                this.userRolesList.Values().forEach(function (role) {
                    if (role.rolePresent == false) {
                        _this.userRolesList.Remove(role.nomRole);
                    }
                });
            }
        }
    };
    AideComponent.prototype.rechercheNomFichierAide = function (authority) {
        var _this = this;
        this.parametrageService.getFileName(AideComponent_1.categorieAide, authority.toString()).subscribe(function (res) {
            if (res != null && res.text() != null && res.text().length > 0) {
                _this.userRolesList.Item(authority).nomFichierAide = res.text();
            }
        }, function (res) { return _this.onError(res); });
    };
    AideComponent.prototype.openAide = function (role) {
        var _this = this;
        this.parametrageService.getFile(AideComponent_1.categorieAide, role).subscribe(function (file) {
            shared_1.ExportService.download(file, role);
        }, function (response) {
            _this.onError(response);
        });
    };
    AideComponent.prototype.onFileUploaded = function (event, userRole) {
        this.rechercheNomFichierAide(userRole);
    };
    // Before the file is sent to the server for upload
    AideComponent.prototype.onBeforeUpload = function (event, user_role) {
        event.formData.append('parametreCategorie', 'aide');
        event.formData.append('parametre', user_role);
    };
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    AideComponent.prototype.onBeforeSend = function (event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', AideComponent_1.getCookie('XSRF-TOKEN'));
    };
    return AideComponent;
}());
AideComponent.categorieAide = 'aide';
AideComponent = AideComponent_1 = __decorate([
    core_1.Component({
        selector: 'jhi-aide',
        template: __webpack_require__(384)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.AuthorityService,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.EventManager,
        parametrage_1.ParametrageService,
        primeng_1.ConfirmationService,
        ng2_translate_1.TranslateService])
], AideComponent);
exports.AideComponent = AideComponent;
var AideComponent_1;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var archive_service_1 = __webpack_require__(52);
var api_1 = __webpack_require__(16);
var Observable_1 = __webpack_require__(48);
var JhiArchiveComponent = (function () {
    function JhiArchiveComponent(jhiLanguageService, archiveService, confirmationService, translateService, alertService) {
        this.jhiLanguageService = jhiLanguageService;
        this.archiveService = archiveService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.alertService = alertService;
        this.archive = null;
        this.listeRepertoire = null;
        this.isLoading = false;
        this.disableArchive = false;
        this.archivageEnCoursDepuis = null;
        this.archivageEnCours = false;
        this.jhiLanguageService.setLocations(['archive']);
        this.filter = '';
    }
    JhiArchiveComponent.prototype.ngOnInit = function () {
        this.refreshStatusArchivage.call(this);
        this.refreshArchive.call(this);
    };
    JhiArchiveComponent.prototype.refreshStatusArchivage = function () {
        var _this = this;
        this.archiveService.getStatusArchivage().subscribe(function (statusArchivage) {
            // date de lancement non null -> archivage en cours sur back end
            if (statusArchivage.dateDeLancement != null) {
                _this.archivageEnCoursDepuis = ((+(new Date()) - +(statusArchivage.dateDeLancement)) / 1000).toFixed();
                // si il y avait pas scrutation périodique en cours en front end on lance la scrutation périodique
                if (_this.archivageEnCours == false) {
                    _this.archivageEnCours = true;
                    Observable_1.Observable.interval(5000).takeWhile(function () { return _this.archivageEnCours == true; })
                        .subscribe(function () { return _this.refreshStatusArchivage(); });
                }
            }
            else {
                // si pas de scrutation périodique on met a zéro la valeur du compteur
                if (_this.archivageEnCours == false) {
                    _this.archivageEnCoursDepuis = null;
                }
                else {
                    // on arrete scrutation périodique
                    _this.archivageEnCours = false;
                    _this.refreshArchive.call(_this);
                }
            }
        }, function (archive) {
            _this.alertService.error(archive, null, null);
        });
    };
    JhiArchiveComponent.prototype.refreshArchive = function () {
        var _this = this;
        this.isLoading = true;
        this.archiveService.get('0').subscribe(function (archive) {
            _this.isLoading = false;
            _this.archive = archive;
            _this.ordonneArchive(_this.archive.fichier);
            if (_this.archive.anneeCourante != null && _this.archivageEnCours == false) {
                _this.metAJourFlagSuppression(_this.archive.fichier, _this.archive.anneeCourante.toString());
            }
            _this.listeRepertoire = _this.archive.fichier.listeRepertoire;
        }, function (archive) {
            _this.isLoading = false;
            _this.alertService.error(archive, null, null);
        });
    };
    JhiArchiveComponent.prototype.onRefreshTreeView = function (refresh) {
        this.refreshArchive.call(this);
    };
    JhiArchiveComponent.prototype.ordonneArchive = function (fichier) {
        var _this = this;
        if (fichier != null) {
            if (fichier.listeSimpleFichier != null) {
                fichier.listeSimpleFichier.sort(function (a, b) { return a.nom.localeCompare(b.nom); });
            }
            if (fichier.listeRepertoire != null) {
                fichier.listeRepertoire.forEach(function (repertoire) { return _this.ordonneArchive(repertoire); });
            }
        }
    };
    JhiArchiveComponent.prototype.metAJourFlagSuppression = function (fichier, debutNom) {
        var _this = this;
        if (fichier != null) {
            if (fichier.nom.startsWith(debutNom)) {
                fichier.peuxEtreSupprime = true;
            }
            if (fichier.listeRepertoire != null) {
                fichier.listeRepertoire.forEach(function (repertoire) { return _this.metAJourFlagSuppression(repertoire, debutNom); });
            }
        }
    };
    JhiArchiveComponent.prototype.archiveAnneeCourante = function () {
        this.confirmationArchive();
    };
    JhiArchiveComponent.prototype.confirmationArchive = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('archive.confirm.question'),
            header: this.translateService.instant('archive.confirm.title'),
            icon: 'fa fa-archive',
            accept: function () {
                _this.disableArchive = true;
                _this.isLoading = true;
                _this.archivageEnCours = true;
                Observable_1.Observable.interval(5000).takeWhile(function () { return _this.archivageEnCours == true; }).subscribe(function () { return _this.refreshStatusArchivage(); });
                _this.archiveService.archiveAnneecourante().subscribe(function (archive) {
                    // archivage lancé--> la fonction refreshStatusArchivage est appelée périodiquement
                }, function (archive) {
                    _this.isLoading = false;
                    _this.archivageEnCours = false;
                    _this.alertService.error(archive, null, null);
                });
            }
        });
    };
    return JhiArchiveComponent;
}());
JhiArchiveComponent = __decorate([
    core_1.Component({
        selector: 'jhi-archive',
        template: __webpack_require__(385),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        archive_service_1.JhiArchiveService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService,
        ng_jhipster_1.AlertService])
], JhiArchiveComponent);
exports.JhiArchiveComponent = JhiArchiveComponent;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Fichier = (function () {
    function Fichier() {
        this.nom = '';
        this.listeFichier = [];
        this.listeRepertoire = [];
        this.listeSimpleFichier = [];
        this.isRepertoire = false;
        this.expanded = false;
        this.checked = false;
        this.peuxEtreSupprime = false;
    }
    Fichier.BuildListeSimpleFichier = function (fichierParent) {
        return fichierParent.listeFichier.filter(function (fichier) { return fichier.isRepertoire == false; });
    };
    Fichier.BuildListeRepertoires = function (fichierParent) {
        return fichierParent.listeFichier.filter(function (fichier) { return fichier.isRepertoire == true; });
    };
    Fichier.creeFichier = function (fichierJson) {
        var newFichier = null;
        if (fichierJson != null) {
            newFichier = new Fichier();
            newFichier.nom = fichierJson.nom;
            newFichier.isRepertoire = fichierJson.isRepertoire;
            newFichier.listeRepertoire = [];
            if (fichierJson.listeFichier != null && fichierJson.listeFichier.length > 0) {
                fichierJson.listeFichier.forEach(function (fichierFils) { return newFichier.listeFichier.push(Fichier.creeFichier(fichierFils)); });
                newFichier.listeRepertoire = Fichier.BuildListeRepertoires(newFichier);
                newFichier.listeSimpleFichier = Fichier.BuildListeSimpleFichier(newFichier);
            }
        }
        return newFichier;
    };
    Fichier.prototype.toggle = function () {
        this.expanded = !this.expanded;
    };
    // noinspection JSUnusedGlobalSymbols
    Fichier.prototype.checkRepertoire = function () {
        this.checked = !this.checked;
        this.checkRecursive(this.checked);
    };
    Fichier.prototype.check = function () {
        this.checked = !this.checked;
    };
    Fichier.prototype.checkRecursive = function (state) {
        this.listeFichier.forEach(function (d) {
            d.checked = state;
            d.checkRecursive(state);
        });
    };
    return Fichier;
}());
exports.Fichier = Fichier;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var PrettyPrintPipe = (function () {
    function PrettyPrintPipe() {
    }
    PrettyPrintPipe.prototype.transform = function (val) {
        return JSON.stringify(val, null, 2)
            .replace(' ', '&nbsp;')
            .replace('\n', '<br/>');
    };
    return PrettyPrintPipe;
}());
PrettyPrintPipe = __decorate([
    core_1.Pipe({
        name: 'prettyprint'
    })
], PrettyPrintPipe);
exports.PrettyPrintPipe = PrettyPrintPipe;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(24);
var ng_jhipster_1 = __webpack_require__(1);
var audits_service_1 = __webpack_require__(104);
var shared_1 = __webpack_require__(2);
var uib_pagination_config_1 = __webpack_require__(57);
var AuditsComponent = (function () {
    function AuditsComponent(jhiLanguageService, auditsService, parseLinks, paginationConfig, datePipe) {
        this.jhiLanguageService = jhiLanguageService;
        this.auditsService = auditsService;
        this.parseLinks = parseLinks;
        this.paginationConfig = paginationConfig;
        this.datePipe = datePipe;
        this.jhiLanguageService.setLocations(['audits']);
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 1;
        this.reverse = false;
        this.orderProp = 'timestamp';
    }
    AuditsComponent.prototype.getAudits = function () {
        return this.sortAudits(this.audits);
    };
    AuditsComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.onChangeDate();
    };
    AuditsComponent.prototype.ngOnInit = function () {
        this.today();
        this.previousMonth();
        this.onChangeDate();
    };
    AuditsComponent.prototype.onChangeDate = function () {
        var _this = this;
        this.auditsService.query({ page: this.page - 1, size: this.itemsPerPage,
            fromDate: this.fromDate, toDate: this.toDate }).subscribe(function (res) {
            _this.audits = res.json();
            _this.links = _this.parseLinks.parse(res.headers.get('link'));
            _this.totalItems = +res.headers.get('X-Total-Count');
        });
    };
    AuditsComponent.prototype.previousMonth = function () {
        var dateFormat = 'yyyy-MM-dd';
        var fromDate = new Date();
        if (fromDate.getMonth() === 0) {
            fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
        }
        else {
            fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
        }
        this.fromDate = this.datePipe.transform(fromDate, dateFormat);
    };
    AuditsComponent.prototype.today = function () {
        var dateFormat = 'yyyy-MM-dd';
        // Today + 1 day - needed if the current day must be included
        var today = new Date();
        var date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        this.toDate = this.datePipe.transform(date, dateFormat);
    };
    AuditsComponent.prototype.sortAudits = function (audits) {
        var _this = this;
        audits = audits.slice(0).sort(function (a, b) {
            if (a[_this.orderProp] < b[_this.orderProp]) {
                return -1;
            }
            else if (true) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return this.reverse ? audits.reverse() : audits;
    };
    return AuditsComponent;
}());
AuditsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-audit',
        template: __webpack_require__(387)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        audits_service_1.AuditsService,
        ng_jhipster_1.ParseLinks,
        uib_pagination_config_1.PaginationConfig,
        common_1.DatePipe])
], AuditsComponent);
exports.AuditsComponent = AuditsComponent;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var AuditsService = (function () {
    function AuditsService(http) {
        this.http = http;
    }
    AuditsService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        params.set('fromDate', req.fromDate);
        params.set('toDate', req.toDate);
        params.set('page', req.page);
        params.set('size', req.size);
        params.set('sort', req.sort);
        var options = {
            search: params
        };
        return this.http.get('management/audits', options);
    };
    return AuditsService;
}());
AuditsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuditsService);
exports.AuditsService = AuditsService;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var configuration_service_1 = __webpack_require__(106);
var JhiConfigurationComponent = (function () {
    function JhiConfigurationComponent(jhiLanguageService, configurationService) {
        this.jhiLanguageService = jhiLanguageService;
        this.configurationService = configurationService;
        this.allConfiguration = null;
        this.configuration = null;
        this.jhiLanguageService.setLocations(['configuration']);
        this.configKeys = [];
        this.filter = '';
        this.orderProp = 'prefix';
        this.reverse = false;
    }
    JhiConfigurationComponent.prototype.keys = function (dict) {
        return (dict === undefined) ? [] : Object.keys(dict);
    };
    JhiConfigurationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configurationService.get().subscribe(function (configuration) {
            _this.configuration = configuration;
            for (var _i = 0, configuration_1 = configuration; _i < configuration_1.length; _i++) {
                var config = configuration_1[_i];
                if (config.properties !== undefined) {
                    _this.configKeys.push(Object.keys(config.properties));
                }
            }
        });
        this.configurationService.getEnv().subscribe(function (configuration) {
            _this.allConfiguration = configuration;
        });
    };
    return JhiConfigurationComponent;
}());
JhiConfigurationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-configuration',
        template: __webpack_require__(388)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        configuration_service_1.JhiConfigurationService])
], JhiConfigurationComponent);
exports.JhiConfigurationComponent = JhiConfigurationComponent;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var JhiConfigurationService = (function () {
    function JhiConfigurationService(http) {
        this.http = http;
    }
    JhiConfigurationService.prototype.get = function () {
        return this.http.get('management/configprops').map(function (res) {
            var properties = [];
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    properties.push(propertiesObject[key]);
                }
            }
            return properties.sort(function (propertyA, propertyB) {
                return (propertyA.prefix === propertyB.prefix) ? 0 :
                    (propertyA.prefix < propertyB.prefix) ? -1 : 1;
            });
        });
    };
    JhiConfigurationService.prototype.getEnv = function () {
        return this.http.get('management/env').map(function (res) {
            var properties = {};
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    var valsObject = propertiesObject[key];
                    var vals = [];
                    for (var valKey in valsObject) {
                        if (valsObject.hasOwnProperty(valKey)) {
                            vals.push({ key: valKey, val: valsObject[valKey] });
                        }
                    }
                    properties[key] = vals;
                }
            }
            return properties;
        });
    };
    return JhiConfigurationService;
}());
JhiConfigurationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiConfigurationService);
exports.JhiConfigurationService = JhiConfigurationService;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var JhiDocsComponent = (function () {
    function JhiDocsComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['global']);
    }
    return JhiDocsComponent;
}());
JhiDocsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-docs',
        template: __webpack_require__(389)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], JhiDocsComponent);
exports.JhiDocsComponent = JhiDocsComponent;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(5);
var health_service_1 = __webpack_require__(53);
var JhiHealthModalComponent = (function () {
    function JhiHealthModalComponent(healthService, activeModal) {
        this.healthService = healthService;
        this.activeModal = activeModal;
    }
    JhiHealthModalComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    JhiHealthModalComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    JhiHealthModalComponent.prototype.readableValue = function (value) {
        if (this.currentHealth.name !== 'diskSpace') {
            return value.toString();
        }
        // Should display storage space in an human readable unit
        var val = value / 1073741824;
        if (val > 1) {
            return val.toFixed(2) + ' GB';
        }
        else {
            return (value / 1048576).toFixed(2) + ' MB';
        }
    };
    return JhiHealthModalComponent;
}());
JhiHealthModalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-health-modal',
        template: __webpack_require__(390)
    }),
    __metadata("design:paramtypes", [health_service_1.JhiHealthService, ng_bootstrap_1.NgbActiveModal])
], JhiHealthModalComponent);
exports.JhiHealthModalComponent = JhiHealthModalComponent;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var health_service_1 = __webpack_require__(53);
var health_modal_component_1 = __webpack_require__(108);
var JhiHealthCheckComponent = (function () {
    function JhiHealthCheckComponent(jhiLanguageService, modalService, healthService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.healthService = healthService;
        this.jhiLanguageService.setLocations(['health']);
    }
    JhiHealthCheckComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    JhiHealthCheckComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    JhiHealthCheckComponent.prototype.getBadgeClass = function (statusState) {
        if (statusState === 'UP') {
            return 'badge-success';
        }
        else {
            return 'badge-danger';
        }
    };
    JhiHealthCheckComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingHealth = true;
        this.healthService.checkHealth().subscribe(function (health) {
            _this.healthData = _this.healthService.transformHealthData(health);
            _this.updatingHealth = false;
        }, function (error) {
            if (error.status === 503) {
                _this.healthData = _this.healthService.transformHealthData(error.json());
                _this.updatingHealth = false;
            }
        });
    };
    JhiHealthCheckComponent.prototype.showHealth = function (health) {
        var modalRef = this.modalService.open(health_modal_component_1.JhiHealthModalComponent);
        modalRef.componentInstance.currentHealth = health;
        modalRef.result.then(function (result) {
            // Left blank intentionally, nothing to do here
        }, function (reason) {
            // Left blank intentionally, nothing to do here
        });
    };
    JhiHealthCheckComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    return JhiHealthCheckComponent;
}());
JhiHealthCheckComponent = __decorate([
    core_1.Component({
        selector: 'jhi-health',
        template: __webpack_require__(391),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        health_service_1.JhiHealthService])
], JhiHealthCheckComponent);
exports.JhiHealthCheckComponent = JhiHealthCheckComponent;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Log = (function () {
    function Log(name, level) {
        this.name = name;
        this.level = level;
    }
    return Log;
}());
exports.Log = Log;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var log_model_1 = __webpack_require__(110);
var logs_service_1 = __webpack_require__(112);
var LogsComponent = (function () {
    function LogsComponent(jhiLanguageService, logsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.logsService = logsService;
        this.filter = '';
        this.orderProp = 'name';
        this.reverse = false;
        this.jhiLanguageService.setLocations(['logs']);
    }
    LogsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
    };
    LogsComponent.prototype.changeLevel = function (name, level) {
        var _this = this;
        var log = new log_model_1.Log(name, level);
        this.logsService.changeLevel(log).subscribe(function () {
            _this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
        });
    };
    return LogsComponent;
}());
LogsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-logs',
        template: __webpack_require__(392),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        logs_service_1.LogsService])
], LogsComponent);
exports.LogsComponent = LogsComponent;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var LogsService = (function () {
    function LogsService(http) {
        this.http = http;
    }
    LogsService.prototype.changeLevel = function (log) {
        return this.http.put('management/logs', log);
    };
    LogsService.prototype.findAll = function () {
        return this.http.get('management/logs').map(function (res) { return res.json(); });
    };
    return LogsService;
}());
LogsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], LogsService);
exports.LogsService = LogsService;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(5);
var JhiMetricsMonitoringModalComponent = (function () {
    function JhiMetricsMonitoringModalComponent(activeModal) {
        this.activeModal = activeModal;
        this.threadDumpAll = 0;
        this.threadDumpBlocked = 0;
        this.threadDumpRunnable = 0;
        this.threadDumpTimedWaiting = 0;
        this.threadDumpWaiting = 0;
    }
    JhiMetricsMonitoringModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.threadDump.forEach(function (value) {
            if (value.threadState === 'RUNNABLE') {
                _this.threadDumpRunnable += 1;
            }
            else if (value.threadState === 'WAITING') {
                _this.threadDumpWaiting += 1;
            }
            else if (value.threadState === 'TIMED_WAITING') {
                _this.threadDumpTimedWaiting += 1;
            }
            else if (value.threadState === 'BLOCKED') {
                _this.threadDumpBlocked += 1;
            }
        });
        this.threadDumpAll = this.threadDumpRunnable + this.threadDumpWaiting +
            this.threadDumpTimedWaiting + this.threadDumpBlocked;
    };
    JhiMetricsMonitoringModalComponent.prototype.getBadgeClass = function (threadState) {
        if (threadState === 'RUNNABLE') {
            return 'badge-success';
        }
        else if (threadState === 'WAITING') {
            return 'badge-info';
        }
        else if (threadState === 'TIMED_WAITING') {
            return 'badge-warning';
        }
        else if (threadState === 'BLOCKED') {
            return 'badge-danger';
        }
    };
    return JhiMetricsMonitoringModalComponent;
}());
JhiMetricsMonitoringModalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-metrics-modal',
        template: __webpack_require__(393)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])
], JhiMetricsMonitoringModalComponent);
exports.JhiMetricsMonitoringModalComponent = JhiMetricsMonitoringModalComponent;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var metrics_modal_component_1 = __webpack_require__(113);
var metrics_service_1 = __webpack_require__(115);
var JhiMetricsMonitoringComponent = (function () {
    function JhiMetricsMonitoringComponent(jhiLanguageService, modalService, metricsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.metricsService = metricsService;
        this.metrics = {};
        this.cachesStats = {};
        this.servicesStats = {};
        this.updatingMetrics = true;
        this.JCACHE_KEY = 'jcache.statistics';
        this.jhiLanguageService.setLocations(['metrics']);
    }
    JhiMetricsMonitoringComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    JhiMetricsMonitoringComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingMetrics = true;
        this.metricsService.getMetrics().subscribe(function (metrics) {
            _this.metrics = metrics;
            _this.updatingMetrics = false;
            _this.servicesStats = {};
            _this.cachesStats = {};
            Object.keys(metrics.timers).forEach(function (key) {
                var value = metrics.timers[key];
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    _this.servicesStats[key] = value;
                }
            });
            Object.keys(metrics.gauges).forEach(function (key) {
                if (key.indexOf('jcache.statistics') !== -1 && metrics.gauges[key] != null) {
                    var value = metrics.gauges[key].value;
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);
                    // Keep the name of the domain
                    _this.cachesStats[newKey] = {
                        'name': _this.JCACHE_KEY.length,
                        'value': value
                    };
                }
            });
        });
    };
    JhiMetricsMonitoringComponent.prototype.refreshThreadDumpData = function () {
        var _this = this;
        this.metricsService.threadDump().subscribe(function (data) {
            var modalRef = _this.modalService.open(metrics_modal_component_1.JhiMetricsMonitoringModalComponent, { size: 'lg' });
            modalRef.componentInstance.threadDump = data;
            modalRef.result.then(function (result) {
                // Left blank intentionally, nothing to do here
            }, function (reason) {
                // Left blank intentionally, nothing to do here
            });
        });
    };
    return JhiMetricsMonitoringComponent;
}());
JhiMetricsMonitoringComponent = __decorate([
    core_1.Component({
        selector: 'jhi-metrics',
        template: __webpack_require__(394),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        metrics_service_1.JhiMetricsService])
], JhiMetricsMonitoringComponent);
exports.JhiMetricsMonitoringComponent = JhiMetricsMonitoringComponent;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var JhiMetricsService = (function () {
    function JhiMetricsService(http) {
        this.http = http;
    }
    JhiMetricsService.prototype.getMetrics = function () {
        return this.http.get('management/metrics').map(function (res) { return res.json(); });
    };
    JhiMetricsService.prototype.threadDump = function () {
        return this.http.get('management/dump').map(function (res) { return res.json(); });
    };
    return JhiMetricsService;
}());
JhiMetricsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiMetricsService);
exports.JhiMetricsService = JhiMetricsService;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var user_echange_modal_service_1 = __webpack_require__(55);
var user_en_echange_1 = __webpack_require__(21);
var UserEchangeMgmtDeleteDialogComponent = (function () {
    function UserEchangeMgmtDeleteDialogComponent(jhiLanguageService, userService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['user-echange']);
    }
    UserEchangeMgmtDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserEchangeMgmtDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.userService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({ name: 'userListModification',
                content: 'Supprimer un étudiant en échange' });
            _this.activeModal.dismiss(true);
        });
    };
    return UserEchangeMgmtDeleteDialogComponent;
}());
UserEchangeMgmtDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-echange-delete-dialog',
        template: __webpack_require__(395)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        user_en_echange_1.UserEnEchangeService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], UserEchangeMgmtDeleteDialogComponent);
exports.UserEchangeMgmtDeleteDialogComponent = UserEchangeMgmtDeleteDialogComponent;
var UserEchangeDeleteDialogComponent = (function () {
    function UserEchangeDeleteDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserEchangeDeleteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.userModalService.open(UserEchangeMgmtDeleteDialogComponent, params['id']);
        });
    };
    UserEchangeDeleteDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserEchangeDeleteDialogComponent;
}());
UserEchangeDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-echange-delete-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_echange_modal_service_1.UserEchangeModalService])
], UserEchangeDeleteDialogComponent);
exports.UserEchangeDeleteDialogComponent = UserEchangeDeleteDialogComponent;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var UserEchangeMgmtDetailComponent = (function () {
    function UserEchangeMgmtDetailComponent(jhiLanguageService, userService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.route = route;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserEchangeMgmtDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['login']);
        });
    };
    UserEchangeMgmtDetailComponent.prototype.load = function (login) {
        var _this = this;
        this.userService.find(login).subscribe(function (user) {
            _this.user = user;
        });
    };
    UserEchangeMgmtDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return UserEchangeMgmtDetailComponent;
}());
UserEchangeMgmtDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-echange-detail',
        template: __webpack_require__(396)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        router_1.ActivatedRoute])
], UserEchangeMgmtDetailComponent);
exports.UserEchangeMgmtDetailComponent = UserEchangeMgmtDetailComponent;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var user_echange_modal_service_1 = __webpack_require__(55);
var shared_1 = __webpack_require__(2);
var user_en_echange_1 = __webpack_require__(21);
var grhum_1 = __webpack_require__(13);
var calendar_constants_1 = __webpack_require__(15);
var campagne_1 = __webpack_require__(59);
var UserEchangeMgmtDialogComponent = (function () {
    function UserEchangeMgmtDialogComponent(activeModal, languageHelper, jhiLanguageService, userService, eventManager, grhumService, alertService, campagneService) {
        this.activeModal = activeModal;
        this.languageHelper = languageHelper;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.grhumService = grhumService;
        this.alertService = alertService;
        this.campagneService = campagneService;
        this.typeEtudiantEnumeration = user_en_echange_1.TypeEtudiantEnumeration;
    }
    UserEchangeMgmtDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'];
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['user-echange']);
        this.grhumService.queryPays().subscribe(function (res) {
            _this.paysListe = res.json();
        }, function (res) { return _this.onError(res.json()); });
        if (this.user.typeEtudiant == user_en_echange_1.TypeEtudiantEnumeration.restrictionEmail) {
            this.campagneService.query({
                restrictionEmail: true
            }).subscribe(function (res) {
                _this.campagnes = res.json();
                if (_this.user.campagne != null) {
                    _this.user.campagne = _this.campagnes.find(function (campagne) { return campagne.id == _this.user.campagne.id; });
                }
            }, function (res) { return _this.onError(res.json()); });
        }
    };
    UserEchangeMgmtDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserEchangeMgmtDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.user.id != null) {
            this.userService.update(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
        else {
            // Remplissage des données avec contraintes "not null" dans la bdd
            if (this.user.typeEtudiant == user_en_echange_1.TypeEtudiantEnumeration.restrictionEmail) {
                if (this.user.codePaysUniversite == null) {
                    this.user.codePaysUniversite = '100';
                }
                if (this.user.nomUniversiteOrigine == null) {
                    this.user.nomUniversiteOrigine = 'N/A';
                }
                if (this.user.typeEchange == null) {
                    this.user.typeEchange = 'N/A';
                }
            }
            this.userService.create(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
    };
    UserEchangeMgmtDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.error, error.message, null);
    };
    UserEchangeMgmtDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'userListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    UserEchangeMgmtDialogComponent.prototype.onSaveError = function () {
        this.isSaving = false;
    };
    return UserEchangeMgmtDialogComponent;
}());
UserEchangeMgmtDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-echange-dialog',
        template: __webpack_require__(397)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        user_en_echange_1.UserEnEchangeService,
        ng_jhipster_1.EventManager,
        grhum_1.GrhumService,
        ng_jhipster_1.AlertService,
        campagne_1.CampagneService])
], UserEchangeMgmtDialogComponent);
exports.UserEchangeMgmtDialogComponent = UserEchangeMgmtDialogComponent;
var UserEchangeDialogComponent = (function () {
    function UserEchangeDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserEchangeDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.userModalService.open(UserEchangeMgmtDialogComponent, params['id'], null);
            }
            else {
                if (params['typeEtudiant']) {
                    _this.modalRef = _this.userModalService.open(UserEchangeMgmtDialogComponent, null, params['typeEtudiant']);
                }
            }
        });
    };
    UserEchangeDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserEchangeDialogComponent;
}());
UserEchangeDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_echange_modal_service_1.UserEchangeModalService])
], UserEchangeDialogComponent);
exports.UserEchangeDialogComponent = UserEchangeDialogComponent;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var user_en_echange_1 = __webpack_require__(21);
var grhum_1 = __webpack_require__(13);
var router_1 = __webpack_require__(3);
var util_1 = __webpack_require__(467);
var UserEchangeMgmtComponent = (function () {
    function UserEchangeMgmtComponent(jhiLanguageService, userEchangeService, alertService, principal, eventManager, grhumService, route) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.userEchangeService = userEchangeService;
        this.alertService = alertService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.grhumService = grhumService;
        this.route = route;
        this.typeEtudiant = 0;
        this.typeEtudiantEnumeration = user_en_echange_1.TypeEtudiantEnumeration;
        this.jhiLanguageService.setLocations(['user-echange']);
        this.parametersTypeEtudiantObservable = this.route.queryParams.subscribe(function (params) {
            try {
                // lorsque l'on ferme les pop up on perd le type d'étudiant--> donc on reutilise la valeur précédente du paramètre
                if (!(isNaN(params['typeEtudiant'])
                    || util_1.toInteger(params['typeEtudiant']).toString().length != params['typeEtudiant'].length)) {
                    _this.typeEtudiant = util_1.toInteger(params['typeEtudiant']);
                }
            }
            catch (e) {
            }
            _this.loadAll();
        });
    }
    UserEchangeMgmtComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.registerChangeInUsers();
        });
        this.grhumService.queryPays().subscribe(function (res) {
            _this.paysListe = res.json();
        }, function (res) { return _this.onError(res.json()); });
    };
    UserEchangeMgmtComponent.prototype.ngOnDestroy = function () {
        if (this.parametersTypeEtudiantObservable != null) {
            this.parametersTypeEtudiantObservable.unsubscribe();
        }
    };
    UserEchangeMgmtComponent.prototype.registerChangeInUsers = function () {
        var _this = this;
        this.eventManager.subscribe('userListModification', function (response) { return _this.loadAll(); });
    };
    UserEchangeMgmtComponent.prototype.setActive = function (user, isActivated) {
        var _this = this;
        user.activated = isActivated;
        this.userEchangeService.update(user).subscribe(function (response) {
            if (response != null) {
                _this.error = null;
                _this.success = 'OK';
                _this.loadAll();
            }
            else {
                _this.success = null;
                _this.error = 'ERROR';
            }
        });
    };
    UserEchangeMgmtComponent.prototype.loadAll = function () {
        var _this = this;
        this.userEchangeService.query(this.typeEtudiant).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    UserEchangeMgmtComponent.prototype.onSuccess = function (data, headers) {
        this.users = data;
    };
    UserEchangeMgmtComponent.prototype.onError = function (error) {
        shared_1.JhiAlertComponent.onError(this.alertService, error);
    };
    UserEchangeMgmtComponent.prototype.findPaysDansListe = function (codePays) {
        return grhum_1.GrhumService.findPaysDansListe(this.paysListe, codePays);
    };
    return UserEchangeMgmtComponent;
}());
UserEchangeMgmtComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-echange',
        template: __webpack_require__(398)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        user_en_echange_1.UserEnEchangeService,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.EventManager,
        grhum_1.GrhumService,
        router_1.ActivatedRoute])
], UserEchangeMgmtComponent);
exports.UserEchangeMgmtComponent = UserEchangeMgmtComponent;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var user_modal_service_1 = __webpack_require__(56);
var UserMgmtDeleteDialogComponent = (function () {
    function UserMgmtDeleteDialogComponent(jhiLanguageService, userService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDeleteDialogComponent.prototype.confirmDelete = function (login) {
        var _this = this;
        this.userService.delete(login).subscribe(function (response) {
            _this.eventManager.broadcast({ name: 'userListModification',
                content: 'Deleted a user' });
            _this.activeModal.dismiss(true);
        });
    };
    return UserMgmtDeleteDialogComponent;
}());
UserMgmtDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-delete-dialog',
        template: __webpack_require__(399)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], UserMgmtDeleteDialogComponent);
exports.UserMgmtDeleteDialogComponent = UserMgmtDeleteDialogComponent;
var UserDeleteDialogComponent = (function () {
    function UserDeleteDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDeleteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.userModalService.open(UserMgmtDeleteDialogComponent, params['login']);
        });
    };
    UserDeleteDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDeleteDialogComponent;
}());
UserDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-delete-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDeleteDialogComponent);
exports.UserDeleteDialogComponent = UserDeleteDialogComponent;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var UserMgmtDetailComponent = (function () {
    function UserMgmtDetailComponent(jhiLanguageService, userService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.route = route;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['login']);
        });
    };
    UserMgmtDetailComponent.prototype.load = function (login) {
        var _this = this;
        this.userService.find(login).subscribe(function (user) {
            _this.user = user;
        });
    };
    UserMgmtDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return UserMgmtDetailComponent;
}());
UserMgmtDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-detail',
        template: __webpack_require__(400)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        router_1.ActivatedRoute])
], UserMgmtDetailComponent);
exports.UserMgmtDetailComponent = UserMgmtDetailComponent;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var user_modal_service_1 = __webpack_require__(56);
var shared_1 = __webpack_require__(2);
var UserMgmtDialogComponent = (function () {
    function UserMgmtDialogComponent(activeModal, languageHelper, jhiLanguageService, userService, eventManager) {
        this.activeModal = activeModal;
        this.languageHelper = languageHelper;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.eventManager = eventManager;
    }
    UserMgmtDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'];
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['user-management']);
    };
    UserMgmtDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.user.id !== null) {
            this.userService.update(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
        else {
            this.userService.create(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
    };
    UserMgmtDialogComponent.prototype.changeAuthority = function (authority) {
        var idx = this.user.authorities.indexOf(authority);
        if (idx === -1) {
            if (authority === 'ROLE_USER') {
                this.user.authorities = [];
            }
            else {
                var idxUser = this.user.authorities.indexOf('ROLE_USER');
                if (idxUser > -1) {
                    this.user.authorities.splice(idxUser, 1);
                }
            }
            this.user.authorities.push(authority);
        }
        else {
            this.user.authorities.splice(idx, 1);
        }
    };
    UserMgmtDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'userListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    UserMgmtDialogComponent.prototype.onSaveError = function () {
        this.isSaving = false;
    };
    return UserMgmtDialogComponent;
}());
UserMgmtDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-dialog',
        template: __webpack_require__(401)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], UserMgmtDialogComponent);
exports.UserMgmtDialogComponent = UserMgmtDialogComponent;
var UserDialogComponent = (function () {
    function UserDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['login']) {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent, params['login']);
            }
            else {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent);
            }
        });
    };
    UserDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDialogComponent;
}());
UserDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDialogComponent);
exports.UserDialogComponent = UserDialogComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var UserMgmtComponent = (function () {
    function UserMgmtComponent(jhiLanguageService, userService, alertService, principal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.alertService = alertService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.isSaving = false;
        this.filtreUtilisateurEns = true;
        this.isGestionnaire = false;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.isGestionnaire = shared_1.Principal.isAnyAuthorityInListe(['ROLE_GEST', 'ROLE_SYSTEM', 'ROLE_ADMIN'], _this.currentAccount.authorities);
            _this.loadAll();
            _this.registerChangeInUsers();
        });
    };
    UserMgmtComponent.prototype.registerChangeInUsers = function () {
        var _this = this;
        this.eventManager.subscribe('userListModification', function (response) { return _this.loadAll(); });
    };
    UserMgmtComponent.prototype.setActive = function (user, isActivated) {
        user.activated = isActivated;
        this.updateUser(user);
    };
    UserMgmtComponent.prototype.setPluriannuel = function (user, isPluriannuel) {
        user.pluriannuel = isPluriannuel;
        this.updateUser(user);
    };
    UserMgmtComponent.prototype.updateUser = function (user) {
        var _this = this;
        this.userService.update(user).subscribe(function (res) {
            _this.error = null;
            _this.success = 'OK';
            _this.onRefreshUser(res.json(), res.headers);
        }, function (res) {
            _this.onError(res.json());
            _this.loadAll();
        });
    };
    UserMgmtComponent.prototype.loadAll = function () {
        var _this = this;
        this.isSaving = true;
        this.userService.query({ userENS: this.filtreUtilisateurEns }).subscribe(function (res) {
            _this.onSuccess(res.json(), res.headers);
            _this.isSaving = false;
        }, function (res) {
            _this.onError(res.json());
            _this.isSaving = false;
        });
    };
    UserMgmtComponent.prototype.onRefreshUser = function (data, headers) {
        var refreshedUser = data;
        if (refreshedUser != null) {
            var index = this.users.findIndex(function (user) { return user.id === refreshedUser.id; });
            if (index > 0) {
                this.users[index] = refreshedUser;
            }
        }
    };
    UserMgmtComponent.prototype.onSuccess = function (data, headers) {
        this.users = data;
    };
    UserMgmtComponent.prototype.onError = function (error) {
        this.alertService.error(error.error, error.message, null);
    };
    // filtre sur année en cours
    UserMgmtComponent.prototype.onChangeFiltreUtilisateurEns = function (value) {
        this.filtreUtilisateurEns = value;
        this.loadAll();
    };
    // noinspection JSMethodCanBeStatic
    UserMgmtComponent.prototype.userPeutCandidater = function (user) {
        return shared_1.User.userPeutCandidater(user);
    };
    // noinspection JSMethodCanBeStatic
    UserMgmtComponent.prototype.userResinscription = function (user) {
        return shared_1.User.userResinscription(user);
    };
    return UserMgmtComponent;
}());
UserMgmtComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt',
        template: __webpack_require__(402)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.EventManager])
], UserMgmtComponent);
exports.UserMgmtComponent = UserMgmtComponent;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var router_1 = __webpack_require__(3);
var admis_service_1 = __webpack_require__(58);
var piece_jointe_1 = __webpack_require__(34);
var shared_1 = __webpack_require__(2);
var calendar_constants_1 = __webpack_require__(15);
var forms_1 = __webpack_require__(36);
var candidature_1 = __webpack_require__(29);
var forkJoin_1 = __webpack_require__(199);
var intl_1 = __webpack_require__(468);
var AdmisComponent = (function () {
    function AdmisComponent(jhiLanguageService, activatedRoute, alertService, translate, admisService, formBuilder, pieceJointeService, candidatureService, candidatureFormationService, router) {
        this.jhiLanguageService = jhiLanguageService;
        this.activatedRoute = activatedRoute;
        this.alertService = alertService;
        this.translate = translate;
        this.admisService = admisService;
        this.formBuilder = formBuilder;
        this.pieceJointeService = pieceJointeService;
        this.candidatureService = candidatureService;
        this.candidatureFormationService = candidatureFormationService;
        this.router = router;
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.isLoading = false;
        this.conformites = [
            { label: 'Conforme', value: true },
            { label: '-', value: null },
            { label: 'Non conforme', value: false },
        ];
        this.jhiLanguageService.setLocations(['global', 'admis', 'candidature']);
        this.form = this.formBuilder.group({
            candidatureFormationId: new forms_1.FormControl({ disabled: true }, forms_1.Validators.required),
            commission: new forms_1.FormControl({ disabled: true }, forms_1.Validators.required),
            civilite: new forms_1.FormControl({}, forms_1.Validators.required),
            nom: new forms_1.FormControl({}, forms_1.Validators.required),
            nomUsuel: new forms_1.FormControl(),
            prenom: new forms_1.FormControl({}, forms_1.Validators.required),
            prenom2: new forms_1.FormControl(),
            dateNaissance: new forms_1.FormControl({}, forms_1.Validators.required),
            controleIdentiteAdmis: new forms_1.FormControl()
        });
    }
    AdmisComponent.prototype.ngOnInit = function () {
        this.initCandidatureEtFormulaire();
    };
    AdmisComponent.prototype.initCandidatureEtFormulaire = function () {
        var _this = this;
        this.isLoading = true;
        var candidatureFormation = this.admisService.getCurrentCandidature();
        if (candidatureFormation && candidatureFormation.id) {
            var candidatureQuery = this.candidatureService.find(candidatureFormation.candidatureId);
            var candidatureFormationQuery = this.candidatureFormationService.find(candidatureFormation.id, false);
            var pieceJointeQuery = this.pieceJointeService.findPieceIdentite(candidatureFormation.id);
            forkJoin_1.forkJoin(candidatureQuery, candidatureFormationQuery, pieceJointeQuery).subscribe(function (res) {
                _this.candidature = res[0];
                _this.candidatureFormation = res[1];
                _this.initFormWithCandidatureData();
                _this.piecesIdentite = res[2].json();
                if (_this.piecesIdentite) {
                    _this.piecesIdentite.forEach(function (piece) {
                        _this.pieceJointeService.openFile(piece.nom).subscribe(function (res) {
                            _this.pieceJointeService.initPDFOrImageFile(res, piece);
                            _this.isLoading = false;
                        }, function (error) {
                            _this.isLoading = false;
                            _this.onError(error);
                        });
                    });
                }
            });
        }
        else {
            this.isLoading = false;
        }
    };
    AdmisComponent.prototype.initFormWithCandidatureData = function () {
        this.form.get('candidatureFormationId').setValue(this.candidatureFormation.id);
        this.form.get('commission').setValue(this.candidatureFormation.commission);
        this.form.get('nom').setValue(this.candidature.nomPatronymique);
        this.form.get('civilite').setValue(this.candidature.civilite);
        this.form.get('nomUsuel').setValue(this.candidature.nomUsuel);
        this.form.get('prenom').setValue(this.candidature.prenom);
        this.form.get('prenom2').setValue(this.candidature.prenom2);
        this.form.get('dateNaissance').setValue(intl_1.DateFormatter.format(this.candidature.dateNaissance, 'fr', 'dd/MM/yyyy'));
        this.form.get('controleIdentiteAdmis').setValue(this.candidatureFormation.controleIdentiteAdmis);
    };
    AdmisComponent.prototype.initCandidatureDataWithForm = function () {
        this.candidature.nomPatronymique = this.form.get('nom').value;
        this.candidature.civilite = this.form.get('civilite').value;
        this.candidature.nomUsuel = this.form.get('nomUsuel').value;
        this.candidature.prenom = this.form.get('prenom').value;
        this.candidature.prenom2 = this.form.get('prenom2').value;
        if (typeof this.form.get('dateNaissance').value !== 'string') {
            this.candidature.dateNaissance = this.form.get('dateNaissance').value;
        }
        this.candidatureFormation.controleIdentiteAdmis = this.form.get('controleIdentiteAdmis').value;
    };
    AdmisComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    AdmisComponent.prototype.onSubmit = function () {
        var _this = this;
        this.isLoading = true;
        this.initCandidatureDataWithForm();
        var updates = [
            this.candidatureService.update(this.candidature),
            this.candidatureFormationService.update(this.candidatureFormation, false, false)
        ];
        forkJoin_1.forkJoin(updates).subscribe(function () { return _this.isLoading = false; }, function (error) {
            _this.isLoading = false;
            _this.onError(error);
        });
    };
    AdmisComponent.prototype.dossierPrecedent = function () {
        this.admisService.previous();
        this.initCandidatureEtFormulaire();
    };
    AdmisComponent.prototype.dossierSuivant = function () {
        this.admisService.next();
        this.initCandidatureEtFormulaire();
    };
    AdmisComponent.prototype.retour = function () {
        this.router.navigate(['/candidature']);
    };
    return AdmisComponent;
}());
AdmisComponent = __decorate([
    core_1.Component({
        selector: 'jhi-faq',
        template: __webpack_require__(403)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        router_1.ActivatedRoute,
        ng_jhipster_1.AlertService,
        ng2_translate_1.TranslateService,
        admis_service_1.AdmisService,
        forms_1.FormBuilder,
        piece_jointe_1.PieceJointeService,
        candidature_1.CandidatureService,
        candidature_1.CandidatureFormationService,
        router_1.Router])
], AdmisComponent);
exports.AdmisComponent = AdmisComponent;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var campagne_service_1 = __webpack_require__(27);
var commission_1 = __webpack_require__(33);
var calendar_constants_1 = __webpack_require__(15);
var rxjs_1 = __webpack_require__(14);
var formation_1 = __webpack_require__(9);
var user_en_echange_1 = __webpack_require__(21);
var CampagneDetailComponent = (function () {
    function CampagneDetailComponent(jhiLanguageService, campagneService, commissionService, formationService, userEnEchangeService, route, eventManager, alertService) {
        this.jhiLanguageService = jhiLanguageService;
        this.campagneService = campagneService;
        this.commissionService = commissionService;
        this.formationService = formationService;
        this.userEnEchangeService = userEnEchangeService;
        this.route = route;
        this.eventManager = eventManager;
        this.alertService = alertService;
        this.commissions = [];
        this.formations = [];
        this.pageEdition = 'informations';
        this.loading = true;
        this.restrictionEmailDisabled = true;
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
        this.fr = calendar_constants_1.CALENDAR_FR;
    }
    CampagneDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInCommissions();
    };
    CampagneDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.loading = true;
        this.campagneService.find(id).subscribe(function (campagne) {
            _this.campagne = campagne;
            var findCommissions = [];
            if (_this.campagne.commissions != null && _this.campagne.commissions.length > 0) {
                _this.campagne.commissions.forEach(function (commission) {
                    findCommissions.push(_this.commissionService.find(commission));
                });
                rxjs_1.Observable.forkJoin(findCommissions).subscribe(function (results) {
                    _this.commissions = results.map(function (result) { return result; });
                    _this.commissions.sort(function (a, b) {
                        return a.dateCommission < b.dateCommission ? -1 : 1;
                    });
                    _this.loadFormations();
                });
            }
            else {
                _this.loadFormations();
            }
        });
        this.userEnEchangeService.getRestrictionEmail(id).subscribe(function (res) {
            _this.usersAvecRestrictionEmail = res.json();
            if (_this.usersAvecRestrictionEmail.length == 0) {
                _this.restrictionEmailDisabled = false;
            }
        }, function (res) { return _this.onError(res.json()); });
    };
    CampagneDetailComponent.prototype.loadFormations = function () {
        var _this = this;
        var findFormations = [];
        this.formationService.findFormationCampagne(this.campagne.id).subscribe(function (results) {
            _this.formations = results;
            _this.formations.sort(function (a, b) {
                return a.libelle < b.libelle ? -1 : 1;
            });
            _this.loading = false;
        });
    };
    CampagneDetailComponent.prototype.registerChangeInCommissions = function () {
        var _this = this;
        this.eventCommissionSubscriber = this.eventManager.subscribe('campagneCommissionsModification', function (response) {
            var comm = response.content;
            if (_this.campagne.commissions == null) {
                _this.campagne.commissions = [];
                _this.commissions = [];
            }
            if (_this.campagne.commissions.indexOf(comm.id) < 0) {
                _this.campagne.commissions.push(comm.id);
            }
            if (_this.commissions.indexOf(comm) < 0) {
                _this.commissions.push(comm);
            }
        });
        this.eventFormationSubscriber = this.eventManager.subscribe('campagneFormationsModification', function (response) {
            var forms = response.content;
            if (_this.campagne.formations == null) {
                _this.campagne.formations = [];
            }
            (_a = _this.campagne.formations).push.apply(_a, forms[0].formations);
            _this.loadFormations();
            var _a;
        });
    };
    CampagneDetailComponent.prototype.save = function () {
        var _this = this;
        if (this.commissions != null && this.commissions.length > 0) {
            this.loading = true;
            this.campagne.commissions = this.commissions.map(function (c) { return c.id; });
            var updateCampagne = this.campagneService.update(this.campagne);
            var updateCommissions = this.commissionService.update(this.commissions);
            var updates = [updateCommissions, updateCampagne];
            rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
                _this.commissions = results[0];
                _this.campagne = results[1];
                _this.loading = false;
                _this.alertService.success('cadensApp.campagne.updated', null, null);
            });
        }
        else {
            this.onError({ message: 'cadensApp.campagne.commission.required' });
        }
    };
    CampagneDetailComponent.prototype.removeFormation = function (index, id) {
        // Remove the formation attached to a campagne
        this.formations.splice(index, 1);
        index = this.campagne.formations.indexOf(id);
        this.campagne.formations.splice(index, 1);
    };
    CampagneDetailComponent.prototype.goToStep = function (step) {
        this.pageEdition = step;
        var element = document.querySelector('#' + step);
        if (element) {
            element.scrollIntoView(element);
        }
    };
    CampagneDetailComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    CampagneDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventCommissionSubscriber);
        this.eventManager.destroy(this.eventFormationSubscriber);
    };
    return CampagneDetailComponent;
}());
CampagneDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne-detail',
        template: __webpack_require__(412)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        campagne_service_1.CampagneService,
        commission_1.CommissionService,
        formation_1.FormationService,
        user_en_echange_1.UserEnEchangeService,
        router_1.ActivatedRoute,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.AlertService])
], CampagneDetailComponent);
exports.CampagneDetailComponent = CampagneDetailComponent;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var campagne_popup_service_1 = __webpack_require__(39);
var campagne_service_1 = __webpack_require__(27);
var calendar_constants_1 = __webpack_require__(15);
var CampagneDialogComponent = (function () {
    function CampagneDialogComponent(activeModal, jhiLanguageService, alertService, router, campagneService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.router = router;
        this.campagneService = campagneService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['campagne']);
    }
    CampagneDialogComponent.prototype.ngOnInit = function () {
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.campagne.heureFermeture = new Date();
        this.campagne.heureFermeture.setHours(23);
        this.campagne.heureFermeture.setMinutes(59);
        this.campagne.heureFermeture.setSeconds(59);
        this.campagne.heureOuverture = new Date();
        this.campagne.heureOuverture.setHours(0);
        this.campagne.heureOuverture.setMinutes(0);
        this.campagne.heureFermeture.setSeconds(0);
    };
    CampagneDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    CampagneDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        this.campagneService.create(this.campagne)
            .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
    };
    CampagneDialogComponent.prototype.onSaveSuccess = function (result) {
        var _this = this;
        this.eventManager.broadcast({ name: 'campagneListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
        setTimeout(function () { return _this.router.navigate(['/campagne/' + result.id]); }, 500);
    };
    CampagneDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    CampagneDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return CampagneDialogComponent;
}());
CampagneDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne-dialog',
        template: __webpack_require__(413)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        router_1.Router,
        campagne_service_1.CampagneService,
        ng_jhipster_1.EventManager])
], CampagneDialogComponent);
exports.CampagneDialogComponent = CampagneDialogComponent;
var CampagnePopupComponent = (function () {
    function CampagnePopupComponent(route, router, campagnePopupService) {
        this.route = route;
        this.router = router;
        this.campagnePopupService = campagnePopupService;
    }
    CampagnePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.router.navigate(['/campagne/' + params['id']]);
            }
            else {
                _this.modalRef = _this.campagnePopupService
                    .open(CampagneDialogComponent);
            }
        });
    };
    CampagnePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return CampagnePopupComponent;
}());
CampagnePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        campagne_popup_service_1.CampagnePopupService])
], CampagnePopupComponent);
exports.CampagnePopupComponent = CampagnePopupComponent;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Rx_1 = __webpack_require__(14);
var ng2_translate_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var campagne_model_1 = __webpack_require__(40);
var campagne_service_1 = __webpack_require__(27);
var shared_1 = __webpack_require__(2);
var api_1 = __webpack_require__(16);
var formation_1 = __webpack_require__(9);
var campagne_popup_service_1 = __webpack_require__(39);
var campagne_formations_dialog_component_1 = __webpack_require__(38);
var jsUtil_1 = __webpack_require__(44);
var CampagneComponent = (function () {
    function CampagneComponent(jhiLanguageService, campagneService, formationService, confirmationService, alertService, eventManager, principal, router, exportService, campagnePopupService, translateService) {
        this.jhiLanguageService = jhiLanguageService;
        this.campagneService = campagneService;
        this.formationService = formationService;
        this.confirmationService = confirmationService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.principal = principal;
        this.router = router;
        this.exportService = exportService;
        this.campagnePopupService = campagnePopupService;
        this.translateService = translateService;
        this.now = new Date();
        // Show / Hide selected columns
        this.cols = [
            { label: 'Id', value: 'id' },
            { label: 'Libellés', value: 'libelle' },
            { label: 'Commissions', value: 'commissions' },
            { label: 'Formations', value: 'formations' },
            { label: 'Ouverture', value: 'dateOuverture' },
            { label: 'Fermeture', value: 'dateFermeture' }
        ];
        this.selectedColumns = ['libelle', 'dateOuverture', 'dateFermeture'];
        // Actions groupées
        this.actions = [
            { label: 'Rattacher des formations', value: 'rattacher' },
            { label: 'Supprimer', value: 'supprimer' }
        ];
        this.selectedAction = [];
        this.jhiLanguageService.setLocations(['campagne', 'global']);
    }
    CampagneComponent.prototype.loadAll = function () {
        var _this = this;
        this.isLoading = true;
        this.campagneService.query().subscribe(function (res) {
            _this.campagnes = res.json();
            _this.isLoading = false;
        }, function (res) {
            _this.onError(res.json());
            _this.isLoading = false;
        });
    };
    CampagneComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInCampagnes();
    };
    CampagneComponent.prototype.ngAfterViewInit = function () {
        var translateKey = 'cadensApp.campagne.colonnes';
        var multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(function (translation) {
            jsUtil_1.JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    };
    CampagneComponent.prototype.goToCampagne = function (campagne) {
        this.router.navigate(['/campagne/' + campagne.id]);
    };
    CampagneComponent.prototype.onSelectedAction = function (event) {
        if (this.selectedCampagnes != null && this.selectedCampagnes.length > 0) {
            // Rattacher des formations aux campagnes sélectionnées
            if (this.selectedAction.indexOf('rattacher') > -1) {
                this.modalRef = this.campagnePopupService.open(campagne_formations_dialog_component_1.CampagneFormationsDialogComponent, this.selectedCampagnes.map(function (c) { return new campagne_model_1.Campagne(c.id); }));
            }
            else if (this.selectedAction.indexOf('supprimer') > -1) {
                // Supprimer des campagnes sélectionnées
                this.delete();
            }
        }
        else {
            this.selectedAction = [];
        }
    };
    CampagneComponent.prototype.cancel = function () {
        this.selectedAction = [];
        this.selectedCampagnes = [];
    };
    CampagneComponent.prototype.delete = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.campagne.delete.question', { param: this.selectedCampagnes.length }),
            header: this.translateService.instant('cadensApp.campagne.delete.title'),
            accept: function () {
                var updates = [];
                _this.selectedCampagnes.forEach(function (campagne) {
                    updates.push(_this.campagneService.delete(campagne.id));
                });
                Rx_1.Observable.forkJoin(updates).subscribe(function (results) {
                    _this.selectedAction = [];
                    _this.selectedCampagnes = [];
                    _this.loadAll();
                }, function (error) {
                    _this.onError(error);
                    _this.selectedAction = [];
                });
            },
            reject: function () {
                _this.selectedAction = [];
            }
        });
    };
    CampagneComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    CampagneComponent.prototype.registerChangeInCampagnes = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('campagneListModification', function (response) { return _this.loadAll(); });
    };
    CampagneComponent.prototype.exportFormationsCSV = function () {
        var _this = this;
        this.formationService.query({ userId: this.currentAccount.id }).subscribe(function (res) {
            var formations = res.json();
            var formationPourChaqueCampagne = [];
            formations.forEach(function (formation) {
                formation.campagnes.forEach(function (campagne) {
                    formationPourChaqueCampagne.push({ nomCampagne: campagne.libelle, nomFormation: formation.libelle });
                });
            });
            var colFieldNameDictionary = new shared_1.KeyedCollection();
            colFieldNameDictionary.Add('Formation', 'nomFormation');
            colFieldNameDictionary.Add('Campagne', 'nomCampagne');
            _this.exportService.toCSVAvecNomOrigineField(formationPourChaqueCampagne, ['Formation', 'Campagne'], colFieldNameDictionary, null, 'CampagnesFormations.csv');
        }, function (res) { return _this.onError(res.json()); });
    };
    CampagneComponent.prototype.exportCSV = function () {
        var colHeaderDictionary = new shared_1.KeyedCollection();
        this.cols.forEach(function (col) {
            colHeaderDictionary.Add(col.value, col.label);
        });
        this.exportService.toCSVAvecNomOrigineField(this.campagnes, this.selectedColumns, null, colHeaderDictionary, 'Candidatures.csv');
    };
    CampagneComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return CampagneComponent;
}());
CampagneComponent = __decorate([
    core_1.Component({
        selector: 'jhi-campagne',
        template: __webpack_require__(415)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        campagne_service_1.CampagneService,
        formation_1.FormationService,
        api_1.ConfirmationService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        shared_1.Principal,
        router_1.Router,
        shared_1.ExportService,
        campagne_popup_service_1.CampagnePopupService,
        ng2_translate_1.TranslateService])
], CampagneComponent);
exports.CampagneComponent = CampagneComponent;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var grhum_1 = __webpack_require__(13);
var AdresseComponent = (function () {
    function AdresseComponent(grhumService) {
        this.grhumService = grhumService;
        this.paysChange = new core_1.EventEmitter();
        this.deptChange = new core_1.EventEmitter();
        this.villeChange = new core_1.EventEmitter();
        this.rneChange = new core_1.EventEmitter();
        this.rneAutreChange = new core_1.EventEmitter();
    }
    Object.defineProperty(AdresseComponent.prototype, "typeEtab", {
        get: function () {
            return this.typeEtablissement;
        },
        set: function (typeEtab) {
            this.typeEtablissement = typeEtab;
            this.refreshList();
        },
        enumerable: true,
        configurable: true
    });
    AdresseComponent.prototype.ngOnInit = function () {
        this.refreshList();
    };
    AdresseComponent.prototype.refreshList = function () {
        if (this.pays) {
            // liste des etablissements francais
            if (this.pays === '100' && this.dept && this.showRne && this.typeEtab !== 'EFE') {
                this.getRnes({ codePostal: this.dept });
            }
            // liste des villes
            if (this.pays === '100' && this.dept) {
                this.getVilles(this.dept);
            }
        }
        // liste des etablissements à l'étranger
        if (this.showRne && this.typeEtab === 'EFE') {
            this.getRnes({ typeEtabCode: this.typeEtab });
        }
    };
    AdresseComponent.prototype.ngOnChanges = function () {
        // this.refreshList();
    };
    AdresseComponent.prototype.onChangePays = function (newPays) {
        this.ville = null;
        this.villesListe = null;
        this.dept = null;
        this.rne = null;
        this.rneListe = null;
        this.refreshList();
        this.villeChange.emit(this.ville);
        this.rneChange.emit(this.rne);
        this.deptChange.emit(this.dept);
        this.paysChange.emit(newPays);
    };
    AdresseComponent.prototype.onChangeDept = function (newDept) {
        this.ville = null;
        this.rne = null;
        this.refreshList();
        this.villeChange.emit(this.ville);
        this.rneChange.emit(this.rne);
        this.deptChange.emit(newDept);
        this.paysChange.emit(this.pays);
    };
    AdresseComponent.prototype.onChangeVille = function (newVille) {
        this.villeChange.emit(newVille);
    };
    AdresseComponent.prototype.onChangeRne = function (newRne) {
        var idx = this.rneListe.findIndex(function (rne) { return rne.value === newRne; });
        if (idx >= 0) {
            this.ville = this.rneListe[idx].codeInsee;
        }
        else {
            this.ville = null;
        }
        this.villeChange.emit(this.ville);
        this.rneChange.emit(newRne);
    };
    AdresseComponent.prototype.onChangeRneAutre = function (newRne) {
        this.rneAutreChange.emit(newRne);
    };
    AdresseComponent.prototype.getVilles = function (dept) {
        var _this = this;
        this.grhumService.queryCommune({ departement: dept }).subscribe(function (res) {
            _this.villesListe = res.json();
        });
    };
    AdresseComponent.prototype.getRnes = function (param) {
        var _this = this;
        this.grhumService.queryRne(param).subscribe(function (res) {
            _this.rneListe = res.json();
        });
    };
    return AdresseComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "translationKey", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "pays", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AdresseComponent.prototype, "paysChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "dept", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AdresseComponent.prototype, "deptChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "ville", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AdresseComponent.prototype, "villeChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "rne", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AdresseComponent.prototype, "rneAutre", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], AdresseComponent.prototype, "showRne", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AdresseComponent.prototype, "rneChange", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AdresseComponent.prototype, "rneAutreChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], AdresseComponent.prototype, "paysListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], AdresseComponent.prototype, "deptListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], AdresseComponent.prototype, "cols", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], AdresseComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdresseComponent.prototype, "typeEtab", null);
AdresseComponent = __decorate([
    core_1.Component({
        selector: 'jhi-adresse-component',
        template: __webpack_require__(416)
    }),
    __metadata("design:paramtypes", [grhum_1.GrhumService])
], AdresseComponent);
exports.AdresseComponent = AdresseComponent;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var cadens_constants_1 = __webpack_require__(8);
var formation_1 = __webpack_require__(9);
var listeChoix_service_1 = __webpack_require__(23);
var AvisComponent = (function () {
    function AvisComponent(listeChoixService, formationService) {
        this.listeChoixService = listeChoixService;
        this.formationService = formationService;
        this.candidatureFormation = {};
        this.candidatureFormationChange = new core_1.EventEmitter();
        this.constants = cadens_constants_1.CONSTANTS;
    }
    AvisComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.AVIS }).subscribe(function (res) {
            _this.listeAvis = res.json().map(function (avis) { return avis.code; });
            if (_this.candidatureFormation.formationId != null) {
                _this.formationService.findPourEtudiant(_this.candidatureFormation.formationId, _this.candidatureFormation.userId).subscribe(function (formation) {
                    if (!formation.lc) {
                        _this.listeAvis.pop();
                    }
                });
            }
        });
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.COMMENTAIRE }).subscribe(function (res) {
            _this.listeCommentaires = res.json();
        });
    };
    AvisComponent.prototype.chooseAvis = function (avis) {
        this.candidatureFormation.avis = this.candidatureFormation.avis === avis ? null : avis;
        this.candidatureFormation.avisRang = avis !== cadens_constants_1.CONSTANTS.AWAITING ? null : this.candidatureFormation.avisRang;
        this.candidatureFormation.commentaire = avis !== cadens_constants_1.CONSTANTS.NOTFAVORABLE ? null : this.candidatureFormation.commentaire;
        this.candidatureFormationChange.emit(this.candidatureFormation);
    };
    return AvisComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], AvisComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], AvisComponent.prototype, "avisEnabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], AvisComponent.prototype, "dateLimiteAvis", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AvisComponent.prototype, "candidatureFormationChange", void 0);
AvisComponent = __decorate([
    core_1.Component({
        selector: 'jhi-avis-component',
        template: __webpack_require__(417)
    }),
    __metadata("design:paramtypes", [listeChoix_service_1.ListeChoixService,
        formation_1.FormationService])
], AvisComponent);
exports.AvisComponent = AvisComponent;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
///<reference path="../../../../../../node_modules/@angular/router/src/router.d.ts"/>
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var candidature_model_1 = __webpack_require__(42);
var candidature_service_1 = __webpack_require__(134);
var commission_1 = __webpack_require__(33);
var shared_1 = __webpack_require__(2);
var grhum_1 = __webpack_require__(13);
var cadens_constants_1 = __webpack_require__(8);
var cursus_service_1 = __webpack_require__(64);
var cours_service_1 = __webpack_require__(138);
var candidature_formation_service_1 = __webpack_require__(18);
var adresse_model_1 = __webpack_require__(60);
var adresse_service_1 = __webpack_require__(41);
var concours_service_1 = __webpack_require__(63);
var rxjs_1 = __webpack_require__(14);
var reponse_service_1 = __webpack_require__(28);
var formation_1 = __webpack_require__(9);
var ng2_page_scroll_1 = __webpack_require__(31);
var platform_browser_1 = __webpack_require__(17);
var referent_1 = __webpack_require__(77);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var preavis_service_1 = __webpack_require__(65);
var preavis_model_1 = __webpack_require__(259);
var CandidatureDetailComponent = (function () {
    function CandidatureDetailComponent(jhiLanguageService, candidatureService, adresseService, reponseService, activatedRoute, candidatureFormationService, exportService, cursusService, coursService, concoursService, referentService, route, router, principal, alertService, grhumService, eventManager, pageScrollService, confirmationService, translateService, userService, CommissionService, preavisService, formationService, document) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.candidatureService = candidatureService;
        this.adresseService = adresseService;
        this.reponseService = reponseService;
        this.activatedRoute = activatedRoute;
        this.candidatureFormationService = candidatureFormationService;
        this.exportService = exportService;
        this.cursusService = cursusService;
        this.coursService = coursService;
        this.concoursService = concoursService;
        this.referentService = referentService;
        this.route = route;
        this.router = router;
        this.principal = principal;
        this.alertService = alertService;
        this.grhumService = grhumService;
        this.eventManager = eventManager;
        this.pageScrollService = pageScrollService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.userService = userService;
        this.CommissionService = CommissionService;
        this.preavisService = preavisService;
        this.formationService = formationService;
        this.document = document;
        this.listeCoursChange = new core_1.EventEmitter();
        this.listeCours = []; // Liste des cours de la candidature
        this.questions = []; // Liste des questions complémentaires
        this.referents = []; // Liste des referents pour form de recommandations
        this.navIsFixed = true;
        this.missingPieces = true;
        this.constants = cadens_constants_1.CONSTANTS;
        this.isSaving = false;
        this.isUser = false;
        this.isEditable = false;
        this.avisEnabled = 0;
        this.traitementEnabled = 0;
        this.candidatureUser = null;
        this.commissionOuvertePourCandidature = null;
        this.isCurrentAccountNotUser = false;
        this.commissionCouranteCandidature = null;
        this.commissionFermePourCandidature = null;
        this.desCategoriesFormationDisponibles = false;
        this.eventsSubject = new rxjs_1.Subject();
        this.commentaireObligatoireAlerteId = 3615436;
        this.alertCommentaireObligatoireTimeout = 120000;
        // Fichiers json de langue à charger pour cette page
        this.jhiLanguageService.setLocations(['candidature', 'global', 'cursus', 'formation', 'referent']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            var listeActionGroupee = data['pagingParams'].listeCandidatures;
            if (listeActionGroupee != null) {
                _this.listeCandidatures = listeActionGroupee.split(',');
            }
        });
    }
    /**
     * Charger la liste des pays, départements au chargement de la page
     */
    CandidatureDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = true;
        this.grhumService.queryPays().subscribe(function (res) {
            _this.paysListe = res.json();
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
        });
        this.grhumService.queryDepartement().subscribe(function (res) {
            _this.deptListe = res.json();
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
        });
        this.subscription = this.route.params.subscribe(function (params) {
            var userId = params['userId'];
            _this.principal.identity().then(function (account) {
                _this.currentAccount = account;
                if (!shared_1.Principal.isAuthorityInListe('ROLE_USER', _this.currentAccount.authorities)) {
                    _this.isCurrentAccountNotUser = true;
                }
                if (userId != null) {
                    _this.userService.findById(userId).subscribe(function (user) {
                        _this.candidatureUser = user;
                        _this.load(params['id']);
                    });
                }
                else {
                    _this.candidatureUser = account;
                    _this.load(params['id']);
                }
            });
            _this.registerChangeInCandidatures();
        });
    };
    CandidatureDetailComponent.prototype.registerChangeInCandidatures = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('candidatureListModification', function () {
            return _this.load(_this.candidatureFormation.id);
        });
    };
    CandidatureDetailComponent.prototype.load = function (idCandidatureFormation) {
        var _this = this;
        this.isSaving = true;
        if (idCandidatureFormation < 1) {
            // Chargement d'une candidature pour création, init les valeurs par défaut
            this.isEditable = true;
            this.isUser = true;
            this.initNewCandidature(this.candidatureUser);
            this.adresse = new adresse_model_1.Adresse();
            this.adresseLoaded = true;
        }
        else {
            if (shared_1.Principal.isAuthorityInListe('ROLE_USER', this.candidatureUser.authorities)) {
                this.isUser = true;
            }
            // Chargement d'une candidature existante en base
            var recalculateEi = true;
            if (this.isEditable == false) {
                recalculateEi = false;
            }
            this.candidatureFormationService.
                find(idCandidatureFormation, recalculateEi).subscribe(function (candidatureFormation) {
                _this.candidatureFormation = candidatureFormation;
                _this.currentPage = _this.candidatureFormation.pageEdition;
                if (candidatureFormation != null && candidatureFormation.candidatureId != null) {
                    var loads = [];
                    loads.push(_this.candidatureService.find(candidatureFormation.candidatureId));
                    loads.push(_this.adresseService.find(_this.candidatureFormation.candidatureId));
                    loads.push(_this.coursService.query({ 'candidatureFormationId': _this.candidatureFormation.id }));
                    if (!_this.isUser) {
                        loads.push(_this.preavisService.query({ 'candidatureFormationId': _this.candidatureFormation.id }));
                    }
                    if (_this.candidatureFormation.commissionId != null) {
                        loads.push(_this.CommissionService.find(_this.candidatureFormation.commissionId));
                    }
                    if (_this.candidatureFormation.formationId != null) {
                        loads.push(_this.formationService.findPourEtudiant(_this.candidatureFormation.formationId, _this.candidatureFormation.userId));
                    }
                    rxjs_1.Observable.forkJoin(loads).subscribe(function (results) {
                        var index = 0;
                        if (results.length > 0) {
                            _this.candidature = results[index];
                            index++;
                            //adresse
                            _this.adresse = results[index];
                            index++;
                            _this.adresseLoaded = true;
                            //cours
                            _this.listeCours = results[index].json();
                            _this.listeCoursChange.emit(_this.listeCours);
                            index++;
                            //preavis
                            _this.candidatureFormation.listePreavis = [];
                            var listePreavis = null;
                            if (!_this.isUser) {
                                listePreavis = results[index].json();
                                index++;
                            }
                            //commission
                            if (_this.candidatureFormation.commissionId != null) {
                                var commission = results[index];
                                index++;
                                if (commission != null) {
                                    _this.dateLimiteAvis = commission.dateLimiteAvis;
                                    _this.commissionCouranteCandidature = commission;
                                }
                            }
                            //formation
                            if (_this.candidatureFormation.formationId != null) {
                                _this.candidatureFormation.formation = results[index];
                            }
                            _this.gestionDroits(_this.candidatureUser.id, _this.dateLimiteAvis, _this.candidatureUser.authorities);
                            if (_this.candidatureFormation.formation != null &&
                                _this.candidatureFormation.formation.lecteurs != null &&
                                _this.candidatureFormation.formation.avecPreavis) {
                                if (!_this.isUser) {
                                    //calcul liste preavis
                                    _this.candidatureFormation.listePreavis = preavis_model_1.Preavis.buildListePreavis(_this.currentAccount.id, _this.preavisVisuAllEnabled, _this.preavisModifEnabled, _this.candidatureFormation.id, listePreavis, _this.candidatureFormation.formation.lecteurs, _this.candidatureFormation.formation.users);
                                }
                            }
                            _this.isSaving = false;
                        }
                    }, function (res) {
                        _this.isSaving = false;
                        _this.onError(res);
                    });
                }
            }, function (res) {
                _this.isSaving = false;
                _this.onError(res);
            });
            if (this.isCurrentAccountNotUser) {
                this.candidatureFormationService.findCommissionPourCandidature(true, idCandidatureFormation).subscribe(function (commission) {
                    if (commission != null && commission.length > 0) {
                        _this.commissionOuvertePourCandidature = commission[0];
                    }
                }, function (res) {
                    _this.isSaving = false;
                    _this.onError(res);
                });
                this.candidatureFormationService.findCommissionPourCandidature(false, idCandidatureFormation).subscribe(function (commission) {
                    if (commission != null && commission.length > 0) {
                        _this.commissionFermePourCandidature = commission[0];
                    }
                }, function (res) {
                    _this.isSaving = false;
                    _this.onError(res);
                });
            }
        }
    };
    CandidatureDetailComponent.prototype.initNewCandidature = function (account) {
        var _this = this;
        this.candidature = {
            'id': null,
            'civilite': account.civilite,
            'prenom': account.firstName,
            'nomPatronymique': account.lastName,
            'prenom2': account.otherNames,
            'nomUsuel': account.lastNameUsage,
            'dateNaissance': account.birthDate != null ? new Date(account.birthDate) : null,
            'userId': account.id
        };
        this.candidatureFormation = {
            'id': null,
            'pageEdition': cadens_constants_1.CONSTANTS.CIVILITE,
            'statut': cadens_constants_1.CONSTANTS.CREATED,
            'userId': account.id,
            'reinscription': false,
            'fc': false,
            'email': account.email
        };
        if (account.etudiant != null && account.etudiant.numeroEtudiant != null) {
            this.candidatureFormation.reinscription = true;
        }
        this.candidatureService.query({ userId: account.id }).subscribe(function (res) {
            var candis = res.json();
            if (candis != null && candis.length > 0) {
                _this.candidature = candidature_service_1.CandidatureService.copyCandidature(_this.candidature, candis[0]);
            }
            _this.currentPage = _this.candidatureFormation.pageEdition;
            _this.isSaving = false;
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
        });
    };
    /**SAVE du 03/02/2026**/
    CandidatureDetailComponent.prototype.save = function (fullValidation, forceTransmit, callbackSaveOk) {
        var _this = this;
        this.isSaving = true;
        if (this.isEditable && !(this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.FORMATION && this.desCategoriesFormationDisponibles == false)) {
            // Enregistrement fait par le candidat
            if (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.CIVILITE) {
                // Save the CIVILITE page: Créer la candidature ou la mettre à jour
                if (this.candidature.civilite == null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.validate.civilite' });
                }
                else if (!this.candidature.id) {
                    this.createCandidature(fullValidation, callbackSaveOk);
                }
                else {
                    if (this.listeCours != null && this.listeCours.length > 0) {
                        this.listeCours.forEach(function (cours) { return cours.candidatureFormationId = _this.candidatureFormation.id; });
                        this.coursService.update(this.listeCours).subscribe(function (listCours) {
                            _this.listeCours = listCours;
                        });
                    }
                    this.updateCandidature(fullValidation, forceTransmit, false, callbackSaveOk);
                }
            }
            else if (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.SCOLARITE) {
                // Save the SCOLARITE page: update les Cursus, Concours, et la Candidature
                var validCursuses = cursus_service_1.CursusService.areCursusesValid(this.courses, this.candidatureFormation.reinscription);
                var validConcours = this.concoursService.areConcoursValid(this.concours);
                if (fullValidation && (this.courses == null || this.courses.length < 1)) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.cursusobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bourse === null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.bourseobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bourse && this.candidature.echelon === null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.echelonBourseObligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bac == null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.bacobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacAnnee == null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.bacanneeobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && candidature_model_1.Candidature.areSpecialitesBacObligatoires(this.candidature)
                    && (this.candidature.bacSpec1LibelleCourt == null || this.candidature.bacSpec2LibelleCourt == null)) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.bacspecialitesobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && candidature_model_1.Candidature.areSpecialitesBacObligatoires(this.candidature)
                    && (this.candidature.bacSpec1LibelleCourt === this.candidature.bacSpec2LibelleCourt)) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.bacspecialitesdifferentes' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacEtab == null
                    && this.candidature.bacEtablissementAutre == null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.etablissementobligatoire' });
                }
                else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacPays === '100'
                    && this.candidature.bacEtab == null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.etablissementobligatoire' });
                }
                else if (fullValidation && (this.concours.find(function (con) { return con.passage == null; }) != null)) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.concoursobligatoire' });
                }
                else if (fullValidation && validCursuses != null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.cursus.' + validCursuses });
                }
                else if (fullValidation && validConcours != null) {
                    this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.concours.' + validConcours });
                }
                else {
                    if (!this.candidature.bacAnnee || this.candidature.bacAnnee < 2021) {
                        this.candidature.bacSpec1LibelleCourt = null;
                        this.candidature.bacSpec2LibelleCourt = null;
                    }
                    var updates = [this.concoursService.update(this.concours),
                        this.candidatureService.update(this.candidature)];
                    if (this.courses != null && this.courses.length > 0) {
                        updates.push(this.cursusService.update(this.courses));
                    }
                    rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
                        if (results.length > 0) {
                            _this.concours = results[0];
                        }
                        if (results.length > 2) {
                            _this.courses = results[2]._body;
                        }
                        //Modification Eric : pour gérer le flag EI il faut sauver la candidature meme en sauvegarde temporaire
                        if (fullValidation) {
                            _this.updateCandidatureFormation(cadens_constants_1.CONSTANTS.FORMATION, cadens_constants_1.CONSTANTS.SCOLARITE, forceTransmit, fullValidation);
                        }
                        else {
                            _this.updateCandidatureFormation(cadens_constants_1.CONSTANTS.SCOLARITE, cadens_constants_1.CONSTANTS.SCOLARITE, forceTransmit, fullValidation);
                        }
                        _this.isSaving = false;
                    }, function (res) {
                        _this.isSaving = false;
                        _this.onError(res);
                    });
                }
            }
            else if (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.FORMATION) {
                // Save the FORMATION page: update les Réponses et la CandidatureFormation
                var message = this.valideFormation(fullValidation);
                if (message != null && message.messageText != null) {
                    this.onErrorMessage(message.messageText, message.messageParam);
                }
                else {
                    var page_1 = cadens_constants_1.CONSTANTS.FORMATION;
                    if (fullValidation) {
                        page_1 = this.candidatureFormation.reinscription ? cadens_constants_1.CONSTANTS.CONFIRMATION : cadens_constants_1.CONSTANTS.PIECES;
                    } /*else if (fullValidation && this.candidatureFormation.ei === 2 && this.candidatureFormation.indicBourseExcellence === null) {
                        this.onErrorMessage({message: 'cadensApp.formation.master.indicBourseObligatoire'});
                    }*/
                    var updateReponses = this.reponseService.update(this.questions);
                    if (updateReponses != null) {
                        rxjs_1.Observable.forkJoin([updateReponses]).subscribe(function (results) {
                            _this.questions = results[0];
                            _this.updateCandidatureFormation(page_1, cadens_constants_1.CONSTANTS.FORMATION, forceTransmit, fullValidation);
                        }, function (res) {
                            _this.isSaving = false;
                            _this.onError(res);
                        });
                    }
                    else {
                        this.updateCandidatureFormation(page_1, cadens_constants_1.CONSTANTS.FORMATION, forceTransmit, fullValidation);
                    }
                }
            }
            else if (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.PIECES) {
                // Save the PIECES page: juste besoin de confirmer si tout est ok
                var page_2 = cadens_constants_1.CONSTANTS.PIECES;
                if (fullValidation && this.missingPieces) {
                    return this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.piecesobligatoire' });
                }
                var countOfReferentNotExchange = this.referents.filter(function (referent) { return referent.typeReferent != cadens_constants_1.CONSTANTS.CONTACT_PEDAGO && referent.typeReferent != cadens_constants_1.CONSTANTS.CONTACT_ADMIN; }).length;
                if (fullValidation && this.referents.length > 0 && countOfReferentNotExchange > 0) {
                    this.referents.forEach(function (ref) { return ref.key == null ? ref.key = 'true' : true; });
                }
                var updateRefs_1 = [];
                this.referents.forEach(function (ref) { return updateRefs_1.push(_this.referentService.update(ref, null)); });
                if (updateRefs_1.length > 0) {
                    rxjs_1.Observable.forkJoin(updateRefs_1).subscribe(function () {
                        if (fullValidation) {
                            page_2 = cadens_constants_1.CONSTANTS.CONFIRMATION;
                        }
                        _this.updateCandidatureFormation(page_2, cadens_constants_1.CONSTANTS.PIECES, forceTransmit, fullValidation);
                    }, function (res) {
                        _this.eventsSubject.next();
                        _this.isSaving = false;
                        _this.onError(res);
                    });
                }
                else {
                    if (fullValidation) {
                        page_2 = cadens_constants_1.CONSTANTS.CONFIRMATION;
                    }
                    this.updateCandidatureFormation(page_2, cadens_constants_1.CONSTANTS.PIECES, forceTransmit, fullValidation);
                }
            }
        }
        else {
            // Quand le candidat est en lecture seule
            if (this.currentPage === cadens_constants_1.CONSTANTS.CIVILITE) {
                this.goToStep(cadens_constants_1.CONSTANTS.SCOLARITE);
            }
            else if (this.currentPage === cadens_constants_1.CONSTANTS.SCOLARITE) {
                this.goToStep(cadens_constants_1.CONSTANTS.FORMATION);
            }
            else if (this.currentPage === cadens_constants_1.CONSTANTS.FORMATION) {
                this.goToStep(cadens_constants_1.CONSTANTS.PIECES);
            }
            this.isSaving = false;
        }
    };
    CandidatureDetailComponent.prototype.goToHome = function () {
        this.isSaving = false;
        if (this.isCurrentAccountNotUser == false) {
            this.router.navigate(['/espaceCandidat']);
        }
        else {
            this.router.navigate(['/candidature']);
        }
    };
    /**
     * Enregistrer une candidature sans valider tous les champs obligatoire
     * Redirection vers mon espace candidat ensuite
     */
    CandidatureDetailComponent.prototype.saveForLaterAndGoHome = function () {
        this.saveForLater();
        this.goToHome();
    };
    /**
     * Enregistrer une candidature sans valider tous les champs obligatoire
     * Redirection vers mon espace candidat ensuite
     */
    CandidatureDetailComponent.prototype.saveForLater = function () {
        this.save(false, false, this.goToHome);
    };
    CandidatureDetailComponent.prototype.backToListe = function (direct) {
        if (direct && this.listeCandidatures != null && this.listeCandidatures.length > 1) {
            if (this.listeCandidatures[this.listeCandidatures.length - 1] !== '' + this.candidatureFormation.id) {
                this.nextCandidature();
            }
            else {
                this.previousCandidature();
            }
        }
        else {
            if (this.candidatureFormation != null) {
                this.router.navigate(['/candidature-back/' + this.candidatureFormation.id]);
            }
            else {
                this.router.navigate(['/candidature']);
            }
        }
        this.isSaving = false;
    };
    CandidatureDetailComponent.prototype.previousCandidature = function () {
        // Go to the previous Candidature in Action groupées
        var previous = this.listeCandidatures.indexOf(String(this.candidatureFormation.id));
        this.router.navigate(['/candidature/' + this.listeCandidatures[previous - 1], {
                listeCandidatures: this.listeCandidatures
            }]);
        this.load(this.listeCandidatures[previous - 1]);
        var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#TOP');
        this.pageScrollService.start(pageScrollInstance);
    };
    CandidatureDetailComponent.prototype.nextCandidature = function () {
        // Go to the next Candidature in Action groupées
        var next = this.listeCandidatures.indexOf('' + this.candidatureFormation.id);
        this.router.navigate(['/candidature/' + this.listeCandidatures[next + 1], {
                listeCandidatures: this.listeCandidatures
            }]);
        this.load(this.listeCandidatures[next + 1]);
        var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#TOP');
        this.pageScrollService.start(pageScrollInstance);
    };
    /**
     * To create a new Candidature -> Post it to CandidatureFormation
     */
    CandidatureDetailComponent.prototype.createCandidature = function (fullValidation, callbackSaveOk) {
        var _this = this;
        if (this.adresse && this.candidatureFormation && this.candidature) {
            if (navigator && navigator.userAgent) {
                this.candidature.navigator = navigator.userAgent;
            }
            var stream = this.candidatureService.create(this.candidature);
            stream.subscribe(function (candi) {
                if (fullValidation) {
                    _this.candidatureFormation.pageEdition = cadens_constants_1.CONSTANTS.SCOLARITE;
                }
                _this.candidature = candi;
                _this.candidatureFormation.candidatureId = candi.id;
                _this.adresse.candidatureId = candi.id;
                var adresseStream = _this.adresseService.update(_this.adresse);
                var candFormStream = _this.candidatureFormationService.create(_this.candidatureFormation);
                rxjs_1.Observable.forkJoin([candFormStream, adresseStream]).subscribe(function (results) {
                    _this.candidatureFormation = results[0];
                    _this.isSaving = false;
                    var nextUrl = '/candidature/' + _this.candidatureFormation.id;
                    if (_this.candidatureUser.id != _this.currentAccount.id) {
                        nextUrl = nextUrl + '/' + _this.candidatureUser.id;
                    }
                    _this.router.navigate([nextUrl]);
                    _this.load(_this.candidatureFormation.id);
                }, function (res) {
                    _this.candidatureFormation.pageEdition = cadens_constants_1.CONSTANTS.CIVILITE;
                    _this.onError(res);
                });
            }, function (res) {
                _this.candidatureFormation.pageEdition = cadens_constants_1.CONSTANTS.CIVILITE;
                _this.onError(res);
            });
        }
    };
    CandidatureDetailComponent.prototype.updateCandidature = function (fullValidation, forceTransmit, verifier, callbackSaveOk) {
        var _this = this;
        if (fullValidation) {
            this.candidatureFormation.pageEdition = cadens_constants_1.CONSTANTS.SCOLARITE;
        }
        var candStream = this.candidatureService.update(this.candidature);
        var adresseStream = this.adresseService.update(this.adresse);
        rxjs_1.Observable.forkJoin([candStream, adresseStream]).subscribe(function (results) {
            _this.candidature = results[0];
            _this.adresse = results[1];
            //on a besoin d'avoir fini de sauver la candidature avant de sauver la candidature formation
            var candFormStream = _this.candidatureFormationService.update(_this.candidatureFormation, forceTransmit, fullValidation);
            rxjs_1.Observable.forkJoin([candFormStream]).subscribe(function (results) {
                var oldCandidatureFormation = _this.candidatureFormation;
                _this.candidatureFormation = results[0];
                if (_this.isEditable && _this.traitementEnabled > 0) {
                    if (verifier) {
                        _this.load(_this.candidatureFormation.id);
                        _this.verifierCandidature();
                    }
                    else {
                        _this.backToListe(true);
                    }
                }
                else {
                    _this.goToStep(_this.candidatureFormation.pageEdition);
                }
            }, function (res) {
                _this.isSaving = false;
                _this.onError(res);
            });
            /*
                        if (this.listeCours != null && this.listeCours.length > 0) {
                            this.listeCours.forEach(cours => cours.candidatureFormationId = this.candidatureFormation.id);
                            this.coursService.update(this.listeCours).subscribe(listCours => {
                                this.listeCours = listCours;
                            });
                        }
            */
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
        });
    };
    CandidatureDetailComponent.prototype.updateCandidatureFormation = function (page, oldPage, forceTransmit, fullValidation) {
        var _this = this;
        this.candidatureFormation.pageEdition = page;
        this.candidatureFormationService.update(this.candidatureFormation, forceTransmit, fullValidation).subscribe(function (candiFormation) {
            _this.candidatureFormation = candiFormation;
            _this.isSaving = false;
            _this.goToStep(_this.candidatureFormation.pageEdition);
        }, function (res) {
            _this.candidatureFormation.pageEdition = oldPage;
            _this.isSaving = false;
            _this.onError(res);
        });
        if (this.listeCours != null && this.listeCours.length > 0) {
            this.listeCours.forEach(function (cours) { return cours.candidatureFormationId = _this.candidatureFormation.id; });
            this.coursService.update(this.listeCours).subscribe(function (listCours) {
                _this.listeCours = listCours;
            });
        }
    };
    CandidatureDetailComponent.prototype.saveParGestionnaire = function (verifier) {
        var _this = this;
        // Si pas de motif pour avis défavorable, on ne peut pas sauvegarder
        if (this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.NOTFAVORABLE
            && (this.candidatureFormation.commentaire === undefined || this.candidatureFormation.commentaire === null)) {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({ id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.error.commentaireObligatoire', timeout: this.alertCommentaireObligatoireTimeout }, []);
            this.onClickOnStep(this.constants.AVIS);
        }
        else if (this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.AWAITING
            && this.candidatureFormation.avisRang !== undefined
            && this.candidatureFormation.avisRang !== null
            && this.candidatureFormation.avisRang <= 0) {
            // Si rang négatif pour l'avis liste complémentaire, on ne peut pas sauvegarder
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({ id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.avisRangDoitEtrePositif', timeout: this.alertCommentaireObligatoireTimeout }, []);
            this.onClickOnStep(this.constants.AVIS);
        }
        else if (this.isEditable && this.traitementEnabled > 0) {
            // Enregistrement fait par le Gestionnaire
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.candidature.confirmSave.message'),
                header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                accept: function () {
                    if (shared_1.Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_REFERENT', 'ROLE_GEST'], _this.candidatureUser.authorities)) {
                        var updates_1 = [_this.concoursService.update(_this.concours)];
                        if (_this.courses != null && _this.courses.length > 0) {
                            updates_1.push(_this.cursusService.update(_this.courses));
                        }
                        if (_this.candidatureFormation.categorieFormationId != null && _this.candidatureFormation.formationId != null) {
                            updates_1.push(_this.reponseService.update(_this.questions));
                        }
                        if (_this.referents != null && _this.referents.length > 0) {
                            _this.referents.forEach(function (ref) { return updates_1.push(_this.referentService.update(ref, null)); });
                        }
                        if (_this.preavisModifEnabled && _this.candidatureFormation.listePreavis != null && _this.candidatureFormation.listePreavis.length > 0) {
                            updates_1.push(_this.preavisService.update(_this.candidatureFormation.listePreavis));
                        }
                        if (_this.listeCours != null && _this.listeCours.length > 0) {
                            _this.listeCours.forEach(function (cours) { return cours.candidatureFormationId = _this.candidatureFormation.id; });
                            updates_1.push(_this.coursService.update(_this.listeCours));
                        }
                        if (updates_1.length > 0) {
                            _this.isSaving = true;
                            rxjs_1.Observable.forkJoin(updates_1).subscribe(function () {
                                _this.updateCandidature(false, false, verifier, null);
                            }, function (res) {
                                _this.isSaving = false;
                                _this.onError(res);
                            });
                        }
                        else {
                            _this.onErrorMessage('cadensApp.candidature.error.saveNonFait');
                        }
                    }
                }
            });
        }
        else {
            var updates = [];
            var updateStatus_1 = false;
            if (shared_1.Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'], this.candidatureUser.authorities)) {
                updates.push(this.candidatureFormationService.updateCandidaturesStatus([this.candidatureFormation], null));
                updateStatus_1 = true;
                if (this.preavisModifEnabled && this.candidatureFormation.listePreavis != null && this.candidatureFormation.listePreavis.length > 0) {
                    updates.push(this.preavisService.update(this.candidatureFormation.listePreavis));
                }
            }
            if (updates.length > 0) {
                this.isSaving = true;
                rxjs_1.Observable.forkJoin(updates).subscribe(function () {
                    _this.isSaving = false;
                    if (updateStatus_1 == true) {
                        _this.backToListe(true);
                    }
                    else {
                        _this.load(_this.candidatureFormation.id);
                    }
                }, function (res) {
                    _this.isSaving = false;
                    _this.onError(res);
                });
            }
            else {
                this.onErrorMessage('cadensApp.candidature.error.saveNonFait');
                this.load(this.candidatureFormation.id);
            }
        }
    };
    CandidatureDetailComponent.prototype.verifierCandidature = function () {
        var _this = this;
        // Si pas de motif pour avis défavorable, on affiche une erreur
        if (this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.NOTFAVORABLE
            && (this.candidatureFormation.commentaire === undefined || this.candidatureFormation.commentaire === null)) {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({ id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.error.commentaireObligatoire', timeout: this.alertCommentaireObligatoireTimeout }, []);
            this.onClickOnStep(this.constants.AVIS);
        }
        else {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.candidatureFormationService.verifierCandidature(this.candidatureFormation.id, false).subscribe(function (verif) {
                if (verif.verificationOk) {
                    _this.alertService.success('cadensApp.candidature.verificationOk', null, null);
                }
                else {
                    shared_1.JhiAlertComponent.onErrorMessage(_this.alertService, shared_1.JhiAlertComponent.construitCleMessage(verif.message, verif.entityName, verif.applicationName), null);
                }
            }, function (res) {
                _this.onError(res);
            });
        }
    };
    CandidatureDetailComponent.prototype.onError = function (response) {
        this.isSaving = false;
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    CandidatureDetailComponent.prototype.onErrorMessage = function (message, params) {
        this.isSaving = false;
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    };
    /** User clicks directly from UI on another step **/
    CandidatureDetailComponent.prototype.onClickOnStep = function (step) {
        if (this.currentPage === cadens_constants_1.CONSTANTS.ALL) {
            var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#' + step);
            this.pageScrollService.start(pageScrollInstance);
        }
        else if (!this.isEditable || this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.PIECES ||
            (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.SCOLARITE &&
                (step === cadens_constants_1.CONSTANTS.CIVILITE || step === cadens_constants_1.CONSTANTS.SCOLARITE)) ||
            (this.candidatureFormation.pageEdition === cadens_constants_1.CONSTANTS.FORMATION &&
                (step === cadens_constants_1.CONSTANTS.CIVILITE || step === cadens_constants_1.CONSTANTS.SCOLARITE || step === cadens_constants_1.CONSTANTS.FORMATION))) {
            this.goToStep(step);
        }
    };
    CandidatureDetailComponent.prototype.goToStep = function (step) {
        this.isSaving = false;
        this.candidatureFormation.pageEdition = step;
        this.currentPage = step;
    };
    CandidatureDetailComponent.prototype.gestionDroits = function (userId, dateLimiteAvis, authoritiesListe) {
        this.preavisModifEnabled = false;
        this.preavisVisuAllEnabled = false;
        //le role utilisateur prend le pas sur tout les autres roles
        if (shared_1.Principal.isAuthorityInListe('ROLE_USER', authoritiesListe)) {
            if (this.candidatureFormation.userId !== userId) {
                // Empêcher l'accès à la candidature d'un autre
                this.alertService.error('error.rights', null, null);
                this.router.navigate(['/espaceCandidat']);
            }
            if (this.candidatureFormation.dateValidation == null) {
                this.isEditable = true;
            }
            else {
                this.goToStep(cadens_constants_1.CONSTANTS.CIVILITE);
            }
        }
        else {
            //le gestionnaire peut en général éditer les informations de la candidature
            if (shared_1.Principal.isAuthorityInListe('ROLE_GEST', authoritiesListe)) {
                this.isEditable = true;
                if (this.candidatureFormation.statut === cadens_constants_1.CONSTANTS.FINISHED ||
                    this.candidatureFormation.statut === cadens_constants_1.CONSTANTS.CONFIRMED) {
                    this.avisEnabled = 2;
                    this.traitementEnabled = 2;
                    this.preavisVisuAllEnabled = true;
                    this.preavisModifEnabled = true;
                }
                else {
                    this.preavisVisuAllEnabled = true;
                    this.avisEnabled = 1;
                    this.traitementEnabled = 1;
                }
                this.loadOtherCandidatures();
            }
            else {
                //les systems et admins peuvent en général visualiser les informations de la candidature
                if (shared_1.Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN'], authoritiesListe)) {
                    this.preavisVisuAllEnabled = true;
                    this.avisEnabled = 1;
                    this.traitementEnabled = 1;
                }
                //le responsable de formation peut editer les préavis des autres et avis
                //remarque : le fait qu'il soit responsable de cette formation n'est pas vérifié ici
                if (shared_1.Principal.isAuthorityInListe('ROLE_REFERENT', authoritiesListe)) {
                    this.avisEnabled = 1;
                    if (this.candidatureFormation.statut === cadens_constants_1.CONSTANTS.FINISHED) {
                        if (this.candidatureFormation.avis == null || dateLimiteAvis == null) {
                            this.preavisVisuAllEnabled = true;
                            this.preavisModifEnabled = true;
                            this.avisEnabled = 2;
                        }
                        else {
                            this.preavisVisuAllEnabled = true;
                            if (dateLimiteAvis >= Date.now()) {
                                this.preavisModifEnabled = true;
                                this.avisEnabled = 2;
                            }
                        }
                    }
                }
                //l'enseignant lecteur peut editer son préavis uniquement pour les candidatures sur sa formation
                //remarque : le fait qu'il soit lecteur sur la formation n'est pas vérifié ici
                if (shared_1.Principal.isAuthorityInListe('ROLE_DELEGATE', authoritiesListe)) {
                    if (this.candidatureFormation.statut === cadens_constants_1.CONSTANTS.FINISHED) {
                        if (dateLimiteAvis == null) {
                            this.preavisModifEnabled = true;
                        }
                        else {
                            if (dateLimiteAvis >= Date.now()) {
                                this.preavisModifEnabled = true;
                            }
                        }
                    }
                }
            }
            this.candidatureFormation.pageEdition = cadens_constants_1.CONSTANTS.CIVILITE;
            this.currentPage = cadens_constants_1.CONSTANTS.ALL;
        }
    };
    // Changer de page dans la candidature
    CandidatureDetailComponent.prototype.loadOtherCandidatures = function () {
        var _this = this;
        // load other candis transmises afficher ordre
        this.candidatureFormationService.query({ userId: this.candidatureFormation.userId }).subscribe(function (res) {
            _this.otherCandidatures = res.json();
            _this.otherCandidatures = _this.otherCandidatures.filter(function (candi) {
                return candi.id !== _this.candidatureFormation.id && candi.dateSuppression == null;
            });
        }, function (res) {
            _this.onError(res);
        });
    };
    CandidatureDetailComponent.prototype.isLastStep = function () {
        return (this.currentPage === cadens_constants_1.CONSTANTS.PIECES
            || (this.currentPage === cadens_constants_1.CONSTANTS.FORMATION && this.candidatureFormation.reinscription));
    };
    //Renvoie vrai si la candidature est echange international
    CandidatureDetailComponent.prototype.isCandidatureEchange = function () {
        return candidature_formation_service_1.CandidatureFormationService.isCandidatureEchange(this.candidatureFormation);
    };
    CandidatureDetailComponent.prototype.exportPdf = function () {
        var _this = this;
        this.isSaving = true;
        this.candidatureFormationService.generatePDF(this.candidatureFormation.id, this.isUser, this.candidatureFormationService.exportPdfNormal).subscribe(function (res) {
            _this.isSaving = false;
            shared_1.ExportService.download(res, 'Candidature_' + _this.candidatureFormation.id + '.pdf');
        }, (function (error) {
            _this.isSaving = false;
            _this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.genererExportPdf' });
        }));
    };
    CandidatureDetailComponent.prototype.auditClick = function () {
        this.router.navigateByUrl('/entity-audit-event/candidatureFormation/' + this.candidatureFormation.id);
    };
    CandidatureDetailComponent.prototype.historiqueClick = function () {
        this.router.navigateByUrl('/historique/candidatureFormation/' + this.candidatureFormation.id);
    };
    //Generation du pdf contrat de service
    CandidatureDetailComponent.prototype.genererContratEtudeInternational = function () {
        var _this = this;
        //vérification des référents
        if (this.isCandidatureEchange()) {
            if (!this.referentsEchangeCorrects()) {
                return this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.referentobligatoire' });
            }
            else {
                this.saveForLater();
                this.candidatureFormationService.genererContratEtudeInternational(this.candidatureFormation.id).subscribe(function (res) {
                    shared_1.ExportService.download(res, 'StudyContract_' + _this.candidatureFormation.id + '.pdf');
                }, (function (error) {
                    _this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.generationContratEtude' });
                }));
            }
        }
    };
    //Generation du document suivants status acceptation, refus, attente
    CandidatureDetailComponent.prototype.genererLettreAdmission = function (candiId, pourReponseCode, sortieListeComplementaire) {
        var _this = this;
        var lc = '_';
        if (sortieListeComplementaire == true) {
            lc = 'lc';
        }
        var fileName = 'reponseENS' + lc + candiId + '.pdf';
        this.isSaving = true;
        this.candidatureFormationService.genererLettreAdmission(candiId, pourReponseCode, sortieListeComplementaire).subscribe(function (res) {
            _this.isSaving = false;
            shared_1.ExportService.download(res, fileName);
        }, (function (error) {
            _this.onErrorMessage({ message: 'cadensApp.candidature.messages.error.genererLettreAdmission' });
        }));
    };
    CandidatureDetailComponent.prototype.onWindowScroll = function () {
        var scroll = this.document.body.scrollTop;
        var scrollBottom = this.document.body.scrollHeight - this.document.body.clientHeight - 50;
        this.navIsFixed = scroll < scrollBottom;
    };
    CandidatureDetailComponent.prototype.getTransmitTitle = function (forceTransmit, defaultTitle) {
        var commissionLibelle = "";
        var commission = null;
        var title = undefined;
        if (this.isCurrentAccountNotUser == true) {
            if (this.commissionCouranteCandidature == null) {
                if (forceTransmit == false) {
                    commission = this.commissionOuvertePourCandidature;
                }
                else {
                    commission = this.commissionFermePourCandidature;
                }
                if (commission != null) {
                    title = this.translateService.instant('entity.action.seraTransmisSurCommission', { 'commission': commission.libelle });
                }
                else {
                    title = this.translateService.instant('entity.action.seraTransmisSurAucuneCommission');
                }
            }
            else {
                title = this.translateService.instant('entity.action.estTransmisSurCommission', { 'commission': this.commissionCouranteCandidature.libelle });
            }
        }
        else {
            title = this.translateService.instant(defaultTitle);
        }
        return title;
    };
    CandidatureDetailComponent.prototype.getVerifierTitle = function (defaultTitle) {
        return this.translateService.instant(defaultTitle);
    };
    CandidatureDetailComponent.prototype.onFormationsDisponiblesChange = function ($event) {
        this.desCategoriesFormationDisponibles = $event;
    };
    CandidatureDetailComponent.prototype.savePreavis = function (listePreavis) {
        var _this = this;
        if (this.preavisModifEnabled && listePreavis != null && listePreavis.length > 0) {
            this.preavisService.update(listePreavis).subscribe(function (listePreavisUpdated) {
                _this.candidatureFormation.listePreavis = preavis_model_1.Preavis.buildListePreavis(_this.currentAccount.id, _this.preavisVisuAllEnabled, _this.preavisModifEnabled, _this.candidatureFormation.id, listePreavisUpdated.json(), _this.candidatureFormation.formation.lecteurs, _this.candidatureFormation.formation.users);
            }, function (res) {
                _this.onError(res);
            });
        }
    };
    CandidatureDetailComponent.prototype.valideFormation = function (fullValidation) {
        var _this = this;
        var messageText = null;
        var messageParam = null;
        if (this.candidatureFormation.categorieFormationId == null || this.candidatureFormation.formationId == null) {
            messageText = 'cadensApp.candidature.messages.error.formationobligatoire';
        }
        else if (fullValidation) {
            if (this.questions != null) {
                var nbQuestion = 0;
                this.questions.forEach(function (question) {
                    if (question.obligatoire == true &&
                        (question.reponseComplement == null ||
                            (question.reponseComplement.localeCompare(formation_1.CasParticulierEI.EI_QUESTION_COURS_CODE) != 0 &&
                                question.reponseComplement.localeCompare(formation_1.CasParticulierEI.EI_QUESTION_COURS_ECTS) != 0 &&
                                question.reponseComplement.localeCompare(formation_1.CasParticulierEI.EI_QUESTION_COURS_LIBELLE) != 0))) {
                        if (question.typeReponse !== cadens_constants_1.CONSTANTS.NONE && (question.reponse == null || question.reponse.toString().length == 0)) {
                            messageParam = { 'question': (_this.currentLang === 'fr' ? question.libelle : question.libelleEn).replace(/<(.|\n)*?>/g, '') };
                            messageText = 'cadensApp.candidature.messages.error.reponse.reponseManquante';
                        }
                        if (question.typeReponse == 'CHECKBOX' && (question.reponse == null || question.reponse.toString().length == 0 || question.reponse.toString() == 'false')) {
                            messageParam = { 'question': (_this.currentLang === 'fr' ? question.libelle : question.libelleEn).replace(/<(.|\n)*?>/g, '') };
                            messageText = 'cadensApp.candidature.messages.error.reponse.cocheObligatoire';
                        }
                    }
                });
            }
            if (this.candidatureFormation.formationId == this.constants.ECHANGE_INTERNATIONAL_ID) {
                if (this.listeCours == null || this.listeCours.length == 0) {
                    messageText = 'cadensApp.candidature.messages.error.cours.aucun';
                }
                else if (this.coursService.isCoursExistant(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.existant';
                }
                else if (this.coursService.isCoursEmpty(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.vide';
                }
                else if (this.coursService.isCoursDuplique(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.duplique';
                }
            }
        }
        return { messageText: messageText, messageParam: messageParam };
    };
    CandidatureDetailComponent.prototype.referentsEchangeCorrects = function () {
        var checkOk = true;
        var countOfReferentExchange = this.referents.filter(function (referent) { return referent.typeReferent == cadens_constants_1.CONSTANTS.CONTACT_PEDAGO || referent.typeReferent == cadens_constants_1.CONSTANTS.CONTACT_ADMIN; }).length;
        if (countOfReferentExchange >= 2) {
            if (this.referents.filter(function (referent) {
                return referent.email == null || referent.email.length == 0 ||
                    referent.position == null || referent.position.length == 0 ||
                    referent.nom == null || referent.nom.length == 0 ||
                    referent.prenom == null || referent.prenom.length == 0;
            }).length > 0) {
                checkOk = false;
            }
        }
        else {
            checkOk = false;
        }
        return checkOk;
    };
    return CandidatureDetailComponent;
}());
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CandidatureDetailComponent.prototype, "listeCoursChange", void 0);
__decorate([
    core_1.HostListener('window:scroll', []),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CandidatureDetailComponent.prototype, "onWindowScroll", null);
CandidatureDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-candidature-detail',
        template: __webpack_require__(418)
    }),
    __param(24, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        candidature_service_1.CandidatureService,
        adresse_service_1.AdresseService,
        reponse_service_1.ReponseService,
        router_1.ActivatedRoute,
        candidature_formation_service_1.CandidatureFormationService,
        shared_1.ExportService,
        cursus_service_1.CursusService,
        cours_service_1.CoursService,
        concours_service_1.ConcoursService,
        referent_1.ReferentService,
        router_1.ActivatedRoute,
        router_1.Router,
        shared_1.Principal,
        ng_jhipster_1.AlertService,
        grhum_1.GrhumService,
        ng_jhipster_1.EventManager,
        ng2_page_scroll_1.PageScrollService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService,
        shared_1.UserService,
        commission_1.CommissionService,
        preavis_service_1.PreavisService,
        formation_1.FormationService, Object])
], CandidatureDetailComponent);
exports.CandidatureDetailComponent = CandidatureDetailComponent;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var CandidatureFormationOrder = (function () {
    // noinspection JSUnusedGlobalSymbols
    function CandidatureFormationOrder(id, ordre, ordreModifiable) {
        this.id = id;
        this.ordre = ordre;
        this.ordreModifiable = ordreModifiable;
    }
    return CandidatureFormationOrder;
}());
exports.CandidatureFormationOrder = CandidatureFormationOrder;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Rx_1 = __webpack_require__(14);
var ng_jhipster_1 = __webpack_require__(1);
var candidature_formation_service_1 = __webpack_require__(18);
var cadens_constants_1 = __webpack_require__(8);
var shared_1 = __webpack_require__(2);
var listeChoix_service_1 = __webpack_require__(23);
var ng2_webstorage_1 = __webpack_require__(35);
var grhum_1 = __webpack_require__(13);
var formation_1 = __webpack_require__(9);
var datatable_1 = __webpack_require__(472);
var commission_1 = __webpack_require__(33);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var reponse_service_1 = __webpack_require__(28);
var entity_verification_model_1 = __webpack_require__(255);
var user_en_echange_1 = __webpack_require__(21);
var ng2_page_scroll_1 = __webpack_require__(31);
var platform_browser_1 = __webpack_require__(17);
var enscol_service_1 = __webpack_require__(140);
var jsUtil_1 = __webpack_require__(44);
var admis_service_1 = __webpack_require__(58);
var CandidatureComponent = (function () {
    function CandidatureComponent(jhiLanguageService, candidatureFormationService, grhumService, formationService, reponseService, commissionService, alertService, listeChoixService, router, activatedRoute, exportService, principal, localStorage, confirmationService, translateService, userEnEchangeService, pageScrollService, userService, enscolService, admisService, document) {
        this.jhiLanguageService = jhiLanguageService;
        this.candidatureFormationService = candidatureFormationService;
        this.grhumService = grhumService;
        this.formationService = formationService;
        this.reponseService = reponseService;
        this.commissionService = commissionService;
        this.alertService = alertService;
        this.listeChoixService = listeChoixService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.exportService = exportService;
        this.principal = principal;
        this.localStorage = localStorage;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.userEnEchangeService = userEnEchangeService;
        this.pageScrollService = pageScrollService;
        this.userService = userService;
        this.enscolService = enscolService;
        this.admisService = admisService;
        this.document = document;
        this.selectedColumns = ['id', 'libelle', 'civilite', 'candidat', 'statut'];
        this.searchText = null;
        this.rowPerPage = 20;
        this.isOnlyEnseignantDelegate = false;
        this.isResponsableFormation = false;
        this.isOnlyResponsableFormation = false;
        this.isAdminOrGestionnaire = false;
        this.isGestionnaire = false;
        this.reinscription = false;
        this.constants = cadens_constants_1.CONSTANTS;
        this.isLoading = false;
        this.isVerifying = false;
        this.displayVerifyingDialog = false;
        this.invalideCandidatureList = [];
        this.messageErreur = null;
        // Show / Hide selected columns
        this.cols = [
            { label: 'id', value: 'id' },
            { label: 'statut', value: 'statut' },
            { label: 'formation', value: 'libelle' },
            { label: 'civilité', value: 'civilite' },
            { label: 'nom prénom', value: 'candidat' },
            { label: 'avis', value: 'avis' },
            { label: 'rang comm péda', value: 'avisRang' },
            { label: 'Validation de l avis pédagogique', value: 'response' },
            { label: 'Rang liste complémentaire', value: 'responseRang' },
            { label: 'conforme', value: 'conforme' },
            { label: 'bourse CROUS', value: 'bourse' },
            { label: 'échelon de bourse', value: 'echelon' },
            { label: 'Demande bourse Excellence', value: 'indicBourseExcellence' },
            { label: 'Bénéficiaire bourse Excellence', value: 'bourseExcellence' },
            { label: 'date de création', value: 'dateCreation' },
            { label: 'date de transmission', value: 'dateValidation' },
            { label: 'date de confirmation', value: 'dateConfirmation' },
            { label: 'date de désistement', value: 'dateDesistement' },
            { label: 'date de naissance', value: 'dateNaissance' },
            { label: 'statut ENSCOL', value: 'statutEnscol' },
            { label: 'inscriptions ENSCOL', value: 'inscriptionsEnscol' },
            { label: 'nationalité', value: 'paysNationalite' },
            { label: 'type nationalité', value: 'typeNationalite' },
            { label: 'téléphone', value: 'telephoneFixe' },
            { label: 'email', value: 'email' },
            { label: 'type de formation', value: 'categorieFormation' },
            { label: 'dernier cursus', value: 'dernierCursus' },
            { label: 'niveau études', value: 'niveauEtudes' },
            { label: 'questions complémentaires condensées', value: 'questionsComplementaires' },
            { label: 'questions complémentaires par colonne', value: 'questionsComplementairesParColonne' },
            { label: 'formation continue', value: 'formationContinue' },
            { label: 'commission', value: 'commission' },
            { label: 'voeux', value: 'ordre' },
            { label: 'ei', value: 'ei' },
            { label: 'discipline majeure', value: 'reponseMajorDiscipline' },
            { label: 'université origine', value: 'universiteOrigine' },
            { label: 'pays origine', value: 'paysOrigine' },
            { label: 'type échange', value: 'typeEchange' },
            { label: 'controle identité', value: 'controleIdentiteAdmis' },
            { label: 'old id', value: 'oldCfId' },
        ];
        // Show / Hide selected columns
        this.colFieldNameDictionary = new shared_1.KeyedCollection();
        this.actions = [];
        this.selectedAction = [];
        this.responseDialog = false;
        this.avisDialog = false;
        this.libelleList = [];
        this.mentionList = [];
        this.parcoursList = [];
        this.disciplineList = [];
        this.commissionList = [];
        this.statutList = [];
        this.responseList = [];
        this.avisList = [];
        this.conformeList = [];
        this.typeEIList = [];
        this.disciplineMajeureList = [];
        this.statutEnscolList = [];
        this.reponsesQuestionLoaded = false;
        this.disciplineMajeurLoaded = false;
        // pour le split des questions/reponses
        this.allQuestions = [];
        // Nom du filtre sur le Local Storage, est différent sur les 2 pages de candidatures internes / externes
        this.textTruncate = function (str, length) {
            if (length == null) {
                length = 100;
            }
            var ending = '...';
            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            }
            else {
                return str;
            }
        };
        this.CONSTANTS = cadens_constants_1.CONSTANTS;
        this.jhiLanguageService.setLocations(['candidature', 'global']);
        this.colFieldNameDictionary.Add('formationContinue', 'fc');
        this.colFieldNameDictionary.Add('grade', 'formation.libelleGrade');
        this.colFieldNameDictionary.Add('mention', 'formation.libelleMention');
        this.colFieldNameDictionary.Add('parcours', 'formation.libelleParcours');
        this.colFieldNameDictionary.Add('parcours', 'formation.libelleParcours');
        this.colFieldNameDictionary.Add('universiteOrigine', 'userEnEchange.nomUniversiteOrigine');
        this.colFieldNameDictionary.Add('paysOrigine', 'userEnEchange.paysUniversite');
        this.colFieldNameDictionary.Add('typeEchange', 'userEnEchange.typeEchange');
        this.colFieldNameDictionary.Add('niveauEtudes', 'niveauAccessDiplomeLibelle');
        this.colFieldNameDictionary.Add('inscriptionsEnscol', 'inscriptionsEnscolString');
    }
    CandidatureComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.activatedRoute.params.subscribe(function (params) {
            _this.backToId = params['id'];
        });
        this.isLoading = true;
        this.reinscription = this.activatedRoute.snapshot.data['reinscription'];
        this.resetLastFilters();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.initBooleensPermissions(account);
            _this.initActionsGroupees();
            _this.loadListes();
        });
        // rajout filtre custom pour filter les valeurs non null
        this.dataTable.filterConstraints['notNull'] = function (value, filter) {
            if (filter == true) {
                if (value === null) {
                    return false;
                }
            }
            return true;
        };
    };
    CandidatureComponent.prototype.initBooleensPermissions = function (account) {
        this.isAdminOrGestionnaire = shared_1.Principal.isAdminOrGestionnaire(account.authorities);
        this.isGestionnaire = shared_1.Principal.isGestionnaire(account.authorities);
        this.isResponsableFormation = shared_1.Principal.isResponsableFormation(account.authorities);
        this.isOnlyResponsableFormation = shared_1.Principal.isOnlyResponsableFormation(account.authorities);
        this.isOnlyEnseignantDelegate = shared_1.Principal.isOnlyEnseignant(account.authorities);
    };
    CandidatureComponent.prototype.initActionsGroupees = function () {
        if (this.isGestionnaire || this.isResponsableFormation) {
            this.actions.push({ label: 'Avis pédagogique', value: 'avis' });
        }
        if (this.isAdminOrGestionnaire) {
            // Les gestionnaire de formation et référents ne peuvent pas mettre de résultat
            this.actions.push({ label: 'Décision admission', value: 'resultat' });
        }
        if (!this.isOnlyEnseignantDelegate) {
            this.actions.push({ label: 'Traiter', value: 'traiter' });
        }
        this.actions.push({ label: 'Export PDF des sélections', value: 'export' });
        this.actions.push({ label: 'Export PDF pour rentree', value: 'exportRentree' });
        if (this.isAdminOrGestionnaire) {
            this.actions.push({ label: 'Vérifier candidature', value: 'verifier' });
            this.actions.push({ label: "Contrôle pièce d'identité", value: 'controleID' });
        }
    };
    CandidatureComponent.prototype.loadAll = function () {
        var _this = this;
        // Charger les listes des filtres et des candidatures
        this.candidatureFormationService.query({
            referentId: (this.isOnlyResponsableFormation ? this.currentAccount.id : null),
            enseignantId: (this.isOnlyEnseignantDelegate ? this.currentAccount.id : null),
            reinscription: this.reinscription,
            dateSuppression: this.getFilterProperty('dateSuppression').value
        }).subscribe(function (res) {
            _this.candidatures = res.json();
            _this.isLoading = false;
            if (_this.candidatures != null) {
                if (_this.isAdminOrGestionnaire || _this.isResponsableFormation || _this.isOnlyEnseignantDelegate) {
                    _this.candidatures.forEach(function (candidature) { return _this.loadEnscolData(candidature); });
                }
                var listeLibelleWithDuplicate = void 0;
                listeLibelleWithDuplicate = _this.candidatures.filter(function (candidature) { return candidature != null && candidature.libelle != null; }).map(function (candidature) { return ({
                    label: candidature.libelle, value: candidature.libelle
                }); }).sort(function (n1, n2) { return n1.label.localeCompare(n2.label); });
                var previousLibelle_1 = null;
                listeLibelleWithDuplicate.forEach(function (candidature) {
                    if (previousLibelle_1 == null ||
                        (previousLibelle_1 != candidature.label)) {
                        _this.libelleList.push(candidature);
                    }
                    previousLibelle_1 = candidature.label;
                });
                _this.loadQuestionsComplementaires();
            }
            _this.reponseService.findMajorDiscipline().subscribe(function (results) {
                results.forEach(function (reponse) {
                    _this.candidatures.filter(function (candidature) { return candidature.id == reponse.candidatureFormationId; }).forEach(function (candidatureMajor) {
                        candidatureMajor.reponseMajorDiscipline = _this.getDisciplineMajeurLibelle(reponse.response);
                    });
                });
                _this.disciplineMajeurLoaded = true;
            }, function (res) { return _this.onError(res.json()); });
            _this.grhumService.queryPays().subscribe(function (res) {
                _this.paysListe = res.json();
                _this.userEnEchangeService.query(user_en_echange_1.TypeEtudiantEnumeration.enEchange).subscribe(function (reponse) {
                    var listeUserEnEchange = reponse.json();
                    if (listeUserEnEchange != null) {
                        _this.candidatures.filter(function (candidature) { return candidature.ei == cadens_constants_1.CONSTANTS.EN_ECHANGE; }).forEach(function (candidature) {
                            candidature.userEnEchange = listeUserEnEchange.find(function (userenEchange) { return userenEchange.email == candidature.email; });
                            if (candidature.userEnEchange != null && candidature.userEnEchange.codePaysUniversite != null) {
                                var pays = _this.paysListe.find(function (pays) { return pays.code == candidature.userEnEchange.codePaysUniversite; });
                                if (pays != null) {
                                    candidature.userEnEchange.paysUniversite = pays.pays;
                                }
                            }
                        }, function (res) { return _this.newOnError(res.json()); });
                    }
                }, function (res) { return _this.newOnError(res.json()); });
            }, function (res) { return _this.newOnError(res.json()); });
            if (_this.backToId != null) {
                var backToId_1 = _this.backToId;
                setTimeout(function () {
                    _this.scrollToCandidature(backToId_1);
                }, 1000);
            }
            setTimeout(function () { return _this.applyFilters(); }, 100);
        }, function (res) { return _this.newOnError(res.json()); });
    };
    CandidatureComponent.prototype.loadEnscolData = function (candidature) {
        var _this = this;
        if (candidature.persId != undefined) {
            // Récupération du statut ENSCOL
            this.enscolService.getStatut(candidature.persId)
                .subscribe(function (statut) { candidature.statutEnscol = statut; }, function (error) { return _this.newOnError(error); });
            // Récupération des inscriptions ENSCOL
            this.enscolService.getInscriptions(candidature.persId)
                .subscribe(function (inscriptions) {
                candidature.inscriptionsEnscol = inscriptions;
                // Tri des inscriptions pour avoir la principale en premier
                candidature.inscriptionsEnscol.sort(function (obj1, obj2) {
                    if (obj2.typeinscription === 'Principale') {
                        return 1;
                    }
                    return -1;
                });
                // Conversion en string pour affichage dans datatable
                candidature.inscriptionsEnscol.forEach(function (inscription) {
                    if (candidature.inscriptionsEnscolString !== undefined) {
                        candidature.inscriptionsEnscolString += '\n\n';
                    }
                    else {
                        candidature.inscriptionsEnscolString = '';
                    }
                    candidature.inscriptionsEnscolString += inscription.typediplome + ' - ' + inscription.niveau + ' - '
                        + inscription.diplome + ' - ' + inscription.parcours + ' (' + inscription.typeinscription + ')';
                });
            }, function (error) { return _this.newOnError(error); });
        }
    };
    CandidatureComponent.prototype.scrollToCandidature = function (candidatureId) {
        if (candidatureId != null) {
            var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#' + candidatureId);
            this.pageScrollService.start(pageScrollInstance);
        }
    };
    CandidatureComponent.prototype.ngAfterViewInit = function () {
        var translateKey = 'cadensApp.candidature.colonnes';
        var multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(function (translation) {
            jsUtil_1.JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    };
    CandidatureComponent.prototype.goToCandidature = function (candidature, enTantQueUser) {
        this.saveFilters();
        if (this.reinscription) {
            if (enTantQueUser == true) {
                this.router.navigate(['/reinscription/' + candidature.id + '/' + candidature.userId]);
            }
            else {
                this.router.navigate(['/reinscription/' + candidature.id]);
            }
        }
        else {
            if (enTantQueUser == true) {
                this.router.navigate(['/candidature/' + candidature.id + '/' + candidature.userId]);
            }
            else {
                this.router.navigate(['/candidature/' + candidature.id]);
            }
        }
    };
    CandidatureComponent.prototype.getCandidatureLink = function (candidatureId) {
        if (this.reinscription) {
            return '/reinscription/' + candidatureId;
        }
        else {
            return '/candidature/' + candidatureId;
        }
    };
    // Modification du Rang sur la liste complémentaire d'une candidature
    CandidatureComponent.prototype.saveRang = function (candidature) {
        var _this = this;
        this.candidatureFormationService.update(candidature, false, false).subscribe(function (res) {
            _this.isLoading = true;
            candidature.saved = true;
            _this.loadAll();
        }, function (err) {
            _this.newOnError(err);
        });
    };
    CandidatureComponent.prototype.onErrorMessage = function (message, params) {
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    };
    CandidatureComponent.prototype.onSuccessMessage = function (message, params) {
        shared_1.JhiAlertComponent.onSuccessMessage(this.alertService, message, params);
    };
    /****************** ACTIONS GROUPEES ******************/
    // Selection d'une action groupée
    CandidatureComponent.prototype.onSelectedAction = function (event) {
        var _this = this;
        if (this.selectedCandidatures != null && this.selectedCandidatures.length > 0) {
            // Sélectionner le service gérant les formations sélectionnées
            if (this.selectedAction.indexOf('avis') > -1) {
                if (this.verifCandidatureAvantModifAvisPedagogique(this.selectedCandidatures) == true) {
                    this.avisDialog = true;
                }
            }
            if (this.selectedAction.indexOf('resultat') > -1) {
                if (this.verifCandidatureAvantModifReponse(this.selectedCandidatures) == true) {
                    this.responseDialog = true;
                }
            }
            else if (this.selectedAction.indexOf('traiter') > -1) {
                // Traiter toutes les candidatures les unes après les autres (mets des flèches de navigation)
                var idsList = this.selectedCandidatures.map(function (candi) { return candi.id; });
                this.router.navigate(['/candidature/' + idsList[0], {
                        listeCandidatures: idsList
                    }]);
            }
            else if (this.selectedAction.indexOf('export') > -1) {
                // Export d'un ZIP regroupant tous les Pdf
                var idsList = this.selectedCandidatures.map(function (candi) { return candi.id; });
                this.isLoading = true;
                this.candidatureFormationService.generatePDFs(idsList, false, this.candidatureFormationService.exportPdfNormal).subscribe(function (res) {
                    _this.isLoading = false;
                    shared_1.ExportService.download(res, 'Candidatures.zip');
                    _this.selectedAction = [];
                });
            }
            else if (this.selectedAction.indexOf('exportRentree') > -1) {
                // Export d'un ZIP regroupant tous les Pdf pour la rentree
                var idsList = this.selectedCandidatures.map(function (candi) { return candi.id; });
                this.isLoading = true;
                this.candidatureFormationService.generatePDFs(idsList, false, this.candidatureFormationService.exportPdfRentree).subscribe(function (res) {
                    _this.isLoading = false;
                    shared_1.ExportService.download(res, 'CandidaturesRentree.zip');
                    _this.selectedAction = [];
                });
            }
            else if (this.selectedAction.indexOf('verifier') > -1) {
                var idsList = this.selectedCandidatures.map(function (candi) { return candi.id; });
                this.verifierListeCandidature(idsList);
            }
            else if (this.selectedAction.indexOf('controleID') > -1) {
                this.controlerIdentites(this.selectedCandidatures);
            }
        }
        else {
            this.selectedAction = [];
        }
    };
    CandidatureComponent.prototype.verifierListeCandidature = function (candidatureFormationIds) {
        this.valideCandidatureCount = 0;
        this.invalideCandidatureList = [];
        this.loopVerifierListeCandidature(candidatureFormationIds);
    };
    CandidatureComponent.prototype.loopVerifierListeCandidature = function (candidatureFormationIds) {
        var _this = this;
        if (candidatureFormationIds != null && candidatureFormationIds.length > 0) {
            this.isVerifying = true;
            this.displayVerifyingDialog = true;
            var candidatureFormationId_1 = candidatureFormationIds[0];
            this.candidatureFormationService.verifierCandidature(candidatureFormationId_1, false).subscribe(function (verif) {
                if (!verif.verificationOk) {
                    verif.translatedMessage = _this.translateService.instant(shared_1.JhiAlertComponent.construitCleMessage(verif.message, verif.entityName, verif.applicationName));
                    _this.invalideCandidatureList.push(verif);
                }
                else {
                    _this.valideCandidatureCount++;
                }
                //this.onSuccessMessage('cadensApp.candidature.error.candidatureValide', {id:candidatureFormationId});
                //ATTENTION RECURSIF
                if (_this.isVerifying) {
                    _this.loopVerifierListeCandidature(candidatureFormationIds.filter(function (id) { return id != candidatureFormationId_1; }));
                }
            }, function (res) {
                _this.isVerifying = false;
                var verif = new entity_verification_model_1.EntityVerification();
                verif.entityId = candidatureFormationId_1;
                verif.message = 'cadensApp.candidature.verification.candidatureInvalide';
                _this.invalideCandidatureList.push(verif);
                //this.onErrorMessage('cadensApp.candidature.error.candidatureInvalide', {id:candidatureFormationId});
                _this.newOnError(res);
            });
        }
        else {
            this.isVerifying = false;
            if (this.invalideCandidatureList.length > 0) {
                this.onErrorMessage('cadensApp.candidature.verification.candidatureInvalideCount', { 'count': this.invalideCandidatureList.length });
            }
            else {
                this.onSuccessMessage('cadensApp.candidature.verification.candidatureValideCount', { 'count': this.valideCandidatureCount });
            }
        }
    };
    CandidatureComponent.prototype.cancelResponse = function () {
        this.responseDialog = false;
        this.selectedAction = [];
    };
    CandidatureComponent.prototype.cancelAvis = function () {
        this.avisDialog = false;
        this.selectedAction = [];
    };
    CandidatureComponent.prototype.cancelDialogInvalideCandidature = function () {
        this.invalideCandidatureList = [];
        this.displayVerifyingDialog = false;
    };
    CandidatureComponent.prototype.saisirAvis = function (candidatureFormation) {
        this.selectedCandidatures = [candidatureFormation];
        this.selectedAction = ['avis'];
        this.onSelectedAction(null);
    };
    CandidatureComponent.prototype.exportCSV = function (fullExport) {
        var _this = this;
        var colHeaderDictionary = new shared_1.KeyedCollection();
        this.cols.forEach(function (col) {
            colHeaderDictionary.Add(col.value, col.label);
        });
        var columns = this.cols.map(function (col) { return col.value; });
        if (!columns.find(function (x) { return x === 'nom'; })) {
            columns.push('nom');
            colHeaderDictionary.Add('nom', 'nom');
        }
        if (!columns.find(function (x) { return x === 'prenom'; })) {
            columns.push('prenom');
            colHeaderDictionary.Add('prenom', 'prénom');
        }
        var libelleIndex = columns.findIndex(function (col) { return col == 'libelle'; });
        if (libelleIndex == null) {
            libelleIndex = columns.length - 1;
        }
        if (!columns.find(function (x) { return x === 'grade'; })) {
            columns.splice(libelleIndex + 1, 0, 'grade');
            colHeaderDictionary.Add('grade', 'grade');
        }
        if (!columns.find(function (x) { return x === 'mention'; })) {
            columns.splice(libelleIndex + 2, 0, 'mention');
            colHeaderDictionary.Add('mention', 'mention');
        }
        if (!columns.find(function (x) { return x === 'parcours'; })) {
            columns.splice(libelleIndex + 3, 0, 'parcours');
            colHeaderDictionary.Add('parcours', 'parcours');
        }
        libelleIndex = columns.findIndex(function (col) { return col == 'dernierCursus'; });
        if (libelleIndex == null) {
            libelleIndex = columns.length - 1;
        }
        if (!columns.find(function (x) { return x === 'questionsComplementaires'; })) {
            columns.splice(libelleIndex + 1, 0, 'questionsComplementaires');
            colHeaderDictionary.Add('questions complémentaires condensées', 'questionsComplementaires');
        }
        if (!columns.find(function (x) { return x === 'questionsComplementairesParColonne'; })) {
            columns.splice(libelleIndex + 2, 0, 'questionsComplementairesParColonne');
            colHeaderDictionary.Add('questions complémentaires par colonne', 'questionsComplementairesParColonne');
        }
        if (fullExport == false) {
            columns = columns.filter(function (column) { return _this.selectedColumns.find(function (selectedCol) { return selectedCol == column; }) != null; });
        }
        var updatePourExport = [];
        updatePourExport.push(this.formationService.query({ userId: this.currentAccount.id }));
        if (this.reponsesQuestionLoaded == false) {
            updatePourExport.push(this.reponseService.getAllReponsesCandidature());
        }
        if (updatePourExport.length > 0) {
            Rx_1.Observable.forkJoin(updatePourExport).subscribe(function (results) {
                if (results != null && results.length > 0) {
                    var formationList = results[0].json();
                    formationList.forEach(function (formation) {
                        _this.candidatures.filter(function (candidature) { return candidature.formationId == formation.id; }).forEach(function (candidatureFormation) {
                            candidatureFormation.formation = formation;
                        });
                    });
                }
                if (results != null && results.length > 1) {
                    _this.completerCandidatureFormation(results[1].json());
                }
                var data = _this.dataTable.filteredValue != null ? _this.dataTable.filteredValue : _this.dataTable.value;
                // Ajout des colonnes correspondant aux questions complémentaires (lorsqu'un export par colonne est choisi)
                if (columns.find(function (x) { return x === 'questionsComplementairesParColonne'; })) {
                    var idx = columns.indexOf('questionsComplementairesParColonne');
                    if (idx != -1) {
                        columns.splice.apply(columns, [idx, 1].concat(_this.allQuestions.map(function (question) { return shared_1.ExportService.QUESTION_PREFIX + question; })));
                        data.forEach(function (record) {
                            _this.allQuestions.forEach(function (question) {
                                record[shared_1.ExportService.QUESTION_PREFIX + question] = shared_1.ExportService.QUESTION_PREFIX + question;
                            });
                        });
                    }
                }
                _this.exportService.toCSVAvecNomOrigineField(data, columns, _this.colFieldNameDictionary, colHeaderDictionary, 'Candidatures.csv');
            }, function (res) {
                _this.onError(res);
            });
        }
    };
    /****************************************
     *  FILTRES DU TABLEAU DES CANDIDATURES *
     *  *************************************/
    CandidatureComponent.prototype.applyFilters = function () {
        var _this = this;
        var defaultFilters = this.getDefaultFilters();
        Object.keys(defaultFilters).forEach(function (filterName) {
            var filterType = Reflect.get(defaultFilters, filterName);
            if (filterType && Object.keys(filterType) && Object.keys(filterType).indexOf('matchMode') > -1) {
                if (filterName !== 'dateSuppression') {
                    var matchMode = Reflect.get(filterType, 'matchMode');
                    var value = _this.getFilterProperty(filterName).value;
                    if (filterName == 'fc') {
                        if (value == false) {
                            var valueAll = ''; // affiche les FC et FI
                            _this.dataTable.filter(valueAll, filterName, matchMode);
                        }
                        else {
                            _this.dataTable.filter(value, filterName, matchMode);
                        }
                    }
                    else {
                        _this.dataTable.filter(value, filterName, matchMode);
                    }
                }
            }
        });
    };
    CandidatureComponent.prototype.getFilterProperty = function (propName) {
        return this.filters[propName];
    };
    CandidatureComponent.prototype.loadListes = function () {
        var _this = this;
        var updates = [
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.AVIS }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.ETAT }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.CONFORME }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.RESULTAT }),
            this.grhumService.queryComposant({
                type: cadens_constants_1.CONSTANTS.MENTION, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.grhumService.queryComposant({
                type: cadens_constants_1.CONSTANTS.PARCOURS, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.formationService.queryDisciplinesFormations({
                niveau: 1, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.commissionService.query(),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.TYPE_EI }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.DISCIPLINE_ECH_INT }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.COMMENTAIRE }),
            this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.STATUT_ENSCOL })
        ];
        Rx_1.Observable.forkJoin(updates).subscribe(function (results) {
            _this.avisList = _this.listeChoixService.toLabelValue(results[0].json());
            _this.statutList = _this.listeChoixService.toLabelValue(results[1].json());
            _this.conformeList = _this.listeChoixService.toLabelValue(results[2].json());
            _this.responseList = _this.listeChoixService.toLabelValue(results[3].json());
            _this.mentionList = _this.grhumService.composantToLabelValue(results[4].json());
            _this.parcoursList = _this.grhumService.composantToLabelValue(results[5].json());
            _this.disciplineList = _this.grhumService.disciplineToLabelValue(results[6].json());
            _this.commissionList = _this.commissionService.toOrderedLabelValue(results[7].json());
            _this.toutesLesCommissions = results[7].json();
            _this.typeEIList = _this.listeChoixService.toLabelValueInteger(results[8].json());
            _this.disciplineMajeureList = _this.listeChoixService.toLabelValue(results[9].json());
            _this.listeCommentaires = _this.listeChoixService.toLabelValue(results[10].json());
            _this.statutEnscolList = _this.listeChoixService.toLabelLabel(results[11].json());
            // this.listeEchelons = this.listeChoixService.toLabelValue(results[12].json());
            _this.loadAll();
        }, function (error) { return _this.newOnError(error); });
    };
    // Le filtre sur dateSuppression est fait en rappelant le serveur
    CandidatureComponent.prototype.onChangeSuppressionFilter = function () {
        this.isLoading = true;
        this.loadAll();
    };
    // Récupération des filtres enregistrés sur le Local Storage, ou alors des filtres par défaut
    CandidatureComponent.prototype.getDefaultFilters = function () {
        return {
            dateSuppression: { matchMode: 'equals', value: true },
            dateValidation: { matchMode: 'notNull', value: !this.isOnlyResponsableFormation },
            fc: { matchMode: 'equals', value: false },
            ei: { matchMode: 'in', value: [] },
            avis: { matchMode: 'in', value: [] },
            libelle: { matchMode: 'in', value: [] },
            mentionId: { matchMode: 'in', value: [] },
            parcoursId: { matchMode: 'in', value: [] },
            niveauId: { matchMode: 'in', value: [] },
            disciplineId: { matchMode: 'in', value: [] },
            commissionId: { matchMode: 'in', value: [] },
            response: { matchMode: 'in', value: [] },
            statut: { matchMode: 'in', value: [] },
            statutEnscol: { matchMode: 'in', value: [] },
            selectedColumns: ['id', 'libelle', 'civilite', 'candidat', 'statut'],
            sortField: null,
            sortOrder: null,
            searchText: null,
            rowPerPage: 20
        };
    };
    CandidatureComponent.prototype.getLocalStorageFilterName = function () {
        return 'cadensFilters' + (this.reinscription ? 'reinscr' : '');
    };
    // Chargement de toutes les dropdown des filtres de recherche
    CandidatureComponent.prototype.resetLastFilters = function () {
        var _this = this;
        var lastFilters = this.getDefaultFilters();
        var localFilters = null;
        try {
            localFilters = this.localStorage.retrieve(this.getLocalStorageFilterName());
        }
        catch (e) {
            this.localStorage.clear(this.getLocalStorageFilterName());
        }
        if (localFilters != null) {
            for (var prop in lastFilters) {
                if (localFilters.hasOwnProperty(prop)) {
                    lastFilters[prop] = localFilters[prop];
                }
            }
            if (localFilters.hasOwnProperty('searchText')) {
                lastFilters['searchText'] = localFilters['searchText'];
            }
            if (localFilters.hasOwnProperty('rowPerPage')) {
                lastFilters['rowPerPage'] = localFilters['rowPerPage'];
            }
            //si il y a des colonnes dans les filtres mémorisés qui n'existent pas dans la liste actuelle on reset les filtres
            if (lastFilters.selectedColumns.filter(function (selectedColumn) {
                return _this.cols.filter(function (col) { return col.value === selectedColumn; }).length === 0;
            }).length > 0) {
                lastFilters = this.getDefaultFilters();
            }
        }
        this.filters = lastFilters;
        if (this.filters.hasOwnProperty('searchText')) {
            this.searchText = this.getFilterProperty('searchText');
        }
        this.rowPerPage = this.getFilterProperty('rowPerPage');
        this.selectedColumns = this.getFilterProperty('selectedColumns');
    };
    // Enregistrer les filtres de recherche dans le Local Storage
    CandidatureComponent.prototype.saveFilters = function () {
        var filtersToSave = {};
        Object.assign(filtersToSave, this.filters);
        filtersToSave.sortField = this.dataTable.sortField;
        filtersToSave.sortOrder = this.dataTable.sortOrder;
        filtersToSave.searchText = this.searchText;
        filtersToSave.rowPerPage = this.dataTable.rows != null ? this.dataTable.rows : 20;
        this.localStorage.clear(this.getLocalStorageFilterName());
        this.localStorage.store(this.getLocalStorageFilterName(), filtersToSave);
    };
    // Bouton Reset RAZ ou pas des filtres de recherche
    CandidatureComponent.prototype.resetFilters = function (raz) {
        this.isLoading = true;
        var previousDateSupp = this.getFilterProperty('dateSuppression');
        if (raz) {
            this.filters = this.getDefaultFilters();
            this.rowPerPage = this.getFilterProperty('rowPerPage');
            this.selectedColumns = this.getFilterProperty('selectedColumns');
            if (this.filters.hasOwnProperty('searchText')) {
                this.searchText = this.getFilterProperty('searchText');
            }
        }
        else {
            this.resetLastFilters();
        }
        if (previousDateSupp !== this.getFilterProperty('dateSuppression')) {
            this.loadAll();
        }
        else {
            this.isLoading = false;
            this.applyFilters();
        }
    };
    CandidatureComponent.prototype.onChangeFC = function (event) {
        this.filters.fc.value = event.target.checked;
        this.applyFilters();
    };
    CandidatureComponent.prototype.onChangeDateValidation = function (event) {
        this.filters.dateValidation.value = event.target.checked;
        this.applyFilters();
    };
    CandidatureComponent.prototype.getDisciplineMajeurLibelle = function (code) {
        if (this.disciplineMajeureList != null && code != null && code.length > 0) {
            var choix = this.disciplineMajeureList.find(function (choix) { return choix.value == code; });
            if (choix != null) {
                return (choix.label);
            }
            else {
                return (code);
            }
        }
    };
    // noinspection JSMethodCanBeStatic
    CandidatureComponent.prototype.getFilterColor = function (selecteItems) {
        if (selecteItems != null) {
            if (Array.isArray(selecteItems)) {
                if (selecteItems.length > 0) {
                    return 'orange';
                }
            }
            else {
                return 'orange';
            }
        }
        return 'black';
    };
    CandidatureComponent.prototype.onSelectedColumnsChange = function ($event) {
        this.loadQuestionsComplementaires();
    };
    CandidatureComponent.prototype.buildReponseLibelle = function (reponse) {
        return ('[' + this.textTruncate(reponse.question.libelle, 50) + '] ' + reponse.response).replace(/<\/?[^>]+(>|$)/g, "").replace(':', "");
    };
    CandidatureComponent.prototype.verifCandidatureAvantModifReponse = function (selectedCandidatures) {
        var _this = this;
        var verifOk = true;
        selectedCandidatures.forEach(function (candi) {
            if (verifOk) {
                if (candi.statut !== cadens_constants_1.CONSTANTS.FINISHED || candi.dateSuppression !== null) {
                    _this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureNonTransmise', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            }
        });
        return verifOk;
    };
    CandidatureComponent.prototype.verifCandidatureAvantModifAvisPedagogique = function (selectedCandidatures) {
        var _this = this;
        var verifOk = true;
        selectedCandidatures.forEach(function (candi) {
            if (_this.isGestionnaire) {
                if (candi.statut != cadens_constants_1.CONSTANTS.FINISHED &&
                    candi.statut != cadens_constants_1.CONSTANTS.CONFIRMED) {
                    _this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureNonTransmise', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            }
            else {
                if (_this.isResponsableFormation) {
                    var dateLimiteAvis = null;
                    if (candi.commissionId != null) {
                        var commission = _this.toutesLesCommissions.find(function (com) { return com.id == candi.commissionId; });
                        if (commission != null) {
                            dateLimiteAvis = commission.dateLimiteAvis;
                        }
                    }
                    if (candi.statut != cadens_constants_1.CONSTANTS.FINISHED ||
                        (candi.statut === cadens_constants_1.CONSTANTS.FINISHED &&
                            candi.avis != null && dateLimiteAvis != null &&
                            dateLimiteAvis < Date.now())) {
                        _this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureDateAvisTardive', {
                            id: candi.id,
                            libelle: candi.libelle == null ? candi.id : candi.libelle,
                            limite: dateLimiteAvis
                        });
                        verifOk = false;
                    }
                }
                else {
                    _this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureDateAvisDroits', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            }
        });
        return verifOk;
    };
    CandidatureComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    CandidatureComponent.prototype.newOnError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    // Popup Modifier Résultat dans Actions groupées
    CandidatureComponent.prototype.saveResponse = function () {
        var _this = this;
        this.selectedCandidatures.forEach(function (candi) {
            _this.confirmationService.confirm({
                message: _this.translateService.instant('cadensApp.candidature.confirmSave.messagePlusieurs'),
                header: _this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                key: 'actionGroupee',
                accept: function () {
                    _this.candidatureFormationService.updateCandidaturesStatus(_this.selectedCandidatures, { response: _this.resultatSelected }).subscribe(function (res) {
                        _this.responseDialog = false;
                        _this.selectedAction = [];
                        _this.loadAll();
                    }, function (res) {
                        _this.newOnError(res);
                        _this.responseDialog = false;
                    });
                },
            });
        });
    };
    // Popup Modifier Avis dans Actions groupées
    CandidatureComponent.prototype.saveAvis = function () {
        var _this = this;
        this.selectedCandidatures.forEach(function (candi) {
            _this.confirmationService.confirm({
                message: _this.translateService.instant('cadensApp.candidature.confirmSave.messagePlusieurs'),
                header: _this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                key: 'actionGroupee',
                accept: function () {
                    if (_this.avisRang !== null && _this.avisRang !== undefined && _this.avisRang <= 0) {
                        _this.alertService.error('cadensApp.candidature.avisRangDoitEtrePositif');
                        _this.avisDialog = false;
                    }
                    else {
                        var option = {};
                        option.avis = _this.avisSelected;
                        if (_this.avisSelected == cadens_constants_1.CONSTANTS.AWAITING) {
                            option.avisRang = _this.avisRang;
                        }
                        else {
                            if (_this.avisSelected == cadens_constants_1.CONSTANTS.NOTFAVORABLE) {
                                option.commentaire = _this.avisCommentaire;
                            }
                        }
                        _this.candidatureFormationService.updateCandidaturesStatus(_this.selectedCandidatures, option).subscribe(function (res) {
                            _this.avisDialog = false;
                            _this.selectedAction = [];
                            _this.loadAll();
                        }, function (err) {
                            _this.newOnError(err);
                            _this.avisDialog = false;
                        });
                    }
                },
            });
        });
    };
    CandidatureComponent.prototype.loadQuestionsComplementaires = function () {
        var _this = this;
        if (this.reponsesQuestionLoaded == false && this.selectedColumns.indexOf('questionsComplementaires') > -1) {
            this.reponseService.getAllReponsesCandidature().subscribe(function (res) {
                _this.completerCandidatureFormation(res.json());
            }, function (res) { return _this.newOnError(res); });
        }
    };
    CandidatureComponent.prototype.completerCandidatureFormation = function (reponsesJson) {
        var _this = this;
        if (reponsesJson != null) {
            var reponsesJsonCopy_1 = reponsesJson;
            this.allQuestions = [];
            this.candidatures.forEach(function (candidature) {
                if (reponsesJsonCopy_1.hasOwnProperty(candidature.id.toString())) {
                    candidature.reponses = reponsesJsonCopy_1[candidature.id.toString()];
                    candidature.reponses.forEach(function (reponse) {
                        if (!_this.allQuestions.find(function (x) { return x === reponse.question.libelle; })) {
                            _this.allQuestions.push(reponse.question.libelle);
                        }
                    });
                }
            });
            this.reponsesQuestionLoaded = true;
        }
    };
    CandidatureComponent.prototype.controlerIdentite = function (candidatureFormation) {
        this.controlerIdentites([candidatureFormation]);
    };
    CandidatureComponent.prototype.controlerIdentites = function (candidaturesFormation) {
        this.admisService.initCandidatures(candidaturesFormation);
        this.router.navigate(['/admis']);
    };
    return CandidatureComponent;
}());
__decorate([
    core_1.ViewChild('table'),
    __metadata("design:type", datatable_1.DataTable)
], CandidatureComponent.prototype, "dataTable", void 0);
__decorate([
    core_1.ViewChild('searchFilter'),
    __metadata("design:type", core_1.ElementRef)
], CandidatureComponent.prototype, "searchFilter", void 0);
CandidatureComponent = __decorate([
    core_1.Component({
        selector: 'jhi-candidature',
        template: __webpack_require__(420)
    }),
    __param(20, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        candidature_formation_service_1.CandidatureFormationService,
        grhum_1.GrhumService,
        formation_1.FormationService,
        reponse_service_1.ReponseService,
        commission_1.CommissionService,
        ng_jhipster_1.AlertService,
        listeChoix_service_1.ListeChoixService,
        router_1.Router,
        router_1.ActivatedRoute,
        shared_1.ExportService,
        shared_1.Principal,
        ng2_webstorage_1.LocalStorageService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService,
        user_en_echange_1.UserEnEchangeService,
        ng2_page_scroll_1.PageScrollService,
        shared_1.UserService,
        enscol_service_1.EnscolService,
        admis_service_1.AdmisService, Object])
], CandidatureComponent);
exports.CandidatureComponent = CandidatureComponent;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_component_1 = __webpack_require__(132);
var candidature_detail_component_1 = __webpack_require__(130);
var shared_1 = __webpack_require__(2);
var candidature_traitement_dialog_component_1 = __webpack_require__(62);
var CandidatureResolveActionsGroupees = (function () {
    function CandidatureResolveActionsGroupees() {
    }
    CandidatureResolveActionsGroupees.prototype.resolve = function (route, state) {
        var listeCandidatures = route.params['listeCandidatures'] ? route.params['listeCandidatures'] : '';
        var first = listeCandidatures.indexOf(',') > 0 ? listeCandidatures.indexOf(',') : listeCandidatures.length - 1;
        var page = route.params['page'] ? route.params['page'] : listeCandidatures.substring(0, first);
        return {
            page: page,
            listeCandidatures: listeCandidatures
        };
    };
    return CandidatureResolveActionsGroupees;
}());
CandidatureResolveActionsGroupees = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], CandidatureResolveActionsGroupees);
exports.CandidatureResolveActionsGroupees = CandidatureResolveActionsGroupees;
exports.candidatureRoutes = [
    { path: 'candidature',
        component: candidature_component_1.CandidatureComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
            pageTitle: 'cadensApp.candidature.home.title',
            reinscription: false
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'candidature-back/:id',
        component: candidature_component_1.CandidatureComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
            pageTitle: 'cadensApp.candidature.home.title',
            reinscription: false
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    { path: 'reinscription',
        component: candidature_component_1.CandidatureComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
            pageTitle: 'cadensApp.candidature.home.title',
            reinscription: true
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'candidature/:id',
        component: candidature_detail_component_1.CandidatureDetailComponent,
        resolve: {
            'pagingParams': CandidatureResolveActionsGroupees
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'candidature/:id/:userId',
        component: candidature_detail_component_1.CandidatureDetailComponent,
        resolve: {
            'pagingParams': CandidatureResolveActionsGroupees
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'reinscription/:id',
        component: candidature_detail_component_1.CandidatureDetailComponent,
        resolve: {
            'pagingParams': CandidatureResolveActionsGroupees
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'reinscription/:id/:userId',
        component: candidature_detail_component_1.CandidatureDetailComponent,
        resolve: {
            'pagingParams': CandidatureResolveActionsGroupees
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.candidaturePopupRoute = [
    {
        path: 'candidature-traitement/:id',
        component: candidature_traitement_dialog_component_1.CandidatureTraitementPopupComponent,
        data: {
            authorities: ['ROLE_GEST', 'ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var CandidatureService = CandidatureService_1 = (function () {
    function CandidatureService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/candidatures';
    }
    CandidatureService.prototype.create = function (candidature) {
        var _this = this;
        var copy = Object.assign({}, candidature);
        if (candidature.dateNaissance != null && candidature.dateNaissance.getDate()) {
            copy.dateNaissance = new Date(Date.UTC(candidature.dateNaissance.getFullYear(), candidature.dateNaissance.getMonth(), candidature.dateNaissance.getDate()));
        }
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateNaissance = _this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    };
    CandidatureService.prototype.update = function (candidature) {
        var _this = this;
        var copy = Object.assign({}, candidature);
        if (candidature.dateNaissance != null && candidature.dateNaissance.getDate()) {
            copy.dateNaissance = new Date(Date.UTC(candidature.dateNaissance.getFullYear(), candidature.dateNaissance.getMonth(), candidature.dateNaissance.getDate()));
        }
        if (CandidatureService_1.empty(copy.paysNationalite))
            copy.paysNationalite = null;
        if (CandidatureService_1.empty(copy.paysNaissance))
            copy.paysNaissance = null;
        if (CandidatureService_1.empty(copy.deptNaissance))
            copy.deptNaissance = null;
        if (CandidatureService_1.empty(copy.bacPays))
            copy.bacPays = null;
        if (CandidatureService_1.empty(copy.bacDept))
            copy.bacDept = null;
        if (CandidatureService_1.empty(copy.bacVille))
            copy.bacVille = null;
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateNaissance = _this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    };
    CandidatureService.empty = function (stringValue) {
        return typeof stringValue == 'undefined' || !stringValue || stringValue.length == 0;
    };
    CandidatureService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateNaissance = _this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    };
    CandidatureService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    CandidatureService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CandidatureService.copyCandidature = function (candidature, toCopy) {
        candidature.bac = toCopy.bac;
        candidature.bacAnnee = toCopy.bacAnnee;
        candidature.bacDept = toCopy.bacDept;
        candidature.bacEtab = toCopy.bacEtab;
        candidature.bacEtablissementAutre = toCopy.bacEtablissementAutre;
        candidature.bacMention = toCopy.bacMention;
        candidature.bacPays = toCopy.bacPays;
        candidature.bacVille = toCopy.bacVille;
        candidature.bacTypeEtablissement = toCopy.bacTypeEtablissement;
        candidature.telephoneFixe = toCopy.telephoneFixe;
        candidature.telephonePortable = toCopy.telephonePortable;
        candidature.paysNaissance = toCopy.paysNaissance;
        candidature.paysNationalite = toCopy.paysNationalite;
        candidature.paysNationalite2 = toCopy.paysNationalite2;
        candidature.deptNaissance = toCopy.deptNaissance;
        candidature.villeNaissance = toCopy.villeNaissance;
        candidature.ines = toCopy.ines;
        candidature.bourse = toCopy.bourse;
        candidature.echelon = toCopy.echelon;
        candidature.bourseExcellence = toCopy.bourseExcellence;
        candidature.indicBourseExcellence = toCopy.indicBourseExcellence;
        candidature.bacSpec1LibelleCourt = toCopy.bacSpec1LibelleCourt;
        candidature.bacSpec2LibelleCourt = toCopy.bacSpec2LibelleCourt;
        return candidature;
    };
    CandidatureService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateNaissance = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].dateNaissance);
        }
        res._body = jsonResponse;
        return res;
    };
    CandidatureService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return CandidatureService;
}());
CandidatureService = CandidatureService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], CandidatureService);
exports.CandidatureService = CandidatureService;
var CandidatureService_1;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_model_1 = __webpack_require__(42);
var calendar_constants_1 = __webpack_require__(15);
var grhum_1 = __webpack_require__(13);
// noinspection TypeScriptPreferShortImport
var adresse_model_1 = __webpack_require__(60);
var candidature_formation_model_1 = __webpack_require__(12);
// noinspection TypeScriptPreferShortImport
var adresse_service_1 = __webpack_require__(41);
var CiviliteComponent = (function () {
    function CiviliteComponent(grhumService, adresseService) {
        this.grhumService = grhumService;
        this.adresseService = adresseService;
        this.adresseChange = new core_1.EventEmitter();
    }
    CiviliteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        if (!this.adresse || this.adresse.candidatureId == null) {
            this.adresse = new adresse_model_1.Adresse();
            // Préremplir l'adresse avec la dernière candidature créée, si existe
            this.adresseService.query({ userId: this.candidatureFormation.userId }).subscribe(function (res) {
                var adresses = res.json();
                if (adresses != null && adresses.length > 0) {
                    _this.adresse = adresses[0];
                }
                _this.adresse.id = null;
                _this.adresse.candidatureId = _this.candidature.id;
                _this.adresseChange.emit(_this.adresse);
            }, function (res) {
                _this.adresse.candidatureId = _this.candidature.id;
                _this.adresseChange.emit(_this.adresse);
            });
        }
        if (this.candidatureFormation.reinscription) {
            this.isEditable = false;
        }
    };
    CiviliteComponent.prototype.onChangeCodePostal = function () {
        var _this = this;
        if (this.adresse.codePostal && this.adresse.codePostal !== '') {
            this.grhumService.queryCommune({ codePostal: this.adresse.codePostal }).subscribe(function (res) {
                _this.villesAdresse = res.json();
                _this.adresse.ville = null;
            });
        }
        else {
            this.villesAdresse = [];
        }
        this.adresseChange.emit(this.adresse);
    };
    return CiviliteComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_model_1.Candidature)
], CiviliteComponent.prototype, "candidature", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], CiviliteComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", adresse_model_1.Adresse)
], CiviliteComponent.prototype, "adresse", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CiviliteComponent.prototype, "adresseChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CiviliteComponent.prototype, "paysListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CiviliteComponent.prototype, "deptListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CiviliteComponent.prototype, "isEditable", void 0);
CiviliteComponent = __decorate([
    core_1.Component({
        selector: 'jhi-civilite-component',
        template: __webpack_require__(421)
    }),
    __metadata("design:paramtypes", [grhum_1.GrhumService,
        adresse_service_1.AdresseService])
], CiviliteComponent);
exports.CiviliteComponent = CiviliteComponent;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var grhum_1 = __webpack_require__(13);
var candidature_formation_model_1 = __webpack_require__(12);
var cadens_constants_1 = __webpack_require__(8);
var parametrage_1 = __webpack_require__(11);
var ng_jhipster_1 = __webpack_require__(1);
var ConfirmationComponent = (function () {
    function ConfirmationComponent(parametrageService, grhumService, jhiLanguageService) {
        this.parametrageService = parametrageService;
        this.grhumService = grhumService;
        this.jhiLanguageService = jhiLanguageService;
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    ConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.CONFIRMATION }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        if (this.candidatureFormation.mentionId) {
            this.grhumService.findComposant(this.candidatureFormation.mentionId).subscribe(function (res) {
                var json = res.json();
                _this.mention = json.llComposant;
            });
        }
        if (this.candidatureFormation.parcoursId) {
            this.grhumService.findComposant(this.candidatureFormation.parcoursId).subscribe(function (res) {
                var json = res.json();
                _this.parcours = json.llComposant;
            });
        }
        if (this.candidatureFormation.niveauId) {
            this.grhumService.findComposant(this.candidatureFormation.niveauId).subscribe(function (res) {
                var json = res.json();
                _this.niveau = json.llComposant;
            });
        }
        if (this.candidatureFormation.disciplineId) {
            this.grhumService.findDiscipline(this.candidatureFormation.disciplineId).subscribe(function (res) {
                var json = res.json();
                _this.discipline = json.llDiscipline;
            });
        }
    };
    // noinspection JSMethodCanBeStatic
    ConfirmationComponent.prototype.escapeParam = function (param) {
        if (param != null) {
            return (param.replace(/'/g, ' '));
        }
        return param;
    };
    return ConfirmationComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], ConfirmationComponent.prototype, "candidatureFormation", void 0);
ConfirmationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-confirmation-component',
        template: __webpack_require__(422)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        grhum_1.GrhumService,
        ng_jhipster_1.JhiLanguageService])
], ConfirmationComponent);
exports.ConfirmationComponent = ConfirmationComponent;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Cours = (function () {
    function Cours(id, candidatureFormationId, code, libelle, ects, index) {
        this.id = id;
        this.candidatureFormationId = candidatureFormationId;
        this.code = code;
        this.libelle = libelle;
        this.ects = ects;
        this.index = index;
    }
    return Cours;
}());
exports.Cours = Cours;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var CoursService = CoursService_1 = (function () {
    function CoursService(http) {
        this.http = http;
        this.resourceUrl = 'api/cours';
    }
    CoursService.convertResponse = function (res) {
        res._body = res.json();
        return res;
    };
    CoursService.prototype.create = function (cours) {
        var copy = Object.assign({}, cours);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CoursService.prototype.update = function (cours) {
        var copy = [];
        cours.forEach(function (c) {
            copy.push(c);
        });
        if (copy != null && copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map(function (res) {
                return res.json();
            });
        }
        return null;
    };
    CoursService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    CoursService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return CoursService_1.convertResponse(res); });
    };
    CoursService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CoursService.prototype.isCoursEmpty = function (listeCours) {
        var filtered = listeCours.filter(function (cours) { return !(cours.code !== undefined && cours.code.length > 0 && cours.libelle !== undefined && cours.libelle.length > 0); });
        return filtered.length > 0;
    };
    CoursService.prototype.isCoursExistant = function (listeCours) {
        var filtered = listeCours.filter(function (cours) { return !(cours.libelle !== undefined && cours.libelle.length > 0); });
        return filtered.length > 0;
    };
    CoursService.prototype.isCoursDuplique = function (listeCours) {
        return this.checkDuplicateInObject('code', listeCours);
    };
    CoursService.prototype.checkDuplicateInObject = function (propertyName, inputArray) {
        var seenDuplicate = false, testObject = {};
        inputArray.map(function (item) {
            var itemPropertyName = item[propertyName];
            if (itemPropertyName in testObject) {
                testObject[itemPropertyName].duplicate = true;
                item.duplicate = true;
                seenDuplicate = true;
            }
            else {
                testObject[itemPropertyName] = item;
                delete item.duplicate;
            }
        });
        return seenDuplicate;
    };
    return CoursService;
}());
CoursService = CoursService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], CoursService);
exports.CoursService = CoursService;
var CoursService_1;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Cursus = (function () {
    function Cursus(id, dateDebut, dateFin, interruption, motif, titreDiplomePrepare, mentionAutre, anneeSanctionnee, intituleDiplome, dateObtentionDiplome, dateCreation, dateModification, candidatureId, etablissement, etablissementAutre, mention, pays, dept, ville, gradeUniversitaireId, typeFormationId, niveauAccesDiplomeId) {
        this.id = id;
        this.dateDebut = dateDebut;
        this.dateFin = dateFin;
        this.interruption = interruption;
        this.motif = motif;
        this.titreDiplomePrepare = titreDiplomePrepare;
        this.mentionAutre = mentionAutre;
        this.anneeSanctionnee = anneeSanctionnee;
        this.intituleDiplome = intituleDiplome;
        this.dateObtentionDiplome = dateObtentionDiplome;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
        this.candidatureId = candidatureId;
        this.etablissement = etablissement;
        this.etablissementAutre = etablissementAutre;
        this.mention = mention;
        this.pays = pays;
        this.dept = dept;
        this.ville = ville;
        this.gradeUniversitaireId = gradeUniversitaireId;
        this.typeFormationId = typeFormationId;
        this.niveauAccesDiplomeId = niveauAccesDiplomeId;
    }
    return Cursus;
}());
exports.Cursus = Cursus;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var EnscolService = (function () {
    function EnscolService(http) {
        this.http = http;
        this.resourceStatutUrl = 'api/enscolStatut';
        this.resourceInscriptionsUrl = 'api/enscolInscriptions';
    }
    EnscolService.prototype.buildSearchParams = function (pers_id) {
        var params = new http_1.URLSearchParams();
        params.set('pers_id', pers_id);
        return params;
    };
    EnscolService.prototype.getInscriptions = function (pers_id) {
        return this.http.get(this.resourceInscriptionsUrl, { search: this.buildSearchParams(pers_id) })
            .map(function (res) { return res.json(); });
    };
    EnscolService.prototype.getStatut = function (pers_id) {
        return this.http.get(this.resourceStatutUrl, { search: this.buildSearchParams(pers_id) }).map(function (res) { return res._body; });
    };
    return EnscolService;
}());
EnscolService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], EnscolService);
exports.EnscolService = EnscolService;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var parametrage_1 = __webpack_require__(11);
var cadens_constants_1 = __webpack_require__(8);
var grhum_1 = __webpack_require__(13);
var formation_1 = __webpack_require__(9);
var formationComponent_service_1 = __webpack_require__(22);
var CpesComponent = (function () {
    function CpesComponent(parametrageService, grhumService, formationService, formationComponentService) {
        this.parametrageService = parametrageService;
        this.grhumService = grhumService;
        this.formationService = formationService;
        this.formationComponentService = formationComponentService;
        this.candidatureFormation = {};
        this.filterByParcours = false;
        this.constants = cadens_constants_1.CONSTANTS;
        this.isSaving = false;
        this.isGradeLicence = false;
    }
    CpesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.CPES }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        // Chargement des listes de Mentions, parcours & niveaux
        this.getListeMentions(this.candidatureFormation.parcoursId);
        this.getListeParcours(this.candidatureFormation.mentionId);
        if (this.candidatureFormation.parcoursId) {
            this.getListeNiveaux(this.candidatureFormation.parcoursId);
        }
        if (this.candidatureFormation.ei != this.constants.NON_CONCERNE) {
            this.candidatureFormation.fc = false;
        }
    };
    CpesComponent.prototype.onChangeMention = function (newMention) {
        var _this = this;
        this.isGradeLicence = false;
        if (typeof newMention === 'string') {
            newMention = null;
            this.candidatureFormation.mentionId = null;
        }
        if (this.candidatureFormation.mentionId) {
            var composantMention = this.mentionsListe.filter(function (value) { return value.idComposant === _this.candidatureFormation.mentionId; });
            if (composantMention) {
                this.isGradeLicence = composantMention[0].grade === 1;
            }
        }
        this.candidatureFormation.formationId = null;
        if (this.filterByParcours && this.candidatureFormation.niveauId !== null) {
            this.findFormation(this.candidatureFormation.niveauId);
        }
        if (!this.filterByParcours || this.candidatureFormation.parcoursId == null) {
            this.niveauxListe = [];
            this.getListeParcours(newMention);
            if (newMention == null) {
                this.getListeMentions(this.candidatureFormation.formationId);
            }
            this.filterByParcours = false;
        }
    };
    CpesComponent.prototype.onChangeParcours = function (newParcours) {
        if (typeof newParcours === 'string') {
            newParcours = null;
            this.candidatureFormation.parcoursId = null;
        }
        this.candidatureFormation.formationId = null;
        this.candidatureFormation.niveauId = null;
        this.niveauxListe = [];
        this.getListeNiveaux(newParcours);
        if (this.candidatureFormation.mentionId == null || this.filterByParcours) {
            this.filterByParcours = true;
            this.getListeMentions(newParcours);
        }
        else {
            this.filterByParcours = false;
        }
    };
    // Once candidat has choosen Master + Parcours + Niveau, get the corresponding formation id
    CpesComponent.prototype.findFormation = function (newNiveau) {
        var _this = this;
        if (newNiveau == null || typeof newNiveau === 'string') {
            this.candidatureFormation.formationId = null;
            this.candidatureFormation.niveauId = null;
            newNiveau = null;
        }
        if (this.candidatureFormation.mentionId && this.candidatureFormation.niveauId && this.candidatureFormation.parcoursId) {
            this.isSaving = true;
            this.formationService.query({
                mentionId: this.candidatureFormation.mentionId,
                parcoursId: this.candidatureFormation.parcoursId,
                niveauId: newNiveau
            }).subscribe(function (res) {
                var formation = res.json();
                _this.candidatureFormation.formationId = formation[0].id;
                _this.candidatureFormation.libelle = formation[0].libelle;
                _this.formationComponentService.changeFormation(_this.candidatureFormation.formationId);
                _this.isSaving = false;
            }, function (res) {
                _this.isSaving = false;
            });
        }
    };
    CpesComponent.prototype.selectionFormationContinue = function (fc) {
        this.formationComponentService.changeFc(fc);
    };
    CpesComponent.prototype.getListeMentions = function (parcoursId) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.MENTION,
            typeCampagne: cadens_constants_1.CONSTANTS.CPES,
            childId: parcoursId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.mentionsListe = res.json();
            if (_this.mentionsListe != null && _this.mentionsListe.length === 1) {
                _this.candidatureFormation.mentionId = _this.mentionsListe[0].idComposant;
                _this.isGradeLicence = _this.mentionsListe[0].grade === 1;
                if (_this.candidatureFormation.parcoursId == null) {
                    _this.getListeParcours(_this.candidatureFormation.mentionId);
                }
                else {
                    _this.getListeNiveaux(_this.candidatureFormation.parcoursId);
                }
            }
        });
    };
    CpesComponent.prototype.getListeParcours = function (mention) {
        var _this = this;
        var copyParcours = this.candidatureFormation.parcoursId;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.PARCOURS,
            typeCampagne: cadens_constants_1.CONSTANTS.CPES,
            parentId: mention,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.parcoursListe = res.json();
            if (mention == null) {
                _this.candidatureFormation.parcoursId = copyParcours;
            }
            if (_this.parcoursListe != null && _this.parcoursListe.length === 1) {
                _this.candidatureFormation.parcoursId = _this.parcoursListe[0].idComposant;
                _this.getListeNiveaux(_this.candidatureFormation.parcoursId);
            }
        });
    };
    CpesComponent.prototype.getListeNiveaux = function (parcours) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.NIVEAU,
            typeCampagne: cadens_constants_1.CONSTANTS.CPES,
            parentId: parcours,
            mentionId: this.candidatureFormation.mentionId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.niveauxListe = res.json();
            if (_this.niveauxListe != null && _this.niveauxListe.length === 1) {
                _this.candidatureFormation.niveauId = _this.niveauxListe[0].idComposant;
                _this.findFormation(_this.candidatureFormation.niveauId);
            }
        });
    };
    return CpesComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], CpesComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CpesComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CpesComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CpesComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CpesComponent.prototype, "isBO", void 0);
CpesComponent = __decorate([
    core_1.Component({
        selector: 'jhi-cpes-component',
        template: __webpack_require__(423)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        grhum_1.GrhumService,
        formation_1.FormationService,
        formationComponent_service_1.FormationComponentService])
], CpesComponent);
exports.CpesComponent = CpesComponent;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var formation_service_1 = __webpack_require__(25);
var parametrage_service_1 = __webpack_require__(75);
var cadens_constants_1 = __webpack_require__(8);
var formationComponent_service_1 = __webpack_require__(22);
var AutresFormationsComponent = (function () {
    function AutresFormationsComponent(parametrageService, formationService, formationComponentService) {
        this.parametrageService = parametrageService;
        this.formationService = formationService;
        this.formationComponentService = formationComponentService;
        this.candidatureFormation = {};
        this.libelle = [];
        this.isLoading = true;
        this.constantes = cadens_constants_1.CONSTANTS;
    }
    AutresFormationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.AUTRES }).subscribe(function (res) {
            var parametrage = res.json();
            parametrage.forEach(function (form) {
                var code = form.code.replace('_INFORMATIONS', '');
                _this.libelle[code] = form.libelle;
            });
            _this.isLoading = false;
        });
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.INTERNATIONAL }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.getListeAutresFormations();
    };
    AutresFormationsComponent.prototype.changeFormation = function (formationId, libelle) {
        this.candidatureFormation.libelle = libelle;
        this.formationComponentService.changeFormation(formationId);
    };
    AutresFormationsComponent.prototype.getListeAutresFormations = function () {
        var _this = this;
        this.formationService.queryAutresFormations({ reinscription: this.candidatureFormation.reinscription,
            lecture: (this.isBO > 0 || !this.isEditable) }).subscribe(function (res) {
            _this.autresListe = res.json();
        });
    };
    return AutresFormationsComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], AutresFormationsComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], AutresFormationsComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], AutresFormationsComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], AutresFormationsComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AutresFormationsComponent.prototype, "currentLang", void 0);
AutresFormationsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-autres-formations-component',
        template: __webpack_require__(424)
    }),
    __metadata("design:paramtypes", [parametrage_service_1.ParametrageService, formation_service_1.FormationService,
        formationComponent_service_1.FormationComponentService])
], AutresFormationsComponent);
exports.AutresFormationsComponent = AutresFormationsComponent;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var formation_1 = __webpack_require__(9);
var grhum_1 = __webpack_require__(13);
var parametrage_1 = __webpack_require__(11);
var cadens_constants_1 = __webpack_require__(8);
var ng_jhipster_1 = __webpack_require__(1);
var formationComponent_service_1 = __webpack_require__(22);
var ng_bootstrap_1 = __webpack_require__(5);
var DiplomeComponent = (function () {
    function DiplomeComponent(parametrageService, grhumService, jhiLanguageService, formationService, modalService, formationComponentService) {
        this.parametrageService = parametrageService;
        this.grhumService = grhumService;
        this.jhiLanguageService = jhiLanguageService;
        this.formationService = formationService;
        this.modalService = modalService;
        this.formationComponentService = formationComponentService;
        this.candidatureFormation = {};
        this.btnActivation = new core_1.EventEmitter();
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    DiplomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.DIPLOME }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.niveauxListe = [];
        this.parcoursListe = [];
        if (this.candidatureFormation.parcoursId) {
            this.annee = 2;
            this.getListeParcours(this.candidatureFormation.disciplineId);
            this.getListeNiveaux(this.candidatureFormation.parcoursId);
        }
        else if (this.candidatureFormation.disciplineId) {
            if (this.candidatureFormation.ects === 180) {
                this.annee = 1;
            }
            this.getListeStructure(this.candidatureFormation.disciplineId);
        }
        this.getListeDisciplines();
    };
    DiplomeComponent.prototype.onChangeEcts = function (newEcts) {
        this.annee = null;
        this.cleanInfos();
    };
    DiplomeComponent.prototype.onChangeParcours = function (newParcours) {
        // Appelé à chaque fois que la mention change: recharger la liste des niveaux
        this.getListeNiveaux(newParcours);
    };
    DiplomeComponent.prototype.onChangeAnnee = function (newAnnee) {
        this.cleanInfos();
    };
    DiplomeComponent.prototype.onChangeDiscipline = function (newDiscipline) {
        var _this = this;
        this.candidatureFormation.disciplineId = newDiscipline;
        if (this.annee === 2) {
            this.getListeParcours(newDiscipline);
            this.candidatureFormation.parcoursId = null;
            this.candidatureFormation.niveauId = null;
        }
        else {
            // select le département de la discipline
            this.getListeStructure(newDiscipline);
            // Get la formation correspondant à la discipline
            this.isSaving = true;
            this.formationService.query({ disciplineId: newDiscipline }).subscribe(function (res) {
                var formation = res.json();
                formation = formation.filter(function (forma) { return forma.id != cadens_constants_1.CONSTANTS.DOUBLE_CURSUS_ID && forma.id != cadens_constants_1.CONSTANTS.DOUBLE_CURSUS_HUMANITES_ID && forma.id != cadens_constants_1.CONSTANTS.PROGRAMME_EM_LYON_ID; });
                _this.candidatureFormation.formationId = formation[0].id;
                _this.candidatureFormation.libelle = formation[0].libelle;
                _this.formationComponentService.changeFormation(_this.candidatureFormation.formationId);
                _this.isSaving = false;
            }, function (res) {
                _this.isSaving = false;
            });
            this.niveauxListe = [];
            this.parcoursListe = [];
            this.findDisciplineLibelle();
        }
    };
    DiplomeComponent.prototype.findFormation = function (newNiveau) {
        var _this = this;
        this.isSaving = true;
        this.formationService.query({
            disciplineId: this.candidatureFormation.disciplineId,
            parcoursId: this.candidatureFormation.parcoursId, niveauId: newNiveau
        }).subscribe(function (res) {
            var formation = res.json();
            formation = formation.filter(function (forma) { return forma.id != cadens_constants_1.CONSTANTS.DOUBLE_CURSUS_ID && forma.id != cadens_constants_1.CONSTANTS.DOUBLE_CURSUS_HUMANITES_ID && forma.id != cadens_constants_1.CONSTANTS.PROGRAMME_EM_LYON_ID; });
            _this.candidatureFormation.formationId = formation[0].id;
            _this.candidatureFormation.libelle = formation[0].libelle;
            _this.formationComponentService.changeFormation(_this.candidatureFormation.formationId);
            _this.isSaving = false;
        }, function (res) {
            _this.isSaving = false;
        });
    };
    // Open la popup d'aide
    DiplomeComponent.prototype.openAide = function (aideModal, parametre) {
        this.aide = parametre;
        this.modalService.open(aideModal);
    };
    DiplomeComponent.prototype.getListeDisciplines = function () {
        var _this = this;
        if (!this.disciplinesListe) {
            this.formationService.queryDisciplinesFormations({
                niveau: 1, reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            })
                .subscribe(function (res) {
                _this.disciplinesListe = res.json();
                _this.findDisciplineLibelle();
            });
        }
        if (!this.disciplinesParcoursListe) {
            this.formationService.queryDisciplinesFormations({
                niveau: 2, reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            })
                .subscribe(function (res) {
                _this.disciplinesParcoursListe = res.json();
            });
        }
    };
    DiplomeComponent.prototype.getListeParcours = function (disciplineId) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.PARCOURS, disciplineId: disciplineId,
            reinscription: this.candidatureFormation.reinscription, lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.parcoursListe = res.json();
        });
    };
    DiplomeComponent.prototype.getListeNiveaux = function (parcours) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.NIVEAU,
            parentId: parcours,
            disciplineId: this.candidatureFormation.disciplineId,
            reinscription: this.candidatureFormation.reinscription,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.niveauxListe = res.json();
            if (_this.niveauxListe != null && _this.niveauxListe.length === 1) {
                _this.candidatureFormation.niveauId = _this.niveauxListe[0].idComposant;
                _this.findFormation(_this.candidatureFormation.niveauId);
            }
        });
    };
    DiplomeComponent.prototype.getListeStructure = function (disciplineId) {
        var _this = this;
        this.grhumService.queryStructure({ disciplineId: disciplineId }).subscribe(function (res) {
            var structures = res.json();
            if (structures && structures.length > 0) {
                _this.departement = structures[0].libelle;
            }
        });
    };
    DiplomeComponent.prototype.cleanInfos = function () {
        this.niveauxListe = [];
        this.parcoursListe = [];
        this.departement = '';
        this.candidatureFormation.disciplineId = null;
        this.candidatureFormation.discipline = null;
        this.candidatureFormation.parcoursId = null;
        this.candidatureFormation.niveauId = null;
        this.candidatureFormation.formationId = null;
        this.candidatureFormation.libelle = null;
    };
    DiplomeComponent.prototype.findDisciplineLibelle = function () {
        var _this = this;
        if (this.disciplinesListe != null && this.candidatureFormation.disciplineId != null) {
            var discipline = this.disciplinesListe.find(function (d) { return d.idDiscipline === _this.candidatureFormation.disciplineId; });
            if (discipline) {
                this.candidatureFormation.discipline = discipline.llDiscipline;
            }
        }
    };
    DiplomeComponent.prototype.clickBoutonQuestion = function (buttonAction) {
        this.btnActivation.emit({ value: buttonAction });
    };
    return DiplomeComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], DiplomeComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DiplomeComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DiplomeComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DiplomeComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DiplomeComponent.prototype, "btnActivation", void 0);
DiplomeComponent = __decorate([
    core_1.Component({
        selector: 'jhi-diplome-component',
        template: __webpack_require__(425)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        grhum_1.GrhumService,
        ng_jhipster_1.JhiLanguageService,
        formation_1.FormationService,
        ng_bootstrap_1.NgbModal,
        formationComponent_service_1.FormationComponentService])
], DiplomeComponent);
exports.DiplomeComponent = DiplomeComponent;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var cadens_constants_1 = __webpack_require__(8);
var formation_1 = __webpack_require__(9);
var rxjs_1 = __webpack_require__(14);
var reponse_service_1 = __webpack_require__(28);
var user_en_echange_1 = __webpack_require__(21);
var formationComponent_service_1 = __webpack_require__(22);
var shared_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var FormationComponent = (function () {
    function FormationComponent(categorieFormationService, questionService, reponseService, userEnEchangeService, principal, formationComponentService, alertService) {
        var _this = this;
        this.categorieFormationService = categorieFormationService;
        this.questionService = questionService;
        this.reponseService = reponseService;
        this.userEnEchangeService = userEnEchangeService;
        this.principal = principal;
        this.formationComponentService = formationComponentService;
        this.alertService = alertService;
        this.candidatureFormation = {};
        this.questionsChange = new core_1.EventEmitter();
        this.desCategoriesFormationDisponiblesChange = new core_1.EventEmitter();
        this.constants = cadens_constants_1.CONSTANTS;
        this.codesMONO = [
            'Biologie', 'Mathématiques', 'Chimie, physique', 'Sciences de la terre', 'Informatique'
        ];
        formationComponentService.formationChanged$.subscribe(function (formationId) {
            _this.candidatureFormation.formationId = formationId;
            _this.getListeQuestions();
            // this.principal.identity().then(account=> this.userId=account) ;
        });
        formationComponentService.fcChanged$.subscribe(function (fc) {
            _this.candidatureFormation.fc = fc;
            _this.getListeQuestions();
            // this.principal.identity().then(account=> this.userId=account) ;
        });
    }
    FormationComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Load la liste des questions complémentaire de la formation et les réponses
        this.getListeQuestions();
        this.userId = this.candidatureFormation.userId;
        // cherche les categories qui sont disponibles pour le candidat selon les critères normal,
        // ou re inscription, ou en echange en international, ou hors echange en international
        var getCategories;
        if (this.isEditable == false) {
            getCategories = this.categorieFormationService.queryDisponibles({
                etudiantId: this.candidatureFormation.userId,
                reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            });
        }
        else {
            getCategories = this.categorieFormationService.queryDisponibles({
                etudiantId: this.candidatureFormation.userId,
                reinscription: this.candidatureFormation.reinscription,
                ei: this.candidatureFormation.ei,
                lecture: (this.isBO > 0 || !this.isEditable)
            });
        }
        // determine si l'utilisateur courant est en echange
        var getUserEchange = this.userEnEchangeService.findByCadensUserId(this.userId);
        rxjs_1.Observable.forkJoin([getCategories, getUserEchange]).subscribe(function (results) {
            _this.categoriesFormation = results[0].json();
            _this.userEnEchange = results[1];
            var categorieFormationFound = true;
            if (_this.categoriesFormation.length > 0) {
                if (_this.categoriesFormation.every(function (categorie) { return categorie.disabled == true; })) {
                    if (_this.isEditable == true) {
                        _this.isEditable = false;
                        categorieFormationFound = false;
                    }
                }
            }
            else {
                categorieFormationFound = false;
            }
            _this.desCategoriesFormationDisponibles = categorieFormationFound;
            _this.desCategoriesFormationDisponiblesChange.emit(categorieFormationFound);
        });
    };
    FormationComponent.prototype.isCategorieDisplayed = function (catCode) {
        var displayed = false;
        if (this.categoriesFormation) {
            var cat = this.categoriesFormation.find(function (categ) { return categ.code == catCode; });
            if (cat) {
                displayed = cat.displayed;
            }
        }
        return (displayed);
    };
    FormationComponent.prototype.chooseFormation = function (categorieFormation) {
        if (this.isEditable) {
            if (this.candidatureFormation.categorieFormation !== categorieFormation) {
                this.candidatureFormation.categorieFormation = categorieFormation;
                this.candidatureFormation.categorieFormationId = this.categoriesFormation.find(function (f) { return f.code == categorieFormation; }).id;
                this.candidatureFormation.mentionId = null;
                this.candidatureFormation.parcoursId = null;
                this.candidatureFormation.discipline = null;
                this.candidatureFormation.niveauId = null;
                this.candidatureFormation.disciplineId = null;
                this.candidatureFormation.formationId = null;
                this.candidatureFormation.ects = null;
                this.candidatureFormation.libelle = null;
                this.candidatureFormation.fc = null;
                this.questions = [];
            }
        }
    };
    FormationComponent.prototype.getListeQuestions = function () {
        var _this = this;
        if (this.candidatureFormation.formationId != null) {
            var queries = [];
            var categorieIdList = [];
            categorieIdList.push(formation_1.CategorieFormation.CategorieFormationIds.GENERAL);
            categorieIdList.push(this.candidatureFormation.categorieFormationId);
            if (this.candidatureFormation.fc === true) {
                categorieIdList.push(formation_1.CategorieFormation.CategorieFormationIds.FC);
            }
            var getQuestions = this.questionService.query({
                interne: this.candidatureFormation.reinscription,
                formationId: this.candidatureFormation.formationId,
                categorieIdList: categorieIdList
            });
            queries.push(getQuestions);
            var getReponses = this.reponseService.query({
                candidatureFormationId: this.candidatureFormation.id
            });
            queries.push(getReponses);
            var getQuestionsFc = null;
            this.isLoading = true;
            rxjs_1.Observable.forkJoin(queries).subscribe(function (results) {
                _this.questions = results[0].json();
                var reponses = results[1] != null ? results[1].json() : [];
                _this.questions.forEach(function (question) {
                    question.candidatureFormationId = _this.candidatureFormation.id;
                    var rep = reponses.find(function (r) { return question.id === r.question.id; });
                    if (rep) {
                        question.reponse = rep.response;
                    }
                });
                _this.questionsChange.emit(_this.questions);
                _this.isLoading = false;
            }, function (error) {
                _this.onError(error);
            });
        }
    };
    FormationComponent.prototype.onError = function (response) {
        this.isLoading = false;
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    // Sur reception de l'evenement, click sur le bouton autres formations
    // noinspection JSMethodCanBeStatic
    FormationComponent.prototype.btnActivation = function (activationType) {
        if (activationType != null && activationType.value.btnAction === 'AutreFormation') {
            var button = document.getElementById('AUTRES');
            if (button != null) {
                button.click();
            }
        }
    };
    return FormationComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], FormationComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FormationComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], FormationComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FormationComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FormationComponent.prototype, "listeCours", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FormationComponent.prototype, "questionsChange", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FormationComponent.prototype, "desCategoriesFormationDisponiblesChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FormationComponent.prototype, "currentLang", void 0);
FormationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-component',
        template: __webpack_require__(426)
    }),
    __metadata("design:paramtypes", [formation_1.CategorieFormationService,
        formation_1.QuestionService,
        reponse_service_1.ReponseService,
        user_en_echange_1.UserEnEchangeService,
        shared_1.Principal,
        formationComponent_service_1.FormationComponentService,
        ng_jhipster_1.AlertService])
], FormationComponent);
exports.FormationComponent = FormationComponent;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var grhum_1 = __webpack_require__(13);
var formation_1 = __webpack_require__(9);
var parametrage_1 = __webpack_require__(11);
var cadens_constants_1 = __webpack_require__(8);
var formationComponent_service_1 = __webpack_require__(22);
var ng_jhipster_1 = __webpack_require__(1);
var user_en_echange_1 = __webpack_require__(21);
var ng2_translate_1 = __webpack_require__(7);
var cours_model_1 = __webpack_require__(137);
var cours_disponible_service_1 = __webpack_require__(155);
var InternationalComponent = (function () {
    function InternationalComponent(parametrageService, translate, grhumService, formationService, formationComponentService, alertService, coursDisponibleService) {
        this.parametrageService = parametrageService;
        this.translate = translate;
        this.grhumService = grhumService;
        this.formationService = formationService;
        this.formationComponentService = formationComponentService;
        this.alertService = alertService;
        this.coursDisponibleService = coursDisponibleService;
        this.candidatureFormation = {};
        this.btnActivation = new core_1.EventEmitter();
        this.listeCoursChange = new core_1.EventEmitter();
        this.isSaving = false;
        this.paysOrigine = new grhum_1.Pays();
    }
    InternationalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.INTERNATIONAL }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.grhumService.queryPays().subscribe(function (res) {
            _this.paysListe = res.json();
            if (_this.userEnEchange && _this.userEnEchange.codePaysUniversite && _this.paysListe) {
                _this.paysOrigine = _this.paysListe.find(function (pays) { return pays.code === _this.userEnEchange.codePaysUniversite; });
                if (!_this.paysOrigine) {
                    _this.paysOrigine = grhum_1.Pays.getPaysInconnu(_this.userEnEchange.codePaysUniversite);
                }
            }
        }, function (res) { return _this.onError(res.json()); });
        this.coursDisponibleService.findByAnneeEnCours().subscribe(function (res) {
            _this.listeCoursDisponible = res;
        });
        this.findFormationEchangeInternational();
        if (!this.listeCours || this.listeCours.length == 0) {
            this.addCours();
        }
        // this.candidatureFormation.paysUniversiteOrigine=this.userEnEchange.codePaysUniversite ;
        // this.candidatureFormation.nomUniversiteOrigine=this.userEnEchange.nomUniversiteOrigine ;
        // this.candidatureFormation.typeEchangeInternational=this.userEnEchange.typeEchange ;
    };
    InternationalComponent.prototype.onError = function (error) {
        this.isSaving = false;
        this.alertService.error(error.message, null, null);
    };
    InternationalComponent.prototype.addCours = function () {
        if (!this.listeCours) {
            this.listeCours = [];
        }
        this.listeCours.push(this.newCours());
        this.listeCoursChange.emit(this.listeCours);
    };
    InternationalComponent.prototype.clearCours = function (index) {
        this.listeCours.splice(index, 1);
    };
    InternationalComponent.prototype.newCours = function () {
        var cours = new cours_model_1.Cours();
        return (cours);
    };
    InternationalComponent.prototype.findFormationEchangeInternational = function () {
        var _this = this;
        this.formationService.findPourEtudiant(cadens_constants_1.CONSTANTS.ECHANGE_INTERNATIONAL_ID, this.candidatureFormation.userId).subscribe(function (formation) {
            _this.candidatureFormation.formationId = formation.id;
            _this.candidatureFormation.libelle = formation.libelle;
            _this.formationComponentService.changeFormation(_this.candidatureFormation.formationId);
        });
    };
    InternationalComponent.prototype.clickBoutonQuestion = function (buttonAction) {
        this.btnActivation.emit({ value: buttonAction });
    };
    InternationalComponent.prototype.onCoursChanged = function (cours) {
        /*       if (this.listeCours != null && cours!=null && this.listeCours.length > cours.index) {
                   this.listeCours[cours.index] = cours;
               }
       */ 
    };
    return InternationalComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], InternationalComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], InternationalComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], InternationalComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.EventEmitter)
], InternationalComponent.prototype, "questionsChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InternationalComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], InternationalComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", user_en_echange_1.UserEnEchange)
], InternationalComponent.prototype, "userEnEchange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], InternationalComponent.prototype, "listeCours", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], InternationalComponent.prototype, "btnActivation", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], InternationalComponent.prototype, "listeCoursChange", void 0);
InternationalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-international-component',
        template: __webpack_require__(428)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        ng2_translate_1.TranslateService,
        grhum_1.GrhumService,
        formation_1.FormationService,
        formationComponent_service_1.FormationComponentService,
        ng_jhipster_1.AlertService,
        cours_disponible_service_1.CoursDisponibleService])
], InternationalComponent);
exports.InternationalComponent = InternationalComponent;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var parametrage_1 = __webpack_require__(11);
var cadens_constants_1 = __webpack_require__(8);
var grhum_1 = __webpack_require__(13);
var formation_1 = __webpack_require__(9);
var formationComponent_service_1 = __webpack_require__(22);
var MasterComponent = (function () {
    function MasterComponent(parametrageService, grhumService, formationService, formationComponentService) {
        this.parametrageService = parametrageService;
        this.grhumService = grhumService;
        this.formationService = formationService;
        this.formationComponentService = formationComponentService;
        this.candidatureFormation = {};
        this.filterByParcours = false;
        this.constants = cadens_constants_1.CONSTANTS;
        this.isSaving = false;
        this.isGradeLicence = false;
        this.ageLimiteBourse = null;
        this.isEligibleBourse = false;
    }
    MasterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.MASTER }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        // Récupération de la date limite de bourse
        this.parametrageService.queryAgeLimiteBourseExc().subscribe(function (res) {
            var parametrages = res.json();
            if (parametrages && parametrages.length > 0) {
                var parametrage = parametrages[0];
                // Utilise libelle ou libelleEn selon la langue
                var dateLibelle = _this.currentLang === 'fr' ? parametrage.libelle : parametrage.libelleEn;
                console.log('Valeur brute de libelle :', dateLibelle);
                if (dateLibelle) {
                    try {
                        // Parse la date selon le format attendu (exemple : "JJ/MM/AAAA")
                        var dateParts = dateLibelle.split('/');
                        if (dateParts.length === 3) {
                            var day = parseInt(dateParts[0], 10);
                            var month = parseInt(dateParts[1], 10) - 1; // Les mois commencent à 0 en JavaScript
                            var year = parseInt(dateParts[2], 10);
                            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                                _this.ageLimiteBourse = new Date(year, month, day);
                                console.log('Date limite bourse :', _this.ageLimiteBourse);
                                // Calcul de l'éligibilité uniquement si ei === 2
                                if (_this.candidatureFormation.ei === 2 && _this.candidatureFormation.dateNaissance) {
                                    var birthDate = new Date(_this.candidatureFormation.dateNaissance);
                                    _this.isEligibleBourse = birthDate >= _this.ageLimiteBourse;
                                    _this.candidatureFormation.bourseExcellence = _this.isEligibleBourse;
                                    console.log('Date de naissance :', birthDate, 'Eligible :', _this.isEligibleBourse);
                                }
                                else {
                                    // Si ei n'est pas égal à 2, bourseExcellence est false
                                    _this.candidatureFormation.bourseExcellence = false;
                                }
                            }
                            else {
                                console.error('Format de date invalide dans libelle :', dateLibelle);
                            }
                        }
                        else {
                            console.error('Format de date inattendu dans libelle :', dateLibelle);
                        }
                    }
                    catch (e) {
                        console.error('Erreur lors du parsing de la date :', e);
                    }
                }
            }
        }, function (error) {
            console.error('Erreur lors de la récupération de la date limite de bourse :', error);
        });
        // Chargement des listes de Mentions, parcours & niveaux
        this.getListeMentions(this.candidatureFormation.parcoursId);
        this.getListeParcours(this.candidatureFormation.mentionId);
        if (this.candidatureFormation.parcoursId) {
            this.getListeNiveaux(this.candidatureFormation.parcoursId);
        }
        if (this.candidatureFormation.ei != this.constants.NON_CONCERNE) {
            this.candidatureFormation.fc = false;
        }
    };
    MasterComponent.prototype.onChangeBourseIndicExcellence = function () {
        if (this.candidatureFormation.indicBourseExcellence == false) {
            this.candidatureFormation.bourseExcellence = false;
        }
    };
    MasterComponent.prototype.onChangeMention = function (newMention) {
        var _this = this;
        this.isGradeLicence = false;
        if (typeof newMention === 'string') {
            newMention = null;
            this.candidatureFormation.mentionId = null;
        }
        if (this.candidatureFormation.mentionId) {
            var composantMention = this.mentionsListe.filter(function (value) { return value.idComposant === _this.candidatureFormation.mentionId; });
            if (composantMention) {
                this.isGradeLicence = composantMention[0].grade === 1;
            }
        }
        this.candidatureFormation.formationId = null;
        if (this.filterByParcours && this.candidatureFormation.niveauId !== null) {
            this.findFormation(this.candidatureFormation.niveauId);
        }
        if (!this.filterByParcours || this.candidatureFormation.parcoursId == null) {
            this.niveauxListe = [];
            this.getListeParcours(newMention);
            if (newMention == null) {
                this.getListeMentions(this.candidatureFormation.formationId);
            }
            this.filterByParcours = false;
        }
    };
    MasterComponent.prototype.onChangeParcours = function (newParcours) {
        if (typeof newParcours === 'string') {
            newParcours = null;
            this.candidatureFormation.parcoursId = null;
        }
        this.candidatureFormation.formationId = null;
        this.candidatureFormation.niveauId = null;
        this.niveauxListe = [];
        this.getListeNiveaux(newParcours);
        if (this.candidatureFormation.mentionId == null || this.filterByParcours) {
            this.filterByParcours = true;
            this.getListeMentions(newParcours);
        }
        else {
            this.filterByParcours = false;
        }
    };
    // Once candidat has choosen Master + Parcours + Niveau, get the corresponding formation id
    MasterComponent.prototype.findFormation = function (newNiveau) {
        var _this = this;
        if (newNiveau == null || typeof newNiveau === 'string') {
            this.candidatureFormation.formationId = null;
            this.candidatureFormation.niveauId = null;
            newNiveau = null;
        }
        if (this.candidatureFormation.mentionId && this.candidatureFormation.niveauId && this.candidatureFormation.parcoursId) {
            this.isSaving = true;
            this.formationService.query({
                mentionId: this.candidatureFormation.mentionId,
                parcoursId: this.candidatureFormation.parcoursId,
                niveauId: newNiveau
            }).subscribe(function (res) {
                var formation = res.json();
                _this.candidatureFormation.formationId = formation[0].id;
                _this.candidatureFormation.libelle = formation[0].libelle;
                _this.formationComponentService.changeFormation(_this.candidatureFormation.formationId);
                _this.isSaving = false;
            }, function (res) {
                _this.isSaving = false;
            });
        }
    };
    MasterComponent.prototype.selectionFormationContinue = function (fc) {
        this.formationComponentService.changeFc(fc);
    };
    MasterComponent.prototype.getListeMentions = function (parcoursId) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.MENTION,
            typeCampagne: cadens_constants_1.CONSTANTS.MASTER,
            childId: parcoursId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.mentionsListe = res.json();
            if (_this.mentionsListe != null && _this.mentionsListe.length === 1) {
                _this.candidatureFormation.mentionId = _this.mentionsListe[0].idComposant;
                _this.isGradeLicence = _this.mentionsListe[0].grade === 1;
                if (_this.candidatureFormation.parcoursId == null) {
                    _this.getListeParcours(_this.candidatureFormation.mentionId);
                }
                else {
                    _this.getListeNiveaux(_this.candidatureFormation.parcoursId);
                }
            }
        });
    };
    MasterComponent.prototype.getListeParcours = function (mention) {
        var _this = this;
        var copyParcours = this.candidatureFormation.parcoursId;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.PARCOURS,
            typeCampagne: cadens_constants_1.CONSTANTS.MASTER,
            parentId: mention,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.parcoursListe = res.json();
            if (mention == null) {
                _this.candidatureFormation.parcoursId = copyParcours;
            }
            if (_this.parcoursListe != null && _this.parcoursListe.length === 1) {
                _this.candidatureFormation.parcoursId = _this.parcoursListe[0].idComposant;
                _this.getListeNiveaux(_this.candidatureFormation.parcoursId);
            }
        });
    };
    MasterComponent.prototype.getListeNiveaux = function (parcours) {
        var _this = this;
        this.grhumService.queryComposant({
            type: cadens_constants_1.CONSTANTS.NIVEAU,
            typeCampagne: cadens_constants_1.CONSTANTS.MASTER,
            parentId: parcours,
            mentionId: this.candidatureFormation.mentionId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(function (res) {
            _this.niveauxListe = res.json();
            if (_this.niveauxListe != null && _this.niveauxListe.length === 1) {
                _this.candidatureFormation.niveauId = _this.niveauxListe[0].idComposant;
                _this.findFormation(_this.candidatureFormation.niveauId);
            }
        });
    };
    return MasterComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], MasterComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], MasterComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], MasterComponent.prototype, "questions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MasterComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], MasterComponent.prototype, "isBO", void 0);
MasterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-master-component',
        template: __webpack_require__(429)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        grhum_1.GrhumService,
        formation_1.FormationService,
        formationComponent_service_1.FormationComponentService])
], MasterComponent);
exports.MasterComponent = MasterComponent;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_formation_model_1 = __webpack_require__(12);
var cadens_constants_1 = __webpack_require__(8);
var parametrage_1 = __webpack_require__(11);
var piece_jointe_1 = __webpack_require__(34);
var formation_1 = __webpack_require__(9);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var referent_1 = __webpack_require__(77);
var rxjs_1 = __webpack_require__(14);
var __1 = __webpack_require__(29);
var platform_browser_1 = __webpack_require__(17);
var ng2_translate_1 = __webpack_require__(7);
var candidature_formation_service_1 = __webpack_require__(18);
var shared_1 = __webpack_require__(2);
var PiecesComponent = PiecesComponent_1 = (function () {
    function PiecesComponent(parametrageService, translate, sanitizer, pieceService, formationService, pieceJointeService, referentService, reponseService, alertService, questionService, modalService, candidatureFormationService, exportService) {
        this.parametrageService = parametrageService;
        this.translate = translate;
        this.sanitizer = sanitizer;
        this.pieceService = pieceService;
        this.formationService = formationService;
        this.pieceJointeService = pieceJointeService;
        this.referentService = referentService;
        this.reponseService = reponseService;
        this.alertService = alertService;
        this.questionService = questionService;
        this.modalService = modalService;
        this.candidatureFormationService = candidatureFormationService;
        this.exportService = exportService;
        this.candidatureFormation = {};
        this.candidatureFormationId = null;
        this.candidatureFormationFc = null;
        this.missingPiecesChange = new core_1.EventEmitter();
        this.piecesJointes = [];
        this.maxSize = 2000000;
        this.pieces = [];
        this.otherUploadedFiles = [];
        this.uploadedFiles = new shared_1.KeyedCollection();
        this.radios = [];
        this.referents = [];
        this.referentsChange = new core_1.EventEmitter();
        this.isReloading = false;
        this.ngInitDone = false;
        this.constantes = cadens_constants_1.CONSTANTS;
    }
    PiecesComponent.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    PiecesComponent.prototype.ngOnChanges = function (changes) {
        if (((changes['candidatureFormation'] != null
            && changes['candidatureFormation'].previousValue.id != null
            && changes['candidatureFormation'].previousValue.id !== changes['candidatureFormation'].currentValue.id) ||
            (changes['candidatureFormationId'] != null
                && changes['candidatureFormationId'].previousValue != null
                && changes['candidatureFormationId'].previousValue !== changes['candidatureFormationId'].currentValue) ||
            (changes['candidatureFormationFc'] != null
                && changes['candidatureFormationFc'].previousValue != null
                && changes['candidatureFormationFc'].previousValue !== changes['candidatureFormationFc'].currentValue))
            && !this.isReloading
            && this.ngInitDone) {
            this.isReloading = true;
            this.pieces = [];
            this.otherUploadedFiles = [];
            this.uploadedFiles = new shared_1.KeyedCollection();
            this.referents = [];
            this.piecesJointes = [];
            this.ngOnInit();
        }
    };
    PiecesComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.loadReferentEvents != null) {
            this.loadReferentSubscription = this.loadReferentEvents.subscribe(function () {
                _this.loadReferents();
            });
        }
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
        this.isSaving = true;
        // Get les paramétrages des pièces jointes
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.PIECES }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
            _this.maxSize = _this.parametrage.MAX_SIZE.libelle;
        });
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {
            // get de la pièce recommandation
            var getPiece = this.pieceService.findByCode('LETTRE_RECOMMANDATION').subscribe(function (res) {
                _this.lettreRecommandation = res;
            });
            // Get la liste des pièces jointes déjà uploadées
            this.pieceJointeService.query({ candidatureFormationId: this.candidatureFormation.id }).subscribe(function (res) {
                _this.piecesJointes = res.json();
                _this.piecesJointes.forEach(function (pj) {
                    if (pj.pieceId === 1) {
                        _this.otherUploadedFiles.push(pj);
                    }
                    else {
                        _this.uploadedFiles.Add(_this.getPieceIndex(pj.pieceId, pj.referentId), pj);
                    }
                });
                // Get la liste des pièces pour la formation choisie
                var categorieFormationIdList = [];
                categorieFormationIdList.push(_this.candidatureFormation.categorieFormationId);
                _this.pieceService.query({
                    categorieFormationIdList: categorieFormationIdList,
                    formationId: _this.candidatureFormation.formationId,
                    isFormationContinue: _this.candidatureFormation.fc,
                    etudiantId: _this.candidatureFormation.userId
                }).subscribe(function (piecesResp) {
                    _this.pieces = piecesResp.json();
                    _this.isMissingPJ();
                    _this.isSaving = false;
                    _this.isReloading = false;
                });
                _this.loadPJContent(); // Chargement de la visu des pj dans le BO
            });
            this.loadReferents();
        }
        else {
            this.isSaving = false;
            this.isReloading = false;
        }
        this.ngInitDone = true;
    };
    PiecesComponent.prototype.ngOnDestroy = function () {
        if (this.loadReferentSubscription != null) {
            this.loadReferentSubscription.unsubscribe();
        }
    };
    PiecesComponent.prototype.loadReferents = function () {
        var _this = this;
        this.formationService.find(this.candidatureFormation.formationId).subscribe(function (res) {
            if (res.nombreReferents > 0 && _this.candidatureFormation.fc !== true) {
                _this.referentService.query({ candidatureFormationId: _this.candidatureFormation.id }).subscribe(function (referents) {
                    _this.referents = referents.json().sort(function (ref1, ref2) {
                        if (ref1.id > ref2.id) {
                            return 1;
                        }
                        if (ref1.id < ref2.id) {
                            return -1;
                        }
                        return 0;
                    });
                    for (var i = _this.referents.length; i < res.nombreReferents; i++) {
                        var newRef = new referent_1.Referent();
                        if (res.id === cadens_constants_1.CONSTANTS.ECHANGE_INTERNATIONAL_ID) {
                            if (i === 0) {
                                newRef.typeReferent = cadens_constants_1.CONSTANTS.CONTACT_PEDAGO;
                            }
                            if (i === 1) {
                                newRef.typeReferent = cadens_constants_1.CONSTANTS.CONTACT_ADMIN;
                            }
                        }
                        newRef.candidatureFormationId = _this.candidatureFormation.id;
                        _this.referents.push(newRef);
                    }
                    _this.referents.forEach(function (referent, idx) {
                        referent.obligatoire = idx < res.nombreReferentsObligatoires;
                    });
                    _this.referentsChange.emit(_this.referents);
                    if (_this.isBO > 0 && _this.referents != null) {
                        _this.loadFormulaireRecommandationBO();
                    }
                    _this.isSaving = false;
                    _this.isReloading = false;
                }, function (error) {
                    _this.isSaving = false;
                    _this.onError(error);
                });
            }
        });
    };
    // Envoyer le mail avec le formulaire de reco au référent
    PiecesComponent.prototype.sendMailToReferent = function (referent, idx) {
        var _this = this;
        this.isSaving = true;
        if (referent.nom == null || referent.nom.length < 1 || referent.prenom == null || referent.prenom.length < 1
            || referent.email == null || referent.email.length < 1 || referent.discipline == null || referent.discipline.length < 1
            || referent.etablissement == null || referent.etablissement.length < 1) {
            this.isSaving = false;
            return this.referents[idx].invalid = true;
        }
        referent.invalid = false;
        referent.key = 'true';
        this.referentService.update(referent, null).subscribe(function (res) {
            _this.referents[idx] = res;
            _this.isSaving = false;
        }, function (error) {
            // CADENSCAD-192 Dédoublement des référents : ici pb si envoi mail provoque une erreur et que le referent
            // est enregistré ca provoque des doublons --> on recharge tous les referents
            _this.referents = null;
            _this.loadReferents();
            referent.key = null;
            _this.onError(error);
        });
    };
    // Gestionnaire peut réinitialiser un formulaire de reco
    PiecesComponent.prototype.reinitMailToReferent = function (referent, idx) {
        var _this = this;
        this.isSaving = true;
        referent.key = null; // => suppr la key
        referent.formulaire = null;
        this.referentService.update(referent, null).subscribe(function (res) {
            _this.referents[idx] = res;
            _this.isSaving = false;
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    // Open a file in a new tab when click on it
    PiecesComponent.prototype.openFile = function (name) {
        var _this = this;
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe(function (res) {
            var fileUrl = URL.createObjectURL(res);
            window.open(fileUrl);
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    // Open la popup d'aide
    PiecesComponent.prototype.openAide = function (pieceModal, piece) {
        this.aide = piece;
        this.modalService.open(pieceModal);
    };
    // When the file is uploaded
    PiecesComponent.prototype.onFileUploaded = function (event, idPiece, referentId) {
        var _this = this;
        var pj = JSON.parse(event.xhr.response);
        var id = this.getPieceIndex(idPiece, referentId);
        if (this.uploadedFiles.Item(id) == null) {
            this.uploadedFiles.Add(id, { nom: pj.nom });
        }
        else {
            this.uploadedFiles.Item(id).nom = pj.nom;
        }
        if (this.isBO > 0) {
            this.loadFileContent(this.uploadedFiles.Item(id));
        }
        if (this.piecesJointes.find(function (p) { return _this.getPieceIndex(p.pieceId, p.referentId) === id; })) {
            this.piecesJointes.find(function (p) { return _this.getPieceIndex(p.pieceId, p.referentId) === id; }).nom = pj.nom;
        }
        else {
            this.piecesJointes.push(pj);
            this.isMissingPJ();
        }
    };
    PiecesComponent.prototype.onOtherFileUploaded = function (event) {
        var pj = JSON.parse(event.xhr.response);
        var notes = this.otherUploadedFiles[this.lastIdx].notes;
        this.otherUploadedFiles[this.lastIdx] = pj;
        this.otherUploadedFiles[this.lastIdx].notes = notes;
    };
    // Before the file is sent to the server for upload
    PiecesComponent.prototype.onBeforeUpload = function (event, id) {
        this.onBeforeUploadReferent(event, id, null);
    };
    // Before the file is sent to the server for upload
    PiecesComponent.prototype.onBeforeUploadReferent = function (event, id, referentId) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId', this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.candidatureFormation.id);
        if (referentId != null) {
            event.formData.append('referentId', referentId);
        }
    };
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    PiecesComponent.prototype.onBeforeSend = function (event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', PiecesComponent_1.getCookie('XSRF-TOKEN'));
    };
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    PiecesComponent.prototype.onRemove = function (event, id) {
        event.formData.append('pieceId', id);
    };
    // Autres pièces justificatives
    PiecesComponent.prototype.addOtherPJ = function (modal, idx) {
        this.modalRef = this.modalService.open(modal);
        if (!this.otherUploadedFiles) {
            this.otherUploadedFiles = [];
        }
        if (idx != null) {
            this.lastIdx = idx;
        }
        else {
            this.otherUploadedFiles.push({ pieceId: 1 });
            this.lastIdx = this.otherUploadedFiles.length - 1;
        }
    };
    PiecesComponent.prototype.saveOtherPJ = function (modal) {
        var _this = this;
        if (this.otherUploadedFiles[this.lastIdx].nom != null) {
            this.pieceJointeService.update(this.otherUploadedFiles[this.lastIdx]).subscribe(function (res) {
                _this.otherUploadedFiles[_this.lastIdx] = res;
                _this.modalRef.close();
            }, function (error) {
                _this.isSaving = false;
                _this.onError(error);
            });
        }
    };
    PiecesComponent.prototype.closeOtherPJ = function () {
        if (this.otherUploadedFiles[this.lastIdx].id == null) {
            this.otherUploadedFiles.pop();
        }
        this.modalRef.close();
    };
    PiecesComponent.prototype.deleteOtherPJ = function () {
        var _this = this;
        this.pieceJointeService.delete(this.otherUploadedFiles[this.lastIdx].id).subscribe(function (res) {
            _this.otherUploadedFiles.splice(_this.lastIdx, 1);
            _this.modalRef.close();
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    // Afficher le contenu des pièces jointes dans le Back Office dans la page web
    PiecesComponent.prototype.loadPJContent = function () {
        var _this = this;
        if (this.isBO > 0) {
            this.uploadedFiles.Values().forEach(function (piece) {
                _this.loadFileContent(piece);
            });
            this.otherUploadedFiles.forEach(function (piece) {
                _this.loadFileContent(piece);
            });
        }
    };
    PiecesComponent.prototype.loadFileContent = function (piece) {
        var _this = this;
        this.pieceJointeService.openFile(piece.nom).subscribe(function (res) {
            _this.pieceJointeService.initPDFOrImageFile(res, piece);
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    PiecesComponent.prototype.loadFormulaireRecommandationBO = function () {
        var _this = this;
        this.referents.forEach(function (referent) {
            if (referent.id != null) {
                var getQuestions = _this.questionService.query();
                var getReponses = _this.reponseService.query({
                    referentId: referent.id
                });
                rxjs_1.Observable.forkJoin([getQuestions, getReponses]).subscribe(function (results) {
                    var questions = results[0].json();
                    var reponses = results[1] != null ? results[1].json() : [];
                    questions.forEach(function (question) {
                        question.referentId = referent.id;
                        var rep = reponses.find(function (r) { return question.id === r.question.id; });
                        if (rep) {
                            question.reponse = rep.response;
                        }
                    });
                    referent.questions = questions.filter(function (question) { return question.reponse != null; });
                    if ((_this.radios == null || _this.radios.length === 0) && referent.questions.length > 0) {
                        _this.getRadios(referent.questions);
                    }
                }, function (error) {
                    _this.isSaving = false;
                    _this.onError(error);
                });
            }
        });
    };
    PiecesComponent.prototype.getRadios = function (questions) {
        var _this = this;
        if (questions != null) {
            questions.forEach(function (question) {
                if (question.typeReponse === 'RADIO' && question.reponseComplement != null) {
                    var choix = question.reponseComplement.split('|');
                    var idx = _this.radios.map(function (radio) { return radio.join('|'); }).indexOf(question.reponseComplement);
                    if (idx < 0) {
                        _this.radios.push(choix);
                    }
                }
            });
        }
    };
    /**
     * Check if one of the PJ is mandatory and missing
     */
    PiecesComponent.prototype.isMissingPJ = function () {
        if (this.pieces != null && this.pieces.length > 0) {
            if (this.piecesJointes == null || this.piecesJointes.length === 0) {
                this.missingPieces = true;
            }
            else {
                var piecesMandat_1 = this.pieces.filter(function (p) { return p.obligatoire === true; });
                var pjMandat = this.piecesJointes.filter(function (pj) { return piecesMandat_1.findIndex(function (p) { return p.id === pj.pieceId; }) > -1; });
                this.missingPieces = piecesMandat_1.length > pjMandat.length;
            }
        }
        else {
            this.missingPieces = false;
        }
        this.missingPiecesChange.emit(this.missingPieces);
    };
    PiecesComponent.prototype.calculTitreReferent = function (referent) {
        var titre = '';
        var param;
        if (referent != null) {
            if (this.parametrage != null) {
                if (referent.typeReferent === cadens_constants_1.CONSTANTS.CONTACT_PEDAGO) {
                    param = this.parametrage.PIECES_REFERENTS_PEDAGO;
                }
                else {
                    if (referent.typeReferent === cadens_constants_1.CONSTANTS.CONTACT_ADMIN) {
                        param = this.parametrage.PIECES_REFERENTS_ADMIN;
                    }
                    else {
                        param = this.parametrage.PIECES_REFERENTS;
                    }
                }
            }
        }
        if (param) {
            titre = this.currentLang === 'fr' ? param.libelle : param.libelleEn;
        }
        return titre;
    };
    // noinspection JSMethodCanBeStatic
    PiecesComponent.prototype.getPieceIndex = function (pieceId, referentId) {
        return piece_jointe_1.PieceJointe.getPieceIndex(pieceId, referentId);
    };
    PiecesComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    PiecesComponent.prototype.onErrorMessage = function (message) {
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, null);
    };
    return PiecesComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], PiecesComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PiecesComponent.prototype, "candidatureFormationId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PiecesComponent.prototype, "candidatureFormationFc", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PiecesComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PiecesComponent.prototype, "missingPieces", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PiecesComponent.prototype, "missingReferent", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PiecesComponent.prototype, "missingPiecesChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PiecesComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PiecesComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PiecesComponent.prototype, "isSaving", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], PiecesComponent.prototype, "referents", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PiecesComponent.prototype, "referentsChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", rxjs_1.Observable)
], PiecesComponent.prototype, "loadReferentEvents", void 0);
PiecesComponent = PiecesComponent_1 = __decorate([
    core_1.Component({
        selector: 'jhi-pieces-component',
        template: __webpack_require__(430)
    }),
    __metadata("design:paramtypes", [parametrage_1.ParametrageService,
        ng2_translate_1.TranslateService,
        platform_browser_1.DomSanitizer,
        formation_1.PieceService,
        formation_1.FormationService,
        piece_jointe_1.PieceJointeService,
        referent_1.ReferentService,
        __1.ReponseService,
        ng_jhipster_1.AlertService,
        formation_1.QuestionService,
        ng_bootstrap_1.NgbModal,
        candidature_formation_service_1.CandidatureFormationService,
        shared_1.ExportService])
], PiecesComponent);
exports.PiecesComponent = PiecesComponent;
var PiecesComponent_1;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var cursus_model_1 = __webpack_require__(139);
var calendar_constants_1 = __webpack_require__(15);
var grhum_1 = __webpack_require__(13);
var formation_1 = __webpack_require__(9);
var candidature_formation_service_1 = __webpack_require__(18);
var cadens_constants_1 = __webpack_require__(8);
var CursusComponent = (function () {
    function CursusComponent(grhumService, formationService, candidatureFormationService) {
        this.grhumService = grhumService;
        this.formationService = formationService;
        this.candidatureFormationService = candidatureFormationService;
        this.cursusChange = new core_1.EventEmitter();
        this.dateFinInvalid = { beforeDateDebut: false, invalid: false };
        this.constants = cadens_constants_1.CONSTANTS;
    }
    CursusComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.grhumService.queryTypeFormation().subscribe(function (res) { _this.typeFormationListe = res.json(); });
        this.grhumService.queryGradeUniversitaire().subscribe(function (res) { _this.gradeUniversitaireListe = res.json(); });
        this.grhumService.queryNiveauAccesDiplome().subscribe(function (res) { _this.niveauAccesDiplomeListe = res.json(); });
        if (this.isReinscription && this.cursus.titreDiplomePrepare == null && this.candidatureFormationId != null) {
            this.candidatureFormationService.findLastFormationENS(this.candidatureFormationId).subscribe(function (res) { _this.cursus.titreDiplomePrepare = res; });
        }
        this.fr = calendar_constants_1.CALENDAR_FR;
    };
    CursusComponent.prototype.checkDates = function (date) {
        this.dateFinInvalid.invalid = false;
        this.dateFinInvalid.beforeDateDebut = this.cursus.dateDebut && this.cursus.dateFin && this.cursus.dateDebut > this.cursus.dateFin;
        if (this.cursus.dateDebut > new Date()) {
            this.dateFinInvalid.invalid = true;
        }
    };
    return CursusComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", cursus_model_1.Cursus)
], CursusComponent.prototype, "cursus", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CursusComponent.prototype, "cursusChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CursusComponent.prototype, "index", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CursusComponent.prototype, "paysListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CursusComponent.prototype, "deptListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CursusComponent.prototype, "mentionListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CursusComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CursusComponent.prototype, "isReinscription", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CursusComponent.prototype, "candidatureFormationId", void 0);
CursusComponent = __decorate([
    core_1.Component({
        selector: 'jhi-cursus-component',
        template: __webpack_require__(432)
    }),
    __metadata("design:paramtypes", [grhum_1.GrhumService,
        formation_1.FormationService,
        candidature_formation_service_1.CandidatureFormationService])
], CursusComponent);
exports.CursusComponent = CursusComponent;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var candidature_model_1 = __webpack_require__(42);
var grhum_1 = __webpack_require__(13);
var cursus_service_1 = __webpack_require__(64);
var cadens_constants_1 = __webpack_require__(8);
var parametrage_1 = __webpack_require__(11);
var concours_service_1 = __webpack_require__(63);
var ng_jhipster_1 = __webpack_require__(1);
var candidature_formation_model_1 = __webpack_require__(12);
var ng_bootstrap_1 = __webpack_require__(5);
var listeChoix_service_1 = __webpack_require__(23);
var ScolariteComponent = (function () {
    function ScolariteComponent(grhumService, cursusService, concoursService, jhiLanguageService, parametrageService, listeChoixService, modalService) {
        this.grhumService = grhumService;
        this.cursusService = cursusService;
        this.concoursService = concoursService;
        this.jhiLanguageService = jhiLanguageService;
        this.parametrageService = parametrageService;
        this.listeChoixService = listeChoixService;
        this.modalService = modalService;
        this.coursesChange = new core_1.EventEmitter();
        this.concoursChange = new core_1.EventEmitter();
        this.annee = [];
        this.displayBacDetail = false;
        this.constants = cadens_constants_1.CONSTANTS;
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    ScolariteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.candidature.echelon = "";
        if (this.candidature.id > 0) {
            this.cursusService.query({ 'candidatureId': this.candidature.id }).subscribe(function (res) {
                _this.courses = res.json();
                if (!_this.courses || _this.courses.length === 0) {
                    _this.courses = [];
                    if (_this.candidatureFormation.reinscription) {
                        _this.courses.push(_this.newCursusReinscription());
                    }
                }
                _this.coursesChange.emit(_this.courses);
            });
            this.concoursService.query({ 'candidatureId': this.candidature.id }).subscribe(function (res) {
                _this.concours = res.json();
                _this.concoursChange.emit(_this.concours);
            });
        }
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.SCOLARITE }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.grhumService.queryBac().subscribe(function (res) {
            _this.bacsListe = res.json();
        });
        this.typesEtablissement = cadens_constants_1.CodeTypeEtablissement;
        this.grhumService.queryGMention().subscribe(function (res) {
            _this.mentionsListe = res.json();
        });
        this.grhumService.queryBacSpecialite().subscribe(function (res) {
            _this.bacSpecialitesListe = res.json();
        });
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.ECHELON }).subscribe(function (res) {
            _this.listeEchelons = res.json();
        });
        this.updateDisplayBacDetail();
    };
    ScolariteComponent.prototype.addCursus = function () {
        if (!this.courses) {
            this.courses = [];
        }
        this.courses.push(this.newCursus());
        this.coursesChange.emit(this.courses);
    };
    ScolariteComponent.prototype.clearCursus = function (index) {
        this.courses.splice(index, 1);
    };
    ScolariteComponent.prototype.newCursus = function () {
        return { candidatureId: this.candidature.id };
    };
    ScolariteComponent.prototype.newCursusReinscription = function () {
        return {
            candidatureId: this.candidature.id,
            interruption: false,
            pays: '100',
            dept: '069',
            etablissement: '0694123G',
            ville: '69387'
        };
    };
    ScolariteComponent.prototype.onChangeConcours = function (idx) {
        this.concours[idx].rang = null;
        this.concours[idx].annee = null;
        this.concours[idx].resultat = null;
    };
    ScolariteComponent.prototype.onChangeBourse = function () {
        if (this.candidature.bourse == false) {
            this.candidature.echelon = "";
        }
    };
    ScolariteComponent.prototype.onChangeTypeEtab = function () {
        this.candidature.bacPays = null;
        this.candidature.bacDept = null;
        this.candidature.bacVille = null;
        this.candidature.bacEtab = null;
        this.candidature.bacEtablissementAutre = null;
        this.candidature.bacSpec1LibelleCourt = null;
        this.candidature.bacSpec2LibelleCourt = null;
        this.verifBacFrancaisApres2021AndUpdateDisplayBacDetail();
        this.updateDisplayBacDetail();
    };
    ScolariteComponent.prototype.onChangeBacAnnee = function () {
        this.verifBacFrancaisApres2021AndUpdateDisplayBacDetail();
        this.updateDisplayBacDetail();
    };
    ScolariteComponent.prototype.verifBacFrancaisApres2021AndUpdateDisplayBacDetail = function () {
        if (candidature_model_1.Candidature.areSpecialitesBacObligatoires(this.candidature)) {
            this.candidature.bac = this.bacsListe.find(function (bac) { return bac.value === 'NBGE'; }).value;
        }
    };
    ScolariteComponent.prototype.updateDisplayBacDetail = function () {
        this.displayBacDetail = (this.candidature.bacAnnee && this.candidature.bacTypeEtablissement) && (this.candidature.bacAnnee > 1900);
    };
    // Open la popup d'aide
    ScolariteComponent.prototype.openAide = function (aideModal, parametre) {
        this.aide = parametre;
        this.modalService.open(aideModal);
    };
    ScolariteComponent.prototype.areSpecialitesBacObligatoires = function () {
        return candidature_model_1.Candidature.areSpecialitesBacObligatoires(this.candidature);
    };
    return ScolariteComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_model_1.Candidature)
], ScolariteComponent.prototype, "candidature", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], ScolariteComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ScolariteComponent.prototype, "paysListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ScolariteComponent.prototype, "deptListe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ScolariteComponent.prototype, "courses", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ScolariteComponent.prototype, "coursesChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ScolariteComponent.prototype, "concours", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ScolariteComponent.prototype, "concoursChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ScolariteComponent.prototype, "isEditable", void 0);
ScolariteComponent = __decorate([
    core_1.Component({
        selector: 'jhi-scolarite-component',
        template: __webpack_require__(433)
    }),
    __metadata("design:paramtypes", [grhum_1.GrhumService,
        cursus_service_1.CursusService,
        concours_service_1.ConcoursService,
        ng_jhipster_1.JhiLanguageService,
        parametrage_1.ParametrageService,
        listeChoix_service_1.ListeChoixService,
        ng_bootstrap_1.NgbModal])
], ScolariteComponent);
exports.ScolariteComponent = ScolariteComponent;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var commission_model_1 = __webpack_require__(66);
var commission_popup_service_1 = __webpack_require__(151);
var commission_service_1 = __webpack_require__(67);
var calendar_constants_1 = __webpack_require__(15);
var CommissionDialogComponent = (function () {
    function CommissionDialogComponent(activeModal, jhiLanguageService, alertService, commissionService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.commissionService = commissionService;
        this.eventManager = eventManager;
        this.createCommission = false;
        this.isCommissionValid = commission_model_1.Commission.isCommissionValid;
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
    }
    CommissionDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.commissionService.query().subscribe(function (res) {
            var commissions = res.json();
            // On filtre pour n'afficher que les commissions avec une date > (now - 3 mois)
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth() - 3;
            if (month < 0) {
                month += 12;
                year -= 1;
            }
            _this.commissions = commissions.filter(function (commission) { return commission.dateCommission > new Date(year, month, now.getDate()); });
        }, function (res) { return _this.onError(res.json()); });
    };
    CommissionDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    CommissionDialogComponent.prototype.createCommissionButton = function () {
        this.createCommission = true;
    };
    CommissionDialogComponent.prototype.selectCommission = function (commission) {
        this.onSaveSuccess(this.commissionService.convertHeures(commission));
    };
    CommissionDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.commission.id !== undefined) {
            this.commissionService.update([this.commission])
                .subscribe(function (res) { return _this.onSaveSuccess(res[0]); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.commissionService.create(this.commission)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    CommissionDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'campagneCommissionsModification', content: result });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    CommissionDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    CommissionDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return CommissionDialogComponent;
}());
CommissionDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-commission-dialog',
        template: __webpack_require__(434)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        commission_service_1.CommissionService,
        ng_jhipster_1.EventManager])
], CommissionDialogComponent);
exports.CommissionDialogComponent = CommissionDialogComponent;
var CommissionPopupComponent = (function () {
    function CommissionPopupComponent(route, commissionPopupService) {
        this.route = route;
        this.commissionPopupService = commissionPopupService;
    }
    CommissionPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            var campagneId = params['campagneId'];
            if (params['id']) {
                _this.modalRef = _this.commissionPopupService
                    .open(CommissionDialogComponent, campagneId, params['id']);
            }
            else {
                _this.modalRef = _this.commissionPopupService
                    .open(CommissionDialogComponent, campagneId);
            }
        });
    };
    CommissionPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return CommissionPopupComponent;
}());
CommissionPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-commission-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        commission_popup_service_1.CommissionPopupService])
], CommissionPopupComponent);
exports.CommissionPopupComponent = CommissionPopupComponent;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var commission_model_1 = __webpack_require__(66);
var commission_service_1 = __webpack_require__(67);
var CommissionPopupService = (function () {
    function CommissionPopupService(modalService, router, commissionService) {
        this.modalService = modalService;
        this.router = router;
        this.commissionService = commissionService;
        this.isOpen = false;
    }
    CommissionPopupService.prototype.open = function (component, campagneId, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.commissionService.find(id).subscribe(function (commission) {
                // commission.dateCommission = this.datePipe.transform(commission.dateCommission, 'yyyy-MM-ddThh:mm');
                // commission.datePublication = this.datePipe.transform(commission.datePublication, 'yyyy-MM-ddThh:mm');
                // commission.dateCoupure = this.datePipe.transform(commission.dateCoupure, 'yyyy-MM-ddThh:mm');
                _this.commissionModalRef(component, campagneId, commission);
            });
        }
        else {
            return this.commissionModalRef(component, campagneId, new commission_model_1.Commission());
        }
    };
    CommissionPopupService.prototype.commissionModalRef = function (component, campagneId, commission) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.commission = commission;
        modalRef.componentInstance.campagneId = campagneId;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return CommissionPopupService;
}());
CommissionPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        commission_service_1.CommissionService])
], CommissionPopupService);
exports.CommissionPopupService = CommissionPopupService;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var parametrage_1 = __webpack_require__(11);
var calendar_constants_1 = __webpack_require__(15);
var contact_service_1 = __webpack_require__(154);
var ContactComponent = (function () {
    function ContactComponent(jhiLanguageService, parametrageService, contactService, alertService) {
        this.jhiLanguageService = jhiLanguageService;
        this.parametrageService = parametrageService;
        this.contactService = contactService;
        this.alertService = alertService;
        this.jhiLanguageService.setLocations(['contact']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    ContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        this.contact = {};
        this.parametrageService.queryPageAll().subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
    };
    ContactComponent.prototype.sendEmail = function () {
        var _this = this;
        this.contactService.create(this.contact).subscribe(function (res) { return _this.onSuccess(res); }, function (res) { return _this.onError(res); });
    };
    ContactComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ContactComponent.prototype.onSuccess = function (data) {
        this.alertService.success('cadensApp.contact.sent', null, null);
    };
    return ContactComponent;
}());
ContactComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact',
        template: __webpack_require__(435)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        parametrage_1.ParametrageService,
        contact_service_1.ContactService,
        ng_jhipster_1.AlertService])
], ContactComponent);
exports.ContactComponent = ContactComponent;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(264);
var ENTITY_STATES = _1.contactRoute.slice();
var CadensContactModule = (function () {
    function CadensContactModule() {
    }
    return CadensContactModule;
}());
CadensContactModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            primeng_1.CalendarModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ContactComponent
        ],
        entryComponents: [
            _1.ContactComponent
        ],
        providers: [
            _1.ContactService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensContactModule);
exports.CadensContactModule = CadensContactModule;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ContactService = (function () {
    function ContactService(http) {
        this.http = http;
        this.resourceUrl = 'api/public/contact';
    }
    ContactService.prototype.create = function (contact) {
        var copy = Object.assign({}, contact);
        copy.dateNaissance = new Date(Date.UTC(contact.dateNaissance.getFullYear(), contact.dateNaissance.getMonth(), contact.dateNaissance.getDate()));
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res;
        });
    };
    return ContactService;
}());
ContactService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ContactService);
exports.ContactService = ContactService;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var CoursDisponibleService = (function () {
    function CoursDisponibleService(http) {
        this.http = http;
        this.resourceUrl = 'api/cours-disponible';
    }
    CoursDisponibleService.prototype.create = function (coursDisponible) {
        var copy = Object.assign({}, coursDisponible);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CoursDisponibleService.prototype.update = function (coursDisponible) {
        var copy = Object.assign({}, coursDisponible);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CoursDisponibleService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    CoursDisponibleService.prototype.findByAnnee = function (annee) {
        return this.http.get(this.resourceUrl + "/annee/" + annee).map(function (res) {
            return res.json();
        });
    };
    CoursDisponibleService.prototype.findByAnneeEnCours = function () {
        return this.http.get(this.resourceUrl + "/annee-en-cours").map(function (res) {
            return res.json();
        });
    };
    CoursDisponibleService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.type) {
            params.set('type', req.type.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    CoursDisponibleService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CoursDisponibleService.prototype.toLabelValue = function (coursDisponible) {
        var liste = [];
        coursDisponible.forEach(function (cours) { return liste.push({ label: cours.llCours, value: cours.cCours }); });
        return liste;
    };
    CoursDisponibleService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return CoursDisponibleService;
}());
CoursDisponibleService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], CoursDisponibleService);
exports.CoursDisponibleService = CoursDisponibleService;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var entity_audit_event_service_1 = __webpack_require__(68);
var EntityAuditEventDetailComponent = (function () {
    function EntityAuditEventDetailComponent(jhiLanguageService, entityAuditEventService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.entityAuditEventService = entityAuditEventService;
        this.route = route;
        this.jhiLanguageService.setLocations(['entityAuditEvent']);
    }
    EntityAuditEventDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    EntityAuditEventDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.entityAuditEventService.find(id).subscribe(function (entityAuditEvent) {
            _this.entityAuditEvent = entityAuditEvent;
        });
    };
    // noinspection JSMethodCanBeStatic
    EntityAuditEventDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    EntityAuditEventDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    // noinspection JSMethodCanBeStatic
    EntityAuditEventDetailComponent.prototype.toJsonObject = function (entity) {
        try {
            return JSON.parse(entity);
        }
        catch (err) {
            return entity;
        }
    };
    return EntityAuditEventDetailComponent;
}());
EntityAuditEventDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-entity-audit-event-detail',
        template: __webpack_require__(436)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        entity_audit_event_service_1.EntityAuditEventService,
        router_1.ActivatedRoute])
], EntityAuditEventDetailComponent);
exports.EntityAuditEventDetailComponent = EntityAuditEventDetailComponent;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var entity_audit_event_service_1 = __webpack_require__(68);
var shared_1 = __webpack_require__(2);
var candidature_formation_service_1 = __webpack_require__(18);
var EntityAuditEventComponent = (function () {
    function EntityAuditEventComponent(jhiLanguageService, entityAuditEventService, parseLinks, alertService, principal, activatedRoute, router, eventManager, candidatureFormationService, route) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.entityAuditEventService = entityAuditEventService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.candidatureFormationService = candidatureFormationService;
        this.route = route;
        this.valueDialog = false;
        this.isLoading = false;
        this.isFilterCandidatureDisplayed = true;
        this.candidatureFormation = null;
        this.itemsPerPage = 300;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['entityAuditEvent']);
        this.subscription = this.route.params.subscribe(function (params) {
            _this.candidatureFormationId = params['id'];
            if (_this.candidatureFormationId != null) {
                _this.isFilterCandidatureDisplayed = false;
                _this.candidatureFormationService.find(_this.candidatureFormationId, false).subscribe(function (candidatureFormation) {
                    if (candidatureFormation != null) {
                        _this.candidatureFormation = candidatureFormation;
                    }
                });
            }
        });
    }
    EntityAuditEventComponent.prototype.loadAll = function () {
        var _this = this;
        this.entityAuditEvents = null;
        this.isLoading = true;
        if (this.candidatureFormationId != null && this.isLoading) {
            this.entityAuditEventService.findLogCandidatureFormation(this.candidatureFormationId).subscribe(function (res) { return _this.onSuccess(res.json(), null); }, function (res) { return _this.onError(res.json()); });
        }
        else {
            this.entityAuditEventService.query({
                page: this.page - 1,
                size: this.itemsPerPage,
                query: this.candidatureFormationId,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
        }
    };
    EntityAuditEventComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    EntityAuditEventComponent.prototype.transition = function () {
        if (this.candidatureFormationId != null) {
            this.router.navigate(['/entity-audit-event/candidatureFormation/' + this.candidatureFormationId], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
        }
        else {
            this.router.navigate(['/entity-audit-event'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
        }
        this.loadAll();
    };
    EntityAuditEventComponent.prototype.clear = function () {
        this.page = 0;
        this.router.navigate(['/entity-audit-event', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    EntityAuditEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInEntityAuditEvents();
    };
    EntityAuditEventComponent.prototype.viewValue = function (value) {
        this.entityValue = JSON.stringify(JSON.parse(value.replace(/,/g, ', ')), null, 4);
        this.valueDialog = true;
    };
    EntityAuditEventComponent.prototype.closeValueDialog = function () {
        this.valueDialog = false;
    };
    EntityAuditEventComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    EntityAuditEventComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    EntityAuditEventComponent.prototype.registerChangeInEntityAuditEvents = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('entityAuditEventListModification', function (response) { return _this.loadAll(); });
    };
    EntityAuditEventComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    EntityAuditEventComponent.prototype.onSuccess = function (data, headers) {
        this.isLoading = false;
        if (headers != null) {
            this.links = this.parseLinks.parse(headers.get('link'));
            this.totalItems = headers.get('X-Total-Count');
            this.queryCount = this.totalItems;
        }
        // this.page = pagingParams.page;
        this.entityAuditEvents = data;
    };
    EntityAuditEventComponent.prototype.onError = function (error) {
        this.isLoading = false;
        this.alertService.error(error.message, null, null);
    };
    EntityAuditEventComponent.prototype.goToCandidature = function () {
        var _this = this;
        this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(function (candidatureFormation) {
            if (candidatureFormation != null) {
                if (candidatureFormation.reinscription) {
                    _this.router.navigate(['/reinscription/' + candidatureFormation.id]);
                }
                else {
                    _this.router.navigate(['/candidature/' + candidatureFormation.id]);
                }
            }
        });
    };
    return EntityAuditEventComponent;
}());
EntityAuditEventComponent = __decorate([
    core_1.Component({
        selector: 'jhi-entity-audit-event',
        template: __webpack_require__(437)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        entity_audit_event_service_1.EntityAuditEventService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        candidature_formation_service_1.CandidatureFormationService,
        router_1.ActivatedRoute])
], EntityAuditEventComponent);
exports.EntityAuditEventComponent = EntityAuditEventComponent;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng2_translate_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var cadens_constants_1 = __webpack_require__(8);
var parametrage_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(2);
var api_1 = __webpack_require__(16);
var ng_bootstrap_1 = __webpack_require__(5);
var admin_1 = __webpack_require__(54);
var forkJoin_1 = __webpack_require__(199);
var formation_1 = __webpack_require__(9);
var piece_jointe_1 = __webpack_require__(34);
var candidature_formation_service_1 = __webpack_require__(18);
var candidature_formation_model_1 = __webpack_require__(12);
var EspaceCandidatComponent = EspaceCandidatComponent_1 = (function () {
    function EspaceCandidatComponent(candidatureFormationService, principal, jhiLanguageService, parametrageService, categorieFormationService, alertService, router, confirmationService, translateService, modalService, exportService, translate, formationService, pieceJointeService, pieceService) {
        this.candidatureFormationService = candidatureFormationService;
        this.principal = principal;
        this.jhiLanguageService = jhiLanguageService;
        this.parametrageService = parametrageService;
        this.categorieFormationService = categorieFormationService;
        this.alertService = alertService;
        this.router = router;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.modalService = modalService;
        this.exportService = exportService;
        this.translate = translate;
        this.formationService = formationService;
        this.pieceJointeService = pieceJointeService;
        this.pieceService = pieceService;
        this.isEditable = true;
        this.isConfirmable = false;
        this.isClickable = false;
        this.candidatureFormationId = null;
        this.candidatureFormation = {};
        this.missingPiecesChange = new core_1.EventEmitter();
        this.piecesJointes = [];
        this.maxSize = 2000000;
        this.pieces = [];
        this.otherUploadedFiles = [];
        this.ngInitDone = false;
        this.isReloading = false;
        this.constants = cadens_constants_1.CONSTANTS;
        this.formationsOpen = false;
        this.acceptLabel = 'delete';
        this.reinscription = false;
        this.candidatureAutorisee = true;
        this.jhiLanguageService.setLocations(['candidature', 'global']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    // private reorder: any[] = [];
    EspaceCandidatComponent.sortByDateCreation = function (a, b) {
        if (a.dateCreation > a.dateCreation) {
            return 1;
        }
        else {
            return -1;
        }
    };
    EspaceCandidatComponent.sortByOrder = function (a, b) {
        if (a.ordre !== null && b.ordre !== null) {
            if (a.ordre !== b.ordre) {
                if (a.ordre > b.ordre) {
                    return 1;
                }
                else {
                    return -1;
                }
            }
        }
        else {
            if (a.ordre !== null) {
                return 1;
            }
            if (b.ordre !== null) {
                return -1;
            }
        }
        if (a.dateCreation !== null && b.dateCreation !== null) {
            if (a.dateCreation < b.dateCreation) {
                return 1;
            }
            else {
                return -1;
            }
        }
        return 0;
    };
    EspaceCandidatComponent.isbefore = function (a, b) {
        if (a.parentNode === b.parentNode) {
            for (var cur = a; cur; cur = cur.previousSibling) {
                if (cur === b) {
                    return true;
                }
            }
        }
        return false;
    };
    EspaceCandidatComponent.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    /**
     * ngOnInit is called when the page is loaded
     * Load the candidatures and the parametrage for the page (contains some libelles)
     */
    EspaceCandidatComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.parametrageService.query({ page: cadens_constants_1.CONSTANTS.ESPACECANDIDAT }).subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
        this.rechercheNomFichierAide();
        this.ngInitDone = true;
        this.otherUploadedFiles = [];
        this.ngInitDone = true;
    };
    /**
     * Check if one of the PJ is mandatory and missing
     */
    EspaceCandidatComponent.prototype.isMissingPJ = function () {
        if (this.pieces != null && this.pieces.length > 0) {
            if (this.piecesJointes == null || this.piecesJointes.length === 0) {
                this.missingPieces = true;
            }
            else {
                var piecesMandat_1 = this.pieces.filter(function (p) { return p.obligatoire === true; });
                var pjMandat = this.piecesJointes.filter(function (pj) { return piecesMandat_1.findIndex(function (p) { return p.id === pj.pieceId; }) > -1; });
                this.missingPieces = piecesMandat_1.length > pjMandat.length;
            }
        }
        else {
            this.missingPieces = false;
        }
        this.missingPiecesChange.emit(this.missingPieces);
    };
    /****
     * ngOnChanges is called where change on page
     * ****/
    EspaceCandidatComponent.prototype.ngOnChanges = function (changes) {
        if (((changes['candidatureFormation'] != null
            && changes['candidatureFormation'].previousValue.id != null
            && changes['candidatureFormation'].previousValue.id !== changes['candidatureFormation'].currentValue.id) ||
            (changes['candidatureFormationId'] != null
                && changes['candidatureFormationId'].previousValue != null
                && changes['candidatureFormationId'].previousValue !== changes['candidatureFormationId'].currentValue) ||
            (changes['candidatureFormationFc'] != null
                && changes['candidatureFormationFc'].previousValue != null
                && changes['candidatureFormationFc'].previousValue !== changes['candidatureFormationFc'].currentValue))
            && !this.isReloading
            && this.ngInitDone) {
            this.isReloading = true;
            this.otherUploadedFiles = [];
        }
    };
    /**
     * Load all the candidatures from candidatureFormation for the connected user
     */
    EspaceCandidatComponent.prototype.loadAll = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            if (account.etudiant != null && account.etudiant.numeroEtudiant != null) {
                _this.reinscription = true;
            }
            else {
                if (account.email.endsWith('@ens-lyon.fr')) {
                    _this.candidatureAutorisee = false;
                }
            }
            _this.isLoading = true;
            _this.candidatureFormationService.query({ userId: account.id }).subscribe(function (resCandidature) {
                _this.candidatureFormationService.findCandidatureOrdre({ userId: account.id }).subscribe(function (resOrdre) {
                    var candidatureJson = resCandidature.json();
                    var candidaturesAvecFormation = candidatureJson.filter(function (cf) { return cf.formationId != null; });
                    // Initialisation de la formation de chacune des candidatures
                    if (candidaturesAvecFormation.length === 0) {
                        _this.onSuccess(candidatureJson, resOrdre.json());
                        _this.isLoading = false;
                    }
                    else {
                        forkJoin_1.forkJoin(candidaturesAvecFormation
                            .map(function (candidatureFormation) { return _this.formationService.find(candidatureFormation.formationId); })).subscribe(function (res) {
                            candidaturesAvecFormation.forEach(function (cf, i) { return candidaturesAvecFormation[i].formation = res[i]; });
                            _this.onSuccess(candidatureJson, resOrdre.json());
                            _this.isLoading = false;
                        }, function (err) {
                            _this.isLoading = false;
                            _this.onError(err);
                        });
                    }
                }, function (resOrdre) {
                    _this.isLoading = false;
                    _this.onError(resOrdre);
                });
            }, function (resCandidature) {
                _this.isLoading = false;
                _this.onError(resCandidature);
            });
            _this.categorieFormationService.queryDisponibles({
                etudiantId: account.id,
                reinscription: _this.reinscription,
                lecture: false
            }).subscribe(function (res) {
                var cats = res.json();
                if (cats && cats.length > 0) {
                    if (cats.find(function (cat) { return !cat.disabled; })) {
                        _this.formationsOpen = true;
                    }
                }
            });
        });
    };
    /**
     * Redirect to the candidature on button click
     * @param id
     */
    EspaceCandidatComponent.prototype.open = function (id) {
        this.router.navigate(['/candidature/' + id]);
    };
    EspaceCandidatComponent.prototype.delete = function (id) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.delete.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.delete.title'),
            icon: 'fa fa-trash',
            key: 'confirmDelete',
            accept: function () {
                _this.isLoading = true;
                _this.candidatureFormationService.delete(id).subscribe(function (res) {
                    _this.loadAll();
                }, function (res) {
                    _this.isLoading = false;
                    _this.onError(res);
                });
            }
        });
    };
    /**
     * Le candidat se désiste pour une candidature
     * @param candidatureFormation
     */
    EspaceCandidatComponent.prototype.desistResponse = function (candidatureFormation) {
        var _this = this;
        this.acceptLabel = 'desist';
        var messageValue = candidatureFormation.response === cadens_constants_1.CONSTANTS.AWAITING ?
            'cadensApp.espaceCandidat.desist.questionLC' : 'cadensApp.espaceCandidat.desist.question';
        this.confirmationService.confirm({
            message: this.translateService.instant(messageValue),
            header: this.translateService.instant('cadensApp.espaceCandidat.desist.title'),
            icon: 'fa fa-ban',
            accept: function () {
                _this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation], { statut: cadens_constants_1.CONSTANTS.DESISTED }).subscribe(function (res) {
                    _this.loadAll();
                });
            }
        });
    };
    EspaceCandidatComponent.prototype.onChangeChoix = function (newChoix) {
        this.isClickable = true;
        this.otherUploadedFiles = [];
    };
    /**
     * Le candidat confirme sa venue pour une candidature
     * @param candidatureFormation
     */
    EspaceCandidatComponent.prototype.confirmResponse = function (candidatureFormation) {
        var _this = this;
        this.acceptLabel = 'confirm';
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: function () {
                _this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation], { statut: cadens_constants_1.CONSTANTS.CONFIRMED }).subscribe(function (res) {
                    _this.loadAll();
                });
            }
        });
    };
    EspaceCandidatComponent.prototype.confirmResponseAvecChoix = function (candidatureFormation, choix) {
        var _this = this;
        this.acceptLabel = 'confirm';
        this.choixConfirmation = choix;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: function () {
                _this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation], { statut: cadens_constants_1.CONSTANTS.CONFIRMED, choixConfirmation: _this.choixConfirmation }).subscribe(function (res) {
                    _this.loadAll();
                });
            }
        });
    };
    /** MANAGE Ordre des candidature par DragNDrop (https://www.primefaces.org/primeng/#/dragdrop) **/
    EspaceCandidatComponent.prototype.dragStart = function (event, candidatureF) {
        if (event.target.nodeName === 'LI' && candidatureF.dateSuppression == null && candidatureF.dateValidation != null) {
            // Quand le user pick une candidature, l'enregistrer
            this.draggedCandidature = event.target;
            event.dataTransfer.effectAllowed = 'move';
        }
    };
    EspaceCandidatComponent.prototype.dragEnd = function (event) {
        var _this = this;
        // A la fin du drag&drop, enregistrer le nouvel ordre!
        var updates = [];
        this.cfOrdreModifiable.forEach(function (candidatureFormation) {
            updates.push(candidatureFormation);
        });
        // this.reorder.forEach((candi, index) => {
        //     let candidatureFormation = this.cfOrdreModifiable.find(cf => cf.id === Number(candi));
        //     candidatureFormation.ordre = index + 1;
        //     updates.push(candidatureFormation);
        // });
        if (updates.length > 0) {
            this.isLoading = true;
            this.candidatureFormationService.updateCandidaturesOrder(updates).subscribe(function (res) {
                _this.loadAll();
            }, function (error) {
                _this.isLoading = false;
                _this.onError({ message: 'cadensApp.candidature.messages.error.modificationOrdre' });
            });
        }
        this.draggedCandidature = null;
    };
    EspaceCandidatComponent.prototype.dragEnter = function (event) {
        var target = event.target;
        if (target.nodeName === 'LI' && this.draggedCandidature) {
            if (target.attributes.getNamedItem('draggable') != null) {
                // Appelé pendant le drag&drop process, permet d'insérer un LI avant/après un autre
                if (EspaceCandidatComponent_1.isbefore(this.draggedCandidature, target)) {
                    target.parentNode.insertBefore(this.draggedCandidature, target);
                }
                else {
                    target.parentNode.insertBefore(this.draggedCandidature, target.nextSibling);
                }
                if (target.parentNode.id === 'parentUL') {
                    // Récupérer l'ordre des 'LI' à chaque fois que ça change
                    // this.reorder = [];
                    // L'id des candidature est l'ID du 'LI'
                    var minOrdre_1 = Math.min.apply(Math, this.cfOrdreModifiable.map(function (o) {
                        return o.ordre;
                    }));
                    var _loop_1 = function (i) {
                        // this.reorder.push(target.parentNode.children[i].id) ;
                        this_1.cfOrdreModifiable.filter(function (candidature) {
                            // noinspection JSUnfilteredForInLoop
                            return candidature.id.toString() === target.parentNode.children[i].id;
                        }).forEach(function (candidatureTrouvee) {
                            // noinspection JSUnfilteredForInLoop
                            candidatureTrouvee.ordre = minOrdre_1;
                        });
                        minOrdre_1++;
                    };
                    var this_1 = this;
                    for (var i in target.parentNode.children) {
                        _loop_1(i);
                    }
                }
            }
        }
    };
    EspaceCandidatComponent.prototype.drop = function (event) {
        this.draggedCandidature = null;
    };
    // Open la popup d'aide
    EspaceCandidatComponent.prototype.openAide = function (aideModal) {
        this.modalService.open(aideModal);
    };
    // Generation du document suivants status acceptation, refus, attente
    EspaceCandidatComponent.prototype.genererLettreAdmission = function (candiId, pourReponseCode, sortieListeComplementaire) {
        var _this = this;
        var lc = '_';
        if (sortieListeComplementaire === true) {
            lc = 'lc';
        }
        var fileName = 'reponseENS' + lc + candiId + '.pdf';
        this.candidatureFormationService.genererLettreAdmission(candiId, pourReponseCode, sortieListeComplementaire).subscribe(function (res) {
            shared_1.ExportService.download(res, fileName);
        }, (function (error) {
            _this.onError({ message: 'cadensApp.candidature.messages.error.genererLettreAdmission' });
        }));
    };
    EspaceCandidatComponent.prototype.onSuccess = function (candidatureJson, ordreJson) {
        var _this = this;
        this.cfListeDesOrdres = ordreJson;
        var cfAll;
        cfAll = candidatureJson;
        cfAll.forEach(function (candidature) {
            candidature.ordreModifiable = false;
            if (_this.cfListeDesOrdres !== null) {
                _this.cfListeDesOrdres.forEach(function (ordre) {
                    if (ordre.id === candidature.id) {
                        candidature.ordre = ordre.ordre;
                        if (ordre.ordreModifiable !== null) {
                            candidature.ordreModifiable = ordre.ordreModifiable;
                        }
                    }
                });
            }
        });
        this.cfEnCoursOuSupprimmee = cfAll
            .filter(function (candi) { return candi.dateSuppression !== null || candi.dateValidation === null; })
            .sort(EspaceCandidatComponent_1.sortByDateCreation);
        this.cfOrdreModifiable = cfAll
            .filter(function (candi) { return !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === true; })
            .sort(EspaceCandidatComponent_1.sortByOrder);
        this.cfOrdreNonModifiable = cfAll
            .filter(function (candi) { return !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === false; })
            .sort(EspaceCandidatComponent_1.sortByOrder);
    };
    EspaceCandidatComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    EspaceCandidatComponent.prototype.rechercheNomFichierAide = function () {
        var _this = this;
        this.parametrageService.getFileName(admin_1.AideComponent.categorieAide, 'ROLE_USER').subscribe(function (res) {
            if (res !== null && res.text() !== null && res.text().length > 0) {
                _this.nomFichierAide = res.text();
            }
        }, function (res) { return _this.onError(res); });
    };
    EspaceCandidatComponent.prototype.openFichierAide = function () {
        var _this = this;
        this.parametrageService.getFile(admin_1.AideComponent.categorieAide, 'ROLE_USER').subscribe(function (file) {
            shared_1.ExportService.download(file, 'ROLE_USER');
        }, function (response) {
            _this.onError(response);
        });
    };
    /****** Televerser attestation*/
    // Open la popup d'aide
    EspaceCandidatComponent.prototype.openModalConfirmationEcts180 = function (otherPieceModalAttestation) {
        this.modalService.open(otherPieceModalAttestation);
    };
    // Open a file in a new tab when click on it
    EspaceCandidatComponent.prototype.openFile = function (name) {
        var _this = this;
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe(function (res) {
            var fileUrl = URL.createObjectURL(res);
            window.open(fileUrl);
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    // Autres pièces justificatives
    EspaceCandidatComponent.prototype.addOtherPJ = function (modal, idx, choix, candidatureFormation) {
        this.modalRef = this.modalService.open(modal);
        this.choixConfirmation = choix;
        this.candidatureFormation = candidatureFormation;
        if (!this.otherUploadedFiles) {
            this.otherUploadedFiles = [];
        }
        if (idx !== null) {
            this.lastIdx = idx;
        }
        else {
            this.otherUploadedFiles.push({ pieceId: 1 });
            if (choix === 1) {
                this.otherUploadedFiles.push({ notes: "Attestation sur l'honneur" });
            }
            else {
                this.otherUploadedFiles.push({ notes: 'Attestation de démission' });
            }
            this.lastIdx = this.otherUploadedFiles.length - 1;
        }
    };
    EspaceCandidatComponent.prototype.closeOtherPJ = function () {
        if (this.otherUploadedFiles[this.lastIdx].id === null) {
            this.otherUploadedFiles.pop();
        }
        this.modalRef.close();
    };
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    EspaceCandidatComponent.prototype.onBeforeSend = function (event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', EspaceCandidatComponent_1.getCookie('XSRF-TOKEN'));
    };
    // Before the file is sent to the server for upload
    EspaceCandidatComponent.prototype.onBeforeUpload = function (event, id) {
        this.onBeforeUploadAttestation(event, id);
    };
    // Before the file is sent to the server for upload
    EspaceCandidatComponent.prototype.onBeforeUploadAttestation = function (event, id) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId', this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.candidatureFormation.id);
        /* if (referentId != null) {
             event.formData.append('referentId', referentId);
         }*/
    };
    EspaceCandidatComponent.prototype.onOtherFileUploaded = function (event) {
        var pj = JSON.parse(event.xhr.response);
        var notes = this.otherUploadedFiles[this.lastIdx].notes;
        this.otherUploadedFiles[this.lastIdx] = pj;
        this.otherUploadedFiles[this.lastIdx].notes = notes;
    };
    EspaceCandidatComponent.prototype.saveOtherPJ = function (modal, choix) {
        var _this = this;
        if (this.otherUploadedFiles[this.lastIdx].nom !== null) {
            this.pieceJointeService.update(this.otherUploadedFiles[this.lastIdx]).subscribe(function (res) {
                _this.otherUploadedFiles[_this.lastIdx] = res;
                _this.modalRef.close();
            }, function (error) {
                _this.isSaving = false;
                _this.onError(error);
            });
            // confirmation de la venue
            this.choixConfirmation = choix;
            this.confirmResponseAvecChoix(this.candidatureFormation, this.choixConfirmation);
        }
    };
    EspaceCandidatComponent.prototype.deleteOtherPJ = function () {
        var _this = this;
        this.pieceJointeService.delete(this.otherUploadedFiles[this.lastIdx].id).subscribe(function (res) {
            _this.otherUploadedFiles.splice(_this.lastIdx, 1);
            _this.modalRef.close();
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    EspaceCandidatComponent.prototype.ngOnInitPj = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
        this.isSaving = true;
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {
        }
    };
    return EspaceCandidatComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], EspaceCandidatComponent.prototype, "isSaving", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], EspaceCandidatComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], EspaceCandidatComponent.prototype, "isConfirmable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], EspaceCandidatComponent.prototype, "isClickable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], EspaceCandidatComponent.prototype, "isBO", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], EspaceCandidatComponent.prototype, "candidatureFormationId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", candidature_formation_model_1.CandidatureFormation)
], EspaceCandidatComponent.prototype, "candidatureFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], EspaceCandidatComponent.prototype, "missingPieces", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], EspaceCandidatComponent.prototype, "missingPiecesChange", void 0);
EspaceCandidatComponent = EspaceCandidatComponent_1 = __decorate([
    core_1.Component({
        selector: 'jhi-espace-candidat',
        template: __webpack_require__(438)
    }),
    __metadata("design:paramtypes", [candidature_formation_service_1.CandidatureFormationService,
        shared_1.Principal,
        ng_jhipster_1.JhiLanguageService,
        parametrage_1.ParametrageService,
        formation_1.CategorieFormationService,
        ng_jhipster_1.AlertService,
        router_1.Router,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService,
        ng_bootstrap_1.NgbModal,
        shared_1.ExportService,
        ng2_translate_1.TranslateService,
        formation_1.FormationService,
        piece_jointe_1.PieceJointeService,
        formation_1.PieceService])
], EspaceCandidatComponent);
exports.EspaceCandidatComponent = EspaceCandidatComponent;
var EspaceCandidatComponent_1;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var _1 = __webpack_require__(273);
var faq_component_1 = __webpack_require__(69);
var ENTITY_STATES = _1.faqRoute.slice();
var CadensFaqModule = (function () {
    function CadensFaqModule() {
    }
    return CadensFaqModule;
}());
CadensFaqModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            faq_component_1.FaqComponent
        ],
        entryComponents: [
            faq_component_1.FaqComponent
        ],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensFaqModule);
exports.CadensFaqModule = CadensFaqModule;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var formation_popup_service_1 = __webpack_require__(70);
var formation_service_1 = __webpack_require__(25);
var FormationDeleteDialogComponent = (function () {
    function FormationDeleteDialogComponent(jhiLanguageService, formationService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.formationService = formationService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['formation']);
    }
    FormationDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    FormationDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.formationService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'formationListModification',
                content: 'Deleted an formation'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return FormationDeleteDialogComponent;
}());
FormationDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-delete-dialog',
        template: __webpack_require__(440)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        formation_service_1.FormationService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], FormationDeleteDialogComponent);
exports.FormationDeleteDialogComponent = FormationDeleteDialogComponent;
var FormationDeletePopupComponent = (function () {
    function FormationDeletePopupComponent(route, formationPopupService) {
        this.route = route;
        this.formationPopupService = formationPopupService;
    }
    FormationDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.formationPopupService
                .open(FormationDeleteDialogComponent, params['id']);
        });
    };
    FormationDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return FormationDeletePopupComponent;
}());
FormationDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        formation_popup_service_1.FormationPopupService])
], FormationDeletePopupComponent);
exports.FormationDeletePopupComponent = FormationDeletePopupComponent;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var formation_model_1 = __webpack_require__(71);
var formation_service_1 = __webpack_require__(25);
var piece_service_1 = __webpack_require__(72);
var rxjs_1 = __webpack_require__(14);
var question_service_1 = __webpack_require__(165);
var cadens_constants_1 = __webpack_require__(8);
var listeChoix_service_1 = __webpack_require__(23);
var shared_1 = __webpack_require__(2);
var ng2_page_scroll_1 = __webpack_require__(31);
var platform_browser_1 = __webpack_require__(17);
var demande_modif_service_1 = __webpack_require__(37);
var ng2_translate_1 = __webpack_require__(7);
var FormationDetailComponent = (function () {
    function FormationDetailComponent(jhiLanguageService, formationService, pieceService, questionService, listeChoixService, route, principal, router, alertService, demandeModifsService, dateUtils, pageScrollService, translateService, document) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.formationService = formationService;
        this.pieceService = pieceService;
        this.questionService = questionService;
        this.listeChoixService = listeChoixService;
        this.route = route;
        this.principal = principal;
        this.router = router;
        this.alertService = alertService;
        this.demandeModifsService = demandeModifsService;
        this.dateUtils = dateUtils;
        this.pageScrollService = pageScrollService;
        this.translateService = translateService;
        this.document = document;
        this.constants = cadens_constants_1.CONSTANTS;
        this.formation = new formation_model_1.Formation();
        this.pageEdition = 'informations';
        this.navIsFixed = false;
        this.reloading = false;
        this.uniquementDemandeModif = false;
        this.demandeModifs = [];
        this.formationUtiliseeDansCampagnefuture = true;
        this.isOnlyEnseignant = false;
        this.isOnlyResponsableFormation = false;
        this.isResponsableFormation = false;
        this.isAdminOrGestionnaireOrSystem = false;
        this.isAdmin = false;
        this.isGestionnaire = false;
        this.isEnseignantOrResponsableFormation = false;
        this.uniquementMajPlacesFormation = true;
        this.jhiLanguageService.setLocations(['formation', 'pieceJointe', 'demandeModif']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
        this.translateService.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    }
    FormationDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reloading = true;
        this.subscription = this.route.params.subscribe(function (params) {
            if (params['id'].indexOf(',') > 0) {
                _this.loadAllFormations(params['id']);
            }
            else {
                _this.loadFormation(params['id']);
            }
        });
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.SERVICE }).subscribe(function (services) {
            _this.services = services.json();
        });
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.isAdminOrGestionnaireOrSystem = shared_1.Principal.isAdminOrGestionnaireOrSystem(account.authorities);
            _this.isAdmin = shared_1.Principal.isAdmin(account.authorities);
            _this.isGestionnaire = shared_1.Principal.isGestionnaire(account.authorities);
            _this.isOnlyEnseignant = shared_1.Principal.isOnlyEnseignant(account.authorities);
            // on regarde si la personne est responsable de la formation
            _this.isOnlyResponsableFormation = shared_1.Principal.isOnlyResponsableFormation(account.authorities);
            _this.isResponsableFormation = shared_1.Principal.isResponsableFormation(account.authorities);
            _this.isEnseignantOrResponsableFormation = shared_1.Principal.isEnseignantOrResponsableFormation((account.authorities));
            if (_this.isOnlyResponsableFormation || _this.isResponsableFormation || _this.isEnseignantOrResponsableFormation || _this.isAdminOrGestionnaireOrSystem || _this.isAdmin) {
                _this.uniquementMajPlacesFormation = true;
            }
            _this.uniquementDemandeModif = _this.isOnlyEnseignant;
        });
        this.principal.getIdentityLogin().then(function (login) {
            _this.login = login.toString();
        });
    };
    /**
     * Sélection / Déselection d'une des formation dans la liste
     * @param formation clickée
     */
    FormationDetailComponent.prototype.onClickOnFormation = function (formation) {
        if (this.formation.id === formation.id) {
            this.formation = new formation_model_1.Formation();
            this.displayListesComplementaires();
            this.displayPiecesCommunes(this.formationListe.map(function (f) { return f.id; }));
        }
        else {
            this.reloading = true;
            this.formation = formation;
            this.loadPiecesQuestions(formation.id);
        }
    };
    FormationDetailComponent.prototype.save = function () {
        var _this = this;
        this.reloading = true;
        // Enregistrement d'une formation
        if (this.formation.id !== null) {
            var updates = [this.formationService.update(this.formation)];
            // if (!this.isOnlyResponsableFormation && !this.isOnlyEnseignant && this.pieces != null && this.pieces.length > 0) {
            if (!this.isOnlyEnseignant || this.isResponsableFormation && this.pieces != null && this.pieces.length > 0) {
                this.pieces.forEach(function (piece) { return piece.formationId = _this.formation.id; });
                updates.push(this.pieceService.update(this.pieces));
            }
            if (!this.isOnlyResponsableFormation && !this.isOnlyEnseignant && this.questions != null && this.questions.length > 0) {
                this.questions.forEach(function (question) { return question.formationId = _this.formation.id; });
                updates.push(this.questionService.update(this.questions));
            }
            if (this.demandeModifs !== null && this.demandeModifs.length > 0) {
                this.demandeModifs.forEach(function (demandModif) {
                });
                updates.push(this.demandeModifsService.update(this.demandeModifs));
            }
            rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
                _this.formation = results[0];
                var idx = _this.formationListe.findIndex(function (f) { return f.id === _this.formation.id; });
                _this.formationListe[idx] = _this.formation;
                _this.loadFormation(_this.formation.id);
                _this.loadPiecesQuestions(_this.formation.id);
                _this.formation.surbooking = (_this.formation.nbPlacesSurbooking !== undefined && _this.formation.nbPlacesSurbooking > 0);
                _this.reloading = false;
                _this.alertService.success('cadensApp.formation.updated');
            }, function (error) {
                _this.reloading = false;
                shared_1.JhiAlertComponent.onError(_this.alertService, error);
            });
        }
        else {
            // Enregistrement des infos communes sur toutes les formations de la liste
            var updates_1 = [];
            this.formationListe.forEach(function (formation) {
                formation.lc = _this.formation.lc;
                formation.rang = _this.formation.rang;
                formation.affichageRang = _this.formation.affichageRang;
                formation.users = _this.formation.users;
                formation.nombreReferents = _this.formation.nombreReferents;
                formation.nombreReferentsContact = _this.formation.nombreReferentsContact;
                formation.nombreReferentsObligatoires = _this.formation.nombreReferentsObligatoires;
                formation.lecteurs = _this.formation.lecteurs;
                updates_1.push(_this.formationService.update(formation));
            });
            this.pieces.forEach(function (piece) {
                var pieceCommune = _this.piecesCommunes.filter(function (p) { return p.code === piece.code; });
                if (pieceCommune != null && piece.id != null) {
                    pieceCommune.forEach(function (p) {
                        p.aide = piece.aide;
                        p.libelle = piece.libelle;
                        p.descriptif = piece.descriptif;
                        p.obligatoire = piece.obligatoire;
                    });
                    updates_1.push(_this.pieceService.update(pieceCommune));
                }
                else {
                    // Create new piece for each formation
                    _this.formationListe.forEach(function (formation) {
                        var newPiece = Object.assign({}, piece);
                        newPiece.formationId = formation.id;
                        updates_1.push(_this.pieceService.update([newPiece]));
                    });
                }
            });
            rxjs_1.Observable.forkJoin(updates_1).subscribe(function (results) {
                _this.loadAllFormations(_this.formationListe.map(function (f) { return f.id; }).join(','));
                _this.alertService.success('cadensApp.formation.updatedAll');
            }, function (error) {
                _this.alertService.error(error);
                _this.reloading = false;
            });
        }
    };
    FormationDetailComponent.prototype.errorEventChange = function (event) {
        this.onErrorMessage(event, null);
    };
    FormationDetailComponent.prototype.onErrorMessage = function (message, params) {
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    };
    FormationDetailComponent.prototype.backToListe = function () {
        this.reloading = false;
        if (this.formation !== null) {
            this.router.navigate(['/formation-back/' + this.formation.id]);
        }
        else {
            this.router.navigate(['/formation']);
        }
    };
    FormationDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    FormationDetailComponent.prototype.goToStep = function (step) {
        this.pageEdition = step;
        var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#' + step);
        this.pageScrollService.start(pageScrollInstance);
    };
    FormationDetailComponent.prototype.onChangeLc = function (newLc) {
        if (!newLc) {
            this.formation.rang = false;
            this.formation.affichageRang = false;
        }
    };
    FormationDetailComponent.prototype.onChangeSuppression = function (newLc) {
        if (this.formation.dateSuppression !== null) {
            this.formation.dateSuppression = null;
        }
        else {
            this.formation.dateSuppression = new Date();
        }
    };
    FormationDetailComponent.prototype.onChangeRang = function (newRang) {
        if (!newRang) {
            this.formation.affichageRang = false;
        }
    };
    // noinspection JSMethodCanBeStatic
    FormationDetailComponent.prototype.isDeleted = function (formation) {
        return formation.dateSuppression != null;
    };
    /**
     * In case of several formations edition, display only the pieces in common
     * @param ids of the formations
     */
    FormationDetailComponent.prototype.displayPiecesCommunes = function (ids) {
        var _this = this;
        this.pieces = [];
        if (this.piecesCommunes.length >= ids.length) {
            // Filtrer toutes les pièces avec le même libellé
            var filteredPieces = this.piecesCommunes.filter(function (elem, index, self) {
                return self.findIndex(function (p) { return p.libelle === elem.libelle; }) === index;
            });
            filteredPieces.forEach(function (piece) {
                // Si même nombre de pièces avec ce libelle qu'il y a de formations sélectionnées
                if (_this.piecesCommunes.filter(function (p) { return p.libelle === piece.libelle; }).length === ids.length) {
                    piece.commonIds = _this.piecesCommunes.filter(function (p) { return p.libelle === piece.libelle; }).map(function (p) { return p.id; });
                    _this.pieces.push(piece);
                }
            });
        }
    };
    FormationDetailComponent.prototype.loadAllFormations = function (ids) {
        var _this = this;
        this.formationService.query({ ids: ids }).subscribe(function (res) {
            _this.formationListe = res.json();
            _this.displayListesComplementaires();
            _this.loadReferentsLecteurs();
            _this.formationListe.forEach(function (formation) {
                formation.surbooking = (formation.nbPlacesSurbooking !== undefined && formation.nbPlacesSurbooking > 0);
            });
            _this.reloading = false;
        });
        this.pieceService.query({ formationId: ids }).subscribe(function (res) {
            _this.piecesCommunes = res.json();
            _this.displayPiecesCommunes(ids.split(','));
            _this.reloading = false;
        });
    };
    /**
     * Set the 3 liste complementaire booleans
     */
    FormationDetailComponent.prototype.displayListesComplementaires = function () {
        var _this = this;
        this.formation.lc = true;
        this.formation.rang = true;
        this.formation.affichageRang = true;
        this.formation.nombreReferents = this.formationListe[0].nombreReferents;
        this.formation.nombreReferentsContact = this.formationListe[0].nombreReferentsContact;
        this.formation.nombreReferentsObligatoires = this.formationListe[0].nombreReferentsObligatoires;
        this.formationListe.forEach(function (formation) {
            _this.formation.lc = formation.lc && _this.formation.lc;
            _this.formation.rang = formation.rang && _this.formation.rang;
            _this.formation.affichageRang = formation.affichageRang && _this.formation.affichageRang;
        });
    };
    FormationDetailComponent.prototype.loadFormation = function (id) {
        var _this = this;
        this.formationService.find(id).subscribe(function (formation) {
            _this.formationListe = [formation];
            _this.formation = formation;
            _this.gereDroitFormation();
            var maintenant = new Date();
            _this.formationUtiliseeDansCampagnefuture = false;
            if (_this.formation.campagnes.length > 0) {
                if (_this.formation.campagnes.some(function (campagne) {
                    var ouverture = new Date(campagne.dateOuverture);
                    var fermeture = new Date(campagne.dateFermeture);
                    return ouverture >= maintenant || fermeture >= maintenant;
                })) {
                    _this.formationUtiliseeDansCampagnefuture = true;
                }
            }
            _this.formation.surbooking = (_this.formation.nbPlacesSurbooking !== undefined && _this.formation.nbPlacesSurbooking > 0);
            _this.reloading = false;
            _this.demandeModifsService.query({
                candidatureFormationId: _this.formation.id
            }).subscribe(function (rep) {
                var modifs = rep.json();
                if (modifs != null) {
                    modifs.forEach(function (modif) {
                        modif.createdDate = _this.dateUtils
                            .convertDateTimeFromServer(modif.createdDate);
                        modif.lastModifiedDate = _this.dateUtils
                            .convertDateTimeFromServer(modif.lastModifiedDate);
                    });
                }
                _this.demandeModifs = modifs;
            });
            _this.loadPiecesQuestions(id);
        });
    };
    FormationDetailComponent.prototype.gereDroitFormation = function () {
        var _this = this;
        if (this.isOnlyResponsableFormation && this.formation.users !== null) {
            if (!this.formation.users.some(function (user) { return user.id === _this.currentAccount.id; })) {
                this.isOnlyEnseignant = true;
                this.isOnlyResponsableFormation = false;
                this.isResponsableFormation = false;
                this.uniquementDemandeModif = true;
            }
        }
    };
    FormationDetailComponent.prototype.loadPiecesQuestions = function (id) {
        var _this = this;
        this.pieceService.query({ formationId: id }).subscribe(function (res) {
            _this.pieces = res.json();
            _this.reloading = false;
        });
        this.questionService.query({ formationId: id }).subscribe(function (res) {
            _this.questions = res.json();
            _this.reloading = false;
        });
    };
    /** GESTION DES ENSEIGNANTS LECTEURS ET DES REFERENTS AYANT DROITS DE PORTER DES AVIS **/
    FormationDetailComponent.prototype.loadReferentsLecteurs = function () {
        var _this = this;
        this.formation.users = [];
        this.formation.lecteurs = [];
        var users = this.formationListe.map(function (f) { return f.users; }).reduce(function (a, b) { return a.concat(b); });
        var lecteurs = this.formationListe.map(function (f) { return f.lecteurs; }).reduce(function (a, b) { return a.concat(b); });
        this.formationListe[0].users.forEach(function (user) {
            var temp = users.filter(function (u) { return u.email === user.email; });
            if (_this.formationListe.length === temp.length) {
                _this.formation.users.push(user);
            }
        });
        this.formationListe[0].lecteurs.forEach(function (lecteur) {
            if (_this.formationListe.length === lecteurs.filter(function (u) { return u.email === lecteur.email; }).length) {
                _this.formation.lecteurs.push(lecteur);
            }
        });
    };
    return FormationDetailComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FormationDetailComponent.prototype, "uniquementDemandeModif", void 0);
FormationDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-detail',
        template: __webpack_require__(441)
    }),
    __param(13, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        formation_service_1.FormationService,
        piece_service_1.PieceService,
        question_service_1.QuestionService,
        listeChoix_service_1.ListeChoixService,
        router_1.ActivatedRoute,
        shared_1.Principal,
        router_1.Router,
        ng_jhipster_1.AlertService,
        demande_modif_service_1.DemandeModifService,
        ng_jhipster_1.DateUtils,
        ng2_page_scroll_1.PageScrollService,
        ng2_translate_1.TranslateService, Object])
], FormationDetailComponent);
exports.FormationDetailComponent = FormationDetailComponent;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var formation_popup_service_1 = __webpack_require__(70);
var formation_service_1 = __webpack_require__(25);
var FormationNewDialogComponent = (function () {
    function FormationNewDialogComponent(activeModal, jhiLanguageService, formationService, eventManager, router, alertService) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.formationService = formationService;
        this.eventManager = eventManager;
        this.router = router;
        this.alertService = alertService;
        this.selectedFormations = [];
        this.jhiLanguageService.setLocations(['formation']);
    }
    FormationNewDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = true;
        this.formationService.queryNewFormationsComposant().subscribe(function (res) {
            _this.formations = res.json();
            // this.formations = this.formations.filter(f => f.id == null);
            _this.assignCopy();
            _this.isSaving = false;
            // on passe un index négatif aux nouvelles formations
            var indexFormationView = -1;
            _this.formations.filter(function (f) { return f.id == null; }).forEach(function (fv) {
                fv.id = indexFormationView;
                indexFormationView--;
            });
        }, function (res) {
            _this.isSaving = false;
            _this.onError(res);
            _this.isSaving = false;
        });
    };
    FormationNewDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    FormationNewDialogComponent.prototype.assignCopy = function () {
        this.filteredList = Object.assign([], this.formations);
    };
    FormationNewDialogComponent.prototype.filterFormations = function (value) {
        if (!value) {
            this.assignCopy();
        }
        this.filteredList = Object.assign([], this.formations).filter(function (item) { return item.libelle.toLowerCase().indexOf(value.toLowerCase()) > -1; });
    };
    FormationNewDialogComponent.prototype.selectFormation = function (event, formation, index) {
        this.isSaving = true;
        // In popup Paramétrer une nouvelle formation, selections des formations!
        if (event.shiftKey && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastRowIndex < index) {
                for (var i = this.lastRowIndex + 1; i <= index; i++) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
            else if (this.lastRowIndex > index) {
                for (var i = this.lastRowIndex - 1; i >= index; i--) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
        }
        else {
            this.addSelectedFormation(formation, index);
            this.lastRowIndex = index;
        }
    };
    FormationNewDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = false;
        var newSelectedFormations = [];
        this.selectedFormations.forEach(function (formationId) {
            if (formationId < 0) {
                var formation = _this.formations.find(function (forma) { return forma.id == formationId; });
                formation.id = null;
                _this.formationService.create(formation).subscribe(function (newFormation) {
                    newSelectedFormations.push(newFormation.id);
                });
            }
            else {
                newSelectedFormations.push(formationId);
            }
        });
        this.activeModal.dismiss('cancel');
        setTimeout(function () { return _this.router.navigate(['/formation/' + newSelectedFormations]); }, 500);
    };
    FormationNewDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param formation sélectionnée
     * @param index de la formation dans la liste
     */
    FormationNewDialogComponent.prototype.addSelectedFormation = function (formation, index) {
        this.pushToSelectedFormations(formation.id);
        // if (formation.id) {
        //     this.pushToSelectedFormations(formation.id);
        // } else {
        //     this.formationService.create(formation).subscribe(ff => {
        //         this.filteredList[index] = ff;
        //         this.pushToSelectedFormations(ff.id);
        //     });
        // }
    };
    /**
     * Sélectionner / Déselectionner une formation dans la liste
     * @param id de la formation
     */
    FormationNewDialogComponent.prototype.pushToSelectedFormations = function (id) {
        if (this.selectedFormations.indexOf(id) < 0) {
            this.selectedFormations.push(id);
        }
        else {
            this.selectedFormations.splice(this.selectedFormations.indexOf(id), 1);
        }
        this.isSaving = false;
    };
    return FormationNewDialogComponent;
}());
FormationNewDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-new-dialog',
        template: __webpack_require__(442)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        formation_service_1.FormationService,
        ng_jhipster_1.EventManager,
        router_1.Router,
        ng_jhipster_1.AlertService])
], FormationNewDialogComponent);
exports.FormationNewDialogComponent = FormationNewDialogComponent;
var FormationNewPopupComponent = (function () {
    function FormationNewPopupComponent(route, formationPopupService) {
        this.route = route;
        this.formationPopupService = formationPopupService;
    }
    FormationNewPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.formationPopupService
                .open(FormationNewDialogComponent);
        });
    };
    FormationNewPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return FormationNewPopupComponent;
}());
FormationNewPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-formation-new-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        formation_popup_service_1.FormationPopupService])
], FormationNewPopupComponent);
exports.FormationNewPopupComponent = FormationNewPopupComponent;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var formation_service_1 = __webpack_require__(25);
var shared_1 = __webpack_require__(2);
var router_1 = __webpack_require__(3);
var cadens_constants_1 = __webpack_require__(8);
var parametrage_1 = __webpack_require__(11);
var listeChoix_service_1 = __webpack_require__(23);
var piece_service_1 = __webpack_require__(72);
var ng_bootstrap_1 = __webpack_require__(5);
var rxjs_1 = __webpack_require__(14);
var campagne_1 = __webpack_require__(59);
var demande_modif_service_1 = __webpack_require__(37);
var primeng_1 = __webpack_require__(10);
var ng2_webstorage_1 = __webpack_require__(35);
var ng2_page_scroll_1 = __webpack_require__(31);
var platform_browser_1 = __webpack_require__(17);
var ng2_translate_1 = __webpack_require__(7);
var jsUtil_1 = __webpack_require__(44);
var FormationComponent = FormationComponent_1 = (function () {
    function FormationComponent(jhiLanguageService, formationService, campagneService, listeChoixService, alertService, pieceService, exportService, principal, activatedRoute, router, parametrageService, demandeModifService, activeModal, localStorage, pageScrollService, translateService, document) {
        this.jhiLanguageService = jhiLanguageService;
        this.formationService = formationService;
        this.campagneService = campagneService;
        this.listeChoixService = listeChoixService;
        this.alertService = alertService;
        this.pieceService = pieceService;
        this.exportService = exportService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.parametrageService = parametrageService;
        this.demandeModifService = demandeModifService;
        this.activeModal = activeModal;
        this.localStorage = localStorage;
        this.pageScrollService = pageScrollService;
        this.translateService = translateService;
        this.document = document;
        this.isReferent = false;
        this.isAdmin = false;
        this.isResponsableFormation = false;
        this.isGestionnaire = false;
        this.selectedCampagnesIds = [];
        // Show / Hide selected columns
        this.cols = [
            { label: 'Id', value: 'id' },
            { label: 'Libellé', value: 'libelle' },
            { label: 'Libellé court', value: 'libelleCourt' },
            { label: 'Campagnes', value: 'campagnes' },
            { label: 'Demande modification', value: 'demandeModifs' },
            { label: 'Pré-avis', value: 'avecPreavis' },
            { label: 'Ayant droit de porter des avis', value: 'respoForma' },
            { label: 'Enseignants lecteurs', value: 'lecteurs' },
            { label: 'Liste complémentaire', value: 'lc' },
            { label: 'Utilisation rang', value: 'rang' },
            { label: 'Affichage rang', value: 'affichageRang' },
            { label: 'Appel sur LC auto', value: 'rangAuto' },
            { label: 'Nombre de places', value: 'nombrePlaces' },
            { label: 'Date suppression', value: 'dateSuppression' }
        ];
        this.colsAdmin = [
            { label: 'Surbooking', value: 'surbooking' },
            { label: 'Nb places surbooking', value: 'nbPlacesSurbooking' },
            { label: 'Nb désistements surbooking', value: 'nbDesistementsSurbooking' }
        ];
        // Actions groupées
        this.servicesDialog = false;
        this.piecesDialog = false;
        this.usersDialog = false;
        this.campagnesDialog = false;
        this.paramLCDialog = false;
        this.actions = [];
        this.selectedAction = [];
        this.listeComplementaireTriStateValue = null;
        this.rangTriStateValue = null;
        this.affichageRangTriStateValue = null;
        this.rangAutoTriStateValue = null;
        this.paging = shared_1.PAGING;
        this.jhiLanguageService.setLocations(['formation']);
        this.filters = FormationComponent_1.defaultFilters();
    }
    FormationComponent.getLocalStorageFilterName = function () {
        return 'cadensFormationsFilters';
    };
    FormationComponent.getObjectPropertyValue = function (a, propertyName) {
        var valueProperty = null;
        if (Object.prototype.hasOwnProperty.call(a, propertyName)) {
            valueProperty = a[propertyName];
        }
        return valueProperty;
    };
    // Récupération des filtres enregistrés sur le Local Storage, ou alors des filtres par défaut
    FormationComponent.defaultFilters = function () {
        return {
            filtreAnneeEnCours: { matchMode: 'equals', value: true },
            supprimee: { matchMode: 'equals', value: false },
            selectedColumns: ['libelle', 'libelleCourt', 'campagnes', 'nombrePlaces'],
            sortField: null,
            sortOrder: null,
            searchText: null,
            rowPerPage: 20
        };
    };
    FormationComponent.prototype.loadAll = function () {
        var _this = this;
        this.isLoading = true;
        this.formationService.query({
            userId: this.currentAccount.id,
            supprimee: this.filters.supprimee.value
        }).subscribe(function (res) {
            _this.onSuccess(res.json(), res.headers);
            _this.isLoading = false;
            _this.onInitFilters();
            _this.loadDemandeModif();
            _this.envoiEvenementSearchFilterChange();
            if (_this.backToId != null) {
                var backToId_1 = _this.backToId;
                setTimeout(function () {
                    _this.scrollToFormation(backToId_1);
                }, 1000);
            }
        }, function (res) {
            _this.onError(res);
            _this.isLoading = false;
        });
        this.parametrageService.queryVDipAnnee().subscribe(function (res) {
            if (res != null && res.json() != null && res.json().length > 0) {
                var parametre = res.json()[0];
                _this.annee = Number.parseInt(parametre.libelle);
                _this.miseAJourListeCampagne();
            }
        }, function (res) { return _this.onError(res); });
    };
    // Modification du Nombres de places des formations
    FormationComponent.prototype.savePlaces = function (formation) {
        var _this = this;
        this.formationService.update(formation).subscribe(function (res) {
            _this.isLoading = true;
            // formation.saved = true;
            _this.loadAll();
        }, function (err) {
            _this.onError(err);
        });
    };
    FormationComponent.prototype.scrollToFormation = function (formationId) {
        if (formationId != null) {
            var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#' + formationId);
            this.pageScrollService.start(pageScrollInstance);
        }
    };
    /****************** FILTRES DU TABLEAU DES CANDIDATURES ******************/
    // Mets à jour le tableau au chargement de la page avec les filtres enregistrés
    FormationComponent.prototype.onInitFilters = function () {
        var _this = this;
        var filtersByKey = {};
        Object.keys(this.filters).forEach(function (key) {
            if (_this.filters[key] != null && _this.filters[key].value != null && _this.filters[key].value.length > 0) {
                filtersByKey[key] = _this.filters[key];
            }
        });
        this.dataTable.sortMode = 'single';
        this.dataTable.sortField = this.filters.sortField;
        this.dataTable.sortOrder = this.filters.sortOrder;
        this.dataTable.filters = filtersByKey;
        this.onChangeFiltreAnneeEnCours(this.filters.filtreAnneeEnCours.value);
    };
    FormationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.activatedRoute.params.subscribe(function (params) {
            _this.backToId = params['id'];
        });
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.isReferent = shared_1.Principal.isOnlyEnseignant(account.authorities);
            _this.isAdmin = shared_1.Principal.isAdmin(account.authorities);
            _this.isGestionnaire = shared_1.Principal.isGestionnaire(account.authorities);
            _this.isResponsableFormation = shared_1.Principal.isResponsableFormation(account.authorities);
            _this.getLastFilters();
            _this.rajoutColonneSupprimee();
            _this.loadAll();
            /**Donne les droits sur boutons actions groupées*/
            if (shared_1.Principal.isAdmin(account.authorities)) {
                _this.actions.push({ label: 'Modifier le service', value: 'service' });
            }
            if (shared_1.Principal.isAdminOrGestionnaire(account.authorities)) {
                _this.actions.push({ label: 'Ajouter des ayant droit de porter des avis pédagogiques', value: 'referent' });
            }
            if (shared_1.Principal.isAdminOrGestionnaire(account.authorities) || shared_1.Principal.isResponsableFormation(account.authorities)) {
                _this.actions.push({ label: 'Ajouter des enseignants lecteurs', value: 'lecteurs' });
            }
            if (shared_1.Principal.isAdmin(account.authorities)) {
                _this.actions.push({ label: 'Rattacher des campagnes', value: 'addcampagnes' });
            }
            if (shared_1.Principal.isAdmin(account.authorities)) {
                _this.actions.push({ label: 'Modifier paramètres de la LC', value: 'paramLC' });
            }
        });
    };
    FormationComponent.prototype.ngAfterViewInit = function () {
        var translateKey = 'cadensApp.formation.colonnes';
        var multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(function (translation) {
            jsUtil_1.JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    };
    FormationComponent.prototype.goToFormation = function (formation) {
        if (this.selectedFormations != null && this.selectedFormations.length > 0) {
            if (this.isReferent) {
                this.router.navigate(['/formation/' + this.selectedFormations[0].id]);
            }
            else {
                this.router.navigate(['/formation/' + this.selectedFormations.map(function (f) { return f.id; })]);
            }
        }
        else {
            this.router.navigate(['/formation/' + formation.id]);
        }
    };
    // Selection d'une action groupée
    FormationComponent.prototype.onSelectedAction = function (event) {
        if (this.selectedFormations != null && this.selectedFormations.length > 0) {
            // Sélectionner le service gérant les formations sélectionnées
            if (this.selectedAction.indexOf('service') > -1) {
                this.loadServices();
            }
            else if (this.selectedAction.indexOf('pieces') > -1) {
                // Rattacher des pj aux formations sélectionnées
                this.piecesDialog = true;
            }
            else if (this.selectedAction.indexOf('referent') > -1 || this.selectedAction.indexOf('lecteurs') > -1) {
                // Rattacher des référents de formation ou des enseignants lecteurs à des formations
                this.loadUsersListe();
            }
            else if (this.selectedAction.indexOf('addcampagnes') > -1) {
                // Rattacher les campagnes
                this.loadCampagnesListe();
            }
            else if (this.selectedAction.indexOf('paramLC') > -1) {
                // Modifier les paramètres de la LC
                this.paramLCDialog = true;
            }
        }
        else {
            this.selectedAction = [];
        }
    };
    FormationComponent.prototype.exportCSV = function () {
        var columnsData = this.cols.map(function (col) { return col.label; });
        var colFieldNameDictionary = new shared_1.KeyedCollection();
        this.cols.forEach(function (col) {
            colFieldNameDictionary.Add(col.label, col.value);
        });
        var colHeaderDictionary = new shared_1.KeyedCollection();
        this.cols.forEach(function (col) {
            colHeaderDictionary.Add(col.value, col.label);
        });
        this.exportService.toCSVAvecNomOrigineField(this.formations, columnsData, colFieldNameDictionary, colHeaderDictionary, 'Formations.csv');
    };
    // Handle the SHIFT key on checkbox click / unclick
    FormationComponent.prototype.onRowSelect = function (event, table) {
        var data = table.dataToRender;
        var index = data.findIndex(function (f) { return f.id === event.data.id; });
        if (event.originalEvent.originalEvent.shiftKey === true && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            if (this.lastRowIndex < index) {
                for (var i = this.lastRowIndex + 1; i <= index; i++) {
                    if (table.selection.indexOf(data[i].id) < 0) {
                        // this.selectedFormations.push(data[i].id);
                        table.selection.push(data[i]);
                    }
                    else {
                        // this.selectedFormations.splice(this.selectedFormations.indexOf(data[i].id), 1);
                        table.selection.splice(table.selection.indexOf(data[i]), 1);
                    }
                }
            }
            else if (this.lastRowIndex > index) {
                for (var i = this.lastRowIndex - 1; i >= index; i--) {
                    if (table.selection.indexOf(data[i].id) < 0) {
                        table.selection.push(data[i]);
                    }
                    else {
                        table.selection.splice(table.selection.indexOf(data[i]), 1);
                    }
                }
            }
        }
        else {
            this.lastRowIndex = index;
        }
    };
    // Popup Services gérant la formation
    FormationComponent.prototype.loadServices = function () {
        var _this = this;
        this.servicesDialog = true;
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.SERVICE }).subscribe(function (res) {
            _this.servicesList = res.json();
        });
    };
    FormationComponent.prototype.saveService = function () {
        var _this = this;
        this.formationService.updateService(this.selectedFormations, this.serviceSelected).subscribe(function (res) {
            _this.servicesDialog = false;
            _this.selectedAction = [];
        });
    };
    FormationComponent.prototype.cancelService = function () {
        this.servicesDialog = false;
        this.selectedAction = [];
    };
    // Liste des responsables de formations et des enseignants lecteurs
    FormationComponent.prototype.loadUsersListe = function () {
        this.usersDialog = true;
        this.users = [];
        /*
        let index = this.selectedAction.indexOf('referent') > -1 ? 'users' : 'lecteurs';
        let users = this.selectedFormations.map(f => f[index]).reduce((a, b) => a.concat(b));
        this.selectedFormations[0][index].forEach(user => {
            let temp = users.filter(u => u.email === user.email);
            if (this.selectedFormations.length != null && this.selectedFormations.length === temp.length) {
                this.users.push(user);
            }
        });
         */
    };
    // Liste des campagnes de l'année courants
    FormationComponent.prototype.loadCampagnesListe = function () {
        var _this = this;
        this.campagnesDialog = true;
        this.campagneService.campagnesAnneeCourante().subscribe(function (res) {
            _this.campagnesAnneeCourante = res.json();
        }, function (res) {
            _this.campagnesDialog = false;
            _this.onError(res);
        });
    };
    FormationComponent.prototype.selectCampagne = function (event, formation, index) {
        // In popup Rattacher des campagnes, selections des campagnes!
        if (event.shiftKey && this.lastCampagneRowIndex > -1 && this.lastCampagneRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastCampagneRowIndex < index) {
                for (var i = this.lastCampagneRowIndex + 1; i <= index; i++) {
                    this.addSelectedCampagne(this.campagnesAnneeCourante[i], i);
                }
            }
            else if (this.lastCampagneRowIndex > index) {
                for (var i = this.lastCampagneRowIndex - 1; i >= index; i--) {
                    this.addSelectedCampagne(this.campagnesAnneeCourante[i], i);
                }
            }
        }
        else {
            this.addSelectedCampagne(formation, index);
            this.lastCampagneRowIndex = index;
        }
    };
    FormationComponent.prototype.clearCampagneModal = function () {
        this.activeModal.dismiss('cancel');
        this.campagnesDialog = false;
    };
    FormationComponent.prototype.saveCampagneModal = function () {
        var _this = this;
        this.campagnesDialog = false;
        this.isLoading = true;
        // Rattacher les formations sélectionnées aux campagnes sélectionnées
        var selectedCampagnes = [];
        this.selectedCampagnesIds.forEach(function (campagneId) {
            var campagneadded = _this.campagnesAnneeCourante.find(function (campagne) { return campagne.id == campagneId; });
            if (campagneadded != null) {
                selectedCampagnes.push(campagneadded);
                _this.selectedFormations.forEach(function (formation) {
                    if (!campagneadded.formations.find(function (formationCampagne) { return formationCampagne == formation.id; })) {
                        campagneadded.formations.push(formation.id);
                    }
                });
            }
        });
        if (selectedCampagnes.length > 0) {
            this.campagneService.updateFormations(selectedCampagnes).subscribe(function (res) {
                _this.isLoading = false;
                _this.loadAll();
            }, function (res) {
                _this.isLoading = false;
                _this.onError(res);
            });
        }
        else {
            this.isLoading = false;
        }
    };
    FormationComponent.prototype.attachUsers = function () {
        var _this = this;
        var updates = [];
        // Ajout des lecteurs ou des référents sélectionnés (this.users)
        // qui ne sont pas déjà dans formation.lecteurs (si ajout de lecteurs) ou dans formation.users (si ajout de référents)
        this.selectedFormations.forEach(function (formation) {
            _this.users.forEach(function (user) {
                if (_this.selectedAction.indexOf('lecteurs') > -1) {
                    if (formation.lecteurs.find(function (lecteur) { return user.id === lecteur.id; }) === undefined) {
                        formation.lecteurs.push(user);
                    }
                }
                else if (_this.selectedAction.indexOf('referent') > -1) {
                    if (formation.users.find(function (lecteur) { return user.id === lecteur.id; }) === undefined) {
                        formation.users.push(user);
                    }
                }
            });
            updates.push(_this.formationService.update(formation));
        });
        rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
            _this.usersDialog = false;
            _this.selectedAction = [];
        }, function (error) {
            _this.alertService.error(error);
            _this.usersDialog = false;
            _this.selectedAction = [];
        });
    };
    FormationComponent.prototype.cancelUsers = function () {
        this.usersDialog = false;
        this.selectedAction = [];
    };
    // Popup Pieces jointes sur les formations
    FormationComponent.prototype.savePieces = function () {
        var _this = this;
        if (this.pieces != null && this.pieces.length > 0) {
            var piecesFormations_1 = [];
            this.pieces.forEach(function (piece) {
                _this.selectedFormations.forEach(function (formation) {
                    var copy = Object.assign({}, piece);
                    copy.formationId = formation.id;
                    piecesFormations_1.push(copy);
                });
            });
            this.pieceService.update(piecesFormations_1).subscribe(function (res) {
                _this.piecesDialog = false;
                _this.selectedAction = [];
            });
        }
    };
    FormationComponent.prototype.cancelPieces = function () {
        this.piecesDialog = false;
        this.selectedAction = [];
    };
    // Popup modif parametres LC
    FormationComponent.prototype.saveParamLC = function () {
        var _this = this;
        var updates = [];
        this.selectedFormations.forEach(function (formation) {
            if (_this.listeComplementaireTriStateValue != null) {
                formation.lc = _this.listeComplementaireTriStateValue;
            }
            if (_this.rangTriStateValue != null) {
                formation.rang = _this.rangTriStateValue;
            }
            if (_this.affichageRangTriStateValue != null) {
                formation.affichageRang = _this.affichageRangTriStateValue;
            }
            if (_this.rangAutoTriStateValue != null) {
                formation.rangAuto = _this.rangAutoTriStateValue;
            }
            updates.push(_this.formationService.update(formation));
        });
        rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
            _this.closeParamLC();
        }, function (error) {
            _this.alertService.error(error);
            _this.closeParamLC();
        });
    };
    FormationComponent.prototype.closeParamLC = function () {
        this.paramLCDialog = false;
        this.selectedAction = [];
        this.listeComplementaireTriStateValue = null;
        this.rangTriStateValue = null;
        this.affichageRangTriStateValue = null;
        this.rangAutoTriStateValue = null;
    };
    // noinspection JSMethodCanBeStatic
    FormationComponent.prototype.getFilterColor = function (selecteItems) {
        if (selecteItems != null) {
            if (Array.isArray(selecteItems)) {
                if (selecteItems.length > 0) {
                    return 'orange';
                }
            }
            else {
                return 'orange';
            }
        }
        return 'black';
    };
    FormationComponent.prototype.errorEventChange = function (event) {
        this.onErrorMessage(event, null);
    };
    FormationComponent.prototype.onErrorMessage = function (message, params) {
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    };
    FormationComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    FormationComponent.prototype.miseAJourListeCampagne = function () {
        var _this = this;
        if (this.formations != null) {
            this.formations.forEach(function (formation) {
                return _this.filtreCampagnes(formation.campagnes, _this.filters.filtreAnneeEnCours.value, _this.annee);
            });
        }
    };
    FormationComponent.prototype.filtreCampagnes = function (campagnes, filtreAnnee, annee) {
        if (campagnes != null) {
            if (filtreAnnee == false || annee == null) {
                campagnes.forEach(function (campagne) { return campagne['display'] = true; });
            }
            else {
                campagnes.forEach(function (campagne) { return campagne['display'] =
                    campagne.dateOuverture != null && (new Date(campagne.dateOuverture)).getFullYear() == annee; });
            }
        }
    };
    // filtre sur année en cours
    FormationComponent.prototype.onChangeFiltreAnneeEnCours = function (value) {
        this.filters.filtreAnneeEnCours.value = value;
        this.miseAJourListeCampagne();
    };
    // filtre sur supprimee
    FormationComponent.prototype.onChangeFiltreSupprimee = function (value) {
        this.filters.supprimee.value = value;
        this.rajoutColonneSupprimee();
        this.loadAll();
    };
    FormationComponent.prototype.onNbPlacesSort = function (event) {
        this.sortObjectProperty(event, 'nombrePlaces', this.formations);
    };
    FormationComponent.prototype.onDateSuppressionSort = function (event) {
        this.sortObjectProperty(event, 'dateSuppression', this.formations);
    };
    FormationComponent.prototype.onLibelleSort = function (event) {
        this.sortObjectProperty(event, 'libelle', this.formations);
    };
    FormationComponent.prototype.onPreavisSort = function (event) {
        this.sortObjectProperty(event, 'avecPreavis', this.formations);
    };
    FormationComponent.prototype.onLcSort = function (event) {
        this.sortObjectProperty(event, 'lc', this.formations);
    };
    FormationComponent.prototype.onRangSort = function (event) {
        this.sortObjectProperty(event, 'rang', this.formations);
    };
    FormationComponent.prototype.onAffichageRangSort = function (event) {
        this.sortObjectProperty(event, 'affichageRang', this.formations);
    };
    FormationComponent.prototype.onRangAutoSort = function (event) {
        this.sortObjectProperty(event, 'rangAuto', this.formations);
    };
    FormationComponent.prototype.onSurbookingSort = function (event) {
        // Tri sur le nb places car le champ boolean n'est pas initialisé ici
        this.sortObjectProperty(event, 'nbPlacesSurbooking', this.formations);
    };
    FormationComponent.prototype.onNbPlacesSurbookingSort = function (event) {
        this.sortObjectProperty(event, 'nbPlacesSurbooking', this.formations);
    };
    FormationComponent.prototype.onNbDesistementsSurbookingSort = function (event) {
        this.sortObjectProperty(event, 'nbDesistementsSurbooking', this.formations);
    };
    FormationComponent.prototype.sortObjectProperty = function (event, propertyName, arrayToOrder) {
        var comparer = function (a, b) {
            var result = -1;
            if (a == null && b == null) {
                result = 0;
            }
            else if (a == null) {
                result = -1;
            }
            else if (b == null) {
                result = 1;
            }
            else {
                var aValue = FormationComponent_1.getObjectPropertyValue(a, propertyName);
                var bValue = FormationComponent_1.getObjectPropertyValue(b, propertyName);
                if (aValue != null && bValue == null) {
                    result = 1;
                }
                else if (aValue == null && bValue != null) {
                    result = -1;
                }
                else if (aValue == null && bValue == null) {
                    result = 0;
                }
                else if (aValue > bValue) {
                    result = 1;
                }
                else if (aValue == bValue) {
                    result = 0;
                }
            }
            return result * event.order;
        };
        arrayToOrder.sort(comparer);
    };
    FormationComponent.prototype.onChangeFilterLc = function ($event, field, match) {
        this.dataTable.filter($event.target.value, field, match);
        // this.dataTable.filter($event.target.value,col.field,col.filterMatchMode)
    };
    // Chargement de toutes les filtres de recherche
    FormationComponent.prototype.getLastFilters = function () {
        var _this = this;
        var lastFilters = FormationComponent_1.defaultFilters();
        var localFilters = null;
        try {
            localFilters = this.localStorage.retrieve(FormationComponent_1.getLocalStorageFilterName());
        }
        catch (e) {
            this.localStorage.clear(FormationComponent_1.getLocalStorageFilterName());
        }
        try {
            if (localFilters != null) {
                for (var prop in lastFilters) {
                    if (localFilters.hasOwnProperty(prop)) {
                        if (localFilters[prop] != null && localFilters[prop].hasOwnProperty('value')) {
                            lastFilters[prop].value = localFilters[prop]['value'];
                        }
                        else {
                            lastFilters[prop] = localFilters[prop];
                        }
                    }
                }
                if (localFilters.hasOwnProperty('searchText')) {
                    lastFilters['searchText'] = localFilters['searchText'];
                }
                if (localFilters.hasOwnProperty('rowPerPage')) {
                    lastFilters['rowPerPage'] = localFilters['rowPerPage'];
                }
                // si il y a des colonnes dans les filtres mémorisés qui n'existent pas dans la liste actuelle on reset les filtres
                if (lastFilters.selectedColumns.filter(function (selectedColumn) {
                    return _this.cols.filter(function (col) { return col.value === selectedColumn; }).length === 0;
                }).length > 0) {
                    lastFilters = FormationComponent_1.defaultFilters();
                }
            }
        }
        catch (e) {
            var lastFilters_1 = FormationComponent_1.defaultFilters();
        }
        this.filters = lastFilters;
        if (this.filters.hasOwnProperty('searchText')) {
            this.searchText = this.filters['searchText'];
            this.envoiEvenementSearchFilterChange();
        }
        this.onChangeFiltreAnneeEnCours(lastFilters.filtreAnneeEnCours.value);
        return lastFilters;
    };
    // Enregistrer les filtres de recherche dans le Local Storage
    FormationComponent.prototype.saveFilters = function () {
        this.filters.sortField = this.dataTable.sortField;
        this.filters.sortOrder = this.dataTable.sortOrder;
        this.filters['searchText'] = this.searchText;
        this.filters['rowPerPage'] = this.dataTable.rows != null ? this.dataTable.rows : 20;
        this.localStorage.clear(FormationComponent_1.getLocalStorageFilterName());
        this.localStorage.store(FormationComponent_1.getLocalStorageFilterName(), this.filters);
    };
    // Bouton Reset RAZ ou pas des filtres de recherche
    FormationComponent.prototype.resetFilters = function (raz) {
        this.isLoading = true;
        var previousSupprimee = this.filters.supprimee.value;
        if (raz) {
            this.filters = FormationComponent_1.defaultFilters();
            if (this.filters.hasOwnProperty('searchText')) {
                this.searchText = this.filters['searchText'];
                this.envoiEvenementSearchFilterChange();
            }
            this.onChangeFiltreAnneeEnCours(this.filters.filtreAnneeEnCours.value);
            this.dataTable.reset();
        }
        else {
            this.getLastFilters();
        }
        if (previousSupprimee !== this.filters.supprimee.value) {
            this.loadAll();
        }
        else {
            this.isLoading = false;
        }
    };
    // Enregistrer les filtres de recherche dans le Local Storage
    /*
        saveFilters() {
            let filtersToSave = {} ;
            for (let prop in this.filters) {
                if (this.filters[prop]!=null && this.filters[prop].hasOwnProperty('value')
                   && this.filters[prop].hasOwnProperty('matchMode') ){
                    filtersToSave[prop] = {};
                    filtersToSave[prop]['value']=this.filters[prop].value ;
                    filtersToSave[prop]['matchMode']=this.filters[prop].matchMode ;
                }
            }

            filtersToSave['sortField'] = this.dataTable.sortField;
            filtersToSave['sortOrder'] = this.dataTable.sortOrder;
            filtersToSave['searchText'] = this.filters.searchText;
            this.localStorage.store(this.getLocalStorageFilterName(), filtersToSave);
        }
    */
    FormationComponent.prototype.envoiEvenementSearchFilterChange = function () {
        if (this.searchFilter != null) {
            this.searchFilter.nativeElement.value = this.searchText;
            // si value=null le filtre plante dans dataTable
            if (this.dataTable.value != null) {
                this.searchFilter.nativeElement.dispatchEvent(new Event('keyup'));
            }
        }
    };
    FormationComponent.prototype.rajoutColonneSupprimee = function () {
        if (this.filters.supprimee.value == true && !(this.filters.selectedColumns.indexOf('dateSuppression') > -1)) {
            this.filters.selectedColumns.push('dateSuppression');
        }
    };
    FormationComponent.prototype.loadDemandeModif = function () {
        var _this = this;
        this.demandeModifService.query({
            entityType: 'formation'
        }).subscribe(function (rep) {
            var modifs = rep.json();
            if (modifs != null) {
                modifs.forEach(function (modif) {
                    var formation = _this.formations.find(function (formation) { return formation.id === modif.entityId; });
                    if (formation != null) {
                        if (formation.demandeModifs == null) {
                            formation.demandeModifs = [];
                        }
                        formation.demandeModifs.push(modif);
                    }
                });
            }
        }, function (res) { return _this.onError(res); });
    };
    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param campagne campagne sélectionnée
     * @param index de la formation dans la liste
     */
    FormationComponent.prototype.addSelectedCampagne = function (campagne, index) {
        this.pushToSelectedCampagnes(campagne.id);
    };
    /**
     * Sélectionner / Déselectionner une campagne dans la liste
     * @param id de la campagne
     */
    FormationComponent.prototype.pushToSelectedCampagnes = function (id) {
        if (this.selectedCampagnesIds.indexOf(id) < 0) {
            this.selectedCampagnesIds.push(id);
        }
        else {
            this.selectedCampagnesIds.splice(this.selectedCampagnesIds.indexOf(id), 1);
        }
    };
    FormationComponent.prototype.onSuccess = function (data, headers) {
        this.formations = data;
        this.miseAJourListeCampagne();
        this.paging.length = this.formations.length;
    };
    return FormationComponent;
}());
__decorate([
    core_1.ViewChild('table'),
    __metadata("design:type", primeng_1.DataTable)
], FormationComponent.prototype, "dataTable", void 0);
__decorate([
    core_1.ViewChild('searchFilter'),
    __metadata("design:type", core_1.ElementRef)
], FormationComponent.prototype, "searchFilter", void 0);
FormationComponent = FormationComponent_1 = __decorate([
    core_1.Component({
        selector: 'jhi-formation',
        template: __webpack_require__(443)
    }),
    __param(16, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        formation_service_1.FormationService,
        campagne_1.CampagneService,
        listeChoix_service_1.ListeChoixService,
        ng_jhipster_1.AlertService,
        piece_service_1.PieceService,
        shared_1.ExportService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        parametrage_1.ParametrageService,
        demande_modif_service_1.DemandeModifService,
        ng_bootstrap_1.NgbActiveModal,
        ng2_webstorage_1.LocalStorageService,
        ng2_page_scroll_1.PageScrollService,
        ng2_translate_1.TranslateService, Object])
], FormationComponent);
exports.FormationComponent = FormationComponent;
var FormationComponent_1;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var forms_1 = __webpack_require__(36);
var LinkUserComponent = (function () {
    function LinkUserComponent(userService) {
        var _this = this;
        this.userService = userService;
        this.onErrorEvent = new core_1.EventEmitter();
        this.linkedUsersChange = new core_1.EventEmitter();
        this.userListe = [];
        this.userListeShow = false;
        this.userSearchControl = new forms_1.FormControl();
        this.userSearchControl.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe(function (userSearch) { return _this.searchUserInLdap(userSearch); });
    }
    LinkUserComponent.prototype.ngOnInit = function () {
    };
    /**
     * Select a user to add/remove him to/from the list linkedUsers
     * @param user to add/remove
     */
    LinkUserComponent.prototype.selectUser = function (user) {
        var idx = this.linkedUsers ? this.linkedUsers.findIndex(function (f) { return f.email === user.email; }) : -1;
        if (idx > -1) {
            this.linkedUsers.splice(idx, 1);
        }
        else {
            if (this.linkedUsers == null) {
                this.linkedUsers = [];
            }
            this.linkedUsers.push(user);
        }
        this.linkedUsersChange.emit(this.linkedUsers);
        this.hideUserListeShow();
        this.userSearchControl.setValue('');
        this.userListe = [];
    };
    /**
     * Add a User from an email -> do not have to be internal user
     * The user must exist in Cadens database jhi_user
     */
    LinkUserComponent.prototype.addLdapUser = function (user) {
        if (user != null) {
            this.selectUserByMailInCadens(user.email, user);
        }
    };
    /**
     * Add a User from an email -> do not have to be internal user
     * The user must exist in Cadens database jhi_user
     */
    LinkUserComponent.prototype.addUserByEmail = function (userEmail) {
        if (userEmail != null) {
            this.selectUserByMailInCadens(userEmail, null);
        }
    };
    LinkUserComponent.prototype.selectUserByMailInCadens = function (userEmail, ldapUser) {
        var _this = this;
        this.userService.find(userEmail.toString()).subscribe(function (user) {
            // If found, link him to the formation
            _this.selectUser(user);
            _this.userEmail = null;
        }, function (res) {
            // si user Ldap on le rajoute même si il n'est pas dans Cadens
            if (ldapUser != null) {
                ldapUser.id = -1;
                _this.selectUser(ldapUser);
                _this.userEmail = null;
            }
            else {
                _this.onErrorMessage('cadensApp.formation.error.pasCompteUtilisateurDansCadens', null);
            }
        });
    };
    LinkUserComponent.prototype.onErrorMessage = function (message, params) {
        // JhiAlertComponent.onErrorMessage(this.alertService, message, params);
        this.onErrorEvent.emit(message);
    };
    LinkUserComponent.prototype.showUserListeShow = function () {
        // Show the dropdown of users
        if (this.userListe != null && this.userListe.length > 0) {
            this.userListeShow = true;
        }
    };
    LinkUserComponent.prototype.hideUserListeShow = function () {
        this.userListeShow = false;
    };
    /**
     * Search a user from the LDAP repo on the server and display the list
     * @param search name of the user to search
     */
    LinkUserComponent.prototype.searchUserInLdap = function (search) {
        var _this = this;
        if (search != null && search.length > 3) {
            this.userService.queryLDAP({ search: search }).subscribe(function (res) {
                _this.userListe = res.json();
                _this.userListeShow = true;
            });
        }
    };
    return LinkUserComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], LinkUserComponent.prototype, "linkedUsers", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], LinkUserComponent.prototype, "onErrorEvent", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], LinkUserComponent.prototype, "linkedUsersChange", void 0);
LinkUserComponent = __decorate([
    core_1.Component({
        selector: 'jhi-link-user-component',
        template: __webpack_require__(444)
    }),
    __metadata("design:paramtypes", [shared_1.UserService])
], LinkUserComponent);
exports.LinkUserComponent = LinkUserComponent;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var QuestionService = (function () {
    function QuestionService(http) {
        this.http = http;
        this.resourceUrl = 'api/questions';
        this.resourcePublicUrl = 'api/public/questions';
    }
    QuestionService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    QuestionService.prototype.create = function (question) {
        var copy = Object.assign({}, question);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    QuestionService.prototype.update = function (questions) {
        var copy = questions.slice(0);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    QuestionService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    QuestionService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.categorieIdList) {
            params.set('categorieIdList', req.categorieIdList);
        }
        if (req && req.formationId) {
            params.set('formationId', req.formationId);
        }
        if (req && req.interne != null) {
            params.set('interne', req.interne);
        }
        return this.http.get(this.resourcePublicUrl, { search: params });
    };
    QuestionService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    return QuestionService;
}());
QuestionService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], QuestionService);
exports.QuestionService = QuestionService;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Pays = (function () {
    function Pays(code, pays, paysEn, edition, nationalite, isEuropeens) {
        this.code = code;
        this.pays = pays;
        this.paysEn = paysEn;
        this.edition = edition;
        this.nationalite = nationalite;
        this.isEuropeens = isEuropeens;
    }
    Pays.getPaysInconnu = function (code) {
        var pays = new Pays();
        var libCode;
        if (code != null) {
            libCode = ' [code=' + code + ']';
        }
        else {
            libCode = ' [code=null]';
        }
        pays.code = code;
        pays.pays = 'Inconnu' + libCode;
        pays.paysEn = 'UNKNOWN' + libCode;
        pays.edition = 'Inconnu';
        pays.nationalite = 'Inconnu';
        return pays;
    };
    return Pays;
}());
exports.Pays = Pays;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var historique_popup_service_1 = __webpack_require__(73);
var historique_service_1 = __webpack_require__(30);
var HistoriqueDeleteDialogComponent = (function () {
    function HistoriqueDeleteDialogComponent(jhiLanguageService, historiqueService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.historiqueService = historiqueService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['historique']);
    }
    HistoriqueDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    HistoriqueDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.historiqueService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'historiqueListModification',
                content: 'Deleted an historique'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return HistoriqueDeleteDialogComponent;
}());
HistoriqueDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique-delete-dialog',
        template: __webpack_require__(445)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        historique_service_1.HistoriqueService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], HistoriqueDeleteDialogComponent);
exports.HistoriqueDeleteDialogComponent = HistoriqueDeleteDialogComponent;
var HistoriqueDeletePopupComponent = (function () {
    function HistoriqueDeletePopupComponent(route, historiquePopupService) {
        this.route = route;
        this.historiquePopupService = historiquePopupService;
    }
    HistoriqueDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.historiquePopupService
                .open(HistoriqueDeleteDialogComponent, params['id']);
        });
    };
    HistoriqueDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return HistoriqueDeletePopupComponent;
}());
HistoriqueDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        historique_popup_service_1.HistoriquePopupService])
], HistoriqueDeletePopupComponent);
exports.HistoriqueDeletePopupComponent = HistoriqueDeletePopupComponent;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var historique_service_1 = __webpack_require__(30);
var HistoriqueDetailComponent = (function () {
    function HistoriqueDetailComponent(jhiLanguageService, historiqueService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.historiqueService = historiqueService;
        this.route = route;
        this.jhiLanguageService.setLocations(['historique']);
    }
    HistoriqueDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    HistoriqueDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.historiqueService.find(id).subscribe(function (historique) {
            _this.historique = historique;
        });
    };
    HistoriqueDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    HistoriqueDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return HistoriqueDetailComponent;
}());
HistoriqueDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique-detail',
        template: __webpack_require__(446)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        historique_service_1.HistoriqueService,
        router_1.ActivatedRoute])
], HistoriqueDetailComponent);
exports.HistoriqueDetailComponent = HistoriqueDetailComponent;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var historique_popup_service_1 = __webpack_require__(73);
var historique_service_1 = __webpack_require__(30);
var HistoriqueDialogComponent = (function () {
    function HistoriqueDialogComponent(activeModal, jhiLanguageService, alertService, historiqueService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.historiqueService = historiqueService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['historique']);
    }
    HistoriqueDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    HistoriqueDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    HistoriqueDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.historique.id !== undefined) {
            this.historiqueService.update(this.historique)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.historiqueService.create(this.historique)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    HistoriqueDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'historiqueListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    HistoriqueDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    HistoriqueDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return HistoriqueDialogComponent;
}());
HistoriqueDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique-dialog',
        template: __webpack_require__(447)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        historique_service_1.HistoriqueService,
        ng_jhipster_1.EventManager])
], HistoriqueDialogComponent);
exports.HistoriqueDialogComponent = HistoriqueDialogComponent;
var HistoriquePopupComponent = (function () {
    function HistoriquePopupComponent(route, historiquePopupService) {
        this.route = route;
        this.historiquePopupService = historiquePopupService;
    }
    HistoriquePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.historiquePopupService
                    .open(HistoriqueDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.historiquePopupService
                    .open(HistoriqueDialogComponent);
            }
        });
    };
    HistoriquePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return HistoriquePopupComponent;
}());
HistoriquePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        historique_popup_service_1.HistoriquePopupService])
], HistoriquePopupComponent);
exports.HistoriquePopupComponent = HistoriquePopupComponent;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var historique_service_1 = __webpack_require__(30);
var shared_1 = __webpack_require__(2);
var candidature_1 = __webpack_require__(29);
var HistoriqueComponent = (function () {
    function HistoriqueComponent(jhiLanguageService, historiqueService, parseLinks, alertService, principal, activatedRoute, router, eventManager, route, candidatureFormationService, exportService) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.historiqueService = historiqueService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.route = route;
        this.candidatureFormationService = candidatureFormationService;
        this.exportService = exportService;
        this.candidatureFormation = null;
        this.isLoading = false;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['historique']);
        this.subscription = this.route.params.subscribe(function (params) {
            _this.candidatureFormationId = params['candidatureFormationId'];
        });
    }
    HistoriqueComponent.prototype.loadAll = function () {
        var _this = this;
        this.isLoading = false;
        this.historiqueService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            candidatureId: this.candidatureFormation.candidatureId,
            candidatureFormationId: this.candidatureFormation.id,
            sort: this.sort()
        }).subscribe(function (res) {
            _this.onSuccess(res.json(), res.headers);
        }, function (res) { return _this.onError(res.json()); });
    };
    HistoriqueComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    HistoriqueComponent.prototype.transition = function () {
        if (this.candidatureFormationId != null) {
            this.router.navigate(['/historique/candidatureFormation/' + this.candidatureFormationId], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
        }
        else {
            this.router.navigate(['/historique'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
        }
        this.loadAll();
    };
    HistoriqueComponent.prototype.clear = function () {
        this.page = 0;
        this.router.navigate(['/historique', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    HistoriqueComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.candidatureFormationId != null) {
            this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(function (candidatureFormation) {
                if (candidatureFormation != null) {
                    _this.candidatureFormation = candidatureFormation;
                    _this.loadAll();
                }
            });
        }
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInHistoriques();
    };
    HistoriqueComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    HistoriqueComponent.trackId = function (index, item) {
        return item.id;
    };
    HistoriqueComponent.prototype.registerChangeInHistoriques = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('historiqueListModification', function (response) { return _this.loadAll(); });
    };
    HistoriqueComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    HistoriqueComponent.prototype.onSuccess = function (data, headers) {
        this.isLoading = false;
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.historiques = data;
        this.historiqueService.fillUser(this.historiques);
    };
    HistoriqueComponent.prototype.onError = function (error) {
        this.isLoading = false;
        this.alertService.error(error.message, null, null);
    };
    HistoriqueComponent.prototype.formatData = function (historiqueCode, nomDuChamp, data) {
        var dataFormatee = "";
        if (data != null) {
            var nomDuchampExport = "";
            if (historiqueCode == "STATUT" && (nomDuChamp == "donneeAvant" || nomDuChamp == "donneeApres")) {
                nomDuchampExport = "STATUT";
            }
            if (historiqueCode == "STATUTEI" && (nomDuChamp == "donneeAvant" || nomDuChamp == "donneeApres")) {
                nomDuchampExport = "EI";
            }
            var format = this.exportService.rechercheFormatageDonnee(nomDuchampExport);
            dataFormatee = format(data);
        }
        return dataFormatee;
    };
    HistoriqueComponent.prototype.goToCandidature = function () {
        var _this = this;
        this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(function (candidatureFormation) {
            if (candidatureFormation != null) {
                if (candidatureFormation.reinscription) {
                    _this.router.navigate(['/reinscription/' + candidatureFormation.id]);
                }
                else {
                    _this.router.navigate(['/candidature/' + candidatureFormation.id]);
                }
            }
        });
    };
    return HistoriqueComponent;
}());
HistoriqueComponent = __decorate([
    core_1.Component({
        selector: 'jhi-historique',
        template: __webpack_require__(448)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        historique_service_1.HistoriqueService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        candidature_1.CandidatureFormationService,
        shared_1.ExportService])
], HistoriqueComponent);
exports.HistoriqueComponent = HistoriqueComponent;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Historique = (function () {
    function Historique(id, code, details, donneeAvant, donneeApres, pieceJointeId, userId, candidatureId, candidatureFormationId, dateCreation, 
        //Chargé dynamiquement
        user) {
        this.id = id;
        this.code = code;
        this.details = details;
        this.donneeAvant = donneeAvant;
        this.donneeApres = donneeApres;
        this.pieceJointeId = pieceJointeId;
        this.userId = userId;
        this.candidatureId = candidatureId;
        this.candidatureFormationId = candidatureFormationId;
        this.dateCreation = dateCreation;
        this.user = user;
    }
    return Historique;
}());
exports.Historique = Historique;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var legal_component_1 = __webpack_require__(74);
var _1 = __webpack_require__(301);
var ENTITY_STATES = _1.legalRoute.slice();
var CadensLegalModule = (function () {
    function CadensLegalModule() {
    }
    return CadensLegalModule;
}());
CadensLegalModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            legal_component_1.LegalComponent
        ],
        entryComponents: [
            legal_component_1.LegalComponent
        ],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensLegalModule);
exports.CadensLegalModule = CadensLegalModule;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var cadens_constants_1 = __webpack_require__(8);
var piece_jointe_service_1 = __webpack_require__(26);
var ng_jhipster_1 = __webpack_require__(1);
var FilesComponent = (function () {
    function FilesComponent(pieceJointeService, alertService) {
        this.pieceJointeService = pieceJointeService;
        this.alertService = alertService;
        this.uploadedFiles = [];
        this.maxSize = 4000000;
    }
    FilesComponent.prototype.ngOnInit = function () {
        this.uploadedFiles.push(cadens_constants_1.CONSTANTS.FORMULAIRE_RECOMMANDATION);
    };
    // Open a file in a new tab when click on it
    FilesComponent.prototype.openFile = function (name) {
        if (name == null) {
            name = cadens_constants_1.CONSTANTS.FORMULAIRE_RECOMMANDATION;
        }
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe(function (res) {
            var fileUrl = URL.createObjectURL(res);
            window.open(fileUrl);
        });
    };
    // When the file is uploaded
    FilesComponent.prototype.onFileUploaded = function (event, fileName) {
        this.uploadedFiles[0] = fileName;
        this.alertService.success('cadensApp.parametrage.messages.success', null, null);
    };
    // Before the file is sent to the server for upload
    FilesComponent.prototype.onBeforeUpload = function (event, fileName) {
        event.formData.append('name', fileName);
    };
    // Before the file is sent to the server for upload
    FilesComponent.prototype.onBeforeSend = function (event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
    };
    FilesComponent.prototype.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    return FilesComponent;
}());
FilesComponent = __decorate([
    core_1.Component({
        selector: 'jhi-files-component',
        template: __webpack_require__(450)
    }),
    __metadata("design:paramtypes", [piece_jointe_service_1.PieceJointeService,
        ng_jhipster_1.AlertService])
], FilesComponent);
exports.FilesComponent = FilesComponent;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var parametrage_model_1 = __webpack_require__(175);
var parametrage_service_1 = __webpack_require__(75);
var platform_browser_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(2);
var cadens_constants_1 = __webpack_require__(8);
var ng2_translate_1 = __webpack_require__(7);
var formation_1 = __webpack_require__(9);
var rxjs_1 = __webpack_require__(14);
var listeChoix_service_1 = __webpack_require__(23);
var ParametrageComponent = (function () {
    function ParametrageComponent(document, jhiLanguageService, translate, parametrageService, listeChoixService, categorieFormationService, alertService, principal, dataUtils, pieceService, questionsService) {
        this.document = document;
        this.jhiLanguageService = jhiLanguageService;
        this.translate = translate;
        this.parametrageService = parametrageService;
        this.listeChoixService = listeChoixService;
        this.categorieFormationService = categorieFormationService;
        this.alertService = alertService;
        this.principal = principal;
        this.dataUtils = dataUtils;
        this.pieceService = pieceService;
        this.questionsService = questionsService;
        this.constants = cadens_constants_1.CONSTANTS;
        this.navIsFixed = true;
        this.isSaving = false;
        this.showAddParametre = false;
        this.jhiLanguageService.setLocations(['parametrage', 'formation', 'pieceJointe']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    ParametrageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = true;
        this.goToStep(cadens_constants_1.CONSTANTS.GENERAL);
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    };
    ParametrageComponent.prototype.goToStep = function (step) {
        var _this = this;
        if (step === 'SERVICE') {
            this.listeChoixService.query({ type: 'SERVICE' }).subscribe(function (res) {
                _this.services = res.json();
                _this.pageEdition = step;
            }, function (res) { return _this.onError(res.json()); });
        }
        if (step === 'INTERNATIONAL') {
            this.parametrageService.query({ rubrique: step.toUpperCase() }).subscribe(function (res) {
                _this.convertToParamatrageArray(res.json());
                _this.showAddParametre = step === 'INTERNATIONAL';
                _this.pageEdition = step;
            }, function (res) { return _this.onError(res.json()); });
            this.categorieFormationService.query({ code: step }).subscribe(function (res) {
                var cats = res.json();
                if (cats != null && cats.length > 0) {
                    _this.categorieFormationId = cats[0].id;
                    _this.LoadAll();
                }
                else {
                    _this.categorieFormationId = null;
                    _this.pieces = null;
                    _this.isSaving = false;
                }
            });
        }
        else {
            this.parametrageService.query({ rubrique: step.toUpperCase() }).subscribe(function (res) {
                _this.convertToParamatrageArray(res.json());
                _this.showAddParametre = step === 'FAQ';
                _this.pageEdition = step;
            }, function (res) { return _this.onError(res.json()); });
            this.categorieFormationService.query({ code: step }).subscribe(function (res) {
                var cats = res.json();
                if (cats != null && cats.length > 0) {
                    _this.categorieFormationId = cats[0].id;
                    _this.LoadAll();
                }
                else {
                    _this.categorieFormationId = null;
                    _this.pieces = null;
                    _this.isSaving = false;
                }
            });
        }
    };
    ParametrageComponent.prototype.convertToParamatrageArray = function (res) {
        var parametrages = res;
        var objectParametrages = [];
        parametrages.forEach(function (param) {
            if (param.objet === 'date' && param.libelle != null) {
                // Parse string to Date
                var dateParts = param.libelle.split("/");
                param.date = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
            }
            objectParametrages.push(Object.assign(new parametrage_model_1.Parametrage(), param));
        });
        this.parametrages = objectParametrages;
    };
    ParametrageComponent.prototype.addParametre = function () {
        var newParam = new parametrage_model_1.Parametrage();
        newParam.rubrique = this.pageEdition;
        newParam.typeParam = 'QUESTION';
        newParam.page = this.pageEdition;
        this.parametrages.push(newParam);
    };
    ParametrageComponent.prototype.loadPieces = function () {
        var _this = this;
        var categorieFormationIdList = [];
        categorieFormationIdList.push(this.categorieFormationId);
        this.pieceService.query({ categorieFormationIdList: categorieFormationIdList }).subscribe(function (res) {
            _this.pieces = res.json();
            if (_this.pieces == null) {
                _this.pieces = [];
            }
            _this.isSaving = false;
        }, function (res) {
            _this.onError(res);
            _this.isSaving = false;
        });
    };
    ParametrageComponent.prototype.loadQuestions = function () {
        var _this = this;
        var categorieIdList = [];
        categorieIdList.push(this.categorieFormationId);
        this.questionsService.query({ categorieIdList: categorieIdList }).subscribe(function (res) {
            _this.questions = res.json();
            if (_this.questions == null) {
                _this.questions = [];
            }
            _this.isSaving = false;
        }, function (res) {
            _this.onError(res);
            _this.isSaving = false;
        });
    };
    ParametrageComponent.prototype.LoadAll = function () {
        this.loadPieces();
        this.loadQuestions();
    };
    ParametrageComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        this.parametrages.forEach(function (parametrage) {
            if (parametrage.objet === 'date') {
                parametrage.libelle = parametrage.date.toLocaleDateString();
            }
        });
        this.parametrageService.update(this.parametrages).subscribe(function (result) {
            _this.convertToParamatrageArray(result);
            _this.isSaving = false;
            _this.alertService.success('cadensApp.parametrage.updated');
        });
        if (this.categorieFormationId != null) {
            var updates = [];
            this.pieces.forEach(function (piece) { return piece.categorieFormationId = _this.categorieFormationId; });
            if (this.pieces != null && this.pieces.length > 0) {
                updates.push(this.pieceService.update(this.pieces));
            }
            this.questions.forEach(function (question) { return question.categorieFormationId = _this.categorieFormationId; });
            if (this.questions != null && this.questions.length > 0) {
                updates.push(this.questionsService.update(this.questions));
            }
            rxjs_1.Observable.forkJoin(updates).subscribe(function (results) {
                _this.pieces = [];
                _this.LoadAll();
                _this.alertService.success('cadensApp.parametrage.updated');
            });
        }
    };
    ParametrageComponent.prototype.cancel = function () {
        this.goToStep(this.pageEdition);
    };
    ParametrageComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ParametrageComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ParametrageComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    return ParametrageComponent;
}());
ParametrageComponent = __decorate([
    core_1.Component({
        selector: 'jhi-parametrage',
        template: __webpack_require__(451)
    }),
    __param(0, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [Document,
        ng_jhipster_1.JhiLanguageService,
        ng2_translate_1.TranslateService,
        parametrage_service_1.ParametrageService,
        listeChoix_service_1.ListeChoixService,
        formation_1.CategorieFormationService,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.DataUtils,
        formation_1.PieceService,
        formation_1.QuestionService])
], ParametrageComponent);
exports.ParametrageComponent = ParametrageComponent;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Parametrage = (function () {
    function Parametrage(id, rubrique, code, page, typeParam, objet, objetEn, libelle, libelleEn, date) {
        this.id = id;
        this.rubrique = rubrique;
        this.code = code;
        this.page = page;
        this.typeParam = typeParam;
        this.objet = objet;
        this.objetEn = objetEn;
        this.libelle = libelle;
        this.libelleEn = libelleEn;
        this.date = date;
    }
    Object.defineProperty(Parametrage.prototype, "libelleBoolean", {
        get: function () {
            return this.libelle != null &&
                (typeof this.libelle === 'string' || this.libelle instanceof String) &&
                this.libelle.toLowerCase() == 'true';
        },
        set: function (thebool) {
            this.libelle = thebool != null && thebool == true ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    return Parametrage;
}());
exports.Parametrage = Parametrage;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var piece_jointe_popup_service_1 = __webpack_require__(76);
var piece_jointe_service_1 = __webpack_require__(26);
var PieceJointeDeleteDialogComponent = (function () {
    function PieceJointeDeleteDialogComponent(jhiLanguageService, pieceJointeService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.pieceJointeService = pieceJointeService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }
    PieceJointeDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    PieceJointeDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.pieceJointeService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'pieceJointeListModification',
                content: 'Deleted an pieceJointe'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return PieceJointeDeleteDialogComponent;
}());
PieceJointeDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe-delete-dialog',
        template: __webpack_require__(452)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        piece_jointe_service_1.PieceJointeService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], PieceJointeDeleteDialogComponent);
exports.PieceJointeDeleteDialogComponent = PieceJointeDeleteDialogComponent;
var PieceJointeDeletePopupComponent = (function () {
    function PieceJointeDeletePopupComponent(route, pieceJointePopupService) {
        this.route = route;
        this.pieceJointePopupService = pieceJointePopupService;
    }
    PieceJointeDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.pieceJointePopupService
                .open(PieceJointeDeleteDialogComponent, params['id']);
        });
    };
    PieceJointeDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return PieceJointeDeletePopupComponent;
}());
PieceJointeDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        piece_jointe_popup_service_1.PieceJointePopupService])
], PieceJointeDeletePopupComponent);
exports.PieceJointeDeletePopupComponent = PieceJointeDeletePopupComponent;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var piece_jointe_service_1 = __webpack_require__(26);
var PieceJointeDetailComponent = (function () {
    function PieceJointeDetailComponent(jhiLanguageService, pieceJointeService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.pieceJointeService = pieceJointeService;
        this.route = route;
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }
    PieceJointeDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    PieceJointeDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.pieceJointeService.find(id).subscribe(function (pieceJointe) {
            _this.pieceJointe = pieceJointe;
        });
    };
    PieceJointeDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    PieceJointeDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return PieceJointeDetailComponent;
}());
PieceJointeDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe-detail',
        template: __webpack_require__(453)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        piece_jointe_service_1.PieceJointeService,
        router_1.ActivatedRoute])
], PieceJointeDetailComponent);
exports.PieceJointeDetailComponent = PieceJointeDetailComponent;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var piece_jointe_popup_service_1 = __webpack_require__(76);
var piece_jointe_service_1 = __webpack_require__(26);
var formation_1 = __webpack_require__(9);
var shared_1 = __webpack_require__(2);
var candidature_1 = __webpack_require__(29);
var PieceJointeDialogComponent = (function () {
    function PieceJointeDialogComponent(activeModal, jhiLanguageService, alertService, pieceJointeService, pieceService, userService, candidatureFormationService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.pieceJointeService = pieceJointeService;
        this.pieceService = pieceService;
        this.userService = userService;
        this.candidatureFormationService = candidatureFormationService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }
    PieceJointeDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.pieceService.query().subscribe(function (res) { _this.pieces = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.candidatureFormationService.query().subscribe(function (res) { _this.candidatureformations = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    PieceJointeDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    PieceJointeDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.pieceJointe.id !== undefined) {
            this.pieceJointeService.update(this.pieceJointe)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.pieceJointeService.create(this.pieceJointe)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    PieceJointeDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'pieceJointeListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    PieceJointeDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    PieceJointeDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    PieceJointeDialogComponent.prototype.trackPieceById = function (index, item) {
        return item.id;
    };
    PieceJointeDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    PieceJointeDialogComponent.prototype.trackCandidatureFormationById = function (index, item) {
        return item.id;
    };
    return PieceJointeDialogComponent;
}());
PieceJointeDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe-dialog',
        template: __webpack_require__(454)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        piece_jointe_service_1.PieceJointeService,
        formation_1.PieceService,
        shared_1.UserService,
        candidature_1.CandidatureFormationService,
        ng_jhipster_1.EventManager])
], PieceJointeDialogComponent);
exports.PieceJointeDialogComponent = PieceJointeDialogComponent;
var PieceJointePopupComponent = (function () {
    function PieceJointePopupComponent(route, pieceJointePopupService) {
        this.route = route;
        this.pieceJointePopupService = pieceJointePopupService;
    }
    PieceJointePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.pieceJointePopupService
                    .open(PieceJointeDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.pieceJointePopupService
                    .open(PieceJointeDialogComponent);
            }
        });
    };
    PieceJointePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return PieceJointePopupComponent;
}());
PieceJointePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        piece_jointe_popup_service_1.PieceJointePopupService])
], PieceJointePopupComponent);
exports.PieceJointePopupComponent = PieceJointePopupComponent;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var piece_jointe_service_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(2);
var uib_pagination_config_1 = __webpack_require__(57);
var PieceJointeComponent = (function () {
    function PieceJointeComponent(jhiLanguageService, pieceJointeService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.pieceJointeService = pieceJointeService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }
    PieceJointeComponent.prototype.loadAll = function () {
        var _this = this;
        this.pieceJointeService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    PieceJointeComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    PieceJointeComponent.prototype.transition = function () {
        this.router.navigate(['/piece-jointe'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    PieceJointeComponent.prototype.clear = function () {
        this.page = 0;
        this.router.navigate(['/piece-jointe', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    PieceJointeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInPieceJointes();
    };
    PieceJointeComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    PieceJointeComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    PieceJointeComponent.prototype.registerChangeInPieceJointes = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('pieceJointeListModification', function (response) { return _this.loadAll(); });
    };
    PieceJointeComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    PieceJointeComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.pieceJointes = data;
    };
    PieceJointeComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return PieceJointeComponent;
}());
PieceJointeComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-jointe',
        template: __webpack_require__(455)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        piece_jointe_service_1.PieceJointeService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], PieceJointeComponent);
exports.PieceJointeComponent = PieceJointeComponent;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PieceJointe = (function () {
    function PieceJointe(id, nom, conforme, notes, dateCreation, dateModification, dateConformite, pieceId, userId, candidatureFormationId, referentId) {
        this.id = id;
        this.nom = nom;
        this.conforme = conforme;
        this.notes = notes;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
        this.dateConformite = dateConformite;
        this.pieceId = pieceId;
        this.userId = userId;
        this.candidatureFormationId = candidatureFormationId;
        this.referentId = referentId;
    }
    PieceJointe.getPieceIndex = function (pieceId, referentId) {
        if (referentId == null) {
            return (String(pieceId));
        }
        else {
            return (String(pieceId) + "_" + String(referentId));
        }
    };
    return PieceJointe;
}());
exports.PieceJointe = PieceJointe;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var referent_service_1 = __webpack_require__(182);
var formation_1 = __webpack_require__(9);
// noinspection TypeScriptPreferShortImport
var reponse_service_1 = __webpack_require__(28);
var rxjs_1 = __webpack_require__(14);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var piece_jointe_1 = __webpack_require__(34);
var ng2_page_scroll_1 = __webpack_require__(31);
var platform_browser_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(2);
var parametrage_1 = __webpack_require__(11);
var ReferentDetailComponent = (function () {
    function ReferentDetailComponent(jhiLanguageService, alertService, referentService, translate, reponseService, questionService, confirmationService, translateService, route, pieceService, pieceJointeService, pageScrollService, parametrageService, document) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.referentService = referentService;
        this.translate = translate;
        this.reponseService = reponseService;
        this.questionService = questionService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.route = route;
        this.pieceService = pieceService;
        this.pieceJointeService = pieceJointeService;
        this.pageScrollService = pageScrollService;
        this.parametrageService = parametrageService;
        this.document = document;
        this.isSaving = false;
        this.radios = [];
        this.firstValid = false;
        this.uploadedFiles = [];
        this.otherUploadedFiles = [];
        this.piecesJointes = [];
        this.jhiLanguageService.setLocations(['referent', 'global']);
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    }
    ReferentDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            var key = params['key'];
            var getReferent = _this.referentService.get(key);
            var getPiece = _this.pieceService.findByCode("LETTRE_RECOMMANDATION");
            rxjs_1.Observable.forkJoin([getReferent, getPiece]).subscribe(function (results) {
                _this.referent = results[0].json();
                _this.lettreRecommandation = results[1];
                _this.pieceJointeService.findByReferent(_this.referent.id, _this.referent.key, _this.lettreRecommandation.id, _this.referent.candidatureFormationId).subscribe(function (piecesJointeResp) {
                    _this.piecesJointes.push(piecesJointeResp);
                    _this.piecesJointes.forEach(function (pj) {
                        _this.uploadedFiles[pj.pieceId] = pj;
                    });
                });
                _this.getListeQuestions(_this.referent.id);
            }, function (error) { return _this.onError(error); });
        });
        this.parametrageService.queryURLenSavoirPlusDiplome().subscribe(function (res) {
            if (res != null && res.json() != null && res.json().length > 0) {
                _this.urlEnSavoirPlusDiplome = res.json()[0].libelle;
            }
        }, function (res) { return _this.onError(res); });
    };
    /*   private getReferent(key) {
           this.referentService.get(key).subscribe((res) => {
               this.error = null;
               this.referent = res.json();
               this.getListeQuestions(this.referent.id);
           }, (error) => this.onError(error));
       }
   */
    ReferentDetailComponent.prototype.getListeQuestions = function (referentId) {
        var _this = this;
        if (referentId != null) {
            var getQuestions = this.questionService.query();
            var getReponses = this.reponseService.query({
                referentId: this.referent.id,
                referentKey: this.referent.key
            });
            rxjs_1.Observable.forkJoin([getQuestions, getReponses]).subscribe(function (results) {
                _this.questions = results[0].json();
                var reponses = results[1] != null ? results[1].json() : [];
                _this.questions.forEach(function (question) {
                    question.referentId = _this.referent.id;
                    var rep = reponses.find(function (r) { return question.id === r.question.id; });
                    if (rep) {
                        question.reponse = rep.response;
                    }
                });
                _this.getRadios();
            }, function (error) { return _this.onError(error); });
        }
    };
    ReferentDetailComponent.prototype.getRadios = function () {
        var _this = this;
        if (this.questions != null) {
            this.questions.forEach(function (question) {
                if (question.typeReponse === 'RADIO' && question.reponseComplement != null) {
                    var choix = question.reponseComplement.split('|');
                    var idx = _this.radios.map(function (radio) { return radio.join('|'); }).indexOf(question.reponseComplement);
                    if (idx < 0) {
                        _this.radios.push(choix);
                    }
                }
            });
        }
    };
    ReferentDetailComponent.prototype.save = function () {
        var _this = this;
        var questionsOblig = this.questions.filter(function (question) { return _this.isQuestionObligatoire(question) === true && question.reponse == null; });
        if (questionsOblig == null || questionsOblig.length === 0) {
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.referent.transmit.question'),
                header: this.translateService.instant('cadensApp.referent.transmit.title'),
                icon: 'fa fa-save',
                accept: function () {
                    _this.referent.savedDate = new Date();
                    _this.saveForLater();
                }
            });
        }
        else {
            this.firstValid = true;
            this.onErrorMessage('entity.validation.allRequired');
        }
    };
    ReferentDetailComponent.prototype.saveForLater = function () {
        var _this = this;
        this.isSaving = true;
        var updateRefs = [this.referentService.update(this.referent, this.referent.key)];
        updateRefs.push(this.reponseService.updateAvecReferent(this.questions, this.referent.key));
        rxjs_1.Observable.forkJoin(updateRefs).subscribe(function (result) {
            _this.isSaving = false;
            _this.alertService.success('cadensApp.referent.updated');
        }, function (error) {
            _this.isSaving = false;
            _this.onError(error);
        });
    };
    ReferentDetailComponent.prototype.cancel = function () {
        this.ngOnInit();
    };
    // When the file is uploaded
    ReferentDetailComponent.prototype.onFileUploaded = function (event, id) {
        var pj = JSON.parse(event.xhr.response);
        if (this.uploadedFiles[id] == null) {
            this.uploadedFiles[id] = { nom: pj.nom };
        }
        else {
            this.uploadedFiles[id].nom = pj.nom;
        }
        if (this.piecesJointes.find(function (p) { return p.pieceId === id; })) {
            this.piecesJointes.find(function (p) { return p.pieceId === id; }).nom = pj.nom;
        }
        else {
            this.piecesJointes.push(pj);
        }
        var pageScrollInstance = ng2_page_scroll_1.PageScrollInstance.simpleInstance(this.document, '#transmit');
        this.scroll(this.pageScrollService, pageScrollInstance);
    };
    ReferentDetailComponent.prototype.scroll = function (scrollService, scrollInstance) {
        setTimeout(function () {
            scrollService.start(scrollInstance);
        }, 1000);
    };
    // Before the file is sent to the server for upload
    ReferentDetailComponent.prototype.onBeforeSend = function (event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
    };
    // Before the file is sent to the server for upload
    ReferentDetailComponent.prototype.onBeforeUpload = function (event, id) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId', this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.referent.candidatureFormationId);
        event.formData.append('referentId', this.referent.id);
        event.formData.append('referentKey', this.referent.key);
    };
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    ReferentDetailComponent.prototype.onRemove = function (event, id) {
        event.formData.append('pieceId', id);
    };
    // noinspection JSMethodCanBeStatic
    ReferentDetailComponent.prototype.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    // Open a file in a new tab when click on it
    ReferentDetailComponent.prototype.openFile = function (name) {
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name)
            .subscribe(function (res) {
            var fileUrl = URL.createObjectURL(res);
            window.open(fileUrl);
        });
    };
    // noinspection JSMethodCanBeStatic
    ReferentDetailComponent.prototype.avantDerniereQuestion = function (question) {
        return question.libelle.includes("conclusion") && question.typeReponse == "RADIO";
    };
    ReferentDetailComponent.prototype.isQuestionObligatoire = function (question) {
        if (this.avantDerniereQuestion(question) || this.uploadedFiles[this.lettreRecommandation.id] == null) {
            return question.obligatoire == true;
        }
        else {
            return false;
        }
    };
    ReferentDetailComponent.prototype.onError = function (response) {
        shared_1.JhiAlertComponent.onError(this.alertService, response);
    };
    ReferentDetailComponent.prototype.onErrorMessage = function (message) {
        shared_1.JhiAlertComponent.onErrorMessage(this.alertService, message, null);
    };
    return ReferentDetailComponent;
}());
ReferentDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-referent-detail',
        template: __webpack_require__(456)
    }),
    __param(13, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        referent_service_1.ReferentService,
        ng2_translate_1.TranslateService,
        reponse_service_1.ReponseService,
        formation_1.QuestionService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService,
        router_1.ActivatedRoute,
        formation_1.PieceService,
        piece_jointe_1.PieceJointeService,
        ng2_page_scroll_1.PageScrollService,
        parametrage_1.ParametrageService, Object])
], ReferentDetailComponent);
exports.ReferentDetailComponent = ReferentDetailComponent;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ReferentService = (function () {
    function ReferentService(http) {
        this.http = http;
        this.resourceUrl = 'api/referents';
        this.resourcePublicUrl = 'api/public/referents';
        this.resourceRecommandationUrl = 'api/public/recommandation';
        this.resourceRecommandationDownloadUrl = 'api/public/recommandation/download';
    }
    ReferentService.prototype.create = function (referent) {
        var copy = Object.assign({}, referent);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ReferentService.prototype.update = function (referent, referentKey) {
        var params = new http_1.URLSearchParams();
        if (referentKey != null) {
            params.set('referentKey', referentKey.toString());
        }
        var copy = Object.assign({}, referent);
        return this.http.put(this.resourcePublicUrl, copy, { search: params }).map(function (res) {
            return res.json();
        });
    };
    ReferentService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ReferentService.prototype.get = function (key) {
        var params = new http_1.URLSearchParams();
        params.set('key', key);
        return this.http.get(this.resourceRecommandationUrl, {
            search: params
        }).map(function (res) { return res; });
    };
    /*    openFile(name: string): Observable<any> {
            return this.http.get(`${this.resourceRecommandationDownloadUrl}/${name}`, { responseType: ResponseContentType.Blob }).map(
                (res) => {
                    return new Blob([res.blob()], { type: 'application/pdf' });
                });
        }*/
    ReferentService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    };
    /*    delete(id: number): Observable<Response> {
            return this.http.delete(`${this.resourceUrl}/${id}`);
        }*/
    ReferentService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ReferentService;
}());
ReferentService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ReferentService);
exports.ReferentService = ReferentService;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ErrorComponent = (function () {
    function ErrorComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['global']);
    }
    ErrorComponent.prototype.ngOnInit = function () {
    };
    return ErrorComponent;
}());
ErrorComponent = __decorate([
    core_1.Component({
        selector: 'jhi-error',
        template: __webpack_require__(458)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], ErrorComponent);
exports.ErrorComponent = ErrorComponent;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ProfileInfo = (function () {
    function ProfileInfo() {
    }
    return ProfileInfo;
}());
exports.ProfileInfo = ProfileInfo;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var AccountService = (function () {
    function AccountService(http) {
        this.http = http;
    }
    AccountService.prototype.get = function () {
        return this.http.get('api/account', { withCredentials: true }).map(function (res) { return res.json(); });
    };
    AccountService.prototype.save = function (account) {
        account.birthDate = new Date(Date.UTC(account.birthDate.getFullYear(), account.birthDate.getMonth(), account.birthDate.getDate()));
        return this.http.post('api/account', account);
    };
    return AccountService;
}());
AccountService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AccountService);
exports.AccountService = AccountService;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var _1 = __webpack_require__(2);
var UserRouteAccessService = (function () {
    function UserRouteAccessService(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    UserRouteAccessService.prototype.canActivate = function (route) {
        return this.auth.authorize(false).then(function (canActivate) { return canActivate; });
    };
    return UserRouteAccessService;
}());
UserRouteAccessService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router, _1.AuthService])
], UserRouteAccessService);
exports.UserRouteAccessService = UserRouteAccessService;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var __1 = __webpack_require__(2);
var ExportService = ExportService_1 = (function () {
    function ExportService() {
    }
    ExportService.getFileExtension = function (fileName) {
        var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var extension = fileName.match(regexp);
        return extension && extension[1];
    };
    ExportService.formatOuiNon = function (data, record) {
        if (data != null) {
            if (data === true) {
                return 'Oui';
            }
            if (data === false) {
                return 'Non';
            }
            return data;
        }
        return '';
    };
    ExportService.formatEI = function (data, record) {
        if (data != null) {
            if (data === 0 || data === '0') {
                return 'Non concerné';
            }
            if (data === 1 || data === '1') {
                return 'En échange';
            }
            if (data === 2 || data === '2') {
                return 'Hors échange';
            }
            return data;
        }
        return '';
    };
    ExportService.formatQuestionsComplementaires = function (data, candidatureFormation) {
        var reponseString = '';
        if (candidatureFormation !== null && candidatureFormation.reponses != null) {
            candidatureFormation.reponses.forEach(function (reponse) {
                reponseString.length === 0 ? reponseString +=
                    ExportService_1.buildReponseLibelle(reponse) : reponseString += '\n' + ExportService_1.buildReponseLibelle(reponse);
            });
        }
        return reponseString;
    };
    ExportService.formatQuestionsComplementairesParColonne = function (question, candidatureFormation) {
        var reponseString = '';
        if (candidatureFormation != null && candidatureFormation.reponses != null) {
            candidatureFormation.reponses.forEach(function (reponse) {
                if ((ExportService_1.QUESTION_PREFIX + reponse.question.libelle) === question && reponse.response != null) {
                    reponseString = reponse.response;
                }
            });
        }
        return reponseString;
    };
    ExportService.formatRespoForma = function (data, formation) {
        var reponseString = '';
        if (formation != null && formation.users != null) {
            formation.users.forEach(function (user) {
                reponseString.length === 0 ?
                    reponseString += ExportService_1.formatUser(user) :
                    reponseString += '\n' + ExportService_1.formatUser(user);
            });
        }
        return reponseString;
    };
    ExportService.formatLecteurs = function (data, formation) {
        var reponseString = '';
        if (formation != null && formation.lecteurs != null) {
            formation.lecteurs.forEach(function (lecteur) {
                reponseString.length === 0 ?
                    reponseString += ExportService_1.formatUser(lecteur) :
                    reponseString += '\n' + ExportService_1.formatUser(lecteur);
            });
        }
        return reponseString;
    };
    ExportService.formatUser = function (user) {
        return user.lastNameUsage + ' ' + user.firstName + ' (' + user.email + ')';
    };
    ExportService.buildReponseLibelle = function (reponse) {
        return ('[' + ExportService_1.textTruncate(reponse.question.libelle, 50) + '] ' + reponse.response)
            .replace(/<\/?[^>]+(>|$)/g, '').replace(':', '');
    };
    ExportService.formatRang = function (rang, record) {
        var rangString = '';
        if (rang !== undefined && record !== null && record['lc'] !== undefined && record['lc'] !== null) {
            if (record['lc'] === true) {
                rangString = ExportService_1.formatOuiNon(rang, record);
            }
        }
        return rangString;
    };
    ExportService.formatRangAuto = function (rangAuto, record) {
        var rangString = '';
        if (rangAuto !== undefined && record !== null && record['lc'] !== undefined
            && record['lc'] !== null && record['rang'] !== undefined && record['rang'] !== null) {
            if (record['lc'] === true && record['rang'] === true) {
                rangString = ExportService_1.formatOuiNon(rangAuto, record);
            }
        }
        return rangString;
    };
    ExportService.formatFC = function (data, record) {
        if (data != null) {
            if (data === true) {
                return 'Oui';
            }
            else {
                return 'Non';
            }
        }
        return '';
    };
    ExportService.formatStatut = function (data, record) {
        if (data != null) {
            if (record != null && record['dateSuppression'] != null) {
                return 'Supprimé';
            }
            if (data === 'FINISHED') {
                return 'Transmis';
            }
            if (data === 'CREATED') {
                return 'En cours';
            }
            if (data === 'FAVORABLE') {
                return 'Favorable';
            }
            if (data === 'NOTFAVORABLE') {
                return 'Défavorable';
            }
            if (data === 'SUCCESS') {
                return 'Admis';
            }
            if (data === 'DESISTED') {
                return 'Désistement';
            }
            return data;
        }
        return '';
    };
    ExportService.formatData = function (data, record) {
        if (data !== null) {
            if (data === true) {
                return 'Oui';
            }
            if (data === false) {
                return 'Non';
            }
            if (data === 'FINISHED') {
                return 'Transmis';
            }
            if (data === 'CREATED') {
                return 'En cours';
            }
            if (data === 'FAVORABLE') {
                return 'Favorable';
            }
            if (data === 'NOTFAVORABLE') {
                return 'Défavorable';
            }
            if (data === 'SUCCESS') {
                return 'Admis';
            }
            /* if (data === 'REJECTED') { return 'Admis'; }
            if (data === 'DESISTED') { return 'Admis'; }
            //if (data === 'AWAITING') { return 'Admis'; }
            if (data === 'AWAITING') { return 'Admis en LC'; }
            if (data === 'CONFIRMED') { return 'Admis'; }
            if (data === 'NOTCONFORME') { return 'Admis'; }
            if (data === 'CONFORME') { return 'Admis'; }*/
            if (data === 'REJECTED') {
                return 'Refusé';
            }
            if (data === 'DESISTED') {
                return 'Désistement confirmé';
            }
            // if (data === 'AWAITING') { return 'Admis'; }
            if (data === 'AWAITING') {
                return 'Admis en LC';
            }
            if (data === 'CONFIRMED') {
                return 'Venue confirmée';
            }
            if (data === 'NOTCONFORME') {
                return 'Non conforme';
            }
            if (data === 'CONFORME') {
                return 'Conforme';
            }
            if (data === 'MASTER') {
                return 'Master';
            }
            if (data === 'CPES') {
                return 'CPES';
            }
            if (data === 'DIPLOME') {
                return 'Diplôme de l\'ENS';
            }
            if (data === 'AUTRES') {
                return 'Autres';
            }
            if (data === 'fc') {
                return 'Formation continue';
            }
            if (typeof data === 'string') {
                data = data.replace('REJECTED', 'Refusé');
                data = data.replace('DESISTED', 'Désistement confirmé');
                data = data.replace('AWAITING', 'Liste complémentaire');
                data = data.replace('CONFIRME', 'Venue confirmée');
                data = data.replace('NOTCONFO', 'Non conforme');
                data = data.replace('CONFORME', 'Conforme');
                data = data.replace(/;/g, '/'); // Replace All ;
            }
            return data;
        }
        return '';
    };
    ExportService.download = function (blob, filename) {
        if (this.getFileExtension(filename) == null) {
            if (blob.type === 'application/pdf') {
                filename += '.pdf';
            }
            else if (blob.type === 'image/jpeg') {
                filename += '.jpeg';
            }
            else if (blob.type === 'application/msword') {
                filename += '.docx';
            }
            else if (blob.type === 'image/png') {
                filename += '.png';
            }
        }
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename); // For IE
        }
        else {
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none;');
            var url = URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.target = '_blank';
            a.click();
            URL.revokeObjectURL(url);
        }
    };
    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param selectedColumns
     * @param filename
     */
    ExportService.prototype.toCSV = function (table, selectedColumns, filename) {
        this.toCSVAvecNomOrigineField(table, selectedColumns, null, null, filename);
    };
    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param nomOrigineFieldList
     * @param selectedColumns
     * @param colHeaderDictionary
     * @param filename
     */
    ExportService.prototype.toCSVAvecNomOrigineField = function (table, selectedColumns, nomOrigineFieldList, colHeaderDictionary, filename) {
        var _this = this;
        var formatColumns = new __1.KeyedCollection();
        if (selectedColumns !== null) {
            selectedColumns.forEach(function (column) {
                var nomOrigineField = column;
                if (nomOrigineFieldList !== null && nomOrigineFieldList.ContainsKey(column)) {
                    nomOrigineField = nomOrigineFieldList.Item(column);
                }
                var format = _this.rechercheFormatageDonnee(nomOrigineField);
                formatColumns.Add(nomOrigineField, format);
            });
        }
        this.toFormatedCSV(table, selectedColumns, formatColumns, nomOrigineFieldList, colHeaderDictionary, filename);
    };
    ExportService.prototype.rechercheFormatageDonnee = function (nomOrigineField) {
        var format;
        if (nomOrigineField.startsWith(ExportService_1.QUESTION_PREFIX)) {
            format = ExportService_1.formatQuestionsComplementairesParColonne;
        }
        else {
            switch (nomOrigineField.toUpperCase()) {
                case 'STATUT':
                    format = ExportService_1.formatStatut;
                    break;
                case 'FC':
                    format = ExportService_1.formatFC;
                    break;
                case 'EI':
                    format = ExportService_1.formatEI;
                    break;
                case 'CAMPAGNES':
                    format = this.formatCampagnes;
                    break;
                case 'DEMANDEMODIFS':
                    format = this.formatDemandeModification;
                    break;
                case 'RANG':
                    format = ExportService_1.formatRang;
                    break;
                case 'RANGAUTO':
                    format = ExportService_1.formatRangAuto;
                    break;
                case 'QUESTIONSCOMPLEMENTAIRES':
                    format = ExportService_1.formatQuestionsComplementaires;
                    break;
                case 'RESPOFORMA':
                    format = ExportService_1.formatRespoForma;
                    break;
                case 'LECTEURS':
                    format = ExportService_1.formatLecteurs;
                    break;
                default:
                    format = ExportService_1.formatData;
                    break;
            }
        }
        return format;
    };
    /**
     * Export a table with the selected columns to a CSV file
     * @param table
     * @param selectedColumns
     * @param formatColumns
     * @param nomOrigineFieldList
     * @param colHeaderDictionary
     * @param filename
     */
    ExportService.prototype.toFormatedCSV = function (table, selectedColumns, formatColumns, nomOrigineFieldList, colHeaderDictionary, filename) {
        var csv = '';
        // headers
        for (var i = 0; i < selectedColumns.length; i++) {
            if (selectedColumns[i]) {
                var colName = selectedColumns[i];
                if (colHeaderDictionary != null) {
                    if (colHeaderDictionary.ContainsKey(colName)) {
                        colName = colHeaderDictionary.Item(colName);
                    }
                }
                csv += '"' + colName.replace(/<\/?[^>]+(>|$)/g, '').replace(ExportService_1.QUESTION_PREFIX, '').replace(/"/g, '""') + '"';
                if (i < (selectedColumns.length - 1)) {
                    csv += ';';
                }
            }
        }
        // body
        table.forEach(function (record) {
            csv += '\n';
            for (var i = 0; i < selectedColumns.length; i++) {
                var nomOrigineField = selectedColumns[i].toString();
                if (nomOrigineFieldList != null && nomOrigineFieldList.ContainsKey(nomOrigineField)) {
                    nomOrigineField = nomOrigineFieldList.Item(nomOrigineField).toString();
                }
                if (nomOrigineField != null && nomOrigineField.length > 0) {
                    var splitedNom = nomOrigineField.split('.');
                    if (splitedNom.length === 1 || nomOrigineField.startsWith(ExportService_1.QUESTION_PREFIX)) {
                        var format = formatColumns.Item(nomOrigineField);
                        if (format !== null) {
                            csv += '"' + format(record[nomOrigineField], record) + '"';
                        }
                        else {
                            csv += '"' + record[nomOrigineField] + '"';
                        }
                        if (i < (selectedColumns.length - 1)) {
                            csv += ';';
                        }
                    }
                    else {
                        // resolveFieldData seems to check if field is nested e.g. data.something --> probably not needed
                        var format = formatColumns.Item(nomOrigineField);
                        if (record[splitedNom[0]] != null) {
                            if (format != null) {
                                csv += '"' + format(record[splitedNom[0]][splitedNom[1]], record) + '"';
                            }
                            else {
                                csv += '"' + record[splitedNom[0]][splitedNom[1]] + '"';
                            }
                        }
                        if (i < (selectedColumns.length - 1)) {
                            csv += ';';
                        }
                    }
                }
            }
        });
        // Blob is important for UTF-8 encoding !!
        var blob = new Blob(['\ufeff', csv]);
        ExportService_1.download(blob, filename);
    };
    ExportService.prototype.formatCampagnes = function (campagnes, record) {
        var campagneString = '';
        if (campagnes != null) {
            campagnes.forEach(function (campagne) {
                if (campagne.display !== undefined && campagne.display === true) {
                    campagneString.length === 0 ? campagneString += campagne.libelle : campagneString += '\n' + campagne.libelle;
                }
            });
        }
        return campagneString;
    };
    ExportService.prototype.formatDemandeModification = function (demandeModifs, record) {
        var demandeString = '';
        if (demandeModifs != null) {
            demandeModifs.forEach(function (demande) {
                if (demande != null) {
                    demandeString.length === 0 ? demandeString += demande.titre : demandeString += '\n' + demande.titre;
                }
            });
        }
        return demandeString;
    };
    return ExportService;
}());
ExportService.QUESTION_PREFIX = 'Q: ';
ExportService.textTruncate = function (str, length) {
    if (length == null) {
        length = 100;
    }
    var ending = '...';
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    }
    else {
        return str;
    }
};
ExportService = ExportService_1 = __decorate([
    core_1.Injectable()
], ExportService);
exports.ExportService = ExportService;
var ExportService_1;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
    Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    They are written in English to avoid character encoding issues (not a perfect solution)
*/
exports.LANGUAGES = [
    'fr',
    'en'
];


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var SpinnerComponent = (function () {
    function SpinnerComponent() {
    }
    return SpinnerComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SpinnerComponent.prototype, "display", void 0);
SpinnerComponent = __decorate([
    core_1.Component({
        selector: 'jhi-spinner',
        template: __webpack_require__(462)
    }),
    __metadata("design:paramtypes", [])
], SpinnerComponent);
exports.SpinnerComponent = SpinnerComponent;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var KeyedCollection = (function () {
    function KeyedCollection() {
        this.items = {};
        this.count = 0;
    }
    KeyedCollection.prototype.ContainsKey = function (key) {
        return this.items.hasOwnProperty(key);
    };
    KeyedCollection.prototype.Count = function () {
        return this.count;
    };
    KeyedCollection.prototype.Add = function (key, value) {
        if (!this.items.hasOwnProperty(key)) {
            this.count++;
        }
        this.items[key] = value;
    };
    KeyedCollection.prototype.Remove = function (key) {
        var val = this.items[key];
        delete this.items[key];
        this.count--;
        return val;
    };
    KeyedCollection.prototype.Item = function (key) {
        return this.items[key];
    };
    KeyedCollection.prototype.Keys = function () {
        var keySet = [];
        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                keySet.push(prop);
            }
        }
        return keySet;
    };
    KeyedCollection.prototype.Values = function () {
        var values = [];
        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                values.push(this.items[prop]);
            }
        }
        return values;
    };
    return KeyedCollection;
}());
exports.KeyedCollection = KeyedCollection;


/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__ = __webpack_require__(47);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageScrollInstance; });
/**
 * Created by sebastianfuss on 29.08.16.
 */



/**
 * Represents a scrolling action
 */
var PageScrollInstance = (function () {
    /**
     * Private constructor, requires the properties assumed to be the bare minimum.
     * Use the factory methods to create instances:
     *      {@link PageScrollInstance#simpleInstance}
     *      {@link PageScrollInstance#newInstance}
     * @param namespace
     * @param document
     */
    function PageScrollInstance(namespace, document) {
        /**
         * These properties will be set during instance construction and default to their defaults from PageScrollConfig
         */
        /* A namespace to "group" scroll animations together and stopping some does not stop others */
        this._namespace = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._defaultNamespace;
        /* Whether we scroll vertically (true) or horizontally (false) */
        this._verticalScrolling = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultIsVerticalScrolling;
        /* Offset in px that the animation should stop above that target element */
        this._offset = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultScrollOffset;
        /* Duration in milliseconds the scroll animation should last */
        this._duration = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultDuration;
        /* Easing function to manipulate the scrollTop/scrollLeft value over time */
        this._easingLogic = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultEasingLogic;
        /* Boolean whether the scroll animation should stop on user interruption or not */
        this._interruptible = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultInterruptible;
        /* Whether the advanded offset calculation for inline scrolling should be used */
        this._advancedInlineOffsetCalculation = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultAdvancedInlineOffsetCalculation;
        /* Event emitter to notify the world about the scrolling */
        this._pageScrollFinish = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * These properties will be set/manipulated if the scroll animation starts
         */
        /* The initial value of the scrollTop or scrollLeft position when the animation starts */
        this._startScrollPosition = 0;
        /* Whether an interrupt listener is attached to the body or not */
        this._interruptListenersAttached = false;
        /* References to the timer instance that is used to perform the scroll animation to be
         able to clear it on animation end*/
        this._timer = null;
        this._namespace = namespace;
        this.document = document;
    }
    /*
     * Factory methods for instance creation
     */
    PageScrollInstance.simpleInstance = function (document, scrollTarget, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            namespace: namespace
        });
    };
    PageScrollInstance.newInstance = function (options) {
        if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.namespace) || options.namespace.length <= 0) {
            options.namespace = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._defaultNamespace;
        }
        var pageScrollInstance = new PageScrollInstance(options.namespace, document);
        if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.scrollingViews) || options.scrollingViews.length === 0) {
            pageScrollInstance._isInlineScrolling = false;
            pageScrollInstance._scrollingViews = [document.documentElement, document.body, document.body.parentNode];
        }
        else {
            pageScrollInstance._isInlineScrolling = true;
            pageScrollInstance._scrollingViews = options.scrollingViews;
        }
        pageScrollInstance._scrollTarget = options.scrollTarget;
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.verticalScrolling)) {
            pageScrollInstance._verticalScrolling = options.verticalScrolling;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollOffset)) {
            pageScrollInstance._offset = options.pageScrollOffset;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollEasingLogic)) {
            pageScrollInstance._easingLogic = options.pageScrollEasingLogic;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollDuration)) {
            pageScrollInstance._duration = options.pageScrollDuration;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollFinishListener)) {
            pageScrollInstance._pageScrollFinish = options.pageScrollFinishListener;
        }
        pageScrollInstance._interruptible = options.pageScrollInterruptible ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollInterruptible) && __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultInterruptible);
        pageScrollInstance._advancedInlineOffsetCalculation = options.advancedInlineOffsetCalculation ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.advancedInlineOffsetCalculation) &&
                __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */].defaultAdvancedInlineOffsetCalculation);
        return pageScrollInstance;
    };
    /**
     * Create a PageScrollInstance representing a scroll animation on the documents body.
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param verticalScrolling
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     **/
    PageScrollInstance.simpleDirectionInstance = function (document, scrollTarget, verticalScrolling, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            namespace: namespace,
            verticalScrolling: verticalScrolling,
        });
    };
    /**
     * Create a PageScrollInstance representing a scroll animation to the target element where the scrollingView
     * elements get scrolled (like a div container with fixed height, resulting in scrollbars in it).
     *
     * Make sure that the scrollTarget is located inside the scrollingView in the DOM hierarchy, otherwise the
     * scrollingView will be scrolled to an apparently arbitrary position.
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingView The element that should be scrolled
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.simpleInlineInstance = function (document, scrollTarget, scrollingView, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: [scrollingView],
            verticalScrolling: true,
            namespace: namespace
        });
    };
    /**
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingView The element that should be scrolled
     * @param verticalScrolling whether the scrolling should be performed in vertical direction (true, default) or horizontal (false)
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.simpleInlineDirectionInstance = function (document, scrollTarget, scrollingView, verticalScrolling, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: [scrollingView],
            namespace: namespace,
            verticalScrolling: verticalScrolling,
        });
    };
    /**
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingViews The elements that should be scrolled. Null to use the default elements of document and body.
     * @param namespace Optional namespace to group scroll animations logically
     * @param verticalScrolling whether the scrolling should be performed in vertical direction (true, default) or horizontal (false)
     * @param pageScrollOffset The offset to be attached to the top of the target element or
     *                          null/undefined to use application default
     * @param pageScrollInterruptible Whether this scroll animation should be interruptible.
     *                                 Null/undefined for application default
     * @param pageScrollEasingLogic Easing function to be used for manipulating the scroll position
     *                          over time. Null/undefined for application default
     * @param pageScrollDuration The duration in milliseconds the animation should last.
     *                            Null/undefined for application default
     * @param pageScrollFinishListener Listener to be called to notify other parts of the application
     *                                  that the scroll animation has finished
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.advancedInstance = function (document, scrollTarget, scrollingViews, namespace, verticalScrolling, pageScrollOffset, pageScrollInterruptible, pageScrollEasingLogic, pageScrollDuration, pageScrollFinishListener) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: scrollingViews,
            namespace: namespace,
            verticalScrolling: verticalScrolling,
            pageScrollOffset: pageScrollOffset,
            pageScrollInterruptible: pageScrollInterruptible,
            pageScrollEasingLogic: pageScrollEasingLogic,
            pageScrollDuration: pageScrollDuration,
            pageScrollFinishListener: pageScrollFinishListener
        });
    };
    PageScrollInstance.prototype.getScrollPropertyValue = function (scrollingView) {
        if (!this.verticalScrolling) {
            return scrollingView.scrollLeft;
        }
        return scrollingView.scrollTop;
    };
    /**
     * Extract the exact location of the scrollTarget element.
     *
     * Extract the scrollTarget HTMLElement from the given PageScrollTarget object. The latter one may be
     * a string like "#heading2", then this method returns the corresponding DOM element for that id.
     *
     * @returns {HTMLElement}
     */
    PageScrollInstance.prototype.extractScrollTargetPosition = function () {
        var scrollTargetElement;
        if (typeof this._scrollTarget === 'string') {
            scrollTargetElement = this.document.getElementById(this._scrollTarget.substr(1));
        }
        else {
            scrollTargetElement = this._scrollTarget;
        }
        if (scrollTargetElement === null || scrollTargetElement === undefined) {
            // Scroll target not found
            return { top: NaN, left: NaN };
        }
        if (this._isInlineScrolling) {
            var position = { top: scrollTargetElement.offsetTop, left: scrollTargetElement.offsetLeft };
            if (this._advancedInlineOffsetCalculation && this.scrollingViews.length === 1) {
                var accumulatedParentsPos = { top: 0, left: 0 };
                // not named window to make sure we're not getting the global window variable by accident
                var theWindow = scrollTargetElement.ownerDocument.defaultView;
                var parentFound = false;
                // Start parent is the immediate parent
                var parent_1 = scrollTargetElement.parentElement;
                // Iterate upwards all parents
                while (!parentFound && !__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(parent_1)) {
                    if (theWindow.getComputedStyle(parent_1).getPropertyValue('position') === 'relative') {
                        accumulatedParentsPos.top += parent_1.offsetTop;
                        accumulatedParentsPos.left += parent_1.offsetLeft;
                    }
                    // Next iteration
                    parent_1 = parent_1.parentElement;
                    parentFound = parent_1 === this.scrollingViews[0];
                }
                if (parentFound) {
                    // Only use the results if we found the parent, otherwise we accumulated too much anyway
                    position.top += accumulatedParentsPos.top;
                    position.left += accumulatedParentsPos.left;
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._logLevel >= 2) {
                        console.warn('Unable to find nested scrolling targets parent!');
                    }
                }
            }
            return position;
        }
        return __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].extractElementPosition(this.document, scrollTargetElement);
    };
    /**
     * Get the top offset of the scroll animation.
     * This automatically takes the offset location of the scrolling container/scrolling view
     * into account (for nested/inline scrolling).
     *
     * @returns {number}
     */
    PageScrollInstance.prototype.getCurrentOffset = function () {
        return this._offset;
    };
    /**
     * Sets the "scrollTop" or "scrollLeft" property for all scrollingViews to the provided value
     * @param position
     * @return true if at least for one ScrollTopSource the scrollTop/scrollLeft value could be set and it kept the new value.
     *          false if it failed for all ScrollingViews, meaning that we should stop the animation
     *          (probably because we're at the end of the scrolling region)
     */
    PageScrollInstance.prototype.setScrollPosition = function (position) {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._logLevel >= 5) {
            console.warn('Scroll Position: ' + position);
        }
        // Set the new scrollTop/scrollLeft to all scrollingViews elements
        return this.scrollingViews.reduce(function (oneAlreadyWorked, scrollingView) {
            var startScrollPropertyValue = _this.getScrollPropertyValue(scrollingView);
            if (scrollingView && !__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(startScrollPropertyValue)) {
                var scrollDistance = Math.abs(startScrollPropertyValue - position);
                // The movement we need to perform is less than 2px
                // This we consider a small movement which some browser may not perform when
                // changing the scrollTop/scrollLeft property
                // Thus in this cases we do not stop the scroll animation, although setting the
                // scrollTop/scrollLeft value "fails"
                var isSmallMovement = scrollDistance < __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._minScrollDistance;
                if (!_this.verticalScrolling) {
                    scrollingView.scrollLeft = position;
                }
                else {
                    scrollingView.scrollTop = position;
                }
                // Return true of setting the new scrollTop/scrollLeft value worked
                // We consider that it worked if the new scrollTop/scrollLeft value is closer to the
                // desired scrollTop/scrollLeft than before (it might not be exactly the value we
                // set due to dpi or rounding irregularities)
                if (isSmallMovement || scrollDistance > Math.abs(_this.getScrollPropertyValue(scrollingView) - position)) {
                    return true;
                }
            }
            return oneAlreadyWorked;
        }, false);
    };
    /**
     * Trigger firing a animation finish event
     * @param value Whether the animation finished at the target (true) or got interrupted (false)
     */
    PageScrollInstance.prototype.fireEvent = function (value) {
        if (this._pageScrollFinish) {
            this._pageScrollFinish.emit(value);
        }
    };
    /**
     * Attach the interrupt listeners to the PageScrollInstance body. The given interruptReporter
     * will be called if any of the attached events is fired.
     *
     * Possibly attached interruptListeners are automatically removed from the body before the new one will be attached.
     *
     * @param interruptReporter
     */
    PageScrollInstance.prototype.attachInterruptListeners = function (interruptReporter) {
        var _this = this;
        if (this._interruptListenersAttached) {
            // Detach possibly existing listeners first
            this.detachInterruptListeners();
        }
        this._interruptListener = function (event) {
            interruptReporter.report(event, _this);
        };
        __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._interruptEvents.forEach(function (event) { return _this.document.body.addEventListener(event, _this._interruptListener); });
        this._interruptListenersAttached = true;
    };
    /**
     * Remove event listeners from the body and stop listening for events that might be treated as "animation
     * interrupt" events.
     */
    PageScrollInstance.prototype.detachInterruptListeners = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["b" /* PageScrollConfig */]._interruptEvents.forEach(function (event) { return _this.document.body.removeEventListener(event, _this._interruptListener); });
        this._interruptListenersAttached = false;
    };
    Object.defineProperty(PageScrollInstance.prototype, "namespace", {
        get: function () {
            return this._namespace;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "scrollTarget", {
        get: function () {
            return this._scrollTarget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "verticalScrolling", {
        get: function () {
            return this._verticalScrolling;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "scrollingViews", {
        get: function () {
            return this._scrollingViews;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "startScrollPosition", {
        get: function () {
            return this._startScrollPosition;
        },
        set: function (value) {
            this._startScrollPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "targetScrollPosition", {
        get: function () {
            return this._targetScrollPosition;
        },
        set: function (value) {
            this._targetScrollPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "distanceToScroll", {
        get: function () {
            return this._distanceToScroll;
        },
        set: function (value) {
            this._distanceToScroll = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "easingLogic", {
        get: function () {
            return this._easingLogic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "interruptible", {
        get: function () {
            return this._interruptible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "startTime", {
        get: function () {
            return this._startTime;
        },
        set: function (value) {
            this._startTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "endTime", {
        get: function () {
            return this._endTime;
        },
        set: function (value) {
            this._endTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "timer", {
        get: function () {
            return this._timer;
        },
        set: function (value) {
            this._timer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "interruptListenersAttached", {
        get: function () {
            return this._interruptListenersAttached;
        },
        enumerable: true,
        configurable: true
    });
    return PageScrollInstance;
}());



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng2_page_scroll_instance__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ng2_page_scroll_util_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng2_page_scroll_config__ = __webpack_require__(46);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageScroll; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};







var PageScroll = (function () {
    function PageScroll(pageScrollService, router, document) {
        this.pageScrollService = pageScrollService;
        this.router = router;
        this.pageScrollHorizontal = null;
        this.pageScrollOffset = null;
        this.pageScrollDuration = null;
        this.pageScrollEasing = null;
        this.pageScrollAdjustHash = false;
        this.pageScroll = null;
        this.pageScrollFinish = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.document = document;
    }
    PageScroll.prototype.ngOnChanges = function (changes) {
        // Some inputs changed, reset the pageScrollInstance
        this.pageScrollInstance = undefined;
    };
    PageScroll.prototype.ngOnDestroy = function () {
        if (this.pageScrollInstance) {
            this.pageScrollService.stop(this.pageScrollInstance);
        }
        return undefined;
    };
    PageScroll.prototype.generatePageScrollInstance = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(this.pageScrollInstance)) {
            this.pageScrollInstance = __WEBPACK_IMPORTED_MODULE_4__ng2_page_scroll_instance__["a" /* PageScrollInstance */].newInstance({
                document: this.document,
                scrollTarget: this.href,
                scrollingViews: null,
                namespace: this.pageScroll,
                verticalScrolling: !this.pageScrollHorizontal,
                pageScrollOffset: this.pageScrollOffset,
                pageScrollInterruptible: this.pageScrollInterruptible,
                pageScrollEasingLogic: this.pageScrollEasing,
                pageScrollDuration: this.pageScrollDuration,
                pageScrollFinishListener: this.pageScrollFinish
            });
        }
        return this.pageScrollInstance;
    };
    PageScroll.prototype.pushRouterState = function () {
        if (this.pageScrollAdjustHash && typeof this.pageScrollInstance.scrollTarget === 'string'
            && this.pageScrollInstance.scrollTarget.substr(0, 1) === '#') {
            // "Navigate" to the current route again and this time set the fragment/hash
            this.router.navigate([], {
                fragment: this.pageScrollInstance.scrollTarget.substr(1),
                preserveQueryParams: true
            });
        }
    };
    PageScroll.prototype.scroll = function () {
        var pageScrollInstance = this.generatePageScrollInstance();
        this.pushRouterState();
        this.pageScrollService.start(pageScrollInstance);
    };
    PageScroll.prototype.handleClick = function (clickEvent) {
        var _this = this;
        if (this.routerLink && this.router !== null && this.router !== undefined) {
            var urlTree = void 0;
            if (typeof this.routerLink === 'string') {
                urlTree = this.router.parseUrl(this.routerLink);
            }
            else {
                urlTree = this.router.createUrlTree(this.routerLink);
            }
            if (!this.router.isActive(urlTree, true)) {
                // We need to navigate their first.
                // Navigation is handled by the routerLink directive
                // so we only need to listen for route change
                var subscription_1 = this.router.events.subscribe(function (routerEvent) {
                    if (routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationEnd"]) {
                        subscription_1.unsubscribe();
                        _this.scroll();
                    }
                    else if (routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationError"] || routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationCancel"]) {
                        subscription_1.unsubscribe();
                    }
                });
                return false; // to preventDefault()
            }
        }
        this.scroll();
        return false; // to preventDefault()
    };
    return PageScroll;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PageScroll.prototype, "routerLink", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PageScroll.prototype, "href", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PageScroll.prototype, "pageScrollHorizontal", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], PageScroll.prototype, "pageScrollOffset", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], PageScroll.prototype, "pageScrollDuration", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_6__ng2_page_scroll_config__["a" /* EasingLogic */])
], PageScroll.prototype, "pageScrollEasing", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PageScroll.prototype, "pageScrollInterruptible", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PageScroll.prototype, "pageScrollAdjustHash", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PageScroll.prototype, "pageScroll", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"])
], PageScroll.prototype, "pageScrollFinish", void 0);
PageScroll = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: '[pageScroll]',
        host: {
            '(click)': 'handleClick($event)',
        }
    }),
    __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DOCUMENT"])),
    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_service__["a" /* PageScrollService */], __WEBPACK_IMPORTED_MODULE_1__angular_router__["Router"], Object])
], PageScroll);



/***/ }),
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(612);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(815);

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
__webpack_require__(470);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(17);
var ng2_webstorage_1 = __webpack_require__(35);
var shared_1 = __webpack_require__(2);
var home_1 = __webpack_require__(78);
var account_module_1 = __webpack_require__(207);
var entity_module_1 = __webpack_require__(269);
var admin_module_1 = __webpack_require__(19);
var layouts_1 = __webpack_require__(79);
var http_provider_1 = __webpack_require__(238);
var uib_pagination_config_1 = __webpack_require__(57);
var ng2_page_scroll_1 = __webpack_require__(31);
var ng_bootstrap_1 = __webpack_require__(5);
var jsUtil_1 = __webpack_require__(44);
var CadensAppModule = (function () {
    function CadensAppModule() {
    }
    return CadensAppModule;
}());
CadensAppModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            layouts_1.LayoutRoutingModule,
            ng2_page_scroll_1.Ng2PageScrollModule.forRoot(),
            ng2_webstorage_1.Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
            shared_1.CadensSharedModule,
            home_1.CadensHomeModule,
            account_module_1.CadensAccountModule,
            entity_module_1.CadensEntityModule,
            admin_module_1.CadensAdminModule
        ],
        declarations: [
            layouts_1.JhiMainComponent,
            layouts_1.NavbarComponent,
            layouts_1.ErrorComponent,
            layouts_1.PageRibbonComponent,
            layouts_1.ActiveMenuDirective,
            layouts_1.FooterComponent
        ],
        providers: [
            layouts_1.ProfileService,
            { provide: Window, useValue: window },
            { provide: Document, useValue: document },
            { provide: core_1.LOCALE_ID, useValue: 'fr-FR' },
            http_provider_1.customHttpProvider(),
            uib_pagination_config_1.PaginationConfig,
            shared_1.UserRouteAccessService,
            ng_bootstrap_1.NgbActiveModal,
            jsUtil_1.JsUtil
        ],
        bootstrap: [layouts_1.JhiMainComponent]
    })
], CadensAppModule);
exports.CadensAppModule = CadensAppModule;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var app_constants_1 = __webpack_require__(49);
function ProdConfig() {
    // disable debug data on prod profile to improve performance
    if (!app_constants_1.DEBUG_INFO_ENABLED) {
        core_1.enableProdMode();
    }
}
exports.ProdConfig = ProdConfig;


/***/ }),
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(437);

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(50);
var CadensAccountModule = (function () {
    function CadensAccountModule() {
    }
    return CadensAccountModule;
}());
CadensAccountModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            router_1.RouterModule.forRoot(_1.accountState, { useHash: true }),
            primeng_1.CalendarModule,
            primeng_1.InputTextModule,
            primeng_1.RadioButtonModule
        ],
        declarations: [
            _1.ActivateComponent,
            _1.RegisterComponent,
            _1.RegisterConfirmationComponent,
            _1.PasswordComponent,
            _1.PasswordStrengthBarComponent,
            _1.PasswordResetInitComponent,
            _1.PasswordResetFinishComponent,
            _1.SessionsComponent,
            _1.SettingsComponent,
            _1.JhiLoginComponent
        ],
        providers: [
            _1.SessionsService,
            _1.Register,
            _1.LoginService,
            _1.Activate,
            _1.Password,
            _1.PasswordResetInit,
            _1.PasswordResetFinish
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensAccountModule);
exports.CadensAccountModule = CadensAccountModule;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _1 = __webpack_require__(50);
var ACCOUNT_ROUTES = [
    _1.activateRoute,
    _1.passwordRoute,
    _1.passwordResetFinishRoute,
    _1.passwordResetInitRoute
].concat(_1.registerRoute, [
    _1.sessionsRoute,
    _1.settingsRoute,
    _1.loginRoute
]);
exports.accountState = [{
        path: '',
        children: ACCOUNT_ROUTES
    }];


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var activate_component_1 = __webpack_require__(84);
exports.activateRoute = {
    path: 'activate',
    component: activate_component_1.ActivateComponent,
    data: {
        authorities: [],
        pageTitle: 'activate.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var login_component_1 = __webpack_require__(86);
exports.loginRoute = {
    path: 'login',
    component: login_component_1.JhiLoginComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.login'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var password_reset_finish_component_1 = __webpack_require__(88);
exports.passwordResetFinishRoute = {
    path: 'reset/finish',
    component: password_reset_finish_component_1.PasswordResetFinishComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var password_reset_init_component_1 = __webpack_require__(90);
exports.passwordResetInitRoute = {
    path: 'reset/request',
    component: password_reset_init_component_1.PasswordResetInitComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var PasswordStrengthBarComponent = (function () {
    function PasswordStrengthBarComponent(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];
    }
    PasswordStrengthBarComponent.prototype.measureStrength = function (p) {
        var force = 0;
        var regex = /[$-/:-?{-~!"^_`\[\]]/g; // "
        var lowerLetters = /[a-z]+/.test(p);
        var upperLetters = /[A-Z]+/.test(p);
        var numbers = /[0-9]+/.test(p);
        var symbols = regex.test(p);
        var flags = [lowerLetters, upperLetters, numbers, symbols];
        var passedMatches = flags.filter(function (isMatchedFlag) {
            return isMatchedFlag === true;
        }).length;
        force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
        force += passedMatches * 10;
        // penality (short password)
        force = (p.length <= 6) ? Math.min(force, 10) : force;
        // penality (poor variety of characters)
        force = (passedMatches === 1) ? Math.min(force, 10) : force;
        force = (passedMatches === 2) ? Math.min(force, 20) : force;
        force = (passedMatches === 3) ? Math.min(force, 40) : force;
        return force;
    };
    ;
    PasswordStrengthBarComponent.prototype.getColor = function (s) {
        var idx = 0;
        if (s <= 10) {
            idx = 0;
        }
        else if (s <= 20) {
            idx = 1;
        }
        else if (s <= 30) {
            idx = 2;
        }
        else if (s <= 40) {
            idx = 3;
        }
        else {
            idx = 4;
        }
        return { idx: idx + 1, col: this.colors[idx] };
    };
    ;
    Object.defineProperty(PasswordStrengthBarComponent.prototype, "passwordToCheck", {
        set: function (password) {
            if (password) {
                var c = this.getColor(this.measureStrength(password));
                var element = this.elementRef.nativeElement;
                if (element.className) {
                    this.renderer.setElementClass(element, element.className, false);
                }
                var lis = element.getElementsByTagName('li');
                for (var i = 0; i < lis.length; i++) {
                    if (i < c.idx) {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', c.col);
                    }
                    else {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', '#DDD');
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return PasswordStrengthBarComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PasswordStrengthBarComponent.prototype, "passwordToCheck", null);
PasswordStrengthBarComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-strength-bar',
        template: "\n        <div id=\"strength\">\n            <small jhiTranslate=\"global.messages.validate.newpassword.strength\">Password strength:</small>\n            <ul id=\"strengthBar\">\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n            </ul>\n        </div>",
        styles: [
            __webpack_require__(463)
        ]
    }),
    __metadata("design:paramtypes", [core_1.Renderer, core_1.ElementRef])
], PasswordStrengthBarComponent);
exports.PasswordStrengthBarComponent = PasswordStrengthBarComponent;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var password_component_1 = __webpack_require__(92);
exports.passwordRoute = {
    path: 'password',
    component: password_component_1.PasswordComponent,
    data: {
        authorities: ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var register_component_1 = __webpack_require__(95);
var register_confirmation_component_1 = __webpack_require__(94);
exports.registerRoute = [{
        path: 'register',
        component: register_component_1.RegisterComponent,
        data: {
            authorities: [],
            pageTitle: 'register.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'register-confirmation',
        component: register_confirmation_component_1.RegisterConfirmationComponent,
        data: {
            authorities: [],
            pageTitle: 'register.confirmation.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }];


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Session = (function () {
    function Session(series, tokenDate, ipAddress, userAgent) {
        this.series = series;
        this.tokenDate = tokenDate;
        this.ipAddress = ipAddress;
        this.userAgent = userAgent;
    }
    return Session;
}());
exports.Session = Session;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var sessions_component_1 = __webpack_require__(96);
exports.sessionsRoute = {
    path: 'sessions',
    component: sessions_component_1.SessionsComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.sessions'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var settings_component_1 = __webpack_require__(98);
exports.settingsRoute = {
    path: 'settings',
    component: settings_component_1.SettingsComponent,
    data: {
        authorities: ['ROLE_USER', 'ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'],
        pageTitle: 'global.menu.account.settings'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _1 = __webpack_require__(54);
var shared_1 = __webpack_require__(2);
var ADMIN_ROUTES = [
    _1.auditsRoute,
    _1.configurationRoute,
    _1.archiveRoute,
    _1.docsRoute,
    _1.healthRoute,
    _1.logsRoute
].concat(_1.userMgmtRoute, [
    _1.metricsRoute
]);
exports.adminState = [
    {
        path: '',
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM']
        },
        canActivate: [shared_1.UserRouteAccessService],
        children: ADMIN_ROUTES
    },
    {
        path: 'user_echange',
        pathMatch: 'prefix',
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_GEST']
        },
        canActivate: [shared_1.UserRouteAccessService],
        children: ADMIN_ROUTES
    }
].concat(_1.userDialogRoute, _1.userEchangeDialogRoute, _1.userEchangeRoute, _1.aideRoute);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var aide_component_1 = __webpack_require__(99);
var AideResolve = (function () {
    function AideResolve(principal) {
        this.principal = principal;
    }
    AideResolve.prototype.canActivate = function () {
        var _this = this;
        return this.principal.identity().then(function (account) {
            return _this.principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST']);
        });
    };
    return AideResolve;
}());
AideResolve = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [shared_1.Principal])
], AideResolve);
exports.AideResolve = AideResolve;
exports.aideRoute = [
    {
        path: 'aide',
        component: aide_component_1.AideComponent,
        data: {
            pageTitle: 'aide.home.title'
        }
    }
];


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Archive = (function () {
    function Archive(label, fichier, annee, anneeCourante) {
        this.label = label;
        this.fichier = fichier;
        this.annee = annee;
        this.anneeCourante = anneeCourante;
    }
    return Archive;
}());
exports.Archive = Archive;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var archive_component_1 = __webpack_require__(100);
exports.archiveRoute = {
    path: 'archive',
    component: archive_component_1.JhiArchiveComponent,
    data: {
        pageTitle: 'archive.title'
    }
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var StatusArchivage = (function () {
    function StatusArchivage(enCours, dateDeLancement) {
        this.enCours = enCours;
        this.dateDeLancement = dateDeLancement;
    }
    return StatusArchivage;
}());
exports.StatusArchivage = StatusArchivage;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var archive_service_1 = __webpack_require__(52);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var TreeView = (function () {
    function TreeView(archiveService, alertService, confirmationService, translateService) {
        this.archiveService = archiveService;
        this.alertService = alertService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.refreshTreeView = new core_1.EventEmitter();
    }
    TreeView.prototype.ngOnInit = function () {
        if (this.listeRepertoire) {
            this.listeRepertoire = this.listeRepertoire.sort(function (f1, f2) { return f1.nom < f2.nom ? 1 : (f1.nom > f2.nom ? -1 : 0); });
        }
    };
    TreeView.prototype.download = function (file) {
        var _this = this;
        this.archiveService.getFile(file).subscribe(function (archive) {
            shared_1.ExportService.download(archive, file.nom);
        }, function (response) {
            _this.onError(response);
        });
    };
    TreeView.prototype.onError = function (event) {
        if (event.xhr) {
            this.alertService.error(event.xhr.response, null, null);
        }
        else if (event.headers && event.headers._headers && event.headers._headers.get('x-cadensapp-error') != null
            && event.headers._headers.get('x-cadensapp-entity') != null) {
            this.alertService.error(event.headers._headers.get('x-cadensapp-error')[0], { 'entityName': event.headers._headers.get('x-cadensapp-entity')[0] }, null);
        }
        else if (event.headers && event.headers._headers && event.headers._headers.get('x-cadensapp-error') != null) {
            this.alertService.error(event.headers._headers.get('x-cadensapp-error')[0], null, null);
        }
        else if (event.message) {
            this.alertService.error(event.message, null, null);
        }
        else {
            this.alertService.error('error.internalServerError', null, null);
        }
    };
    TreeView.prototype.deleteRepertoire = function (repertoire) {
        this.confirmationDelete(repertoire);
    };
    TreeView.prototype.confirmationDelete = function (repertoire) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('archive.confirmDelete.question'),
            header: this.translateService.instant('archive.confirmDelete.title'),
            icon: 'fa fa-trash',
            accept: function () {
                _this.archiveService.deleteRepertoire(repertoire).subscribe(function (archive) {
                    _this.refreshTreeView.emit(true);
                }, function (response) {
                    _this.refreshTreeView.emit(true);
                    _this.onError(response);
                });
            }
        });
    };
    // the treeview component is recursively called
    TreeView.prototype.onRefreshTreeView = function (refresh) {
        this.refreshTreeView.emit(refresh);
    };
    return TreeView;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TreeView.prototype, "listeRepertoire", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], TreeView.prototype, "refreshTreeView", void 0);
TreeView = __decorate([
    core_1.Component({
        selector: 'tree-view',
        template: __webpack_require__(386)
    }),
    __metadata("design:paramtypes", [archive_service_1.JhiArchiveService,
        ng_jhipster_1.AlertService,
        api_1.ConfirmationService,
        ng2_translate_1.TranslateService])
], TreeView);
exports.TreeView = TreeView;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AuditData = (function () {
    function AuditData(remoteAddress, sessionId) {
        this.remoteAddress = remoteAddress;
        this.sessionId = sessionId;
    }
    return AuditData;
}());
exports.AuditData = AuditData;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Audit = (function () {
    function Audit(data, principal, timestamp, type) {
        this.data = data;
        this.principal = principal;
        this.timestamp = timestamp;
        this.type = type;
    }
    return Audit;
}());
exports.Audit = Audit;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audits_component_1 = __webpack_require__(103);
exports.auditsRoute = {
    path: 'audits',
    component: audits_component_1.AuditsComponent,
    data: {
        pageTitle: 'audits.title'
    }
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var configuration_component_1 = __webpack_require__(105);
exports.configurationRoute = {
    path: 'jhi-configuration',
    component: configuration_component_1.JhiConfigurationComponent,
    data: {
        pageTitle: 'configuration.title'
    }
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var docs_component_1 = __webpack_require__(107);
exports.docsRoute = {
    path: 'docs',
    component: docs_component_1.JhiDocsComponent,
    data: {
        pageTitle: 'global.menu.admin.apidocs'
    }
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var health_component_1 = __webpack_require__(109);
exports.healthRoute = {
    path: 'jhi-health',
    component: health_component_1.JhiHealthCheckComponent,
    data: {
        pageTitle: 'health.title'
    }
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var logs_component_1 = __webpack_require__(111);
exports.logsRoute = {
    path: 'logs',
    component: logs_component_1.LogsComponent,
    data: {
        pageTitle: 'logs.title'
    }
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metrics_component_1 = __webpack_require__(114);
exports.metricsRoute = {
    path: 'jhi-metrics',
    component: metrics_component_1.JhiMetricsMonitoringComponent,
    data: {
        pageTitle: 'metrics.title'
    }
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var user_echange_component_1 = __webpack_require__(119);
var user_echange_detail_component_1 = __webpack_require__(117);
var user_echange_dialog_component_1 = __webpack_require__(118);
var user_echange_delete_dialog_component_1 = __webpack_require__(116);
var UserEchangeResolve = (function () {
    function UserEchangeResolve(principal) {
        this.principal = principal;
    }
    UserEchangeResolve.prototype.canActivate = function () {
        var _this = this;
        return this.principal.identity().then(function (account) {
            return _this.principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST']);
        });
    };
    return UserEchangeResolve;
}());
UserEchangeResolve = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [shared_1.Principal])
], UserEchangeResolve);
exports.UserEchangeResolve = UserEchangeResolve;
var UserEchangeResolvePagingParams = (function () {
    function UserEchangeResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    UserEchangeResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return UserEchangeResolvePagingParams;
}());
UserEchangeResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], UserEchangeResolvePagingParams);
exports.UserEchangeResolvePagingParams = UserEchangeResolvePagingParams;
exports.userEchangeRoute = [
    {
        path: 'user-echange',
        component: user_echange_component_1.UserEchangeMgmtComponent,
        data: {
            pageTitle: 'userEchange.home.title'
        }
    },
    {
        path: 'user-echange/:login',
        component: user_echange_detail_component_1.UserEchangeMgmtDetailComponent,
        data: {
            pageTitle: 'userEchange.home.title'
        }
    }
];
exports.userEchangeDialogRoute = [
    {
        path: 'user-echange-new/:typeEtudiant',
        component: user_echange_dialog_component_1.UserEchangeDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-echange/:id/edit',
        component: user_echange_dialog_component_1.UserEchangeDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-echange/:id/delete',
        component: user_echange_delete_dialog_component_1.UserEchangeDeleteDialogComponent,
        outlet: 'popup'
    }
];


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var user_management_component_1 = __webpack_require__(123);
var user_management_detail_component_1 = __webpack_require__(121);
var user_management_dialog_component_1 = __webpack_require__(122);
var user_management_delete_dialog_component_1 = __webpack_require__(120);
var shared_1 = __webpack_require__(2);
var UserResolve = (function () {
    function UserResolve(principal) {
        this.principal = principal;
    }
    UserResolve.prototype.canActivate = function () {
        var _this = this;
        return this.principal.identity().then(function (account) { return _this.principal.hasAnyAuthority(['ROLE_ADMIN']); });
    };
    return UserResolve;
}());
UserResolve = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [shared_1.Principal])
], UserResolve);
exports.UserResolve = UserResolve;
var UserResolvePagingParams = (function () {
    function UserResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    UserResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return UserResolvePagingParams;
}());
UserResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], UserResolvePagingParams);
exports.UserResolvePagingParams = UserResolvePagingParams;
exports.userMgmtRoute = [
    {
        path: 'user-management',
        component: user_management_component_1.UserMgmtComponent,
        data: {
            pageTitle: 'userManagement.home.title'
        }
    },
    {
        path: 'user-management/:login',
        component: user_management_detail_component_1.UserMgmtDetailComponent,
        data: {
            pageTitle: 'userManagement.home.title'
        }
    }
];
exports.userDialogRoute = [
    {
        path: 'user-management-new',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/edit',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/delete',
        component: user_management_delete_dialog_component_1.UserDeleteDialogComponent,
        outlet: 'popup'
    }
];


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var layouts_1 = __webpack_require__(79);
exports.navbarRoute = {
    path: '',
    component: layouts_1.NavbarComponent,
    outlet: 'navbar'
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(48);
var auth_session_service_1 = __webpack_require__(81);
var AuthExpiredInterceptor = (function (_super) {
    __extends(AuthExpiredInterceptor, _super);
    function AuthExpiredInterceptor(injector, router, stateStorageService) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        _this.router = router;
        _this.stateStorageService = stateStorageService;
        return _this;
    }
    AuthExpiredInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    AuthExpiredInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        var self = this;
        return observable.catch(function (error) {
            if (error.status === 401 && error.text() !== '' && error.json().path && error.json().path.indexOf('/api/account') === -1) {
                var authServerProvider = self.injector.get(auth_session_service_1.AuthServerProvider);
                var destination = _this.stateStorageService.getDestinationState();
                var to = destination.destination;
                var toParams = destination.params;
                authServerProvider.logout();
                if (to.name === 'accessdenied') {
                    self.stateStorageService.storePreviousState(to.name, toParams);
                }
                self.router.navigate(['/login']);
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return AuthExpiredInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.AuthExpiredInterceptor = AuthExpiredInterceptor;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(48);
var ErrorHandlerInterceptor = (function (_super) {
    __extends(ErrorHandlerInterceptor, _super);
    function ErrorHandlerInterceptor(eventManager) {
        var _this = _super.call(this) || this;
        _this.eventManager = eventManager;
        return _this;
    }
    ErrorHandlerInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    ErrorHandlerInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        return observable.catch(function (error) {
            if (!(error.status === 401 && (error.text() === '' ||
                (error.json().path && error.json().path.indexOf('/api/account') === 0)))) {
                _this.eventManager.broadcast({ name: 'cadensApp.httpError', content: error });
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return ErrorHandlerInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.ErrorHandlerInterceptor = ErrorHandlerInterceptor;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var state_storage_service_1 = __webpack_require__(82);
var auth_expired_interceptor_1 = __webpack_require__(236);
var errorhandler_interceptor_1 = __webpack_require__(237);
var notification_interceptor_1 = __webpack_require__(239);
var router_1 = __webpack_require__(3);
function interceptableFactory(backend, defaultOptions, injector, stateStorageService, eventManager, router) {
    var interceptable = new ng_jhipster_1.InterceptableHttp(backend, defaultOptions, [
        new auth_expired_interceptor_1.AuthExpiredInterceptor(injector, router, stateStorageService),
        // Other interceptors can be added here
        new errorhandler_interceptor_1.ErrorHandlerInterceptor(eventManager),
        new notification_interceptor_1.NotificationInterceptor()
    ]);
    return interceptable;
}
exports.interceptableFactory = interceptableFactory;
;
function customHttpProvider() {
    return {
        provide: http_1.Http,
        useFactory: interceptableFactory,
        deps: [
            http_1.XHRBackend,
            http_1.RequestOptions,
            core_1.Injector,
            state_storage_service_1.StateStorageService,
            ng_jhipster_1.EventManager,
            router_1.Router
        ]
    };
}
exports.customHttpProvider = customHttpProvider;
;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(48);
var NotificationInterceptor = (function (_super) {
    __extends(NotificationInterceptor, _super);
    function NotificationInterceptor() {
        return _super.call(this) || this;
    }
    NotificationInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    NotificationInterceptor.prototype.responseIntercept = function (observable) {
        return observable.catch(function (error) {
            var arr = Array.from(error.headers._headers);
            var headers = [];
            var i;
            for (i = 0; i < arr.length; i++) {
                if (arr[i][0].endsWith('app-alert') || arr[i][0].endsWith('app-params')) {
                    headers.push(arr[i][0]);
                }
            }
            headers.sort();
            var alertKey = headers.length >= 1 ? error.headers.get(headers[0]) : null;
            if (typeof alertKey === 'string') {
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return NotificationInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.NotificationInterceptor = NotificationInterceptor;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var admis_component_1 = __webpack_require__(124);
var admis_route_1 = __webpack_require__(241);
var admis_service_1 = __webpack_require__(58);
var primeng_1 = __webpack_require__(10);
var forms_1 = __webpack_require__(36);
var ENTITY_STATES = admis_route_1.admisRoute.slice();
var CadensAdmisModule = (function () {
    function CadensAdmisModule() {
    }
    return CadensAdmisModule;
}());
CadensAdmisModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
            primeng_1.RadioButtonModule,
            primeng_1.CalendarModule,
            forms_1.ReactiveFormsModule,
            primeng_1.SelectButtonModule
        ],
        declarations: [
            admis_component_1.AdmisComponent
        ],
        entryComponents: [
            admis_component_1.AdmisComponent
        ],
        providers: [
            admis_service_1.AdmisService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensAdmisModule);
exports.CadensAdmisModule = CadensAdmisModule;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var admis_component_1 = __webpack_require__(124);
exports.admisRoute = [
    {
        path: 'admis',
        component: admis_component_1.AdmisComponent,
        data: {
            pageTitle: 'cadensApp.admis.home.title'
        }
    }
];


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ChoixComponent = (function () {
    function ChoixComponent() {
    }
    return ChoixComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ChoixComponent.prototype, "choix", void 0);
ChoixComponent = __decorate([
    core_1.Component({
        selector: 'jhi-choix-component',
        template: __webpack_require__(404)
    }),
    __metadata("design:paramtypes", [])
], ChoixComponent);
exports.ChoixComponent = ChoixComponent;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var commission_1 = __webpack_require__(33);
var calendar_constants_1 = __webpack_require__(15);
var ng_jhipster_1 = __webpack_require__(1);
var CommissionComponent = (function () {
    function CommissionComponent(dateUtils, commissionService // Injection du service
    ) {
        this.dateUtils = dateUtils;
        this.commissionService = commissionService; // Injection du service
        this.commissionsChange = new core_1.EventEmitter();
    }
    CommissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fr = calendar_constants_1.CALENDAR_FR;
        if (this.commissions != null) {
            this.commissions.forEach(function (comm) {
                comm.dateCommission = _this.dateUtils.convertDateTimeFromServer(comm.dateCommission);
                comm.datePublication = _this.dateUtils.convertDateTimeFromServer(comm.datePublication);
                comm.dateCoupure = _this.dateUtils.convertDateTimeFromServer(comm.dateCoupure);
                comm.dateLimiteAvis = _this.dateUtils.convertDateTimeFromServer(comm.dateLimiteAvis);
                comm.dateLimiteConfirmation = _this.dateUtils.convertDateTimeFromServer(comm.dateLimiteConfirmation);
                comm.heureCoupure = comm.dateCoupure;
                comm.heureCommission = comm.dateCommission;
                comm.heurePublication = comm.datePublication;
                comm.heureLimiteAvis = comm.dateLimiteAvis;
                comm.heureLimiteConfirmation = comm.dateLimiteConfirmation;
            });
        }
    };
    CommissionComponent.prototype.formatDateLimiteConfirmation = function (commission) {
        if (!commission.dateLimiteConfirmation)
            return null;
        return this.commissionService.formatDateLimiteConfirmation(commission, this.currentLang);
    };
    CommissionComponent.prototype.clearCommission = function (index) {
        this.commissions.splice(index, 1);
        this.commissionsChange.emit(this.commissions);
    };
    return CommissionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", commission_1.Commission)
], CommissionComponent.prototype, "commission", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CommissionComponent.prototype, "commissions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CommissionComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CommissionComponent.prototype, "commissionsChange", void 0);
CommissionComponent = __decorate([
    core_1.Component({
        selector: 'jhi-commission-component',
        template: __webpack_require__(405)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.DateUtils,
        commission_1.CommissionService // Injection du service
    ])
], CommissionComponent);
exports.CommissionComponent = CommissionComponent;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var demande_modif_model_1 = __webpack_require__(245);
var demande_modif_service_1 = __webpack_require__(37);
var api_1 = __webpack_require__(16);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var common_1 = __webpack_require__(24);
var ng_bootstrap_1 = __webpack_require__(5);
var DemandeModifComponent = (function () {
    function DemandeModifComponent(confirmationService, demandeModifService, alertService, translateService, principal, datePipe, jhiLanguageService, activeModal) {
        this.confirmationService = confirmationService;
        this.demandeModifService = demandeModifService;
        this.alertService = alertService;
        this.translateService = translateService;
        this.principal = principal;
        this.datePipe = datePipe;
        this.jhiLanguageService = jhiLanguageService;
        this.activeModal = activeModal;
        this.demandeModifsChange = new core_1.EventEmitter();
    }
    DemandeModifComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.getIdentityLogin().then(function (login) {
            _this.login = login.toString();
        });
    };
    DemandeModifComponent.prototype.ngAfterViewInit = function () {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci après
        if (this.disabled) {
            this.editorList.forEach(function (editor) {
                editor.quill.disable();
            });
        }
    };
    DemandeModifComponent.prototype.ngOnChanges = function () {
    };
    DemandeModifComponent.prototype.addDemandeModif = function () {
        if (!this.demandeModifs) {
            this.demandeModifs = [];
        }
        this.demandeModifs.push(this.newDemandeModif());
        this.demandeModifsChange.emit(this.demandeModifs);
    };
    DemandeModifComponent.prototype.clearDemandeModif = function (index) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.formation.delete.demandeModifComplementaire.demandeModif'),
            header: this.translateService.instant('cadensApp.formation.delete.demandeModifComplementaire.title'),
            accept: function () {
                if (_this.demandeModifs[index].id != null) {
                    _this.demandeModifService.delete(_this.demandeModifs[index].id).subscribe(function () {
                        _this.demandeModifs.splice(index, 1);
                        _this.demandeModifsChange.emit(_this.demandeModifs);
                    }, function (error) {
                        _this.alertService.error(error.message, null, null);
                    });
                }
                else {
                    _this.demandeModifs.splice(index, 1);
                    _this.demandeModifsChange.emit(_this.demandeModifs);
                }
            },
            reject: function () {
            }
        });
    };
    DemandeModifComponent.prototype.newDemandeModif = function () {
        var q = new demande_modif_model_1.DemandeModif();
        q.entityId = this.entityId;
        q.entityType = this.entityType;
        /*
                q.createdDate = new Date();
                q.createdBy = this.login;
        */
        return q;
    };
    DemandeModifComponent.prototype.isPasDeModification = function () {
        if (this.disabled) {
            return this.disabled;
        }
        return null;
    };
    DemandeModifComponent.prototype.formatDate = function (date) {
        var dateFormat = 'yyyy-MM-dd';
        return (this.datePipe.transform(date, dateFormat));
    };
    DemandeModifComponent.prototype.deleteDemandeModif = function (index) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.demandeModif.delete.demandeModif.question'),
            header: this.translateService.instant('cadensApp.demandeModif.delete.demandeModif.title'),
            key: 'deleteDemandModif',
            accept: function () {
                if (_this.demandeModifs[index].id != null) {
                    _this.demandeModifService.delete(_this.demandeModifs[index].id).subscribe(function () {
                        _this.demandeModifs.splice(index, 1);
                        _this.demandeModifsChange.emit(_this.demandeModifs);
                        _this.activeModal.dismiss();
                    }, function (error) {
                        shared_1.JhiAlertComponent.onError(_this.alertService, error);
                    });
                }
                else {
                    _this.demandeModifs.splice(index, 1);
                    _this.demandeModifsChange.emit(_this.demandeModifs);
                }
            },
            reject: function () {
            }
        });
    };
    DemandeModifComponent.prototype.buildTitreDemandeModif = function (demandeModif) {
        if (demandeModif.lastModifiedBy != null && demandeModif.lastModifiedDate != null) {
            return this.translateService.instant('cadensApp.demandeModif.titreAvecModification', {
                'titre': demandeModif.titre,
                'createdBy': demandeModif.createdBy,
                'createdDate': this.formatDate(demandeModif.createdDate),
                'modifiedBy': demandeModif.lastModifiedBy,
                'modifiedDate': this.formatDate(demandeModif.lastModifiedDate)
            });
        }
        else {
            if (demandeModif.createdBy != null && demandeModif.createdDate != null) {
                return this.translateService.instant('cadensApp.demandeModif.titreAvecCreation', {
                    'titre': demandeModif.titre,
                    'createdBy': demandeModif.createdBy,
                    'createdDate': this.formatDate(demandeModif.createdDate)
                });
            }
            else {
                return this.translateService.instant('cadensApp.demandeModif.titre', {
                    'titre': demandeModif.titre,
                    'createdBy': demandeModif.createdBy,
                    'createdDate': this.formatDate(demandeModif.createdDate)
                });
            }
        }
    };
    return DemandeModifComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DemandeModifComponent.prototype, "entityId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DemandeModifComponent.prototype, "entityType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DemandeModifComponent.prototype, "demandeModifs", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DemandeModifComponent.prototype, "demandeModifsChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DemandeModifComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DemandeModifComponent.prototype, "disabled", void 0);
__decorate([
    core_1.ViewChildren(primeng_1.Editor),
    __metadata("design:type", core_1.QueryList)
], DemandeModifComponent.prototype, "editorList", void 0);
DemandeModifComponent = __decorate([
    core_1.Component({
        selector: 'jhi-demande-modif-component',
        template: __webpack_require__(406)
    }),
    __metadata("design:paramtypes", [api_1.ConfirmationService,
        demande_modif_service_1.DemandeModifService,
        ng_jhipster_1.AlertService,
        ng2_translate_1.TranslateService,
        shared_1.Principal,
        common_1.DatePipe,
        ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbActiveModal])
], DemandeModifComponent);
exports.DemandeModifComponent = DemandeModifComponent;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DemandeModif = (function () {
    function DemandeModif(id, entityId, entityType, titre, description, createdBy, createdDate, lastModifiedBy, lastModifiedDate) {
        this.id = id;
        this.entityId = entityId;
        this.entityType = entityType;
        this.titre = titre;
        this.description = description;
        this.createdBy = createdBy;
        this.createdDate = createdDate;
        this.lastModifiedBy = lastModifiedBy;
        this.lastModifiedDate = lastModifiedDate;
    }
    return DemandeModif;
}());
exports.DemandeModif = DemandeModif;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var primeng_1 = __webpack_require__(10);
var InformationComponent = (function () {
    function InformationComponent() {
    }
    InformationComponent.prototype.ngOnInit = function () {
        // let quill = new Quill('#editor');
        // quill.enable(false);
    };
    return InformationComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InformationComponent.prototype, "information", void 0);
__decorate([
    core_1.ViewChild(primeng_1.Editor),
    __metadata("design:type", primeng_1.Editor)
], InformationComponent.prototype, "editor", void 0);
InformationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-information-component',
        template: __webpack_require__(407)
    }),
    __metadata("design:paramtypes", [])
], InformationComponent);
exports.InformationComponent = InformationComponent;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var calendar_constants_1 = __webpack_require__(15);
var ParametreComponent = (function () {
    function ParametreComponent() {
    }
    ParametreComponent.prototype.ngOnInit = function () {
        this.fr = calendar_constants_1.CALENDAR_FR;
    };
    return ParametreComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ParametreComponent.prototype, "parametrages", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ParametreComponent.prototype, "currentLang", void 0);
ParametreComponent = __decorate([
    core_1.Component({
        selector: 'jhi-parametre-component',
        template: __webpack_require__(408)
    }),
    __metadata("design:paramtypes", [])
], ParametreComponent);
exports.ParametreComponent = ParametreComponent;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var formation_1 = __webpack_require__(9);
var api_1 = __webpack_require__(16);
var ng2_translate_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var rxjs_1 = __webpack_require__(14);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var PieceComponent = (function () {
    function PieceComponent(confirmationService, pieceService, alertService, translateService, principal) {
        var _this = this;
        this.confirmationService = confirmationService;
        this.pieceService = pieceService;
        this.alertService = alertService;
        this.translateService = translateService;
        this.principal = principal;
        this.piecesChange = new core_1.EventEmitter();
        this.aide = [];
        this.descriptif = [];
        this.exportRentree = [];
        this.translateService.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    }
    PieceComponent.prototype.ngAfterViewInit = function () {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci-après
        if (this.disabled) {
            this.editorList.forEach(function (editor) {
                editor.quill.disable();
            });
        }
    };
    PieceComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (this.pieces && this.pieces.length) {
            this.pieces.forEach(function (piece, idx) { return _this.aide[idx] = piece.aide != null; });
            this.pieces.forEach(function (piece, idx) { return _this.descriptif[idx] = piece.descriptif != null; });
        }
    };
    PieceComponent.prototype.onChangePieceObligatoire = function (piece, idx) {
        var texteObligatoire = this.translateService.instant('cadensApp.formation.piece.televersementObligatoire');
        var texteObligatoireP = "<p>" + this.translateService.instant('cadensApp.formation.piece.televersementObligatoire') + "</p>";
        var chainePBr = "<p><br></p>";
        // Supprimer toutes les occurrences de <p><br></p> dans descriptif/descriptifEn
        if (this.currentLang === 'fr' && piece.descriptif) {
            piece.descriptif = piece.descriptif.replace(new RegExp(chainePBr, 'g'), '').trim();
        }
        else if (this.currentLang !== 'fr' && piece.descriptifEn) {
            piece.descriptifEn = piece.descriptifEn.replace(new RegExp(chainePBr, 'g'), '').trim();
        }
        if (piece.obligatoire) {
            console.log("langue :", this.currentLang);
            // Ajoute le texte "téléversement obligatoire" si ce n'est pas déjà présent
            if (this.currentLang === 'fr') {
                if (!piece.descriptif || !piece.descriptif.includes(texteObligatoire) || !piece.descriptif.includes(texteObligatoireP)) {
                    piece.descriptif = piece.descriptif ? texteObligatoireP + '\n' + piece.descriptif : texteObligatoireP;
                }
            }
            else {
                if (!piece.descriptifEn || !piece.descriptifEn.includes(texteObligatoire) || !piece.descriptifEn.includes(texteObligatoireP)) {
                    piece.descriptifEn = piece.descriptifEn ? texteObligatoireP + '\n' + piece.descriptifEn : texteObligatoireP;
                }
            }
        }
        else {
            // Supprime le texte "téléversement obligatoire" en anglais s'il est présent
            if (this.currentLang === 'fr' && piece.descriptif) {
                piece.descriptif = piece.descriptif.replace(new RegExp('\n?' + texteObligatoireP, 'g'), '').trim();
                piece.descriptif = piece.descriptif.replace(new RegExp('\n?' + texteObligatoire, 'g'), '').trim();
            }
            else if (this.currentLang !== 'fr' && piece.descriptifEn) {
                piece.descriptifEn = piece.descriptifEn.replace(new RegExp('\n?' + texteObligatoireP, 'g'), '').trim();
                piece.descriptifEn = piece.descriptifEn.replace(new RegExp('\n?' + texteObligatoire, 'g'), '').trim();
            }
        }
    };
    PieceComponent.prototype.addPiece = function () {
        if (!this.pieces) {
            this.pieces = [];
        }
        this.pieces.push(this.newPiece());
        this.piecesChange.emit(this.pieces);
    };
    PieceComponent.prototype.clearPiece = function (index, pieceId) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.pieceJointe.delete.question'),
            header: this.translateService.instant('cadensApp.pieceJointe.delete.title'),
            key: 'deletePiece',
            accept: function () {
                if (pieceId != null) {
                    var piece = _this.pieces[index];
                    var updates_1 = [];
                    if (piece.commonIds != null && piece.commonIds.length > 0) {
                        piece.commonIds.forEach(function (p) {
                            updates_1.push(_this.pieceService.delete(p));
                        });
                    }
                    else {
                        updates_1.push(_this.pieceService.delete(pieceId));
                    }
                    rxjs_1.Observable.forkJoin(updates_1).subscribe(function (result) {
                        _this.pieces.splice(index, 1);
                        _this.piecesChange.emit(_this.pieces);
                    }, function (error) {
                        _this.alertService.error(error.message, null, null);
                    });
                }
                else {
                    _this.pieces.splice(index, 1);
                    _this.piecesChange.emit(_this.pieces);
                }
            },
            reject: function () {
            }
        });
    };
    PieceComponent.prototype.newPiece = function () {
        var piece = { obligatoire: false };
        if (this.formation) {
            piece.formationId = this.formation.id;
        }
        if (this.categorieFormationId != null) {
            piece.categorieFormationId = this.categorieFormationId.valueOf();
        }
        return piece;
    };
    PieceComponent.prototype.isPasDeModification = function () {
        if (this.disabled) {
            return this.disabled;
        }
        return null;
    };
    return PieceComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], PieceComponent.prototype, "pieces", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PieceComponent.prototype, "piecesChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", formation_1.Formation)
], PieceComponent.prototype, "formation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PieceComponent.prototype, "categorieFormationId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PieceComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "isResponsableFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "isAdminOrGestionnaireOrSystem", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "isOnlyEnseignant", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "isEnseignantOrResponsableFormation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PieceComponent.prototype, "uniquementMajPlacesFormation", void 0);
__decorate([
    core_1.ViewChildren(primeng_1.Editor),
    __metadata("design:type", core_1.QueryList)
], PieceComponent.prototype, "editorList", void 0);
PieceComponent = __decorate([
    core_1.Component({
        selector: 'jhi-piece-component',
        template: __webpack_require__(409)
    }),
    __metadata("design:paramtypes", [api_1.ConfirmationService,
        formation_1.PieceService,
        ng_jhipster_1.AlertService,
        ng2_translate_1.TranslateService,
        shared_1.Principal])
], PieceComponent);
exports.PieceComponent = PieceComponent;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var formation_1 = __webpack_require__(9);
var api_1 = __webpack_require__(16);
var ng_jhipster_1 = __webpack_require__(1);
var ng2_translate_1 = __webpack_require__(7);
var primeng_1 = __webpack_require__(10);
var QuestionComponent = (function () {
    function QuestionComponent(confirmationService, questionService, alertService, translateService) {
        var _this = this;
        this.confirmationService = confirmationService;
        this.questionService = questionService;
        this.alertService = alertService;
        this.translateService = translateService;
        this.questionsChange = new core_1.EventEmitter();
        this.aideQuestion = [];
        this.typesReponses = Object.keys(formation_1.TypeReponse).slice(Object.keys(formation_1.TypeReponse).length / 2).filter(function (type) { return type != 'RADIO'; });
        this.translateService.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
    }
    QuestionComponent.prototype.ngAfterViewInit = function () {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci après
        if (this.disabled) {
            this.editorList.forEach(function (editor) {
                editor.quill.disable();
            });
        }
    };
    QuestionComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (this.questions && this.questions.length) {
            this.questions.forEach(function (question) { return _this.aideQuestion[question.id] = question.aide != null; });
        }
    };
    QuestionComponent.prototype.addQuestion = function () {
        if (!this.questions) {
            this.questions = [];
        }
        this.questions.push(this.newQuestion());
        this.questionsChange.emit(this.questions);
    };
    QuestionComponent.prototype.clearQuestion = function (index) {
        var _this = this;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.formation.delete.questionComplementaire.question'),
            header: this.translateService.instant('cadensApp.formation.delete.questionComplementaire.title'),
            accept: function () {
                if (_this.questions[index].id != null) {
                    _this.questionService.delete(_this.questions[index].id).subscribe(function () {
                        _this.questions.splice(index, 1);
                        _this.questionsChange.emit(_this.questions);
                    }, function (error) {
                        _this.alertService.error(error.message, null, null);
                    });
                }
                else {
                    _this.questions.splice(index, 1);
                    _this.questionsChange.emit(_this.questions);
                }
            },
            reject: function () {
            }
        });
    };
    QuestionComponent.prototype.newQuestion = function () {
        var q = new formation_1.Question();
        q.obligatoire = true;
        q.interne = true;
        q.externe = true;
        if (this.formation) {
            q.formationId = this.formation.id;
        }
        return q;
    };
    QuestionComponent.prototype.isPasDeModification = function () {
        if (this.disabled) {
            return this.disabled;
        }
        return null;
    };
    return QuestionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", formation_1.Formation)
], QuestionComponent.prototype, "formation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], QuestionComponent.prototype, "questions", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], QuestionComponent.prototype, "questionsChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], QuestionComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], QuestionComponent.prototype, "disabled", void 0);
__decorate([
    core_1.ViewChildren(primeng_1.Editor),
    __metadata("design:type", core_1.QueryList)
], QuestionComponent.prototype, "editorList", void 0);
QuestionComponent = __decorate([
    core_1.Component({
        selector: 'jhi-question-component',
        template: __webpack_require__(410)
    }),
    __metadata("design:paramtypes", [api_1.ConfirmationService,
        formation_1.QuestionService,
        ng_jhipster_1.AlertService,
        ng2_translate_1.TranslateService])
], QuestionComponent);
exports.QuestionComponent = QuestionComponent;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
///<reference path="../../formation/question.model.ts"/>
var core_1 = __webpack_require__(0);
var formation_1 = __webpack_require__(9);
var ng_bootstrap_1 = __webpack_require__(5);
var candidature_1 = __webpack_require__(29);
var ReponseComponent = (function () {
    function ReponseComponent(modalService, listeChoixService) {
        this.modalService = modalService;
        this.listeChoixService = listeChoixService;
        this.isEditable = true;
        this.btnActivation = new core_1.EventEmitter();
        this.ensembleListeChoix = {};
        this.nomsListChoix = [];
        this.typeReponse = formation_1.TypeReponse;
        this.QuestionClass = formation_1.Question;
    }
    Object.defineProperty(ReponseComponent.prototype, "questions", {
        set: function (questions) {
            this._questions = questions;
            this.rechercheListeChoix();
        },
        enumerable: true,
        configurable: true
    });
    ReponseComponent.prototype.ngOnInit = function () {
    };
    // recherche des valeurs des listes de choix
    ReponseComponent.prototype.rechercheListeChoix = function () {
        var _this = this;
        if (this._questions && this._questions.length > 0) {
            this._questions.forEach(function (question) {
                if (question.typeReponse === 'LISTCHOIX') {
                    var nomListe_1 = question.reponseComplement;
                    question.reponseComplement = nomListe_1;
                    if (!_this.ensembleListeChoix[nomListe_1]) {
                        _this.listeChoixService.query({ type: nomListe_1 }).subscribe(function (services) {
                            _this.ensembleListeChoix[nomListe_1] = services.json();
                            _this.nomsListChoix.push(nomListe_1);
                        });
                    }
                }
                if (question.typeReponse === 'CHECKBOX') {
                    question.reponse = !(question.reponse == null || question.reponse.toString() != 'true');
                }
            });
        }
    };
    // Open la popup d'aide
    ReponseComponent.prototype.openAide = function (questionModal, question) {
        this.aide = question;
        this.modalService.open(questionModal);
    };
    ReponseComponent.prototype.libelleChoix = function (listeChoix) {
        if (this.currentLang === 'en' && listeChoix.libelleEn != null) {
            return listeChoix.libelleEn;
        }
        else {
            return listeChoix.libelle;
        }
    };
    ReponseComponent.prototype.libelleQuestion = function (question) {
        var languageLibelle = (formation_1.Question.getLibelleLangue(question, this.currentLang));
        var libelleQuestion = languageLibelle;
        if (languageLibelle != null) {
            if (languageLibelle.search('/#|/') > 0) {
                var splitLibelle = languageLibelle.split('#|');
                if (splitLibelle.length > 1) {
                    if (splitLibelle.length > 5) {
                        libelleQuestion = splitLibelle[0] + splitLibelle[4];
                    }
                    else {
                        libelleQuestion = splitLibelle[0];
                    }
                }
            }
        }
        return libelleQuestion;
    };
    ReponseComponent.prototype.questionAvecBouton = function (question) {
        return formation_1.Question.questionAvecBouton(question, this.currentLang);
    };
    ReponseComponent.prototype.titreBouton = function (question) {
        return formation_1.Question.titreBouton(question, this.currentLang);
    };
    ReponseComponent.prototype.actionBouton = function (question) {
        var languageLibelle = formation_1.Question.getLibelleLangue(question, this.currentLang);
        var btnAction;
        if (languageLibelle != null) {
            var splitLibelle = languageLibelle.split('#|');
            if (splitLibelle.length > 1) {
                btnAction = splitLibelle[1];
            }
        }
        return btnAction;
    };
    ReponseComponent.prototype.clickBouton = function (question) {
        var btnAction;
        btnAction = this.actionBouton(question);
        if (btnAction != null) {
            this.btnActivation.emit({ btnAction: btnAction });
        }
    };
    return ReponseComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ReponseComponent.prototype, "questions", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReponseComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ReponseComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ReponseComponent.prototype, "btnActivation", void 0);
ReponseComponent = __decorate([
    core_1.Component({
        selector: 'jhi-reponse-component',
        template: __webpack_require__(411)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        candidature_1.ListeChoixService])
], ReponseComponent);
exports.ReponseComponent = ReponseComponent;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var primeng_1 = __webpack_require__(10);
var _1 = __webpack_require__(59);
var blocks_module_1 = __webpack_require__(20);
var campagne_formations_dialog_component_1 = __webpack_require__(38);
var ENTITY_STATES = _1.campagneRoute.concat(_1.campagnePopupRoute);
var CadensCampagneModule = (function () {
    function CadensCampagneModule() {
    }
    return CadensCampagneModule;
}());
CadensCampagneModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            blocks_module_1.CadensBlocksModule,
            primeng_1.InputTextModule,
            primeng_1.CalendarModule,
            primeng_1.DataTableModule, primeng_1.SharedModule,
            primeng_1.MultiSelectModule,
            primeng_1.DialogModule,
            primeng_1.ConfirmDialogModule,
            primeng_1.RadioButtonModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.CampagneComponent,
            _1.CampagneDetailComponent,
            _1.CampagneDialogComponent,
            campagne_formations_dialog_component_1.CampagneFormationsDialogComponent,
            campagne_formations_dialog_component_1.CampagneFormationsPopupComponent,
            _1.CampagnePopupComponent,
        ],
        entryComponents: [
            _1.CampagneComponent,
            _1.CampagneDialogComponent,
            _1.CampagnePopupComponent,
            campagne_formations_dialog_component_1.CampagneFormationsDialogComponent,
            campagne_formations_dialog_component_1.CampagneFormationsPopupComponent
        ],
        providers: [
            _1.CampagneService,
            _1.CampagnePopupService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensCampagneModule);
exports.CadensCampagneModule = CadensCampagneModule;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var campagne_component_1 = __webpack_require__(127);
var campagne_detail_component_1 = __webpack_require__(125);
var campagne_dialog_component_1 = __webpack_require__(126);
var campagne_formations_dialog_component_1 = __webpack_require__(38);
exports.campagneRoute = [
    {
        path: 'campagne',
        component: campagne_component_1.CampagneComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.campagne.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'campagne/:id',
        component: campagne_detail_component_1.CampagneDetailComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.campagne.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.campagnePopupRoute = [
    {
        path: 'campagne-new',
        component: campagne_dialog_component_1.CampagnePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.campagne.home.title'
        },
        outlet: 'popup'
    }, {
        path: 'campagne-formations/:campagnes',
        component: campagne_formations_dialog_component_1.CampagneFormationsPopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.campagne.formations.add'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var civilite_component_1 = __webpack_require__(135);
var confirmation_component_1 = __webpack_require__(136);
var adresse_component_1 = __webpack_require__(128);
var adresse_service_1 = __webpack_require__(41);
var preavis_service_1 = __webpack_require__(65);
var scolarite_component_1 = __webpack_require__(149);
var cursus_component_1 = __webpack_require__(148);
var cours_component_1 = __webpack_require__(256);
var pieces_component_1 = __webpack_require__(147);
var formation_component_1 = __webpack_require__(144);
var autres_formations_component_1 = __webpack_require__(142);
var diplome_component_1 = __webpack_require__(143);
var cpes_component_1 = __webpack_require__(141);
var master_component_1 = __webpack_require__(146);
var international_component_1 = __webpack_require__(145);
var blocks_module_1 = __webpack_require__(20);
var reponse_service_1 = __webpack_require__(28);
var formationComponent_service_1 = __webpack_require__(22);
var cours_disponible_service_1 = __webpack_require__(155);
var cours_service_1 = __webpack_require__(138);
var confirmdialog_1 = __webpack_require__(198);
var _1 = __webpack_require__(29);
var avis_component_1 = __webpack_require__(129);
var preavis_component_1 = __webpack_require__(258);
var candidature_popup_service_1 = __webpack_require__(61);
var candidature_traitement_dialog_component_1 = __webpack_require__(62);
var candidature_route_1 = __webpack_require__(133);
var api_1 = __webpack_require__(16);
var enscol_service_1 = __webpack_require__(140);
var ENTITY_STATES = _1.candidatureRoutes.concat(candidature_route_1.candidaturePopupRoute);
var CadensCandidatureModule = (function () {
    function CadensCandidatureModule() {
    }
    return CadensCandidatureModule;
}());
CadensCandidatureModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            blocks_module_1.CadensBlocksModule,
            admin_module_1.CadensAdminModule,
            primeng_1.RadioButtonModule,
            primeng_1.FileUploadModule,
            primeng_1.InputTextModule,
            primeng_1.CalendarModule,
            primeng_1.DropdownModule,
            primeng_1.DataTableModule, primeng_1.SharedModule,
            primeng_1.MultiSelectModule,
            primeng_1.DialogModule,
            confirmdialog_1.ConfirmDialogModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.CandidatureComponent,
            _1.CandidatureDetailComponent,
            civilite_component_1.CiviliteComponent,
            adresse_component_1.AdresseComponent,
            pieces_component_1.PiecesComponent,
            scolarite_component_1.ScolariteComponent,
            cursus_component_1.CursusComponent,
            cours_component_1.CoursComponent,
            formation_component_1.FormationComponent,
            autres_formations_component_1.AutresFormationsComponent,
            master_component_1.MasterComponent,
            international_component_1.InternationalComponent,
            diplome_component_1.DiplomeComponent,
            confirmation_component_1.ConfirmationComponent,
            avis_component_1.AvisComponent,
            preavis_component_1.PreavisComponent,
            candidature_traitement_dialog_component_1.CandidatureTraitementDialogComponent,
            candidature_traitement_dialog_component_1.CandidatureTraitementPopupComponent,
            cpes_component_1.CpesComponent
        ],
        entryComponents: [
            _1.CandidatureComponent,
            candidature_traitement_dialog_component_1.CandidatureTraitementDialogComponent,
            candidature_traitement_dialog_component_1.CandidatureTraitementPopupComponent
        ],
        providers: [
            _1.CandidatureService,
            candidature_popup_service_1.CandidaturePopupService,
            _1.CursusService,
            cours_service_1.CoursService,
            cours_disponible_service_1.CoursDisponibleService,
            _1.CandidatureFormationService,
            _1.CandidatureResolveActionsGroupees,
            _1.ConcoursService,
            adresse_service_1.AdresseService,
            preavis_service_1.PreavisService,
            _1.ListeChoixService,
            reponse_service_1.ReponseService,
            formationComponent_service_1.FormationComponentService,
            api_1.ConfirmationService,
            enscol_service_1.EnscolService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensCandidatureModule);
exports.CadensCandidatureModule = CadensCandidatureModule;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Concours = (function () {
    function Concours(id, passage, resultat, admissible, rang, annee, candidatureId, typeConcoursId, typeConcours) {
        this.id = id;
        this.passage = passage;
        this.resultat = resultat;
        this.admissible = admissible;
        this.rang = rang;
        this.annee = annee;
        this.candidatureId = candidatureId;
        this.typeConcoursId = typeConcoursId;
        this.typeConcours = typeConcours;
    }
    return Concours;
}());
exports.Concours = Concours;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var EntityVerification = (function () {
    // noinspection JSUnusedGlobalSymbols
    function EntityVerification(entityId, applicationName, entityName, verificationOk, message, params, translatedMessage) {
        this.entityId = entityId;
        this.applicationName = applicationName;
        this.entityName = entityName;
        this.verificationOk = verificationOk;
        this.message = message;
        this.params = params;
        this.translatedMessage = translatedMessage;
    }
    EntityVerification.construitCleMessage = function (entity) {
        return shared_1.JhiAlertComponent.construitCleMessage(entity.message, entity.entityName, entity.applicationName);
    };
    return EntityVerification;
}());
exports.EntityVerification = EntityVerification;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var cours_model_1 = __webpack_require__(137);
var formation_1 = __webpack_require__(9);
var candidature_formation_service_1 = __webpack_require__(18);
var ng2_translate_1 = __webpack_require__(7);
var formation_2 = __webpack_require__(9);
var ng_bootstrap_1 = __webpack_require__(5);
var CoursComponent = (function () {
    function CoursComponent(formationService, candidatureFormationService, translate, modalService) {
        this.formationService = formationService;
        this.candidatureFormationService = candidatureFormationService;
        this.translate = translate;
        this.modalService = modalService;
        this.coursChange = new core_1.EventEmitter();
        this.QuestionClass = formation_1.Question;
    }
    CoursComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (lang) { return _this.currentLang = lang.lang; });
        // this.constructionListeCoursGroupee();
        this.selectionDuCoursDisponible();
        this.majQuestion();
        this.questionsChange.subscribe(function (nouvelleQuestions) {
            _this.questions = nouvelleQuestions;
            _this.majQuestion();
        });
    };
    CoursComponent.prototype.majQuestion = function () {
        this.questionCoursCode = this.questions.find(function (question) { return question.reponseComplement != null && question.reponseComplement == formation_2.CasParticulierEI.EI_QUESTION_COURS_CODE; });
        this.questionLibelleCours = this.questions.find(function (question) { return question.reponseComplement != null && question.reponseComplement == formation_2.CasParticulierEI.EI_QUESTION_COURS_LIBELLE; });
        this.questionEctsCours = this.questions.find(function (question) { return question.reponseComplement != null && question.reponseComplement == formation_2.CasParticulierEI.EI_QUESTION_COURS_ECTS; });
    };
    CoursComponent.prototype.selectionDuCoursDisponible = function () {
        var _this = this;
        if (this.listeCoursDisponible != null && this.cours != null) {
            var listCoursDisponibleSelect = this.listeCoursDisponible.filter(function (coursDispo) { return coursDispo.cCours == _this.cours.code; });
            if (listCoursDisponibleSelect.length > 0) {
                this.coursDisponible = listCoursDisponibleSelect[0];
            }
        }
    };
    CoursComponent.prototype.ngOnChanges = function (changes) {
        // this.constructionListeCoursGroupee();
        this.selectionDuCoursDisponible();
    };
    CoursComponent.prototype.onCoursChanged = function (codeCours) {
        var coursOk = false;
        if (codeCours != null && codeCours.length > 0 && this.listeCoursDisponible != null) {
            var coursSelect = this.listeCoursDisponible.filter(function (coursDispo) { return coursDispo.cCours == codeCours; });
            if (coursSelect != null && coursSelect.length > 0) {
                this.coursDisponible = coursSelect[0];
                this.cours.libelle = this.coursDisponible.llCours;
                this.cours.ects = this.coursDisponible.ects;
                this.cours.index = this.index;
                this.coursChange.emit(this.cours);
                coursOk = true;
            }
        }
        if (coursOk == false) {
            // this.coursDisponible = null;
            this.cours.libelle = '';
            this.cours.ects = 0;
            this.cours.index = -1;
            this.coursChange.emit(this.cours);
        }
    };
    CoursComponent.prototype.openAide = function (questionModal, question) {
        this.aide = question;
        this.modalService.open(questionModal);
    };
    return CoursComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", cours_model_1.Cours)
], CoursComponent.prototype, "cours", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CoursComponent.prototype, "listeCoursDisponible", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CoursComponent.prototype, "coursChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.EventEmitter)
], CoursComponent.prototype, "questionsChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CoursComponent.prototype, "index", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CoursComponent.prototype, "isEditable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CoursComponent.prototype, "candidatureFormationId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CoursComponent.prototype, "currentLang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CoursComponent.prototype, "questions", void 0);
CoursComponent = __decorate([
    core_1.Component({
        selector: 'jhi-cours-component',
        template: __webpack_require__(427)
    }),
    __metadata("design:paramtypes", [formation_1.FormationService,
        candidature_formation_service_1.CandidatureFormationService,
        ng2_translate_1.TranslateService, ng_bootstrap_1.NgbModal])
], CoursComponent);
exports.CoursComponent = CoursComponent;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Reponse = (function () {
    function Reponse(id, response, question, candidatureFormationId, 
        //calculé par le back mais pas systématiquement présent
        ordreCategorie, ordreGlobal) {
        this.id = id;
        this.response = response;
        this.question = question;
        this.candidatureFormationId = candidatureFormationId;
        this.ordreCategorie = ordreCategorie;
        this.ordreGlobal = ordreGlobal;
    }
    return Reponse;
}());
exports.Reponse = Reponse;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var cadens_constants_1 = __webpack_require__(8);
var listeChoix_service_1 = __webpack_require__(23);
var ng_jhipster_1 = __webpack_require__(1);
var preavis_service_1 = __webpack_require__(65);
var PreavisComponent = (function () {
    function PreavisComponent(listeChoixService, jhiLanguageService, preavisService) {
        this.listeChoixService = listeChoixService;
        this.jhiLanguageService = jhiLanguageService;
        this.preavisService = preavisService;
        this.listPreavisChange = new core_1.EventEmitter();
        this.constants = cadens_constants_1.CONSTANTS;
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }
    PreavisComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.PREAVIS }).subscribe(function (res) {
            _this.listeChoixPreavis = res.json();
        });
        this.listeChoixService.query({ type: cadens_constants_1.CONSTANTS.COMMENTAIRE }).subscribe(function (res) {
            _this.listeCommentaires = res.json();
        });
    };
    PreavisComponent.prototype.choosePreavis = function (preavis, choixPreavis) {
        if (preavis.choix != null && preavis.choix.code == choixPreavis.code) {
            preavis.choix = null;
        }
        else {
            preavis.choix = choixPreavis;
        }
        if (preavis.dateCreation == null) {
            preavis.dateCreation = preavis.dateModification = new Date();
        }
        else {
            preavis.dateModification = new Date();
        }
        this.listPreavisChange.emit(this.listePreavis);
    };
    return PreavisComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], PreavisComponent.prototype, "listePreavis", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PreavisComponent.prototype, "preavisModifEnabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PreavisComponent.prototype, "dateLimitePreavis", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PreavisComponent.prototype, "listPreavisChange", void 0);
PreavisComponent = __decorate([
    core_1.Component({
        selector: 'jhi-preavis-component',
        template: __webpack_require__(431)
    }),
    __metadata("design:paramtypes", [listeChoix_service_1.ListeChoixService,
        ng_jhipster_1.JhiLanguageService,
        preavis_service_1.PreavisService])
], PreavisComponent);
exports.PreavisComponent = PreavisComponent;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Preavis = (function () {
    function Preavis(id, candidatureFormationId, fournisseur, choix, commentaire, dateCreation, dateModification) {
        this.id = id;
        this.candidatureFormationId = candidatureFormationId;
        this.fournisseur = fournisseur;
        this.choix = choix;
        this.commentaire = commentaire;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
    }
    Preavis.buildListePreavis = function (currentUserId, preavisVisuAllEnabled, preavisModifEnabled, candidatureFormationId, listePreavisExistants, lecteurs, responsables) {
        var listePreavis = [];
        var avisDejaRedige = false;
        // Chargement de l'ensemble des préavis que peut consulter l'utilisateur connecté
        if (candidatureFormationId != null && listePreavisExistants != null && listePreavisExistants.length > 0) {
            var responsable_1 = responsables.find(function (responsable) { return responsable.id === currentUserId; });
            listePreavisExistants.forEach(function (preavis) {
                if (responsable_1 != null || preavis.fournisseur.id === currentUserId) {
                    listePreavis.push(preavis);
                    if (preavis.fournisseur.id === currentUserId) {
                        avisDejaRedige = true;
                    }
                }
            });
        }
        // Si l'utilisateur est lecteur, il faut lui charger une entrée de préavis vierge pour qu'il puisse en saisir un
        if (lecteurs !== null && lecteurs !== undefined && !avisDejaRedige) {
            var lecteur = lecteurs.find(function (lecteur) { return lecteur.id === currentUserId; });
            if (lecteur != null) {
                listePreavis.push(new Preavis(null, candidatureFormationId, lecteur, null, null, null, null));
            }
        }
        if (listePreavis !== null && listePreavis.length > 1) {
            listePreavis.sort(function (p1, p2) {
                return p1.fournisseur.id === currentUserId ? 1 :
                    (p2.fournisseur.id === currentUserId ? -1 : p1.id - p2.id);
            });
        }
        return listePreavis;
    };
    return Preavis;
}());
exports.Preavis = Preavis;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(33);
var primeng_1 = __webpack_require__(10);
var blocks_module_1 = __webpack_require__(20);
var ENTITY_STATES = _1.commissionRoute.concat(_1.commissionPopupRoute);
var CadensCommissionModule = (function () {
    function CadensCommissionModule() {
    }
    return CadensCommissionModule;
}());
CadensCommissionModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            blocks_module_1.CadensBlocksModule,
            primeng_1.InputTextModule,
            primeng_1.CalendarModule,
            primeng_1.DataTableModule, primeng_1.SharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.CommissionDialogComponent,
            _1.CommissionPopupComponent,
        ],
        entryComponents: [
            _1.CommissionDialogComponent,
            _1.CommissionPopupComponent,
        ],
        providers: [
            _1.CommissionService,
            _1.CommissionPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensCommissionModule);
exports.CadensCommissionModule = CadensCommissionModule;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var commission_dialog_component_1 = __webpack_require__(150);
exports.commissionRoute = [];
exports.commissionPopupRoute = [
    {
        path: 'commission-new/:campagneId',
        component: commission_dialog_component_1.CommissionPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.commission.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'commission-new/:campagneId/:id',
        component: commission_dialog_component_1.CommissionPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.commission.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Contact = (function () {
    function Contact(nature, demande, formation, nom, prenom, email, dateNaissance, description) {
        this.nature = nature;
        this.demande = demande;
        this.formation = formation;
        this.nom = nom;
        this.prenom = prenom;
        this.email = email;
        this.dateNaissance = dateNaissance;
        this.description = description;
    }
    return Contact;
}());
exports.Contact = Contact;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var contact_component_1 = __webpack_require__(152);
exports.contactRoute = [
    {
        path: 'contact',
        component: contact_component_1.ContactComponent,
        data: {
            pageTitle: 'cadensApp.contact.home.title'
        }
    }
];


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(152));
__export(__webpack_require__(263));
__export(__webpack_require__(153));
__export(__webpack_require__(262));
__export(__webpack_require__(154));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EntityAuditEvent = (function () {
    function EntityAuditEvent(id, entityId, entityType, action, entityValue, commitVersion, modifiedBy, modifiedDate) {
        this.id = id;
        this.entityId = entityId;
        this.entityType = entityType;
        this.action = action;
        this.entityValue = entityValue;
        this.commitVersion = commitVersion;
        this.modifiedBy = modifiedBy;
        this.modifiedDate = modifiedDate;
    }
    return EntityAuditEvent;
}());
exports.EntityAuditEvent = EntityAuditEvent;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var primeng_1 = __webpack_require__(10);
var _1 = __webpack_require__(268);
var blocks_module_1 = __webpack_require__(20);
var ENTITY_STATES = _1.entityAuditEventRoute.slice();
var CadensEntityAuditEventModule = (function () {
    function CadensEntityAuditEventModule() {
    }
    return CadensEntityAuditEventModule;
}());
CadensEntityAuditEventModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            primeng_1.DialogModule,
            blocks_module_1.CadensBlocksModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.EntityAuditEventComponent,
            _1.EntityAuditEventDetailComponent
        ],
        entryComponents: [
            _1.EntityAuditEventComponent
        ],
        providers: [
            _1.EntityAuditEventService,
            _1.EntityAuditEventResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensEntityAuditEventModule);
exports.CadensEntityAuditEventModule = CadensEntityAuditEventModule;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var entity_audit_event_component_1 = __webpack_require__(157);
var entity_audit_event_detail_component_1 = __webpack_require__(156);
var shared_1 = __webpack_require__(2);
var EntityAuditEventResolvePagingParams = (function () {
    function EntityAuditEventResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    EntityAuditEventResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'commitVersion,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return EntityAuditEventResolvePagingParams;
}());
EntityAuditEventResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], EntityAuditEventResolvePagingParams);
exports.EntityAuditEventResolvePagingParams = EntityAuditEventResolvePagingParams;
exports.entityAuditEventRoute = [
    {
        path: 'entity-audit-event',
        component: entity_audit_event_component_1.EntityAuditEventComponent,
        resolve: {
            'pagingParams': EntityAuditEventResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.entityAuditEvent.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'entity-audit-event/candidatureFormation/:id',
        component: entity_audit_event_component_1.EntityAuditEventComponent,
        resolve: {
            'pagingParams': EntityAuditEventResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.entityAuditEvent.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'entity-audit-event/:id',
        component: entity_audit_event_detail_component_1.EntityAuditEventDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.entityAuditEvent.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(265));
__export(__webpack_require__(68));
__export(__webpack_require__(156));
__export(__webpack_require__(157));
__export(__webpack_require__(267));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var candidature_module_1 = __webpack_require__(253);
var parametrage_module_1 = __webpack_require__(303);
var legal_module_1 = __webpack_require__(172);
var contact_module_1 = __webpack_require__(153);
var faq_module_1 = __webpack_require__(159);
var campagne_module_1 = __webpack_require__(251);
var formation_module_1 = __webpack_require__(276);
var historique_module_1 = __webpack_require__(298);
var piece_jointe_module_1 = __webpack_require__(305);
var grhum_module_1 = __webpack_require__(288);
var blocks_module_1 = __webpack_require__(20);
var espaceCandidat_module_1 = __webpack_require__(270);
var commission_module_1 = __webpack_require__(260);
var referent_module_1 = __webpack_require__(308);
var entity_audit_event_module_1 = __webpack_require__(266);
var user_en_echange_module_1 = __webpack_require__(311);
var admis_module_1 = __webpack_require__(240);
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */
var CadensEntityModule = (function () {
    function CadensEntityModule() {
    }
    return CadensEntityModule;
}());
CadensEntityModule = __decorate([
    core_1.NgModule({
        imports: [
            candidature_module_1.CadensCandidatureModule,
            parametrage_module_1.CadensParametrageModule,
            legal_module_1.CadensLegalModule,
            contact_module_1.CadensContactModule,
            faq_module_1.CadensFaqModule,
            campagne_module_1.CadensCampagneModule,
            formation_module_1.CadensFormationModule,
            historique_module_1.CadensHistoriqueModule,
            piece_jointe_module_1.CadensPieceJointeModule,
            grhum_module_1.CadensGrhumModule,
            referent_module_1.CadensReferentModule,
            blocks_module_1.CadensBlocksModule,
            espaceCandidat_module_1.CadensEspaceCandidatModule,
            commission_module_1.CadensCommissionModule,
            entity_audit_event_module_1.CadensEntityAuditEventModule,
            user_en_echange_module_1.CadensUserEnEchangeModule,
            admis_module_1.CadensAdmisModule
        ],
        declarations: [],
        entryComponents: [],
        exports: [blocks_module_1.CadensBlocksModule],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensEntityModule);
exports.CadensEntityModule = CadensEntityModule;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var espaceCandidat_component_1 = __webpack_require__(158);
var espaceCandidat_route_1 = __webpack_require__(271);
var api_1 = __webpack_require__(16);
var confirmdialog_1 = __webpack_require__(198);
var ENTITY_STATES = espaceCandidat_route_1.espaceCandidatRoute.slice();
var CadensEspaceCandidatModule = (function () {
    function CadensEspaceCandidatModule() {
    }
    return CadensEspaceCandidatModule;
}());
CadensEspaceCandidatModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            primeng_1.FileUploadModule,
            primeng_1.InputTextModule,
            primeng_1.CalendarModule,
            confirmdialog_1.ConfirmDialogModule,
            primeng_1.DragDropModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
            primeng_1.RadioButtonModule
        ],
        declarations: [
            espaceCandidat_component_1.EspaceCandidatComponent
        ],
        entryComponents: [
            espaceCandidat_component_1.EspaceCandidatComponent
        ],
        providers: [
            api_1.ConfirmationService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensEspaceCandidatModule);
exports.CadensEspaceCandidatModule = CadensEspaceCandidatModule;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var espaceCandidat_component_1 = __webpack_require__(158);
var user_route_access_service_1 = __webpack_require__(186);
exports.espaceCandidatRoute = [
    {
        path: 'espaceCandidat',
        component: espaceCandidat_component_1.EspaceCandidatComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'cadensApp.candidature.home.title'
        },
        canActivate: [user_route_access_service_1.UserRouteAccessService]
    }
];


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var faq_component_1 = __webpack_require__(69);
exports.faqRoute = [
    {
        path: 'faq',
        component: faq_component_1.FaqComponent,
        data: {
            pageTitle: 'cadensApp.faq.title'
        }
    }
];


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(69));
__export(__webpack_require__(272));
__export(__webpack_require__(159));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var CategorieFormation = (function () {
    function CategorieFormation(id, code, displayed, disabled, dateCreation, dateModification, ordre) {
        this.id = id;
        this.code = code;
        this.displayed = displayed;
        this.disabled = disabled;
        this.dateCreation = dateCreation;
        this.dateModification = dateModification;
        this.ordre = ordre;
    }
    return CategorieFormation;
}());
CategorieFormation.CategorieFormationIds = {
    MASTER: 1,
    DIPLOME: 2,
    AUTRE: 3,
    FC: 4,
    GENERAL: 5,
    INTERNATIONAL: 6,
    CPES: 7
};
exports.CategorieFormation = CategorieFormation;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var CategorieFormationService = (function () {
    function CategorieFormationService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/categorie-formations';
    }
    CategorieFormationService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    CategorieFormationService.prototype.create = function (categorieFormation) {
        var copy = Object.assign({}, categorieFormation);
        copy.dateCreation = this.dateUtils.toDate(categorieFormation.dateCreation);
        copy.dateModification = this.dateUtils.toDate(categorieFormation.dateModification);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CategorieFormationService.prototype.update = function (categorieFormation) {
        var copy = Object.assign({}, categorieFormation);
        copy.dateCreation = this.dateUtils.toDate(categorieFormation.dateCreation);
        copy.dateModification = this.dateUtils.toDate(categorieFormation.dateModification);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    CategorieFormationService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.dateCreation = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateCreation);
            jsonResponse.dateModification = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateModification);
            return jsonResponse;
        });
    };
    CategorieFormationService.prototype.query = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req.code) {
            params.set('code', req.code.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    CategorieFormationService.prototype.queryDisponibles = function (req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req && req.etudiantId != null) {
            params.set('etudiantId', req.etudiantId);
        }
        if (req && req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req && req.ei != null) {
            params.set('ei', req.ei);
        }
        if (req && req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map(function (res) { return _this.convertResponse(res); });
    };
    CategorieFormationService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    CategorieFormationService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
            jsonResponse[i].dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateModification);
        }
        res._body = jsonResponse;
        return res;
    };
    return CategorieFormationService;
}());
CategorieFormationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], CategorieFormationService);
exports.CategorieFormationService = CategorieFormationService;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var link_user_component_1 = __webpack_require__(164);
var _1 = __webpack_require__(9);
var blocks_module_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(36);
var ENTITY_STATES = _1.formationRoute.concat(_1.formationPopupRoute);
var CadensFormationModule = (function () {
    function CadensFormationModule() {
    }
    return CadensFormationModule;
}());
CadensFormationModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            primeng_1.DataTableModule, primeng_1.SharedModule, primeng_1.InputSwitchModule,
            primeng_1.MultiSelectModule,
            primeng_1.DialogModule,
            blocks_module_1.CadensBlocksModule,
            forms_1.ReactiveFormsModule,
            primeng_1.ConfirmDialogModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true }), primeng_1.TriStateCheckboxModule
        ],
        declarations: [
            _1.FormationComponent,
            _1.FormationDetailComponent,
            _1.FormationDeleteDialogComponent,
            _1.FormationDeletePopupComponent,
            _1.FormationNewDialogComponent,
            _1.FormationNewPopupComponent,
            link_user_component_1.LinkUserComponent
        ],
        entryComponents: [
            _1.FormationComponent,
            _1.FormationDeleteDialogComponent,
            _1.FormationDeletePopupComponent,
            _1.FormationNewDialogComponent,
            _1.FormationNewPopupComponent
        ],
        providers: [
            _1.FormationService,
            _1.FormationPopupService,
            _1.CategorieFormationService,
            _1.PieceService,
            _1.QuestionService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensFormationModule);
exports.CadensFormationModule = CadensFormationModule;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var formation_component_1 = __webpack_require__(163);
var formation_detail_component_1 = __webpack_require__(161);
var formation_delete_dialog_component_1 = __webpack_require__(160);
var shared_1 = __webpack_require__(2);
var formation_new_dialog_component_1 = __webpack_require__(162);
exports.formationRoute = [
    {
        path: 'formation',
        component: formation_component_1.FormationComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'formation-back/:id',
        component: formation_component_1.FormationComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'formation/:id',
        component: formation_detail_component_1.FormationDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.formationPopupRoute = [
    {
        path: 'formation-new',
        component: formation_new_dialog_component_1.FormationNewPopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'formation/:id/delete',
        component: formation_delete_dialog_component_1.FormationDeletePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Piece = (function () {
    function Piece(id, code, libelle, aide, descriptif, obligatoire, exportRentree, categorieFormationId, formationId, ordre, commonIds, libelleEn, aideEn, descriptifEn) {
        this.id = id;
        this.code = code;
        this.libelle = libelle;
        this.aide = aide;
        this.descriptif = descriptif;
        this.obligatoire = obligatoire;
        this.exportRentree = exportRentree;
        this.categorieFormationId = categorieFormationId;
        this.formationId = formationId;
        this.ordre = ordre;
        this.commonIds = commonIds;
        this.libelleEn = libelleEn;
        this.aideEn = aideEn;
        this.descriptifEn = descriptifEn;
    }
    return Piece;
}());
exports.Piece = Piece;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TypeReponse;
(function (TypeReponse) {
    TypeReponse[TypeReponse["CHECKBOX"] = 0] = "CHECKBOX";
    TypeReponse[TypeReponse["RADIO"] = 1] = "RADIO";
    TypeReponse[TypeReponse["NONE"] = 2] = "NONE";
    TypeReponse[TypeReponse["INPUT"] = 3] = "INPUT";
    TypeReponse[TypeReponse["YESNO"] = 4] = "YESNO";
    TypeReponse[TypeReponse["TEXTAREA"] = 5] = "TEXTAREA";
    TypeReponse[TypeReponse["LIST"] = 6] = "LIST";
    TypeReponse[TypeReponse["LISTCHOIX"] = 7] = "LISTCHOIX";
    TypeReponse[TypeReponse["CASPARTICULIER"] = 8] = "CASPARTICULIER";
})(TypeReponse = exports.TypeReponse || (exports.TypeReponse = {}));
var CasParticulierEI = (function () {
    function CasParticulierEI() {
    }
    return CasParticulierEI;
}());
CasParticulierEI.EI_QUESTION_COURS_CODE = 'EI_QUESTION_COURS_CODE';
CasParticulierEI.EI_QUESTION_COURS_LIBELLE = 'EI_QUESTION_COURS_LIBELLE';
CasParticulierEI.EI_QUESTION_COURS_ECTS = 'EI_QUESTION_COURS_ECTS';
exports.CasParticulierEI = CasParticulierEI;
var Question = (function () {
    function Question(id, typeReponse, reponseComplement, reponseComplementEn, libelle, aide, descriptif, obligatoire, interne, externe, categorieFormationId, candidatureFormationId, formationId, referentId, max, ordre, reponse, libelleEn, aideEn, descriptifEn, 
        //calculé par le back mais pas systématiquement présent
        ordreCategorie, ordreGlobal) {
        this.id = id;
        this.typeReponse = typeReponse;
        this.reponseComplement = reponseComplement;
        this.reponseComplementEn = reponseComplementEn;
        this.libelle = libelle;
        this.aide = aide;
        this.descriptif = descriptif;
        this.obligatoire = obligatoire;
        this.interne = interne;
        this.externe = externe;
        this.categorieFormationId = categorieFormationId;
        this.candidatureFormationId = candidatureFormationId;
        this.formationId = formationId;
        this.referentId = referentId;
        this.max = max;
        this.ordre = ordre;
        this.reponse = reponse;
        this.libelleEn = libelleEn;
        this.aideEn = aideEn;
        this.descriptifEn = descriptifEn;
        this.ordreCategorie = ordreCategorie;
        this.ordreGlobal = ordreGlobal;
    }
    ;
    Question.getLibelleLangue = function (question, langue) {
        if (question != null) {
            if (langue && langue === 'en' && question.libelleEn != null) {
                return question.libelleEn;
            }
            else {
                return question.libelle;
            }
        }
        return '';
    };
    Question.getTitreModalAide = function (question, langue) {
        var titre = '';
        if (question != null) {
            if (langue && langue === 'en' && question.libelleEn != null) {
                titre = question.libelleEn;
            }
            else {
                titre = question.libelle;
            }
        }
        if (titre != null && titre.length > 0) {
            titre = titre.replace('<p>', '').replace('</p>', '');
        }
        return titre;
    };
    Question.getAide = function (question, langue) {
        var aide = '';
        if (question != null) {
            if (langue && langue === 'en' && question.aideEn != null) {
                aide = question.aideEn;
            }
            else {
                aide = question.aide;
            }
        }
        return aide;
    };
    Question.questionAvecBouton = function (question, langue) {
        var buttonQuestion = false;
        if (question != null) {
            var languageLibelle = Question.getLibelleLangue(question, langue);
            if (languageLibelle != null) {
                var splitLibelle = languageLibelle.split('#|');
                if (splitLibelle.length > 1) {
                    buttonQuestion = true;
                }
            }
        }
        return buttonQuestion;
    };
    Question.titreBouton = function (question, langue) {
        var languageLibelle = Question.getLibelleLangue(question, langue);
        var buttonTitle = 'sans titre';
        if (languageLibelle != null) {
            var splitLibelle = languageLibelle.split('#|');
            if (splitLibelle.length > 3) {
                buttonTitle = splitLibelle[3];
            }
        }
        return buttonTitle;
    };
    return Question;
}());
exports.Question = Question;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Bac = (function () {
    function Bac(value, label) {
        this.value = value;
        this.label = label;
    }
    return Bac;
}());
exports.Bac = Bac;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Civilite = (function () {
    function Civilite(cCivilite, lCivilite) {
        this.cCivilite = cCivilite;
        this.lCivilite = lCivilite;
    }
    return Civilite;
}());
exports.Civilite = Civilite;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Commune = (function () {
    function Commune(codeInsee, libelle, libelleEdition, codePostal, departement) {
        this.codeInsee = codeInsee;
        this.libelle = libelle;
        this.libelleEdition = libelleEdition;
        this.codePostal = codePostal;
        this.departement = departement;
    }
    return Commune;
}());
exports.Commune = Commune;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Composant = (function () {
    function Composant(idComposant, code, llComposant, lcComposant, typeComposantId, periode, grade) {
        this.idComposant = idComposant;
        this.code = code;
        this.llComposant = llComposant;
        this.lcComposant = lcComposant;
        this.typeComposantId = typeComposantId;
        this.periode = periode;
        this.grade = grade;
    }
    return Composant;
}());
exports.Composant = Composant;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Departement = (function () {
    function Departement(code, libelle) {
        this.code = code;
        this.libelle = libelle;
    }
    return Departement;
}());
exports.Departement = Departement;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Discipline = (function () {
    function Discipline(idDiscipline, code, llDiscipline, lcDiscipline, anneeDebut, anneeFin) {
        this.idDiscipline = idDiscipline;
        this.code = code;
        this.llDiscipline = llDiscipline;
        this.lcDiscipline = lcDiscipline;
        this.anneeDebut = anneeDebut;
        this.anneeFin = anneeFin;
    }
    return Discipline;
}());
exports.Discipline = Discipline;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var GMention = (function () {
    function GMention(code, libelle, valide) {
        this.code = code;
        this.libelle = libelle;
        this.valide = valide;
    }
    return GMention;
}());
exports.GMention = GMention;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var GradeUniversitaire = (function () {
    function GradeUniversitaire(idGradeUniversitaire, typeGradeUniversitaire, libelle, nbUniteTemps) {
        this.idGradeUniversitaire = idGradeUniversitaire;
        this.typeGradeUniversitaire = typeGradeUniversitaire;
        this.libelle = libelle;
        this.nbUniteTemps = nbUniteTemps;
    }
    return GradeUniversitaire;
}());
exports.GradeUniversitaire = GradeUniversitaire;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(13);
var CadensGrhumModule = (function () {
    function CadensGrhumModule() {
    }
    return CadensGrhumModule;
}());
CadensGrhumModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule
        ],
        declarations: [],
        entryComponents: [],
        providers: [
            _1.GrhumService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensGrhumModule);
exports.CadensGrhumModule = CadensGrhumModule;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var pays_model_1 = __webpack_require__(166);
var GrhumService = GrhumService_1 = (function () {
    function GrhumService(http) {
        this.http = http;
        this.bacUrl = 'api/bacs';
        this.bacSpecialiteUrl = 'api/bacSpecialites';
        this.civiliteUrl = 'api/civilites';
        this.communeUrl = 'api/communes';
        this.composantUrl = 'api/composants';
        this.departementUrl = 'api/departements';
        this.disciplineUrl = 'api/disciplines';
        this.mentionUrl = 'api/mentions';
        this.gMentionUrl = 'api/g-mentions';
        this.paysUrl = 'api/pays';
        this.typeComposantUrl = 'api/type-composants';
        this.typeFormationUrl = 'api/type-formations';
        this.rneUrl = 'api/rnes';
        this.typeEtablissementUrl = 'api/type-etablissements';
        this.niveauAccesDiplomeUrl = 'api/niveau-acces-diplomes';
        this.gradeUniversitaireUrl = 'api/grade-universitaires';
        this.lienUrl = 'api/liens';
        this.structuresUrl = 'api/structures';
    }
    GrhumService.findPaysDansListe = function (paysListe, codePays) {
        var paysOrigine = null;
        if (paysListe && codePays) {
            paysOrigine = paysListe.find(function (pays) { return pays.code == codePays; });
        }
        if (!paysOrigine) {
            paysOrigine = pays_model_1.Pays.getPaysInconnu(codePays);
        }
        return (paysOrigine);
    };
    GrhumService.convertResponse = function (res) {
        res._body = res.json();
        return res;
    };
    GrhumService.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    GrhumService.prototype.findBac = function (id) {
        return this.http.get(this.bacUrl + "/" + id);
    };
    GrhumService.prototype.queryBac = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.bacUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findCivilite = function (id) {
        return this.http.get(this.civiliteUrl + "/" + id);
    };
    GrhumService.prototype.queryCivilite = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.civiliteUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findTypeEtablissement = function (id) {
        return this.http.get(this.typeEtablissementUrl + "/" + id);
    };
    GrhumService.prototype.queryTypeEtablissement = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.typeEtablissementUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findCommune = function (id) {
        return this.http.get(this.communeUrl + "/" + id);
    };
    GrhumService.prototype.queryCommune = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.departement) {
            params.set('departement', req.departement);
        }
        else if (req.codePostal) {
            params.set('codePostal', req.codePostal);
        }
        return this.http.get(this.communeUrl, { search: params })
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findComposant = function (id) {
        return this.http.get(this.composantUrl + "/" + id);
    };
    GrhumService.prototype.queryComposant = function (req) {
        var params = new http_1.URLSearchParams();
        if (req && req.type) {
            params.set('type', req.type);
        }
        if (req && req.typeCampagne) {
            params.set('typeCampagne', req.typeCampagne);
        }
        if (req && req.parentId) {
            params.set('parentId', req.parentId);
        }
        if (req && req.childId) {
            params.set('childId', req.childId);
        }
        if (req && req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.etudiantId) {
            params.set('etudiantId', req.etudiantId);
        }
        if (req && req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req && req.ei != null) {
            params.set('ei', req.ei);
        }
        if (req && req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        if (req && req.mentionId != null) {
            params.set('mentionId', req.mentionId);
        }
        return this.http.get(this.composantUrl, { search: params })
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.composantToLabelValue = function (composant) {
        var liste = [];
        composant.forEach(function (comp) { return liste.push({ label: comp.llComposant, value: comp.idComposant }); });
        return liste;
    };
    GrhumService.prototype.disciplineToLabelValue = function (discipline) {
        var liste = [];
        discipline.forEach(function (disc) { return liste.push({ label: disc.llDiscipline, value: disc.idDiscipline }); });
        return liste;
    };
    GrhumService.prototype.findLien = function (id) {
        return this.http.get(this.lienUrl + "/" + id);
    };
    GrhumService.prototype.queryLien = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.lienUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findStructure = function (id) {
        return this.http.get(this.structuresUrl + "/" + id);
    };
    GrhumService.prototype.queryStructure = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        return this.http.get(this.structuresUrl, { search: params })
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findDepartement = function (id) {
        return this.http.get(this.departementUrl + "/" + id);
    };
    GrhumService.prototype.queryDepartement = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.departementUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findDiscipline = function (id) {
        return this.http.get(this.disciplineUrl + "/" + id);
    };
    GrhumService.prototype.queryDiscipline = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.disciplineUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findMention = function (id) {
        return this.http.get(this.mentionUrl + "/" + id);
    };
    GrhumService.prototype.queryMention = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.mentionUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findGMention = function (id) {
        return this.http.get(this.gMentionUrl + "/" + id);
    };
    GrhumService.prototype.queryGMention = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.gMentionUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findPays = function (id) {
        return this.http.get(this.paysUrl + "/" + id);
    };
    GrhumService.prototype.queryPays = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.paysUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findTypeComposant = function (id) {
        return this.http.get(this.typeComposantUrl + "/" + id);
    };
    GrhumService.prototype.queryTypeComposant = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.typeComposantUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findTypeFormation = function (id) {
        return this.http.get(this.typeFormationUrl + "/" + id);
    };
    GrhumService.prototype.queryTypeFormation = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.typeFormationUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findNiveauAccesDiplome = function (id) {
        return this.http.get(this.niveauAccesDiplomeUrl + "/" + id);
    };
    GrhumService.prototype.queryNiveauAccesDiplome = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.niveauAccesDiplomeUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findRne = function (id) {
        return this.http.get(this.rneUrl + "/" + id);
    };
    GrhumService.prototype.queryRne = function (req) {
        var params = new http_1.URLSearchParams();
        if (req.codeInsee) {
            params.set('codeInsee', req.codeInsee);
        }
        if (req.codePostal) {
            params.set('codePostal', req.codePostal);
        }
        if (req.typeEtabCode) {
            params.set('typeEtabCode', req.typeEtabCode);
        }
        return this.http.get(this.rneUrl, { search: params })
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findGradeUniversitaire = function (id) {
        return this.http.get(this.gradeUniversitaireUrl + "/" + id);
    };
    GrhumService.prototype.queryGradeUniversitaire = function (req) {
        var params = new http_1.URLSearchParams();
        return this.http.get(this.gradeUniversitaireUrl, { search: params })
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    GrhumService.prototype.findBacSpecialite = function (id) {
        return this.http.get(this.bacSpecialiteUrl + "/" + id);
    };
    GrhumService.prototype.queryBacSpecialite = function (req) {
        var options = GrhumService_1.createRequestOption(req);
        return this.http.get(this.bacSpecialiteUrl, options)
            .map(function (res) { return GrhumService_1.convertResponse(res); });
    };
    return GrhumService;
}());
GrhumService = GrhumService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], GrhumService);
exports.GrhumService = GrhumService;
var GrhumService_1;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Lien = (function () {
    function Lien(id, idLien, parentId, childId, typeLienId, ordre) {
        this.id = id;
        this.idLien = idLien;
        this.parentId = parentId;
        this.childId = childId;
        this.typeLienId = typeLienId;
        this.ordre = ordre;
    }
    return Lien;
}());
exports.Lien = Lien;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Mention = (function () {
    function Mention(idMention, code, llMention) {
        this.idMention = idMention;
        this.code = code;
        this.llMention = llMention;
    }
    return Mention;
}());
exports.Mention = Mention;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NiveauAccesDiplome = (function () {
    function NiveauAccesDiplome(idNiveauAccesDiplome, niveau, libelle) {
        this.idNiveauAccesDiplome = idNiveauAccesDiplome;
        this.niveau = niveau;
        this.libelle = libelle;
    }
    return NiveauAccesDiplome;
}());
exports.NiveauAccesDiplome = NiveauAccesDiplome;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Rne = (function () {
    function Rne(value, label, typeEtabCode, codePostal, codeInsee) {
        this.value = value;
        this.label = label;
        this.typeEtabCode = typeEtabCode;
        this.codePostal = codePostal;
        this.codeInsee = codeInsee;
    }
    return Rne;
}());
exports.Rne = Rne;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Structure = (function () {
    function Structure(code, libelle, disciplineId) {
        this.code = code;
        this.libelle = libelle;
        this.disciplineId = disciplineId;
    }
    return Structure;
}());
exports.Structure = Structure;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TypeComposant = (function () {
    function TypeComposant(id, idTypeComposant, nom, libelle) {
        this.id = id;
        this.idTypeComposant = idTypeComposant;
        this.nom = nom;
        this.libelle = libelle;
    }
    return TypeComposant;
}());
exports.TypeComposant = TypeComposant;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TypeEtablissement = (function () {
    function TypeEtablissement(id, code, libelle) {
        this.id = id;
        this.code = code;
        this.libelle = libelle;
    }
    return TypeEtablissement;
}());
exports.TypeEtablissement = TypeEtablissement;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TypeFormation = (function () {
    function TypeFormation(id, idTypeFormation, code, libelle, habilitation) {
        this.id = id;
        this.idTypeFormation = idTypeFormation;
        this.code = code;
        this.libelle = libelle;
        this.habilitation = habilitation;
    }
    return TypeFormation;
}());
exports.TypeFormation = TypeFormation;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(300);
var ENTITY_STATES = _1.historiqueRoute.concat(_1.historiquePopupRoute);
var CadensHistoriqueModule = (function () {
    function CadensHistoriqueModule() {
    }
    return CadensHistoriqueModule;
}());
CadensHistoriqueModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.HistoriqueComponent,
            _1.HistoriqueDetailComponent,
            _1.HistoriqueDialogComponent,
            _1.HistoriqueDeleteDialogComponent,
            _1.HistoriquePopupComponent,
            _1.HistoriqueDeletePopupComponent,
        ],
        entryComponents: [
            _1.HistoriqueComponent,
            _1.HistoriqueDialogComponent,
            _1.HistoriquePopupComponent,
            _1.HistoriqueDeleteDialogComponent,
            _1.HistoriqueDeletePopupComponent,
        ],
        providers: [
            _1.HistoriqueService,
            _1.HistoriquePopupService,
            _1.HistoriqueResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensHistoriqueModule);
exports.CadensHistoriqueModule = CadensHistoriqueModule;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var historique_component_1 = __webpack_require__(170);
var historique_detail_component_1 = __webpack_require__(168);
var historique_dialog_component_1 = __webpack_require__(169);
var historique_delete_dialog_component_1 = __webpack_require__(167);
var HistoriqueResolvePagingParams = (function () {
    function HistoriqueResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    HistoriqueResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return HistoriqueResolvePagingParams;
}());
HistoriqueResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], HistoriqueResolvePagingParams);
exports.HistoriqueResolvePagingParams = HistoriqueResolvePagingParams;
exports.historiqueRoute = [
    {
        path: 'historique',
        component: historique_component_1.HistoriqueComponent,
        resolve: {
            'pagingParams': HistoriqueResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'historique/candidatureFormation/:candidatureFormationId',
        component: historique_component_1.HistoriqueComponent,
        resolve: {
            'pagingParams': HistoriqueResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'historique/:id',
        component: historique_detail_component_1.HistoriqueDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.historiquePopupRoute = [
    {
        path: 'historique-new',
        component: historique_dialog_component_1.HistoriquePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'historique/:id/edit',
        component: historique_dialog_component_1.HistoriquePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'historique/:id/delete',
        component: historique_delete_dialog_component_1.HistoriqueDeletePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(171));
__export(__webpack_require__(73));
__export(__webpack_require__(30));
__export(__webpack_require__(169));
__export(__webpack_require__(167));
__export(__webpack_require__(168));
__export(__webpack_require__(170));
__export(__webpack_require__(299));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(74));
__export(__webpack_require__(302));
__export(__webpack_require__(172));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var legal_component_1 = __webpack_require__(74);
exports.legalRoute = [
    {
        path: 'legal',
        component: legal_component_1.LegalComponent,
        data: {
            pageTitle: 'cadensApp.legal.home.title'
        }
    }
];


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var files_component_1 = __webpack_require__(173);
var _1 = __webpack_require__(11);
var blocks_module_1 = __webpack_require__(20);
var ENTITY_STATES = _1.parametrageRoute.slice();
var CadensParametrageModule = (function () {
    function CadensParametrageModule() {
    }
    return CadensParametrageModule;
}());
CadensParametrageModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            primeng_1.DataTableModule,
            primeng_1.SharedModule,
            primeng_1.EditorModule,
            primeng_1.SharedModule,
            blocks_module_1.CadensBlocksModule,
            primeng_1.FileUploadModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ParametrageComponent,
            files_component_1.FilesComponent
        ],
        entryComponents: [
            _1.ParametrageComponent
        ],
        providers: [
            _1.ParametrageService,
            _1.ParametrageResolvePagingParams
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensParametrageModule);
exports.CadensParametrageModule = CadensParametrageModule;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var parametrage_component_1 = __webpack_require__(174);
var ParametrageResolvePagingParams = (function () {
    function ParametrageResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ParametrageResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'page,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ParametrageResolvePagingParams;
}());
ParametrageResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ParametrageResolvePagingParams);
exports.ParametrageResolvePagingParams = ParametrageResolvePagingParams;
exports.parametrageRoute = [
    {
        path: 'parametrage',
        component: parametrage_component_1.ParametrageComponent,
        resolve: {
            'pagingParams': ParametrageResolvePagingParams
        },
        canActivate: [shared_1.UserRouteAccessService],
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
            pageTitle: 'cadensApp.parametrage.home.title'
        }
    }
];


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var primeng_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(2);
var admin_module_1 = __webpack_require__(19);
var _1 = __webpack_require__(34);
var ENTITY_STATES = _1.pieceJointeRoute.concat(_1.pieceJointePopupRoute);
var CadensPieceJointeModule = (function () {
    function CadensPieceJointeModule() {
    }
    return CadensPieceJointeModule;
}());
CadensPieceJointeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            admin_module_1.CadensAdminModule,
            primeng_1.DataTableModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.PieceJointeComponent,
            _1.PieceJointeDetailComponent,
            _1.PieceJointeDialogComponent,
            _1.PieceJointeDeleteDialogComponent,
            _1.PieceJointePopupComponent,
            _1.PieceJointeDeletePopupComponent,
        ],
        entryComponents: [
            _1.PieceJointeComponent,
            _1.PieceJointeDialogComponent,
            _1.PieceJointePopupComponent,
            _1.PieceJointeDeleteDialogComponent,
            _1.PieceJointeDeletePopupComponent,
        ],
        providers: [
            _1.PieceJointeService,
            _1.PieceJointePopupService,
            _1.PieceJointeResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensPieceJointeModule);
exports.CadensPieceJointeModule = CadensPieceJointeModule;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var piece_jointe_component_1 = __webpack_require__(179);
var piece_jointe_detail_component_1 = __webpack_require__(177);
var piece_jointe_dialog_component_1 = __webpack_require__(178);
var piece_jointe_delete_dialog_component_1 = __webpack_require__(176);
var PieceJointeResolvePagingParams = (function () {
    function PieceJointeResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    PieceJointeResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return PieceJointeResolvePagingParams;
}());
PieceJointeResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], PieceJointeResolvePagingParams);
exports.PieceJointeResolvePagingParams = PieceJointeResolvePagingParams;
exports.pieceJointeRoute = [
    {
        path: 'piece-jointe',
        component: piece_jointe_component_1.PieceJointeComponent,
        resolve: {
            'pagingParams': PieceJointeResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.pieceJointe.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'piece-jointe/:id',
        component: piece_jointe_detail_component_1.PieceJointeDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.pieceJointe.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.pieceJointePopupRoute = [
    {
        path: 'piece-jointe-new',
        component: piece_jointe_dialog_component_1.PieceJointePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.pieceJointe.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'piece-jointe/:id/edit',
        component: piece_jointe_dialog_component_1.PieceJointePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.pieceJointe.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'piece-jointe/:id/delete',
        component: piece_jointe_delete_dialog_component_1.PieceJointeDeletePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.pieceJointe.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Referent = (function () {
    function Referent(id, prenom, nom, email, etablissement, discipline, position, key, savedDate, formulaire, formation, ects, candidat, candidatureFormationId, invalid, typeReferent, questions, dateRelance, nombreRelance, obligatoire) {
        this.id = id;
        this.prenom = prenom;
        this.nom = nom;
        this.email = email;
        this.etablissement = etablissement;
        this.discipline = discipline;
        this.position = position;
        this.key = key;
        this.savedDate = savedDate;
        this.formulaire = formulaire;
        this.formation = formation;
        this.ects = ects;
        this.candidat = candidat;
        this.candidatureFormationId = candidatureFormationId;
        this.invalid = invalid;
        this.typeReferent = typeReferent;
        this.questions = questions;
        this.dateRelance = dateRelance;
        this.nombreRelance = nombreRelance;
        this.obligatoire = obligatoire;
    }
    return Referent;
}());
exports.Referent = Referent;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var primeng_1 = __webpack_require__(10);
var blocks_module_1 = __webpack_require__(20);
var _1 = __webpack_require__(77);
var ENTITY_STATES = _1.referentRoute.slice();
var CadensReferentModule = (function () {
    function CadensReferentModule() {
    }
    return CadensReferentModule;
}());
CadensReferentModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            primeng_1.FileUploadModule,
            primeng_1.RadioButtonModule,
            blocks_module_1.CadensBlocksModule,
            primeng_1.ConfirmDialogModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ReferentDetailComponent
        ],
        entryComponents: [
            _1.ReferentDetailComponent
        ],
        providers: [
            _1.ReferentService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensReferentModule);
exports.CadensReferentModule = CadensReferentModule;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var referent_detail_component_1 = __webpack_require__(181);
exports.referentRoute = [
    {
        path: 'recommandation',
        component: referent_detail_component_1.ReferentDetailComponent,
        data: {
            authorities: [],
            pageTitle: 'cadensApp.referent.home.title'
        }
    }
];


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UserEnEchange = (function () {
    function UserEnEchange(id, email, codePaysUniversite, nomUniversiteOrigine, typeEchange, nom, prenom, dateNaissance, typeEtudiant, campagne, 
        // rempli dynamiquement
        paysUniversite) {
        this.id = id;
        this.email = email;
        this.codePaysUniversite = codePaysUniversite;
        this.nomUniversiteOrigine = nomUniversiteOrigine;
        this.typeEchange = typeEchange;
        this.nom = nom;
        this.prenom = prenom;
        this.dateNaissance = dateNaissance;
        this.typeEtudiant = typeEtudiant;
        this.campagne = campagne;
        this.paysUniversite = paysUniversite;
    }
    return UserEnEchange;
}());
exports.UserEnEchange = UserEnEchange;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var blocks_module_1 = __webpack_require__(20);
var _1 = __webpack_require__(21);
var CadensUserEnEchangeModule = (function () {
    function CadensUserEnEchangeModule() {
    }
    return CadensUserEnEchangeModule;
}());
CadensUserEnEchangeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            blocks_module_1.CadensBlocksModule
        ],
        declarations: [],
        entryComponents: [],
        providers: [
            _1.UserEnEchangeService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensUserEnEchangeModule);
exports.CadensUserEnEchangeModule = CadensUserEnEchangeModule;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
// Attention ne pas changer les valeurs, elles sont enregistrees dans la bdd
var TypeEtudiantEnumeration;
(function (TypeEtudiantEnumeration) {
    TypeEtudiantEnumeration[TypeEtudiantEnumeration["enEchange"] = 0] = "enEchange";
    TypeEtudiantEnumeration[TypeEtudiantEnumeration["restrictionEmail"] = 1] = "restrictionEmail";
})(TypeEtudiantEnumeration = exports.TypeEtudiantEnumeration || (exports.TypeEtudiantEnumeration = {}));
var UserEnEchangeService = UserEnEchangeService_1 = (function () {
    function UserEnEchangeService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/user-en-echange';
        this.resourceRestrictionEmailCount = 'api/user-en-echange/findAllPourCampagneRestrictionEmail';
    }
    UserEnEchangeService.copyUser = function (userEnEchange) {
        if (userEnEchange.dateNaissance != null) {
            userEnEchange.dateNaissance = new Date(userEnEchange.dateNaissance.getFullYear(), userEnEchange.dateNaissance.getMonth(), userEnEchange.dateNaissance.getDate(), userEnEchange.dateNaissance.getHours(), userEnEchange.dateNaissance.getMinutes());
        }
        return userEnEchange;
    };
    UserEnEchangeService.prototype.query = function (typeEtudiant, req) {
        var _this = this;
        var params = new http_1.URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        params.set('typeEtudiant', typeEtudiant.toString());
        var options = {
            search: params
        };
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    UserEnEchangeService.prototype.getRestrictionEmail = function (idCampagne) {
        var _this = this;
        return this.http.get(this.resourceRestrictionEmailCount + "/" + idCampagne)
            .map(function (res) { return _this.convertResponse(res); });
    };
    UserEnEchangeService.prototype.create = function (userEnEchange) {
        var _this = this;
        return this.http.post(this.resourceUrl, UserEnEchangeService_1.copyUser(userEnEchange)).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    UserEnEchangeService.prototype.update = function (userEnEchange) {
        var _this = this;
        return this.http.put(this.resourceUrl, UserEnEchangeService_1.copyUser(userEnEchange)).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    UserEnEchangeService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    UserEnEchangeService.prototype.findByCadensUserId = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/userid/" + id).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    UserEnEchangeService.prototype.GetEiByCandidatureFormationId = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/ei/" + id).map(function (res) {
            return _this.convertHeures(res.json());
        });
    };
    UserEnEchangeService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    UserEnEchangeService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            this.convertHeures(jsonResponse[i]);
        }
        res._body = jsonResponse;
        return res;
    };
    UserEnEchangeService.prototype.convertHeures = function (userEnEchange) {
        userEnEchange.dateNaissance = this.dateUtils
            .convertDateTimeFromServer(userEnEchange.dateNaissance);
        return userEnEchange;
    };
    return UserEnEchangeService;
}());
UserEnEchangeService = UserEnEchangeService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], UserEnEchangeService);
exports.UserEnEchangeService = UserEnEchangeService;
var UserEnEchangeService_1;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(2);
var router_1 = __webpack_require__(3);
var HomeComponent = (function () {
    function HomeComponent(jhiLanguageService, principal, router) {
        this.jhiLanguageService = jhiLanguageService;
        this.principal = principal;
        this.router = router;
        this.jhiLanguageService.setLocations(['home']);
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.rootUrl().then(function (rootUrl) {
            _this.router.navigate([rootUrl]);
        });
    };
    HomeComponent.prototype.isAuthenticated = function () {
        return this.principal.isAuthenticated();
    };
    return HomeComponent;
}());
HomeComponent = __decorate([
    core_1.Component({
        selector: 'jhi-home',
        template: __webpack_require__(457)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        router_1.Router])
], HomeComponent);
exports.HomeComponent = HomeComponent;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(78);
var CadensHomeModule = (function () {
    function CadensHomeModule() {
    }
    return CadensHomeModule;
}());
CadensHomeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.CadensSharedModule,
            router_1.RouterModule.forRoot([_1.HOME_ROUTE], { useHash: true })
        ],
        declarations: [
            _1.HomeComponent,
        ],
        entryComponents: [],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensHomeModule);
exports.CadensHomeModule = CadensHomeModule;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var _1 = __webpack_require__(78);
exports.HOME_ROUTE = {
    path: '',
    component: _1.HomeComponent,
    data: {
        authorities: [],
        pageTitle: 'home.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(2);
var error_component_1 = __webpack_require__(183);
exports.errorRoute = [
    {
        path: 'error',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'accessdenied',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_constants_1 = __webpack_require__(49);
var FooterComponent = (function () {
    function FooterComponent() {
        this.version = 'v' + app_constants_1.VERSION;
    }
    return FooterComponent;
}());
FooterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-footer',
        template: __webpack_require__(459)
    }),
    __metadata("design:paramtypes", [])
], FooterComponent);
exports.FooterComponent = FooterComponent;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var app_route_1 = __webpack_require__(235);
var _1 = __webpack_require__(79);
var LAYOUT_ROUTES = [
    app_route_1.navbarRoute
].concat(_1.errorRoute);
var LayoutRoutingModule = (function () {
    function LayoutRoutingModule() {
    }
    return LayoutRoutingModule;
}());
LayoutRoutingModule = __decorate([
    core_1.NgModule({
        imports: [
            router_1.RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
        ],
        exports: [
            router_1.RouterModule
        ]
    })
], LayoutRoutingModule);
exports.LayoutRoutingModule = LayoutRoutingModule;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var JhiMainComponent = (function () {
    function JhiMainComponent(jhiLanguageHelper, router, $storageService) {
        this.jhiLanguageHelper = jhiLanguageHelper;
        this.router = router;
        this.$storageService = $storageService;
    }
    JhiMainComponent.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'cadensApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    JhiMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.jhiLanguageHelper.updateTitle(_this.getPageTitle(_this.router.routerState.snapshot.root));
            }
            if (event instanceof router_1.RoutesRecognized) {
                var params = {};
                var destinationData = {};
                var destinationName = '';
                var destinationEvent = event.state.root.firstChild.children[0];
                if (destinationEvent !== undefined) {
                    params = destinationEvent.params;
                    destinationData = destinationEvent.data;
                    destinationName = destinationEvent.url[0].path;
                }
                else {
                    destinationEvent = event.state.root.firstChild;
                    if (destinationEvent !== undefined && destinationEvent.url != null && destinationEvent.url.length > 0) {
                        params = destinationEvent.params;
                        destinationData = destinationEvent.data;
                        destinationName = destinationEvent.url[0].path;
                    }
                }
                var from = { name: _this.router.url.slice(1) };
                var destination = { name: destinationName, data: destinationData };
                _this.$storageService.storeDestinationState(destination, params, from);
            }
        });
    };
    return JhiMainComponent;
}());
JhiMainComponent = __decorate([
    core_1.Component({
        selector: 'jhi-main',
        template: __webpack_require__(460)
    }),
    __metadata("design:paramtypes", [shared_1.JhiLanguageHelper,
        router_1.Router,
        shared_1.StateStorageService])
], JhiMainComponent);
exports.JhiMainComponent = JhiMainComponent;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(7);
var ActiveMenuDirective = (function () {
    function ActiveMenuDirective(el, renderer, translateService) {
        this.el = el;
        this.renderer = renderer;
        this.translateService = translateService;
    }
    ActiveMenuDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateActiveFlag(event.lang);
        });
        this.updateActiveFlag(this.translateService.currentLang);
    };
    ActiveMenuDirective.prototype.updateActiveFlag = function (selectedLanguage) {
        if (this.jhiActiveMenu === selectedLanguage) {
            this.renderer.setElementClass(this.el.nativeElement, 'active', true);
        }
        else {
            this.renderer.setElementClass(this.el.nativeElement, 'active', false);
        }
    };
    return ActiveMenuDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ActiveMenuDirective.prototype, "jhiActiveMenu", void 0);
ActiveMenuDirective = __decorate([
    core_1.Directive({
        selector: '[jhiActiveMenu]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, ng2_translate_1.TranslateService])
], ActiveMenuDirective);
exports.ActiveMenuDirective = ActiveMenuDirective;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
// noinspection TypeScriptPreferShortImport
var profile_service_1 = __webpack_require__(80); // FIXME barrel doesnt work here
var shared_1 = __webpack_require__(2);
var app_constants_1 = __webpack_require__(49);
var account_1 = __webpack_require__(50);
var parametrage_1 = __webpack_require__(11);
var NavbarComponent = (function () {
    function NavbarComponent(loginService, languageHelper, languageService, principal, parametrageService, profileService, router) {
        this.loginService = loginService;
        this.languageHelper = languageHelper;
        this.languageService = languageService;
        this.principal = principal;
        this.parametrageService = parametrageService;
        this.profileService = profileService;
        this.router = router;
        this.isGestionnaire = false;
        this.isEnseignant = false;
        this.isReferent = false;
        this.isUser = false;
        this.isAdminSys = false;
        this.isAdmin = false;
        this.version = app_constants_1.DEBUG_INFO_ENABLED ? 'v' + app_constants_1.VERSION : '';
        this.isNavbarCollapsed = true;
        this.languageService.addLocation('home');
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametrageService.queryPageAll().subscribe(function (res) {
            _this.parametrage = _this.parametrageService.parametresArrayToObject(res.json());
        });
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.inProduction = profileInfo.inProduction;
            _this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
        this.principal.getIdentityName().then(function (name) {
            _this.username = name;
        });
        this.principal.hasAuthority('ROLE_SYSTEM').then(function (isAdmin) {
            _this.isAdminSys = isAdmin;
        });
        this.principal.hasAuthority('ROLE_ADMIN').then(function (isAdmin) {
            _this.isAdmin = isAdmin;
            _this.isGestionnaire = isAdmin;
            if (isAdmin === false) {
                _this.principal.hasAnyAuthority(['ROLE_GEST']).then(function (isGest) {
                    _this.isGestionnaire = isGest;
                });
            }
        });
        this.principal.hasAuthority('ROLE_REFERENT').then(function (isReferent) {
            _this.isReferent = isReferent;
        });
        this.principal.hasAuthority('ROLE_DELEGATE').then(function (isEnseignant) {
            _this.isEnseignant = isEnseignant;
        });
        this.principal.hasAuthority('ROLE_USER').then(function (isUser) {
            _this.isUser = isUser && !_this.isAdmin && !_this.isGestionnaire && !_this.isAdminSys;
        });
    };
    NavbarComponent.prototype.changeLanguage = function (languageKey) {
        this.languageService.changeLanguage(languageKey);
    };
    NavbarComponent.prototype.collapseNavbar = function () {
        this.isNavbarCollapsed = true;
    };
    NavbarComponent.prototype.isAuthenticated = function () {
        var isAuth = this.principal.isAuthenticated();
        if (!isAuth) {
            this.username = null;
            this.isGestionnaire = false;
            this.isAdminSys = false;
            this.isAdmin = false;
        }
        else if (this.username == null) {
            this.ngOnInit();
        }
        return isAuth;
    };
    NavbarComponent.prototype.register = function () {
        this.router.navigate(['/register']);
    };
    NavbarComponent.prototype.login = function () {
        this.router.navigate(['/login']);
    };
    NavbarComponent.prototype.logout = function () {
        this.loginService.logout();
        this.collapseNavbar();
        this.username = null;
        this.isGestionnaire = false;
        this.isAdminSys = false;
        this.isAdmin = false;
        this.router.navigate(['']);
    };
    NavbarComponent.prototype.toggleNavbar = function () {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    };
    NavbarComponent.prototype.getImageUrl = function () {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    };
    return NavbarComponent;
}());
NavbarComponent = __decorate([
    core_1.Component({
        selector: 'jhi-navbar',
        template: __webpack_require__(461),
        styles: [
            __webpack_require__(465)
        ]
    }),
    __metadata("design:paramtypes", [account_1.LoginService,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        parametrage_1.ParametrageService,
        profile_service_1.ProfileService,
        router_1.Router])
], NavbarComponent);
exports.NavbarComponent = NavbarComponent;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var profile_service_1 = __webpack_require__(80);
var PageRibbonComponent = (function () {
    function PageRibbonComponent(profileService) {
        this.profileService = profileService;
    }
    PageRibbonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.profileInfo = profileInfo;
            _this.ribbonEnv = profileInfo.ribbonEnv;
        });
    };
    return PageRibbonComponent;
}());
PageRibbonComponent = __decorate([
    core_1.Component({
        selector: 'jhi-page-ribbon',
        template: "<div class=\"ribbon\" *ngIf=\"ribbonEnv\"><a href=\"\" jhiTranslate=\"global.ribbon.{{ribbonEnv}}\">{{ribbonEnv}}</a></div>",
        styles: [
            __webpack_require__(464)
        ]
    }),
    __metadata("design:paramtypes", [profile_service_1.ProfileService])
], PageRibbonComponent);
exports.PageRibbonComponent = PageRibbonComponent;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ListeChoix = (function () {
    function ListeChoix(id, code, libelle, libelleEn, ordre, actif) {
        this.id = id;
        this.code = code;
        this.libelle = libelle;
        this.libelleEn = libelleEn;
        this.ordre = ordre;
        this.actif = actif;
    }
    return ListeChoix;
}());
exports.ListeChoix = ListeChoix;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var JhiAlertErrorComponent = (function () {
    function JhiAlertErrorComponent(alertService, eventManager, translateService) {
        var _this = this;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.translateService = translateService;
        this.alerts = [];
        this.cleanHttpErrorListener = eventManager.subscribe('cadensApp.httpError', function (response) {
            var i;
            var httpResponse = response.content;
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    _this.addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;
                case 400:
                    var arr = Array.from(httpResponse.headers._headers);
                    var headers = [];
                    for (i = 0; i < arr.length; i++) {
                        if (arr[i][0].endsWith('app-error') || arr[i][0].endsWith('app-params')) {
                            headers.push(arr[i][0]);
                        }
                    }
                    headers.sort();
                    var errorHeader = httpResponse.headers.get(headers[0]);
                    var entityKey = httpResponse.headers.get(headers[1]);
                    if (errorHeader) {
                        var entityName = translateService.instant('global.menu.entities.' + entityKey);
                        _this.addErrorAlert(errorHeader, errorHeader, { entityName: entityName });
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().fieldErrors) {
                        var fieldErrors = httpResponse.json().fieldErrors;
                        for (i = 0; i < fieldErrors.length; i++) {
                            var fieldError = fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = translateService.instant('cadensApp.' +
                                fieldError.objectName + '.' + convertedField);
                            _this.addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, { fieldName: fieldName });
                        }
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message, httpResponse.json().message, httpResponse.json());
                    }
                    else {
                        _this.addErrorAlert(httpResponse.text());
                    }
                    break;
                case 404:
                    _this.addErrorAlert('Not found', 'error.url.not.found');
                    break;
                default:
                    if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message);
                    }
                    else {
                        _this.addErrorAlert(JSON.stringify(httpResponse)); // Fixme find a way to parse httpResponse
                    }
            }
        });
    }
    JhiAlertErrorComponent.prototype.ngOnDestroy = function () {
        if (this.cleanHttpErrorListener !== undefined && this.cleanHttpErrorListener !== null) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
            this.alerts = [];
        }
    };
    JhiAlertErrorComponent.prototype.addErrorAlert = function (message, key, data) {
        key = key && key !== null ? key : message;
        this.alerts.push(this.alertService.addAlert({
            type: 'danger',
            msg: key,
            params: data,
            timeout: 5000,
            toast: this.alertService.isToast(),
            scoped: true
        }, this.alerts));
    };
    return JhiAlertErrorComponent;
}());
JhiAlertErrorComponent = __decorate([
    core_1.Component({
        selector: 'jhi-alert-error',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\"  [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert type=\"{{alert.type}}\" close=\"alert.close(alerts)\"><pre>{{ alert.msg }}</pre></ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService, ng_jhipster_1.EventManager, ng2_translate_1.TranslateService])
], JhiAlertErrorComponent);
exports.JhiAlertErrorComponent = JhiAlertErrorComponent;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var JhiAlertComponent = (function () {
    function JhiAlertComponent(alertService) {
        this.alertService = alertService;
    }
    JhiAlertComponent.onError = function (leServiceAlert, error) {
        var errorFound = false;
        if (error !== null && typeof error !== 'undefined') {
            if (error.headers !== null && typeof error.headers !== 'undefined') {
                // traitement des erreurs type x-cadensapp-error envoyées par le back
                var errorKey = error.headers.get('x-cadensapp-error');
                var param = error.headers.get('x-cadensapp-params');
                if (errorKey != null) {
                    var entity = error.headers.get('x-cadensapp-entity');
                    var application = error.headers.get('x-cadensapp-application');
                    errorFound = this.onEntityError(leServiceAlert, application, entity, errorKey, param);
                }
                else {
                    if (error.status != null) {
                        errorFound = this.onStatusError(leServiceAlert, error.status);
                    }
                }
            }
            if (!errorFound) {
                if (error.json !== null && typeof error.json !== 'undefined') {
                    errorFound = true;
                    // traitement types d'erreurs autre que x-cadensapp-error
                    this.onErrorMessage(leServiceAlert, error.json(), null);
                }
                else {
                }
            }
        }
        if (!errorFound) {
            leServiceAlert.error('error.erreurInconnue', null, null);
        }
    };
    JhiAlertComponent.onEntityError = function (leServiceAlert, application, entity, errorKey, param) {
        var messageKey = this.construitCleMessage(errorKey, entity, application);
        leServiceAlert.error(messageKey, param, null);
        return true;
    };
    JhiAlertComponent.onStatusError = function (leServiceAlert, status) {
        var messageKey = 'error.' + status;
        leServiceAlert.error(messageKey, null, null);
        return true;
    };
    JhiAlertComponent.construitCleMessage = function (errorKey, entity, application) {
        errorKey = errorKey == null ? 'error.erreurInconnue' : errorKey;
        var messageKey = null;
        if (entity != null) {
            if (application != null && ['candidature', 'cursus', 'referent'].indexOf(entity) >= 0) {
                messageKey = application + '.' + entity + '.' + errorKey;
            }
            else {
                messageKey = entity + '.' + errorKey;
            }
        }
        else {
            messageKey = errorKey;
        }
        return messageKey;
    };
    JhiAlertComponent.onErrorMessage = function (leService, error, params) {
        if (error !== null && typeof error !== 'undefined') {
            if (error.message) {
                if (error.message.indexOf('SendFailedException') > 0) {
                    leService.error('error.transmissionmailnotsent', params != null ? params : null, null);
                }
                else {
                    leService.error(error.message, params != null ? params : null, null);
                }
            }
            else {
                leService.error(error, params != null ? params : null, null);
            }
        }
        else {
            leService.error('error.erreurInconnue', params != null ? params : null, null);
        }
    };
    JhiAlertComponent.onSuccessMessage = function (leService, success, params) {
        if (success !== null && typeof success !== 'undefined') {
            if (success.message) {
                leService.success(success.message, params != null ? params : null, null);
            }
            else {
                leService.success(success, params != null ? params : null, null);
            }
        }
        else {
            leService.success('error.erreurInconnue', params != null ? params : null, null);
        }
    };
    JhiAlertComponent.prototype.ngOnInit = function () {
        this.alerts = this.alertService.get();
    };
    JhiAlertComponent.prototype.ngOnDestroy = function () {
        this.alerts = [];
    };
    return JhiAlertComponent;
}());
JhiAlertComponent = __decorate([
    core_1.Component({
        selector: 'jhi-alert',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\" [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert [type]=\"alert.type\" (close)=\"alert.close(alerts)\">\n                    <pre [innerHTML]=\"alert.msg\"></pre>\n                </ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService])
], JhiAlertComponent);
exports.JhiAlertComponent = JhiAlertComponent;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var principal_service_1 = __webpack_require__(43);
var state_storage_service_1 = __webpack_require__(82);
var AuthService = (function () {
    function AuthService(principal, stateStorageService, router) {
        this.principal = principal;
        this.stateStorageService = stateStorageService;
        this.router = router;
    }
    AuthService.prototype.authorize = function (force) {
        var authReturn = this.principal.identity(force).then(authThen.bind(this));
        return authReturn;
        function authThen() {
            var _this = this;
            var isAuthenticated = this.principal.isAuthenticated();
            var toStateInfo = this.stateStorageService.getDestinationState().destination;
            // an authenticated user can't access to login and register pages
            if (isAuthenticated && (toStateInfo.name === 'register') &&
                !this.principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN'])) {
                this.router.navigate(['']);
                return false;
            }
            // recover and clear previousState after external login redirect (e.g. oauth2)
            var fromStateInfo = this.stateStorageService.getDestinationState().from;
            var previousState = this.stateStorageService.getPreviousState();
            if (isAuthenticated && !fromStateInfo.name && previousState) {
                this.stateStorageService.resetPreviousState();
                this.router.navigate([previousState.name], { queryParams: previousState.params });
                return false;
            }
            if (toStateInfo.data.authorities && toStateInfo.data.authorities.length > 0) {
                return this.principal.hasAnyAuthority(toStateInfo.data.authorities).then(function (hasAnyAuthority) {
                    if (!hasAnyAuthority) {
                        if (isAuthenticated) {
                            // user is signed in but not authorized for desired state
                            _this.router.navigate(['accessdenied']);
                        }
                        else {
                            // user is not authenticated. Show the state they wanted before you
                            // send them to the login service, so you can return them when you're done
                            var toStateParamsInfo = _this.stateStorageService.getDestinationState().params;
                            _this.stateStorageService.storePreviousState(toStateInfo.name, toStateParamsInfo);
                            // now, send them to the signin state so they can log in
                            _this.router.navigate(['accessdenied']);
                        }
                    }
                    return hasAnyAuthority;
                });
            }
            return true;
        }
    };
    return AuthService;
}());
AuthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [principal_service_1.Principal,
        state_storage_service_1.StateStorageService,
        router_1.Router])
], AuthService);
exports.AuthService = AuthService;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(469);
var CSRFService = (function () {
    function CSRFService(cookieService) {
        this.cookieService = cookieService;
    }
    CSRFService.prototype.getCSRF = function (name) {
        name = "" + (name ? name : 'XSRF-TOKEN');
        return this.cookieService.get(name);
    };
    return CSRFService;
}());
CSRFService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [core_2.CookieService])
], CSRFService);
exports.CSRFService = CSRFService;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var principal_service_1 = __webpack_require__(43);
/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiHasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
var HasAnyAuthorityDirective = (function () {
    function HasAnyAuthorityDirective(principal, templateRef, viewContainerRef) {
        this.principal = principal;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    Object.defineProperty(HasAnyAuthorityDirective.prototype, "jhiHasAnyAuthority", {
        set: function (value) {
            var _this = this;
            this.authorities = typeof value === 'string' ? [value] : value;
            this.updateView();
            // Get notified each time authentication state changes.
            this.principal.getAuthenticationState().subscribe(function (identity) { return _this.updateView(); });
        },
        enumerable: true,
        configurable: true
    });
    HasAnyAuthorityDirective.prototype.updateView = function () {
        var _this = this;
        this.principal.hasAnyAuthority(this.authorities).then(function (result) {
            if (result) {
                _this.viewContainerRef.createEmbeddedView(_this.templateRef);
            }
            else {
                _this.viewContainerRef.clear();
            }
        });
    };
    return HasAnyAuthorityDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], HasAnyAuthorityDirective.prototype, "jhiHasAnyAuthority", null);
HasAnyAuthorityDirective = __decorate([
    core_1.Directive({
        selector: '[jhiHasAnyAuthority]'
    }),
    __metadata("design:paramtypes", [principal_service_1.Principal, core_1.TemplateRef, core_1.ViewContainerRef])
], HasAnyAuthorityDirective);
exports.HasAnyAuthorityDirective = HasAnyAuthorityDirective;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.ITEMS_PER_PAGE = 20;
exports.PAGING = {
    page: 1,
    itemsPerPage: exports.ITEMS_PER_PAGE,
    maxSize: 5,
    numPages: 1,
    length: 0
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(17);
var SafeHtmlPipe = (function () {
    function SafeHtmlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    SafeHtmlPipe.prototype.transform = function (html) {
        // return this.sanitizer.bypassSecurityTrustStyle(html);
        return this.sanitizeHtml(html);
        // return this.sanitizer.bypassSecurityTrustScript(html);
        // return this.sanitizer.bypassSecurityTrustUrl(html);
        // return this.sanitizer.bypassSecurityTrustResourceUrl(html);
    };
    SafeHtmlPipe.prototype.sanitizeHtml = function (html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    };
    return SafeHtmlPipe;
}());
SafeHtmlPipe = __decorate([
    core_1.Pipe({ name: 'SafeHtml' }),
    __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
], SafeHtmlPipe);
exports.SafeHtmlPipe = SafeHtmlPipe;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var InputRequiredDirective = (function () {
    function InputRequiredDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    InputRequiredDirective.prototype.onBlur = function () {
        if ((!this.el.nativeElement.value ||
            this.el.nativeElement.value === '' ||
            this.el.nativeElement.value === '0: null') && this.el.nativeElement.required !== false) {
            this.renderer.setElementClass(this.el.nativeElement, 'inputRequired', true);
        }
        else {
            this.renderer.setElementClass(this.el.nativeElement, 'inputRequired', false);
        }
    };
    return InputRequiredDirective;
}());
__decorate([
    core_1.HostListener('blur'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InputRequiredDirective.prototype, "onBlur", null);
InputRequiredDirective = __decorate([
    core_1.Directive({
        selector: '[jhiInputRequired]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
], InputRequiredDirective);
exports.InputRequiredDirective = InputRequiredDirective;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(17);
var router_1 = __webpack_require__(3);
var ng2_translate_1 = __webpack_require__(374);
var language_constants_1 = __webpack_require__(188);
var JhiLanguageHelper = (function () {
    function JhiLanguageHelper(translateService, titleService, router) {
        this.translateService = translateService;
        this.titleService = titleService;
        this.router = router;
        this.init();
    }
    JhiLanguageHelper.prototype.getAll = function () {
        return Promise.resolve(language_constants_1.LANGUAGES);
    };
    /**
     * Update the window title using params in the following
     * order:
     * 1. titleKey parameter
     * 2. $state.$current.data.pageTitle (current state page title)
     * 3. 'global.title'
     */
    JhiLanguageHelper.prototype.updateTitle = function (titleKey) {
        var _this = this;
        if (!titleKey) {
            titleKey = this.getPageTitle(this.router.routerState.snapshot.root);
        }
        this.translateService.get(titleKey).subscribe(function (title) {
            _this.titleService.setTitle(title);
        });
    };
    JhiLanguageHelper.prototype.init = function () {
        var _this = this;
        this.translateService.onTranslationChange.subscribe(function (event) {
            _this.updateTitle();
        });
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateTitle();
        });
    };
    JhiLanguageHelper.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'cadensApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    return JhiLanguageHelper;
}());
JhiLanguageHelper = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_translate_1.TranslateService, platform_browser_1.Title, router_1.Router])
], JhiLanguageHelper);
exports.JhiLanguageHelper = JhiLanguageHelper;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var FindLanguageFromKeyPipe = (function () {
    function FindLanguageFromKeyPipe() {
        this.languages = {
            'ca': 'Català',
            'cs': 'Český',
            'da': 'Dansk',
            'de': 'Deutsch',
            'el': 'Ελληνικά',
            'en': 'English',
            'es': 'Español',
            'et': 'Eesti',
            'fr': 'Français',
            'gl': 'Galego',
            'hu': 'Magyar',
            'hi': 'हिंदी',
            'it': 'Italiano',
            'ja': '日本語',
            'ko': '한국어',
            'mr': 'मराठी',
            'nl': 'Nederlands',
            'pl': 'Polski',
            'pt-br': 'Português (Brasil)',
            'pt-pt': 'Português',
            'ro': 'Română',
            'ru': 'Русский',
            'sk': 'Slovenský',
            'sr': 'Srpski',
            'sv': 'Svenska',
            'ta': 'தமிழ்',
            'tr': 'Türkçe',
            'vi': 'Tiếng Việt',
            'zh-cn': '中文（简体）',
            'zh-tw': '繁體中文'
        };
    }
    FindLanguageFromKeyPipe.prototype.transform = function (lang) {
        return this.languages[lang];
    };
    return FindLanguageFromKeyPipe;
}());
FindLanguageFromKeyPipe = __decorate([
    core_1.Pipe({ name: 'findLanguageFromKey' })
], FindLanguageFromKeyPipe);
exports.FindLanguageFromKeyPipe = FindLanguageFromKeyPipe;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(17);
var ng2_translate_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var _1 = __webpack_require__(2);
function alertServiceProvider(sanitizer, translateService) {
    // set below to true to make alerts look like toast
    var isToast = false;
    return new ng_jhipster_1.AlertService(sanitizer, isToast, translateService);
}
exports.alertServiceProvider = alertServiceProvider;
var CadensSharedCommonModule = (function () {
    function CadensSharedCommonModule() {
    }
    return CadensSharedCommonModule;
}());
CadensSharedCommonModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.CadensSharedLibsModule
        ],
        declarations: [
            _1.FindLanguageFromKeyPipe,
            _1.SafeHtmlPipe,
            _1.JhiAlertComponent,
            _1.JhiAlertErrorComponent
        ],
        providers: [
            _1.JhiLanguageHelper,
            {
                provide: ng_jhipster_1.AlertService,
                useFactory: alertServiceProvider,
                deps: [core_1.Sanitizer, ng2_translate_1.TranslateService]
            },
            platform_browser_1.Title
        ],
        exports: [
            _1.CadensSharedLibsModule,
            _1.FindLanguageFromKeyPipe,
            _1.SafeHtmlPipe,
            _1.JhiAlertComponent,
            _1.JhiAlertErrorComponent
        ]
    })
], CadensSharedCommonModule);
exports.CadensSharedCommonModule = CadensSharedCommonModule;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(36);
var http_1 = __webpack_require__(4);
var common_1 = __webpack_require__(24);
var ng_bootstrap_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var CadensSharedLibsModule = (function () {
    function CadensSharedLibsModule() {
    }
    return CadensSharedLibsModule;
}());
CadensSharedLibsModule = __decorate([
    core_1.NgModule({
        imports: [
            ng_bootstrap_1.NgbModule.forRoot(),
            ng_jhipster_1.NgJhipsterModule.forRoot({
                i18nEnabled: true,
                defaultI18nLang: 'fr'
            })
        ],
        exports: [
            forms_1.FormsModule,
            http_1.HttpModule,
            common_1.CommonModule,
            ng_bootstrap_1.NgbModule,
            ng_jhipster_1.NgJhipsterModule
        ]
    })
], CadensSharedLibsModule);
exports.CadensSharedLibsModule = CadensSharedLibsModule;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(24);
var cookies_service_1 = __webpack_require__(471);
var _1 = __webpack_require__(2);
var input_required_directive_1 = __webpack_require__(331);
var export_service_1 = __webpack_require__(187);
var spinner_component_1 = __webpack_require__(189);
var CadensSharedModule = (function () {
    function CadensSharedModule() {
    }
    return CadensSharedModule;
}());
CadensSharedModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.CadensSharedLibsModule,
            _1.CadensSharedCommonModule
        ],
        declarations: [
            _1.HasAnyAuthorityDirective,
            input_required_directive_1.InputRequiredDirective,
            spinner_component_1.SpinnerComponent
        ],
        providers: [
            cookies_service_1.CookieService,
            _1.AccountService,
            _1.StateStorageService,
            _1.Principal,
            _1.CSRFService,
            _1.AuthServerProvider,
            _1.AuthService,
            _1.UserService,
            _1.AuthorityService,
            common_1.DatePipe,
            export_service_1.ExportService
        ],
        exports: [
            _1.CadensSharedCommonModule,
            _1.HasAnyAuthorityDirective,
            common_1.DatePipe,
            input_required_directive_1.InputRequiredDirective,
            spinner_component_1.SpinnerComponent
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], CadensSharedModule);
exports.CadensSharedModule = CadensSharedModule;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Account = (function () {
    function Account(activated, authorities, email, civilite, firstName, otherNames, lastName, lastNameUsage, birthDate, langKey, login, imageUrl) {
        this.activated = activated;
        this.authorities = authorities;
        this.email = email;
        this.civilite = civilite;
        this.firstName = firstName;
        this.otherNames = otherNames;
        this.lastName = lastName;
        this.lastNameUsage = lastNameUsage;
        this.birthDate = birthDate;
        this.langKey = langKey;
        this.login = login;
        this.imageUrl = imageUrl;
    }
    return Account;
}());
exports.Account = Account;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Authority = (function () {
    function Authority(name) {
        this.name = name ? name : null;
    }
    return Authority;
}());
exports.Authority = Authority;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var AuthorityService = (function () {
    function AuthorityService(http) {
        this.http = http;
        this.resourceUrl = 'api/authorities';
    }
    AuthorityService.prototype.getAllAuthorities = function () {
        return this.http.get(this.resourceUrl);
    };
    return AuthorityService;
}());
AuthorityService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuthorityService);
exports.AuthorityService = AuthorityService;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __1 = __webpack_require__(2);
var User = (function () {
    function User(id, login, civilite, firstName, otherNames, lastName, lastNameUsage, birthDate, email, activated, pluriannuel, langKey, authorities, createdBy, createdDate, lastModifiedBy, lastModifiedDate, password) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.civilite = civilite ? civilite : null;
        this.firstName = firstName ? firstName : null;
        this.otherNames = otherNames ? otherNames : null;
        this.lastName = lastName ? lastName : null;
        this.lastNameUsage = lastNameUsage ? lastNameUsage : null;
        this.birthDate = birthDate ? birthDate : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.pluriannuel = pluriannuel ? pluriannuel : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
    }
    // un utilisateur peut candidater :
    //   - si il est déjà étudiant à L'ENS
    //   - si il n'a pas un mail ENS et qu'il a un role USER
    User.userPeutCandidater = function (user) {
        var peutCandidater = false;
        if (user != null) {
            if (user.etudiant != null && user.etudiant.numeroEtudiant != null) {
                peutCandidater = true;
            }
            else {
                if (!user.email.endsWith('@ens-lyon.fr')) {
                    if (__1.Principal.isAuthorityInListe('ROLE_USER', user.authorities)) {
                        peutCandidater = true;
                    }
                }
            }
        }
        return peutCandidater;
    };
    // un utilisateur est en resincription si  :
    //   - si il est déjà étudiant à L'ENS
    User.userResinscription = function (user) {
        var reinscription = false;
        if (user != null) {
            if (user.etudiant != null && user.etudiant.numeroEtudiant != null) {
                reinscription = true;
            }
        }
        return reinscription;
    };
    return User;
}());
exports.User = User;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(4);
var UserService = (function () {
    function UserService(http) {
        this.http = http;
        this.resourceUrl = 'api/users';
        this.resourceAuthoritiesUrl = 'api/authorities';
        this.resourceLdapUrl = 'api/ldapusers';
    }
    UserService.prototype.create = function (user) {
        return this.http.post(this.resourceUrl, user);
    };
    UserService.prototype.update = function (user) {
        return this.http.put(this.resourceUrl, user);
    };
    UserService.prototype.find = function (login) {
        return this.http.get(this.resourceUrl + "/" + login).map(function (res) { return res.json(); });
    };
    UserService.prototype.findById = function (userId) {
        return this.http.get(this.resourceUrl + "/byid/" + userId).map(function (res) { return res.json(); });
    };
    UserService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            params.set('userENS', req.userENS);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        var options = {
            search: params
        };
        return this.http.get(this.resourceUrl, options);
    };
    UserService.prototype.queryLDAP = function (req) {
        var params = new http_1.URLSearchParams();
        if (req) {
            params.set('search', req.search);
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        var options = {
            search: params
        };
        return this.http.get(this.resourceLdapUrl, options);
    };
    UserService.prototype.delete = function (login) {
        return this.http.delete(this.resourceUrl + "/" + login);
    };
    return UserService;
}());
UserService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], UserService);
exports.UserService = UserService;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var DisabledDirective = (function () {
    function DisabledDirective(optParent) {
        this.optParent = optParent;
    }
    return DisabledDirective;
}());
DisabledDirective = __decorate([
    __param(0, core_1.SkipSelf()), __param(0, core_1.Optional()),
    __metadata("design:paramtypes", [DisabledDirective])
], DisabledDirective);
exports.DisabledDirective = DisabledDirective;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ObjectUtil = (function () {
    function ObjectUtil() {
    }
    ObjectUtil.cloneAttributs = function (objectToClone) {
        var cloneObj;
        if (typeof objectToClone !== 'object') {
            cloneObj = objectToClone;
        }
        else {
            cloneObj = [];
            for (var attribut in objectToClone) {
                if (typeof objectToClone[attribut] === 'object') {
                    cloneObj[attribut] = ObjectUtil.cloneAttributs(objectToClone[attribut]);
                }
                else {
                    cloneObj[attribut] = objectToClone[attribut];
                }
            }
        }
        return cloneObj;
    };
    return ObjectUtil;
}());
exports.ObjectUtil = ObjectUtil;


/***/ }),
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)();
// imports


// module
exports.push([module.i, "ul#strength{display:inline;list-style:none;margin:0;margin-left:15px;padding:0;vertical-align:2px}.point{background:#ddd;border-radius:2px;display:inline-block;height:5px;margin-right:1px;width:20px}.point:last{margin:0!important}", ""]);

// exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)();
// imports


// module
exports.push([module.i, ".ribbon{background-color:rgba(170,0,0,.5);left:-3.5em;moz-transform:rotate(-45deg);ms-transform:rotate(-45deg);o-transform:rotate(-45deg);webkit-transform:rotate(-45deg);transform:rotate(-45deg);overflow:hidden;position:absolute;top:40px;white-space:nowrap;width:15em;z-index:9999;opacity:.75}.ribbon,.ribbon a{pointer-events:none}.ribbon a{color:#fff;display:block;font-weight:600;font-size:20px;margin:1px 0;padding:10px 50px;text-align:center;text-decoration:none;text-shadow:0 0 5px #444}", ""]);

// exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)();
// imports


// module
exports.push([module.i, ".navbar-version{font-size:10px;color:#ccc}.jh-navbar{background-color:#fff;padding:.2em 1em}.jh-navbar .profile-image{margin:-10px 0;height:40px;width:40px;border-radius:50%}.jh-navbar .dropdown-item.active,.jh-navbar .dropdown-item.active:focus,.jh-navbar .dropdown-item.active:hover{border:1px solid #9a9a9a;border-radius:10px;background-color:transparent}.jh-navbar .dropdown-toggle:after{margin-left:.15em}.jh-navbar a.nav-link{font-weight:400}.jh-navbar .jh-navbar-toggler{color:#ccc;font-size:1.5em;padding:10px}.jh-navbar .jh-navbar-toggler:hover{color:#272727}.spaceMenus{border-bottom:1px solid #9a9a9a;border-radius:0;font-family:ArialMt;height:55px;text-align:center;padding:.6rem 1rem}.spaceMenus ul{list-style:none}.spaceMenus a.nav-link{font-size:14px;color:#9c9c9c;text-transform:uppercase;margin:0 10px}.spaceNavigation .title h1{display:block}.spaceNavigation .title .piped{float:left;height:100%;width:60px;padding-top:7px;font-size:32px}.sidebar-action{background-color:#fff;border:1px solid #ddd;text-align:center}.sidebar-action .sidebar-item.info{border-bottom:1px solid #ddd;word-wrap:break-word;overflow-wrap:break-word}", ""]);

// exports


/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__ = __webpack_require__(196);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ng2PageScrollModule; });
/**
 * Created by sebastianfuss on 03.09.16.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var Ng2PageScrollModule = Ng2PageScrollModule_1 = (function () {
    function Ng2PageScrollModule() {
    }
    Ng2PageScrollModule.forRoot = function () {
        return {
            ngModule: Ng2PageScrollModule_1,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__["a" /* PageScrollService */], useClass: __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__["a" /* PageScrollService */] }
            ]
        };
    };
    return Ng2PageScrollModule;
}());
Ng2PageScrollModule = Ng2PageScrollModule_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
        declarations: [__WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__["a" /* PageScroll */]],
        exports: [__WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__["a" /* PageScroll */]]
    })
], Ng2PageScrollModule);

var Ng2PageScrollModule_1;


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(7);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "translateLoaderFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["translateLoaderFactory"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateModule", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateModule"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslatePipe"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["MissingTranslationHandler"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateStaticLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateStaticLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateService"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DefaultTranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["DefaultTranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateDirective"]; });



/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-6 offset-md-3\">\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h1 jhiTranslate=\"activate.title\">Activation</h1>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\">\n                <span jhiTranslate=\"activate.messages.success\">\n                    Your user has been activated.\n                </span>\n                <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.connect\">sign in</a>.\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"activate.messages.error\">\n                <strong>Your user could not be activated.</strong> Please use the registration form to sign up.\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-8 offset-md-2\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"login.title\">Sign in</h1>\n        </div>\n        <div class=\"col-md-10 offset-md-1\">\n            <div class=\"alert alert-danger\" *ngIf=\"authenticationError\" jhiTranslate=\"login.messages.error.authentication\">\n                <strong>Failed to sign in!</strong> Please check your credentials and try again.\n            </div>\n        </div>\n       <!-- <div class=\"col-md-10 offset-md-1\">\n            <div class=\"alert alert-info\" *ngIf=\"parametrage?.NEWSACCUEIL?.libelle != null\" [innerHTML]=\"parametrage?.NEWSACCUEIL?.libelle\"> </div>\n        </div>-->\n        <div class=\"col-md-10 offset-md-1\">\n            <div class=\"alert alert-warning\"\n                 *ngIf=\"(currentLang != 'en' && parametrage?.MESSAGE_CONNEXION?.libelle != null && parametrage?.MESSAGE_CONNEXION?.libelle.length>10)  || (currentLang === 'en' && parametrage?.MESSAGE_CONNEXION?.libelleEn != null && parametrage?.MESSAGE_CONNEXION?.libelleEn.length>10) \"\n                 [innerHTML]=\"getConnexionMessage(currentLang) | SafeHtml \">\n            </div>\n        </div>\n        <div class=\"col-md-10 offset-md-1\">\n            <form class=\"form\" role=\"form\" (ngSubmit)=\"login()\">\n                <div class=\"form-group\">\n                    <label for=\"email\" jhiTranslate=\"global.form.email\">Email</label>\n                    <input type=\"text\" class=\"form-control\" name=\"email\" id=\"email\" placeholder=\"{{'global.form.email' | translate}}\"\n                    [(ngModel)]=\"email\" jhiInputRequired required >\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"password\" jhiTranslate=\"login.form.password\">Password</label>\n                    <input type=\"password\" class=\"form-control\" name=\"password\" id=\"password\" placeholder=\"{{'login.form.password.placeholder' | translate}}\"\n                           [(ngModel)]=\"password\" jhiInputRequired required >\n                </div>\n                <!--<div class=\"form-check\">-->\n                    <!--<input class=\"form-check-input\" type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe\" [(ngModel)]=\"rememberMe\" checked>-->\n                    <!--<label for=\"rememberMe\"><span></span></label>-->\n                    <!--<label jhiTranslate=\"login.form.rememberme\">Remember me</label>-->\n                <!--</div>-->\n                <div class=\"\">\n                    <button type=\"submit\" class=\"btn btn-primary\" jhiTranslate=\"login.form.button\">Sign in</button>\n                </div>\n                <div class=\"\">\n                    <a class=\"sublink\" (click)=\"requestResetPassword()\" jhiTranslate=\"login.password.forgot\">Did you forget your password?</a>\n                </div>\n            </form>\n            <p></p>\n            <div class=\"\">\n                <h2 jhiTranslate=\"global.messages.info.register.noaccount\">Don't have an account yet?</h2>\n            </div>\n            <div class=\"text-sm-center\">\n                <button (click)=\"register()\" class=\"btn btn-default\" jhiTranslate=\"global.messages.info.register.link\">Register a new account</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"reset.finish.title\">Reset password</h1>\n\n            <div class=\"alert alert-danger\" jhiTranslate=\"reset.finish.messages.keymissing\" *ngIf=\"keyMissing\">\n                <strong>The password reset key is missing.</strong>\n            </div>\n\n            <div class=\"alert alert-warning\" *ngIf=\"!success && !keyMissing\">\n                <p jhiTranslate=\"reset.finish.messages.info\">Choose a new password</p>\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"error\">\n                <p jhiTranslate=\"reset.finish.messages.error\">Your password couldn't be reset. Remember a password request is only valid for 24 hours.</p>\n            </div>\n\n            <p class=\"alert alert-success\" *ngIf=\"success\">\n                <span jhiTranslate=\"reset.finish.messages.success\"><strong>Your password has been reset.</strong> Please </span>\n                <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign in</a>.\n            </p>\n\n            <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\">\n                The password and its confirmation do not match!\n            </div>\n\n            <div *ngIf=\"!keyMissing\">\n                <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"finishReset()\" #passwordForm=\"ngForm\">\n                    <div class=\"form-group\">\n                        <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label>\n                        <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #passwordInput=\"ngModel\"\n                               placeholder=\"{{'global.form.newpassword' | translate}}\" pattern=\"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+\"\n                               [(ngModel)]=\"resetAccount.password\" minlength=8 maxlength=50 required jhiInputRequired>\n                        <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\">\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.required\" jhiTranslate=\"global.messages.validate.newpassword.required\">\n                                Your password is required.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.newpassword.minlength\">\n                                Your password is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.newpassword.maxlength\">\n                                Your password cannot be longer than 50 characters.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.pattern\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.pattern\">\n                                Your password format is invalid.\n                            </small>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label>\n                        <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" #confirmPasswordInput=\"ngModel\"\n                               placeholder=\"{{'global.form.confirmpassword' | translate}}\" jhiInputRequired\n                               [(ngModel)]=\"confirmPassword\" minlength=8 maxlength=50 required>\n                        <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\">\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.required\" jhiTranslate=\"global.messages.validate.confirmpassword.required\">\n                                Your password confirmation is required.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.confirmpassword.minlength\">\n                                Your password confirmation is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\">\n                                Your password confirmation cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"reset.finish.form.button\">Reset Password</button>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"reset.request.title\">Reset your password</h1>\n            <div class=\"how\" jhiTranslate=\"reset.request.how\"></div>\n\n            <div class=\"alert alert-danger\" jhiTranslate=\"reset.request.messages.notfound\" *ngIf=\"errorEmailNotExists\">\n                <strong>If you have an account, a reset email will be sent to you.</strong> Please check.\n            </div>\n            <div class=\"alert alert-danger\" jhiTranslate=\"reset.request.messages.errorInconnue\" *ngIf=\"error\">\n                <strong>If you have an account, a reset email will be sent to you.</strong> Please check.\n            </div>\n\n            <div class=\"alert alert-warning\">\n                <p jhiTranslate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p>\n            </div>\n\n            <div class=\"alert alert-success\" *ngIf=\"success == 'OK'\" jhiTranslate=\"reset.request.messages.success\">\n                <strong>If you have an account, a reset email will be sent to you.</strong> Please check.\n            </div>\n\n            <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"requestReset()\" #resetRequestForm=\"ngForm\" class=\"form-inline\">\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">E-mail</label>\n                    <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{'global.form.email' | translate}}\"\n                           [(ngModel)]=\"resetAccount.email\" minlength=5 maxlength=100 #emailInput=\"ngModel\" required jhiInputRequired\n                           pattern=\"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\">\n                    <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.required\" jhiTranslate=\"global.messages.validate.email.required\">\n                            Your e-mail is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.pattern\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                            Your e-mail is invalid.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.minlength\" jhiTranslate=\"global.messages.validate.email.minlength\">\n                            Your e-mail is required to be at least 5 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.email.maxlength\">\n                            Your e-mail cannot be longer than 100 characters.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"text-sm-center\">\n                    <button type=\"submit\" [disabled]=\"resetRequestForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"reset.request.form.button\">Reset</button>\n                </div>\n            </form>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\" *ngIf=\"passwordChangeAllowed === false\">\n        <div class=\"col-md-10 offset-md-1\">\n            <div class=\"alert alert-success\">\n                <span jhiTranslate=\"password.messages.ens\">Not allowed</span>\n                <a href=\"https://ent.ens-lyon.fr\" target=\"_blank\" jhiTranslate=\"password.messages.portal\">Allez sur le portail</a>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" *ngIf=\"passwordChangeAllowed === true\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"password.title\" *ngIf=\"account\">Password for</h1>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"password.messages.success\">\n                <strong>Password changed!</strong>\n            </div>\n            <div class=\"alert alert-danger\" *ngIf=\"error\"  jhiTranslate=\"password.messages.error\">\n                <strong>An error has occurred!</strong> The password could not be changed.\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\">\n                The password and its confirmation do not match!\n            </div>\n\n            <form name=\"form\" role=\"form\" (ngSubmit)=\"changePassword()\" #passwordForm=\"ngForm\">\n\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label>\n                    <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #passwordInput=\"ngModel\"\n                    placeholder=\"{{'global.form.newpassword' | translate}}\" jhiInputRequired\n                           [(ngModel)]=\"password\" minlength=8 maxlength=50 required pattern=\"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+\">\n                    <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"passwordInput.errors.required\" jhiTranslate=\"global.messages.validate.newpassword.required\">\n                            Your password is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"passwordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.newpassword.minlength\">\n                            Your password is required to be at least 4 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"passwordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.newpassword.maxlength\">\n                            Your password cannot be longer than 50 characters.\n                        </small>\n                        <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.pattern\"\n                               jhiTranslate=\"global.messages.validate.newpassword.pattern\">\n                            Your password format is invalid.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label>\n                    <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" #confirmPasswordInput=\"ngModel\"\n                    placeholder=\"{{'global.form.confirmpassword' | translate}}\"\n                           [(ngModel)]=\"confirmPassword\" minlength=8 maxlength=50 required jhiInputRequired>\n                    <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"confirmPasswordInput.errors.required\" jhiTranslate=\"global.messages.validate.confirmpassword.required\">\n                            Your confirmation password is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"confirmPasswordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.confirmpassword.minlength\">\n                            Your confirmation password is required to be at least 4 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                           *ngIf=\"confirmPasswordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\">\n                            Your confirmation password cannot be longer than 50 characters.\n                        </small>\n                    </div>\n                </div>\n\n                <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"password.form.button\">Save</button>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h4 jhiTranslate=\"register.confirmation.title\">Registration</h4>\n            <div class=\"how\" jhiTranslate=\"register.confirmation.how\"></div>\n            <div class=\"how\" jhiTranslate=\"register.confirmation.how2\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"register.title\">Registration</h1>\n            <div class=\"how\" jhiTranslate=\"register.messages.how\"></div>\n        </div>\n        <div class=\"col-md-10 offset-md-1\">\n            <form autocomplete=\"off\"\n                  name=\"form\" role=\"form\" (ngSubmit)=\"register()\" #registerForm=\"ngForm\">\n                <div class=\"\">\n                    <div class=\"alert alert-warning\"\n                         *ngIf=\"!createUser && ((currentLang != 'en' && parametrage?.MESSAGE_INSCRIPTION?.libelle != null && parametrage?.MESSAGE_INSCRIPTION?.libelle.length>10)  || (currentLang === 'en' && parametrage?.MESSAGE_INSCRIPTION?.libelleEn != null && parametrage?.MESSAGE_INSCRIPTION?.libelleEn.length>10)) \"\n                         [innerHTML]=\"getConnexionMessage(currentLang) | SafeHtml \">\n                    </div>\n                    <div *ngIf=\"createUser\" class=\"alert alert-warning\"\n                         jhiTranslate=\"global.messages.info.adminRegister\">\n                    </div>\n                </div>\n\n                <div class=\"\">\n                    <div class=\"form-inline\">\n                        <label class=\"col-sm-2 control-label\" jhiTranslate=\"register.form.civilite\">Civility</label>\n                        <div class=\"form-check form-check-inline\">\n                            <p-radioButton name=\"civilite\" id=\"female\" value=\"MME\" [(ngModel)]=\"registerAccount.civilite\" #civility=\"ngModel\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"register.form.female\">Female</label>\n                        </div>\n                        <div class=\"form-check form-check-inline\">\n                            <p-radioButton name=\"civilite\" id=\"male\" value=\"M.\" [(ngModel)]=\"registerAccount.civilite\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"register.form.male\">Male</label>\n                        </div>\n                        <div *ngIf=\"civility.dirty && civility.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"civility.errors.required\" jhiTranslate=\"register.messages.validate.civility.required\">\n                                Your civility is required.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"lastNameCadensSansCompletion\" jhiTranslate=\"register.form.lastname\">Nom</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"registerAccount.lastName\" id=\"lastNameCadensSansCompletion\" name=\"lastNameCadensSansCompletion\" #lastName=\"ngModel\"\n                               placeholder=\"{{'register.form.lastname' | translate}}\"\n                               required jhiInputRequired minlength=\"1\" maxlength=\"80\">\n                        <div *ngIf=\"lastName?.dirty && lastName?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.required\" jhiTranslate=\"register.messages.validate.lastName.required\">\n                                Your username is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.minlength\"\n                                   jhiTranslate=\"register.messages.validate.lastName.minlength\">\n                                Your username is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.maxlength\"\n                                   jhiTranslate=\"register.messages.validate.lastName.maxlength\">\n                                Your username cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"lastNameUsageCadensSansCompletion\" jhiTranslate=\"register.form.lastNameUsage\">lastNameUsageCadensSansCompletion</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"registerAccount.lastNameUsage\" id=\"lastNameUsageCadensSansCompletion\" name=\"lastNameUsageCadensSansCompletion\"\n                               #lastNameUsage=\"ngModel\" placeholder=\"{{'register.form.lastNameUsage.placeholder' | translate}}\"\n                               maxlength=\"80\">\n                        <div *ngIf=\"lastNameUsage?.dirty && lastNameUsage?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.required\" jhiTranslate=\"register.messages.validate.lastNameUsage.required\">\n                                Your lastNameUsage is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.minlength\"\n                                   jhiTranslate=\"register.messages.validate.lastNameUsage.minlength\">\n                                Your lastNameUsage is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.maxlength\"\n                                   jhiTranslate=\"register.messages.validate.lastNameUsage.maxlength\">\n                                Your lastNameUsage cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"firstNameCadensSansCompletion\" jhiTranslate=\"register.form.firstName\">firstNameCadensSansCompletion</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"registerAccount.firstName\" id=\"firstNameCadensSansCompletion\" name=\"firstNameCadensSansCompletion\"\n                               #firstName=\"ngModel\" placeholder=\"{{'register.form.firstName' | translate}}\"\n                               required jhiInputRequired minlength=\"1\" maxlength=\"40\">\n                        <div *ngIf=\"firstName?.dirty && firstName?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.required\" jhiTranslate=\"register.messages.validate.firstName.required\">\n                                Your firstname is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.minlength\"\n                                   jhiTranslate=\"register.messages.validate.firstName.minlength\">\n                                Your firstname is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.maxlength\"\n                                   jhiTranslate=\"register.messages.validate.firstName.maxlength\">\n                                Your firstname cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"otherNames\" jhiTranslate=\"register.form.otherNames\">othernames</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"registerAccount.otherNames\" id=\"otherNames\" name=\"otherNamesCadensSansCompletion\" #otherNames=\"ngModel\"\n                               placeholder=\"{{'register.form.otherNames.placeholder' | translate}}\" maxlength=\"40\">\n                        <div *ngIf=\"otherNames.dirty && otherNames.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"otherNames.errors.minlength\"\n                                   jhiTranslate=\"register.messages.validate.otherNames.minlength\">\n                                Your othernames is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"otherNames.errors.maxlength\"\n                                   jhiTranslate=\"register.messages.validate.otherNames.maxlength\">\n                                Your othernames cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"birthDate\" jhiTranslate=\"register.form.birthDate\">birthDate</label>\n                        <p-calendar [(ngModel)]=\"registerAccount.birthDate\" id=\"birthDate\" name=\"birthDate\" #birthDate=\"ngModel\" required jhiInputRequired\n                                    [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\" yearRange=\"1960:2007\"\n                                    [monthNavigator]=\"true\"></p-calendar>\n                        <div *ngIf=\"birthDate?.dirty && birthDate?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"birthDate.errors.required\" jhiTranslate=\"register.messages.validate.birthDate.required\">\n                                Your birthDate is required.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-12\">\n                        <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">E-mail</label>\n                        <input type=\"email\" class=\"form-control\" id=\"email\" name=\"emailCadensSansCompletion\" #email=\"ngModel\" placeholder=\"{{'global.form.email' | translate}}\"\n                               [(ngModel)]=\"registerAccount.email\" minlength=5 maxlength=100 required jhiInputRequired\n                               pattern=\"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\">\n                        <div *ngIf=\"email.dirty && email.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"email.errors.required\"\n                                   jhiTranslate=\"global.messages.validate.email.required\">\n                                Your e-mail is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"email.errors.pattern\"\n                                   jhiTranslate=\"global.messages.validate.email.invalid\">\n                                Your e-mail is invalid.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"email.errors.minlength\"\n                                   jhiTranslate=\"global.messages.validate.email.minlength\">\n                                Your e-mail is required to be at least 5 characters.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"email.errors.maxlength\"\n                                   jhiTranslate=\"global.messages.validate.email.maxlength\">\n                                Your e-mail cannot be longer than 100 characters.\n                            </small>\n                        </div>\n                        <small class=\"form-text text-danger\" *ngIf=\"email.dirty && registerAccount.email != null && registerAccount.email.indexOf('@ens-lyon.fr') > 0\"\n                               jhiTranslate=\"global.messages.validate.email.ens\">\n                            Attention c'est un email ENS.\n                        </small>\n                    </div>\n                </div>\n                <div *ngIf=\"!createUser\"   class=\"\">\n                    <h2 jhiTranslate=\"register.conditions\">Conditions</h2>\n                    <div class=\"how\" jhiTranslate=\"register.messages.password\"></div>\n                </div>\n                <div *ngIf=\"!createUser\"  class=\"row\">\n                    <div class=\"form-group col-md-8\">\n                        <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label>\n                        <input type=\"password\" class=\"form-control\" id=\"password\" name=\"passwordCadensSansCompletion\" #password=\"ngModel\" placeholder=\"{{'global.form.newpassword' | translate}}\"\n                               [(ngModel)]=\"registerAccount.password\" minlength=8 maxlength=50 required jhiInputRequired pattern=\"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+\">\n                        <div *ngIf=\"password.dirty && password.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"password.errors.required\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.required\">\n                                Your password is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"password.errors.minlength\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.minlength\">\n                                Your password is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"password.errors.maxlength\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.maxlength\">\n                                Your password cannot be longer than 50 characters.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"password.errors.pattern\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.pattern\">\n                                Your password format is invalid.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div  *ngIf=\"!createUser\" class=\"row\">\n                    <div class=\"form-group col-md-8\">\n                        <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label>\n                        <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPasswordCadensSansCompletion\" #confirmPasswordInput=\"ngModel\"\n                               placeholder=\"{{'global.form.confirmpassword' | translate}}\"\n                               [(ngModel)]=\"confirmPassword\" minlength=8 maxlength=50 required jhiInputRequired>\n                        <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.required\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.required\">\n                                Your confirmation password is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.minlength\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.minlength\">\n                                Your confirmation password is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.maxlength\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\">\n                                Your confirmation password cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n\n                    <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"register.messages.success\">\n                        <strong>Registration saved!</strong> Please check your email for confirmation.\n                    </div>\n\n                    <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"register.messages.error.fail\">\n                        <strong>Registration failed!</strong> Please try again later.\n                    </div>\n\n                    <div class=\"alert alert-danger\" *ngIf=\"errorTestEmail\" jhiTranslate=\"register.messages.error.errorTestEmail\">\n                        <strong>email test failed!</strong> Please try again later.\n                    </div>\n\n                    <div class=\"alert alert-danger\" *ngIf=\"errorEmailExists\" jhiTranslate=\"register.messages.error.emailexists\">\n                        <strong>E-mail is already in use!</strong> Please choose another one.\n                    </div>\n\n                    <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\">\n                        The password and its confirmation do not match!\n                    </div>\n                </div>\n                <button type=\"submit\" [disabled]=\"registerForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"register.form.button\">Register</button>\n            </form>\n            <p></p>\n            <div class=\"alert alert-warning\">\n                <span jhiTranslate=\"global.messages.info.authenticated.prefix\">If you want to </span>\n                <a class=\"alert-link\" (click)=\"openLogin()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign in</a><span jhiTranslate=\"global.messages.info.authenticated.suffix\">, you can try the default accounts:<br/>- Administrator (login=\"admin\" and password=\"admin\") <br/>- User (login=\"user\" and password=\"user\").</span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-6 offset-md-3\">\n    <h1 jhiTranslate=\"sessions.title\" translateValues=\"{username: '{{account.login}}'}\" *ngIf=\"account\">Active sessions for [<b>{{account.login}}</b>]</h1>\n\n    <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"sessions.messages.success\">\n        <strong>Session invalidated!</strong>\n    </div>\n    <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"sessions.messages.error\">\n        <strong>An error has occured!</strong> The session could not be invalidated.\n    </div>\n\n    <div class=\"table-responsive\">\n        <table class=\"table table-striped\">\n            <thead>\n                <tr>\n                    <th jhiTranslate=\"sessions.table.ipaddress\">IP Address</th>\n                    <th jhiTranslate=\"sessions.table.useragent\">User agent</th>\n                    <th jhiTranslate=\"sessions.table.date\">Date</th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let session of sessions\">\n                    <td>{{session.ipAddress}}</td>\n                    <td>{{session.userAgent}}</td>\n                    <td>{{session.tokenDate | date:'longDate'}}</td>\n                    <td>\n                        <button type=\"submit\"\n                                class=\"btn btn-primary\"\n                                (click)=\"invalidate(session.series)\" jhiTranslate=\"sessions.table.button\">\n                                 Invalidate\n                        </button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h1 jhiTranslate=\"settings.title\" *ngIf=\"settingsAccount\">User settings</h1>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"settings.messages.success\">\n                <strong>Settings saved!</strong>\n            </div>\n\n            <jhi-alert-error></jhi-alert-error>\n\n            <form autocomplete=\"off\" name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #settingsForm=\"ngForm\" *ngIf=\"settingsAccount\" novalidate>\n\n                <div class=\"\">\n                    <div class=\"form-inline\">\n                        <label class=\"col-sm-2 control-label\" jhiTranslate=\"settings.form.civilite\">Civility</label>\n                        <div class=\"form-check form-check-inline\">\n                            <p-radioButton name=\"civilite\" id=\"female\" value=\"MME\" [(ngModel)]=\"settingsAccount.civilite\" #civility=\"ngModel\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"settings.form.female\">Female</label>\n                        </div>\n                        <div class=\"form-check form-check-inline\">\n                            <p-radioButton name=\"civilite\" id=\"male\" value=\"M.\" [(ngModel)]=\"settingsAccount.civilite\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"settings.form.male\">Male</label>\n                        </div>\n                        <div *ngIf=\"civility.dirty && civility.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"civility.errors.required\" jhiTranslate=\"settings.messages.validate.civility.required\">\n                                Your civility is required.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"lastNameCadensSansCompletion\" jhiTranslate=\"settings.form.lastname\">Nom</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"settingsAccount.lastName\" id=\"lastNameCadensSansCompletion\" name=\"lastlastNameCadensSansCompletion\" #lastName=\"ngModel\"\n                               placeholder=\"{{'settings.form.lastname' | translate}}\"\n                               required jhiInputRequired minlength=\"1\" maxlength=\"80\">\n                        <div *ngIf=\"lastName?.dirty && lastName?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.required\" jhiTranslate=\"settings.messages.validate.lastName.required\">\n                                Your username is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.minlength\"\n                                   jhiTranslate=\"settings.messages.validate.lastName.minlength\">\n                                Your username is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastName.errors.maxlength\"\n                                   jhiTranslate=\"settings.messages.validate.lastName.maxlength\">\n                                Your username cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"lastNameUsage\" jhiTranslate=\"settings.form.lastNameUsage\">lastNameUsage</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"settingsAccount.lastNameUsage\" id=\"lastNameUsage\" name=\"lastNameUsage\"\n                               #lastNameUsage=\"ngModel\" placeholder=\"{{'settings.form.lastNameUsage.placeholder' | translate}}\"\n                               maxlength=\"80\">\n                        <div *ngIf=\"lastNameUsage?.dirty && lastNameUsage?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.required\" jhiTranslate=\"settings.messages.validate.lastNameUsage.required\">\n                                Your lastNameUsage is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.minlength\"\n                                   jhiTranslate=\"settings.messages.validate.lastNameUsage.minlength\">\n                                Your lastNameUsage is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"lastNameUsage.errors.maxlength\"\n                                   jhiTranslate=\"settings.messages.validate.lastNameUsage.maxlength\">\n                                Your lastNameUsage cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"firstNameCadensSansCompletion\" jhiTranslate=\"settings.form.firstName\">firstName</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"settingsAccount.firstName\" id=\"firstNameCadensSansCompletion\" name=\"firstNameCadensSansCompletion\"\n                               #firstName=\"ngModel\" placeholder=\"{{'settings.form.firstName' | translate}}\"\n                               required jhiInputRequired minlength=\"1\" maxlength=\"40\">\n                        <div *ngIf=\"firstName?.dirty && firstName?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.required\" jhiTranslate=\"settings.messages.validate.firstName.required\">\n                                Your firstname is required.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.minlength\"\n                                   jhiTranslate=\"settings.messages.validate.firstName.minlength\">\n                                Your firstname is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"firstName.errors.maxlength\"\n                                   jhiTranslate=\"settings.messages.validate.firstName.maxlength\">\n                                Your firstname cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"otherNames\" jhiTranslate=\"settings.form.otherNames\">othernames</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"settingsAccount.otherNames\" id=\"otherNames\" name=\"otherNames\" #otherNames=\"ngModel\"\n                               placeholder=\"{{'settings.form.otherNames.placeholder' | translate}}\" maxlength=\"40\">\n                        <div *ngIf=\"otherNames.dirty && otherNames.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"otherNames.errors.minlength\"\n                                   jhiTranslate=\"settings.messages.validate.otherNames.minlength\">\n                                Your othernames is required to be at least 1 character.\n                            </small>\n                            <small class=\"form-text text-danger\" *ngIf=\"otherNames.errors.maxlength\"\n                                   jhiTranslate=\"settings.messages.validate.otherNames.maxlength\">\n                                Your othernames cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-md-6\">\n                        <label class=\"form-control-label\" for=\"birthDate\" jhiTranslate=\"settings.form.birthDate\">birthDate</label>\n                        <p-calendar [(ngModel)]=\"settingsAccount.birthDate\" id=\"birthDate\" name=\"birthDate\" #birthDate=\"ngModel\" required jhiInputRequired\n                                    [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\" yearRange=\"1960:2007\"\n                                    [monthNavigator]=\"true\"></p-calendar>\n                        <div *ngIf=\"birthDate?.dirty && birthDate?.invalid\">\n                            <small class=\"form-text text-danger\" *ngIf=\"birthDate.errors.required\" jhiTranslate=\"settings.messages.validate.birthDate.required\">\n                                Your birthDate is required.\n                            </small>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">E-mail</label>\n                    <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{'global.form.email.placeholder' | translate}}\"\n                           [(ngModel)]=\"settingsAccount.email\" minlength=5 maxlength=100 #emailInput=\"ngModel\" required\n                           pattern=\"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\" disabled=\"true\">\n                    <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                        <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.required\" jhiTranslate=\"global.messages.validate.email.required\">\n                            Your e-mail is required.\n                        </small>\n                        <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.pattern\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                            Your e-mail is invalid.\n                        </small>\n                        <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.minlength\" jhiTranslate=\"global.messages.validate.email.minlength\">\n                            Your e-mail is required to be at least 5 characters.\n                        </small>\n                        <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.email.maxlength\">\n                            Your e-mail cannot be longer than 100 characters.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\">\n                    <label for=\"langKey\" jhiTranslate=\"settings.form.language\">Language</label>\n                    <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"settingsAccount.langKey\">\n                        <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}</option>\n                    </select>\n                </div>\n                <button type=\"submit\" [disabled]=\"settingsForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"settings.form.button\">Save</button>\n            </form>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-8 pagecard\">\n    <h1 jhiTranslate=\"aide.home.title\">archive</h1>\n    <jhi-alert></jhi-alert>\n\n\n    <div class=\"table-responsive\" *ngIf=\"userRolesList.Count()>0\">\n        <p-dataTable #table [value]=\"userRolesList.Values()\" tableStyleClass=\"table-striped table-bordered\">\n            <p-header class=\"row justify-content-around\">\n            </p-header>\n\n            <p-column [style]=\"{'width':'250px'}\" field=\"nomRole\" [header]=\"'aide.userRole' | translate\">\n                <template let-col let-aideRole=\"rowData\" pTemplate=\"body\">\n                    <span>{{ \"userManagement.\" + aideRole.nomRole  | translate }}</span>\n                </template>\n            </p-column>\n            <p-column field=\"nomFichierAide\" [header]=\"'aide.fichierAide' | translate\">\n                <template let-col let-aideRole=\"rowData\" pTemplate=\"body\">\n                    <div class=\"center\">\n                        <button *ngIf=\"aideRole.nomFichierAide!=null\" type=\"submit\" (click)=\"openAide(aideRole.nomRole)\"\n                                class=\"btn btn-primary\">\n                            <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"aide.telechargerFichierAide\">Save</span>\n                        </button>\n                        <span *ngIf=\"aideRole.nomFichierAide==null\"\n                              jhiTranslate=\"aide.aideNonDisponible\">\n                            Aide non disponible\n                    </span>\n                    </div>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"isGestionnaire\" field=\"nomFichierAide\" class=\"center\">\n                <template let-col let-aideRole=\"rowData\" pTemplate=\"body\">\n                    <div class=\"center\">\n                        <p-fileUpload name=\"parameterFile+ aideRole.nomRole\"\n                                      url=\"./api/parametrages/upload\"\n                                      accept=\"application/pdf\"\n                                      auto=\"auto\"\n                                      [id]=\"parameterFile+ aideRole.nomRole\"\n                                      (onUpload)=\"onFileUploaded($event, aideRole.nomRole)\"\n                                      (onBeforeSend)=\"onBeforeSend($event)\"\n                                      (onBeforeUpload)=\"onBeforeUpload($event, aideRole.nomRole)\"\n                                      [maxFileSize]=\"maxSize\"\n                                      (onError)=\"onError($event)\"\n                                      chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                                      uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                                      cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n                        </p-fileUpload>\n                    </div>\n                </template>\n            </p-column>\n            <p-column *ngIf=\"isGestionnaire\" field=\"nomFichierAide\" class=\"center\">\n                <template let-col let-aideRole=\"rowData\" pTemplate=\"body\">\n                    <div *ngIf=\"aideRole.nomFichierAide!=null\" class=\"center\">\n                        <button type=\"submit\" (click)=\"supprimeAide(aideRole.nomRole)\" class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"aide.deleteAide\">Delete</span>\n                        </button>\n                    </div>\n                </template>\n            </p-column>\n        </p-dataTable>\n\n    </div>\n</div>\n<p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #dmd key=\"confirmAide\">\n    <p-footer>\n        <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                (click)=\"dmd.reject()\"></button>\n        <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.delete' | translate\"\n                (click)=\"dmd.accept()\"></button>\n    </p-footer>\n</p-confirmDialog>\n"

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard \">\n    <h1 jhiTranslate=\"archive.title\">archive</h1>\n    <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n    <div *ngIf=\"archive\">\n        <!--<div>{{ archive | prettyprint }}</div>-->\n        <div class=\"pagebutton\">\n            <!--<span>{{archive.fichier!=null?archive.fichier.nom:\"Archive vide\"}}</span>-->\n            <button *ngIf=\"archivageEnCours==false && archivageEnCoursDepuis==null\" class=\"btn btn-primary float-right\"\n                    [disabled]=\"disableArchive\" (click)=\"archiveAnneeCourante()\"\n                    [title]=\"'archive.archiveButtonTitle' | translate \">\n                <span class=\"fa fa-archive\"></span> <span jhiTranslate=\"archive.archiveButton\">Archive</span>\n            </button>\n            <button *ngIf=\"archivageEnCours==true && archivageEnCoursDepuis!=null\" class=\"btn btn-primary float-right\"\n                    [disabled]=\"true\"\n                    [title]=\"'archive.statusArchivageTitle' | translate:{dateLancement:archivageEnCoursDepuis} \">\n                <span class=\"fa fa-archive\"></span> <span jhiTranslate=\"archive.statusArchivageTitle\"\n                                                          translateValues=\"{dateLancement: '{{archivageEnCoursDepuis}}'}\">status archivage</span>\n            </button>\n            <button *ngIf=\"archivageEnCours==false && archivageEnCoursDepuis!=null\" class=\"btn btn-primary float-right\"\n                    [disabled]=\"true\"\n                    [title]=\"'archive.finArchivageTitle' | translate:{dateLancement:archivageEnCoursDepuis} \">\n                <span class=\"fa fa-archive\"></span> <span jhiTranslate=\"archive.finArchivageTitle\"\n                                                          translateValues=\"{dateLancement: '{{archivageEnCoursDepuis}}'}\">status archivage</span>\n            </button>\n        </div>\n        <jhi-alert></jhi-alert>\n\n        <tree-view *ngIf=\"archive.fichier!=null\" [listeRepertoire]=\"listeRepertoire\"\n                   (refreshTreeView)=\"onRefreshTreeView($event)\"></tree-view>\n\n        <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd>\n            <p-footer>\n                <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                        (click)=\"cd.reject()\"></button>\n                <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'archive.confirm.button' | translate\"\n                        (click)=\"cd.accept()\"></button>\n            </p-footer>\n        </p-confirmDialog>\n    </div>\n\n</div>\n"

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "<jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n\n<ul>\n\n    <li class=\"list-style-type-none\" *ngFor=\"let dir of listeRepertoire\">\n        <div>\n            <!--\n                         <input style=\"display:inline-block\" type=\"checkbox\" [checked]=\"dir.checked\"\n                                (click)=\"dir.checkRepertoire()\">\n            -->\n\n            <span  *ngIf=\"dir.listeSimpleFichier.length>0\">\n                 <button [class]=\"dir.expanded?'btn btn-light no-padding text-align-left fa fa-caret-down':'btn btn-light no-padding text-align-left fa fa-caret-right'\"\n                         (click)=\"dir.toggle()\"\n                         >\n                    {{dir.nom + ' (' + dir.listeSimpleFichier.length + ')'}}\n                </button>\n                <span *jhiHasAnyAuthority=\"'ROLE_SYSTEM'\">\n                    <button *ngIf=\"dir.peuxEtreSupprime\" [class]=\"'btn btn-danger no-padding float-right fa fa-remove'\"\n                          (click)=\"deleteRepertoire(dir)\"\n                          [title]=\"'archive.deleteButtonTitle' | translate:{nomRepertoire:dir.nom} \">\n                    </button>\n                </span>\n            </span>\n            <span *ngIf=\"dir.listeSimpleFichier.length<=0\" (click)=\"dir.toggle()\">\n                 {{ dir.nom + (dir.listeSimpleFichier.length>0?' (' + dir.listeSimpleFichier.length + ')':'')  }}\n             </span>\n        </div>\n\n        <div>\n            <ul *ngIf=\"dir.expanded\">\n                <li *ngFor=\"let file of dir.listeSimpleFichier\">\n         <span>\n<!--\n                <input style=\"display:inline-block\" type=\"checkbox\" [checked]=\"file.checked\"\n                       (click)=\"file.check()\">\n-->\n                <a tabindex=\"1\" (click)=\"download(file)\"  [title]=\"'archive.downloadButtonTitle' | translate\">{{file.nom}}</a>\n         </span>\n                </li>\n            </ul>\n            <tree-view [listeRepertoire]=\"dir.listeRepertoire\" (refreshTreeView)=\"onRefreshTreeView($event)\"></tree-view>\n        </div>\n    </li>\n</ul>\n"

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"audits\" class=\"card col-md-10 offset-md-1\">\n    <h1 jhiTranslate=\"audits.title\">Audits</h1>\n\n    <div class=\"row\">\n        <div class=\"col-md-5\">\n            <h4 jhiTranslate=\"audits.filter.title\">Filter by date</h4>\n            <p class=\"d-flex\">\n                <span jhiTranslate=\"audits.filter.from\" class=\"input-group-addon\">from</span>\n                <input type=\"date\" class=\"form-control\" name=\"start\" [(ngModel)]=\"fromDate\" (ngModelChange)=\"onChangeDate($event)\" required/>\n                <span jhiTranslate=\"audits.filter.to\" class=\"input-group-addon\">to</span>\n                <input type=\"date\" class=\"form-control\" name=\"end\" [(ngModel)]=\"toDate\" (ngModelChange)=\"onChangeDate($event)\" required/>\n            </p>\n        </div>\n    </div>\n\n    <div class=\"table-responsive\">\n        <table class=\"table table-condensed table-striped table-bordered\">\n            <thead>\n            <tr>\n                <th (click)=\"orderProp = 'timestamp'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.date\">Date</span></th>\n                <th (click)=\"orderProp = 'principal'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.principal\">User</span></th>\n                <th (click)=\"orderProp = 'type'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.status\">State</span></th>\n                <th (click)=\"orderProp = 'data.message'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.data\">Extra data</span></th>\n            </tr>\n            </thead>\n            <tr *ngFor=\"let audit of getAudits()\">\n                <td><span>{{audit.timestamp| date:'medium'}}</span></td>\n                <td><small>{{audit.principal}}</small></td>\n                <td>{{audit.type}}</td>\n                <td>\n                    <span *ngIf=\"audit.data\" ng-show=\"audit.data.message\">{{audit.data.message}}</span>\n                    <span *ngIf=\"audit.data\" ng-show=\"audit.data.remoteAddress\"><span jhiTranslate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span>\n                </td>\n            </tr>\n        </table>\n    </div>\n    <div *ngIf=\"audits\">\n        <div class=\"row justify-content-center\">\n            <jhi-item-count [page]=\"page\" [total]=\"totalItems\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n        </div>\n        <div class=\"row justify-content-center\">\n            <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"allConfiguration && configuration\" class=\"card col-md-10 offset-md-1\">\n    <h1 jhiTranslate=\"configuration.title\">Configuration</h1>\n\n    <span jhiTranslate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\">\n    <label>Spring configuration</label>\n    <table class=\"table table-striped table-bordered table-responsive d-table\">\n        <thead>\n        <tr>\n            <th class=\"w-40\" (click)=\"orderProp = 'prefix'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.prefix\">Prefix</span></th>\n            <th class=\"w-60\" (click)=\"orderProp = 'properties'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.properties\">Properties</span></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let entry of (configuration | pureFilter:filter:'prefix' | orderBy:orderProp:reverse)\">\n            <td><span>{{entry.prefix}}</span></td>\n            <td>\n                <div class=\"row\" *ngFor=\"let key of keys(entry.properties)\">\n                    <div class=\"col-md-4\">{{key}}</div>\n                    <div class=\"col-md-8\">\n                        <span class=\"float-right badge badge-default break\">{{entry.properties[key]}}</span>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n    <div *ngFor=\"let key of keys(allConfiguration)\">\n        <label><span>{{key}}</span></label>\n        <table class=\"table table-sm table-striped table-bordered table-responsive d-table\">\n            <thead>\n            <tr>\n                <th class=\"w-40\">Property</th>\n                <th class=\"w-60\">Value</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let item of allConfiguration[key]\">\n                <td class=\"break\">{{item.key}}</td>\n                <td class=\"break\">\n                    <span class=\"float-right badge badge-default break\">{{item.val}}</span>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<iframe src=\"swagger-ui/index.html\" width=\"100%\" height=\"900\" seamless\n    target=\"_top\" title=\"Swagger UI\" class=\"border-0\"></iframe>\n"

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\" id=\"showHealthLabel\">\n\t\t{{'health.indicator.' + baseName(currentHealth.name) | translate}}\n        {{subSystemName(currentHealth.name)}}\n    </h4>\n    <button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('closed')\"><span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body pad\">\n    <div *ngIf=\"currentHealth.details\">\n        <h5 jhiTranslate=\"health.details.properties\">Properties</h5>\n        <div class=\"table-responsive\">\n            <table class=\"table table-striped\">\n                <thead>\n                    <tr>\n                        <th class=\"text-left\" jhiTranslate=\"health.details.name\">Name</th>\n                        <th class=\"text-left\" jhiTranslate=\"health.details.value\">Value</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let entry of currentHealth.details | keys\">\n                        <td class=\"text-left\">{{entry.key}}</td>\n                        <td class=\"text-left\">{{readableValue(entry.value)}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div *ngIf=\"currentHealth.error\">\n        <h4 jhiTranslate=\"health.details.error\">Error</h4>\n            <pre>{{currentHealth.error}}</pre>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button data-dismiss=\"modal\" class=\"btn btn-secondary float-left\" type=\"button\" (click)=\"activeModal.dismiss('closed')\">Done</button>\n</div>\n"

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1\">\n    <h2>\n        <span jhiTranslate=\"health.title\">Health Checks</span>\n        <button class=\"btn btn-primary float-right\" (click)=\"refresh()\">\n            <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"health.refresh.button\">Refresh</span>\n        </button>\n    </h2>\n    <div class=\"table-responsive\">\n        <table id=\"healthCheck\" class=\"table table-striped\">\n            <thead>\n                <tr>\n                    <th jhiTranslate=\"health.table.service\">Service Name</th>\n                    <th class=\"text-center\" jhiTranslate=\"health.table.status\">Status</th>\n                    <th class=\"text-center\" jhiTranslate=\"health.details.details\">Details</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let health of healthData\">\n                    <td>{{'health.indicator.' + baseName(health.name) | translate}} {{subSystemName(health.name)}}</td>\n                    <td class=\"text-center\">\n                        <span class=\"badge\" [ngClass]=\"getBadgeClass(health.status)\" jhiTranslate=\"{{'health.status.' + health.status}}\">\n                            {{health.status}}\n                        </span>\n                    </td>\n                    <td class=\"text-center\">\n                        <a class=\"hand\" (click)=\"showHealth(health)\" *ngIf=\"health.details || health.error\">\n                            <i class=\"fa fa-eye\"></i>\n                        </a>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive card\" *ngIf=\"loggers\">\n    <h1 jhiTranslate=\"logs.title\">Logs</h1>\n\n    <p jhiTranslate=\"logs.nbloggers\" translateValues=\"{total: '{{ loggers.length }}'}\">There are {{ loggers.length }} loggers.</p>\n\n    <span jhiTranslate=\"logs.filter\">Filter</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\">\n\n    <table class=\"table table-condensed table-striped table-bordered\">\n        <thead>\n        <tr title=\"click to order\">\n            <th (click)=\"orderProp = 'name'; reverse=!reverse\"><span jhiTranslate=\"logs.table.name\">Name</span></th>\n            <th (click)=\"orderProp = 'level'; reverse=!reverse\"><span jhiTranslate=\"logs.table.level\">Level</span></th>\n        </tr>\n        </thead>\n\n        <tr *ngFor=\"let logger of (loggers | pureFilter:filter:'name' | orderBy:orderProp:reverse)\">\n            <td><small>{{logger.name | slice:0:140}}</small></td>\n            <td>\n                <button (click)=\"changeLevel(logger.name, 'TRACE')\" [ngClass]=\"(logger.level=='TRACE') ? 'btn-danger' : 'btn-secondary'\" class=\"btn btn-sm\">TRACE</button>\n                <button (click)=\"changeLevel(logger.name, 'DEBUG')\" [ngClass]=\"(logger.level=='DEBUG') ? 'btn-warning' : 'btn-secondary'\" class=\"btn btn-sm\">DEBUG</button>\n                <button (click)=\"changeLevel(logger.name, 'INFO')\" [ngClass]=\"(logger.level=='INFO') ? 'btn-info' : 'btn-secondary'\" class=\"btn btn-sm\">INFO</button>\n                <button (click)=\"changeLevel(logger.name, 'WARN')\" [ngClass]=\"(logger.level=='WARN') ? 'btn-success' : 'btn-secondary'\" class=\"btn btn-sm\">WARN</button>\n                <button (click)=\"changeLevel(logger.name, 'ERROR')\" [ngClass]=\"(logger.level=='ERROR') ? 'btn-primary' : 'btn-secondary'\" class=\"btn btn-sm\">ERROR</button>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "<!-- Modal used to display the threads dump -->\n<div class=\"modal-header\">\n    <h4 class=\"modal-title\" jhiTranslate=\"metrics.jvm.threads.dump.title\">Threads dump</h4>\n    <button type=\"button\" class=\"close\" (click)=\"activeModal.dismiss('closed')\">&times;</button>\n</div>\n<div class=\"modal-body\">\n    <span class=\"badge badge-primary\" (click)=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpAll}}</span></span>&nbsp;\n    <span class=\"badge badge-success\" (click)=\"threadDumpFilter = {threadState: 'RUNNABLE'}\">Runnable&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpRunnable}}</span></span>&nbsp;\n    <span class=\"badge badge-info\" (click)=\"threadDumpFilter = {threadState: 'WAITING'}\">Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpWaiting}}</span></span>&nbsp;\n    <span class=\"badge badge-warning\" (click)=\"threadDumpFilter = {threadState: 'TIMED_WAITING'}\">Timed Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpTimedWaiting}}</span></span>&nbsp;\n    <span class=\"badge badge-danger\" (click)=\"threadDumpFilter = {threadState: 'BLOCKED'}\">Blocked&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpBlocked}}</span></span>&nbsp;\n    <div class=\"mt-2\">&nbsp;</div>\n    Filter\n    <input type=\"text\" [(ngModel)]=\"threadDumpFilter\" class=\"form-control\">\n    <div class=\"pad\" *ngFor=\"let entry of threadDump | pureFilter:threadDumpFilter:'lockName' | keys\">\n        <h6>\n            <span class=\"badge\" [ngClass]=\"getBadgeClass(entry.value.threadState)\">{{entry.value.threadState}}</span>&nbsp;{{entry.value.threadName}} (ID {{entry.value.threadId}})\n            <a (click)=\"entry.show = !entry.show\" href=\"javascript:void(0);\">\n               <span [hidden]=\"entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span>\n               <span [hidden]=\"!entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span>\n            </a>\n        </h6>\n        <div class=\"card\" [hidden]=\"!entry.show\">\n            <div class=\"card-block\">\n                <div *ngFor=\"let st of entry.value.stackTrace | keys\" class=\"break\">\n                    <samp>{{st.value.className}}.{{st.value.methodName}}(<code>{{st.value.fileName}}:{{st.value.lineNumber}}</code>)</samp>\n                    <span class=\"mt-1\"></span>\n                </div>\n            </div>\n        </div>\n        <table class=\"table table-sm table-responsive\">\n            <thead>\n                <tr>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th>\n                    <th jhiTranslate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>{{entry.value.blockedTime}}</td>\n                    <td>{{entry.value.blockedCount}}</td>\n                    <td>{{entry.value.waitedTime}}</td>\n                    <td>{{entry.value.waitedCount}}</td>\n                    <td><code>{{entry.value.lockName}}</code></td>\n                </tr>\n            </tbody>\n        </table>\n\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-secondary pull-left\" data-dismiss=\"modal\" (click)=\"activeModal.dismiss('closed')\">Done</button>\n</div>\n"

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1\">\n    <h2>\n        <span jhiTranslate=\"metrics.title\">Application Metrics</span>\n        <button class=\"btn btn-primary float-right\" (click)=\"refresh()\">\n            <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"metrics.refresh.button\">Refresh</span>\n        </button>\n    </h2>\n\n    <h3 jhiTranslate=\"metrics.jvm.title\">JVM Metrics</h3>\n    <div class=\"row\" *ngIf=\"!updatingMetrics\">\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.memory.title\">Memory</b>\n            <p><span jhiTranslate=\"metrics.jvm.memory.total\">Total Memory</span> ({{metrics.gauges['jvm.memory.total.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.total.max'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar type=\"success\" [max]=\"metrics.gauges['jvm.memory.total.max'].value\" [value]=\"metrics.gauges['jvm.memory.total.used'].value\" [striped]=\"true\" [animated]=\"true\">\n                <span>{{metrics.gauges['jvm.memory.total.used'].value * 100 / metrics.gauges['jvm.memory.total.max'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{metrics.gauges['jvm.memory.heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.heap.max'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.heap.max'].value\" [value]=\"metrics.gauges['jvm.memory.heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.memory.heap.used'].value * 100 / metrics.gauges['jvm.memory.heap.max'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{metrics.gauges['jvm.memory.non-heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.non-heap.committed'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.non-heap.committed'].value\" [value]=\"metrics.gauges['jvm.memory.non-heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.memory.non-heap.used'].value * 100 / metrics.gauges['jvm.memory.non-heap.committed'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n        </div>\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{metrics.gauges['jvm.threads.count'].value}}) <a class=\"hand\" (click)=\"refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"fa fa-eye\"></i></a>\n            <p><span jhiTranslate=\"metrics.jvm.threads.runnable\">Runnable</span> {{metrics.gauges['jvm.threads.runnable.count'].value}}</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.runnable.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.threads.runnable.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{metrics.gauges['jvm.threads.timed_waiting.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.timed_waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\">\n                <span>{{metrics.gauges['jvm.threads.timed_waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{metrics.gauges['jvm.threads.waiting.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\">\n                <span>{{metrics.gauges['jvm.threads.waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{metrics.gauges['jvm.threads.blocked.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.blocked.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.threads.blocked.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n        </div>\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.gc.title\">Garbage collections</b>\n            <div class=\"row\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.count'].value}}</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.time'].value}}ms</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.count'].value}}</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.time'].value}}ms</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"well well-lg\" *ngIf=\"updatingMetrics\" jhiTranslate=\"metrics.updating\">Updating...</div>\n\n    <h3 jhiTranslate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3>\n    <p *ngIf=\"metrics.counters\">\n        <span jhiTranslate=\"metrics.jvm.http.active\">Active requests</span> <b>{{metrics.counters['com.codahale.metrics.servlet.InstrumentedFilter.activeRequests'].count | number:'1.0-0'}}</b> - <span jhiTranslate=\"metrics.jvm.http.total\">Total requests</span> <b>{{metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count | number:'1.0-0'}}</b>\n    </p>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.jvm.http.table.code\">Code</th>\n                <th jhiTranslate=\"metrics.jvm.http.table.count\">Count</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.jvm.http.table.mean\">Mean</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.ok\">OK</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.notfound\">Not Found</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.servererror\">Server error</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.servicesstats.table.name\">Service name</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.count\">Count</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.mean\">Mean</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.min\">Min</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p50\">p50</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p75\">p75</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p95\">p95</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p99\">p99</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.max\">Max</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let entry of servicesStats | keys\">\n                <td>{{entry.key}}</td>\n                <td class=\"text-right\">{{entry.value.count}}</td>\n                <td class=\"text-right\">{{entry.value.mean * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.min * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p50 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p75 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p95 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p99 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.max * 1000 | number:'1.0-0'}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.cache.title\">Cache statistics</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.cache.cachename\">Cache name</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.hits\">Cache Hits</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.misses\">Cache Misses</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.gets\">Cache Gets</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.puts\">Cache Puts</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.removals\">Cache Removals</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.evictions\">Cache Evictions</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.hitPercent\">Cache Hit %</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.missPercent\">Cache Miss %</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averageGetTime\">Average get time (µs)</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averagePutTime\">Average put time (µs)</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averageRemoveTime\">Average remove time (µs)</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let entry of cachesStats | keys\">\n                <td>{{entry.key}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hits'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-misses'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-gets'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-puts'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-removals'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-evictions'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hit-percentage'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-miss-percentage'].value }}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-get-time'].value  | number : '1.2-2' }}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-put-time'].value  | number : '1.2-2'}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-remove-time'].value | number : '1.2-2' }}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.datasource.title\" *ngIf=\"metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\">DataSource statistics (time in millisecond)</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics && metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\">\n        <table class=\"table table-striped\">\n            <thead>\n                <tr>\n                    <th><span jhiTranslate=\"metrics.datasource.usage\">Usage</span> ({{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value}} / {{metrics.gauges['HikariPool-1.pool.TotalConnections'].value}})</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.count\">Count</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.mean\">Mean</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.min\">Min</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p50\">p50</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p75\">p75</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p95\">p95</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p99\">p99</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.max\">Max</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>\n                        <div class=\"progress progress-striped\">\n                            <ngb-progressbar [max]=\"metrics.gauges['HikariPool-1.pool.TotalConnections'].value\" [value]=\"metrics.gauges['HikariPool-1.pool.ActiveConnections'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                                <span>{{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value * 100 / metrics.gauges['HikariPool-1.pool.TotalConnections'].value  | number:'1.0-0'}}%</span>\n                            </ngb-progressbar>\n                        </div>\n                    </td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].count}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].mean | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].min | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p50 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p75 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p95 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p99 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].max | number:'1.0-2'}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(user.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirmation de suppression</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n            (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"userEchange.delete.question\" translateValues=\"{email: '{{user.email}}'}\">Etes vous sûr de vouloir supprimer cet étudiant en échange?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"user\">\n    <h2>\n        <span jhiTranslate=\"userManagement.detail.title\">User</span> [<b>{{user.login}}</b>]\n    </h2>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"userManagement.login\">Login</span></dt>\n        <dd>\n            <span>{{user.login}}</span>\n            <span class=\"badge badge-danger\" *ngIf=\"!user.activated\"\n                  jhiTranslate=\"userManagement.deactivated\">Deactivated</span>\n            <span class=\"badge badge-success\" *ngIf=\"user.activated\"\n                  jhiTranslate=\"userManagement.activated\">Activated</span>\n        </dd>\n        <dt><span jhiTranslate=\"userManagement.firstName\">First Name</span></dt>\n        <dd>{{user.firstName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastName\">Last Name</span></dt>\n        <dd>{{user.lastName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.email\">Email</span></dt>\n        <dd>{{user.email}}</dd>\n        <dt><span jhiTranslate=\"userManagement.langKey\">Lang Key</span></dt>\n        <dd>{{user.langKey}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdBy\">Created By</span></dt>\n        <dd>{{user.createdBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdDate\">Created Date</span></dt>\n        <dd>{{user.createdDate | date:'dd/MM/yy HH:mm' }}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt>\n        <dd>{{user.lastModifiedBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt>\n        <dd>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</dd>\n        <dt><span jhiTranslate=\"userManagement.profiles\">Profiles</span></dt>\n        <dd>\n            <ul class=\"list-unstyled\">\n                <li *ngFor=\"let authority of user.authorities\">\n                    <span class=\"badge badge-info\">{{authority}}</span>\n                </li>\n            </ul>\n        </dd>\n    </dl>\n    <button type=\"submit\"\n            routerLink=\"/user-management\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n</div>\n"

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myUserLabel\"\n            jhiTranslate=\"userEchange.home.createOrEditLabel.{{typeEtudiantEnumeration[user.typeEtudiant]}}\">\n            Cree ou Edit un étudiant</h4>\n        <h3>{{ user.id }}&nbsp;{{ user.email }}&nbsp;</h3>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" name=\"id\"\n                   [(ngModel)]=\"user.id\" readonly>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.email\">Email</label>\n            <input type=\"email\" class=\"form-control\" name=\"email\" [(ngModel)]=\"user.email\" jhiInputRequired required\n                   pattern=\"^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,6})+$\" >\n        </div>\n\n        <div class=\"form-group\"\n             *ngIf=\"paysListe && paysListe.length > 0 && user.typeEtudiant==typeEtudiantEnumeration.enEchange\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.paysUniversite\">Pays université</label>\n            <select class=\"form-control\" id=\"PaysKey\" name=\"langKey\" [(ngModel)]=\"user.codePaysUniversite\"\n                    jhiInputRequired required>\n                <option *ngFor=\"let pays of paysListe\" [value]=\"pays.code\">{{pays.pays}}</option>\n            </select>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.enEchange\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.nomUniversiteOrigine\">Université</label>\n            <input type=\"text\" class=\"form-control\" name=\"nomUniversiteOrigine\" [(ngModel)]=\"user.nomUniversiteOrigine\"\n                   jhiInputRequired required>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.enEchange\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.typeEchange\">type echange</label>\n            <input type=\"text\" class=\"form-control\" name=\"typeEchange\" [(ngModel)]=\"user.typeEchange\" jhiInputRequired\n                   required>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.restrictionEmail\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.nom\">nom</label>\n            <input type=\"text\" class=\"form-control\" name=\"nom\" [(ngModel)]=\"user.nom\" jhiInputRequired required>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.restrictionEmail\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.prenom\">nom</label>\n            <input type=\"text\" class=\"form-control\" name=\"prenom\" [(ngModel)]=\"user.prenom\" jhiInputRequired required>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.restrictionEmail\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.dateNaissance\">date de naissance</label>\n            <p-calendar [(ngModel)]=\"user.dateNaissance\" name=\"dateNaissance\" jhiInputRequired required\n                        [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                        yearRange=\"1960:2107\" [monthNavigator]=\"true\"></p-calendar>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"user.typeEtudiant==typeEtudiantEnumeration.restrictionEmail\">\n            <label class=\"form-control-label\" jhiTranslate=\"userEchange.campagne\">campagne</label>\n            <select class=\"form-control\" name=\"campagne\" jhiInputRequired required [(ngModel)]=\"user.campagne\">\n                <option></option>\n                <option [ngValue]=\"campagneOption\"\n                        *ngFor=\"let campagneOption of campagnes\">{{campagneOption.libelle}}</option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span\n            jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-floppy-o\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <h1 jhiTranslate=\"userEchange.home.titleType.{{typeEtudiantEnumeration[typeEtudiant]}}\">En echange</h1>\n    <div class=\"pagebutton\">\n        <!--<span jhiTranslate=\"userEchange.home.subtitle\">Etudiants en échanges</span>-->\n        <button class=\"btn btn-primary float-right\"\n                [routerLink]=\"['/', { outlets: { popup: 'user-echange-new/'+ typeEtudiant  } }]\">\n            <span class=\"fa fa-plus\"></span> <span\n            jhiTranslate=\"userEchange.home.createLabel\">Créer un nouvel étudiant en échange</span>\n        </button>\n    </div>\n    <jhi-alert></jhi-alert>\n    <div class=\"table-responsive\" *ngIf=\"users\">\n        <p-dataTable #table [value]=\"users\" [rows]=\"1000\" [paginator]=\"false\" tableStyleClass=\"table-striped table-bordered\"\n                     [globalFilter]=\"search\" [rowsPerPageOptions]=\"[20,50,100]\">\n            <p-header class=\"row justify-content-around\">\n                <div class=\"cold-sm-2\">\n                    <label class=\"\" jhiTranslate=\"userEchange.total\"\n                           translateValues=\"{param: '{{users.length }}'}\"></label>\n                </div>\n                <div class=\"cold-sm-10\">\n                    <div class=\"input-group\">\n                        <input #search type=\"text\" class=\"form-control\" placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\">\n                        <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span class=\"fa fa-search\"></span></span>\n                    </div>\n                </div>\n            </p-header>\n\n            <p-column [style]=\"{'width':'80px'}\" field=\"id\" [header]=\"'global.field.id' | translate\" sortable=\"true\"></p-column>\n            <p-column [style]=\"{'width':'380px'}\" field=\"email\" [header]=\"'userEchange.email' | translate\" sortable=\"true\" [filter]=\"true\" filterMatchMode=\"contains\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <a [routerLink]=\"['/', { outlets: { popup: 'user-echange/'+ user.id + '/edit'} }]\">{{ user.email }}</a>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.enEchange\" [style]=\"{'width':'200px'}\"\n                      field=\"codePaysUniversite\" [header]=\"'userEchange.paysUniversite' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{findPaysDansListe(user.codePaysUniversite).pays}}</p>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.enEchange\" [style]=\"{'width':'500px'}\"\n                      field=\"nomUniversiteOrigine\" [header]=\"'userEchange.nomUniversiteOrigine' | translate\"\n                      sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{user.nomUniversiteOrigine}}</p>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.enEchange\" [style]=\"{'width':'300px'}\"\n                      field=\"typeEchange\" [header]=\"'userEchange.typeEchange' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{user.typeEchange}}</p>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.restrictionEmail\" [style]=\"{'width':'200px'}\"\n                      field=\"nom\" [header]=\"'userEchange.nom' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{user.nom}}</p>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.restrictionEmail\" [style]=\"{'width':'200px'}\"\n                      field=\"nom\" [header]=\"'userEchange.prenom' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{user.prenom}}</p>\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.restrictionEmail\" [style]=\"{'width':'250px'}\"\n                      field=\"nom\" [header]=\"'userEchange.dateNaissance' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    {{ user.dateNaissance | date: 'short'}}\n                </template>\n            </p-column>\n\n            <p-column *ngIf=\"typeEtudiant==typeEtudiantEnumeration.restrictionEmail\" [style]=\"{'width':'200px'}\"\n                      field=\"campagne\" [header]=\"'userEchange.campagne' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <p>{{user.campagne != null ? user.campagne.libelle : null}}</p>\n                </template>\n            </p-column>\n\n            <p-column [style]=\"{'width':'130px'}\" styleClass=\"col-button\">\n                <template let-user=\"rowData\" pTemplate=\"body\">\n                    <button  type=\"submit\" replaceUrl=\"true\" [routerLink]=\"['/', { outlets: { popup: 'user-echange/'+ user.id + '/delete'} }]\" class=\"btn btn-danger btn-sm\">\n                        <span class=\"fa fa-remove\"></span>\n                        <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                    </button>\n                </template>\n            </p-column>\n\n        </p-dataTable>\n\n    </div>\n</div>\n"

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(user.login)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n            (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"userManagement.delete.question\" translateValues=\"{login: '{{user.login}}'}\">Are you sure you want to delete this User?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"user\">\n    <h2>\n        <span jhiTranslate=\"userManagement.detail.title\">User</span> [<b>{{user.login}}</b>]\n    </h2>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"userManagement.login\">Login</span></dt>\n        <dd>\n            <span>{{user.login}}</span>\n            <span class=\"badge badge-danger\" *ngIf=\"!user.activated\"\n                  jhiTranslate=\"userManagement.deactivated\">Deactivated</span>\n            <span class=\"badge badge-success\" *ngIf=\"user.activated\"\n                  jhiTranslate=\"userManagement.activated\">Activated</span>\n        </dd>\n        <dt><span jhiTranslate=\"userManagement.firstName\">First Name</span></dt>\n        <dd>{{user.firstName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastName\">Last Name</span></dt>\n        <dd>{{user.lastName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.email\">Email</span></dt>\n        <dd>{{user.email}}</dd>\n        <dt><span jhiTranslate=\"userManagement.langKey\">Lang Key</span></dt>\n        <dd>{{user.langKey}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdBy\">Created By</span></dt>\n        <dd>{{user.createdBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdDate\">Created Date</span></dt>\n        <dd>{{user.createdDate | date:'dd/MM/yy HH:mm' }}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt>\n        <dd>{{user.lastModifiedBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt>\n        <dd>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</dd>\n        <dt><span jhiTranslate=\"userManagement.profiles\">Profiles</span></dt>\n        <dd>\n            <ul class=\"list-unstyled\">\n                <li *ngFor=\"let authority of user.authorities\">\n                    <span class=\"badge badge-info\">{{authority}}</span>\n                </li>\n            </ul>\n        </dd>\n    </dl>\n    <button type=\"submit\"\n            routerLink=\"/user-management\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n</div>\n"

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myUserLabel\" jhiTranslate=\"userManagement.home.createOrEditLabel\">\n            Create or edit a User</h4>\n        <h3>{{ user.civilite }}&nbsp;{{ user.firstName }}&nbsp;{{ user.lastName }}</h3>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n            (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n    <div class=\"form-group\">\n            <label jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" name=\"id\"\n                   [(ngModel)]=\"user.id\" readonly>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userManagement.email\">Email</label>\n            <input type=\"email\" class=\"form-control\" name=\"email\" [(ngModel)]=\"user.email\" required [disabled]=\"user.id != null\" >\n        </div>\n\n        <div class=\"form-check\">\n            <input class=\"form-check-input\" [disabled]=\"user.id === null\" type=\"checkbox\" id=\"activated\" name=\"activated\" [(ngModel)]=\"user.activated\">\n            <label for=\"activated\"><span></span></label>\n            <label jhiTranslate=\"userManagement.activated\">Activated</label>\n        </div>\n\n        <div class=\"form-check\">\n            <input class=\"form-check-input\" [disabled]=\"user.id === null\" type=\"checkbox\" id=\"pluriannuel\" name=\"pluriannuel\" [(ngModel)]=\"user.pluriannuel\">\n            <label for=\"pluriannuel\"><span></span></label>\n            <label jhiTranslate=\"userManagement.pluriannuel\">pluriannuel</label>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\">\n            <label jhiTranslate=\"userManagement.langKey\">Lang Key</label>\n            <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"user.langKey\">\n                <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}</option>\n            </select>\n        </div>\n         <div class=\"form-group\">\n            <label jhiTranslate=\"userManagement.profiles\">Profiles</label>\n            <div *ngFor=\"let authority of authorities\">\n                <div class=\"form-inline form-check-inline\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [id]=\"authority\" name=\"authority\" jhiInputRequired required\n                           [checked]=\"user!=null && user.authorities!=null && user.authorities.indexOf(authority) > -1\" (change)=\"changeAuthority(authority)\">\n                    <label [for]=\"authority\"><span></span></label>\n                    <label jhiTranslate=\"userManagement.{{authority}}\">authority</label>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span\n            jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-floppy-o\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <h1 jhiTranslate=\"userManagement.home.title\">Utilisateurs</h1>\n    <div class=\"pagebutton\">\n        <!--<span jhiTranslate=\"userManagement.home.subtitle\">Users</span>-->\n        <button class=\"btn btn-primary float-right\" [routerLink]=\"['/register', {  createUser: 'true'} ]\">\n            <span class=\"fa fa-plus\"></span> <span jhiTranslate=\"userManagement.home.createLabel\">Create a new User</span>\n        </button>\n    </div>\n    <jhi-alert></jhi-alert>\n    <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n    <div class=\"table-responsive\" *ngIf=\"users\">\n        <p-dataTable #table [value]=\"users\" [rows]=\"20\" [paginator]=\"true\" tableStyleClass=\"table-striped table-bordered\"\n                     [globalFilter]=\"search\" [rowsPerPageOptions]=\"[20,50,100]\">\n            <p-header class=\"row justify-content-around\">\n                <div class=\"cold-sm-2\">\n                    <label class=\"\" jhiTranslate=\"userManagement.total\" translateValues=\"{param: '{{table.totalRecords}}'}\"></label>\n                </div>\n                <div class=\"col-sm-2 flex-btn-group-container\">\n                    <div class=\"form-check\">\n                        <input class=\"form-check-input\" type=\"checkbox\" name=\"fc\" [(ngModel)]=\"filtreUtilisateurEns\"\n                               id=\"filtreUtilisateurEns\"\n                               [value]=\"true\" (click)=\"onChangeFiltreUtilisateurEns($event.target.checked)\">\n                        <label class=\"d-inline form-control-label\"\n                               for=\"filtreUtilisateurEns\"><span></span></label>\n                        <label jhiTranslate=\"userManagement.filtreUtilisateurEns\"\n                               title=\"Année en cours\">fc</label>\n                    </div>\n                </div>\n                <div class=\"cold-sm-8\">\n                    <div class=\"input-group\">\n                        <input #search type=\"text\" class=\"form-control\" placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\">\n                        <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span class=\"fa fa-search\"></span></span>\n                    </div>\n                </div>\n            </p-header>\n\n            <p-column [style]=\"{'width':'75px'}\" field=\"id\" [header]=\"'global.field.id' | translate\" sortable=\"true\"></p-column>\n            <p-column field=\"email\" [header]=\"'userManagement.email' | translate\" sortable=\"true\" [filter]=\"true\" filterMatchMode=\"contains\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <a [routerLink]=\"['/', { outlets: { popup: 'user-management/'+ user.login + '/edit'} }]\">{{ user.email }}</a>\n                </template>\n            </p-column>\n\n            <p-column [style]=\"{'width':'90px'}\" field=\"activated\" [header]=\"'userManagement.activated' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <span class=\"badge badge-danger hand\" (click)=\"setActive(user, true)\" *ngIf=\"!user.activated\"\n                          jhiTranslate=\"userManagement.deactivated\">Deactivated</span>\n                    <span class=\"badge badge-success hand\" (click)=\"setActive(user, false)\" *ngIf=\"user.activated\"\n                          jhiTranslate=\"userManagement.activated\">Activated</span>\n                </template>\n            </p-column>\n\n            <p-column [style]=\"{'width':'130px'}\" field=\"pluriannuel\" [header]=\"'userManagement.pluriannuel' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <span class=\"badge badge-success hand\" (click)=\"setPluriannuel(user, true)\"  *ngIf=\"!user.pluriannuel\"\n                          jhiTranslate=\"userManagement.pluriannuelDeactivated\">pluriannuel</span>\n                    <span class=\"badge badge-success hand\" (click)=\"setPluriannuel(user, false)\"  *ngIf=\"user.pluriannuel\"\n                          jhiTranslate=\"userManagement.pluriannuelActivated\"></span>\n                </template>\n            </p-column>\n\n            <p-column [style]=\"{'width':'100px'}\" field=\"langKey\" [header]=\"'userManagement.langKey' | translate\" sortable=\"true\"></p-column>\n\n            <p-column field=\"authorities\" [header]=\"'userManagement.profiles' | translate\" sortable=\"true\" [filter]=\"true\" filterMatchMode=\"contains\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    <div *ngFor=\"let authority of user.authorities\">\n                        <span class=\"tag tag-info\">{{ 'userManagement.' + authority | translate }}</span>\n                    </div>\n                </template>\n            </p-column>\n\n            <p-column field=\"createdDate\" [header]=\"'userManagement.createdDate' | translate\" sortable=\"true\">\n                <template let-col let-user=\"rowData\" pTemplate=\"body\">\n                    {{ user.createdDate | date: 'medium'}}\n                </template>\n            </p-column>\n\n            <p-column styleClass=\"col-button\">\n                <template let-user=\"rowData\" pTemplate=\"body\">\n                    <button  type=\"button\"  *ngIf=\"userPeutCandidater(user) && !userResinscription(user)\"  [routerLink]=\"['/candidature/0/' + user.id]\" class=\"btn btn-primary  btn-sm\">\n                        <span class=\"fa fa-plus\"></span>\n                        <span class=\"hidden-md-down\" jhiTranslate=\"userManagement.ajouterCandidature\">Créer une candidature</span>\n                    </button>\n                    <button  type=\"button\"  *ngIf=\"userPeutCandidater(user) && userResinscription(user)\"  [routerLink]=\"['/reinscription/0/' + user.id]\" class=\"btn btn-primary  btn-sm\">\n                        <span class=\"fa fa-plus\"></span>\n                        <span class=\"hidden-md-down\" jhiTranslate=\"userManagement.ajouterResinscription\">Ajouter réinscription</span>\n                    </button>\n                </template>\n            </p-column>\n\n        </p-dataTable>\n\n    </div>\n</div>\n"

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-10 offset-md-1\">\n    <br/>\n    <h1 jhiTranslate=\"cadensApp.admis.home.title\">Admis</h1>\n\n    <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n    <jhi-alert></jhi-alert>\n\n    <div *ngIf=\"!isLoading\">\n        <form class=\"container\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\n\n            <br/>\n            <h2 jhiTranslate=\"cadensApp.admis.home.candidature\">Données candidature</h2>\n\n            <div class=\"row\">\n                <div class=\"form-group col-md-4\">\n                    <label for=\"candidatureFormationId\"><span jhiTranslate=\"global.field.id\">ID</span></label>\n                    <input type=\"text\" id=\"candidatureFormationId\" name=\"candidatureFormationId\" formControlName=\"candidatureFormationId\" class=\"form-control\"\n                           disabled=\"true\">\n                </div>\n                <div class=\"form-group col-md-4\">\n                    <label for=\"commission\"><span jhiTranslate=\"cadensApp.candidature.commission\">Commission</span></label>\n                    <input type=\"text\" id=\"commission\" name=\"commission\" formControlName=\"commission\" class=\"form-control\"\n                           disabled=\"true\">\n                </div>\n            </div>\n\n            <br/>\n\n            <div class=\"table\">\n                <div class=\"row\">\n\n                    <div class=\"col-md-3\">\n\n                        <h2 jhiTranslate=\"cadensApp.admis.home.candidat\">Données candidat</h2>\n                        <br/>\n\n                        <div class=\"row form-group\">\n                            <label class=\"col-sm-2 control-label\" jhiTranslate=\"cadensApp.candidature.civilite\">Civility</label>\n                            <p-radioButton name=\"civilite\" id=\"female\" formControlName=\"civilite\" value=\"MME\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"cadensApp.candidature.female\">Female</label>\n                            &nbsp;&nbsp;\n                            <p-radioButton name=\"civilite\" id=\"male\" formControlName=\"civilite\" value=\"M.\" jhiInputRequired required></p-radioButton>\n                            <label jhiTranslate=\"cadensApp.candidature.male\">Male</label>\n                        </div>\n\n                        <br/>\n                        <div class=\"row form-group\">\n                            <label for=\"nom\"><span jhiTranslate=\"cadensApp.candidature.nom\">Nom</span></label>\n                            <input type=\"text\" id=\"nom\" name=\"nomCadensSansCompletion\" formControlName=\"nom\" class=\"form-control\"\n                                   jhiInputRequired required\n                                   placeholder=\"{{'cadensApp.candidature.nom' | translate}}\" maxlength=\"80\">\n                        </div>\n\n                        <br/>\n                        <div class=\"row form-group\">\n                            <label for=\"nomUsuel\"><span jhiTranslate=\"cadensApp.candidature.nomUsuel\">nomUsuel</span></label>\n                            <input type=\"text\" id=\"nomUsuel\" name=\"nomUsuelCadensSansCompletion\" formControlName=\"nomUsuel\" class=\"form-control\"\n                                   placeholder=\"{{'cadensApp.candidature.nomUsuel' | translate}}\" maxlength=\"80\">\n                        </div>\n\n                        <br/>\n                        <div class=\"row form-group\">\n                            <label for=\"prenom\"><span jhiTranslate=\"cadensApp.candidature.prenom\">prenom</span></label>\n                            <input type=\"text\" id=\"prenom\" name=\"prenomCadensSansCompletion\" formControlName=\"prenom\" class=\"form-control\"\n                                   jhiInputRequired required\n                                   placeholder=\"{{'cadensApp.candidature.prenom' | translate}}\" maxlength=\"40\">\n                        </div>\n\n                        <br/>\n                        <div class=\"row form-group\">\n                            <label for=\"prenom2\"><span jhiTranslate=\"cadensApp.candidature.prenom2\">prenom2</span></label>\n                            <input type=\"text\" id=\"prenom2\" name=\"prenom2CadensSansCompletion\" formControlName=\"prenom2\" class=\"form-control\"\n                                   placeholder=\"{{'cadensApp.candidature.prenom2' | translate}}\" maxlength=\"40\">\n                        </div>\n\n                        <br/>\n                        <div class=\"row form-group\">\n                            <label for=\"dateNaissance\"><span jhiTranslate=\"cadensApp.candidature.naissance.date\">dateNaissance</span></label>\n                        </div>\n                        <div class=\"row form-group\">\n                            <p-calendar id=\"dateNaissance\" formControlName=\"dateNaissance\" name=\"dateNaissanceCadensSansCompletion\"\n                                        jhiInputRequired required\n                                        [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                                        yearRange=\"1960:2107\" [monthNavigator]=\"true\"></p-calendar>\n                        </div>\n\n                        <br/>\n                        <br/>\n                        <h2 jhiTranslate=\"cadensApp.admis.home.conformiteTitre\">Conformité</h2>\n                        <div class=\"row\">\n                            <div class=\"form-group\">\n                                <label><span jhiTranslate=\"cadensApp.admis.home.conformite\">conformité des données</span></label>\n                                <br/>\n                                <p-selectButton\n                                    [options]=\"conformites\"\n                                    formControlName=\"controleIdentiteAdmis\"\n                                    optionLabel=\"label\"\n                                    optionValue=\"value\"\n                                    (onChange)=\"onSubmit()\"\n                                >\n                                </p-selectButton>\n\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-inline col-md-9\">\n                        <div *ngIf=\"piecesIdentite\">\n                            <div class=\"row\" *ngFor=\"let piece of piecesIdentite\">\n                                <object class=\"pdfViewer\" *ngIf=\"piece.content\" [data]=\"piece.content\" type=\"application/pdf\">\n                                    <param name=\"view\" value=\"Fit\"/>\n                                </object>\n                                <img *ngIf=\"piece.image\" class=\"pdfViewer\" [src]=\"piece.image\"/>\n                                <div class=\"row\">\n                                    <strong>Nom du fichier :</strong>&nbsp;&nbsp; {{ piece.nom }}\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <br/>\n            <br/>\n            <br/>\n            <div class=\"row justify-content-center\">\n                <div class=\"form-group col-md-4\">\n                    <button class=\"btn btn-primary\" title=\"Dossier précédent\"\n                            [disabled]=\"admisService.getIndexCandidatureEnTraitement() === 0\"\n                            (click)=\"dossierPrecedent()\">\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"cadensApp.admis.home.dossierPrecedent\">précédent</span>\n                    </button>\n                </div>\n                <div class=\"form-group col-md-4\">\n                    <button class=\"btn btn-primary\" title=\"Retour\"\n                            (click)=\"retour()\">\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"cadensApp.admis.home.retour\">retour</span>\n                    </button>\n                </div>\n                <div class=\"form-group col-md-4\">\n                    <button class=\"btn btn-primary\" title=\"Dossier suivant\"\n                            [disabled]=\"admisService.getIndexCandidatureEnTraitement() === admisService.getNbCandidaturesEnTraitement() - 1\"\n                            (click)=\"dossierSuivant()\">\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"cadensApp.admis.home.dossierSuivant\">suivant</span>\n                    </button>\n                </div>\n            </div>\n            <br/>\n            <div class=\"row justify-content-end\">\n                <p>\n                    Dossier {{ admisService.getIndexCandidatureEnTraitement() + 1 }} / {{ admisService.getNbCandidaturesEnTraitement() }}\n                </p>\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "<h1 *ngIf=\"choix != null\" [jhiTranslate]=\"'cadensApp.parametrage.' + choix[0]?.type?.toLowerCase()\">master</h1>\n<div *ngFor=\"let choice of choix\">\n    <div class=\"row\">\n        <h3>{{ choice.libelle }}</h3>\n\n        <div class=\"form-group col-sm-10\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.parametrage.libelle\" for=\"libelle-{{choice.id}}\">Libelle</label>\n            <input type=\"text\" class=\"form-control\" id=\"libelle-{{choice.id}}\" [(ngModel)]=\"choice.libelle\" name=\"libelle-{{choice.id}}\" maxlength=\"255\">\n        </div>\n        <div class=\"form-group col-sm-2\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.parametrage.ordre\" for=\"ordre-{{choice.id}}\">ordre</label>\n            <input type=\"number\" class=\"form-control\" id=\"ordre-{{choice.id}}\" [(ngModel)]=\"choice.ordre\" name=\"ordre-{{choice.id}}\">\n        </div>\n\n    </div>\n</div>\n\n"

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"commissions != null && commission == null\" >\n    <div *ngFor=\"let comm of commissions; let idx = index\" class=\"subgroup\" >\n        <div class=\"subgroup-clear\" (click)=\"clearCommission(idx)\">\n            <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n        </div>\n        <div class=\"subgroup-header\">{{ comm.libelle == null ? ('cadensApp.campagne.commission.new' | translate) : comm.libelle }}</div>\n\n        <!--Liste des commissions pour une campagne-->\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.libelle\" for=\"fields_libelle-{{comm.id}}\">Libelle</label>\n            <input type=\"text\" class=\"form-control\" name=\"libelle-{{comm.id}}\" id=\"fields_libelle-{{comm.id}}\" maxlength=\"255\"\n                   [(ngModel)]=\"comm.libelle\" required jhiInputRequired/>\n        </div>\n        <!--Si plusieurs commissions pour une même campagne on définie une date de coupure (les dossiers sont réparties dans les commissions selon cette date) -->\n        <div class=\"row\" *ngIf=\"idx > 0\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateCoupure\" for=\"fields_dateCoupure-{{comm.id}}\">dateCoupure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.dateCoupure\" id=\"fields_dateCoupure-{{comm.id}}\" name=\"dateCoupure-{{comm.id}}\"\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heureCoupure-{{comm.id}}\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.heureCoupure\" id=\"fields_heureCoupure-{{comm.id}}\" name=\"heureCoupure-{{comm.id}}\"\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n        </div>\n        <!--date limite d'avis pédagogique-->\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateLimiteAvis\" for=\"fields_dateLimiteAvis-{{comm.id}}\">Date limite avis</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.dateLimiteAvis\" id=\"fields_dateLimiteAvis-{{comm.id}}\"\n                                name=\"dateLimiteAvis-{{comm.id}}\"\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heureLimiteAvis-{{comm.id}}\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.heureLimiteAvis\" id=\"fields_heureLimiteAvis-{{comm.id}}\" name=\"heureLimiteAvis-{{comm.id}}\"\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n        </div>\n        <!--date de la commission-->\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateCommission\" for=\"fields_dateCommission-{{comm.id}}\">Date Commission</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.dateCommission\" id=\"fields_dateCommission-{{comm.id}}\"\n                                name=\"dateCommission-{{comm.id}}\"\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heureCommission-{{comm.id}}\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.heureCommission\" id=\"fields_heureCommission-{{comm.id}}\" name=\"heureCommission-{{comm.id}}\"\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n        </div>\n        <!--date de publication des résultats de la commission d'admission, à cette date les résultats sont visible par le candidat dans espaceCandidat-->\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.datePublication\" for=\"fields_datePublication-{{comm.id}}\">Date Publication</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.datePublication\" id=\"fields_datePublication-{{comm.id}}\"\n                                name=\"datePublication-{{comm.id}}\"\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heurePublication-{{comm.id}}\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.heurePublication\" id=\"fields_heurePublication-{{comm.id}}\" name=\"heurePublication-{{comm.id}}\"\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n        </div>\n        <!--date limite de confirmation de venue du candidat, après cette date le candidat ne peux plus confirmer ni se désister, les LC ne seront plus mises à jour-->\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateLimiteConfirmation\" for=\"fields_dateLimiteConfirmation-{{comm.id}}\">Date Limite Confirmation</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.dateLimiteConfirmation\" id=\"fields_dateLimiteConfirmation-{{comm.id}}\"\n                                name=\"dateLimiteConfirmation-{{comm.id}}\"\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heureLimiteConfirmation-{{comm.id}}\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"comm.heureLimiteConfirmation\" id=\"fields_heureLimiteConfirmation-{{comm.id}}-{{comm.id}}\"\n                                name=\"heureLimiteConfirmation-{{comm.id}}\"\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"commission != null && commissions == null\">\n    <div class=\"form-group\">\n        <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.libelle\" for=\"field_libelle\">Libelle</label>\n        <input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" maxlength=\"255\"\n               [(ngModel)]=\"commission.libelle\" jhiInputRequired required/>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateLimiteAvis\"\n                   for=\"field_dateLimiteAvis\">Date limite avis</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.dateLimiteAvis\" id=\"field_dateLimiteAvis\" name=\"dateLimiteAvis\"\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                            yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"field_heureLimiteAvis\">Heure</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.heureLimiteAvis\" id=\"field_heureLimiteAvis\" name=\"heureLimiteAvis\"\n                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateCommission\" for=\"field_dateCommission\">Date Commission</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.dateCommission\" id=\"field_dateCommission\" name=\"dateCommission\"\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                            yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"field_heureCommission\">Heure</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.heureCommission\" id=\"field_heureCommission\" name=\"heureCommission\"\n                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.datePublication\" for=\"field_datePublication\">Date Publication</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.datePublication\" id=\"field_datePublication\" name=\"datePublication\"\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                            yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"field_heurePublication\">Heure</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.heurePublication\" id=\"field_heurePublication\" name=\"heurePublication\"\n                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n    </div>\n    <!--date limite de confirmation de venue du candidat, après cette date le candidat ne peux plus confirmer ni se désister, les LC ne seront plus mises à jour-->\n    <div class=\"row\">\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.dateLimiteConfirmation\" for=\"fields_dateLimiteConfirmation\">Date Limite Confirmation</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.dateLimiteConfirmation\" id=\"fields_dateLimiteConfirmation\" name=\"dateLimiteConfirmation\"\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                            yearRange=\"2017:2100\" [monthNavigator]=\"false\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n        <div class=\"form-group col-md-4 col-sm-6\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.commission.heure\" for=\"fields_heureLimiteConfirmation\">Heure</label>\n            <div class=\"d-flex\">\n                <p-calendar [(ngModel)]=\"commission.heureLimiteConfirmation\" id=\"fields_heureLimiteConfirmation\"\n                            name=\"heureLimiteConfirmation\"\n                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\" required jhiInputRequired></p-calendar>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<fieldset [disabled]=\"isPasDeModification()\">\n    <div *ngFor=\"let demandeModif of demandeModifs; let idx = index\" class=\"subgroup\">\n        <div class=\"subgroup-clear\" (click)=\"deleteDemandeModif(idx)\">\n            <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n        </div>\n        <p></p>\n        <div class=\"subgroup-header\">{{buildTitreDemandeModif(demandeModif)}}</div>\n\n        <div class=\"form-group\">\n            <label for=\"demandeModif-{{demandeModif.id}}\"\n                   jhiTranslate=\"cadensApp.demandeModif.titre\">description</label>\n            <input type=\"text\" class=\"form-control\" id=\"demandeModif-{{demandeModif.id}}\"\n                   [(ngModel)]=\"demandeModif.titre\" [maxlength]=\"500\"\n                   jhiInputRequired required ngDefaultControl>\n            <div *ngIf=\"demandeModif?.titre?.length > 255\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.demandeModif.messages.texttoolong\"\n                       translateValues=\"{param: '{{demandeModif.titre.length - 255}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"demandeModifDescription-titre-{{demandeModif.id}}\"\n                   jhiTranslate=\"cadensApp.demandeModif.description\">description</label>\n            <p-editor class=\"\" id=\"demandeModifDescription-titre-{{demandeModif.id}}\"\n                      [(ngModel)]=\"demandeModif.description\" [maxlength]=\"3900\"\n                      jhiInputRequired required>\n            </p-editor>\n        </div>\n    </div>\n    <div>\n        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addDemandeModif()\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span\n            jhiTranslate=\"cadensApp.demandeModif.add\">Ajouter</span>\n        </button>\n    </div>\n\n\n</fieldset>\n\n<p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #dmd key=\"deleteDemandModif\">\n    <p-footer>\n        <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                (click)=\"dmd.reject()\"></button>\n        <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.delete' | translate\"\n                (click)=\"dmd.accept()\"></button>\n    </p-footer>\n</p-confirmDialog>\n"

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"row\">\n    <label>\n        <i class=\"fa fa-info-circle text-primary\" aria-hidden=\"true\"></i>\n        <span jhiTranslate=\"cadensApp.formation.informations\">Informations</span></label>\n</div>\n\n<div class=\"row bloc-informations\" [innerHTML]=\"information\"></div>\n\n<hr>\n"

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "<h1 *ngIf=\"parametrages != null\" [jhiTranslate]=\"'cadensApp.parametrage.' + parametrages[0]?.rubrique?.toLowerCase()\">master</h1>\n<h2 [jhiTranslate]=\"'cadensApp.parametrage.libelles'\">libelles</h2>\n<div *ngFor=\"let parametre of parametrages\">\n    <div class=\"form-group\">\n        <h3 *ngIf=\"parametre.page !== 'FAQ'\" [innerHTML]=\"'cadensApp.parametrage.' + parametre.code | translate\"></h3>\n        <h3 *ngIf=\"parametre.page === 'FAQ'\">{{ parametre.objet }}</h3>\n\n        <input type=\"number\" *ngIf=\"parametre.objet === 'number'\" class=\"form-control\" id=\"number-{{parametre.id}}\" [(ngModel)]=\"parametre.libelle\" name=\"input-{{parametre.id}}\">\n\n        <p-inputSwitch *ngIf=\"parametre.objet === 'yesno'\" class=\"form-control\"\n                       [onLabel]=\"'entity.action.activated' | translate\"\n                       [offLabel]=\"'entity.action.deactivated' | translate\"\n                       name=\"yesno-{{parametre.id}}\" id=\"yesno-{{parametre.id}}\"\n                       [(ngModel)]=\"parametre.libelleBoolean\"\n        ></p-inputSwitch>\n\n        <div *ngIf=\"currentLang === 'fr'\">\n            <input type=\"text\" *ngIf=\"parametre.page === 'FAQ'\" class=\"form-control\" id=\"faq-{{parametre.id}}\" [(ngModel)]=\"parametre.objet\" name=\"faq-{{parametre.id}}\" maxlength=\"255\">\n\n            <input type=\"text\" *ngIf=\"parametre.objet === 'text'\" class=\"form-control\" id=\"input-{{parametre.id}}\" [(ngModel)]=\"parametre.libelle\" name=\"input-{{parametre.id}}\" maxlength=\"255\">\n\n            <p-editor class=\"\" *ngIf=\"parametre.objet === 'textarea' || parametre.page === 'FAQ'\" id=\"editor-{{parametre.id}}\"\n                      [(ngModel)]=\"parametre.libelle\" name=\"editor-{{parametre.id}}\" maxlength=\"2000\">\n            </p-editor>\n            <div *ngIf=\"(parametre.objet === 'textarea' || parametre.page === 'FAQ') && parametre.libelle?.length > 2000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.parametrage.messages.texttoolong\" translateValues=\"{param: '{{parametre.libelle.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n            <p-calendar *ngIf=\"parametre.objet === 'date'\" id=\"date-{{parametre.id}}\"\n                        [(ngModel)]=\"parametre.date\" name=\"date-{{parametre.id}}\"\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                            yearRange=\"1960:2107\" [monthNavigator]=\"true\">\n            </p-calendar>\n        </div>\n\n        <div *ngIf=\"currentLang === 'en'\">\n            <input type=\"text\" *ngIf=\"parametre.page === 'FAQ'\" class=\"form-control\" id=\"faqEn-{{parametre.id}}\" [(ngModel)]=\"parametre.objetEn\" name=\"faqEn-{{parametre.id}}\" maxlength=\"255\">\n\n            <input type=\"text\" *ngIf=\"parametre.objet === 'text'\" class=\"form-control\" id=\"inputEn-{{parametre.id}}\" [(ngModel)]=\"parametre.libelleEn\"\n                   name=\"inputEn-{{parametre.id}}\" maxlength=\"255\">\n\n            <p-editor class=\"\" *ngIf=\"parametre.objet === 'textarea' || parametre.page === 'FAQ'\" id=\"editorEn-{{parametre.id}}\"\n                      [(ngModel)]=\"parametre.libelleEn\" name=\"editorEn-{{parametre.id}}\" maxlength=\"2000\">\n            </p-editor>\n            <div *ngIf=\"(parametre.objet === 'textarea' || parametre.page === 'FAQ') && parametre.libelleEn?.length > 2000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.parametrage.messages.texttoolong\" translateValues=\"{param: '{{parametre.libelleEn.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n            <p-calendar *ngIf=\"parametre.objet === 'date'\" id=\"dateEn-{{parametre.id}}\"\n                        [(ngModel)]=\"parametre.date\" name=\"dateEn-{{parametre.id}}\"\n                        [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                        yearRange=\"1960:2107\" [monthNavigator]=\"true\">\n            </p-calendar>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<fieldset [disabled]=\"isPasDeModification()\">\n    <div *ngFor=\"let piece of pieces; let idx = index\" class=\"subgroup\">\n        <div class=\"subgroup-clear\" (click)=\"clearPiece(idx, piece.id)\">\n            <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n        </div>\n        <div\n            class=\"subgroup-header\">{{currentLang === 'en' && piece.libelleEn != null ? piece.libelleEn : piece.libelle}}</div>\n        <div class=\"form-group\">\n            <label for=\"piece-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.libelle\">libelle</label>\n            <input *ngIf=\"currentLang === 'fr'\" type=\"text\" class=\"form-control\" id=\"piece-{{idx}}\" jhiInputRequired\n                   required [(ngModel)]=\"piece.libelle\" name=\"piece-{{idx}}\" maxlength=\"255\">\n            <input *ngIf=\"currentLang === 'en'\" type=\"text\" class=\"form-control\" id=\"pieceEn-{{idx}}\" jhiInputRequired\n                   required [(ngModel)]=\"piece.libelleEn\" name=\"pieceEn-{{idx}}\" maxlength=\"255\">\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-sm-2\">\n                <label for=\"optionel-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.obligatoire\">obligatoire</label>\n                <p-inputSwitch [disabled]=\"isPasDeModification()\" class=\"d-block\"\n                               [onLabel]=\"'entity.action.activated' | translate\"\n                               [offLabel]=\"'entity.action.deactivated' | translate\"\n                               name=\"optionel-{{idx}}\" id=\"optionel-{{idx}}\"\n                               [(ngModel)]=\"piece.obligatoire\"\n                               (onChange)=\"onChangePieceObligatoire(piece, idx)\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <!--[disabled]=\"isPasDeModification()\" disabled=\"true\"-->\n                <label for=\"aide-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.aide\">aide</label>\n                <p-inputSwitch  class=\"d-block\"\n                                [disabled]=\"isPasDeModification()\"\n                                [onLabel]=\"'entity.action.activated' | translate\"\n                                [offLabel]=\"'entity.action.deactivated' | translate\"\n                                name=\"aide-{{idx}}\" id=\"aide-{{idx}}\" [(ngModel)]=\"aide[idx]\"\n                                #aide[idx]=\"ngModel\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <!--[disabled]=\"isPasDeModification()\"-->\n                <label for=\"descriptif-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.descriptif\">descriptif</label>\n                <p-inputSwitch  class=\"d-block\"\n                                [disabled]=\"isPasDeModification()\"\n                                [onLabel]=\"'entity.action.activated' | translate\"\n                                [offLabel]=\"'entity.action.deactivated' | translate\"\n                                name=\"descriptif-{{idx}}\" id=\"descriptif-{{idx}}\" [(ngModel)]=\"descriptif[idx]\"\n                                #descriptif[piece.id]=\"ngModel\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-3\">\n                <label for=\"descriptif-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.exportRentree\">export\n                    rentrée</label>\n                <p-inputSwitch [disabled]=\"isPasDeModification()\" class=\"d-block\"\n                               [onLabel]=\"'entity.action.activated' | translate\"\n                               [offLabel]=\"'entity.action.deactivated' | translate\"\n                               name=\"exportRentree-{{idx}}\" id=\"exportRentree-{{idx}}\"\n                               [(ngModel)]=\"piece.exportRentree\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <label for=\"ordre-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.ordre\">ordre</label>\n                <input type=\"number\" name=\"ordre-{{idx}}\" id=\"ordre-{{idx}}\" [(ngModel)]=\"piece.ordre\">\n            </div>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"aide[idx] === true\">\n            <label for=\"aide-text-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.aide\">aideLibelle</label>\n            <!-- [disabled]=\"isPasDeModification()\"-->\n            <p-editor [disabled]=\"isOnlyEnseignant\" *ngIf=\"currentLang === 'fr'\" id=\"aide-text-{{idx}}\" [(ngModel)]=\"piece.aide\"\n                      name=\"editor-{{idx}}\" maxlength=\"2000\" jhiInputRequired required>\n            </p-editor>\n            <!-- [disabled]=\"isPasDeModification()\"-->\n            <p-editor [disabled]=\"isOnlyEnseignant\" *ngIf=\"currentLang === 'en'\" id=\"aideEn-text-{{idx}}\"\n                      [(ngModel)]=\"piece.aideEn\"\n                      name=\"editorEn-{{idx}}\" maxlength=\"2000\" jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"piece?.aide?.length > 2000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{piece.aide.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{piece.aideEn.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"descriptif[idx] === true\">\n            <label for=\"descriptif-text-{{idx}}\" jhiTranslate=\"cadensApp.formation.piece.descriptif\">descriptifLibelle</label>\n            <!-- [disabled]=\"isPasDeModification()\"-->\n            <p-editor [disabled]=\"isOnlyEnseignant\" *ngIf=\"currentLang === 'fr'\" id=\"descriptif-text-{{idx}}\"\n                      [(ngModel)]=\"piece.descriptif\"\n                      name=\"editor-descriptif-{{idx}}\" maxlength=\"2000\" jhiInputRequired required>\n            </p-editor>\n            <!-- [disabled]=\"isPasDeModification()\"-->\n            <p-editor [disabled]=\"isOnlyEnseignant\" *ngIf=\"currentLang === 'en'\" id=\"descriptifEn-text-{{idx}}\"\n                      [(ngModel)]=\"piece.descriptifEn\"\n                      name=\"editorEn-descriptif-{{idx}}\" maxlength=\"2000\" jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"piece?.descriptif?.length > 2000 || piece?.descriptifEn?.length > 2000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{piece.descriptif.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n    </div>\n    <div>\n        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addPiece()\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span jhiTranslate=\"cadensApp.formation.piece.add\">Ajouter</span>\n        </button>\n    </div>\n\n\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd key=\"deletePiece\">\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cd.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.delete' | translate\"\n                    (click)=\"cd.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n</fieldset>\n"

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<fieldset [disabled]=\"isPasDeModification()\">\n    <div *ngFor=\"let question of questions; let idx = index\" class=\"subgroup\">\n        <div class=\"subgroup-clear\" (click)=\"clearQuestion(idx)\">\n            <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n        </div>\n        <div class=\"subgroup-header\" [innerHTML]=\"currentLang === 'en'?question.libelleEn:question.libelle\"></div>\n        <div class=\"form-group\">\n            <p-editor *ngIf=\"currentLang === 'fr'\" class=\"\" name=\"question-{{question.id}}\"\n                      id=\"question-{{question.id}}\"\n                      [(ngModel)]=\"question.libelle\" [maxlength]=\"3000\"\n                      jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"question?.libelle?.length > 3000 \">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{question.libelle.length - 3000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n            <p-editor *ngIf=\"currentLang === 'en'\" class=\"\" name=\"questionen-{{question.id}}\"\n                      id=\"questionen-{{question.id}}\"\n                      [(ngModel)]=\"question.libelleEn\" [maxlength]=\"3000\"\n                      jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"question?.libelleEn?.length > 3000 \">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{question.libelleEn.length - 3000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-sm-2\">\n                <label for=\"aidequestion-{{question.id}}\" jhiTranslate=\"cadensApp.formation.question.aide\">aide</label>\n                <p-inputSwitch [disabled]=\"isPasDeModification()\" class=\"d-block\"\n                               [onLabel]=\"'entity.action.activated' | translate\"\n\n                               [offLabel]=\"'entity.action.deactivated' | translate\"\n                               name=\"aidequestion-{{question.id}}\" id=\"aidequestion-{{question.id}}\"\n                               [(ngModel)]=\"aideQuestion[question.id]\"\n                               #aidequestion[question.id]=\"ngModel\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <label for=\"aidequestion-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.interne\">aide</label>\n                <p-inputSwitch [disabled]=\"isPasDeModification()\" class=\"d-block\"\n                               [onLabel]=\"'entity.action.activated' | translate\"\n                               [offLabel]=\"'entity.action.deactivated' | translate\"\n                               name=\"questioninterne-{{question.id}}\" id=\"questioninterne-{{question.id}}\"\n                               [(ngModel)]=\"question.interne\"\n                               #questionInterne[question.id]=\"ngModel\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <label for=\"aidequestion-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.externe\">aide</label>\n                <p-inputSwitch [disabled]=\"isPasDeModification()\" class=\"d-block\"\n                               [onLabel]=\"'entity.action.activated' | translate\"\n                               [offLabel]=\"'entity.action.deactivated' | translate\"\n                               name=\"questionexterne-{{question.id}}\" id=\"questionexterne-{{question.id}}\"\n                               [(ngModel)]=\"question.externe\"\n                               #questionExterne[question.id]=\"ngModel\"></p-inputSwitch>\n            </div>\n            <div class=\"form-group col-sm-2\">\n                <label for=\"ordre-{{idx}}\" jhiTranslate=\"cadensApp.formation.question.ordre\">ordre</label>\n                <input type=\"number\" jhiInputRequired required name=\"ordre-{{idx}}\" id=\"ordre-{{idx}}\" [(ngModel)]=\"question.ordre\">\n            </div>\n        </div>\n        <div class=\"form-group\" *ngIf=\"aideQuestion[question.id] === true\">\n            <label for=\"aidequestion-text-{{question.id}}\"\n                   jhiTranslate=\"cadensApp.formation.question.aide\">libelle</label>\n            <p-editor *ngIf=\"currentLang === 'fr'\" class=\"\" name=\"aidequestion-text-{{question.id}}\"\n                      id=\"aidequestion-text-{{question.id}}\"\n                      [(ngModel)]=\"question.aide\" [maxlength]=\"3000\"\n                      jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"question?.aide?.length > 3000 \">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{question.aide.length - 3000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n            <p-editor *ngIf=\"currentLang === 'en'\" class=\"\" name=\"aidequestionen-text-{{question.id}}\"\n                      id=\"aidequestionen-text-{{question.id}}\"\n                      [(ngModel)]=\"question.aideEn\" [maxlength]=\"3000\"\n                      jhiInputRequired required>\n            </p-editor>\n            <div *ngIf=\"question?.aideEn?.length > 3000  \">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.formation.messages.texttoolong\"\n                       translateValues=\"{param: '{{question.aideEn.length - 3000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-sm-4\">\n                <label for=\"typereponse-{{question.id}}\" jhiTranslate=\"cadensApp.formation.question.typereponse\">typereponse</label>\n                <select class=\"form-control\" jhiInputRequired required\n                        id=\"typereponse-{{question.id}}\"\n                        [(ngModel)]=\"question.typeReponse\" name=\"typereponse-{{question.id}}\">\n                    <option *ngFor=\"let type of typesReponses\" [value]=\"type\">{{ 'cadensApp.formation.typesReponses.' +\n                        type | translate }}\n                    </option>\n                </select>\n            </div>\n            <div class=\"form-group col-sm-8\"\n                 *ngIf=\"question.typeReponse === 'LIST' || question.typeReponse === 'LISTCHOIX' || question.typeReponse === 'CASPARTICULIER' || question.typeReponse === 'CHECKBOX'\">\n                <label *ngIf=\"question.typeReponse === 'LIST'\" for=\"complement-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.complement\">complement</label>\n                <label *ngIf=\"question.typeReponse === 'LISTCHOIX'\" for=\"complement-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.complementChoix\">complement</label>\n                <label *ngIf=\"question.typeReponse === 'CASPARTICULIER'\" for=\"complement-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.complementCasParticulier\">code du cas\n                    particulier</label>\n                <label *ngIf=\"question.typeReponse === 'CHECKBOX'\" for=\"complement-{{question.id}}\"\n                       jhiTranslate=\"cadensApp.formation.question.complementCheckbox\">texte checkbox</label>\n                <input *ngIf=\"currentLang === 'fr'\" type=\"text\" class=\"form-control\" jhiInputRequired required\n                       id=\"complement-{{question.id}}\"\n                       [(ngModel)]=\"question.reponseComplement\" name=\"complement-{{question.id}}\">\n                <input *ngIf=\"currentLang === 'en'\" type=\"text\" class=\"form-control\" jhiInputRequired required\n                       id=\"complementen-{{question.id}}\"\n                       [(ngModel)]=\"question.reponseComplementEn\" name=\"complementen-{{question.id}}\">\n            </div>\n        </div>\n    </div>\n    <div>\n        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addQuestion()\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span jhiTranslate=\"cadensApp.formation.question.add\">Ajouter</span>\n        </button>\n    </div>\n\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd>\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cd.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.delete' | translate\"\n                    (click)=\"cd.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n</fieldset>\n"

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" *ngFor=\"let question of _questions; let idx = index\">\n    <div class=\"form-group col-sm-12\" *ngIf=\"question.typeReponse !== 'RADIO' && question.typeReponse !== 'CASPARTICULIER'\">\n        <label class=\"header question-header\">\n            <span [innerHTML]=\"libelleQuestion(question)\"></span>\n            <span *ngIf=\"question.descriptif != null\"\n                  [innerHTML]=\"currentLang === 'en' && question.descriptifEn != null ? question.descriptifEn : question.descriptif\"></span>\n        </label>\n        <button *ngIf=\"questionAvecBouton(question)\" type=\"button\" (click)=\"clickBouton(question)\"\n                class=\"btn-link btn-question\">\n            <span>{{titreBouton(question)}}</span>\n        </button>\n        <span *ngIf=\"question.aide != null\" (click)=\"openAide(questionModal, question)\" class=\"fa fa-question-circle-o\"\n              title=\"Cliquer\"></span>\n\n        <input class=\"form-control\" id=\"questions-input-{{idx}}\" *ngIf=\"question.typeReponse === 'INPUT'\"\n               [disabled]=\"!isEditable\"\n               [attr.jhiInputRequired]=\"question.obligatoire ? true : undefined\"\n               [attr.required]=\"question.obligatoire ? true : undefined\"\n               name=\"questions-input-{{idx}}\" [(ngModel)]=\"question.reponse\">\n\n        <textarea class=\"form-control\" id=\"questions-{{idx}}\" *ngIf=\"question.typeReponse === 'TEXTAREA'\"\n                  [maxlength]=\"question.max != null ? question.max : 2000\" [rows]=\"question.max > 500 ? 10 : 5\"\n                  [disabled]=\"!isEditable\"\n                  [attr.jhiInputRequired]=\"question.obligatoire ? true : undefined\"\n                  [attr.required]=\"question.obligatoire ? true : undefined\"\n                  name=\"questions-{{idx}}\" [(ngModel)]=\"question.reponse\"></textarea>\n\n\n        <div *ngIf=\"question.typeReponse === 'CHECKBOX' \">\n            <div class=\"form-check\">\n                <p-checkbox name=\"questions-checkbox-{{idx}}\" #questionscheckbox id=\"questions-checkbox\" binary=\"true\"\n                            [(ngModel)]=\"question.reponse\" jhiInputRequired required\n                            [disabled]=\"!isEditable\"></p-checkbox>\n                <label>{{currentLang === 'en' && question.reponseComplementEn != null ? question.reponseComplementEn : question.reponseComplement}}</label>\n            </div>\n            <p>{{questionscheckbox.value}}</p>\n        </div>\n\n        <div class=\"\" *ngIf=\"question.typeReponse === 'YESNO'\">\n            <div class=\"form-check\">\n                <p-radioButton name=\"questions-yesno-{{idx}}\" id=\"questions-yes-{{idx}}\" value=\"true\"\n                               [(ngModel)]=\"question.reponse\" jhiInputRequired required\n                               [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"entity.action.activated\">activated</label>\n            </div>\n            <div class=\"form-check\">\n                <p-radioButton name=\"questions-yesno-{{idx}}\" id=\"questions-no-{{idx}}\" value=\"false\"\n                               [(ngModel)]=\"question.reponse\" jhiInputRequired required\n                               [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"entity.action.deactivated\">deactivated</label>\n            </div>\n        </div>\n\n        <div class=\"\" *ngIf=\"question.typeReponse === 'LIST'\">\n            <select class=\"form-control\" id=\"list-{{question.id}}\" [disabled]=\"!isEditable\"\n                    [attr.jhiInputRequired]=\"question.obligatoire ? true : undefined\"\n                    [attr.required]=\"question.obligatoire ? true : undefined\"\n                    [(ngModel)]=\"question.reponse\" name=\"list-{{question.id}}\">\n                <option *ngFor=\"let compl of question.reponseComplement.split('|')\" [value]=\"compl\">{{ compl }}</option>\n            </select>\n        </div>\n\n        <div class=\"\" *ngIf=\"question.typeReponse === 'LISTCHOIX'\">\n            <select class=\"form-control\" id=\"listchoix-{{question.id}}\" [disabled]=\"!isEditable\"\n                    [attr.jhiInputRequired]=\"question.obligatoire ? true : undefined\"\n                    [attr.required]=\"question.obligatoire ? true : undefined\"\n                    [(ngModel)]=\"question.reponse\" name=\"listchoix-{{question.id}}\">\n                <option *ngFor=\"let liste of ensembleListeChoix[question.reponseComplement]\" [value]=\"liste.code\">{{ libelleChoix(liste)}} </option>\n             </select>\n        </div>\n\n        <div *ngIf=\"question.typeReponse === 'EDITOR' && isEditable\">\n            <p-editor class=\"\" id=\"question-editor-{{idx}}\" [(ngModel)]=\"question.reponse\"\n                      name=\"question-editor-{{idx}}\" maxlength=\"2000\" jhiInputRequired required\n                      [disabled]=\"!isEditable\">\n            </p-editor>\n            <div *ngIf=\"question?.reponse?.length > 2000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"global.form.texttoolong\"\n                       translateValues=\"{param: '{{question.reponse.length - 2000}}'}\">\n                    Text is too long.\n                </small>\n            </div>\n        </div>\n        <div *ngIf=\"question.typeReponse === 'EDITOR' && !isEditable\">\n            <p class=\"reponse\" [innerHTML]=\"question.reponse\"></p>\n        </div>\n    </div>\n</div>\n\n<template #questionModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <div><h4 class=\"modal-title\"\n                 [innerHTML]=\"QuestionClass.getTitreModalAide(aide, currentLang)\"></h4>\n        </div>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p [innerHTML]=\"QuestionClass.getAide(aide, currentLang)\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\">Close</button>\n    </div>\n</template>\n"

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\" *ngIf=\"campagne\">\n    <div class=\"spaceNavigation\">\n        <div class=\"title\">\n            <a class=\"piped\" routerLink=\"/campagne\"><i class=\"fa fa-long-arrow-left\" aria-hidden=\"true\"></i></a>\n            <h1 jhiTranslate=\"global.menu.gestionnaire.campagnes\">campagnes</h1></div>\n    </div>\n\n    <jhi-spinner [display]=\"loading\"></jhi-spinner>\n\n    <div class=\"row no-gutters\">\n        <div class=\"col-sm-3\">\n            <ul id=\"sidebar\" class=\"nav flex-column affix\">\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('informations')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'informations'}\">\n                        <span jhiTranslate=\"cadensApp.campagne.informations\">informations</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('commissions')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'commissions'}\">\n                        <span jhiTranslate=\"cadensApp.campagne.commissions\">commissions</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('formations')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'formations'}\">\n                        <span jhiTranslate=\"cadensApp.campagne.formations.libelle\">formations</span></a>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"col-sm-9 content\">\n            <form name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #registerForm=\"ngForm\" data-toggle=\"validator\">\n                <div>\n\n                    <h1 jhiTranslate=\"cadensApp.campagne.informations\" id=\"informations\">informations</h1>\n\n                    <div class=\"form-group\">\n                        <label for=\"libelle\" jhiTranslate=\"cadensApp.campagne.libelle\">libelle</label>\n                        <input type=\"text\" class=\"form-control\" jhiInputRequired required id=\"libelle\"\n                               [(ngModel)]=\"campagne.libelle\" name=\"libelle\" maxlength=\"255\">\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"form-group col-md-4 col-sm-6\">\n                            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.dateOuverture\"\n                                   for=\"field_dateOuverture\">Date Ouverture</label>\n                            <div class=\"d-flex\">\n                                <p-calendar [(ngModel)]=\"campagne.dateOuverture\" id=\"field_dateOuverture\" name=\"dateOuverture\"\n                                            jhiInputRequired required\n                                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\"\n                                            [yearNavigator]=\"false\"\n                                            yearRange=\"2017:2100\" [monthNavigator]=\"false\"></p-calendar>\n                            </div>\n                        </div>\n                        <div class=\"form-group col-md-4 col-sm-6\">\n                            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.heure\"\n                                   for=\"field_heureOuverture\">Heure</label>\n                            <div class=\"d-flex\">\n                                <p-calendar [(ngModel)]=\"campagne.heureOuverture\" id=\"field_heureOuverture\" name=\"heureOuverture\"\n                                            jhiInputRequired required\n                                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\"></p-calendar>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group col-md-4 col-sm-6\">\n                            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.dateFermeture\"\n                                   for=\"field_dateFermeture\">Date Fermeture</label>\n                            <div class=\"d-flex\">\n                                <p-calendar [(ngModel)]=\"campagne.dateFermeture\" id=\"field_dateFermeture\" name=\"dateFermeture\"\n                                            jhiInputRequired required\n                                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\"\n                                            [yearNavigator]=\"false\"\n                                            yearRange=\"2017:2100\" [monthNavigator]=\"false\"></p-calendar>\n                            </div>\n                        </div>\n                        <div class=\"form-group col-md-4 col-sm-6\">\n                            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.heure\"\n                                   for=\"field_heureOuverture\">Heure</label>\n                            <div class=\"d-flex\">\n                                <p-calendar [(ngModel)]=\"campagne.heureFermeture\" id=\"field_heureFermeture\" name=\"heureFermeture\"\n                                            jhiInputRequired required\n                                            [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\"></p-calendar>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group\">\n                            <table class=\"table\">\n                                <tr>\n                                    <td>\n                                        <label class=\"form-control-label\"\n                                               jhiTranslate=\"cadensApp.campagne.reinscription\"\n                                               for=\"field_reinscription\">reinscription</label>\n                                    </td>\n                                    <td>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"reinscription\" id=\"field_reinscription\" [value]=\"false\"\n                                                           [(ngModel)]=\"campagne.reinscription\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.no\">non</label>\n                                        </div>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"reinscription\" id=\"field_reinscriptionOui\"\n                                                           [value]=\"true\"\n                                                           [(ngModel)]=\"campagne.reinscription\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.yes\">yes</label>\n                                        </div>\n                                    </td>\n                                <tr>\n                                    <td>\n                                        <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.ei\"\n                                               for=\"field_ei\">echange international</label>\n                                    </td>\n                                    <td>\n\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"ei\" id=\"field_ei\" [value]=\"false\"\n                                                           [(ngModel)]=\"campagne.ei\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.no\">non</label>\n                                        </div>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"ei\" id=\"field_eiOui\" [value]=\"true\"\n                                                           [(ngModel)]=\"campagne.ei\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.yes\">yes</label>\n                                        </div>\n                                    </td>\n                                </tr>\n                                <tr>\n                                    <td>\n                                        <label class=\"form-control-label\"\n                                               jhiTranslate=\"cadensApp.campagne.restrictionEmail\"\n                                               for=\"field_restrictionEmail\">restriction email</label>\n                                    </td>\n                                    <td>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"restrictionEmail\" id=\"field_restrictionEmail\"\n                                                           [value]=\"false\" [disabled]=\"restrictionEmailDisabled\"\n                                                           (ngModelChange)=\"campagne.restrictionEmail==true?campagne.restrictionPieces=false:campagne.restrictionEmail==false\"\n                                                           [(ngModel)]=\"campagne.restrictionEmail\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.no\">non</label>\n                                        </div>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"restrictionEmail\" id=\"field_restrictionEmailOui\"\n                                                           [value]=\"true\"\n                                                           [disabled]=\"restrictionEmailDisabled\"\n                                                           (ngModelChange)=\"campagne.restrictionEmail==true?campagne.restrictionPieces=false:campagne.restrictionPieces=campagne.restrictionPieces\"\n                                                           [(ngModel)]=\"campagne.restrictionEmail\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.yes\">yes</label>\n                                        </div>\n                                        <div *ngIf=\"restrictionEmailDisabled\">\n                                            <span jhiTranslate=\"cadensApp.campagne.restrictionEmailInfo\">non</span>\n                                        </div>\n                                    </td>\n                                </tr>\n                                <tr *ngIf=\"campagne.restrictionEmail==true\">\n                                    <td>\n                                        <label class=\"form-control-label\"\n                                               jhiTranslate=\"cadensApp.campagne.restrictionPieces\"\n                                               for=\"field_restrictionPieces\">restriction piecs</label>\n                                    </td>\n                                    <td>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"restrictionPieces\" id=\"field_restrictionPieces\"\n                                                           [value]=\"false\"\n                                                           [(ngModel)]=\"campagne.restrictionPieces\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.no\">non</label>\n                                        </div>\n                                        <div class=\"form-check form-check-inline\">\n                                            <p-radioButton name=\"restrictionPieces\" id=\"field_restrictionPiecesOui\"\n                                                           [value]=\"true\"\n                                                           [(ngModel)]=\"campagne.restrictionPieces\"></p-radioButton>\n                                            <label jhiTranslate=\"global.form.yes\">yes</label>\n                                        </div>\n                                        <div *ngIf=\"campagne.restrictionPieces==true\">\n                                            <span jhiTranslate=\"cadensApp.campagne.restrictionPiecesInfo\">non</span>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n\n                    </div>\n\n                    <hr/>\n                    <h1 jhiTranslate=\"cadensApp.campagne.commissions\" id=\"commissions\">commissions</h1>\n\n                    <jhi-commission-component [(commissions)]=\"commissions\"></jhi-commission-component>\n                    <br/>\n                    <div>\n                        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\"\n                                [routerLink]=\"['/', { outlets: { popup: 'commission-new/' + campagne.id }, params: {campagneId: campagne.id} }]\">\n                            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> <span\n                            jhiTranslate=\"cadensApp.campagne.commission.add\">Ajouter</span>\n                        </button>\n                    </div>\n\n\n                    <hr/>\n                    <h1 id=\"formations\">{{ formations?.length }}&nbsp;<span\n                        jhiTranslate=\"cadensApp.campagne.formations.libelle\">formations</span></h1>\n                    <div class=\"list-group formations\">\n                        <span *ngFor=\"let ff of formations; let idx = index\" class=\"row list-group-item\">\n                            <span class=\"col-sm-11 list-group-item-libelle\">{{ ff.libelleCourt || ff.libelle }}</span>\n                            <a (click)=\"removeFormation(idx, ff.id)\" class=\"col-sm-1\"><i class=\"fa fa-trash-o\"\n                                                                                         aria-hidden=\"true\"></i></a>\n                        </span>\n                    </div>\n                    <div>\n                        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\"\n                                [routerLink]=\"['/', { outlets: { popup: 'campagne-formations/' + campagne.id } }]\">\n                            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> <span\n                            jhiTranslate=\"cadensApp.campagne.formations.add\">Ajouter</span>\n                        </button>\n                    </div>\n\n                    <br/>\n                    <br/>\n                </div>\n\n                <jhi-alert></jhi-alert>\n\n                <div class=\"row\">\n                    <div class=\"col-md-5\">\n                        <button type=\"submit\" class=\"btn btn-primary\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.save\">Save</span>\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myCampagneLabel\" jhiTranslate=\"cadensApp.campagne.home.createOrEditLabel\">Create or edit a Campagne</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.libelle\" for=\"field_libelle\">Libelle</label>\n            <input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" maxlength=\"255\"\n                [(ngModel)]=\"campagne.libelle\" jhiInputRequired required />\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.dateOuverture\" for=\"field_dateOuverture\">Date Ouverture</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"campagne.dateOuverture\" id=\"field_dateOuverture\" name=\"dateOuverture\" jhiInputRequired required\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\"></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.heure\" for=\"field_heureOuverture\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"campagne.heureOuverture\" id=\"field_heureOuverture\" name=\"heureOuverture\" jhiInputRequired required\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\"></p-calendar>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.dateFermeture\" for=\"field_dateFermeture\">Date Fermeture</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"campagne.dateFermeture\" id=\"field_dateFermeture\" name=\"dateFermeture\" jhiInputRequired required\n                                [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"false\"\n                                yearRange=\"2017:2100\" [monthNavigator]=\"false\"></p-calendar>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4 col-sm-6\">\n                <label class=\"form-control-label\" jhiTranslate=\"cadensApp.campagne.heure\" for=\"field_heureOuverture\">Heure</label>\n                <div class=\"d-flex\">\n                    <p-calendar [(ngModel)]=\"campagne.heureFermeture\" id=\"field_heureFermeture\" name=\"heureFermeture\" jhiInputRequired required\n                                [locale]=\"fr\" [timeOnly]=\"true\" hourFormat=\"24\" showSeconds=\"true\"></p-calendar>\n                </div>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myCampagneLabel\" jhiTranslate=\"cadensApp.campagne.formations.add\">Rattacher des formations</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n        <input #filtre placeholder=\"Filtrer\" (input)=\"filterFormations(filtre.value)\">\n        <div class=\"list-group formations\">\n            <span *ngFor=\"let ff of filteredList; let idx = index\">\n                <button type=\"button\" (click)=\"selectFormation($event, ff, idx)\" class=\"list-group-item list-group-item-action\"\n                        [ngClass]=\"{active: selectedFormations.indexOf(ff.id) > -1 }\">{{ ff.libelle }}</button>\n            </span>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"clear()\">\n            <span jhiTranslate=\"entity.action.cancel\"></span></button>\n        <button type=\"submit\" class=\"btn btn-primary\">\n            <span jhiTranslate=\"entity.action.save\"></span></button>\n    </div>\n</form>\n"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <h1 jhiTranslate=\"cadensApp.campagne.home.title\">Campagnes</h1>\n    <div>\n        <div class=\"pagebutton\">\n            <button class=\"btn btn-primary float-right create-campagne\"\n                    [routerLink]=\"['/', { outlets: { popup: ['campagne-new'] } }]\">\n                <span class=\"fa fa-plus\"></span>\n                <span jhiTranslate=\"cadensApp.campagne.home.createLabel\">\n            Create new Campagne\n            </span>\n            </button>\n        </div>\n        <jhi-alert></jhi-alert>\n        <div class=\"row\">\n        </div>\n        <br/>\n        <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n        <div class=\"table-responsive\" *ngIf=\"campagnes\">\n            <p-dataTable #table [value]=\"campagnes\" [rows]=\"20\" [paginator]=\"true\"\n                         tableStyleClass=\"table-striped table-bordered\"\n                         [globalFilter]=\"search\" [(selection)]=\"selectedCampagnes\" [rowsPerPageOptions]=\"[20,50,100]\">\n                <p-header class=\"row justify-content-around\">\n                    <div class=\"cold-sm-1 d-flex align-items-center\">\n                        <label class=\"\" jhiTranslate=\"cadensApp.campagne.total\"\n                               translateValues=\"{param: '{{table.totalRecords}}'}\"></label>\n                    </div>\n                    <div class=\"cold-sm-2\">\n                        <p-multiSelect [options]=\"actions\" [(ngModel)]=\"selectedAction\"\n                                       (onChange)=\"onSelectedAction($event)\"\n                                       [defaultLabel]=\"'cadensApp.campagne.actions' | translate\"></p-multiSelect>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <div class=\"input-group\">\n                            <input #search type=\"text\" class=\"form-control\"\n                                   placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\">\n                            <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span\n                                class=\"fa fa-search\"></span></span>\n                        </div>\n                    </div>\n                    <div class=\"cold-sm-2\">\n                        <button type=\"button\" (click)=\"exportCSV()\" class=\"btn float-right btn-secondary\">\n                            <span class=\"fa fa-file-o text-primary\"></span><span\n                            jhiTranslate=\"entity.action.export\"></span>\n                        </button>\n                    </div>\n                    <div class=\"cold-sm-1\">\n                        <button type=\"button\" (click)=\"exportFormationsCSV()\"\n                                class=\"btn float-right btn-secondary\">\n                            <span class=\"fa fa-file-o text-primary\"></span><span\n                            jhiTranslate=\"entity.action.exportFormationsCampagnes\"></span>\n                        </button>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <p-multiSelect id=\"columnSelection\" name=\"columnSelection\" [options]=\"cols\" [(ngModel)]=\"selectedColumns\"></p-multiSelect>\n                    </div>\n                </p-header>\n\n                <p-column [style]=\"{'width':'55px'}\" selectionMode=\"multiple\"></p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('id') > -1\" [style]=\"{'width':'45px'}\" field=\"id\"\n                          [header]=\"'global.field.id' | translate\" sortable=\"true\"></p-column>\n\n                <p-column field=\"libelle\" [header]=\"'cadensApp.campagne.libelle' | translate\"\n                          [filter]=\"true\" filterMatchMode=\"contains\" sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\" *ngIf=\"campagne.dateSuppression == null\"><a (click)=\"goToCampagne(campagne)\" tabindex=\"-1\">{{campagne.libelle}}</a></span>\n                        <span class=\"ui-cell-data text-deleted\" *ngIf=\"campagne.dateSuppression != null\">{{campagne.libelle}}</span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('commissions') > -1\" [style]=\"{'width':'220px'}\"\n                          [header]=\"'cadensApp.campagne.commission.header' | translate\"\n                          sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        {{ campagne.commissions != null ? campagne.commissions.length : 0 }}\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('formations') > -1\" [style]=\"{'width':'220px'}\"\n                          [header]=\"'cadensApp.campagne.formations.header' | translate\"\n                          sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        {{ campagne.formations != null ? campagne.formations.length : 0 }}\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('dateOuverture') > -1\" [style]=\"{'width':'220px'}\"\n                          field=\"dateOuverture\" [header]=\"'cadensApp.campagne.dateOuverture' | translate\"\n                          [filter]=\"true\" filterMatchMode=\"contains\" sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        {{ campagne.dateOuverture | date: 'short'}}\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('dateFermeture') > -1\" [style]=\"{'width':'230px'}\"\n                          field=\"dateFermeture\" [header]=\"'cadensApp.campagne.dateFermeture' | translate\"\n                          [filter]=\"true\" filterMatchMode=\"contains\" sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        {{ campagne.dateFermeture | date: 'short'}}\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('dateSuppression') > -1\" [style]=\"{'width':'230px'}\"\n                          field=\"dateSuppression\" [header]=\"'cadensApp.campagne.dateSuppression' | translate\"\n                          [filter]=\"true\" filterMatchMode=\"contains\" sortable=\"true\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        {{ campagne.dateSuppression | date: 'short'}}\n                    </template>\n                </p-column>\n\n                <p-column [style]=\"{'width':'120px'}\">\n                    <template let-col let-campagne=\"rowData\" pTemplate=\"body\">\n                        <div\n                            *ngIf=\"campagne.dateOuverture <= now && campagne.dateFermeture >= now && campagne.dateSuppression == null\"\n                            [ngClass]=\"'row-statut statut-FINISHED'\">\n                            En cours\n                        </div>\n                        <div *ngIf=\"campagne.dateOuverture > now && campagne.dateSuppression == null\"\n                             [ngClass]=\"'row-statut statut-CREATED'\">\n                            Future\n                        </div>\n                        <div *ngIf=\"campagne.dateFermeture < now && campagne.dateSuppression == null\"\n                             [ngClass]=\"'row-statut statut-NOTCONFORME'\">\n                            Passee\n                        </div>\n                        <div *ngIf=\"campagne.dateSuppression != null\" [ngClass]=\"'row-statut statut-NOTCONFORME'\">\n                            Supprimee\n                        </div>\n                    </template>\n                </p-column>\n            </p-dataTable>\n        </div>\n    </div>\n\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd>\n        <p-footer>\n            <button type=\"button\" class=\"btn btn-default\" pButton icon=\"fa-close\"\n                    [label]=\"'entity.action.cancel' | translate\" (click)=\"cd.reject()\"></button>\n            <button type=\"button\" class=\"btn btn-primary\" pButton icon=\"fa-check\"\n                    [label]=\"'entity.action.delete' | translate\" (click)=\"cd.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n\n</div>\n"

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" *ngIf=\"typeEtab !== 'EFE'\">\n    <div class=\"form-group col-md-7\">\n        <label for=\"pays\"><span jhiTranslate=\"{{ translationKey + '.pays' }}\">pays</span></label>\n        <select class=\"form-control\" id=\"pays\" jhiInputRequired required [(ngModel)]=\"pays\" name=\"pays\" (ngModelChange)=\"onChangePays($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"paysOption.code\" *ngFor=\"let paysOption of paysListe\">{{ paysOption.edition }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-5\" *ngIf=\"(!pays || pays === '100') && typeEtab !== 'ETRANGER'\">\n        <label for=\"dept\"><span jhiTranslate=\"{{ translationKey + '.dept' }}\">dept</span></label>\n        <select class=\"form-control\" id=\"dept\" jhiInputRequired required [(ngModel)]=\"dept\" name=\"dept\"\n                (ngModelChange)=\"onChangeDept($event)\" [disabled]=\"!isEditable || !pays\">\n            <option></option>\n            <option [ngValue]=\"deptOption.code\" *ngFor=\"let deptOption of deptListe\">{{ deptOption.code + ' - ' + deptOption.libelle }}</option>\n        </select>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"showRne\">\n    <div class=\"form-group col-md-12\" *ngIf=\"(pays === '100' || typeEtab === 'EFE') \">\n        <label for=\"rne\"><span jhiTranslate=\"{{ translationKey + '.etab'}}\">etab</span></label>\n        <p-dropdown class=\"p-form-control\" placeholder=\"     \"\n                    [(ngModel)]=\"rne\" [options]=\"rneListe\" (ngModelChange)=\"onChangeRne($event)\"\n                    id=\"rne\" name=\"rne\" [disabled]=\"!isEditable || (typeEtab !== 'EFE' && (!dept || !pays))\"\n                    [filter]=\"true\">\n        </p-dropdown>\n    </div>\n    <div class=\"form-group col-md-12\" *ngIf=\"pays !== '100'\">\n        <label for=\"rneInput\"><span jhiTranslate=\"{{ translationKey + '.etabAutre'}}\">etab</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"rneInput\" [(ngModel)]=\"rneAutre\" name=\"rne\" maxlength=\"255\"\n               placeholder=\"{{ translationKey + '.etab' | translate}}\"\n               [disabled]=\"!isEditable || (!pays && typeEtab !== 'EFE') \" (ngModelChange)=\"onChangeRneAutre($event)\">\n    </div>\n    <div class=\"form-group col-md-12\" *ngIf=\"typeEtab === 'EFE'\">\n        <label for=\"villeInputEFE\"><span jhiTranslate=\"{{ translationKey + '.ville'}}\">ville</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"villeInputEFE\" jhiInputRequired required [(ngModel)]=\"ville\" name=\"ville\" maxlength=\"60\"\n               placeholder=\"{{ translationKey + '.ville' | translate}}\"\n               [disabled]=\"!isEditable || (!pays && typeEtab !== 'EFE')\" (ngModelChange)=\"onChangeVille($event)\">\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"typeEtab !== 'EFE'\">\n    <div class=\"form-group col-md-12\">\n        <label for=\"ville\"><span jhiTranslate=\"{{ translationKey + '.ville'}}\">ville</span></label>\n        <select class=\"form-control\" id=\"ville\" jhiInputRequired required [(ngModel)]=\"ville\" name=\"ville\"\n                (ngModelChange)=\"onChangeVille($event)\" *ngIf=\"pays === '100'\"\n                [disabled]=\"!isEditable || showRne || (!showRne && !dept )\">\n            <option></option>\n            <option *ngFor=\"let villeOption of villesListe\" [ngValue]=\"villeOption.codeInsee\">{{ villeOption.libelleEdition ? villeOption.libelleEdition : villeOption.libelle }}</option>\n        </select>\n        <input type=\"text\" class=\"form-control\" id=\"villeInput\" jhiInputRequired required [(ngModel)]=\"ville\" name=\"ville\" maxlength=\"60\"\n               placeholder=\"{{ translationKey + '.ville' | translate}}\" *ngIf=\"pays !== '100'\"\n               [disabled]=\"!isEditable || !pays\" (ngModelChange)=\"onChangeVille($event)\">\n    </div>\n</div>\n"

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "\n<h1 jhiTranslate=\"cadensApp.candidature.avis.title\">Avis pédagogique</h1>\n\n\n\n<div class=\"row\">\n    <div class=\"form-group\">\n        <label *ngIf=\"dateLimiteAvis!=null\"><span jhiTranslate=\"cadensApp.candidature.avis.dateLimiteAvis\" translateValues=\"{dateLimiteAvis: '{{dateLimiteAvis | date: 'shortDate' }}'}\">date limite avis</span></label>\n        <br *ngIf=\"dateLimiteAvis!=null\">\n        <label ><span jhiTranslate=\"cadensApp.candidature.avis.avis\">Sélectionner</span></label>\n        <div class=\"btn-toolbar\" role=\"toolbar\">\n            <div class=\"btn-group mr-2\" role=\"group\" *ngFor=\"let avisOption of listeAvis\">\n                <button type=\"button\" (click)=\"chooseAvis(avisOption)\" class=\"btn btn-secondary\" [disabled]=\"avisEnabled < 2\"\n                        [ngClass]=\"{'selected': candidatureFormation.avis === avisOption}\">\n                    <span [jhiTranslate]=\"'cadensApp.candidature.avis.' + avisOption\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"row\" *ngIf=\"candidatureFormation.avis != null && candidatureFormation.avis === constants.NOTFAVORABLE\">\n    <div class=\"form-group\">\n        <label><span jhiTranslate=\"cadensApp.candidature.avis.commentaire\">Sélectionner</span></label>\n        <select class=\"form-control\" id=\"commentaire\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.commentaire\" name=\"commentaire\" [disabled]=\"avisEnabled < 2\">\n            <option [ngValue]=\"commOption.code\" *ngFor=\"let commOption of listeCommentaires\">{{ commOption.libelle }}</option>\n        </select>\n    </div>\n</div>\n\n<div class=\"row\" *ngIf=\"candidatureFormation.avis != null && candidatureFormation.avis === constants.AWAITING\">\n    <div class=\"form-group\">\n        <label for=\"avisRang\"><span jhiTranslate=\"cadensApp.candidature.rang\">rang</span></label>\n        <input type=\"number\" class=\"form-control\" [(ngModel)]=\"candidatureFormation.avisRang\" name=\"avisRang\" id=\"avisRang\" [disabled]=\"avisEnabled < 2\">\n    </div>\n</div>\n"

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <div class=\"tableContainer candidatures\" *ngIf=\"!isUser\" id=\"TOP\">\n        <div class=\"row\">\n            <div class=\"col-sm-3 name icon\">{{candidatureFormation?.candidat}}</div>\n            <div class=\"col-sm-5 name\">{{candidatureFormation?.ordre != null && traitementEnabled > 1 ?\n                (('cadensApp.candidature.choix' | translate) + candidatureFormation?.ordre + ' : ') : ''\n                }}{{candidatureFormation?.libelle}}\n            </div>\n            <div class=\"date col-md-2\"\n                 *ngIf=\"candidatureFormation?.dateValidation != null && candidatureFormation?.dateSuppression == null\">\n                <span jhiTranslate=\"cadensApp.candidature.transmittedOn\"></span>{{candidatureFormation?.dateValidation |\n                date: 'longDate'}}\n            </div>\n            <div class=\"date col-md-2\"\n                 *ngIf=\"candidatureFormation?.dateValidation == null && candidatureFormation?.dateSuppression == null\">\n                <span jhiTranslate=\"cadensApp.candidature.createdOn\"></span>{{candidatureFormation?.dateCreation | date:\n                'longDate'}}\n            </div>\n            <div class=\"date col-md-2\" *ngIf=\"candidatureFormation?.dateSuppression != null\">\n                <span jhiTranslate=\"cadensApp.candidature.deletedOn\"></span>{{candidatureFormation?.dateSuppression |\n                date: 'longDate'}}\n            </div>\n            <div class=\"col-md-2\">\n                <span class=\"row-statut statut-{{candidatureFormation?.statut}}\"\n                      jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation?.statut}}\"></span>\n            </div>\n        </div>\n        <div class=\"row\" *ngFor=\"let otherCandi of otherCandidatures\">\n            <div class=\"col-sm-3 name icon\" jhiTranslate=\"cadensApp.candidature.other\"></div>\n            <div class=\"col-sm-5 name\"><a [routerLink]=\"['../', otherCandi.id]\">\n                {{otherCandi.ordre != null ? (('cadensApp.candidature.choix' | translate) + otherCandi.ordre + ' : ') :\n                '' }}{{otherCandi.libelle}}</a>\n            </div>\n            <div class=\"date col-md-2\" *ngIf=\"otherCandi.dateValidation != null && otherCandi.dateSuppression == null\">\n                <span jhiTranslate=\"cadensApp.candidature.transmittedOn\"></span>{{otherCandi.dateValidation | date:\n                'longDate'}}\n            </div>\n            <div class=\"date col-md-2\" *ngIf=\"otherCandi.dateValidation == null && otherCandi.dateSuppression == null\">\n                <span jhiTranslate=\"cadensApp.candidature.createdOn\"></span>{{otherCandi.dateCreation | date:\n                'longDate'}}\n            </div>\n            <div class=\"date col-md-2\" *ngIf=\"otherCandi.dateSuppression != null\">\n                <span jhiTranslate=\"cadensApp.candidature.deletedOn\"></span>{{otherCandi.dateSuppression | date:\n                'longDate'}}\n            </div>\n            <div class=\"col-md-2\">\n                <span class=\"row-statut statut-{{otherCandi.statut}}\"\n                      jhiTranslate=\"cadensApp.candidature.status.{{otherCandi.statut}}\"></span>\n            </div>\n        </div>\n    </div>\n\n    <!-- <p>EI = {{candidatureFormation?.ei}}</p> -->\n    <div class=\"row no-gutters\">\n        <div class=\"col-sm-3\">\n            <div id=\"sidebar\" class=\"\">\n                <ul class=\"nav navbar-nav flex-column\">\n                    <li class=\"sidebar-item\">\n                        <span class=\"sidebar-link\" jhiTranslate=\"global.menu.candidature.admin\" id=\"sidebar-admin\"\n                              (click)=\"onClickOnStep(constants.CIVILITE)\"\n                              [ngClass]=\"{active: (currentPage === constants.SCOLARITE || currentPage === constants.CIVILITE || currentPage === constants.CONFIRMATION || currentPage === constants.ALL)}\">\n                            Données administratives\n                        </span>\n                        <ul class=\"\">\n                            <li class=\"\">\n                                <a class=\"sidebar-sublink\" (click)=\"onClickOnStep(constants.CIVILITE)\"\n                                   [ngClass]=\"{active: currentPage === constants.CIVILITE || currentPage === constants.CONFIRMATION }\">\n                                    <span jhiTranslate=\"global.menu.candidature.civility\">civility</span>\n                                </a>\n                            </li>\n                            <li class=\"\">\n                                <a class=\"sidebar-sublink\" (click)=\"onClickOnStep(constants.SCOLARITE)\"\n                                   [ngClass]=\"{active: currentPage === constants.SCOLARITE || currentPage === constants.CONFIRMATION }\">\n                                    <span jhiTranslate=\"global.menu.candidature.scolarity\">scolarity</span>\n                                </a>\n                            </li>\n                        </ul>\n                    </li>\n                    <li class=\"sidebar-item\">\n                        <a (click)=\"onClickOnStep(constants.FORMATION)\" class=\"sidebar-link\"\n                           [ngClass]=\"{active: currentPage === constants.FORMATION || currentPage === constants.CONFIRMATION || currentPage === constants.ALL}\">\n                            <span jhiTranslate=\"global.menu.candidature.formation\"></span>\n                        </a>\n                    </li>\n                    <li class=\"sidebar-item\" *ngIf=\"!candidatureFormation?.reinscription\">\n                        <a (click)=\"onClickOnStep(constants.PIECES)\" class=\"sidebar-link\"\n                           [ngClass]=\"{active: currentPage === constants.PIECES || currentPage === constants.CONFIRMATION || currentPage === constants.ALL}\">\n                            <span jhiTranslate=\"global.menu.candidature.files\"></span>\n                        </a>\n                    </li>\n\n                    <li class=\"sidebar-item\" *ngIf=\"!isUser\">\n                        <a (click)=\"onClickOnStep(constants.AVIS)\" class=\"sidebar-link\"\n                           [ngClass]=\"{active: currentPage === constants.AVIS || currentPage === constants.ALL}\">\n                            <span jhiTranslate=\"global.menu.candidature.avis\"></span>\n                        </a>\n                    </li>\n                    <!--Si avis autorisé-->\n                    <li class=\"sidebar-item info\" *ngIf=\"avisEnabled > 0 && candidatureFormation.conforme != null\">\n                            <span class=\"row-statut statut-{{candidatureFormation.conforme}}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.conforme}}\"></span>\n                    </li>\n                    <li class=\"sidebar-item info\" *ngIf=\"avisEnabled > 0 && candidatureFormation.response != null\">\n                            <span class=\"row-statut statut-{{candidatureFormation.response}}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.response}}\"></span>\n                    </li>\n                    <li class=\"sidebar-item info\" *ngIf=\"avisEnabled > 0 && candidatureFormation.response === constants.SUCCESS\n                                    && candidatureFormation.ei === constants.HORS_ECHANGE\n                                    && candidatureFormation.indicBourseExcellence\">\n                            <span class=\"row-statut statut-{{ candidatureFormation.bourseExcellence ? 'OK' : 'REJECTED' }}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{ candidatureFormation.bourseExcellence ? 'SUCCES_WITH_BOURSE' : 'SUCCES_WITHOUT_BOURSE' }}\">\n                            </span>\n                    </li>\n                    <li class=\"sidebar-item\" *ngIf=\"avisEnabled > 0 && traitementEnabled > 1\">\n                        <button type=\"button\" class=\"btn btn-primary\"\n                                [routerLink]=\"['/', { outlets: { popup: 'candidature-traitement/' + candidatureFormation.id} }]\"\n                                jhiTranslate=\"entity.action.treat\"></button>\n                    </li>\n                    <li class=\"sidebar-item\" *ngIf=\"avisEnabled > 0\">\n                        <button type=\"button\" (click)=\"exportPdf()\" class=\"btn btn-outline-primary\">\n                            <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.exportPDF\">export</span>\n                        </button>\n                        <button type=\"button\" (click)=\"auditClick()\" class=\"btn btn-outline-primary\">\n                            <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.audit\">Audit</span>\n                        </button>\n                        <button type=\"button\" (click)=\"historiqueClick()\" class=\"btn btn-outline-primary\">\n                            <i class=\"fa fa-history\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.historique\">Historique</span>\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"col-sm-9 content\" *ngIf=\"candidature\">\n            <form autocomplete=\"off\" name=\"form\" role=\"form\" (ngSubmit)=\"save(true,false,null)\" #registerForm=\"ngForm\"\n                  data-toggle=\"validator\">\n                <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n                <div [ngSwitch]=\"currentPage\" id=\"pdfComponent\">\n                    <div class=\"row justify-content-between\" *ngIf=\"avisEnabled > 0 || preavisModifEnabled\">\n                        <div class=\"col-md-3\">\n                            <button type=\"button\" (click)=\"backToListe(false)\" class=\"btn btn-default\">\n                                <span jhiTranslate=\"entity.action.backToList\">back</span>\n                            </button>\n                        </div>\n                        <div class=\"col-md-1\"\n                             *ngIf=\"avisEnabled > 0 && listeCandidatures != null && listeCandidatures.length > 1\">\n                            <button type=\"button\" (click)=\"previousCandidature()\" class=\"btn btn-default\"\n                                    [disabled]=\"listeCandidatures[0] == candidatureFormation.id\">\n                                <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n                            </button>\n                        </div>\n                        <div class=\"col-md-3\"></div>\n                        <div class=\"col-md-1\"\n                             *ngIf=\"avisEnabled > 0 && listeCandidatures != null && listeCandidatures.length > 1\">\n                            <button type=\"button\" (click)=\"nextCandidature()\" class=\"btn btn-default\"\n                                    [disabled]=\"listeCandidatures[listeCandidatures.length - 1] == candidatureFormation.id\">\n                                <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            </button>\n                        </div>\n                        <div class=\"float-right col-md-3\">\n                            <button type=\"button\" (click)=\"saveParGestionnaire(false)\"\n                                    class=\"btn btn-primary btn-group\">\n                                <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.save\">save</span>\n                            </button>\n                            <button *ngIf=\"avisEnabled > 0 && isCurrentAccountNotUser \"\n                                    type=\"button\" (click)=\"saveParGestionnaire(true)\" class=\"btn btn-primary btn-group\"\n                                    [title]=\"getVerifierTitle('entity.action.verifierCandidatureTitle')\">\n                                <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.verifierCandidature\"> save et vérifier</span>\n                            </button>\n                        </div>\n                    </div>\n                    <br>\n                    <div *ngIf=\"candidatureFormation.listePreavis!=null && candidatureFormation.listePreavis.length>0\"></div>\n\n                    <jhi-preavis-component\n                        *ngSwitchCase=\"currentPage === constants.AVIS || currentPage === constants.ALL ? currentPage : 'non'\"\n                        [(listePreavis)]=\"candidatureFormation.listePreavis\" [dateLimitePreavis]=\"dateLimiteAvis\"\n                        [preavisModifEnabled]=\"preavisModifEnabled\"\n                        id=\"PREAVIS\"></jhi-preavis-component>\n\n                    <jhi-avis-component\n                        *ngSwitchCase=\"currentPage === constants.AVIS || currentPage === constants.ALL ? currentPage : 'non'\"\n                        [(candidatureFormation)]=\"candidatureFormation\" [dateLimiteAvis]=\"dateLimiteAvis\"\n                        [avisEnabled]=\"avisEnabled\"\n                        id=\"AVIS\"></jhi-avis-component>\n\n                    <jhi-civilite-component\n                        *ngSwitchCase=\"adresseLoaded && (currentPage === constants.CIVILITE || currentPage === constants.ALL) ? currentPage : 'non'\"\n                        [candidature]=\"candidature\"\n                        [candidatureFormation]=\"candidatureFormation\" [(adresse)]=\"adresse\" [isEditable]=\"isEditable\"\n                        [paysListe]=\"paysListe\" [deptListe]=\"deptListe\" id=\"CIVILITE\"></jhi-civilite-component>\n\n                    <jhi-scolarite-component\n                        *ngSwitchCase=\"currentPage === constants.SCOLARITE || currentPage === constants.ALL ? currentPage : 'non'\"\n                        [candidature]=\"candidature\" [(courses)]=\"courses\"\n                        [candidatureFormation]=\"candidatureFormation\" [(concours)]=\"concours\" [isEditable]=\"isEditable\"\n                        [paysListe]=\"paysListe\" [deptListe]=\"deptListe\" id=\"SCOLARITE\"></jhi-scolarite-component>\n\n                    <jhi-formation-component\n                        *ngSwitchCase=\"currentPage === constants.FORMATION || currentPage === constants.ALL ? currentPage : 'non'\"\n                        [candidatureFormation]=\"candidatureFormation\" [isBO]=\"avisEnabled\"\n                        (desCategoriesFormationDisponiblesChange)=\"onFormationsDisponiblesChange($event)\"\n                        [isEditable]=\"isEditable\" [currentLang]=\"currentLang\" [(questions)]=\"questions\"\n                        [listeCours]=\"listeCours\" id=\"FORMATION\"></jhi-formation-component>\n\n                    <jhi-pieces-component\n                        *ngSwitchCase=\"currentPage === constants.PIECES || (currentPage === constants.ALL && !candidatureFormation.reinscription) ? currentPage : 'non'\"\n                        [candidatureFormation]=\"candidatureFormation\"\n                        [candidatureFormationId]=\"candidatureFormation.formationId\"\n                        [candidatureFormationFc]=\"candidatureFormation.fc\"\n                        [isEditable]=\"isEditable\" [currentLang]=\"currentLang\" [(missingPieces)]=\"missingPieces\"\n                        id=\"PIECES\"\n                        [(referents)]=\"referents\" [loadReferentEvents]=\"eventsSubject.asObservable()\"\n                        [isBO]=\"avisEnabled\" [isSaving]=\"isSaving\">\n                    </jhi-pieces-component>\n\n                    <jhi-confirmation-component *ngSwitchCase=\"constants.CONFIRMATION\"\n                                                [candidatureFormation]=\"candidatureFormation\"></jhi-confirmation-component>\n\n                    <jhi-avis-component\n                        *ngSwitchCase=\"currentPage === constants.AVIS || currentPage === constants.ALL ? currentPage : 'non'\"\n                        [(candidatureFormation)]=\"candidatureFormation\" [avisEnabled]=\"avisEnabled\"\n                        id=\"AVIS2\"></jhi-avis-component>\n\n                </div>\n\n                <jhi-alert></jhi-alert>\n\n                <div class=\"row justify-content-between\" *ngIf=\"avisEnabled === 0\">\n                    <div class=\"col-md-5\"\n                         *ngIf=\"currentPage !== constants.CONFIRMATION && isEditable && candidatureFormation.id != null  \">\n                        <button type=\"button\" (click)=\"saveForLaterAndGoHome()\" class=\"btn btn-default\">\n                            <span jhiTranslate=\"entity.action.saveBackStep\"> save back</span>\n                        </button>\n                        <button type=\"button\" *ngIf=\"isCandidatureEchange() && currentPage == constants.PIECES\"\n                                class=\"btn btn-outline-info\" (click)=\"genererContratEtudeInternational()\">\n                            <i class=\"fa fa-file-text\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.enregistrerEtgenererContratEtude\"></span>\n                        </button>\n                    </div>\n                    <div class=\"col-md-2\"></div>\n                    <div class=\"col-md-5\"\n                         *ngIf=\"\n                         (\n                            isEditable &&\n                            currentPage !== constants.CONFIRMATION &&\n                            (currentPage !== constants.FORMATION || desCategoriesFormationDisponibles==true || candidatureFormation.formationId!=null) &&\n                            !isLastStep()\n                         ) ||\n                         (  !isEditable && !isLastStep()  )\">\n                        <button type=\"submit\" class=\"btn btn-primary\"\n                                [title]=\"getTransmitTitle(false,'entity.action.saveNextStep')\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.saveNextStep\"> save next</span>\n                        </button>\n                    </div>\n                    <div class=\"col-md-5\" *ngIf=\"isEditable && isLastStep()\">\n                        <button type=\"submit\" class=\"btn btn-primary\"\n                                [title]=\"getTransmitTitle(false,'entity.action.transmettreCandidature')\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.transmettreCandidature\"> Transmettre </span>\n                        </button>\n                        <button *ngIf=\"isCurrentAccountNotUser && commissionCouranteCandidature==null \"\n                                [disabled]=\"commissionOuvertePourCandidature!=null || commissionFermePourCandidature==null \"\n                                type=\"button\" (click)=\"save(true,true,null)\" class=\"btn btn-primary\"\n                                [title]=\"getTransmitTitle(true,'entity.action.transmettreCandidature')\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.forcerTransmettreCandidature\"> forcer transmettre</span>\n                        </button>\n                    </div>\n                    <div class=\"float-right\"\n                         *ngIf=\"currentPage === constants.CONFIRMATION || (!isEditable && isLastStep())\">\n                        <button type=\"button\" (click)=\"goToHome()\" class=\"btn btn-primary\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.quit\">Back to list</span>\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row justify-content-between\" *ngIf=\"avisEnabled || preavisModifEnabled > 0\">\n                    <div class=\"col-md-3\">\n                        <button type=\"button\" (click)=\"backToListe(false)\" class=\"btn btn-default\">\n                            <span jhiTranslate=\"entity.action.backToList\">back</span>\n                        </button>\n                    </div>\n                    <div class=\"col-md-1\"\n                         *ngIf=\"avisEnabled > 0 && listeCandidatures != null && listeCandidatures.length > 1\">\n                        <button type=\"button\" (click)=\"previousCandidature()\" class=\"btn btn-default\"\n                                [disabled]=\"listeCandidatures[0] == candidatureFormation.id\">\n                            <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n                        </button>\n                    </div>\n                    <div class=\"col-md-1\"></div>\n                    <div class=\"col-md-2 \">\n                        <button type=\"button\" (click)=\"exportPdf()\" class=\"btn btn-primary mr-2 mb-2\">\n                            <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.exportPDF\">export</span>\n                        </button>\n\n                        <div *ngIf=\"avisEnabled > 0\">\n                            <!-- GENERATION DOC CONTRAT ETUDE -->\n                            <button *ngIf=\"isCandidatureEchange() && !isSaving && isEditable\"\n                                    class=\"btn btn-outline-info mr-2 mb-2\" (click)=\"genererContratEtudeInternational()\">\n                                <i class=\"fa fa-file-text\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.genererContratEtude\"></span>\n                            </button>\n\n                            <!-- REPONSE = ADMIS -->\n                            <div *ngIf=\"candidatureFormation.response === constants.SUCCESS\">\n                                <button\n                                    *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC==null\"\n                                    type=\"button\"\n                                    (click)=\"genererLettreAdmission(candidatureFormation.id,constants.SUCCESS, false)\"\n                                    class=\"btn btn-outline-info mr-2 mb-2\">\n                                    <span jhiTranslate=\"entity.action.genererDocAcceptation\"\n                                          class=\"fa fa-file-text\"></span>\n                                </button>\n                                <button\n                                    *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC !=null\"\n                                    type=\"button\"\n                                    (click)=\"genererLettreAdmission(candidatureFormation.id,constants.AWAITING, false)\"\n                                    class=\"btn btn-outline-info mr-2 mb-2\">\n                                    <span jhiTranslate=\"entity.action.genererDocAttente\" class=\"fa fa-file-text\"></span>\n                                </button>\n                                <button\n                                    *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC!=null\"\n                                    type=\"button\"\n                                    (click)=\"genererLettreAdmission(candidatureFormation.id, constants.SUCCESS, true)\"\n                                    class=\"btn btn-outline-info mr-2 mb-2\">\n                            <span jhiTranslate=\"entity.action.genererDocAcceptationApresLC\"\n                                  class=\"fa fa-file-text\"></span>\n                                </button>\n                            </div>\n                            <!-- REPONSE = LISTE COMPLEMENTAIRE -->\n                            <div *ngIf=\"candidatureFormation.response === constants.AWAITING\">\n                                <button *ngIf=\"candidatureFormation.responseRang != null\"\n                                        class=\"btn btn-secondary\"><span\n                                    jhiTranslate=\"cadensApp.candidature.rang\"></span>\n                                    {{ candidatureFormation.responseRang }}\n                                </button>\n                                <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                        type=\"button\" (click)=\"desistResponse(idx)\" class=\"btn btn-outline-danger\"\n                                        jhiTranslate=\"entity.action.desist\">desist\n                                </button>\n                                <button *ngIf=\"candidatureFormation.statut === constants.DESISTED\"\n                                        class=\"btn btn-outline-danger\"\n                                        jhiTranslate=\"cadensApp.candidature.status.DESISTED\">\n                                    DESISTED\n                                </button>\n                                <p *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"></p>\n                                <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                        type=\"button\"\n                                        (click)=\"genererLettreAdmission(candidatureFormation.id, constants.AWAITING, false)\"\n                                        class=\"btn btn-outline-info mr-2 mb-2\">\n                                    <span jhiTranslate=\"entity.action.genererDocAttente\" class=\"fa fa-file-text\"></span>\n                                </button>\n                            </div>\n                            <!-- REPONSE = REFUS -->\n                            <div *ngIf=\"candidatureFormation.response === constants.REJECTED\">\n                                <button *ngIf=\"candidatureFormation.dateSortieLC ==null\"\n                                        type=\"button\"\n                                        (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, false)\"\n                                        class=\"btn btn-outline-info mr-2 mb-2\">\n                                    <span jhiTranslate=\"entity.action.genererDocRefus\" class=\"fa fa-file-text\"></span>\n                                </button>\n                                <button *ngIf=\"candidatureFormation.dateSortieLC !=null\"\n                                        type=\"button\"\n                                        (click)=\"genererLettreAdmission(candidatureFormation.id,constants.AWAITING, false)\"\n                                        class=\"btn btn-outline-info mr-2 mb-2\">\n                                    <span jhiTranslate=\"entity.action.genererDocAttente\" class=\"fa fa-file-text\"></span>\n                                </button>\n                                <button *ngIf=\"candidatureFormation.dateSortieLC!=null\"\n                                        type=\"button\"\n                                        (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, true)\"\n                                        class=\"btn btn-outline-info mr-2 mb-2\">\n                                <span jhiTranslate=\"entity.action.genererDocRefusApresLC\"\n                                      class=\"fa fa-file-text\"></span>\n                                </button>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"col-md-1\"></div>\n                    <div class=\"col-md-1\" *ngIf=\"listeCandidatures != null && listeCandidatures.length > 1\">\n                        <button type=\"button\" (click)=\"nextCandidature()\" class=\"btn btn-default\"\n                                [disabled]=\"listeCandidatures[listeCandidatures.length - 1] == candidatureFormation.id\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                        </button>\n                    </div>\n                    <div class=\"col-md-3 float-right\">\n                        <button type=\"button\" (click)=\"saveParGestionnaire(false)\" class=\"btn btn-primary  btn-group\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.save\">save</span>\n                        </button>\n                        <button *ngIf=\"avisEnabled > 0 && isCurrentAccountNotUser \"\n                                type=\"button\" (click)=\"verifierCandidature()\" class=\"btn btn-primary  btn-group\"\n                                [title]=\"getVerifierTitle('entity.action.verifierCandidatureTitle')\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.verifierCandidature\"> forcer transmettre</span>\n                        </button>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n    </div>\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd>\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cd.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.save' | translate\"\n                    (click)=\"cd.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n\n</div>\n"

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myCandidatureLabel\" jhiTranslate=\"cadensApp.candidature.traitement.title\">Traitement du dossier</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"form-group\">\n                    <label ><span jhiTranslate=\"cadensApp.candidature.traitement.conformite\">Sélectionner</span></label>\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\n                        <div class=\"btn-group mr-2\" role=\"group\" *ngFor=\"let conformeOption of listeConformites\">\n                            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"selectConformite(conformeOption)\"\n                                    [ngClass]=\"{'selected': candidatureFormation.conforme === conformeOption}\">\n                                <span [jhiTranslate]=\"'cadensApp.candidature.status.' + conformeOption\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"alert alert-danger\" role=\"alert\" *ngIf=\"candidatureFormation.conforme === Constants.NOTCONFORME\">\n                <strong jhiTranslate=\"cadensApp.candidature.traitement.nonavertissement\"></strong>\n            </div>\n            <div class=\"row\">\n                <div class=\"form-group\">\n                    <label ><span jhiTranslate=\"cadensApp.candidature.traitement.resultat\">Sélectionner</span></label>\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\n                        <div class=\"btn-group mr-2\" role=\"group\" *ngFor=\"let resultOption of listeResultats\">\n                            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"selectReponse(resultOption)\"\n                                    [ngClass]=\"{'selected': candidatureFormation.response === resultOption}\">\n                                <span [jhiTranslate]=\"'cadensApp.candidature.status.' + resultOption\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" *ngIf=\"candidatureFormation.response === Constants.SUCCESS\n                                    && candidatureFormation.ei === Constants.HORS_ECHANGE\n                                    && candidatureFormation.indicBourseExcellence\">\n                <div class=\"form-group\">\n                    <table >\n                        <tr>\n                            <div class=\"row\">\n                                <div class=\"form-check col-sm-8\">\n                                    <p-radioButton id=\"bourseExcellence\" class=\"form-check-input\" name=\"bourseExcellence\" [value]=\"true\"\n                                                   [(ngModel)]=\"candidatureFormation.bourseExcellence\"></p-radioButton>\n                                       <label jhiTranslate=\"cadensApp.candidature.status.SUCCES_WITH_BOURSE\">Avec</label>\n                                </div>\n                                <div class=\"form-check col-sm-8\">\n                                    <p-radioButton id=\"bourseExcellence2\" class=\"form-check-input\" name=\"bourseExcellence\" [value]=\"false\"\n                                                   [(ngModel)]=\"candidatureFormation.bourseExcellence\"></p-radioButton>\n                                        <label jhiTranslate=\"cadensApp.candidature.status.SUCCES_WITHOUT_BOURSE\">Sans</label>\n                                </div>\n                            </div>\n\n                        </tr>\n                    </table>\n                </div>\n            </div>\n            <div class=\"row\" *ngIf=\"affichageRang === true && candidatureFormation.response === Constants.AWAITING\">\n                <div class=\"form-group\">\n                    <label *ngIf=\"rangAuto\" for=\"responseRang\"><span jhiTranslate=\"cadensApp.candidature.rangAuto\">rang</span></label>\n                    <label *ngIf=\"!rangAuto\" for=\"responseRang\"><span jhiTranslate=\"cadensApp.candidature.rang\">rang</span></label>\n                    <input type=\"number\" class=\"form-control\" [(ngModel)]=\"candidatureFormation.responseRang\" name=\"responseRang\" id=\"responseRang\">\n                </div>\n            </div>\n            <div class=\"alert alert-warning\" role=\"alert\" *ngIf=\"affichageRang === false\">\n                <strong jhiTranslate=\"cadensApp.candidature.traitement.norang\"></strong>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cdtraiter key=\"traiter\">\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\" (click)=\"cdtraiter.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.save' | translate\" (click)=\"cdtraiter.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n\n</form>\n"

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <h1 *ngIf=\"!reinscription\" jhiTranslate=\"cadensApp.candidature.home.title\">candidature</h1>\n    <h1 *ngIf=\"reinscription\" jhiTranslate=\"cadensApp.candidature.home.reinscription\">candidature interne</h1>\n\n    <div>\n        <div class=\"container-search\">\n            <div class=\"search\" *ngIf=\"candidatures\">\n                <div class=\"search-header row justify-content-between\">\n                    <div class=\"col-sm-4\">\n                        <label><strong>Filtrer par :</strong></label>\n                    </div>\n                    <div class=\"col-sm-4 text-right\">\n                        <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"saveFilters()\"\n                                title=\"Sauvegarder le filtre Favoris\">\n                            <i class=\"fa fa-star btn-yellow\" aria-hidden=\"true\"></i>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"resetFilters(false)\"\n                                title=\"Recharger le filtre Favoris\">\n                            <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"resetFilters(true)\"\n                                title=\"Remise à zéro\">RàZ\n                        </button>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-3 col-sm-4\">\n                        <p-multiSelect [options]=\"commissionList\" defaultLabel=\"Commission\"\n                                       [(ngModel)]=\"filters.commissionId.value\"\n                                       [style.color]=\"getFilterColor(filters.commissionId.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-4\">\n                        <p-multiSelect [options]=\"statutList\" defaultLabel=\"Statut candidature\"\n                                       [(ngModel)]=\"filters.statut.value\"\n                                       [style.color]=\"getFilterColor(filters.statut.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-4\">\n                        <p-multiSelect [options]=\"avisList\" defaultLabel=\"Avis pédagogique\"\n                                       [(ngModel)]=\"filters.avis.value\"\n                                       [style.color]=\"getFilterColor(filters.avis.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-4\">\n                        <p-multiSelect [options]=\"responseList\" defaultLabel=\"Résultat commission\"\n                                       [(ngModel)]=\"filters.response.value\"\n                                       [style.color]=\"getFilterColor(filters.response.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-4 display-line\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"dateSuppression\"\n                                   [(ngModel)]=\"filters.dateSuppression.value\" id=\"dateSuppression\"\n                                   [style.color]=\"getFilterColor(filters.dateSuppression.value)\"\n                                   (click)=\"onChangeSuppressionFilter()\">\n                            <label class=\"form-control-label\" for=\"dateSuppression\"><span></span></label>\n                            <label jhiTranslate=\"cadensApp.candidature.notdeleted\" for=\"dateSuppression\"\n                                   title=\"Cacher les candidatures supprimées\">deleted</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"fc\"\n                                   [(ngModel)]=\"filters.fc.value\" id=\"fc\"\n                                   [style.color]=\"getFilterColor(filters.fc.value)\"\n                                   (click)=\"onChangeFC($event)\">\n                            <label class=\"form-control-label\" for=\"fc\"><span></span></label>\n                            <label jhiTranslate=\"cadensApp.candidature.fcOnly\"\n                                   title=\"Ne voir que les formations continues\">fc</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"dateValidation\"\n                                   [(ngModel)]=\"filters.dateValidation.value\" id=\"dateValidation\"\n                                   [style.color]=\"getFilterColor(filters.dateValidation.value)\"\n                                   (click)=\"onChangeDateValidation($event)\">\n                            <label class=\"form-control-label\" for=\"dateValidation\"><span></span></label>\n                            <label jhiTranslate=\"cadensApp.candidature.filtreDateValidation\"\n                                   title=\"Ne voir que les candidatures transmises\">transmis</label>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-3 col-sm-6\">\n                        <p-multiSelect [options]=\"libelleList\" defaultLabel=\"Libellé candidature\"\n                                       [(ngModel)]=\"filters.libelle.value\"\n                                       [style.color]=\"getFilterColor(filters.libelle.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-6\">\n                        <p-multiSelect [options]=\"mentionList\" defaultLabel=\"Mention Master\"\n                                       [(ngModel)]=\"filters.mentionId.value\"\n                                       [style.color]=\"getFilterColor(filters.mentionId.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-6\">\n                        <p-multiSelect [options]=\"parcoursList\" defaultLabel=\"Parcours Master\"\n                                       [(ngModel)]=\"filters.parcoursId.value\"\n                                       [style.color]=\"getFilterColor(filters.parcoursId.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div *ngIf=\"this.reinscription\" class=\"col-md-2 col-sm-6\">\n                        <p-multiSelect [options]=\"statutEnscolList\"\n                                       defaultLabel=\"Statut ENSCOL\" [(ngModel)]=\"filters.statutEnscol.value\"\n                                       [style.color]=\"getFilterColor(filters.statutEnscol.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-6\">\n                        <p-multiSelect *ngIf=\"!this.reinscription\" [options]=\"disciplineList\"\n                                       defaultLabel=\"Discipline Diplôme\" [(ngModel)]=\"filters.disciplineId.value\"\n                                       [style.color]=\"getFilterColor(filters.disciplineId.value)\"\n                                       (onChange)=\"applyFilters()\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                    <div class=\"col-md-2 col-sm-6\">\n                        <p-multiSelect [options]=\"typeEIList\" defaultLabel=\"Type échange international\"\n                                       [(ngModel)]=\"filters.ei.value\"\n                                       (onChange)=\"applyFilters()\"\n                                       [style.color]=\"getFilterColor(filters.ei.value)\"\n                                       styleClass=\"ui-column-filter\"></p-multiSelect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <br/>\n        <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n        <jhi-alert></jhi-alert>\n\n        <div class=\"table-responsive\">\n            <p-dataTable #table [value]=\"candidatures\" [rows]=\"rowPerPage\" [paginator]=\"true\"\n                         tableStyleClass=\"table-striped table-bordered\"\n                         [globalFilter]=\"searchFilter\"\n                         [(selection)]=\"selectedCandidatures\"\n                         [rowsPerPageOptions]=\"[20,50,100,500]\"\n                         sortField=\"candidat\" [sortOrder]=\"1\">\n                <p-header class=\"row justify-content-around\">\n                    <div class=\"cold-sm-1 d-flex align-items-center\">\n                        <label class=\"\" jhiTranslate=\"cadensApp.candidature.total\"\n                               translateValues=\"{param: '{{table.totalRecords}}'}\"></label>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <p-multiSelect [options]=\"actions\" [(ngModel)]=\"selectedAction\"\n                                       (onChange)=\"onSelectedAction($event)\"\n                                       defaultLabel=\"Actions groupées\"></p-multiSelect>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <div class=\"input-group\">\n                            <input #searchFilter type=\"text\" class=\"form-control\"\n                                   [style.color]=\"getFilterColor(searchFilter)\"\n                                   placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\"\n                                   [(ngModel)]=\"searchText\">\n                            <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span\n                                class=\"fa fa-search\"></span></span>\n                        </div>\n                    </div>\n                    <div class=\"cold-sm-1\">\n                        <button type=\"button\" (click)=\"exportCSV(false)\" class=\"btn float-right btn-secondary\">\n                            <span class=\"fa fa-file-o text-primary\"></span><span\n                            jhiTranslate=\"entity.action.export\"></span>\n                        </button>\n                    </div>\n                    <div class=\"cold-sm-1\">\n                        <button type=\"button\" (click)=\"exportCSV(true)\" class=\"btn float-right btn-secondary\">\n                            <span class=\"fa fa-file-o text-primary\"></span><span\n                            jhiTranslate=\"entity.action.exportComplet\"></span>\n                        </button>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <p-multiSelect id=\"columnSelection\" [options]=\"cols\" [(ngModel)]=\"selectedColumns\"\n                                       (onChange)=\"onSelectedColumnsChange($event)\"></p-multiSelect>\n                    </div>\n                </p-header>\n                <p-column [style]=\"{'width':'65px'}\" selectionMode=\"multiple\"></p-column>\n\n                <p-column *ngIf=\"!isAdminOrGestionnaire\" [hidden]=\"selectedColumns.indexOf('id') < 0\"\n                          [style]=\"{'width':'75px'}\" field=\"id\" [header]=\"'global.field.id' | translate\"\n                          sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span><a title=\"{{'cadensApp.candidature.infoBulleCompleterDossier' | translate}}\"\n                             (click)=\"goToCandidature(candidature, true )\" tabindex=\"-1\">{{candidature.id}}</a></span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('oldCfId') < 0\" [style]=\"{'width':'80px'}\"\n                          field=\"oldCfId\" [header]=\"'global.field.oldCfId' | translate\" sortable=\"true\">\n                </p-column>\n\n                <p-column *ngIf=\"isAdminOrGestionnaire\" [hidden]=\"selectedColumns.indexOf('id') < 0\"\n                          [style]=\"{'width':'75px'}\" field=\"id\" [header]=\"'global.field.id' | translate\"\n                          sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span><a title=\"{{'cadensApp.candidature.infoBulleCompleterDossier' | translate}}\"\n                             (click)=\"goToCandidature(candidature, true )\" tabindex=\"-1\">{{candidature.id}}</a></span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('libelle') < 0\" field=\"libelle\"\n                          [header]=\"'cadensApp.candidature.libelle' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span class=\"ui-cell-data\">\n                        <a id=\"{{candidature.id}}\"\n                           title=\"{{'cadensApp.candidature.infoBulletraiterDossier' | translate}}\"\n                           (click)=\"goToCandidature(candidature, false)\" tabindex=\"-1\">{{candidature.libelle==null?candidature.id:candidature.libelle}}</a>\n                    </span>\n                    </template>\n                </p-column>\n\n                <!--\n                            <p-column  [filter]=\"true\"  filterMatchMode=\"in\" [hidden]=\"selectedColumns.indexOf('libelle') < 0\" field=\"libelle\" [header]=\"'cadensApp.candidature.libelle' | translate\" sortable=\"true\">\n                                <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                                    <span class=\"ui-cell-data\">\n                                        <a title=\"{{'cadensApp.candidature.infoBulletraiterDossier' | translate}}\" (click)=\"goToCandidature(candidature, false)\" tabindex=\"-1\">{{candidature.libelle==null?candidature.id:candidature.libelle}}</a>\n                                    </span>\n                                </template>\n                                <template pTemplate=\"filter\" let-col>\n                                    <p-multiSelect [options]=\"listeLibelle\"  appendTo=\"body\" defaultLabel=\"All\" (onChange)=\"dt.filter($event.value,col.field,col.filterMatchMode)\" styleClass=\"ui-column-filter\"></p-multiSelect>\n                                </template>\n                            </p-column>\n\n                -->\n                <p-column [hidden]=\"true\" field=\"mentionId\" header=\"mentionId\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"parcoursId\" header=\"parcoursId\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"niveauId\" header=\"niveauId\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"disciplineId\" header=\"disciplineId\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"commissionId\" header=\"commissionId\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"dateCreation\" header=\"dateCreation\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"dateDesistement\" header=\"dateDesistement\"></p-column>\n                <!-- Hidden column for filtering-->\n                <p-column [hidden]=\"true\" field=\"dateSuppression\" header=\"dateSuppression\"></p-column>\n                <!-- Hidden column for filtering-->\n\n                <p-column [hidden]=\"selectedColumns.indexOf('civilite') < 0\" field=\"civilite\"\n                          [header]=\"'cadensApp.candidature.civilite' | translate\" sortable=\"true\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('candidat') < 0\" field=\"candidat\"\n                          [header]=\"'cadensApp.candidature.nomPrenom' | translate\" sortable=\"true\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('nom') < 0\" field=\"nom\"\n                          [header]=\"'cadensApp.candidature.nom' | translate\" sortable=\"true\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('prenom') < 0\" field=\"prenom\"\n                          [header]=\"'cadensApp.candidature.prenom' | translate\" sortable=\"true\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('bourse') < 0\" field=\"bourse\"\n                          [header]=\"'cadensApp.candidature.bourse.title' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span class=\"row-statut statut-OK\" *ngIf=\"candidature.bourse === true\" jhiTranslate=\"global.form.yes\">Oui</span>\n                        <span class=\"row-statut statut-enErreur\" *ngIf=\"candidature.bourse === false\" jhiTranslate=\"global.form.no\">Non</span>\n                    </template>\n                    <!--<span th:text=\"${candidature.bourse} ? 'Oui' : 'Non'\"></span>-->\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('echelon') < 0\" field=\"echelon\"\n                          [header]=\"'cadensApp.candidature.bourse.echelon' | translate\" sortable=\"true\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('ordre') < 0\" field=\"ordre\"\n                          [header]=\"'cadensApp.candidature.ordre' | translate\" sortable=\"true\"\n                          [style]=\"{'width':'75px'}\"></p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('dateNaissance') < 0\" field=\"dateNaissance\"\n                          [header]=\"'cadensApp.candidature.naissance.date' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.dateNaissance | date: 'shortDate' }}</span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('statutEnscol') < 0\" field=\"statutEnscol\"\n                          [header]=\"'cadensApp.candidature.statutEnscol' | translate\" sortable=\"true\"></p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('inscriptionsEnscol') < 0\" field=\"inscriptionsEnscolString\"\n                          [header]=\"'cadensApp.candidature.inscriptionsEnscol' | translate\" sortable=\"true\">\n                    <template let-col let-appdt=\"rowData\" pTemplate=\"body\">\n                        <span style=\"white-space: pre-line\">{{(appdt[col.field])}}</span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('paysNationalite') < 0\" field=\"paysNationalite\"\n                          [header]=\"'cadensApp.candidature.nationalite' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.paysNationalite  }}</span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('typeNationalite') < 0\" field=\"typeNationalite\"\n                          [header]=\"'cadensApp.candidature.typeNationalite' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.typeNationalite  }}</span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('telephoneFixe') < 0\" field=\"telephoneFixe\"\n                          [header]=\"'cadensApp.candidature.adresse.telephone' | translate\"></p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('email') < 0\" field=\"email\"\n                          [header]=\"'cadensApp.candidature.email' | translate\"></p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('formationContinue') < 0\" field=\"fc\"\n                          [header]=\"'cadensApp.candidature.fc' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span class=\"ui-cell-data\" *ngIf=\"candidature.fc === true\"\n                          jhiTranslate=\"cadensApp.candidature.continue\"></span>\n                        <span class=\"ui-cell-data\" *ngIf=\"candidature.fc === false\"\n                              jhiTranslate=\"cadensApp.candidature.initiale\"></span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('categorieFormation') > -1\" field=\"categorieFormation\"\n                          [header]=\"'cadensApp.candidature.categorieFormation' | translate\" sortable=\"true\"></p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('commission') < 0\" field=\"commission\"\n                          [header]=\"'cadensApp.candidature.commission' | translate\" sortable=\"true\"></p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('dernierCursus') < 0\" field=\"dernierCursus\"\n                          [header]=\"'cadensApp.candidature.dernierCursus' | translate\" sortable=\"true\"></p-column>\n                <p-column *ngIf=\"selectedColumns.indexOf('niveauEtudes') > -1\"\n                          field=\"niveauAccessDiplomeLibelle\"\n                          [header]=\"'cadensApp.candidature.niveauEtudes' | translate\" sortable=\"true\">\n                </p-column>\n\n                <p-column\n                    *ngIf=\"reponsesQuestionLoaded == true  && selectedColumns.indexOf('questionsComplementaires') >-1\"\n                    [header]=\"'cadensApp.candidature.questionsComplementaires' | translate\" sortable=\"true\"\n                    [filter]=\"false\" filterMatchMode=\"contains\">\n                    <template let-col let-candidatureFormation=\"rowData\" pTemplate=\"body\">\n                        <div class=\"row\" *ngFor=\"let reponse of candidatureFormation.reponses\">\n                            <p>{{buildReponseLibelle(reponse)}}</p>\n                        </div>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('dateCreation') < 0\" field=\"dateCreation\"\n                          [header]=\"'cadensApp.candidature.dateCreation' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.dateCreation | date: 'short' }}</span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('dateConfirmation') < 0\" field=\"dateConfirmation\"\n                          [header]=\"'cadensApp.candidature.dateConfirmation' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.dateConfirmation | date: 'short' }}</span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('dateValidation') < 0\" field=\"dateValidation\"\n                          [header]=\"'cadensApp.candidature.dateValidation' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.dateValidation | date: 'short' }}</span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('dateDesistement') < 0\" field=\"dateDesistement\"\n                          [header]=\"'cadensApp.candidature.dateDesistement' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{ candidature?.dateDesistement | date: 'short' }}</span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('statut') < 0\" field=\"statut\"\n                          [style]=\"{'width':'210px','overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.statut' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span *ngIf=\"candidature.dateSuppression == null\" class=\"row-statut statut-{{candidature.statut}}\"\n                          jhiTranslate=\"cadensApp.candidature.status.{{candidature.statut}}\"></span>\n                        <span *ngIf=\"candidature.dateSuppression != null\" class=\"alert alert-danger row-statut\"\n                              jhiTranslate=\"cadensApp.candidature.status.DELETED_SHORT\"></span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('avis') < 0\" field=\"avis\"\n                          [style]=\"{'width':'210px','overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.avis.title' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span *ngIf=\"candidature.avis != null\" class=\"row-statut statut-{{candidature.avis}}\"\n                          jhiTranslate=\"cadensApp.candidature.avis.{{candidature.avis}}\"></span>\n                    <button  *ngIf=\"candidature.avis == null && (isAdminOrGestionnaire || isOnlyResponsableFormation)\"\n                             class=\"row-statut statut-saisirAvis\" jhiTranslate=\"cadensApp.candidature.avis.saisirAvis\"\n                             type=\"button\" (click)=\"saisirAvis(candidature)\"><i class=\"fa fa-save\"></i></button>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"selectedColumns.indexOf('avisRang') > -1\" field=\"avisRang\"\n                          [style]=\"{'width':'210px'}\"\n                          [header]=\"'cadensApp.candidature.avisRang' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span\n                        *ngIf=\"candidature.avis != null && candidature.avis === constants.AWAITING && candidature.statut === constants.FINISHED  \">\n                        <input type=\"number\" name=\"avisRang{{candidature.id}}\"\n                               [(ngModel)]=\"candidature.avisRang\" style=\"width: 100px;\">\n                        <!--<button type=\"button\" *ngIf=\"candidature.saved !== true && !isOnlyEnseignantDelegate\" class=\"btn btn-default\" (click)=\"saveRang(candidature)\">-->\n                        <button *ngIf=\"candidature.saved !== true && (isAdminOrGestionnaire || isOnlyResponsableFormation)\" class=\"btn btn-default\" (click)=\"saveRang(candidature)\">\n                            <i class=\"fa fa-save\"></i>\n                        </button>\n                    </span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('conforme') < 0\" field=\"conforme\"\n                          [style]=\"{'width':'210px','overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.conforme' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span *ngIf=\"candidature.conforme != null\" class=\"row-statut statut-{{candidature.conforme}}\"\n                          jhiTranslate=\"cadensApp.candidature.status.{{candidature.conforme}}\"></span>\n                    </template>\n                </p-column>\n\n                <p-column [hidden]=\"selectedColumns.indexOf('response') < 0\" field=\"response\"\n                          [style]=\"{'width':'210px','overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.response' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span *ngIf=\"candidature.response != null\" class=\"row-statut statut-{{candidature.response}}\"\n                          jhiTranslate=\"cadensApp.candidature.status.{{candidature.response}}\"></span>\n                        <br/>\n                        <br/>\n                            <!-- Gestion spécifique pour les ADMIS HORS ECHANGE avec bourse -->\n                        <div *ngIf=\"candidature.response === constants.SUCCESS\n                                    && candidature.ei === constants.HORS_ECHANGE\n                                    && candidature.indicBourseExcellence\">\n                            <span class=\"row-statut statut-{{ candidature.bourseExcellence ? 'OK' : 'REJECTED' }}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{ candidature.bourseExcellence ? 'SUCCES_WITH_BOURSE' : 'SUCCES_WITHOUT_BOURSE' }}\">\n                            </span>\n                        </div>\n\n\n                             </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('responseRang') > -1\" field=\"responseRang\"\n                          [style]=\"{'width':'210px'}\"\n                          [header]=\"'cadensApp.candidature.responseRang' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                    <span\n                        *ngIf=\"candidature.response != null && candidature.response === constants.AWAITING && candidature.statut === constants.FINISHED  \">\n                        <input type=\"number\" name=\"responseRang{{candidature.id}}\"\n                               [(ngModel)]=\"candidature.responseRang\" style=\"width: 100px;\">\n                        <button type=\"button\"\n                                *ngIf=\"candidature.saved !== true && !isOnlyEnseignantDelegate && !isOnlyResponsableFormation\"\n                                class=\"btn btn-default\" (click)=\"saveRang(candidature)\"><i\n                            class=\"fa fa-save\"></i></button>\n                    </span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('ei') < 0\" field=\"ei\"\n                          [style]=\"{'width':'210px','overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.ei' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span jhiTranslate=\"cadensApp.candidature.eiList.{{candidature.ei}}\"></span>\n                    </template>\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('bourseExcellence') < 0\" field=\"bourseExcellence\"\n                          [header]=\"'cadensApp.candidature.bourseExcellence.beneficiaire' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span class=\"row-statut statut-OK\" *ngIf=\"candidature.bourseExcellence === true && candidature.ei === 2\" jhiTranslate=\"global.form.yes\">Oui</span>\n                        <span class=\"row-statut statut-enErreur\" *ngIf=\"candidature.bourseExcellence === false && candidature.ei === 2\" jhiTranslate=\"global.form.no\">Non</span>\n                        <span *ngIf=\"candidature.bourseExcellence === false && candidature.ei !== 2\" jhiTranslate=\"cadensApp.candidature.eiList.0\">NC</span>\n                    </template>\n\n                </p-column>\n                <p-column [hidden]=\"selectedColumns.indexOf('indicBourseExcellence') < 0\" field=\"indicBourseExcellence\"\n                          [header]=\"'cadensApp.candidature.bourseExcellence.demande' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span class=\"row-statut statut-OK\" *ngIf=\"candidature.indicBourseExcellence === true && candidature.ei === 2\" jhiTranslate=\"global.form.yes\">Oui</span>\n                        <span class=\"row-statut statut-enErreur\" *ngIf=\"candidature.indicBourseExcellence === false && candidature.ei === 2\" jhiTranslate=\"global.form.no\">Non</span>\n                        <span *ngIf=\"candidature.bourseExcellence === false && candidature.ei !== 2\" jhiTranslate=\"cadensApp.candidature.eiList.0\">NC</span>\n                    </template>\n\n                </p-column>\n                <p-column\n                    *ngIf=\"disciplineMajeurLoaded == true  && selectedColumns.indexOf('reponseMajorDiscipline') >-1\"\n                          field=\"reponseMajorDiscipline\" [style]=\"{'overflow':'visible'}\"\n                          [header]=\"'cadensApp.candidature.reponseMajorDiscipline' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span>{{candidature.reponseMajorDiscipline}}</span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"selectedColumns.indexOf('universiteOrigine') > -1\"\n                          field=\"userEnEchange.nomUniversiteOrigine\"\n                          [header]=\"'cadensApp.candidature.universiteOrigine' | translate\" sortable=\"true\">\n                </p-column>\n                <p-column *ngIf=\"selectedColumns.indexOf('paysOrigine') > -1\"\n                          field=\"userEnEchange.paysUniversite\"\n                          [header]=\"'cadensApp.candidature.paysUniversite' | translate\" sortable=\"true\">\n                </p-column>\n                <p-column *ngIf=\"selectedColumns.indexOf('typeEchange') > -1\" field=\"userEnEchange.typeEchange\"\n                          [header]=\"'cadensApp.candidature.typeEchange' | translate\" sortable=\"true\">\n                </p-column>\n                <p-column *ngIf=\"selectedColumns.indexOf('controleIdentiteAdmis') > -1\" field=\"controleIdentiteAdmis\"\n                          [header]=\"'cadensApp.candidature.controleIdentiteAdmis' | translate\" sortable=\"true\">\n                    <template let-col let-candidature=\"rowData\" pTemplate=\"body\">\n                        <span class=\"row-statut statut-OK\" *ngIf=\"candidature.controleIdentiteAdmis === true\">OK</span>\n                        <span class=\"row-statut statut-enErreur\" *ngIf=\"candidature.controleIdentiteAdmis === false\">Dossier en erreur</span>\n                        <button *ngIf=\"isAdminOrGestionnaire\n                        && candidature.response === constants.SUCCESS\n                        && (candidature.statut === constants.FINISHED || candidature.statut === constants.CONFIRMED)\"\n                                     class=\"row-statut statut-saisirAvis\" jhiTranslate=\"cadensApp.candidature.controleIdentite.controler\"\n                                     type=\"button\" (click)=\"controlerIdentite(candidature)\"><i class=\"fa fa-save\"></i>\n                        </button>\n                    </template>\n                </p-column>\n            </p-dataTable>\n        </div>\n    </div>\n\n    <p-dialog [header]=\"'cadensApp.candidature.responsePopup.add' | translate\" [(visible)]=\"responseDialog\"\n              [responsive]=\"true\"\n              [modal]=\"true\">\n        <div class=\"ui-grid ui-grid-responsive ui-fluid\" *ngIf=\"selectedCandidatures\">\n            <div class=\"row\">\n                <div class=\"form-group col-sm-12\">\n                    <label for=\"resultatSelected\"\n                           jhiTranslate=\"cadensApp.candidature.responsePopup.resultat\">resultat</label>\n                    <select class=\"form-control\" jhiInputRequired required id=\"resultatSelected\"\n                            [(ngModel)]=\"resultatSelected\" name=\"resultatSelected\">\n                        <option *ngFor=\"let resp of responseList\" [value]=\"resp.value\">{{ resp.label }}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        <p-footer>\n            <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelResponse()\"><span\n                    jhiTranslate=\"entity.action.cancel\"></span></button>\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveResponse()\"><span\n                    jhiTranslate=\"entity.action.save\"></span></button>\n            </div>\n        </p-footer>\n    </p-dialog>\n\n    <p-dialog [header]=\"'cadensApp.candidature.avisPopup.add' | translate\" [(visible)]=\"avisDialog\"\n              [responsive]=\"true\"\n              [modal]=\"true\">\n        <div class=\"ui-grid ui-grid-responsive ui-fluid\" *ngIf=\"selectedCandidatures\">\n            <div class=\"row\">\n                <div class=\"form-group col-sm-12\">\n                    <label for=\"avisSelected\"\n                           jhiTranslate=\"cadensApp.candidature.avisPopup.avis\">avis</label>\n                    <select class=\"form-control\" jhiInputRequired required id=\"avisSelected\"\n                            [(ngModel)]=\"avisSelected\" name=\"avisSelected\">\n                        <option *ngFor=\"let avis of avisList\" [value]=\"avis.value\">{{ avis.label }}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\" *ngIf=\"avisSelected!=null && avisSelected==constants.NOTFAVORABLE\">\n                    <label><span jhiTranslate=\"cadensApp.candidature.avis.commentaire\">Sélectionner</span></label>\n                    <select class=\"form-control\" id=\"commentaire\" jhiInputRequired required\n                            [(ngModel)]=\"avisCommentaire\" name=\"commentaire\" [disabled]=\"avisEnabled < 2\">\n                        <option [ngValue]=\"commOption.value\"\n                                *ngFor=\"let commOption of listeCommentaires\">{{ commOption.label }}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\" *ngIf=\"avisSelected!=null && avisSelected==constants.AWAITING\">\n                    <label for=\"avisRang\"><span jhiTranslate=\"cadensApp.candidature.rang\">rang</span></label>\n                    <input type=\"number\" class=\"form-control\" [(ngModel)]=\"avisRang\" name=\"avisRang\" id=\"avisRang\">\n                </div>\n            </div>\n        </div>\n        <p-footer>\n            <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelAvis()\"><span\n                    jhiTranslate=\"entity.action.cancel\"></span></button>\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveAvis()\"\n                        [disabled]=\"avisSelected==null || (avisSelected==constants.AWAITING && avisRang==null) || (avisSelected==constants.NOTFAVORABLE && avisCommentaire==null)\"><span\n                    jhiTranslate=\"entity.action.save\"></span></button>\n            </div>\n        </p-footer>\n    </p-dialog>\n\n\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cdactionGroupee key=\"actionGroupee\">\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cdactionGroupee.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.save' | translate\"\n                    (click)=\"cdactionGroupee.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n    <p-confirmDialog width=\"1500\" icon=\"fa fa-trash\" #verif key=\"verifConfirmDialog\">\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"verif.reject()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n\n    <p-dialog [(visible)]=\"displayVerifyingDialog\" styleClass=\"large\"\n              [header]=\"'cadensApp.candidature.verification.candidatureDialogVerifTitle' | translate\"\n              [responsive]=\"true\"\n              [modal]=\"true\" [closable]=\"false\">\n\n        <p jhiTranslate=\"cadensApp.candidature.verification.candidatureValideCount\"\n           translateValues=\"{count: '{{this.valideCandidatureCount}}'}\">nombre de candidatures valides</p>\n        <p jhiTranslate=\"cadensApp.candidature.verification.candidatureInvalideCount\"\n           translateValues=\"{count: '{{this.invalideCandidatureList.length}}'}\">Are you sure you want to delete this\n            Formation?</p>\n         \n        <div style=\"height:350px; overflow:scroll\">\n            <p-dataTable #tableVerif\n                         [value]=\"invalideCandidatureList\"\n                         tableStyleClass=\"table-striped table-bordered\">\n                <p-column [style]=\"{'width':'300px'}\"\n                          field=\"entityId\"\n                          [header]=\"'cadensApp.candidature.verification.candidatureTitleColumnEntityId' | translate\">\n                    <template let-col let-invalideVerification=\"rowData\" pTemplate=\"body\">\n                        <span><a target=\"_blank\" [routerLink]=\"getCandidatureLink(invalideVerification.entityId)\">{{invalideVerification.entityId}}</a></span>\n                    </template>\n                </p-column>\n                <p-column field=\"translatedMessage\"\n                          [header]=\"'cadensApp.candidature.verification.candidatureTitleColumnErreur' | translate\"></p-column>\n            </p-dataTable>\n        </div>\n        <p-footer>\n            <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelDialogInvalideCandidature()\"><span\n                    jhiTranslate=\"entity.action.cancel\"></span></button>\n            </div>\n        </p-footer>\n    </p-dialog>\n</div>\n"

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<div id=\"component-civilite\">\n    <h1 jhiTranslate=\"global.menu.candidature.admin\">Données administratives</h1>\n    <h2 jhiTranslate=\"cadensApp.candidature.civility.title\">Civilite</h2>\n\n    <jhi-alert></jhi-alert>\n\n    <h3 jhiTranslate=\"cadensApp.candidature.civility.personal\">Infos personnelles</h3>\n\n    <div class=\"row\">\n        <div class=\"form-inline col-md-6\">\n            <label class=\"col-sm-2 control-label\" jhiTranslate=\"cadensApp.candidature.civilite\">Civility</label>\n            <div class=\"form-check form-check-inline\">\n                <p-radioButton name=\"civilite\" id=\"female\" value=\"MME\" [(ngModel)]=\"candidature.civilite\" #civility=\"ngModel\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n\n                <label jhiTranslate=\"cadensApp.candidature.female\">Female</label>\n            </div>\n            <div class=\"form-check form-check-inline\">\n                <p-radioButton name=\"civilite\" id=\"male\" value=\"M.\" [(ngModel)]=\"candidature.civilite\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"cadensApp.candidature.male\">Male</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" *ngIf=\"civility.invalid\">\n        <small class=\"form-text text-danger\" *ngIf=\"civility.errors.required\" jhiTranslate=\"cadensApp.candidature.messages.validate.civilite\">\n            Your civility is required.\n        </small>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-4\">\n            <label for=\"nom\"><span jhiTranslate=\"cadensApp.candidature.nom\">Nom</span></label>\n            <input type=\"text\" class=\"form-control\" id=\"nom\" jhiInputRequired required [(ngModel)]=\"candidature.nomPatronymique\" name=\"nomCadensSansCompletion\"\n                   placeholder=\"{{'cadensApp.candidature.nom' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"80\">\n        </div>\n        <div class=\"form-group col-md-4\">\n            <label for=\"nomUsuel\"><span jhiTranslate=\"cadensApp.candidature.nomUsuel\">nomUsuel</span></label>\n            <input type=\"text\" class=\"form-control\" id=\"nomUsuel\" [(ngModel)]=\"candidature.nomUsuel\" name=\"nomUsuelCadensSansCompletion\"\n                   placeholder=\"{{'cadensApp.candidature.nomUsuel' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"80\">\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-4\">\n            <label for=\"prenom\"><span jhiTranslate=\"cadensApp.candidature.prenom\">prenom</span></label>\n            <input type=\"text\" class=\"form-control\" id=\"prenom\" jhiInputRequired required [(ngModel)]=\"candidature.prenom\" name=\"prenomCadensSansCompletion\"\n                   placeholder=\"{{'cadensApp.candidature.prenom' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"40\">\n        </div>\n        <div class=\"form-group col-md-4\">\n            <label for=\"prenom2\"><span jhiTranslate=\"cadensApp.candidature.prenom2\">prenom2</span></label>\n            <input type=\"text\" class=\"form-control\" id=\"prenom2\" [(ngModel)]=\"candidature.prenom2\" name=\"prenom2CadensSansCompletion\"\n                   placeholder=\"{{'cadensApp.candidature.prenom2' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"40\">\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-4\">\n            <label><span jhiTranslate=\"cadensApp.candidature.naissance.date\">dateNaissance</span></label>\n            <p-calendar [(ngModel)]=\"candidature.dateNaissance\" id=\"dateNaissance\" name=\"dateNaissanceCadensSansCompletion\" jhiInputRequired required [disabled]=\"!isEditable\"\n                        [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                        yearRange=\"1960:2107\" [monthNavigator]=\"true\"></p-calendar>\n        </div>\n    </div>\n\n\n    <div *ngIf=\"!candidatureFormation.reinscription\"> <!--  AFFICHAGE POUR LES PRIMO ACCEDANTS !! -->\n        <jhi-adresse-component [(pays)]=\"candidature.paysNaissance\" [paysListe]=\"paysListe\"\n                           [(dept)]=\"candidature.deptNaissance\" [deptListe]=\"deptListe\"\n                           [(ville)]=\"candidature.villeNaissance\" [cols]=\"4\" [isEditable]=\"isEditable\"\n                           [translationKey]=\"'cadensApp.candidature.naissance'\"></jhi-adresse-component>\n\n\n        <div class=\"row\">\n            <div class=\"form-group col-md-4\">\n                <label for=\"paysNationalite\"><span jhiTranslate=\"cadensApp.candidature.paysNationalite\">paysNationalite</span></label>\n                <select class=\"form-control\" id=\"paysNationalite\" jhiInputRequired required [(ngModel)]=\"candidature.paysNationalite\" name=\"paysNationaliteCadensSansCompletion\" [disabled]=\"!isEditable\">\n                    <option></option>\n                    <option [ngValue]=\"paysOption.code\" *ngFor=\"let paysOption of paysListe\">{{paysOption.nationalite}}</option>\n                </select>\n            </div>\n            <div class=\"form-group col-md-4\">\n                <label for=\"paysNationalite2\"><span jhiTranslate=\"cadensApp.candidature.paysNationalite2\">paysNationalite2</span></label>\n                <select class=\"form-control\" id=\"paysNationalite2\" [(ngModel)]=\"candidature.paysNationalite2\" name=\"paysNationalite2CadensSansCompletion\" [disabled]=\"!isEditable\">\n                    <option [ngValue]=\"null\"></option>\n                    <option [ngValue]=\"paysOption.code\" *ngFor=\"let paysOption of paysListe\">{{paysOption.nationalite}}</option>\n                </select>\n            </div>\n        </div>\n\n        <h3 jhiTranslate=\"cadensApp.candidature.civility.contact\">Contact</h3>\n\n        <div class=\"row\">\n            <div class=\"form-group col-md-4\">\n                <label for=\"adresseContact\"><span\n                    jhiTranslate=\"cadensApp.candidature.adresse.adresse\">adresse</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"adresseContact\" jhiInputRequired required\n                       [(ngModel)]=\"adresse.adresse\" name=\"adresseCadensSansCompletion\"\n                       placeholder=\"{{'cadensApp.candidature.adresse.adresse' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"100\">\n            </div>\n            <div class=\"form-group col-md-6\">\n                <label for=\"adresse2Contact\"><span jhiTranslate=\"cadensApp.candidature.adresse.adresse2\">adresse2</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"adresse2Contact\" [(ngModel)]=\"adresse.adresse2\"\n                       name=\"adresse2CadensSansCompletion\" maxlength=\"300\"\n                       placeholder=\"{{'cadensApp.candidature.adresse.adresse2' | translate}}\" [disabled]=\"!isEditable\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-4\">\n                <label for=\"codePostalContact\"><span\n                    jhiTranslate=\"cadensApp.candidature.adresse.codePostal\">codePostal</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"codePostalContact\" jhiInputRequired required\n                       [(ngModel)]=\"adresse.codePostal\" name=\"codePostalCadensSansCompletion\" maxlength=\"10\"\n                       placeholder=\"{{'cadensApp.candidature.adresse.codePostal' | translate}}\" (blur)=\"onChangeCodePostal()\" autocomplete=\"off\" [disabled]=\"!isEditable\">\n            </div>\n            <div class=\"form-group col-md-4\">\n                <label for=\"villeContact\"><span jhiTranslate=\"cadensApp.candidature.adresse.ville\">ville</span></label>\n                <input type=\"text\" list=\"villesAdresse\" class=\"form-control\" jhiInputRequired required id=\"villeContact\"\n                       [(ngModel)]=\"adresse.ville\" name=\"villeCadensSansCompletion\"\n                       placeholder=\"{{'cadensApp.candidature.adresse.ville' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"60\">\n                <datalist id=\"villesAdresse\">\n                    <option [ngValue]=\"villeOption.libelleEdition\" *ngFor=\"let villeOption of villesAdresse\">{{villeOption.libelleEdition}}</option>\n                </datalist>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-4\">\n                <label for=\"pays\"><span jhiTranslate=\"cadensApp.candidature.adresse.pays\">pays</span></label>\n                <select class=\"form-control\" id=\"pays\" jhiInputRequired required [(ngModel)]=\"adresse.pays\"\n                        name=\"paysContactCadensSansCompletion\" [disabled]=\"!isEditable\">\n                    <option></option>\n                    <option [ngValue]=\"paysOption.code\" *ngFor=\"let paysOption of paysListe\">{{paysOption.edition}}</option>\n                </select>\n            </div>\n            <div class=\"form-group col-md-4\">\n                <label for=\"telephone\"><span jhiTranslate=\"cadensApp.candidature.adresse.telephone\">telephone</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"telephone\" [(ngModel)]=\"candidature.telephoneFixe\"\n                       name=\"telephoneContactCadensSansCompletion\" maxlength=\"14\"\n                       placeholder=\"{{'cadensApp.candidature.adresse.telephone' | translate}}\" required jhiInputRequired [disabled]=\"!isEditable\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-6\">\n            <label for=\"email\"><span jhiTranslate=\"cadensApp.candidature.email\">email</span></label>\n            <input type=\"text\" class=\"form-control\" id=\"email\" jhiInputRequired required disabled [(ngModel)]=\"candidatureFormation.email\" name=\"emailCadensSansCompletion\"\n                   placeholder=\"{{'cadensApp.candidature.email' | translate}}\" [disabled]=\"!isEditable\">\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "\n<h1 jhiTranslate=\"cadensApp.candidature.confirmation.title\">Confirmation</h1>\n\n<div class=\"row\" jhiTranslate=\"cadensApp.candidature.confirmation.felicitations\"></div>\n<br>\n<div class=\"row\" jhiTranslate=\"cadensApp.candidature.confirmation.finished\"></div>\n<div class=\"bloc-informations\">\n    <div class=\"row\" *ngIf=\"candidatureFormation?.categorieFormation\">\n        <span jhiTranslate=\"cadensApp.candidature.formation.{{candidatureFormation?.categorieFormation}}\" ></span>\n    </div>\n    <div class=\"row\" *ngIf=\"candidatureFormation?.mentionId\">\n        <span jhiTranslate=\"cadensApp.candidature.confirmation.mention\" translateValues=\"{param: '{{escapeParam(mention)}}'}\"></span>\n    </div>\n    <div class=\"row\" *ngIf=\"candidatureFormation?.disciplineId\">\n        <span jhiTranslate=\"cadensApp.candidature.confirmation.discipline\" translateValues=\"{param: '{{escapeParam(discipline)}}'}\"></span>\n    </div>\n    <div class=\"row\" *ngIf=\"candidatureFormation?.parcoursId\">\n        <span jhiTranslate=\"cadensApp.candidature.confirmation.parcours\" translateValues=\"{param: '{{escapeParam(parcours)}}'}\"></span>\n    </div>\n    <div class=\"row\" *ngIf=\"candidatureFormation?.niveauId\">\n        <span jhiTranslate=\"cadensApp.candidature.confirmation.niveau\" translateValues=\"{param: '{{escapeParam(niveau)}}'}\"></span>\n    </div>\n</div>\n<br>\n<br>\n<div class=\"row\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.CONFIRMATION_CANDIDATURE?.libelle : parametrage?.CONFIRMATION_CANDIDATURE?.libelleEn\"></div>\n<br>\n"

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "\n<jhi-information-component [information]=\"currentLang === 'fr' ? parametrage?.CPES_INFORMATIONS.libelle : parametrage?.CPES_INFORMATIONS.libelleEn\"></jhi-information-component>\n\n<jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n<div class=\"row\">\n    <div class=\"form-group col-md-12\">\n        <label class=\"control-label\" jhiTranslate=\"cadensApp.formation.master.type\">candidature en:</label>\n    </div>\n</div>\n\n<!-- Liste de choix des formations disponibles dans la campagne -->\n<div class=\"row\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"mention\"><span jhiTranslate=\"cadensApp.formation.mention\">mention</span></label>\n        <select class=\"form-control\" id=\"mention\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.mentionId\" name=\"mention\" (ngModelChange)=\"onChangeMention($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"mentionOption.idComposant\" *ngFor=\"let mentionOption of mentionsListe\">{{ mentionOption.llComposant }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"parcours\"><span jhiTranslate=\"cadensApp.formation.parcours\">parcours</span></label>\n        <select class=\"form-control\" id=\"parcours\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.parcoursId\" name=\"parcours\" (ngModelChange)=\"onChangeParcours($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"parcoursOption.idComposant\" *ngFor=\"let parcoursOption of parcoursListe\">{{ parcoursOption.llComposant }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"niveau\"><span jhiTranslate=\"cadensApp.formation.niveau\">niveau</span></label>\n        <select class=\"form-control\" id=\"niveau\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.niveauId\" name=\"niveau\" (ngModelChange)=\"findFormation($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"niveauOption.idComposant\" *ngFor=\"let niveauOption of niveauxListe\">\n                <span *ngIf=\"!this.isGradeLicence\" jhiTranslate=\"cadensApp.formation.master.niveau\" translateValues=\"{niveau: '{{ niveauOption.periode }}'}\"></span>\n                <span *ngIf=\"this.isGradeLicence\" jhiTranslate=\"cadensApp.formation.master.niveaulicence\" translateValues=\"{niveau: '{{ niveauOption.periode }}'}\"></span>\n            </option>\n        </select>\n    </div>\n</div>\n\n<jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\" [questions]=\"questions\"\n                       [currentLang]=\"currentLang\" [isEditable]=\"isEditable\"></jhi-reponse-component>\n"

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<div *ngFor=\"let formation of autresListe\">\n\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <p-radioButton name=\"formation\" id=\"formation{{formation.id}}\" [value]=\"formation.id\" [(ngModel)]=\"candidatureFormation.formationId\"\n                           (ngModelChange)=\"changeFormation($event, formation.libelle)\" jhiInputRequired required [disabled]=\"!isEditable\"\n             ></p-radioButton>\n            <label class=\"form-control-label font-weight-bold\" for=\"formation{{formation.id}}\">{{ formation.libelle }}</label>\n            <br/>\n            <div *ngIf=\"formation.id != constantes.DOUBLE_CURSUS_ID && candidatureFormation?.formationId!=constantes.DOUBLE_CURSUS_ID\n                    && formation.id != constantes.DOUBLE_CURSUS_HUMANITES_ID && candidatureFormation?.formationId != constantes.DOUBLE_CURSUS_HUMANITES_ID\">\n                <label class=\"form-control-label\" for=\"formation{{formation.id}}\">{{ libelle && libelle[formation.libelleCourt] }}</label>\n                <jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\" [(questions)]=\"questions\" [(currentLang)]=\"currentLang\" [isEditable]=\"isEditable\"></jhi-reponse-component>\n            </div>\n            <!--Double Cursus Médecine-->\n             <div *ngIf=\"formation.id==constantes.DOUBLE_CURSUS_ID && candidatureFormation?.formationId==constantes.DOUBLE_CURSUS_ID\" >\n                <div *ngIf=\"isLoading\">\n                        <label class=\"alert alert-warning font-medium\" for=\"formation{{formation.id}}\"\n                        [innerHTML]=\"currentLang === 'fr' ? parametrage?.ALERT_DOUBLECURSUS.libelle : parametrage?.ALERT_DOUBLECURSUS.libelleEn\"></label>\n                </div>\n                 <div *ngIf=\"!isLoading\">\n                     <div [innerHTML]=\"(currentLang === 'fr' ? ('cadensApp.formation.alertDoubleCursusMedecine' | translate) : ('cadensApp.formation.alertDoubleCursusMedecine' | translate)) | SafeHtml\"></div>\n                 </div>\n                 <jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\" [(questions)]=\"questions\" [(currentLang)]=\"currentLang\" [isEditable]=\"isEditable\"></jhi-reponse-component>\n             </div>\n            <!--Double cursus médecine humanité-->\n            <div *ngIf=\"formation.id == constantes.DOUBLE_CURSUS_HUMANITES_ID && candidatureFormation?.formationId == constantes.DOUBLE_CURSUS_HUMANITES_ID\">\n                <jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\" [(questions)]=\"questions\" [(currentLang)]=\"currentLang\" [isEditable]=\"isEditable\"></jhi-reponse-component>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<jhi-information-component [information]=\"currentLang === 'fr' ? parametrage?.DIPLOME_INFORMATIONS.libelle : parametrage?.DIPLOME_INFORMATIONS.libelleEn\"></jhi-information-component>\n\n<jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n<div class=\"row\">\n    <div class=\"form-group col-md-12\">\n        <label class=\"control-label\" jhiTranslate=\"cadensApp.formation.diplome.ects.selection\">Vous avez au moins:</label>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"form-group col-md-6\">\n        <p-radioButton name=\"ects\" id=\"ects120\" [value]=\"120\" (ngModelChange)=\"onChangeEcts($event)\"\n                       [(ngModel)]=\"candidatureFormation.ects\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n\n        <label class=\"form-control-label\" for=\"ects120\" jhiTranslate=\"cadensApp.formation.diplome.ects.120\">120</label>\n        <span (click)=\"openAide(aideModal, parametrage?.ECTS120_MORE)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n        <label class=\"form-control-label\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS120.libelle : parametrage?.ECTS120.libelleEn\"></label>\n    </div>\n    <div class=\"form-group col-md-6\">\n        <p-radioButton name=\"ects\" id=\"ects180\" [value]=\"180\" [(ngModel)]=\"candidatureFormation.ects\" (ngModelChange)=\"onChangeEcts($event)\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n\n        <label class=\"form-control-label\" for=\"ects180\" jhiTranslate=\"cadensApp.formation.diplome.ects.180\">180</label>\n        <span (click)=\"openAide(aideModal, parametrage?.ECTS180_MORE)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n        <label class=\"form-control-label\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS180.libelle : parametrage?.ECTS180.libelleEn\"></label>\n    </div>\n</div>\n\n<!-- ANNEE 1 -->\n<div *ngIf=\"candidatureFormation.ects === 180\">\n    <div class=\"row\">\n        <div class=\"form-group col-md-12\">\n            <label class=\"control-label\" jhiTranslate=\"cadensApp.formation.diplome.annee\">Selectionner l'annee:</label>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <p-radioButton name=\"annee\" id=\"annee1\" [value]=\"1\" [(ngModel)]=\"annee\" (ngModelChange)=\"onChangeAnnee($event)\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n\n            <label class=\"form-control-label font-weight-bold\" for=\"annee1\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS180_ANNEE1.libelle : parametrage?.ECTS180_ANNEE1.libelleEn\"></label>\n            <label class=\"form-control-label\" for=\"annee2\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS180_ANNEE1_MORE.libelle : parametrage?.ECTS180_ANNEE1_MORE.libelleEn\"></label>\n        </div>\n    </div>\n</div>\n\n<!-- SELECTION DE LA DISCIPLINE -->\n<div class=\"row\" *ngIf=\"candidatureFormation.ects === 120 || annee === 1\">\n    <div class=\"form-group col-md-4 col-lg-3\">\n        <label for=\"disciplineDiplome\"><span jhiTranslate=\"cadensApp.formation.discipline\">discipline</span></label>\n        <select class=\"form-control\" id=\"disciplineDiplome\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.disciplineId\" name=\"disciplineDiplome\"\n                (ngModelChange)=\"onChangeDiscipline($event)\" [disabled]=\"!isEditable\">\n            <option [ngValue]=\"discOption.idDiscipline\" *ngFor=\"let discOption of disciplinesListe\">{{ discOption.llDiscipline }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-8 col-lg-9\">\n        <label for=\"departement\"><span jhiTranslate=\"cadensApp.formation.departement\">departement</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"departement\" [(ngModel)]=\"departement\" name=\"departement\" disabled jhiInputRequired required>\n    </div>\n</div>\n\n<!-- ANNEE 2-->\n<div *ngIf=\"candidatureFormation.ects === 180\">\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <p-radioButton name=\"annee\" id=\"annee2\" [value]=\"2\" [(ngModel)]=\"annee\" (ngModelChange)=\"onChangeAnnee($event)\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n\n            <label class=\"form-control-label font-weight-bold\" for=\"annee2\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS180_ANNEE2.libelle : parametrage?.ECTS180_ANNEE2.libelleEn\"></label>\n            <label class=\"form-control-label\" for=\"annee2\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.ECTS180_ANNEE2_MORE.libelle : parametrage?.ECTS180_ANNEE2_MORE.libelleEn\"></label>\n        </div>\n    </div>\n</div>\n\n<!-- SELECTION DU DISCIPLINE + PARCOURS + NIVEAU EN ANNEE 2-->\n<div class=\"row\" *ngIf=\"annee === 2\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"disciplineDiplome2\"><span jhiTranslate=\"cadensApp.formation.discipline\">discipline</span></label>\n        <select class=\"form-control\" id=\"disciplineDiplome2\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.disciplineId\" name=\"disciplineDiplome\"\n                (ngModelChange)=\"onChangeDiscipline($event)\" [disabled]=\"!isEditable\">\n            <option [ngValue]=\"discOption.idDiscipline\" *ngFor=\"let discOption of disciplinesParcoursListe\">{{ discOption.llDiscipline }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"parcoursDiplome\"><span jhiTranslate=\"cadensApp.formation.parcours\">parcours</span></label>\n        <select class=\"form-control\" id=\"parcoursDiplome\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.parcoursId\" name=\"parcoursDiplome\"\n                (ngModelChange)=\"onChangeParcours($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"parcoursOption.idComposant\" *ngFor=\"let parcoursOption of parcoursListe\">{{ parcoursOption.llComposant }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\" *ngIf=\"annee === 2\">\n        <label for=\"niveauDiplome\"><span jhiTranslate=\"cadensApp.formation.niveau\">niveau</span></label>\n        <select class=\"form-control\" id=\"niveauDiplome\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.niveauId\" name=\"niveauDiplome\"\n                (ngModelChange)=\"findFormation($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"niveauOption.idComposant\" *ngFor=\"let niveauOption of niveauxListe\">{{ niveauOption.llComposant }}</option>\n        </select>\n    </div>\n</div>\n\n<jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\"\n                       [(questions)]=\"questions\" [isEditable]=\"isEditable\" [(currentLang)]=\"currentLang\"\n                       (btnActivation)=\"clickBoutonQuestion($event)\"></jhi-reponse-component>\n\n<template #aideModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.action.help\">Aide</h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p [innerHTML]=\"currentLang === 'fr' ? aide?.libelle : aide?.libelleEn\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\">Close</button>\n    </div>\n</template>\n"

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<h1 jhiTranslate=\"cadensApp.formation.choice\">Choix de la formation</h1>\n\n<jhi-alert-error></jhi-alert-error>\n<jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n\n<div class=\"row\">\n    <div class=\"form-group\">\n        <P class=\"alerts\" *ngIf=\"!desCategoriesFormationDisponibles\"\n           jhiTranslate=\"cadensApp.formation.aucuneFormationDisponible\">Pas de campagne ouverte</P>\n        <div *ngIf=\"desCategoriesFormationDisponibles\">\n            <label><span jhiTranslate=\"cadensApp.formation.type\">Type</span></label>\n            <div class=\"btn-toolbar\" role=\"toolbar\">\n                <div class=\"btn-group mr-2\" role=\"group\" *ngFor=\"let categorie of categoriesFormation\">\n                    <button [id]=\"categorie.code\" *ngIf=\"categorie.displayed === true \" type=\"button\"\n                            (click)=\"chooseFormation(constants[categorie.code])\" class=\"btn btn-secondary\"\n                            [disabled]=\"!isEditable || categorie.disabled\"\n                            [ngClass]=\"{'selected': candidatureFormation.categorieFormation === constants[categorie.code]}\">\n                    <span\n                        *ngIf=\"categorie.code !== 'DIPLOME' || candidatureFormation.ects !== 120 || codesMONO.indexOf(candidatureFormation.discipline) < 0\"\n                        [jhiTranslate]=\"'cadensApp.formation.' + categorie.code.toLowerCase() + '.title'\"></span>\n                        <span\n                            *ngIf=\"categorie.code === 'DIPLOME' && candidatureFormation.ects === 120 && codesMONO.indexOf(candidatureFormation.discipline) > -1\"\n                            [jhiTranslate]=\"'cadensApp.formation.' + categorie.code.toLowerCase() + '.titleL3'\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<hr>\n\n<div [ngSwitch]=\"candidatureFormation.categorieFormation\">\n    <div *ngSwitchCase=\"constants.MASTER\">\n        <div *ngIf=\"isCategorieDisplayed(constants.MASTER)\">\n            <jhi-master-component [(candidatureFormation)]=\"candidatureFormation\"\n                                  [(currentLang)]=\"currentLang\"\n                                  [questions]=\"questions\" [isEditable]=\"isEditable\"\n                                  [isBO]=\"isBO\"></jhi-master-component>\n        </div>\n    </div>\n    <div *ngSwitchCase=\"constants.DIPLOME\">\n        <div *ngIf=\"isCategorieDisplayed(constants.DIPLOME)\">\n            <jhi-diplome-component [(candidatureFormation)]=\"candidatureFormation\"\n                                   [(currentLang)]=\"currentLang\"\n                                   [(questions)]=\"questions\" [isEditable]=\"isEditable\" [isBO]=\"isBO\"\n                                   (btnActivation)=\"btnActivation($event)\"></jhi-diplome-component>\n        </div>\n    </div>\n    <div *ngSwitchCase=\"constants.CPES\">\n        <div *ngIf=\"isCategorieDisplayed(constants.CPES)\">\n            <jhi-cpes-component [(candidatureFormation)]=\"candidatureFormation\"\n                                   [(currentLang)]=\"currentLang\"\n                                   [(questions)]=\"questions\" [isEditable]=\"isEditable\"\n                                   [isBO]=\"isBO\"></jhi-cpes-component>\n        </div>\n    </div>\n    <div *ngSwitchCase=\"constants.INTERNATIONAL\">\n        <div *ngIf=\"isCategorieDisplayed(constants.INTERNATIONAL)\">\n            <jhi-international-component [(candidatureFormation)]=\"candidatureFormation\"\n                                         [(currentLang)]=\"currentLang\"\n                                         [(questions)]=\"questions\" [isEditable]=\"isEditable\"\n                                         [(questionsChange)]=\"questionsChange\"\n                                         [(userEnEchange)]=\"userEnEchange\"\n                                         [(listeCours)]=\"listeCours\"\n                                         [isBO]=\"isBO\"></jhi-international-component>\n        </div>\n    </div>\n    <div *ngSwitchCase=\"constants.AUTRES\">\n        <div *ngIf=\"isCategorieDisplayed(constants.AUTRES)\">\n            <jhi-autres-formations-component [(candidatureFormation)]=\"candidatureFormation\"\n                                             [(currentLang)]=\"currentLang\"\n                                             [(questions)]=\"questions\" [isEditable]=\"isEditable\" [isBO]=\"isBO\"\n            ></jhi-autres-formations-component>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<div class=\"subgroup-header\" jhiTranslate=\"cadensApp.coursDisponible.home.title\"\n     translateValues=\"{index: '{{index+1}}'}\">Cours XX</div>\n\n<div  class=\"row\" >\n    <div *ngIf=\"questionCoursCode\" class=\"col-md-2\">\n        <label class=\"header question-header\" for=\"selectedCours-{{index}}\"><span [innerHTML]=\"QuestionClass.getLibelleLangue(questionCoursCode, currentLang)\">Code du cours</span></label>\n        <span *ngIf=\"questionCoursCode?.aide != null\" (click)=\"openAide(questionModal, questionCoursCode)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n        <input type=\"text\" class=\"form-control\" id=\"selectedCours-{{index}}\" jhiInputRequired required\n               [(ngModel)]=\"cours.code\" name=\"selectedCours-{{index}}\"\n               [disabled]=\"!isEditable\" maxlength=\"80\" (ngModelChange)=\"onCoursChanged($event)\">\n    </div>\n    <div *ngIf=\"questionLibelleCours\" class=\"form-group  col-md-8\">\n        <label class=\"header question-header\" for=\"libelleCours-{{index}}\"><span [innerHTML]=\"QuestionClass.getLibelleLangue(questionLibelleCours, currentLang)\">Libelle du\n            cours</span></label>\n        <span *ngIf=\"questionLibelleCours?.aide != null\" (click)=\"openAide(questionModal, questionLibelleCours)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n       <input type=\"text\" class=\"form-control\" id=\"libelleCours-{{index}}\" jhiInputRequired required\n               [(ngModel)]=\"cours.libelle\" name=\"libelleCours-{{index}}\" [disabled]=\"true\" maxlength=\"255\">\n    </div>\n    <div *ngIf=\"questionEctsCours\" class=\"form-group  col-md-1\">\n        <label class=\"header question-header\" for=\"ects-{{index}}\"><span [innerHTML]=\"QuestionClass.getLibelleLangue(questionEctsCours, currentLang)\">Ects</span></label>\n        <span *ngIf=\"questionEctsCours?.aide != null\" (click)=\"openAide(questionModal, questionEctsCours)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n        <input type=\"text\" class=\"form-control\" id=\"ects-{{index}}\"  [(ngModel)]=\"cours.ects\"\n               name=\"ects-{{index}}\" [disabled]=\"true\">\n    </div>\n</div>\n\n<template #questionModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <div><h4 class=\"modal-title no_margin\" [innerHTML]=\"QuestionClass.getTitreModalAide(aide, currentLang)\"></h4></div>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p [innerHTML]=\"QuestionClass.getAide(aide, currentLang)\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\">Close</button>\n    </div>\n</template>\n\n"

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "<jhi-information-component\n    [information]=\"currentLang === 'fr' ? parametrage?.INTERNATIONAL_INFORMATIONS.libelle : parametrage?.INTERNATIONAL_INFORMATIONS.libelleEn\"></jhi-information-component>\n\n<!--<h2>{{ candidatureFormation | json }}</h2>-->\n\n\n<h2 jhiTranslate=\"cadensApp.formation.international.sejour\">sejour</h2>\n<div class=\"row\">\n    <div class=\"form-group col-md-3 col-log-4\">\n        <label class=\"header\" for=\"pays\"><span jhiTranslate=\"cadensApp.formation.international.pays\">pays</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"pays\"\n               value=\"{{currentLang === 'fr'?this.paysOrigine.pays:this.paysOrigine.paysEn}}\" name=\"pays\"\n               [disabled]=\"true\">\n    </div>\n    <div class=\"form-group col-md-3 col-log-4\">\n        <label class=\"header\" for=\"etab\"><span jhiTranslate=\"cadensApp.formation.international.etab\">etab</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"etab\" [(ngModel)]=\"userEnEchange.nomUniversiteOrigine\" name=\"etab\"\n               [disabled]=\"true\">\n    </div>\n    <div class=\"form-group col-md-3 col-log-4\">\n        <label class=\"header\" for=\"type\"><span jhiTranslate=\"cadensApp.formation.international.type\">type</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"type\" [(ngModel)]=\"userEnEchange.typeEchange\" name=\"type\"\n               [disabled]=\"true\">\n    </div>\n</div>\n\n<jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\"\n                       [(questions)]=\"questions\" [isEditable]=\"isEditable\" [(currentLang)]=\"currentLang\"\n                       (btnActivation)=\"clickBoutonQuestion($event)\"></jhi-reponse-component>\n\n<hr>\n<h3 jhiTranslate=\"cadensApp.formation.international.contrat\">Contrat d'études</h3>\n<div class=\"how\" jhiTranslate=\"cadensApp.formation.international.cours.aide\"></div>\n<div *ngFor=\"let cours of listeCours; let idx = index\" class=\"subgroup\">\n    <div class=\"subgroup-clear\" (click)=\"clearCours(idx)\" *ngIf=\"isEditable && listeCours.length>1\">\n        <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n    </div>\n\n    <jhi-cours-component [cours]=\"cours\" [index]=\"idx\" [isEditable]=\"isEditable\"\n                         [listeCoursDisponible]=\"listeCoursDisponible\" [(currentLang)]=\"currentLang\" [(questions)]=\"questions\"\n                         [(questionsChange)]=\"questionsChange\"\n                         (coursChange)=\"onCoursChanged(cours)\">\n    </jhi-cours-component>\n    <br>\n</div>\n\n<div>\n    <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addCours()\" *ngIf=\"isEditable\">\n        <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span class=\"space-left\"\n                                                                  jhiTranslate=\"cadensApp.formation.international.cours.add\">Ajouter</span>\n    </button>\n</div>\n<hr>\n"

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "\n<jhi-information-component [information]=\"currentLang === 'fr' ? parametrage?.MASTER_INFORMATIONS.libelle : parametrage?.MASTER_INFORMATIONS.libelleEn\"></jhi-information-component>\n\n<jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n<div class=\"row\">\n    <div class=\"form-group col-md-12\">\n        <label class=\"control-label\" jhiTranslate=\"cadensApp.formation.master.type\">candidature en:</label>\n    </div>\n</div>\n<div *ngIf=\"!candidatureFormation.reinscription && this.candidatureFormation.ei == constants.NON_CONCERNE\">\n    <div class=\"row form-group\">\n        <p-radioButton name=\"fc\" id=\"initiale\" [value]=\"false\" (ngModelChange)=\"selectionFormationContinue($event)\"\n                       [(ngModel)]=\"candidatureFormation.fc\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n        <label class=\"form-control-label\" for=\"initiale\" jhiTranslate=\"cadensApp.formation.master.initiale\">Formation initiale</label>\n    </div>\n    <div class=\"row form-group\">\n        <div class=\"bloc-informations\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.FI_INFORMATIONS.libelle : parametrage?.FI_INFORMATIONS.libelleEn\">\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <p-radioButton name=\"fc\" id=\"continue\" [value]=\"true\" (ngModelChange)=\"selectionFormationContinue($event)\"\n                       [(ngModel)]=\"candidatureFormation.fc\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n        <label class=\"form-control-label\" for=\"continue\" jhiTranslate=\"cadensApp.formation.master.continue\">Formation continue</label>\n    </div>\n    <div class=\"row form-group\">\n        <div class=\"bloc-informations\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.FC_INFORMATIONS.libelle : parametrage?.FC_INFORMATIONS.libelleEn\">\n        </div>\n    </div>\n</div>\n\n<div class=\"row\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"mention\"><span jhiTranslate=\"cadensApp.formation.mention\">mention</span></label>\n        <select class=\"form-control\" id=\"mention\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.mentionId\" name=\"mention\" (ngModelChange)=\"onChangeMention($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"mentionOption.idComposant\" *ngFor=\"let mentionOption of mentionsListe\">{{ mentionOption.llComposant }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"parcours\"><span jhiTranslate=\"cadensApp.formation.parcours\">parcours</span></label>\n        <select class=\"form-control\" id=\"parcours\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.parcoursId\" name=\"parcours\" (ngModelChange)=\"onChangeParcours($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"parcoursOption.idComposant\" *ngFor=\"let parcoursOption of parcoursListe\">{{ parcoursOption.llComposant }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"niveau\"><span jhiTranslate=\"cadensApp.formation.niveau\">niveau</span></label>\n        <select class=\"form-control\" id=\"niveau\" jhiInputRequired required [(ngModel)]=\"candidatureFormation.niveauId\" name=\"niveau\" (ngModelChange)=\"findFormation($event)\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"niveauOption.idComposant\" *ngFor=\"let niveauOption of niveauxListe\">\n                <span *ngIf=\"!this.isGradeLicence\" jhiTranslate=\"cadensApp.formation.master.niveau\" translateValues=\"{niveau: '{{ niveauOption.periode }}'}\"></span>\n                <span *ngIf=\"this.isGradeLicence\" jhiTranslate=\"cadensApp.formation.master.niveaulicence\" translateValues=\"{niveau: '{{ niveauOption.periode }}'}\"></span>\n            </option>\n        </select>\n    </div>\n</div>\n<br/>\n<jhi-reponse-component *ngIf=\"candidatureFormation.formationId !== null\" [questions]=\"questions\"\n                       [currentLang]=\"currentLang\" [isEditable]=\"isEditable\"></jhi-reponse-component>\n<br/>\n<div *ngIf=\"!candidatureFormation.reinscription && this.candidatureFormation.ei == constants.HORS_ECHANGE\" class=\"form-group col-md-12\">\n\n    <h3 jhiTranslate=\"cadensApp.formation.master.titleBourseExcellence\">Bourse d'excellence</h3>\n    <br/>\n    <div *ngIf=\"isEligibleBourse\">\n        <div class=\"form-group col-md-10\">\n\n            <span jhiTranslate=\"cadensApp.formation.master.postulatBourse\">Postulez-vous</span>\n            <br/>\n            <span >\n                    {{ 'cadensApp.formation.master.dateLimiteBourse' | translate: { dateLimite: (ageLimiteBourse | date:'dd/MM/yyyy') } }}\n            </span>\n            <div *ngIf=\"isEligibleBourse\" class=\"alert alert-warning\">\n                <span >\n                    {{ 'cadensApp.formation.master.eligibleBourse' | translate: { dateLimite: (ageLimiteBourse | date:'dd/MM/yyyy') } }}\n                </span>\n\n            </div>\n\n             <div class=\"row\">\n                 <div class=\"form-check col-sm-8\">\n                         <p-radioButton id=\"bourseExcellenceYes\" class=\"form-check-input\" name=\"indicBourseExcellence\" [value]=\"true\"\n                                        [(ngModel)]=\"candidatureFormation.indicBourseExcellence\"\n                                        jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                         <label jhiTranslate=\"global.form.yes\">oui</label>\n                 </div>\n                 <div class=\"form-check col-sm-8\">\n                     <p-radioButton id=\"bourseExcellenceNo\" class=\"form-check-input\" name=\"indicBourseExcellence\" [value]=\"false\"\n                                    [(ngModel)]=\"candidatureFormation.indicBourseExcellence\"\n                                    (ngModelChange)=\"onChangeBourseIndicExcellence()\"\n                                    jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                     <label jhiTranslate=\"global.form.no\">non</label>\n                 </div>\n             </div>\n         </div>\n    </div>\n    <div *ngIf=\"!isEligibleBourse\" class=\"alert alert-warning\">\n        <span >\n                    {{ 'cadensApp.formation.master.notEligibleBourse' | translate: { dateLimite: (ageLimiteBourse | date:'dd/MM/yyyy') } }}\n                </span>\n\n    </div>\n </div>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "<h1 jhiTranslate=\"cadensApp.candidature.files.title\">Pièces jointes</h1>\n\n<jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n<jhi-information-component\n    [information]=\"currentLang === 'fr' ? parametrage?.PIECES_INFOS?.libelle : parametrage?.PIECES_INFOS?.libelleEn\"></jhi-information-component>\n\n<!-- Loop over all the pièces jointes required and optional -->\n<div class=\"row\" *ngFor=\"let piece of pieces\">\n    <div class=\"form-group\">\n        <label class=\"header\">{{ currentLang === 'fr' || piece.libelleEn == null ? piece.libelle : piece.libelleEn\n            }}</label>\n        <span *ngIf=\"piece.aide != null\" (click)=\"openAide(pieceModal, piece)\" class=\"fa fa-question-circle-o\"\n              title=\"Cliquer\"></span>\n        <label class=\"subLabel\" *ngIf=\"piece.descriptif != null\"\n               [innerHTML]=\"currentLang === 'fr' || piece.descriptifEn == null ? piece.descriptif : piece.descriptifEn\"></label>\n        <p-fileUpload [name]=\"uploadedFiles.Item(getPieceIndex(piece.id, null))?.nom\" url=\"./api/upload\" accept=\"application/pdf\" auto=\"auto\"\n                      id=\"{{piece.id}}\"\n                      (onUpload)=\"onFileUploaded($event, piece.id)\" [disabled]=\"!isEditable\" withCredentials=\"true\"\n                      (onBeforeSend)=\"onBeforeSend($event)\" (onBeforeUpload)=\"onBeforeUpload($event, piece.id)\"\n                      [maxFileSize]=\"maxSize\" required invalidFileTypeMessageDetail=\"invalid pdf type\"\n                      (onError)=\"onError($event)\"\n                      chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                      uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                      cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n            <template pTemplate=\"content\" type=\"content\">\n                <a *ngIf=\"uploadedFiles.Item(getPieceIndex(piece.id, null)) != null\" (click)=\"openFile(uploadedFiles.Item(getPieceIndex(piece.id, null)).nom)\">{{\n                    uploadedFiles.Item(getPieceIndex(piece.id, null)).nom }}</a>\n            </template>\n        </p-fileUpload>\n    </div>\n    <object *ngIf=\"isBO > 0 && uploadedFiles.Item(getPieceIndex(piece.id, null)) != null && uploadedFiles.Item(getPieceIndex(piece.id, null)).content != null\"\n            class=\"pdfViewer\"\n            [data]=\"uploadedFiles.Item(getPieceIndex(piece.id, null)).content\" type=\"application/pdf\">\n        <param name=\"view\" value=\"Fit\"/>\n    </object>\n    <img *ngIf=\"isBO > 0 && uploadedFiles.Item(getPieceIndex(piece.id, null)) != null && uploadedFiles.Item(getPieceIndex(piece.id, null)).image != null\" class=\"pdfViewer\"\n         [src]=\"uploadedFiles.Item(getPieceIndex(piece.id, null)).image\"/>\n    <jhi-alert *ngIf=\"piece.id === alertId\"></jhi-alert>\n</div>\n\n<!-- Loop over all the referents of the candidature -->\n<div class=\"form-group alert alert-warning\" role=\"alert\">\n    <!-- Message d'information dernière étape de la candidature -->\n    <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\n    <label [innerHTML]=\"currentLang === 'fr' ? parametrage?.PIECES_REFERENTS_INFOS?.libelle : parametrage?.PIECES_REFERENTS_INFOS?.libelleEn\"></label>\n</div>\n<div class=\"\" *ngFor=\"let referent of referents; let idx = index\">\n    <hr>\n    <h3 *ngIf=\"referent.typeReferent != constantes.CONTACT_PEDAGO && referent.typeReferent != constantes.CONTACT_ADMIN\" jhiTranslate=\"cadensApp.candidature.referents.title\">Referent</h3>\n    <h3 *ngIf=\"idx===0 && (referent.typeReferent === constantes.CONTACT_PEDAGO || referent.typeReferent === constantes.CONTACT_ADMIN)\" jhiTranslate=\"cadensApp.candidature.referents.titlePedago\">Contacts dans l'établissement d'origine</h3>\n\n    <div class=\"how\" [innerHTML]=\"calculTitreReferent(referent)\"></div>\n    <div class=\"row\">\n        <div class=\"form-group col-md-3\">\n            <label for=\"nom\"><span jhiTranslate=\"cadensApp.candidature.nom\">nom</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"nom\" [(ngModel)]=\"referent.nom\" name=\"nom\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"nom\" [(ngModel)]=\"referent.nom\" name=\"nom\"\n                       [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"form-group col-md-3\">\n            <label for=\"prenom\"><span jhiTranslate=\"cadensApp.candidature.prenom\">prenom</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"prenom\" [(ngModel)]=\"referent.prenom\" name=\"prenom\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"prenom\" [(ngModel)]=\"referent.prenom\" name=\"prenom\"\n                       [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n        </div>\n        <div *ngIf=\"referent.typeReferent === constantes.CONTACT_PEDAGO || referent.typeReferent === constantes.CONTACT_ADMIN\" class=\"form-group col-md-3\">\n            <label for=\"position\"><span jhiTranslate=\"cadensApp.candidature.position\">Position</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"position\" [(ngModel)]=\"referent.position\" name=\"position\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"position\" [(ngModel)]=\"referent.position\" name=\"position\"\n                       [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"form-group col-md-3\">\n            <label for=\"email\"><span jhiTranslate=\"cadensApp.candidature.email\">email</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"email\" class=\"form-control\" id=\"email\" [(ngModel)]=\"referent.email\" name=\"email\"\n                       #email=\"ngModel\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" minlength=5 maxlength=100\n                       pattern=\"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\">\n                <div *ngIf=\"email.dirty && email.invalid\">\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.required\"\n                           jhiTranslate=\"global.messages.validate.email.required\">\n                        Your e-mail is required.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.pattern\"\n                           jhiTranslate=\"global.messages.validate.email.invalid\">\n                        Your e-mail is invalid.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.minlength\"\n                           jhiTranslate=\"global.messages.validate.email.minlength\">\n                        Your e-mail is required to be at least 5 characters.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.maxlength\"\n                           jhiTranslate=\"global.messages.validate.email.maxlength\">\n                        Your e-mail cannot be longer than 100 characters.\n                    </small>\n                </div>\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"email\" class=\"form-control\" id=\"email\" [(ngModel)]=\"referent.email\" name=\"email\"\n                       #email=\"ngModel\"\n                       [disabled]=\"referent.key != null || !isEditable\" minlength=5 maxlength=100\n                       pattern=\"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\">\n                <div *ngIf=\"email.dirty && email.invalid\">\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.required\"\n                           jhiTranslate=\"global.messages.validate.email.required\">\n                        Your e-mail is required.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.pattern\"\n                           jhiTranslate=\"global.messages.validate.email.invalid\">\n                        Your e-mail is invalid.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.minlength\"\n                           jhiTranslate=\"global.messages.validate.email.minlength\">\n                        Your e-mail is required to be at least 5 characters.\n                    </small>\n                    <small class=\"form-text text-danger\" *ngIf=\"email.errors.maxlength\"\n                           jhiTranslate=\"global.messages.validate.email.maxlength\">\n                        Your e-mail cannot be longer than 100 characters.\n                    </small>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div     *ngIf=\"referent.typeReferent != constantes.CONTACT_PEDAGO && referent.typeReferent != constantes.CONTACT_ADMIN\"\n             class=\"row\">\n        <div class=\"form-group col-md-6\">\n            <label for=\"discipline\"><span\n                jhiTranslate=\"cadensApp.candidature.referents.discipline\">discipline</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"discipline\" [(ngModel)]=\"referent.discipline\" name=\"discipline\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"discipline\" [(ngModel)]=\"referent.discipline\" name=\"discipline\"\n                       [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"form-group col-md-6\">\n            <label for=\"etablissement\"><span\n                jhiTranslate=\"cadensApp.candidature.referents.etablissement\">etablissement</span></label>\n            <div *ngIf=\"referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"etablissement\" [(ngModel)]=\"referent.etablissement\"\n                       name=\"etablissement\"\n                       jhiInputRequired required [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n            <div *ngIf=\"!referent.obligatoire\">\n                <input type=\"text\" class=\"form-control\" id=\"etablissement\" [(ngModel)]=\"referent.etablissement\"\n                       name=\"etablissement\"\n                       [disabled]=\"referent.key != null || !isEditable\" maxlength=\"255\">\n            </div>\n        </div>\n        <div *ngIf=\"referent.invalid === true\">\n            <small class=\"form-text text-danger\"\n                   jhiTranslate=\"cadensApp.candidature.messages.error.referentobligatoire\">\n                Referent obligatoire\n            </small>\n        </div>\n        <div class=\"form-group col-md-6\" *ngIf=\"referent.key != null && isBO > 0 && isEditable\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"reinitMailToReferent(referent, idx)\">\n                <span class=\"fa fa-ban\"></span> <span\n                jhiTranslate=\"cadensApp.candidature.referents.reinit\">Envoyer</span>\n            </button>\n        </div>\n        <div *ngIf=\"referent.key != null && referent.email != null && isBO < 1 && referent.savedDate == null\">\n            <small class=\"form-text text-success\" jhiTranslate=\"cadensApp.candidature.messages.success.referent\">\n                Mail envoyé\n            </small>\n        </div>\n        <div *ngIf=\"referent.key != null && referent.email != null && isBO < 1 && referent.savedDate != null\">\n            <small class=\"form-text text-success\" jhiTranslate=\"cadensApp.candidature.messages.success.referentDone\">\n                Formulaire rempli\n            </small>\n        </div>\n        <div class=\"form-group col-md-6\" *ngIf=\"referent.key == null && isEditable && !isSaving\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"sendMailToReferent(referent, idx)\"\n                    (dblclick)=\"false\">\n                <span class=\"fa fa-send\"></span> <span jhiTranslate=\"cadensApp.candidature.referents.sendRequest\">Envoyer</span>\n            </button>\n        </div>\n    </div>\n\n\n\n    <!-- LETTRE DE RECOMMANDATION VISIBLE COTE BACK OFFICE !!! -->\n\n    <div *ngIf=\"isBO > 0 && lettreRecommandation !=null\">\n        <small class=\"row form-text text-success\" jhiTranslate=\"cadensApp.candidature.referents.lettre\">formulaire\n        </small>\n        <label *ngIf=\"lettreRecommandation.libelleEn || lettreRecommandation.libelle\" class=\"header\">{{ currentLang === 'fr' || lettreRecommandation.libelleEn == null ?\n            lettreRecommandation.libelle :\n            lettreRecommandation.libelleEn\n            }}</label>\n        <span *ngIf=\"lettreRecommandation.aide != null\"\n              (click)=\"openAide(pieceModal, lettreRecommandation)\"\n              class=\"fa fa-question-circle-o\"\n              title=\"Cliquer\"></span>\n        <label class=\"subLabel\" *ngIf=\"lettreRecommandation.descriptif != null\"\n               [innerHTML]=\"currentLang === 'fr' || lettreRecommandation.descriptifEn == null ? lettreRecommandation.descriptif : lettreRecommandation.descriptifEn\"></label>\n        <p-fileUpload [name]=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id))?.nom\" url=\"./api/public/upload\"\n                      [disabled]=\"!isEditable\"\n                      accept=\"application/pdf\"\n                      auto=\"auto\"\n                      id=\"{{lettreRecommandation.id}}\"\n                      (onUpload)=\"onFileUploaded($event, lettreRecommandation.id, referent.id)\"\n                      withCredentials=\"false\"\n                      (onBeforeSend)=\"onBeforeSend($event)\"\n                      (onBeforeUpload)=\"onBeforeUploadReferent($event, lettreRecommandation.id, referent.id)\"\n                      (onBeforeRemove)=\"onRemove(this.piecesJointes.find(lettreRecommandation.id)?.id)\"\n                      [maxFileSize]=\"maxSize\"\n                      invalidFileTypeMessageDetail=\"invalid pdf type\"\n                      (onError)=\"onError($event)\"\n                      chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                      uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                      cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n            <template pTemplate=\"content\" type=\"content\">\n                <a *ngIf=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)) != null\"\n                   (click)=\"openFile(uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).nom)\">{{\n                    uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).nom }}</a>\n            </template>\n        </p-fileUpload>\n        <object  *ngIf=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)) != null && uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).content != null\"\n                 class=\"pdfViewer\"\n                 [data]=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).content\" type=\"application/pdf\">\n            <param name=\"view\" value=\"Fit\"/>\n        </object>\n        <img  *ngIf=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)) != null && uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).image != null\" class=\"pdfViewer\"\n              [src]=\"uploadedFiles.Item(getPieceIndex(lettreRecommandation.id, referent.id)).image\"/>\n        <jhi-alert *ngIf=\"lettreRecommandation.id === alertId\"></jhi-alert>\n    </div>\n\n    <!-- FORMULAIRE DE RECOMMANDATION VISIBLE COTE BACK OFFICE !!! -->\n    <div class=\"\" *ngIf=\"isBO > 0 && referent.questions != null && referent.questions.length > 0\">\n        <small class=\"row form-text text-success\" jhiTranslate=\"cadensApp.candidature.referents.dispo\">formulaire\n        </small>\n        <div>\n            <jhi-reponse-component [(questions)]=\"referent.questions\" *ngIf=\"referent.questions\"\n                                   [isEditable]=\"false\"></jhi-reponse-component>\n        </div>\n        <br/>\n        <div *ngIf=\"radios?.length > 0 && radios[0].length > 0\">\n            <div class=\"table-radios\">\n                <div class=\"row head\">\n                    <div class=\"col-sm-4 header\" jhiTranslate=\"cadensApp.referent.competences\"></div>\n                    <div class=\"col-sm-1 header\" *ngFor=\"let choix of radios[0]\">{{choix}}</div>\n                </div>\n\n                <div *ngFor=\"let question of referent.questions; let idx2 = index\">\n                    <div class=\"row choice\"\n                         *ngIf=\"question.typeReponse === 'RADIO' && radios[0].join('|').indexOf(question.reponseComplement) > -1\">\n                        <label class=\"header col-sm-4\">{{ question.libelle }}</label>\n                        <div class=\"col-sm-1 radios\" *ngFor=\"let choix of radios[0]\">\n                            <p-radioButton name=\"questions-radios-{{idx}}-{{idx2}}-{{choix}}\"\n                                           id=\"questions-radios-{{idx}}-{{idx2}}-{{choix}}\"\n                                           [value]=\"choix\" [(ngModel)]=\"question.reponse\"\n                                           disabled=\"true\"></p-radioButton>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <br/>\n        <div *ngIf=\"radios?.length > 1 && radios[1].length > 0\">\n            <div *ngFor=\"let question of referent.questions; let idx3 = index\">\n                <div class=\"table-radios\"\n                     *ngIf=\"question.typeReponse === 'RADIO' && radios[1].join('|').indexOf(question.reponseComplement) > -1\">\n                    <label class=\"header\">{{ question.libelle }} {{ referent.candidat }} :</label>\n                    <div class=\"row\">\n                        <div class=\"radios\" *ngFor=\"let choix of radios[1]\">\n                            <label class=\"col-sm-2 header\">{{ choix }}</label><br/>\n                            <p-radioButton name=\"questions-radios1-{{idx}}-{{idx3}}-{{choix}}\"\n                                           id=\"questions-radios1-{{idx}}-{{idx3}}-{{choix}}\"\n                                           [value]=\"choix\" [(ngModel)]=\"question.reponse\" class=\"col-sm-2\"\n                                           disabled=\"true\"></p-radioButton>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <br/>\n        <br/>\n    </div>\n</div>\n\n\n<div class=\"row\" *ngIf=\"(pieces == null || pieces.length === 0) && referents.length < 1\">\n    <div class=\"form-group\">\n        <label jhiTranslate=\"cadensApp.candidature.files.none\">Aucune pièce n'est demandée!</label>\n    </div>\n</div>\n\n<div class=\"row\" *ngIf=\"isBO < 1\">\n    <div class=\"form-group alert alert-warning\" role=\"alert\">\n        <!-- Message d'information dernière étape de la candidature -->\n        <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>&nbsp;<label\n        [innerHTML]=\"currentLang === 'fr' ? parametrage?.PIECES_END?.libelle : parametrage?.PIECES_END?.libelleEn\"></label>\n    </div>\n</div>\n\n<div class=\"\" *ngIf=\"isBO > 0\">\n    <!--Rajout des pièces complémentaires du dossier uniquement pour le Back Office -->\n    <h1 jhiTranslate=\"cadensApp.candidature.files.others\">Autres Pièces jointes</h1>\n\n    <div class=\"row\" *ngFor=\"let file of otherUploadedFiles; let idx = index\">\n        <div class=\"form-group col-sm-12\">\n            <label class=\"header\">{{ file.notes == null ? ('cadensApp.candidature.files.othersLabel' | translate) :\n                file?.notes }}</label>\n\n            <button type=\"button\" *ngIf=\"isBO > 1\" class=\"btn btn-outline-primary pull-right\"\n                    (click)=\"addOtherPJ(otherPieceModal, idx)\"\n                    jhiTranslate=\"entity.action.update\">Modifier\n            </button>\n            <p-fileUpload url=\"./api/upload\" auto=\"auto\" [disabled]=\"true\" withCredentials=\"true\" class=\"row\"\n                          chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                          uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                          cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n                <template pTemplate=\"content\" type=\"content\">\n                    <a (click)=\"openFile(file?.nom)\">{{ file?.nom }}</a>\n                </template>\n            </p-fileUpload>\n            <object *ngIf=\"otherUploadedFiles[idx] != null && otherUploadedFiles[idx].content != null\" class=\"pdfViewer\"\n                    [data]=\"otherUploadedFiles[idx].content\" type=\"application/pdf\">\n                <param name=\"view\" value=\"Fit\"/>\n            </object>\n        </div>\n    </div>\n    <div class=\"row\">\n        <button type=\"button\" class=\"col-sm-12 btn btn-sectionFor\" data-dismiss=\"modal\"\n                (click)=\"addOtherPJ(otherPieceModal, idx)\" *ngIf=\"isBO > 1 || isEditable\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span\n            jhiTranslate=\"entity.action.addOtherPJ\">Ajouter</span>\n        </button>\n    </div>\n</div>\n\n<!-- Modal d'aide des pièces jointes -->\n<template #pieceModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">{{ currentLang === 'fr' || aide.libelleEn == null ? aide.libelle : aide.libelleEn\n            }}</h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p [innerHTML]=\"currentLang === 'fr' || aide.aideEn == null ? aide.aide : aide.aideEn\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\" jhiTranslate=\"entity.action.cancel\">\n            Close\n        </button>\n    </div>\n</template>\n\n<!-- Modal d'ajout d'une pièce jointe complémentaire au dossier par un référent / gestionnaire -->\n<template #otherPieceModal>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.action.addOtherPJ\"></h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"closeOtherPJ()\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row form-group\">\n            <label jhiTranslate=\"cadensApp.candidature.files.notes\">Commentaire : </label>\n            <input type=\"text\" class=\"form-control\" id=\"notes\" [maxlength]=\"255\" name=\"notes\"\n                   [(ngModel)]=\"otherUploadedFiles[lastIdx].notes\">\n        </div>\n        <p-fileUpload [name]=\"otherUploadedFiles[lastIdx]?.nom\" url=\"./api/upload\" auto=\"auto\" withCredentials=\"true\"\n                      class=\"row\"\n                      (onBeforeSend)=\"onBeforeSend($event)\" (onBeforeUpload)=\"onBeforeUpload($event, 1)\"\n                      (onUpload)=\"onOtherFileUploaded($event)\" [maxFileSize]=\"32000000\" (onError)=\"onError($event)\"\n                      chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                      uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                      cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n            <template pTemplate=\"content\" type=\"content\">\n                <a (click)=\"openFile(otherUploadedFiles[lastIdx]?.nom)\">{{ otherUploadedFiles[lastIdx]?.nom }}</a>\n            </template>\n        </p-fileUpload>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveOtherPJ(otherPieceModal)\"\n                jhiTranslate=\"entity.action.save\">Modifier\n        </button>\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"closeOtherPJ()\" jhiTranslate=\"entity.action.cancel\">\n            Close\n        </button>\n        <button *ngIf=\"otherUploadedFiles[lastIdx].id != null\" type=\"button\" class=\"btn btn-danger\" icon=\"fa-check\"\n                (click)=\"deleteOtherPJ()\"><span jhiTranslate=\"entity.action.delete\"></span></button>\n    </div>\n</template>\n"

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"listePreavis!=null && listePreavis.length>0\">\n    <h1 jhiTranslate=\"cadensApp.candidature.preavis.title\">Preavis pédagogique</h1>\n\n    <label *ngIf=\"dateLimitePreavis!=null\"><span jhiTranslate=\"cadensApp.candidature.preavis.dateLimitePreavis\"\n                                                 translateValues=\"{dateLimitePreavis: '{{dateLimitePreavis | date: 'shortDate' }}'}\">date limite preavis</span></label>\n    <br *ngIf=\"dateLimitePreavis!=null\">\n\n    <div class=\"row col-md-10\">\n        <div class=\"table-responsive no-padding\">\n            <table [ngClass]=\" listePreavis.length>1?'table table-striped':'table'\">\n                <thead>\n                <tr>\n                    <td class=\"label\"><span\n                        jhiTranslate=\"cadensApp.candidature.preavis.nomFournisseur\">Enseignant</span></td>\n                    <td class=\"label\"><span jhiTranslate=\"cadensApp.candidature.preavis.saisiePreavis\">Choix</span></td>\n\n                    <td class=\"label\"><span jhiTranslate=\"cadensApp.candidature.preavis.dateModification\">date modification</span>                    </td>\n                    <td class=\"label\"><span\n                        jhiTranslate=\"cadensApp.candidature.preavis.saisieCommentaire\">commentaire</span></td>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let preavis of listePreavis\" >\n                    <td>{{preavis.fournisseur.firstName + ' ' + preavis.fournisseur.lastName}}</td>\n                    <td he>\n                        <div class=\"btn-toolbar col-md-4\" role=\"toolbar\">\n                            <div class=\"btn-group mr-2\" role=\"group\" *ngFor=\"let preavisOption of listeChoixPreavis\">\n                                <button type=\"button\" (click)=\"choosePreavis(preavis,preavisOption)\"\n                                        class=\"btn btn-secondary\"\n                                        [disabled]=\"!preavisModifEnabled\"\n                                        [ngClass]=\"{'selected': preavis.choix!=null && preavis.choix.code === preavisOption.code}\">\n                                    <span *ngIf=\"currentLang=='fr'\">{{preavisOption.libelle}}</span>\n                                    <span *ngIf=\"currentLang=='en'\">{{preavisOption.libelleEn}}</span>\n                                </button>\n                            </div>\n                        </div>\n                    </td>\n\n                    <td>{{preavis.dateModification == null ? preavis.dateCreation : preavis.dateModification  | date:'dd/MM/yy HH:mm:ss'  }}</td>\n\n                    <td>\n                        <textarea class=\"form-control\" rows=\"4\" id=\"commentaire\" [(ngModel)]=\"preavis.commentaire\" name=\"commentaire\"  maxlength=\"1000\"></textarea>\n                        <!-- <input type=\"text\" class=\"form-control\" id=\"commentaire\" name=\"commentaire\"\n                                [(ngModel)]=\"preavis.commentaire\" [title]=\"preavis.commentaire\"\n                                [disabled]=\"!preavisModifEnabled\"\n                                maxlength=\"100\" class=\"inputPreavis\" >\n                         <textarea class=\"form-control\" rows=\"5\" id=\"description\" [(ngModel)]=\"preavis.commentaire\" name=\"commentaire\"  maxlength=\"255\"></textarea>\n  <textarea class=\"form-control\" rows=\"5\" id=\"description\" jhiInputRequired required [(ngModel)]=\"contact.description\" name=\"description\"  maxlength=\"2000\"></textarea>\n                           <textarea class=\"form-control\" id=\"commentaire\" name=\"commentaire\"\n                                    [maxlength]=\"255\"\n                                    [disabled]=\"!preavisModifEnabled\"\n                                    [[(ngModel)]=\"preavis.commentaire\"></textarea>\n                         <textarea rows=\"5\" cols=\"30\" pInputTextarea autoResize=\"autoResize\" id=\"commentaire\" name=\"commentaire\"\n                                    [(ngModel)]=\"preavis.commentaire\" [title]=\"preavis.commentaire\" maxlength=\"255\"\n                                    [disabled]=\"!preavisModifEnabled\"/> -->\n                    </td>\n                </tr>\n\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"!isReinscription\" class=\"subgroup-header\" jhiTranslate=\"cadensApp.cursus.home.year\" translateValues=\"{index: '{{index+1}}'}\" ></div>\n\n<div class=\"row\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"dateDebut-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.dateDebut\">dateDebut</span></label>\n        <p-calendar [(ngModel)]=\"cursus.dateDebut\" id=\"dateDebut-{{index}}\" jhiInputRequired required class=\"form-control\"\n                    [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\" yearRange=\"1920:3000\" [monthNavigator]=\"true\"\n                    placeholder=\"jj/mm/aaaa\" (ngModelChange)=\"checkDates($event)\" [disabled]=\"!isEditable\"></p-calendar>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"dateFin-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.dateFin\">dateFin</span></label>\n        <p-calendar [(ngModel)]=\"cursus.dateFin\" id=\"dateFin-{{index}}\" jhiInputRequired required class=\"form-control\"\n                    [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\" yearRange=\"1920:3000\" [monthNavigator]=\"true\"\n                    placeholder=\"jj/mm/aaaa\" (ngModelChange)=\"checkDates($event)\" [disabled]=\"!isEditable\"></p-calendar>\n    </div>\n</div>\n<div class=\"row\">\n    <div *ngIf=\"dateFinInvalid\">\n        <small class=\"form-text text-danger\" *ngIf=\"dateFinInvalid.beforeDateDebut\" jhiTranslate=\"cadensApp.cursus.validate.dateFin.beforeDateDebut\">\n            Date début before date fin.\n        </small>\n        <small class=\"form-text text-danger\" *ngIf=\"dateFinInvalid.invalid\" jhiTranslate=\"cadensApp.cursus.validate.dateFin.invalid\">\n            Dates invalides\n        </small>\n    </div>\n</div>\n\n<div class=\"row\" *ngIf=\"!isReinscription\">\n    <div class=\"form-group col-md-6\">\n        <label><span jhiTranslate=\"cadensApp.cursus.interruption\">interruption</span></label>\n        <div class=\"row\">\n            <div class=\"form-check col-sm-3\">\n                <p-radioButton class=\"form-check-input\" name=\"interruption{{index}}\" id=\"interr1{{index}}\" [value]=\"true\"\n                               [(ngModel)]=\"cursus.interruption\" #interruption=\"ngModel\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"global.form.yes\">oui</label>\n            </div>\n            <div class=\"form-check col-sm-3\">\n                <p-radioButton class=\"form-check-input\" name=\"interruption{{index}}\" id=\"interr0{{index}}\" [value]=\"false\"\n                               [(ngModel)]=\"cursus.interruption\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"global.form.no\">non</label>\n            </div>\n            <div *ngIf=\"interruption.dirty && interruption.invalid\">\n                <small class=\"form-text text-danger\" *ngIf=\"interruption.errors.required\" jhiTranslate=\"cadensApp.cursus.validate.interruption.required\">\n                    Interruption is required.\n                </small>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group col-md-6\" *ngIf=\"cursus.interruption === true\">\n        <label><span jhiTranslate=\"cadensApp.cursus.motif\">motif</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"motif-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.motif\" name=\"motif\"\n               placeholder=\"{{'cadensApp.cursus.motif' | translate}}\" [disabled]=\"!isEditable\" maxlength=\"255\">\n    </div>\n</div>\n\n\n\n<div class=\"row\" *ngIf=\"cursus.interruption === false\">\n    <div class=\"form-group col-md-12\">\n        <label><span jhiTranslate=\"cadensApp.cursus.detail.etablissement\">etablissement</span></label>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"cursus.interruption === false\">\n    <jhi-adresse-component [(pays)]=\"cursus.pays\" [paysListe]=\"paysListe\"\n                       [(dept)]=\"cursus.dept\" [deptListe]=\"deptListe\"\n                       [(ville)]=\"cursus.ville\" [cols]=\"3\" [isEditable]=\"isEditable\"\n                       [(rne)]=\"cursus.etablissement\" [(rneAutre)]=\"cursus.etablissementAutre\" [showRne]=\"true\"\n                       [translationKey]=\"'cadensApp.cursus'\"></jhi-adresse-component>\n</div>\n\n\n<div class=\"row\" *ngIf=\"cursus.interruption === false\">\n    <div class=\"form-group col-md-12\">\n        <label><span jhiTranslate=\"cadensApp.cursus.detail.formation\">formation</span></label>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"cursus.interruption === false\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"typeFormation-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.typeFormation\">type</span></label>\n        <select class=\"form-control\" id=\"typeFormation-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.typeFormationId\" name=\"typeFormation\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"typeFormationOption.idTypeFormation\" *ngFor=\"let typeFormationOption of typeFormationListe\">{{ typeFormationOption.libelle }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"gradeUniversitaire-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.gradeUniversitaire\">gradeUniversitaire</span></label>\n        <select class=\"form-control\" id=\"gradeUniversitaire-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.gradeUniversitaireId\" name=\"gradeUniversitaire\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"gradeUniversitaireOption.idGradeUniversitaire\" *ngFor=\"let gradeUniversitaireOption of gradeUniversitaireListe\">{{ gradeUniversitaireOption.libelle }}</option>\n        </select>\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"niveau-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.niveau\">niveau</span></label>\n        <select class=\"form-control\" id=\"niveau-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.niveauAccesDiplomeId\" name=\"niveau\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"niveauAccesDiplomeOption.idNiveauAccesDiplome\" *ngFor=\"let niveauAccesDiplomeOption of niveauAccesDiplomeListe\">{{ niveauAccesDiplomeOption.libelle }}</option>\n        </select>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"cursus.interruption === false\">\n    <div class=\"form-group col-md-10\">\n        <label for=\"titre-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.titreDiplomePrepare\">titre</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"titre-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.titreDiplomePrepare\" name=\"titre\" [disabled]=\"!isEditable\" maxlength=\"255\">\n    </div>\n</div>\n\n\n<div class=\"row\" *ngIf=\"cursus.interruption === false && !isReinscription\">\n    <div class=\"form-group col-md-6\">\n        <label><span jhiTranslate=\"cadensApp.cursus.anneeSanctionnee\">diplome</span></label>\n        <div class=\"row\">\n            <div class=\"form-check col-sm-3\">\n                <p-radioButton class=\"form-check-input\" name=\"diplome{{index}}\" id=\"diplome1{{index}}\" [value]=\"true\"\n                               [(ngModel)]=\"cursus.anneeSanctionnee\" #anneeSanctionnee=\"ngModel\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"global.form.yes\">oui</label>\n            </div>\n            <div class=\"form-check col-sm-3\">\n                <p-radioButton class=\"form-check-input\" name=\"diplome{{index}}\" id=\"diplome0{{index}}\" [value]=\"false\"\n                               [(ngModel)]=\"cursus.anneeSanctionnee\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                <label jhiTranslate=\"global.form.no\">non</label>\n            </div>\n            <div *ngIf=\"anneeSanctionnee.untouched && anneeSanctionnee.invalid\">\n                <small class=\"form-text text-danger\" *ngIf=\"anneeSanctionnee.errors.required\" jhiTranslate=\"cadensApp.cursus.validate.anneeSanctionnee.required\">\n                    anneeSanctionnee is required.\n                </small>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"cursus.anneeSanctionnee === true && cursus.interruption === false\">\n    <div class=\"form-group col-md-4\">\n        <label for=\"intituleDiplome-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.intituleDiplome\">intituleDiplome</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"intituleDiplome-{{index}}\" [(ngModel)]=\"cursus.intituleDiplome\" name=\"intituleDiplome\"\n               placeholder=\"{{'cadensApp.cursus.intituleDiplome' | translate}}\" [disabled]=\"!isEditable\" jhiInputRequired required maxlength=\"255\">\n    </div>\n    <div class=\"form-group col-md-4\">\n        <label for=\"mention-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.mention\">mention</span></label>\n        <select class=\"form-control\" id=\"mention-{{index}}\" jhiInputRequired required [(ngModel)]=\"cursus.mention\" name=\"mention\" [disabled]=\"!isEditable\">\n            <option></option>\n            <option [ngValue]=\"mentionOption.code\" *ngFor=\"let mentionOption of mentionListe\">{{ mentionOption.libelle }}</option>\n        </select>\n    </div>\n    <div *ngIf=\"cursus.mention != constants.MENTION_ATTENTE_RESULTAT_CODE\" class=\"form-group col-md-4\">\n        <label for=\"dateObtentionDiplome-{{index}}\"><span jhiTranslate=\"cadensApp.cursus.dateObtentionDiplome\">dateObtentionDiplome</span></label>\n        <div class=\"input-group\">\n            <p-calendar [(ngModel)]=\"cursus.dateObtentionDiplome\" id=\"dateObtentionDiplome-{{index}}\" jhiInputRequired required\n                        [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\" yearRange=\"1920:3000\" [monthNavigator]=\"true\" [disabled]=\"!isEditable\"></p-calendar>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "<div id=\"component-scolarite\">\n    <h1 jhiTranslate=\"global.menu.candidature.admin\">Données administratives</h1>\n    <h2 jhiTranslate=\"cadensApp.candidature.scolarite.title\">scolarite</h2>\n\n    <div *ngIf=\"!candidatureFormation.reinscription\"> <!--  AFFICHAGE POUR LES PRIMO ACCEDANTS !! -->\n\n        <h3 jhiTranslate=\"cadensApp.candidature.ines.title\">INES</h3>\n        <br/>\n        <div class=\"row\">\n            <label for=\"ines\"><span [innerHTML]=\"currentLang === 'fr' ? parametrage?.INES_INFOS?.libelle : parametrage?.INES_INFOS?.libelleEn\"></span></label>\n            &nbsp;\n            <span (click)=\"openAide(aideModal, parametrage?.INES_DETAILS)\" class=\"fa fa-question-circle-o\" title=\"Cliquer\"></span>\n        </div>\n        <div class=\"row\">\n            <input id=\"ines\" name=\"ines\" type=\"text\" #ines=\"ngModel\" class=\"form-control col-md-6\" [(ngModel)]=\"candidature.ines\" maxlength=\"11\" pattern=\"[0-9A-Z]*\" [disabled]=\"!isEditable\" />\n            <small class=\"form-text text-danger\" *ngIf=\"ines && ines.errors && ines.errors.pattern\"\n                   jhiTranslate=\"cadensApp.candidature.ines.invalid\">\n                Your ines is invalid.\n            </small>\n        </div>\n        <br/>\n\n        <h3 jhiTranslate=\"cadensApp.candidature.bourse.title\">Bourse</h3>\n        <br/>\n        <div class=\"row \">\n            <label for=\"bourse\"><span [innerHTML]=\"currentLang === 'fr' ? parametrage?.BOURSE_INFOS?.libelle : parametrage?.BOURSE_INFOS?.libelleEn\"></span></label>\n        </div>\n        <div class=\"form-group col-md-6\">\n            <div class=\"row\">\n                <div class=\"form-check col-sm-3\">\n                    <p-radioButton id=\"bourse\" class=\"form-check-input\" name=\"bourse\" [value]=\"true\"\n                                   [(ngModel)]=\"candidature.bourse\" #bourse=\"ngModel\"\n                                   jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.yes\">oui</label>\n                </div>\n                <div class=\"form-check col-sm-3\">\n                    <p-radioButton id=\"bourse2\" class=\"form-check-input\" name=\"bourse\" [value]=\"false\"\n                                   [(ngModel)]=\"candidature.bourse\"\n                                   (ngModelChange)=\"onChangeBourse()\"\n                                   jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.no\">non</label>\n                </div>\n            </div>\n            <div class=\"row \" *ngIf=\"candidature.bourse==true\">\n                <label for=\"bourse\"><span [innerHTML]=\"currentLang === 'fr' ? parametrage?.BOURSE_ECHELON?.libelle : parametrage?.BOURSE_ECHELON?.libelleEn\"></span></label>\n            </div>\n            <div class=\"row\" *ngIf=\"candidature.bourse==true\">\n                <div class=\"form-group\">\n                    <select class=\"form-control\" id=\"echelon\" jhiInputRequired required [(ngModel)]=\"candidature.echelon\" name=\"echelon\" style=\"width: 400px;\">\n                        <option value=\"\" disabled selected>Veuillez indiquer l'échelon de votre bourse</option>\n                        <option [ngValue]=\"echelon.libelle\" *ngFor=\"let echelon of listeEchelons\">{{ echelon.libelle }}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        <h3 jhiTranslate=\"cadensApp.candidature.bac.title\">Bac</h3>\n        <div class=\"how\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.SCOLARITE_INFOS.libelle : parametrage?.SCOLARITE_INFOS.libelleEn\"></div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-3\">\n                <label for=\"bacTypeEtablissement\"><span jhiTranslate=\"cadensApp.candidature.bac.bacTypeEtablissement\">bacTypeEtablissement</span></label>\n                <select class=\"form-control\" id=\"bacTypeEtablissement\" jhiInputRequired required [(ngModel)]=\"candidature.bacTypeEtablissement\"\n                        name=\"bacTypeEtablissement\" [disabled]=\"!isEditable\" (change)=\"onChangeTypeEtab()\">\n                    <option [ngValue]=\"type\" *ngFor=\"let type of typesEtablissement\">{{ 'cadensApp.candidature.typeEtablissement.' + type | translate }}</option>\n                </select>\n            </div>\n            <div class=\"form-group col-md-3\">\n                <label for=\"bacAnnee\"><span jhiTranslate=\"cadensApp.candidature.bac.annee\">bacAnnee</span></label>\n                <input type=\"number\" class=\"form-control\" id=\"bacAnnee\" jhiInputRequired required [(ngModel)]=\"candidature.bacAnnee\" name=\"bacAnnee\"\n                       placeholder=\"{{'cadensApp.candidature.bac.annee' | translate}}\" min=\"1900\" max=\"3000\" [disabled]=\"!isEditable\"\n                       (change)=\"onChangeBacAnnee()\">\n            </div>\n        </div>\n        <div *ngIf=\"this.displayBacDetail\" class=\"row\">\n            <div class=\"form-group col-md-9\">\n                <label for=\"bacCode\"><span jhiTranslate=\"cadensApp.candidature.bac.code\">bacCode</span></label>\n                <p-dropdown class=\"p-form-control\" [options]=\"bacsListe\" jhiInputRequired required [(ngModel)]=\"candidature.bac\"\n                            id=\"bacCode\" name=\"bacCode\" [disabled]=\"!isEditable\" [filter]=\"true\">\n                </p-dropdown>\n            </div>\n            <div class=\"form-group col-md-3\">\n                <label for=\"bacMention\"><span jhiTranslate=\"cadensApp.candidature.bac.mention\">bacMention</span></label>\n                <select class=\"form-control\" id=\"bacMention\" jhiInputRequired required [(ngModel)]=\"candidature.bacMention\" name=\"bacMention\" [disabled]=\"!isEditable\">\n                    <option [ngValue]=\"mentions.code\" *ngFor=\"let mentions of mentionsListe\">{{mentions.libelle}}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"displayBacDetail && areSpecialitesBacObligatoires()\">\n            <div class=\"form-group col-md-6\">\n                <label for=\"bacSpecialite1\"><span jhiTranslate=\"cadensApp.candidature.bacSpecialite1.label\">bacSpecialite1</span></label>\n                <select class=\"form-control\" id=\"bacSpecialite1\" jhiInputRequired required [(ngModel)]=\"candidature.bacSpec1LibelleCourt\" name=\"bacSpecialite1\" [disabled]=\"!isEditable\">\n                    <option [ngValue]=\"bacSpecialites.libelleCourt\" *ngFor=\"let bacSpecialites of bacSpecialitesListe\">{{bacSpecialites.libelleLong}}</option>\n                </select>\n            </div>\n            <div class=\"form-group col-md-6\">\n                <label for=\"bacSpecialite2\"><span jhiTranslate=\"cadensApp.candidature.bacSpecialite2.label\">bacSpecialite2</span></label>\n                <select class=\"form-control\" id=\"bacSpecialite2\" jhiInputRequired required [(ngModel)]=\"candidature.bacSpec2LibelleCourt\" name=\"bacSpecialite2\" [disabled]=\"!isEditable\">\n                    <option [ngValue]=\"bacSpecialites.libelleCourt\" *ngFor=\"let bacSpecialites of bacSpecialitesListe\">{{bacSpecialites.libelleLong}}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"row\" *ngIf=\"this.displayBacDetail\">\n            <jhi-adresse-component [(pays)]=\"candidature.bacPays\" [paysListe]=\"paysListe\"\n                               [(dept)]=\"candidature.bacDept\" [deptListe]=\"deptListe\" [typeEtab]=\"candidature.bacTypeEtablissement\"\n                               [(ville)]=\"candidature.bacVille\" [cols]=\"6\" [isEditable]=\"isEditable\"\n                               [(rne)]=\"candidature.bacEtab\" [(rneAutre)]=\"candidature.bacEtablissementAutre\" [showRne]=\"true\"\n                               [translationKey]=\"'cadensApp.candidature.bac'\"></jhi-adresse-component>\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"!candidatureFormation.reinscription\"> <!--  AFFICHAGE POUR LES PRIMO ACCEDANTS !! -->\n    <hr>\n    <h3 jhiTranslate=\"cadensApp.candidature.cursus.title\">Cursus</h3>\n    <div class=\"how\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.CURSUS_INFOS.libelle : parametrage?.CURSUS_INFOS.libelleEn\"></div>\n\n    <div *ngFor=\"let cursus of courses; let idx = index\" class=\"subgroup\">\n        <div class=\"subgroup-clear\" (click)=\"clearCursus(idx)\" *ngIf=\"isEditable\">\n            <i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>\n        </div>\n        <jhi-cursus-component [cursus]=\"cursus\" [index]=\"idx\" [isEditable]=\"isEditable\"\n                              [isReinscription]=\"false\"\n                          [paysListe]=\"paysListe\" [deptListe]=\"deptListe\" [mentionListe]=\"mentionsListe\">\n        </jhi-cursus-component>\n    </div>\n    <div>\n        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addCursus()\" *ngIf=\"isEditable\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span jhiTranslate=\"entity.action.addCursus\">Ajouter</span>\n        </button>\n    </div>\n</div>\n\n<div *ngIf=\"candidatureFormation.reinscription\"> <!--  AFFICHAGE POUR LES REINSCRIPTIONS !! -->\n    <h3 jhiTranslate=\"cadensApp.candidature.reinscription.title\">Cursus</h3>\n    <div class=\"how\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.CURSUS_INFOS_REINSCRIPTION.libelle : parametrage?.CURSUS_INFOS_REINSCRIPTION.libelleEn\"></div>\n\n    <div *ngFor=\"let cursus of courses; let idx = index\" class=\"subgroup\">\n        <jhi-cursus-component [cursus]=\"cursus\" [index]=\"idx\" [isEditable]=\"isEditable\" [isReinscription]=\"candidatureFormation.reinscription\"\n                          [paysListe]=\"paysListe\" [deptListe]=\"deptListe\" [mentionListe]=\"mentionsListe\"  [candidatureFormationId]=\"candidatureFormation.id\">\n        </jhi-cursus-component>\n    </div>\n</div>\n\n<hr>\n<h3 jhiTranslate=\"cadensApp.candidature.scolarite.concours\">Concours</h3>\n<div *ngFor=\"let con of concours; let idx = index\">\n    <div class=\"row\">\n        <div class=\"form-group col-md-6\">\n            <label>{{con.typeConcours}}</label>\n            <div class=\"row\">\n                <div class=\"form-check col-sm-3\">\n                    <p-radioButton class=\"form-check-input\"  name=\"concours{{con.id}}\" id=\"{{con.id}}1\" [value]=\"true\"\n                                   [(ngModel)]=\"con.passage\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label class=\"label\" jhiTranslate=\"global.form.yes\">oui</label>\n                </div>\n                <div class=\"form-check col-sm-3\">\n                    <p-radioButton class=\"form-check-input\"  name=\"concours{{con.id}}\" id=\"{{con.id}}0\" [value]=\"false\"\n                                   [(ngModel)]=\"con.passage\" jhiInputRequired required (ngModelChange)=\"onChangeConcours(idx)\" [disabled]=\"!isEditable\"></p-radioButton>\n                    <label class=\"label\" jhiTranslate=\"global.form.no\">non</label>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row subform\" *ngIf=\"con.passage === true\">\n        <div class=\"form-group col-md-3\">\n            <label for=\"annee[{{con.id}}]\"><span jhiTranslate=\"cadensApp.candidature.annee\">annee</span></label>\n            <input type=\"number\" class=\"form-control\" id=\"annee[{{con.id}}]\" jhiInputRequired required [(ngModel)]=\"con.annee\" name=\"annee{{concours.id}}\"\n                   placeholder=\"AAAA\" [disabled]=\"!isEditable\" pattern=\"[0-9]{4}\">\n            <div *ngIf=\"con.annee != null && con.annee < 1000\">\n                <small class=\"form-text text-danger\" jhiTranslate=\"cadensApp.candidature.messages.validate.annee\">\n                    Annee sur 4 caractères.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group col-md-4\">\n            <label><span jhiTranslate=\"cadensApp.candidature.resultat\">resultat</span></label>\n            <div class=\"row\">\n                <div class=\"form-check col-sm-4\">\n                    <p-radioButton class=\"form-check-input\" name=\"resultat{{con.id}}\" id=\"resultat{{con.id}}1\" [value]=\"1\"\n                                   [(ngModel)]=\"con.resultat\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.yes\">oui</label>\n                </div>\n                <div class=\"form-check col-sm-4\">\n                    <p-radioButton class=\"form-check-input\" name=\"resultat{{con.id}}\" id=\"resultat{{con.id}}0\" [value]=\"0\"\n                                   [(ngModel)]=\"con.resultat\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.no\">non</label>\n                </div>\n                <div class=\"form-check col-sm-4\">\n                    <p-radioButton class=\"form-check-input\" name=\"resultat{{con.id}}\" id=\"resultat{{con.id}}2\" [value]=\"2\"\n                                   [(ngModel)]=\"con.resultat\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.encours\">en cours</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group col-md-3\" *ngIf=\"con.resultat === 1\">\n            <label for=\"rang{{con.id}}\"><span jhiTranslate=\"cadensApp.candidature.rang\">rang</span></label>\n            <input type=\"number\" class=\"form-control\" id=\"rang{{con.id}}\" [(ngModel)]=\"con.rang\" name=\"rang{{con.id}}\"\n                   placeholder=\"10\" min=\"0\" jhiInputRequired required [disabled]=\"!isEditable\">\n        </div>\n        <div class=\"form-group col-md-3\" *ngIf=\"con.resultat === 2 || con.resultat === 0\">\n            <label for=\"admissible{{con.id}}1\"><span jhiTranslate=\"cadensApp.candidature.admissible\">admissible</span></label>\n            <div class=\"row\">\n                <div class=\"form-check col-sm-6\">\n                    <p-radioButton class=\"form-check-input\"  name=\"admissible{{con.id}}\" id=\"admissible{{con.id}}1\" [value]=\"true\"\n                                   [(ngModel)]=\"con.admissible\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.yes\">oui</label>\n                </div>\n                <div class=\"form-check col-sm-6\">\n                    <p-radioButton class=\"form-check-input\"  name=\"admissible{{con.id}}\" id=\"admissible{{con.id}}0\" [value]=\"false\"\n                                   [(ngModel)]=\"con.admissible\" jhiInputRequired required [disabled]=\"!isEditable\"></p-radioButton>\n                    <label jhiTranslate=\"global.form.no\">non</label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<template #aideModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.action.help\">Aide</h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p [innerHTML]=\"currentLang === 'fr' ? aide?.libelle : aide?.libelleEn\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\" jhiTranslate=\"global.close\">Close</button>\n    </div>\n</template>\n\n"

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myCommissionLabel\" jhiTranslate=\"cadensApp.commission.home.selectLabel\">Create or edit a Commission</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div *ngIf=\"createCommission === false\">\n            <div *ngFor=\"let commission of commissions; let idx = index\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"selectCommission(commission)\">\n                    <span class=\"fa fa-arrow-right\"></span>&nbsp;{{commission.libelle}}<span jhiTranslate=\"cadensApp.commission.le\"></span>{{commission.dateCommission | date: 'medium'}})\n                </button>\n            </div>\n        </div>\n        <div *ngIf=\"createCommission === true\">\n            <jhi-commission-component [(commission)]=\"commission\"></jhi-commission-component>\n        </div>\n    </div>\n    <div class=\"modal-footer\" *ngIf=\"createCommission === true\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n    <div class=\"modal-footer\" *ngIf=\"createCommission === false\">\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"createCommissionButton()\">\n            <span class=\"fa fa-plus-circle\"></span>&nbsp;<span jhiTranslate=\"cadensApp.commission.home.createLabel\">Cancel</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n\n    <h1 jhiTranslate=\"cadensApp.contact.home.title\">contact</h1>\n\n    <div class=\"row\">\n        <div class=\"form-group col-md-10 offset-md-1\">\n            <label for=\"nature\"><span jhiTranslate=\"cadensApp.contact.nature\">Nature de la demande</span></label>\n            <select class=\"form-control\" id=\"nature\" jhiInputRequired required [(ngModel)]=\"contact.nature\" name=\"nature\">\n                <option value=\"connexion\"><span jhiTranslate=\"cadensApp.contact.connexion\"></span></option>\n                <option jhiTranslate=\"cadensApp.contact.offre\" value=\"offre\"></option>\n                <option jhiTranslate=\"cadensApp.contact.candidature\" value=\"candidature\"></option>\n                <option jhiTranslate=\"cadensApp.contact.autres\" value=\"autres\"></option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"row\" *ngIf=\"contact.nature === 'connexion'\">\n        <span jhiTranslate=\"cadensApp.contact.faq\"></span>\n    </div>\n    <div class=\"row\" *ngIf=\"contact.nature === 'offre'\">\n        <span jhiTranslate=\"cadensApp.contact.lienOffres\"></span><a [href]=\"currentLang === 'fr' ? parametrage?.URL.libelle : parametrage?.URL.libelleEn\" jhiTranslate=\"cadensApp.contact.lien\"></a>\n    </div>\n\n    <div class=\"\" *ngIf=\"contact.nature === 'candidature'\">\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"demande\"><span jhiTranslate=\"cadensApp.contact.demande\">Votre demande concerne</span></label>\n                <select class=\"form-control\" id=\"demande\" jhiInputRequired required [(ngModel)]=\"contact.demande\" name=\"demande\">\n                    <option value=\"champ\"><span jhiTranslate=\"cadensApp.contact.champ\"></span></option>\n                    <option jhiTranslate=\"cadensApp.contact.piece\" value=\"piece\"></option>\n                    <option jhiTranslate=\"cadensApp.contact.autres\" value=\"autres\"></option>\n                </select>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"formation\"><span jhiTranslate=\"cadensApp.contact.formation\">formation concernée</span></label>\n                <input type=\"text\" class=\"form-control\" jhiInputRequired required id=\"formation\" [(ngModel)]=\"contact.formation\" name=\"formation\">\n            </div>\n        </div>\n    </div>\n\n    <div *ngIf=\"(contact.nature === 'candidature' && contact.formation && contact.demande) || contact.nature === 'autres'\">\n        <div class=\"row\">\n            <label><span jhiTranslate=\"cadensApp.contact.fillin\">fillin</span></label>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"nom\"><span jhiTranslate=\"cadensApp.contact.nom\">nom</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"nom\" jhiInputRequired required [(ngModel)]=\"contact.nom\" name=\"nom\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"prenom\"><span jhiTranslate=\"cadensApp.contact.prenom\">prenom</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"prenom\" jhiInputRequired required [(ngModel)]=\"contact.prenom\" name=\"prenom\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"email\"><span jhiTranslate=\"cadensApp.contact.email\">email</span></label>\n                <input type=\"text\" class=\"form-control\" id=\"email\" jhiInputRequired required [(ngModel)]=\"contact.email\" name=\"email\" maxlength=\"255\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"dateNaissance\"><span jhiTranslate=\"cadensApp.contact.naissance\">naissance</span></label>\n                <p-calendar [(ngModel)]=\"contact.dateNaissance\" id=\"dateNaissance\" name=\"dateNaissance\" jhiInputRequired required\n                            [showIcon]=\"true\" dateFormat=\"dd/mm/yy\" [locale]=\"fr\" [yearNavigator]=\"true\"\n                            yearRange=\"1960:2017\" [monthNavigator]=\"true\"></p-calendar>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"form-group col-md-10 offset-md-1\">\n                <label for=\"description\"><span jhiTranslate=\"cadensApp.contact.description\">description</span></label>\n                <textarea class=\"form-control\" rows=\"5\" id=\"description\" jhiInputRequired required [(ngModel)]=\"contact.description\" name=\"description\"  maxlength=\"2000\"></textarea>\n            </div>\n        </div>\n        <br/>\n        <jhi-alert></jhi-alert>\n        <div class=\"text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"sendEmail()\">\n                <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i>\n                <span jhiTranslate=\"entity.action.send\">Envoyer</span>\n            </button>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"card\" *ngIf=\"entityAuditEvent\">\n    <h2><span jhiTranslate=\"cadensApp.entityAuditEvent.detail.title\">Entity Audit Event</span> {{entityAuditEvent.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.entityId\">Entity Id</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.entityId}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.entityType\">Entity Type</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.entityType}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.action\">Action</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.action}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.commitVersion\">Commit Version</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.commitVersion}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.modifiedBy\">Modified By</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.modifiedBy}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.modifiedDate\">Modified Date</span></dt>\n        <dd>\n            <span>{{entityAuditEvent.modifiedDate | date:'medium'}}</span>\n        </dd>\n\n        <dt><span jhiTranslate=\"cadensApp.entityAuditEvent.entityValue\">Entity Value</span></dt>\n        <div>\n            <pre class=\" language-markup code-toolbar\"><code class=\" language-markup\">{{toJsonObject(entityAuditEvent.entityValue) | json }} </code></pre>\n        </div>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n <!--   <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'entity-audit-event/'+ entityAuditEvent.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n-->\n</div>\n"

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"cadensApp.entityAuditEvent.home.title\">Entity Audit Events</span>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div *ngIf=\"isFilterCandidatureDisplayed\" class=\"container-search\">\n        <div class=\"search\">\n            <div class=\"row\">\n                <div class=\"col-md-3 col-sm-4\">\n                    <div class=\"input-group\">\n                        <input [(ngModel)]=\"candidatureFormationId\" name=\"candidatureFormationId\" type=\"text\"\n                               class=\"form-control\"\n                               placeholder=\"CandidatureFormationId\" autocomplete=\"off\">\n                        <span class=\"input-group-addon btn-secondary text-primary\" (click)=\"loadAll()\" id=\"search\"><span\n                            class=\"fa fa-search\"></span></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"!isFilterCandidatureDisplayed && candidatureFormation!=null\" class=\"container-search\">\n                    <span >\n                        <a tabindex=\"-1\"\n                           (click)=\"goToCandidature()\">{{candidatureFormation.libelle==null?candidatureFormation.id: candidatureFormation.libelle }}</a>\n                    </span>\n    </div>\n    <br/>\n    <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n    <div class=\"table-responsive\" *ngIf=\"entityAuditEvents\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n                <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"entityType\"><span jhiTranslate=\"cadensApp.entityAuditEvent.entityType\">Entity Type</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"action\"><span jhiTranslate=\"cadensApp.entityAuditEvent.action\">Action</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <!--<th jhiSortBy=\"entityValue\"><span jhiTranslate=\"cadensApp.entityAuditEvent.entityValue\">Entity Value</span> <span class=\"fa fa-sort\"></span></th>-->\n                <th jhiSortBy=\"commitVersion\"><span jhiTranslate=\"cadensApp.entityAuditEvent.commitVersion\">Commit Version</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"modifiedBy\"><span jhiTranslate=\"cadensApp.entityAuditEvent.modifiedBy\">Modified By</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"modifiedDate\"><span\n                    jhiTranslate=\"cadensApp.entityAuditEvent.modifiedDate\">Modified Date</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let entityAuditEvent of entityAuditEvents ;trackBy: trackId\">\n                <td><a [routerLink]=\"['/entity-audit-event', entityAuditEvent.id ]\">{{entityAuditEvent.id}}</a></td>\n                <td>{{entityAuditEvent.entityType}}</td>\n                <td>{{entityAuditEvent.action}}</td>\n                <!--<td>{{ entityAuditEvent.entityValue}}</td>-->\n                <td>{{entityAuditEvent.commitVersion}}</td>\n                <td>{{entityAuditEvent.modifiedBy}}</td>\n                <td>{{entityAuditEvent.modifiedDate | date:'medium'}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"button\" (click)=\"viewValue(entityAuditEvent.entityValue)\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div *ngIf=\"entityAuditEvents && entityAuditEvents.length\">\n        <div class=\"row justify-content-center\">\n            <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n        </div>\n        <div class=\"row justify-content-center\">\n            <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" [pageSize]=\"itemsPerPage\"\n                            (pageChange)=\"loadPage(page)\"></ngb-pagination>\n        </div>\n    </div>\n</div>\n\n<p-dialog header=\"Valeur\" [(visible)]=\"valueDialog\" [responsive]=\"true\" [resizable]=\"true\" [closeOnEscape]=\"true\"\n          [dismissableMask]=\"true\"\n          showEffect=\"fade\" [modal]=\"true\" closable=\"true\">\n    <div class=\"ui-grid ui-grid-responsive ui-fluid\">\n        <pre style=\"max-height: 600px; overflow: auto;\"><code [innerHTML]=\"entityValue\"></code></pre>\n    </div>\n    <p-footer>\n        <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n            <button type=\"button\" class=\"btn btn-secondary\" icon=\"fa-close\" (click)=\"closeValueDialog()\"><span\n                jhiTranslate=\"entity.action.cancel\"></span></button>\n        </div>\n    </p-footer>\n</p-dialog>\n"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<!--suppress BadExpressionStatementJS -->\n<div *ngIf=\"candidatureAutorisee\">\n\n    <div class=\"spaceTitle\" *ngIf=\"cfOrdreModifiable?.length > 0 || cfEnCoursOuSupprimmee?.length > 0\"><span\n        jhiTranslate=\"cadensApp.espaceCandidat.home.title\"></span></div>\n    <br>\n    <div class=\"alert alert-info\" *ngIf=\"parametrage?.NEWS?.libelle != null\" [innerHTML]=\"parametrage?.NEWS?.libelle\">\n    </div>\n    <jhi-alert></jhi-alert>\n    <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n    <!-- tableau des candidature transmises-->\n    <div\n        *ngIf=\"(cfOrdreModifiable != null && cfOrdreModifiable.length) || (cfOrdreNonModifiable != null && cfOrdreNonModifiable.length > 0)\">\n        <h3 jhiTranslate=\"cadensApp.espaceCandidat.home.transmises\">mes candidatures transmises</h3>\n        <h6><span jhiTranslate=\"cadensApp.espaceCandidat.home.transmisesHow\">Mes candidature ...préférence</span>\n            <span (click)=\"openAide(aideDragDrop)\" class=\"fa fa-question-circle-o\"\n                  title=\"Cliquer\"></span></h6>\n        <!-- première liste transmises et ordre non modifiable -->\n        <div *ngIf=\"cfOrdreNonModifiable != null && cfOrdreNonModifiable.length > 0\">\n            <ul class=\"tableContainer candidatures\">\n                <li *ngFor=\"let candidatureFormation of cfOrdreNonModifiable\" class=\"row\"\n                    [id]=\"candidatureFormation.id\">\n                    <div class=\"icon col-md-1 \">\n                    <span class=\"text-success\" *ngIf=\"candidatureFormation.response === constants.SUCCESS\"><i\n                        class=\"fa fa-lock\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span class=\"text-danger\" *ngIf=\"candidatureFormation.response === constants.REJECTED\"><i\n                            class=\"fa fa-lock\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span class=\"text-warning\" *ngIf=\"candidatureFormation.response === constants.AWAITING\"><i\n                            class=\"fa fa-lock\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span *ngIf=\"candidatureFormation.response == null\"><i class=\"fa fa-lock\"\n                                                                               aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                    </div>\n                    <!-- Libelle de la candidature -->\n                    <div class=\"name col-md-4\">{{candidatureFormation?.libelle}}</div>\n                    <!--S'il y a une réponse, la REPONSE -->\n                    <div class=\"status col-md-2\" *ngIf=\"candidatureFormation.response != null\">\n                        <span class=\"row-statut statut-{{candidatureFormation.response}}\"\n                              jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.response}}\"></span>\n                        <!-- Gestion spécifique pour les ADMIS HORS ECHANGE avec bourse -->\n                        <div *ngIf=\"candidatureFormation.response === constants.SUCCESS\n                                    && candidatureFormation.ei === constants.HORS_ECHANGE\n                                    && candidatureFormation.indicBourseExcellence\">\n                            <span class=\"row-statut statut-{{ candidatureFormation.bourseExcellence ? 'OK' : 'REJECTED' }}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{ candidatureFormation.bourseExcellence ? 'SUCCES_WITH_BOURSE' : 'SUCCES_WITHOUT_BOURSE' }}\">\n                            </span>\n                        </div>\n                    </div>\n                    <!--Sinon s'il n'y a pas de réponse, le STATUT -->\n                    <div class=\"status col-md-2\" *ngIf=\"candidatureFormation.response == null\">\n                        <span jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.statut}}\"></span>\n                        <span class=\"progress\">\n                        <span class=\"progress-bar progress-bar-{{candidatureFormation.statut}}\"></span>\n                    </span>\n                    </div>\n                    <div class=\"date col-md-2\">\n                    <span\n                        jhiTranslate=\"cadensApp.candidature.transmittedOn\"></span>{{candidatureFormation.dateValidation\n                        | date: 'longDate'}}\n                    </div>\n                    <!-- REPONSE = ADMIS -->\n                    <div class=\"button col-md-10\" *ngIf=\"candidatureFormation.response === constants.SUCCESS && candidatureFormation.formation.venueConfirmable\">\n                        <!-- Affichage du bouton pour confirmer la venue si pas encore de réponse -->\n                        <!--DEBUT CHOIX ATTESTATION -->\n                        <div class=\"row form-group\" *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects === 180 \">\n                            <!-- && candidatureFormation.libelle.indexOf('2ème') > 0-->\n                            <!--choix 1: attestation sur honneur-->\n                            <div class=\"col-md-auto ui-radiobutton-check-top\">\n                                <p-radioButton name=\"choixConfirm\" id=\"choix1\" [value]=\"1\" (ngModelChange)=\"onChangeChoix($event)\"\n                                               class=\"ui-radiobutton-candidat\"\n                                               [(ngModel)]=\"candidatureFormation.choixConfirmation\" [ngModelOptions]=\"{standalone: true}\" jhiInputRequired required ></p-radioButton>\n                            </div>\n                            <div class=\"col-md-5 ui-radiobutton-candidat\">\n                                <label class=\"form-control-label label-attestation\"  for=\"choix1\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.CHOIX_CONFIRMATION_1.libelle : parametrage?.CHOIX_CONFIRMATION_1.libelleEn\"></label>\n                            </div>\n                            <!--choix 1: attestation de demission-->\n                            <div class=\"col-md-auto ui-radiobutton-check-top\">\n                                <p-radioButton name=\"choixConfirm\" id=\"choix2\"  [value]=\"2\"\n                                               [(ngModel)]=\"candidatureFormation.choixConfirmation\" (ngModelChange)=\"onChangeChoix($event)\"\n                                               [ngModelOptions]=\"{standalone: true}\" jhiInputRequired required ></p-radioButton>\n                            </div>\n                            <div class=\"col-md-5 ui-radiobutton-candidat\">\n                                <label class=\"form-control-label label-attestation\" for=\"choix2\"  [innerHTML]=\"currentLang === 'fr' ? parametrage?.CHOIX_CONFIRMATION_2.libelle : parametrage?.CHOIX_CONFIRMATION_2.libelleEn\"></label>\n                            </div>\n                        </div>\n                        <div *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects  === 180\">\n                            <!-- && candidatureFormation.libelle.indexOf('2ème') > 0 <div class=\"row\" *ngFor=\"let file of otherUploadedFiles; let idx = index\">-->\n                            <!-- Affichage du bouton pour confirmer la venue si pas encore de réponse et candidature ==180 ects -->\n                            <button (click)=\"addOtherPJ(otherPieceModalAttestation,null,candidatureFormation.choixConfirmation, candidatureFormation)\"\n                                    [disabled]=\"!isClickable\"\n                                    class=\"btn btn-info\" jhiTranslate=\"entity.action.confirm\">confirm2\n                            </button>\n                            <!--  </div>-->\n                        </div>\n                        <!--FIN-->\n                        <div *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects !== 180\">\n                            <!-- (candidatureFormation.ects !== 180 || (candidatureFormation.ects === 180 && candidatureFormation.libelle.indexOf('1ère') > 0))\n                            Affichage du bouton pour confirmer la venue si pas encore de réponse et candidature !=180 ects -->\n                            <button (click)=\"confirmResponse(candidatureFormation)\" [disabled]=\"!isEditable\"\n                                    class=\"btn btn-info\" jhiTranslate=\"entity.action.confirm\">confirm\n                            </button>\n                        </div>\n                        <!-- Affichage \"Venue confirmée\" si le candidat a confirmé sa venue -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.CONFIRMED\" class=\"btn btn-success\"\n                                jhiTranslate=\"cadensApp.candidature.status.CONFIRMED\">CONFIRMED\n                        </button>\n                        <!-- Affichage du bouton pour se désister si pas encore de réponse -->\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"desistResponse(candidatureFormation)\"\n                                class=\"btn btn-outline-danger\" jhiTranslate=\"entity.action.desist\">desist\n                        </button>\n                        <!-- Affichage \"Désistement confirmé\" si le candidat s'est désisté -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.DESISTED\"\n                                class=\"btn btn-outline-danger\"\n                                jhiTranslate=\"cadensApp.candidature.status.DESISTED\">DESISTED\n                        </button>\n                        <p *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"></p>\n                        <!-- Bouton pour imprimer l'attestation d'admission -->\n                        <button\n                            *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC==null\"\n                            (click)=\"genererLettreAdmission(candidatureFormation.id,constants.SUCCESS, false)\"\n                            class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAcceptation\" class=\"fa fa-file-text\"></span>\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation d'admission après LC -->\n                        <button\n                            *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC!=null\"\n                            (click)=\"genererLettreAdmission(candidatureFormation.id, constants.SUCCESS, true)\"\n                            class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAcceptationApresLC\"\n                                  class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- REPONSE = LISTE COMPLEMENTAIRE -->\n                    <div class=\"button col-md-3\" *ngIf=\"candidatureFormation.response === constants.AWAITING\">\n                        <!-- Affichage du rang sur la liste complémentaire -->\n                        <button *ngIf=\"candidatureFormation.responseRang != null\" class=\"btn btn-secondary\"><span\n                            jhiTranslate=\"cadensApp.candidature.rang\"></span>\n                            {{ candidatureFormation.responseRang }}\n                        </button>\n                        <!-- Affichage du bouton pour se désister  -->\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"desistResponse(candidatureFormation)\"\n                                class=\"btn btn-outline-danger\" jhiTranslate=\"entity.action.desist\">desist\n                        </button>\n                        <!-- Affichage \"Désistement confirmé\" si le candidat s'est désisté -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.DESISTED\"\n                                class=\"btn btn-outline-danger\"\n                                jhiTranslate=\"cadensApp.candidature.status.DESISTED\">DESISTED\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation de liste d'attente -->\n                        <p *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"></p>\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.AWAITING, false)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAttente\" class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- REPONSE = REFUS -->\n                    <div class=\"button col-md-3\" *ngIf=\"candidatureFormation.response === constants.REJECTED\">\n                        <!-- Bouton pour imprimer l'attestation de refus -->\n                        <button *ngIf=\"candidatureFormation.dateSortieLC ==null\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, false)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocRefus\" class=\"fa fa-file-text\"></span>\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation de refus après LC -->\n                        <button *ngIf=\"candidatureFormation.dateSortieLC!=null\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, true)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocRefusApresLC\" class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- Pas de réponse, STATUT -->\n                    <div class=\"button col-md-2\" *ngIf=\"candidatureFormation.response == null\">\n                        <button (click)=\"open(candidatureFormation.id)\" class=\"btn btn-outline-info\"\n                                jhiTranslate=\"cadensApp.espaceCandidat.home.{{candidatureFormation.statut}}Label\">Open\n                        </button>\n                    </div>\n                    <!-- Bouton poubelle supprimer -->\n                    <div class=\"icon col-md-1\" *ngIf=\"candidatureFormation.ordreModifiable==true\"\n                         (click)=\"delete(candidatureFormation.id)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n                    </div>\n                </li>\n            </ul>\n        </div>\n        <!-- deuxième liste transmises et ordre modifiable , on peut les drag&droper pour changer l'ordre de voeux -->\n        <div *ngIf=\"cfOrdreModifiable != null && cfOrdreModifiable.length\">\n            <ul class=\"tableContainer candidatures\"\n                pDroppable=\"cfOrdreModifiable\" (onDragEnter)=\"dragEnter($event)\" (onDrop)=\"drop($event)\" id=\"parentUL\">\n                <li *ngFor=\"let candidatureFormation of cfOrdreModifiable\" class=\"row\"\n                    [id]=\"candidatureFormation.id\"\n                    (pDraggable)=\"'cfOrdreModifiable'\" (onDragStart)=\"dragStart($event,candidatureFormation)\"\n                    (onDragEnd)=\"dragEnd($event)\">\n                    <div class=\"icon col-md-1 draggable\">\n                    <span class=\"text-success\" *ngIf=\"candidatureFormation.response === constants.SUCCESS\"><i\n                        class=\"fa fa-hand-paper-o\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span class=\"text-danger\" *ngIf=\"candidatureFormation.response === constants.REJECTED\"><i\n                            class=\"fa fa-hand-paper-o\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span class=\"text-warning\" *ngIf=\"candidatureFormation.response === constants.AWAITING\"><i\n                            class=\"fa fa-hand-paper-o\" aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                        <span *ngIf=\"candidatureFormation.response == null\"><i class=\"fa fa-hand-paper-o\"\n                                                                               aria-hidden=\"true\"></i> {{candidatureFormation.ordre}}</span>\n                    </div>\n                    <!-- Libelle de la candidature -->\n                    <div class=\"name col-md-4\">{{candidatureFormation?.libelle}}</div>\n                    <!--S'il y a une réponse, la REPONSE -->\n                    <div class=\"status col-md-2\" *ngIf=\"candidatureFormation.response != null\">\n                        <span class=\"row-statut statut-{{candidatureFormation.response}}\"\n                              jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.response}}\"></span>\n\n                        <!-- Gestion spécifique pour les ADMIS HORS ECHANGE avec bourse -->\n                        <div *ngIf=\"candidatureFormation.response === constants.SUCCESS\n                                    && candidatureFormation.ei === constants.HORS_ECHANGE\n                                    && candidatureFormation.indicBourseExcellence\">\n                            <span class=\"row-statut statut-{{ candidatureFormation.bourseExcellence ? 'OK' : 'REJECTED' }}\"\n                                  jhiTranslate=\"cadensApp.candidature.status.{{ candidatureFormation.bourseExcellence ? 'SUCCES_WITH_BOURSE' : 'SUCCES_WITHOUT_BOURSE' }}\">\n                            </span>\n                        </div>\n\n\n                    </div>\n                    <!--Sinon s'il n'y a pas de réponse, le STATUT -->\n                    <div class=\"status col-md-2\" *ngIf=\"candidatureFormation.response == null\">\n                        <span jhiTranslate=\"cadensApp.candidature.status.{{candidatureFormation.statut}}\"></span>\n                        <span class=\"progress\">\n                        <span class=\"progress-bar progress-bar-{{candidatureFormation.statut}}\"></span>\n                    </span>\n                    </div>\n                    <div class=\"date col-md-2\">\n                        <span\n                            jhiTranslate=\"cadensApp.candidature.transmittedOn\"></span>{{candidatureFormation.dateValidation\n                        | date: 'longDate'}}\n                    </div>\n                    <!-- REPONSE = ADMIS -->\n                    <div class=\"button col-md-10\" *ngIf=\"candidatureFormation.response === constants.SUCCESS && candidatureFormation.formation.venueConfirmable\">\n                        <!-- Affichage du bouton pour confirmer la venue si pas encore de réponse -->\n                        <!--DEBUT CHOIX ATTESTATION -->\n                        <div class=\"row form-group\" *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects === 180\">\n                            <!--&& candidatureFormation.libelle.indexOf('2ème') > 0 -->\n                            <!--choix 1: attestation sur honneur-->\n                            <div class=\"col-md-auto ui-radiobutton-check-top\">\n                                <p-radioButton name=\"choixConfirm\" id=\"choix1\" [value]=\"1\" (ngModelChange)=\"onChangeChoix($event)\"\n                                               class=\"ui-radiobutton-candidat\"\n                                               [(ngModel)]=\"candidatureFormation.choixConfirmation\" [ngModelOptions]=\"{standalone: true}\" jhiInputRequired required ></p-radioButton>\n                            </div>\n                            <div class=\"col-md-5 ui-radiobutton-candidat\">\n                                <label class=\"form-control-label label-attestation\"  for=\"choix1\" [innerHTML]=\"currentLang === 'fr' ? parametrage?.CHOIX_CONFIRMATION_1.libelle : parametrage?.CHOIX_CONFIRMATION_1.libelleEn\"></label>\n                            </div>\n                            <!--choix 1: attestation de demission-->\n                            <div class=\"col-md-auto ui-radiobutton-check-top\">\n                                <p-radioButton name=\"choixConfirm\" id=\"choix2\"  [value]=\"2\"\n                                               [(ngModel)]=\"candidatureFormation.choixConfirmation\" (ngModelChange)=\"onChangeChoix($event)\"\n                                               [ngModelOptions]=\"{standalone: true}\" jhiInputRequired required ></p-radioButton>\n                            </div>\n                            <div class=\"col-md-5 ui-radiobutton-candidat\">\n                                <label class=\"form-control-label label-attestation\" for=\"choix2\"  [innerHTML]=\"currentLang === 'fr' ? parametrage?.CHOIX_CONFIRMATION_2.libelle : parametrage?.CHOIX_CONFIRMATION_2.libelleEn\"></label>\n                            </div>\n                        </div>\n                        <div *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects  === 180\">\n                            <!-- && candidatureFormation.libelle.indexOf('2ème') > 0 <div class=\"row\" *ngFor=\"let file of otherUploadedFiles; let idx = index\">-->\n                            <!-- Affichage du bouton pour confirmer la venue si pas encore de réponse et candidature ==180 ects -->\n                            <button (click)=\"addOtherPJ(otherPieceModalAttestation,null,candidatureFormation.choixConfirmation, candidatureFormation)\"\n                                    [disabled]=\"!isClickable\"\n                                    class=\"btn btn-info\" jhiTranslate=\"entity.action.confirm\">confirm2\n                            </button>\n                            <!--  </div>-->\n                        </div>\n                        <!--FIN-->\n                        <div *ngIf=\"candidatureFormation.statut === constants.FINISHED && candidatureFormation.ects !== 180\">\n                            <!--(candidatureFormation.ects !== 180 || (candidatureFormation.ects === 180 && candidatureFormation.libelle.indexOf('1ère') > 0))\n                             Affichage du bouton pour confirmer la venue si pas encore de réponse et candidature !=180 ects -->\n                            <button (click)=\"confirmResponse(candidatureFormation)\" [disabled]=\"!isEditable\"\n                                    class=\"btn btn-info\" jhiTranslate=\"entity.action.confirm\">confirm\n                            </button>\n                        </div>\n                        <!-- Affichage \"Venue confirmée\" si le candidat a confirmé sa venue -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.CONFIRMED\" class=\"btn btn-success\"\n                                jhiTranslate=\"cadensApp.candidature.status.CONFIRMED\">CONFIRMED\n                        </button>\n                        <!-- Affichage du bouton pour se désister si pas encore de réponse -->\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"desistResponse(candidatureFormation)\"\n                                class=\"btn btn-outline-danger\" jhiTranslate=\"entity.action.desist\">desist\n                        </button>\n                        <!-- Affichage \"Désistement confirmé\" si le candidat s'est désisté -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.DESISTED\"\n                                class=\"btn btn-outline-danger\"\n                                jhiTranslate=\"cadensApp.candidature.status.DESISTED\">DESISTED\n                        </button>\n                        <p *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"></p>\n                        <!-- Bouton pour imprimer l'attestation d'admission -->\n                        <button\n                            *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC==null\"\n                            (click)=\"genererLettreAdmission(candidatureFormation.id,constants.SUCCESS, false)\"\n                            class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAcceptation\" class=\"fa fa-file-text\"></span>\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation d'admission après LC -->\n                        <button\n                            *ngIf=\"candidatureFormation.statut !== constants.DESISTED && candidatureFormation.dateSortieLC!=null\"\n                            (click)=\"genererLettreAdmission(candidatureFormation.id, constants.SUCCESS, true)\"\n                            class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAcceptationApresLC\"\n                                  class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- REPONSE = LISTE COMPLEMENTAIRE -->\n                    <div class=\"button col-md-3\" *ngIf=\"candidatureFormation.response === constants.AWAITING\">\n                        <!-- Affichage du rang sur la liste complémentaire -->\n                        <button *ngIf=\"candidatureFormation.responseRang != null\" class=\"btn btn-secondary\"><span\n                            jhiTranslate=\"cadensApp.candidature.rang\"></span>\n                            {{ candidatureFormation.responseRang }}\n                        </button>\n                        <!-- Affichage du bouton pour se désister  -->\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"desistResponse(candidatureFormation)\"\n                                class=\"btn btn-outline-danger\" jhiTranslate=\"entity.action.desist\">desist\n                        </button>\n                        <!-- Affichage \"Désistement confirmé\" si le candidat s'est désisté -->\n                        <button *ngIf=\"candidatureFormation.statut === constants.DESISTED\"\n                                class=\"btn btn-outline-danger\"\n                                jhiTranslate=\"cadensApp.candidature.status.DESISTED\">DESISTED\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation de liste d'attente -->\n                        <p *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"></p>\n                        <button *ngIf=\"candidatureFormation.statut !== constants.DESISTED\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.AWAITING, false)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocAttente\" class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- REPONSE = REFUS -->\n                    <div class=\"button col-md-3\" *ngIf=\"candidatureFormation.response === constants.REJECTED\">\n                        <!-- Bouton pour imprimer l'attestation de refus -->\n                        <button *ngIf=\"candidatureFormation.dateSortieLC ==null\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, false)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocRefus\" class=\"fa fa-file-text\"></span>\n                        </button>\n                        <!-- Bouton pour imprimer l'attestation de refus après LC -->\n                        <button *ngIf=\"candidatureFormation.dateSortieLC!=null\"\n                                (click)=\"genererLettreAdmission(candidatureFormation.id, constants.REJECTED, true)\"\n                                class=\"btn btn-outline-info\">\n                            <span jhiTranslate=\"entity.action.genererDocRefusApresLC\" class=\"fa fa-file-text\"></span>\n                        </button>\n                    </div>\n                    <!-- Pas de réponse, STATUT -->\n                    <div class=\"button col-md-2\" *ngIf=\"candidatureFormation.response == null\">\n                        <button (click)=\"open(candidatureFormation.id)\" class=\"btn btn-outline-info\"\n                                jhiTranslate=\"cadensApp.espaceCandidat.home.{{candidatureFormation.statut}}Label\">Open\n                        </button>\n                    </div>\n                    <!-- Bouton poubelle supprimer -->\n                    <div class=\"icon col-md-1\" *ngIf=\"candidatureFormation.response == null\"\n                         (click)=\"delete(candidatureFormation.id)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <!-- Deuxième tableau des candidature en cours ou supprimées -->\n    <div *ngIf=\"cfEnCoursOuSupprimmee != null && cfEnCoursOuSupprimmee.length > 0\">\n        <h3 jhiTranslate=\"cadensApp.espaceCandidat.home.encours\">mes candidatures en cours ou supprimées</h3>\n        <ul class=\"tableContainer candidatures\">\n            <li *ngFor=\"let candi of cfEnCoursOuSupprimmee\" class=\"row\"\n                [ngClass]=\"{'alert-danger': candi.statut === constants.REJECTED || candi.dateSuppression != null,\n                         'alert-warning': candi.statut === constants.AWAITING}\">\n                <div class=\"icon col-md-1\" *ngIf=\"candi.statut === constants.CREATED\">\n                    <i class=\"fa fa-file-o\" aria-hidden=\"true\"></i>\n                </div>\n                <div class=\"icon col-md-1\" *ngIf=\"candi.statut === constants.AWAITING\"><i\n                    class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i></div>\n                <div class=\"icon col-md-1\" *ngIf=\"candi.statut === constants.REJECTED\"><i class=\"fa fa-ban\"\n                                                                                          aria-hidden=\"true\"></i></div>\n                <div class=\"icon col-md-1\" *ngIf=\"candi.dateSuppression != null\"><i class=\"fa fa-ban\"\n                                                                                    aria-hidden=\"true\"></i></div>\n                <div class=\"name col-md-4\" *ngIf=\"candi.libelle\">{{candi.libelle}}</div>\n                <div class=\"name col-md-4\" *ngIf=\"!candi.libelle\"><span\n                    jhiTranslate=\"cadensApp.candidature.nouvelle\"></span></div>\n                <div class=\"status col-md-2\">\n                    <span jhiTranslate=\"cadensApp.candidature.status.{{candi.statut}}\"></span>\n                    <span class=\"progress\" *ngIf=\"candi.statut === constants.CREATED\">\n                        <span class=\"progress-bar progress-bar-{{candi.pageEdition}}\"></span>\n                    </span>\n                </div>\n                <div class=\"date col-md-2\" *ngIf=\"candi.dateSuppression == null\">\n                    <span jhiTranslate=\"cadensApp.candidature.createdOn\"></span>{{candi.dateCreation | date:\n                    'longDate'}}\n                </div>\n                <div class=\"date col-md-2\" *ngIf=\"candi.dateSuppression != null\">\n                    <span jhiTranslate=\"cadensApp.candidature.deletedOn\"></span>{{candi.dateSuppression | date:\n                    'longDate'}}\n                </div>\n                <div class=\"button col-md-1\"\n                     *ngIf=\"candi.statut === constants.CREATED && candi.dateSuppression == null\">\n                    <button (click)=\"open(candi.id)\" class=\"btn btn-outline-info\"\n                            jhiTranslate=\"cadensApp.espaceCandidat.home.{{candi.statut}}Label\">Open\n                    </button>\n                </div>\n                <div class=\" col-md-1\" *ngIf=\"candi.statut === constants.CREATED && candi.dateSuppression == null\"\n                     (click)=\"delete(candi.id)\"><i class=\"fa fa-trash-o float-right\" aria-hidden=\"true\"></i></div>\n            </li>\n        </ul>\n    </div>\n    <div\n        *ngIf=\"(cfOrdreModifiable == null || cfOrdreModifiable?.length == 0) && (cfEnCoursOuSupprimmee == null || cfEnCoursOuSupprimmee?.length == 0)\">\n        <div class=\"nocandidature\"></div>\n        <div class=\"spaceTitle nospace\"\n             [innerHTML]=\"currentLang === 'fr' ? parametrage?.AUCUNE_CANDIDATURE.libelle : parametrage?.AUCUNE_CANDIDATURE.libelleEn\"></div>\n    </div>\n    <div class=\"nospace text-sm-center\">\n        <button *ngIf=\"formationsOpen\" (click)=\"open(0)\" class=\"btn btn-primary\"\n                jhiTranslate=\"cadensApp.espaceCandidat.home.createLabel\">Create\n        </button>\n        <div *ngIf=\"!formationsOpen\" class=\"spaceTitle nospace\"\n             [innerHTML]=\"currentLang === 'fr' ? parametrage?.AUCUNE_CAMPAGNE_OUVERTE.libelle : parametrage?.AUCUNE_CAMPAGNE_OUVERTE.libelleEn\"></div>\n        <button (click)=\"openAide(aideModal)\" class=\"btn btn-default\" jhiTranslate=\"global.help\">Help</button>\n    </div>\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cd>\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cd.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.confirm' | translate\"\n                    (click)=\"cd.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n    <p-confirmDialog width=\"425\" icon=\"fa fa-trash\" #cdc key=\"confirmDelete\">\n        <p-footer>\n            <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                    (click)=\"cdc.reject()\"></button>\n            <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.delete' | translate\"\n                    (click)=\"cdc.accept()\"></button>\n        </p-footer>\n    </p-confirmDialog>\n</div>\n<div *ngIf=\"!candidatureAutorisee\">\n    <div class=\"nospace text-sm-center\">\n        <div class=\"spaceTitle nospace\"\n             [innerHTML]=\"currentLang === 'fr' ? parametrage?.ENS_CANDIDATURE_INTERDITE.libelle : parametrage?.ENS_CANDIDATURE_INTERDITE.libelleEn\"></div>\n    </div>\n</div>\n<template #aideModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.action.help\">Aide</h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p *ngIf=\"!reinscription\"\n           [innerHTML]=\"currentLang === 'fr' ? parametrage?.ESPACE_AIDE?.libelle : parametrage?.ESPACE_AIDE?.libelleEn\"></p>\n        <p *ngIf=\"reinscription\"\n           [innerHTML]=\"currentLang === 'fr' ? parametrage?.ESPACE_AIDE_REINSCRIPTION?.libelle : parametrage?.ESPACE_AIDE_REINSCRIPTION?.libelleEn\"></p>\n        <button *ngIf=\"nomFichierAide!=null\" type=\"submit\" (click)=\"openFichierAide()\"\n                class=\"btn btn-primary\">\n            <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n            <span jhiTranslate=\"cadensApp.espaceCandidat.home.telechargerFichierAide\">Save</span>\n        </button>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\">Close</button>\n    </div>\n</template>\n<template #aideDragDrop let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.action.help\">Aide</h4>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <p\n            [innerHTML]=\"currentLang === 'fr' ? parametrage?.AIDE_DRAGDROP?.libelle : parametrage?.AIDE_DRAGDROP?.libelleEn\"></p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"c('Close click')\">Close</button>\n    </div>\n</template>\n<template #otherPieceModalAttestation>\n    <div class=\"modal-header\">\n        <div *ngIf=\"choixConfirmation === 1\">\n            <h4  jhiTranslate=\"cadensApp.espaceCandidat.home.attestationHonneur\">Télécharger Attestation</h4>\n        </div>\n        <div *ngIf=\"choixConfirmation === 2\">\n            <h4  jhiTranslate=\"cadensApp.espaceCandidat.home.attestationDemission\">Télécharger Attestation  de démission</h4>\n        </div>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"closeOtherPJ()\">\n            <span class=\"fa fa-times\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <!-- <div class=\"row\" *ngFor=\"let file of otherUploadedFiles; let idx = index\">-->\n        <div class=\"name col-md-12\">{{candidatureFormation?.libelle}}</div>\n        <div class=\"row form-group\">\n           <!-- <div class=\"name col-md-12 div-upload-margin-1\" *ngIf=\"choixConfirmation === 1\">\n                <input type=\"text\" class=\"form-control\" id=\"notes1\" [maxlength]=\"255\" name=\"notes\"\n                       jhiTranslate=\"cadensApp.espaceCandidat.home.attestationHonneur\"\n                       [(ngModel)]=\"otherUploadedFiles[lastIdx].notes\" value=\"TEST1\">\n            </div>\n            <div class=\"name col-md-12 div-upload-margin-1\" *ngIf=\"choixConfirmation === 2\">\n                <input type=\"text\" class=\"form-control\" id=\"notes2\" [maxlength]=\"255\" name=\"notes\"\n                       jhiTranslate=\"cadensApp.espaceCandidat.home.attestationDemission\"\n                       [(ngModel)]=\"otherUploadedFiles[lastIdx].notes\" value=\"TEST2\">\n            </div>-->\n            <div class=\"name col-md-12 div-upload-margin-15\">\n                <p-fileUpload [name]=\"otherUploadedFiles[lastIdx]?.nom\" url=\"./api/upload\" auto=\"auto\" withCredentials=\"true\"\n                              class=\"row\"\n                              (onBeforeSend)=\"onBeforeSend($event)\" (onBeforeUpload)=\"onBeforeUpload($event, 1)\"\n                              (onUpload)=\"onOtherFileUploaded($event)\" [maxFileSize]=\"32000000\" (onError)=\"onError($event)\"\n                              chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                              uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                              cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n                    <template pTemplate=\"content\" type=\"content\">\n                        <a (click)=\"openFile(otherUploadedFiles[lastIdx]?.nom)\">{{ otherUploadedFiles[lastIdx]?.nom }}</a>\n                    </template>\n                </p-fileUpload>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveOtherPJ(otherPieceModalAttestation,this.choixConfirmation)\"\n                jhiTranslate=\"entity.action.save\">Modifier\n        </button>\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"closeOtherPJ()\" jhiTranslate=\"entity.action.cancel\">\n            Close\n        </button>\n        <!--<button *ngIf=\"otherUploadedFiles[lastIdx].id != null\" type=\"button\" class=\"btn btn-danger\" icon=\"fa-check\"\n                (click)=\"deleteOtherPJ()\"><span jhiTranslate=\"entity.action.delete\"></span></button>-->\n    </div>\n</template>\n"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-10 offset-md-1\">\n    <h1 jhiTranslate=\"cadensApp.faq.title\">faq</h1>\n\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <select class=\"form-control\" id=\"objet\" [(ngModel)]=\"parametrage\" name=\"objet\">\n                <option *ngFor=\"let param of parametrages\" [ngValue]=\"param\">{{ param.objet }}</option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"card\" *ngIf=\"parametrage != null\">\n        <h2>{{ currentLang === 'fr' || parametrage.objetEn == null ? parametrage.objet : parametrage.objetEn }}</h2>\n        <p [innerHTML]=\"currentLang === 'fr' || parametrage.libelleEn == null ? parametrage.libelle : parametrage.libelleEn\"></p>\n    </div>\n</div>"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(formation.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"cadensApp.formation.delete.question\" translateValues=\"{id: '{{formation.id}}'}\">Are you sure you want to delete this Formation?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\" *ngIf=\"formationListe\">\n    <div class=\"spaceNavigation\">\n        <div class=\"title\">\n            <a class=\"piped\" (click)=\"backToListe()\"><i class=\"fa fa-long-arrow-left\" aria-hidden=\"true\"></i></a>\n            <h1 jhiTranslate=\"global.menu.gestionnaire.formations\">formations</h1>\n        </div>\n    </div>\n    <jhi-spinner [display]=\"reloading\"></jhi-spinner>\n\n    <div class=\"row no-gutters\">\n        <div class=\"col-sm-3\">\n            <ul id=\"sidebar\" class=\"nav flex-column affix\">\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('informations')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'informations'}\">\n                        <span jhiTranslate=\"cadensApp.formation.informations\">informations</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('pieces')\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === 'pieces'}\">\n                        <span jhiTranslate=\"cadensApp.formation.pieces\">pieces</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('questions')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'questions'}\">\n                        <span jhiTranslate=\"cadensApp.formation.questions\">questions</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('gestionFormation')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'gestionFormation'}\">\n                        <span jhiTranslate=\"cadensApp.formation.gestion\">gestion</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('listec')\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === 'listec'}\">\n                        <span jhiTranslate=\"cadensApp.formation.listeComplementaire\">liste</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep('demandeModif')\" class=\"sidebar-link\"\n                       [ngClass]=\"{active: pageEdition === 'demandeModif'}\">\n                        <span jhiTranslate=\"cadensApp.formation.demandeModif\">demande modification</span></a>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"col-sm-9 content\">\n            <form id=\"form\" name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #registerForm=\"ngForm\" data-toggle=\"validator\">\n                <div>\n                    <jhi-spinner [display]=\"reloading\"></jhi-spinner>\n                    <h1 jhiTranslate=\"cadensApp.formation.informations\" id=\"informations\">informations</h1>\n\n                    <fieldset [disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation \">\n\n                        <div class=\"list-group formations\">\n                            <span *ngFor=\"let ff of formationListe\">\n                                <button type=\"button\" class=\"list-group-item list-group-item-action\"\n                                        (click)=\"onClickOnFormation(ff)\"\n                                        [ngClass]=\"{active: ff.id === formation.id }\">{{ ff.libelle }}</button>\n                                <!--, 'list-group-item-info': ff.id !== null-->\n                            </span>\n                        </div>\n                        <div>\n                            <div class=\"form-group\" *ngIf=\"formation.id != null\">\n                                <label for=\"libelle\" jhiTranslate=\"cadensApp.formation.libelle\">libelle</label>\n                                <input [disabled]=\"currentLang != 'fr'\" type=\"text\" class=\"form-control\"\n                                       jhiInputRequired required id=\"libelle\"\n                                       [(ngModel)]=\"formation.libelle\" name=\"libelle\">\n                            </div>\n\n                            <div class=\"form-group\" *ngIf=\"formation.id != null\">\n                                <label for=\"libelleCourt\"\n                                       jhiTranslate=\"cadensApp.formation.libelleCourt\">libelle</label>\n                                <input [disabled]=\"currentLang != 'fr'\" type=\"text\" class=\"form-control\"\n                                       id=\"libelleCourt\"\n                                       [(ngModel)]=\"formation.libelleCourt\" name=\"libelleCourt\">\n                            </div>\n\n                            <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                <label for=\"nombreReferents\" jhiTranslate=\"cadensApp.formation.nombreReferents\">nombreReferents</label>\n                                <input type=\"number\" class=\"form-control\" id=\"nombreReferents\" min=\"0\"\n                                       [(ngModel)]=\"formation.nombreReferents\" name=\"nombreReferents\">\n                            </div>\n\n                            <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                <label for=\"nombreReferentsContact\"\n                                       jhiTranslate=\"cadensApp.formation.nombreReferentsContact\">nombreReferentsContact</label>\n                                <input type=\"number\" class=\"form-control\" id=\"nombreReferentsContact\"\n                                       [(ngModel)]=\"formation.nombreReferentsContact\" name=\"nombreReferentsContact\">\n                            </div>\n                            <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                <label for=\"nombreReferentsObligatoires\"\n                                       jhiTranslate=\"cadensApp.formation.nombreReferentsObligatoires\">nombreReferentsObligatoires</label>\n                                <input type=\"number\" class=\"form-control\" id=\"nombreReferentsObligatoires\" min=\"0\" [max]=\"formation.nombreReferents\"\n                                       [(ngModel)]=\"formation.nombreReferentsObligatoires\" name=\"nombreReferentsObligatoires\">\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset [disabled]=\"!uniquementMajPlacesFormation\">\n                        <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                            <label for=\"nombrePlaces\"\n                                   jhiTranslate=\"cadensApp.formation.nombrePlaces\">nombrePlaces</label>\n                            <input type=\"number\" class=\"form-control\" id=\"nombrePlaces\" min=\"0\"\n                                   [(ngModel)]=\"formation.nombrePlaces\" name=\"nombrePlaces\">\n                        </div>\n                    </fieldset>\n                    <div>\n                        <fieldset [disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation\">\n                            <!-- <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                 <label for=\"totalAdmis\"\n                                        jhiTranslate=\"cadensApp.formation.totalAdmis\">totalAdmis</label>\n                                 <input type=\"number\" class=\"form-control\" id=\"totalAdmis\" min=\"0\" disabled=\"true\"\n                                        [(ngModel)]=\"formation.totalAdmis\" name=\"totalAdmis\">\n                             </div>\n\n\n                             <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                 <label for=\"totalConfirme\"\n                                        jhiTranslate=\"cadensApp.formation.totalConfirme\">totalConfirme</label>\n                                 <input type=\"number\" class=\"form-control\" id=\"totalConfirme\" min=\"0\" disabled=\"true\"\n                                        [(ngModel)]=\"formation.totalConfirme\" name=\"totalConfirme\">\n                              </div>\n                              <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                 <label for=\"totalLc\"\n                                        jhiTranslate=\"cadensApp.formation.totalDesiste\">totalDesiste</label>\n                                 <input type=\"number\" class=\"form-control\" id=\"totalDesiste\" min=\"0\" disabled=\"true\"\n                                        [(ngModel)]=\"formation.totalDesiste\" name=\"totalDesiste\">\n                              </div>\n                             <div class=\"form-group col-sm-3\" *ngIf=\"formation.id != constants.ECHANGE_INTERNATIONAL_ID\">\n                                 <label for=\"totalLc\"\n                                        jhiTranslate=\"cadensApp.formation.totalLc\">totalLc</label>\n                                 <input type=\"number\" class=\"form-control\" id=\"totalLc\" min=\"0\" disabled=\"true\"\n                                        [(ngModel)]=\"formation.totalLc\" name=\"totalLc\">\n                             </div>-->\n\n                            <div class=\"form-group col-sm-3\">\n                                <label for=\"suppression\"\n                                       jhiTranslate=\"cadensApp.formation.suppression\">suppression</label>\n                                <p-inputSwitch\n                                    [disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation || (this.formationUtiliseeDansCampagnefuture && this.formation.dateSuppression == null)\"\n                                    class=\"d-block\"\n                                    [onLabel]=\"'entity.action.activated' | translate\"\n                                    [offLabel]=\"'entity.action.deactivated' | translate\"\n                                    name=\"suppression\" id=\"suppression\"\n                                    [ngModel]=\"isDeleted(formation)\"\n                                    (ngModelChange)=\"onChangeSuppression($event)\"\n                                ></p-inputSwitch>\n                            </div>\n                            <div class=\"form-group col-sm-3 text-info\" *ngIf=\"formation.dateSuppression!=null\">\n                                <span jhiTranslate=\"cadensApp.formation.dateSuppression\"> </span>\n                                {{formation.dateSuppression | date: 'longDate'}}\n                            </div>\n                            <div class=\"form-group col-sm-3 text-info\"\n                                 *ngIf=\"formationUtiliseeDansCampagnefuture==true\">\n                                <span jhiTranslate=\"cadensApp.formation.utiliseeDansCampagneFuture\"> </span>\n                            </div>\n                        </fieldset>\n                        <div *ngIf=\"(formation.id == null && formationListe.length > 1) || formationListe.length === 1\">\n                            <hr/>\n                            <h1 jhiTranslate=\"cadensApp.formation.pieces\" id=\"pieces\">Pièces</h1>\n                            <label jhiTranslate=\"cadensApp.formation.piece.more\">Pièces</label>\n                            <!--[disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation \"-->\n                            <jhi-piece-component [(pieces)]=\"pieces\"\n                                                 *ngIf=\"pieces\" [currentLang]=\"currentLang\"\n\n                                                 [isOnlyEnseignant]=\"isOnlyEnseignant\">\n                            </jhi-piece-component>\n                        </div>\n                        <fieldset [disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation \">\n                            <div *ngIf=\"formation.id != null\">\n                                <hr/>\n                                <h1 jhiTranslate=\"cadensApp.formation.questions\" id=\"questions\">questions</h1>\n                                <jhi-question-component [(questions)]=\"questions\"\n                                                        *ngIf=\"questions\" [currentLang]=\"currentLang\"\n                                                        [disabled]=\"uniquementDemandeModif || isOnlyResponsableFormation \"></jhi-question-component>\n                            </div>\n                        </fieldset>\n                    </div>\n\n                    <hr/>\n                    <h1 jhiTranslate=\"cadensApp.formation.gestion\" id=\"gestionFormation\">gestion</h1>\n\n                    <div class=\"form-group\">\n                        <label jhiTranslate=\"cadensApp.formation.referent\">Referents de la formation</label>\n                        <jhi-link-user-component (onErrorEvent)=\"errorEventChange($event)\"\n                                                 [(linkedUsers)]=\"formation.users\"></jhi-link-user-component>\n                    </div>\n\n\n                    <div class=\"form-group\">\n                        <label jhiTranslate=\"cadensApp.formation.lecteurs\">Enseignants lecteurs</label>\n                        <jhi-link-user-component (onErrorEvent)=\"errorEventChange($event)\"\n                                                 [(linkedUsers)]=\"formation.lecteurs\"></jhi-link-user-component>\n                    </div>\n\n                    <div>\n\n                        <div class=\"form-group col-sm-3\">\n                            <label for=\"avecPreavis\"\n                                   jhiTranslate=\"cadensApp.formation.avecPreavis\">Avec préavis</label>\n                            <p-inputSwitch class=\"d-block\"\n                                           [disabled]=\"uniquementDemandeModif\"\n                                           [onLabel]=\"'entity.action.activated' | translate\"\n                                           [offLabel]=\"'entity.action.deactivated' | translate\"\n                                           name=\"avecPreavis\" id=\"avecPreavis\"\n                                           [(ngModel)]=\"formation.avecPreavis\"></p-inputSwitch>\n                        </div>\n\n                        <fieldset [disabled]=\"uniquementDemandeModif && !isResponsableFormation\">\n\n                            <div class=\"form-group col-sm-6\">\n                                <label for=\"services\" jhiTranslate=\"cadensApp.formation.service.title\">service gérant de\n                                    la formation</label>\n                                <select class=\"form-control\" id=\"services\" [(ngModel)]=\"formation.serviceId\"\n                                        name=\"services\">\n                                    <option value=\"\"></option>\n                                    <option *ngFor=\"let service of services\" [ngValue]=\"service.id\">\n                                        {{service.libelle}}\n                                    </option>\n                                </select>\n                            </div>\n\n                            <hr/>\n                            <h1 jhiTranslate=\"cadensApp.formation.listeComplementaire\" id=\"listec\" *ngIf=\"isAdmin || isGestionnaire || isResponsableFormation\">listeComplementaire</h1>\n                            <div class=\"row\" *ngIf=\"isAdmin || isGestionnaire || isResponsableFormation\">\n                                <div class=\"form-group col-sm-3\">\n                                    <label for=\"listeComplementaire\"\n                                           jhiTranslate=\"cadensApp.formation.listeComplementaire2\">listeComplementaire</label>\n                                    <p-inputSwitch [disabled]=\"!this.isAdmin\"\n                                                   class=\"d-block\"\n                                                   [onLabel]=\"'entity.action.activated' | translate\"\n                                                   [offLabel]=\"'entity.action.deactivated' | translate\"\n                                                   name=\"listeComplementaire\" id=\"listeComplementaire\"\n                                                   [(ngModel)]=\"formation.lc\"\n                                                   (ngModelChange)=\"onChangeLc($event)\"></p-inputSwitch>\n                                </div>\n                                <div class=\"form-group col-sm-3\" *ngIf=\"formation.lc === true\">\n                                    <label for=\"rang\" jhiTranslate=\"cadensApp.formation.rang\">rang</label>\n                                    <p-inputSwitch [disabled]=\"!this.isAdmin\"\n                                                   class=\"d-block\"\n                                                   [onLabel]=\"'entity.action.activated' | translate\"\n                                                   [offLabel]=\"'entity.action.deactivated' | translate\"\n                                                   name=\"rang\" id=\"rang\" [(ngModel)]=\"formation.rang\"\n                                                   (ngModelChange)=\"onChangeRang($event)\"></p-inputSwitch>\n                                </div>\n                                <div class=\"form-group col-sm-3\"\n                                     *ngIf=\"formation.rang === true && formation.lc === true\">\n                                    <label for=\"affichageRang\" jhiTranslate=\"cadensApp.formation.affichageRang\">affichageRang</label>\n                                    <p-inputSwitch [disabled]=\"!this.isAdmin\"\n                                                   class=\"d-block\"\n                                                   [onLabel]=\"'entity.action.activated' | translate\"\n                                                   [offLabel]=\"'entity.action.deactivated' | translate\"\n                                                   name=\"affichageRang\" id=\"affichageRang\"\n                                                   [(ngModel)]=\"formation.affichageRang\"></p-inputSwitch>\n                                </div>\n                                <div class=\"form-group col-sm-3\"\n                                     *ngIf=\"formation.rang === true && formation.lc === true\">\n                                    <label for=\"rangAuto\" jhiTranslate=\"cadensApp.formation.rangAuto\">Rang\n                                        auto</label>\n                                    <p-inputSwitch [disabled]=\"!this.isAdmin\"\n                                                   class=\"d-block\"\n                                                   [onLabel]=\"'entity.action.activated' | translate\"\n                                                   [offLabel]=\"'entity.action.deactivated' | translate\"\n                                                   name=\"rangAuto\" id=\"rangAuto\"\n                                                   [(ngModel)]=\"formation.rangAuto\"></p-inputSwitch>\n                                </div>\n                            </div>\n                            <div class=\"row\" *ngIf=\"formation.rang === true && formation.lc === true && formation.rangAuto === true && isAdmin\">\n                                <div class=\"form-group col-sm-3\">\n                                    <label for=\"surbooking\" jhiTranslate=\"cadensApp.formation.surbooking\">Surbooking</label>\n                                    <p-inputSwitch class=\"d-block\"\n                                                   [onLabel]=\"'entity.action.activated' | translate\"\n                                                   [offLabel]=\"'entity.action.deactivated' | translate\"\n                                                   name=\"surbooking\" id=\"surbooking\"\n                                                   [(ngModel)]=\"formation.surbooking\"></p-inputSwitch>\n                                </div>\n                                <div class=\"form-group col-sm-3\" *ngIf=\"formation.surbooking === true\">\n                                    <label for=\"nbPlacesSurbooking\" jhiTranslate=\"cadensApp.formation.nbPlacesSurbooking\">\n                                        Nb places surbooking</label>\n                                    <input type=\"number\" class=\"form-control\" id=\"nbPlacesSurbooking\" min=\"0\"\n                                           [(ngModel)]=\"formation.nbPlacesSurbooking\" name=\"nbPlacesSurbooking\">\n                                </div>\n                                <div class=\"form-group col-sm-3\" *ngIf=\"formation.surbooking === true\">\n                                    <label for=\"nbDesistementsSurbooking\" jhiTranslate=\"cadensApp.formation.nbDesistementsSurbooking\">\n                                        Nb désistements surbooking</label>\n                                    <input type=\"number\" class=\"form-control\" id=\"nbDesistementsSurbooking\" disabled=\"true\"\n                                           [(ngModel)]=\"formation.nbDesistementsSurbooking\" name=\"nbDesistementsSurbooking\">\n                                </div>\n                            </div>\n                        </fieldset>\n\n                        <h1 jhiTranslate=\"cadensApp.formation.confirmationVenueTitre\" id=\"confirmationVenueTitre\"\n                            *ngIf=\"isAdmin || isGestionnaire || isResponsableFormation\">confirmationVenue</h1>\n\n                        <div class=\"form-group\">\n                            <label for=\"confirmationVenue\"\n                                   jhiTranslate=\"cadensApp.formation.confirmationVenue\">confirmationVenue</label>\n                            <p-inputSwitch [disabled]=\"!this.isAdmin\"\n                                           class=\"d-block\"\n                                           [onLabel]=\"'entity.action.activated' | translate\"\n                                           [offLabel]=\"'entity.action.deactivated' | translate\"\n                                           name=\"confirmationVenue\" id=\"confirmationVenue\"\n                                           [(ngModel)]=\"formation.venueConfirmable\"></p-inputSwitch>\n                        </div>\n\n                        <div *ngIf=\"formation.id != null\">\n                            <hr/>\n                            <h1 jhiTranslate=\"cadensApp.formation.demandeModif\" id=\"demandeModif\">\n                                demande de modification</h1>\n                            <jhi-demande-modif-component [entityId]=\"formation.id\" entityType=\"formation\"\n                                                         [(demandeModifs)]=\"demandeModifs\"\n                                                         [currentLang]=\"currentLang\"\n                            ></jhi-demande-modif-component>\n                        </div>\n                        <hr/>\n                    </div>\n                </div>\n\n                <jhi-alert></jhi-alert>\n\n                <div class=\"row\" [class.fixed-bottom]=\"navIsFixed\" *ngIf=\"reloading === false\">\n                    <div class=\"col-md-3\">\n                        <button type=\"button\" (click)=\"backToListe()\" class=\"btn btn-default\">\n                            <span jhiTranslate=\"entity.action.backToList\">back</span>\n                        </button>\n                    </div>\n                    <div class=\"col-md-5 offset-md-1\">\n                        <button type=\"submit\" class=\"btn btn-primary\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.save\">Save</span>\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myCampagneLabel\" jhiTranslate=\"cadensApp.formation.home.createOrEditLabel\">Create\n            des formations</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n        <div class=\"alert alert-info\" jhiTranslate=\"cadensApp.formation.home.pasDeNouvelleFormation\"\n             *ngIf=\"filteredList==null || filteredList.length==0\">\n            <strong>Pas de nouvelle formation</strong>\n        </div>\n\n        <div *ngIf=\"filteredList!=null && filteredList.length>0\">\n            <input #filtre placeholder=\"Filtrer\" (input)=\"filterFormations(filtre.value)\">\n            <div class=\"list-group formations pad\">\n            <span *ngFor=\"let ff of filteredList; let idx = index\">\n                <button type=\"button\" (click)=\"selectFormation($event, ff, idx)\"\n                        class=\"list-group-item list-group-item-action\"\n                        [ngClass]=\"{active: selectedFormations.indexOf(ff.id) > -1 }\">{{ ff.libelle }}</button>\n            </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"clear()\">\n            <span jhiTranslate=\"entity.action.cancel\"></span></button>\n        <div *ngIf=\"filteredList!=null && filteredList.length>0\">\n            <button type=\"submit\" class=\"btn btn-primary\">\n                <span jhiTranslate=\"entity.action.save\"></span></button>\n        </div>\n    </div>\n\n</form>\n\n"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\" xmlns=\"http://www.w3.org/1999/html\">\n    <h1 jhiTranslate=\"cadensApp.formation.home.title\">Formations</h1>\n    <div class=\"container-search\">\n        <div class=\"search\" *ngIf=\"formations\">\n            <div class=\"search-header row justify-content-between\">\n                <div class=\"col-sm-4\">\n                    <label><strong>Filtrer par :</strong></label>\n                </div>\n                <div class=\"col-sm-4 text-right\">\n                    <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"saveFilters()\"\n                            title=\"Sauvegarder le filtre Favoris\">\n                        <i class=\"fa fa-star btn-yellow\" aria-hidden=\"true\"></i>\n                    </button>\n                    <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"resetFilters(false)\"\n                            title=\"Recharger le filtre Favoris\">\n                        <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                    </button>\n                    <button type=\"button\" class=\"btn btn-outline-white\" (click)=\"resetFilters(true)\"\n                            title=\"Remise à zéro\">RàZ\n                    </button>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-2 col-sm-4 display-line\">\n                    <div class=\"form-check small-width\">\n                        <input class=\"form-check-input\" type=\"checkbox\" name=\"filtreAnneeEnCours\"\n                               [(ngModel)]=\"filters.filtreAnneeEnCours.value\"\n                               id=\"filtreAnneeEnCours\"\n                               [value]=\"true\" (click)=\"onChangeFiltreAnneeEnCours($event.target.checked)\">\n                        <label class=\"form-control-label\"\n                               for=\"filtreAnneeEnCours\"><span></span></label>\n                        <label jhiTranslate=\"cadensApp.formation.filtreAnneeEnCours\"\n                               title=\"Année en cours\">fc</label>\n                    </div>\n                    <div class=\"form-check small-width\">\n                        <input class=\"form-check-input\" type=\"checkbox\" name=\"filtreSupprimee\"\n                               [(ngModel)]=\"filters.supprimee.value\"\n                               id=\"filtreSupprimee\"\n                               [value]=\"false\" (click)=\"onChangeFiltreSupprimee($event.target.checked)\">\n                        <label class=\"form-control-label\"\n                               for=\"filtreSupprimee\"><span></span></label>\n                        <label jhiTranslate=\"cadensApp.formation.filtreSupprimee\"\n                               title=\"Supprimée invisible\">fc</label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"pagebutton\">\n        <button *ngIf=\"!isReferent\" class=\"btn btn-primary float-right create-formation\"\n                [routerLink]=\"['/', { outlets: { popup: ['formation-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span jhiTranslate=\"cadensApp.formation.home.createLabel\">\n            Create new Formation\n            </span>\n        </button>\n    </div>\n\n\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n    </div>\n    <div>\n        <jhi-spinner [display]=\"isLoading\"></jhi-spinner>\n\n        <div class=\"table-responsive\">\n            <p-dataTable #table [value]=\"formations\" [rows]=\"filters.rowPerPage\" [paginator]=\"true\"\n                         tableStyleClass=\"table-striped table-bordered\" (onRowSelect)=\"onRowSelect($event, table)\"\n                         [globalFilter]=\"searchFilter\" [(selection)]=\"selectedFormations\"\n                         [rowsPerPageOptions]=\"[20,50,100,500]\">\n                <p-header class=\"row justify-content-around\">\n                    <div class=\"cold-sm-1 d-flex align-items-center\">\n                        <label class=\"\" jhiTranslate=\"cadensApp.formation.total\"\n                               translateValues=\"{param: '{{table.totalRecords}}'}\"></label>\n                    </div>\n                    <div class=\"cold-sm-2\">\n                        <p-multiSelect *ngIf=\"formations\" [options]=\"actions\" [(ngModel)]=\"selectedAction\"\n                                       (onChange)=\"onSelectedAction($event)\"\n                                       [defaultLabel]=\"'cadensApp.formation.actions' | translate\"></p-multiSelect>\n                    </div>\n                    <div class=\"cold-sm-3\">\n                        <div class=\"input-group\">\n                            <input #searchFilter type=\"text\" class=\"form-control\"\n                                   [style.color]=\"getFilterColor(searchFilter)\"\n                                   placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\"\n                                   [(ngModel)]=\"searchText\">\n                            <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span\n                                class=\"fa fa-search\"></span></span>\n                        </div>\n                    </div>\n                    <div class=\"cold-sm-2\">\n                        <button type=\"button\" (click)=\"exportCSV()\" class=\"btn float-right btn-secondary\">\n                            <span class=\"fa fa-file-o text-primary\"></span><span\n                            jhiTranslate=\"entity.action.export\"></span>\n                        </button>\n                    </div>\n                    <div class=\"col-sm-2 flex-btn-group-container\">\n                        <div class=\"form-check\">\n                            <p-multiSelect id=\"columnSelection\" [options]=\"isAdmin ? cols.concat(colsAdmin) : cols\" [(ngModel)]=\"filters.selectedColumns\">\n                            </p-multiSelect>\n                        </div>\n                    </div>\n                </p-header>\n\n\n                <p-column [style]=\"{'width':'55px'}\" selectionMode=\"multiple\"></p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('id') > -1\" [style]=\"{'width':'45px'}\" field=\"id\"\n                          [header]=\"'cadensApp.formation.idHeader' | translate\"\n                          sortable=\"true\"></p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('libelle') > -1\" field=\"libelle\"\n                          [header]=\"'cadensApp.formation.libelleHeader' | translate\"\n                          [filter]=\"false\" filterMatchMode=\"contains\"\n                          sortable=\"custom\" (sortFunction)=\"onLibelleSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span id=\"{{formation.id}}\" class=\"ui-cell-data\"><a (click)=\"goToFormation(formation)\"\n                                                                            tabindex=\"-1\">{{formation.libelle}}</a></span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('libelleCourt') > -1\" field=\"libelleCourt\"\n                          [header]=\"'cadensApp.formation.libelleCourtHeader' | translate\"\n                          [filter]=\"false\" filterMatchMode=\"contains\" sortable=\"true\"></p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('campagnes') > -1\"\n                          [header]=\"'cadensApp.formation.campagnesHeader' | translate\"\n                >\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <div class=\"row\" *ngFor=\"let campagne of formation.campagnes\">\n                            <p *ngIf=\"campagne.display==true\">{{campagne.libelle}}</p>\n                        </div>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('demandeModifs') > -1 \"\n                          [header]=\"'cadensApp.formation.demandeModifHeader' | translate\"\n                >\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <div class=\"row\" *ngFor=\"let demandeModif of formation.demandeModifs\">\n                            <p>{{demandeModif.titre}}</p>\n                        </div>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('avecPreavis') > -1\" field=\"avecPreavis\"\n                          [header]=\"'cadensApp.formation.preavisHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onPreavisSort($event)\">\n                    <template let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\"\n                              *ngIf=\"formation.avecPreavis === true\"\n                              jhiTranslate=\"cadensApp.formation.preavisValeurs.true\"></span>\n                        <span class=\"ui-cell-data\"\n                              *ngIf=\"formation.avecPreavis === false\"\n                              jhiTranslate=\"cadensApp.formation.preavisValeurs.false\"></span>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('respoForma') > -1\" field=\"respoForma\"\n                          [header]=\"'cadensApp.formation.respoFormaHeader' | translate\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <div class=\"row\" *ngFor=\"let user of formation.users\">\n                            <p>{{user.lastName}} {{user.firstName}} ({{user.email}})</p>\n                        </div>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('lecteurs') > -1\" field=\"lecteurs\"\n                          [header]=\"'cadensApp.formation.lecteursHeader' | translate\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <div class=\"row\" *ngFor=\"let lecteur of formation.lecteurs\">\n                            <p>{{lecteur.lastName}} {{lecteur.firstName}} ({{lecteur.email}})</p>\n                        </div>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('lc') > -1\" field=\"lc\"\n                          [header]=\"'cadensApp.formation.lcHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onLcSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.lc === true\"\n                              jhiTranslate=\"cadensApp.formation.lcAutoValeurs.true\"></span>\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.lc === false\"\n                              jhiTranslate=\"cadensApp.formation.lcAutoValeurs.false\"></span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('rang') > -1\" field=\"rang\"\n                          [header]=\"'cadensApp.formation.rangHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onRangSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.rang === true && formation.lc === true\"\n                              jhiTranslate=\"cadensApp.formation.rangValeurs.true\"></span>\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.rang === false && formation.lc === true\"\n                              jhiTranslate=\"cadensApp.formation.rangValeurs.false\"></span>\n                    </template>\n                </p-column>\n\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('affichageRang') > -1\" field=\"affichageRang\"\n                          [header]=\"'cadensApp.formation.affichageRangHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onAffichageRangSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.affichageRang === true && formation.rang === true && formation.lc === true\"\n                              jhiTranslate=\"cadensApp.formation.affichageRangValeurs.true\"></span>\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.affichageRang === false && formation.rang === true && formation.lc === true\"\n                              jhiTranslate=\"cadensApp.formation.affichageRangValeurs.false\"></span>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('rangAuto') > -1\" field=\"rangAuto\"\n                          [header]=\"'cadensApp.formation.rangAutoHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onRangAutoSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\"\n                              *ngIf=\"formation.rangAuto === true  && formation.lc === true && formation.rang === true\"\n                              jhiTranslate=\"cadensApp.formation.rangAutoValeurs.true\"></span>\n                        <span class=\"ui-cell-data\"\n                              *ngIf=\"formation.rangAuto === false  && formation.lc === true && formation.rang === true\"\n                              jhiTranslate=\"cadensApp.formation.rangAutoValeurs.false\"></span>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('surbooking') > -1\" field=\"surbooking\"\n                          [header]=\"'cadensApp.formation.surbooking' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onSurbookingSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span class=\"ui-cell-data\" *ngIf=\"formation.rang === true\n                              && formation.rangAuto === true && formation.lc === true\n                              && formation.nbPlacesSurbooking > 0\"\n                              jhiTranslate=\"cadensApp.formation.surbookingValeurs.true\"></span>\n                        <span class=\"ui-cell-data\" jhiTranslate=\"cadensApp.formation.surbookingValeurs.false\"\n                              *ngIf=\"formation.nbPlacesSurbooking <= 0 && formation.rang === true\n                              && formation.rangAuto === true && formation.lc === true\">\n                        </span>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('nbPlacesSurbooking') > -1\" field=\"nbPlacesSurbooking\"\n                          [header]=\"'cadensApp.formation.nbPlacesSurbooking' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onNbPlacesSurbookingSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <p *ngIf=\"formation.rang === true && formation.lc === true && formation.nbPlacesSurbooking > 0\">{{formation.nbPlacesSurbooking}}</p>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('nbDesistementsSurbooking') > -1\" field=\"nbDesistementsSurbooking\"\n                          [header]=\"'cadensApp.formation.nbDesistementsSurbooking' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onNbDesistementsSurbookingSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <p *ngIf=\"formation.rang === true && formation.lc === true && formation.nbPlacesSurbooking > 0\">{{formation.nbDesistementsSurbooking}}</p>\n                    </template>\n                </p-column>\n                <!--Nombre de places : Saisie: ROLE_REFERENT (Responsable de formation) ,ROLE_GEST,,ROLE_ADMIN Lecture:  -->\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('nombrePlaces') > -1\" field=\"nombrePlaces\"\n                          [style]=\"{'width':'210px'}\"\n                          [header]=\"'cadensApp.formation.nombrePlaces' | translate\" sortable=\"custom\" (sortFunction)=\"onNbPlacesSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span *ngIf=\"!isAdmin && !isGestionnaire && !isResponsableFormation\">\n                            <p>{{formation.nombrePlaces}}</p>\n                        </span>\n                        <span *ngIf=\"isAdmin || isGestionnaire || isResponsableFormation\">\n                            <input type=\"number\" name=\"nombrePlaces{{formation.id}}\"\n                                   [(ngModel)]=\"formation.nombrePlaces\" style=\"width: 100px;\">\n                            <button type=\"button\"\n                                    class=\"btn btn-default\" (click)=\"savePlaces(formation)\">\n                                <i class=\"fa fa-save\"></i>\n                            </button>\n                        </span>\n                    </template>\n                </p-column>\n                <p-column *ngIf=\"filters.selectedColumns.indexOf('dateSuppression') > -1\"\n                          [header]=\"'cadensApp.formation.dateSuppressionHeader' | translate\"\n                          sortable=\"custom\" (sortFunction)=\"onDateSuppressionSort($event)\">\n                    <template let-col let-formation=\"rowData\" pTemplate=\"body\">\n                        <span>{{ formation?.dateSuppression | date: 'short' }}</span>\n                    </template>\n                </p-column>\n            </p-dataTable>\n        </div>\n    </div>\n</div>\n\n\n<p-dialog [header]=\"'cadensApp.formation.service.update' | translate\" [(visible)]=\"servicesDialog\" [responsive]=\"true\"\n          [modal]=\"true\">\n    <div class=\"ui-grid ui-grid-responsive ui-fluid\" *ngIf=\"selectedFormations\">\n        <div class=\"row\">\n            <div class=\"form-group col-sm-12\">\n                <label for=\"serviceSelected\" jhiTranslate=\"cadensApp.formation.service.title\">service</label>\n                <select class=\"form-control\" jhiInputRequired required id=\"serviceSelected\"\n                        [(ngModel)]=\"serviceSelected\" name=\"serviceSelected\">\n                    <option *ngFor=\"let serviceOption of servicesList\" [value]=\"serviceOption.id\">{{serviceOption.libelle }}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n    <p-footer>\n        <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelService()\"><span\n                jhiTranslate=\"entity.action.cancel\"></span></button>\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveService()\"><span\n                jhiTranslate=\"entity.action.save\"></span></button>\n        </div>\n    </p-footer>\n</p-dialog>\n\n<p-dialog [header]=\"'cadensApp.formation.piece.add' | translate\" [(visible)]=\"piecesDialog\" [responsive]=\"true\"\n          [modal]=\"true\" height=\"500\" styleClass=\"large\">\n    <div class=\"ui-grid ui-grid-responsive ui-fluid\" *ngIf=\"selectedFormations\">\n        <jhi-piece-component [(pieces)]=\"pieces\"></jhi-piece-component>\n    </div>\n    <p-footer>\n        <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelPieces()\"><span\n                jhiTranslate=\"entity.action.cancel\"></span></button>\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"savePieces()\"><span\n                jhiTranslate=\"entity.action.save\"></span></button>\n        </div>\n    </p-footer>\n</p-dialog>\n\n<p-dialog [header]=\"'cadensApp.formation.' + selectedAction | translate\" [(visible)]=\"usersDialog\" [responsive]=\"true\"\n          [modal]=\"true\" [closable]=\"false\" height=\"500\" styleClass=\"large\">\n    <div class=\"ui-grid ui-grid-responsive ui-fluid\">\n        <jhi-link-user-component (onErrorEvent)=\"errorEventChange($event)\"\n                                 [(linkedUsers)]=\"users\"></jhi-link-user-component>\n    </div>\n    <p-footer>\n        <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelUsers()\"><span\n                jhiTranslate=\"entity.action.cancel\"></span></button>\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"attachUsers()\"><span\n                jhiTranslate=\"entity.action.save\"></span></button>\n        </div>\n    </p-footer>\n</p-dialog>\n\n<p-dialog [header]=\"'cadensApp.formation.' + selectedAction | translate\" [(visible)]=\"campagnesDialog\"\n          [responsive]=\"true\"\n          [modal]=\"true\" [closable]=\"false\" height=\"500\">\n\n    <div class=\"modal-body\">\n        <div class=\"list-group campagnes\">\n            <span *ngFor=\"let campagne of campagnesAnneeCourante; let idx = index\">\n                <button type=\"button\" (click)=\"selectCampagne($event, campagne, idx)\"\n                        class=\"list-group-item list-group-item-action\"\n                        [ngClass]=\"{active: selectedCampagnesIds.indexOf(campagne.id) > -1 }\">{{ campagne.libelle }}</button>\n            </span>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"clearCampagneModal()\">\n            <span jhiTranslate=\"entity.action.cancel\"></span></button>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveCampagneModal()\">\n            <span jhiTranslate=\"entity.action.save\"></span></button>\n    </div>\n</p-dialog>\n\n<p-dialog [header]=\"'cadensApp.formation.' + selectedAction | translate\" [(visible)]=\"paramLCDialog\"\n          [responsive]=\"true\"\n          [modal]=\"true\" [closable]=\"false\" height=\"500\">\n    <div class=\"modal-body\">\n        <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\n\n            <h1 jhiTranslate=\"cadensApp.formation.listeComplementaire\" id=\"listec\">listeComplementaire</h1>\n\n            <div class=\"row\">\n                <div class=\"form-group col-sm-8\">\n                    <label for=\"listeComplementaire\"\n                           jhiTranslate=\"cadensApp.formation.listeComplementaire2\">listeComplementaire</label>\n                </div>\n                <div class=\"form-group col-sm-1\">\n                    <p-triStateCheckbox name=\"listeComplementaire\" id=\"listeComplementaire\" [(ngModel)]=\"listeComplementaireTriStateValue\"></p-triStateCheckbox>\n                </div>\n                <div class=\"form-group col-sm-2\">\n                    <div *ngIf=\"listeComplementaireTriStateValue == null\"><label for=\"listeComplementaire\" jhiTranslate=\"entity.action.noChange\"></label></div>\n                    <div *ngIf=\"listeComplementaireTriStateValue == true\"><label for=\"listeComplementaire\" jhiTranslate=\"entity.action.activated\"></label></div>\n                    <div *ngIf=\"listeComplementaireTriStateValue == false\"><label for=\"listeComplementaire\" jhiTranslate=\"entity.action.deactivated\"></label></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"form-group col-sm-8\">\n                    <label for=\"rang\"\n                           jhiTranslate=\"cadensApp.formation.rang\">rang</label>\n                </div>\n                <div class=\"form-group col-sm-1\">\n                    <p-triStateCheckbox name=\"rang\" id=\"rang\" [(ngModel)]=\"rangTriStateValue\"></p-triStateCheckbox>\n                </div>\n                <div class=\"form-group col-sm-2\">\n                    <div *ngIf=\"rangTriStateValue == null\"><label for=\"rang\" jhiTranslate=\"entity.action.noChange\"></label></div>\n                    <div *ngIf=\"rangTriStateValue == true\"><label for=\"rang\" jhiTranslate=\"entity.action.activated\"></label></div>\n                    <div *ngIf=\"rangTriStateValue == false\"><label for=\"rang\" jhiTranslate=\"entity.action.deactivated\"></label></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"form-group col-sm-8\">\n                    <label for=\"affichageRang\"\n                           jhiTranslate=\"cadensApp.formation.affichageRang\">affichageRang</label>\n                </div>\n                <div class=\"form-group col-sm-1\">\n                    <p-triStateCheckbox name=\"affichageRang\" id=\"affichageRang\" [(ngModel)]=\"affichageRangTriStateValue\"></p-triStateCheckbox>\n                </div>\n                <div class=\"form-group col-sm-2\">\n                    <div *ngIf=\"affichageRangTriStateValue == null\"><label for=\"affichageRang\" jhiTranslate=\"entity.action.noChange\"></label></div>\n                    <div *ngIf=\"affichageRangTriStateValue == true\"><label for=\"affichageRang\" jhiTranslate=\"entity.action.activated\"></label></div>\n                    <div *ngIf=\"affichageRangTriStateValue == false\"><label for=\"affichageRang\" jhiTranslate=\"entity.action.deactivated\"></label></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"form-group col-sm-8\">\n                    <label for=\"rangAuto\"\n                           jhiTranslate=\"cadensApp.formation.rangAuto\">rangAuto</label>\n                </div>\n                <div class=\"form-group col-sm-1\">\n                    <p-triStateCheckbox name=\"rangAuto\" id=\"rangAuto\" [(ngModel)]=\"rangAutoTriStateValue\"></p-triStateCheckbox>\n                </div>\n                <div class=\"form-group col-sm-2\">\n                    <div *ngIf=\"rangAutoTriStateValue == null\"><label for=\"rangAuto\" jhiTranslate=\"entity.action.noChange\"></label></div>\n                    <div *ngIf=\"rangAutoTriStateValue == true\"><label for=\"rangAuto\" jhiTranslate=\"entity.action.activated\"></label></div>\n                    <div *ngIf=\"rangAutoTriStateValue == false\"><label for=\"rangAuto\" jhiTranslate=\"entity.action.deactivated\"></label></div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" (click)=\"closeParamLC()\">\n            <span jhiTranslate=\"entity.action.cancel\"></span></button>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveParamLC()\">\n            <span jhiTranslate=\"entity.action.save\"></span></button>\n    </div>\n</p-dialog>\n\n"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"dropdown col-sm-4\" [ngClass]=\"{'show': userListeShow && userListe?.length > 0}\">\n        <div class=\"input-group\">\n            <input type=\"text\" [formControl]=\"userSearchControl\" class=\"form-control dropdown-toggle\"\n                   placeholder=\"Rechercher nom\"\n                   data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" (focus)=\"showUserListeShow()\" (blur)=\"hideUserListeShow()\">\n            <span class=\"input-group-addon\" id=\"user-search\"><i class=\"fa fa-search-plus\" aria-hidden=\"true\"></i></span>\n        </div>\n        <ul class=\"form-control dropdown-menu position-static\" id=\"user-options\" name=\"category\" role=\"menu\">\n            <li *ngFor=\"let user of userListe\"><a class=\"dropdown-item\"\n                                                  (mousedown)=\"addLdapUser(user)\">{{ user.lastName + \" \" + user.firstName }}</a>\n            </li>\n        </ul>\n    </div>\n    <div class=\"col-sm-6\">\n        <ul class=\"form-control liste-users\">\n            <li *ngFor=\"let user of linkedUsers\">{{ user.lastName + \" \" + user.firstName + \" (\" + user.email + \")\" }}\n                <a (click)=\"selectUser(user)\"><i class=\"fa fa-remove pull-right\" aria-hidden=\"true\"></i></a></li>\n        </ul>\n    </div>\n</div>\n<br>\n<div class=\"row\">\n    <div class=\"input-group col-sm-4\">\n        <input type=\"text\" [(ngModel)]=\"userEmail\" class=\"form-control\" placeholder=\"Email\" name=\"emailUser\">\n        <span class=\"input-group-addon\" id=\"user-email\" (click)=\"addUserByEmail(userEmail)\"><i class=\"fa fa-plus-circle\"\n                                                                                               aria-hidden=\"true\"></i></span>\n    </div>\n</div>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(historique.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"cadensApp.historique.delete.question\" translateValues=\"{id: '{{historique.id}}'}\">Are you sure you want to delete this Historique?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"historique\">\n    <h2><span jhiTranslate=\"cadensApp.historique.detail.title\">Historique</span> {{historique.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"cadensApp.historique.code\">Code</span></dt>\n        <dd>\n            <span>{{historique.code}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.details\">Details</span></dt>\n        <dd>\n            <span>{{historique.details}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.donneeAvant\">Donnee Avant</span></dt>\n        <dd>\n            <span>{{historique.donneeAvant}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.donneeApres\">Donnee Apres</span></dt>\n        <dd>\n            <span>{{historique.donneeApres}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.pieceJointeId\">Piece Jointe Id</span></dt>\n        <dd>\n            <span>{{historique.pieceJointeId}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.userId\">User Id</span></dt>\n        <dd>\n            <span>{{historique.userId}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.entityId\">Candidature Id</span></dt>\n        <dd>\n            <span>{{historique.entityId}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.candidatureFormationId\">Candidature Formation Id</span></dt>\n        <dd>\n            <span>{{historique.candidatureFormationId}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.historique.dateCreation\">Date Creation</span></dt>\n        <dd>\n            <span>{{historique.dateCreation | date:'medium'}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <!--<button type=\"button\"-->\n            <!--[routerLink]=\"['/', { outlets: { popup: 'historique/'+ historique.id + '/edit'} }]\"-->\n            <!--replaceUrl=\"true\"-->\n            <!--class=\"btn btn-primary\">-->\n        <!--<span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>-->\n    <!--</button>-->\n</div>\n"

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myHistoriqueLabel\" jhiTranslate=\"cadensApp.historique.home.createOrEditLabel\">Create or edit a Historique</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!historique.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"historique.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.code\" for=\"field_code\">Code</label>\n            <input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\"\n                [(ngModel)]=\"historique.code\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.details\" for=\"field_details\">Details</label>\n            <input type=\"text\" class=\"form-control\" name=\"details\" id=\"field_details\"\n                [(ngModel)]=\"historique.details\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.donneeAvant\" for=\"field_donneeAvant\">Donnee Avant</label>\n            <input type=\"text\" class=\"form-control\" name=\"donneeAvant\" id=\"field_donneeAvant\"\n                [(ngModel)]=\"historique.donneeAvant\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.donneeApres\" for=\"field_donneeApres\">Donnee Apres</label>\n            <input type=\"text\" class=\"form-control\" name=\"donneeApres\" id=\"field_donneeApres\"\n                [(ngModel)]=\"historique.donneeApres\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.pieceJointeId\" for=\"field_pieceJointeId\">Piece Jointe Id</label>\n            <input type=\"number\" class=\"form-control\" name=\"pieceJointeId\" id=\"field_pieceJointeId\"\n                [(ngModel)]=\"historique.pieceJointeId\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.userId\" for=\"field_userId\">User Id</label>\n            <input type=\"number\" class=\"form-control\" name=\"userId\" id=\"field_userId\"\n                [(ngModel)]=\"historique.userId\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.entityId\" for=\"field_candidatureId\">Candidature\n                Id</label>\n            <input type=\"number\" class=\"form-control\" name=\"entityId\" id=\"field_candidatureId\"\n                   [(ngModel)]=\"historique.entityId\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.candidatureFormationId\" for=\"field_candidatureFormationId\">Candidature Formation Id</label>\n            <input type=\"number\" class=\"form-control\" name=\"candidatureFormationId\" id=\"field_candidatureFormationId\"\n                [(ngModel)]=\"historique.candidatureFormationId\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.historique.dateCreation\" for=\"field_dateCreation\">Date Creation</label>\n            <div class=\"d-flex\">\n                <input id=\"field_dateCreation\" type=\"datetime-local\" class=\"form-control\" name=\"dateCreation\" [(ngModel)]=\"historique.dateCreation\"\n                  />\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"cadensApp.historique.home.title\">Historiques</span>\n        <!--\n                <button class=\"btn btn-primary float-right create-historique\" [routerLink]=\"['/', { outlets: { popup: ['historique-new'] } }]\">\n                    <span class=\"fa fa-plus\"></span>\n                    <span  jhiTranslate=\"cadensApp.historique.home.createLabel\">\n                    Create new Historique\n                    </span>\n                </button>\n        -->\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n    </div>\n    <br/>\n\n    <div *ngIf=\"candidatureFormation!=null\" class=\"container-search\">\n                    <span >\n                        <a tabindex=\"-1\"\n                           (click)=\"goToCandidature()\">{{candidatureFormation.libelle==null?candidatureFormation.id: candidatureFormation.libelle }}</a>\n                    </span>\n    </div>\n\n    <div class=\"table-responsive\" *ngIf=\"historiques\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n                <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"code\"><span jhiTranslate=\"cadensApp.historique.code\">Code</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"details\"><span jhiTranslate=\"cadensApp.historique.details\">Details</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"donneeApres\"><span jhiTranslate=\"cadensApp.historique.donneeApres\">Donnee Apres</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"donneeAvant\"><span jhiTranslate=\"cadensApp.historique.donneeAvant\">Donnee Avant</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th *ngIf=\"this.candidatureFormation==null\" jhiSortBy=\"pieceJointeId\"><span\n                    jhiTranslate=\"cadensApp.historique.pieceJointeId\">Piece Jointe Id</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th ><span jhiTranslate=\"cadensApp.historique.user\">User</span> </th>\n                <th *ngIf=\"this.candidatureFormation==null\" jhiSortBy=\"entityId\"><span\n                    jhiTranslate=\"cadensApp.historique.entityId\">Candidature Id</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th *ngIf=\"this.candidatureFormation==null\" jhiSortBy=\"candidatureFormationId\"><span\n                    jhiTranslate=\"cadensApp.historique.candidatureFormationId\">Candidature Formation Id</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"dateCreation\"><span jhiTranslate=\"cadensApp.historique.dateCreation\">Date Creation</span>\n                    <span class=\"fa fa-sort\"></span></th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let historique of historiques ;trackBy: trackId\">\n                <td *ngIf=\"this.candidatureFormation==null\"><a [routerLink]=\"['../historique', historique.id ]\">{{historique.id}}</a>\n                </td>\n                <td *ngIf=\"this.candidatureFormation!=null\">{{historique.id}}</td>\n                <td>{{historique.code}}</td>\n                <td>{{historique.details}}</td>\n                <td>{{formatData(historique.code, \"donneeAvant\", historique.donneeApres)}}</td>\n                <td>{{formatData(historique.code, \"donneeAvant\", historique.donneeAvant)}}</td>\n                <td *ngIf=\"this.candidatureFormation==null\">{{historique.pieceJointeId}}</td>\n                <td>{{historique.user!=null?historique.user.email:historique.userId}}</td>\n                <td *ngIf=\"this.candidatureFormation==null\">{{historique.entityId}}</td>\n                <td *ngIf=\"this.candidatureFormation==null\">{{historique.candidatureFormationId}}</td>\n                <td>{{historique.dateCreation | date:'medium'}}</td>\n                <!--<td class=\"text-right\">-->\n                <!--<div class=\"btn-group flex-btn-group-container\">-->\n                <!--<button type=\"submit\"-->\n                <!--[routerLink]=\"['../historique', historique.id ]\"-->\n                <!--class=\"btn btn-info btn-sm\">-->\n                <!--<span class=\"fa fa-eye\"></span>-->\n                <!--<span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>-->\n                <!--</button>-->\n                <!--<button type=\"submit\"-->\n                <!--[routerLink]=\"['/', { outlets: { popup: 'historique/'+ historique.id + '/edit'} }]\"-->\n                <!--replaceUrl=\"true\"-->\n                <!--class=\"btn btn-primary btn-sm\">-->\n                <!--<span class=\"fa fa-pencil\"></span>-->\n                <!--<span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>-->\n                <!--</button>-->\n                <!--<button type=\"submit\"-->\n                <!--[routerLink]=\"['/', { outlets: { popup: 'historique/'+ historique.id + '/delete'} }]\"-->\n                <!--replaceUrl=\"true\"-->\n                <!--class=\"btn btn-danger btn-sm\">-->\n                <!--<span class=\"fa fa-remove\"></span>-->\n                <!--<span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>-->\n                <!--</button>-->\n                <!--</div>-->\n                <!--</td>-->\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <!-- Pager is not implemented yet, so this is normal pagination instead -->\n    <div *ngIf=\"historiques && historiques.length\">\n        <div class=\"row justify-content-center\">\n            <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n        </div>\n        <div class=\"row justify-content-center\">\n            <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\"\n                            (pageChange)=\"loadPage(page)\"></ngb-pagination>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "\n<h1 jhiTranslate=\"legal.title\">mentions legales</h1>\n"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "\n<h1 jhiTranslate=\"cadensApp.parametrage.pieces\">files</h1>\n\n<jhi-alert></jhi-alert>\n\n<div class=\"\" *ngFor=\"let file of uploadedFiles; let idx = index\">\n    <h3>{{ file }}.pdf</h3>\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <p-fileUpload [name]=\"file\" url=\"./api/upload\" accept=\".pdf\" auto=\"auto\" id=\"{{file}}\"\n                          (onUpload)=\"onFileUploaded($event, file)\"\n                          (onBeforeSend)=\"onBeforeSend($event)\" (onBeforeUpload)=\"onBeforeUpload($event, file)\"\n                          [maxFileSize]=\"maxSize\"\n                          chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                          uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                          cancelLabel=\"{{ 'entity.action.cancel' | translate }}\" >\n                <template pTemplate=\"content\" type=\"content\">\n                    <a *ngIf=\"file != null\" (click)=\"openFile(file)\">{{ file }}</a>\n                </template>\n            </p-fileUpload>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-11 pagecard\">\n    <h1 jhiTranslate=\"global.menu.gestionnaire.parametres\">archive</h1>\n    <div class=\"row no-gutters\">\n        <div class=\"col-sm-3\">\n            <ul id=\"sidebar\" class=\"nav flex-column\">\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.GENERAL)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.GENERAL}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.general\">general</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.MASTER)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.MASTER}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.master\">master</span></a>\n\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.DIPLOME)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.DIPLOME}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.diplome\">diplome</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.CPES)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.CPES}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.cpes\">CPES</span></a>\n\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.INTERNATIONAL)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.INTERNATIONAL}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.campagnesInternational\">International</span></a>\n\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.FC)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.FC}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.fc\">fc</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.FAQ)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.FAQ}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.faq\">faq</span></a>\n                </li>\n                <li class=\"sidebar-item\">\n                    <a (click)=\"goToStep(constants.SERVICE)\" class=\"sidebar-link\" [ngClass]=\"{active: pageEdition === constants.SERVICE}\">\n                        <span jhiTranslate=\"cadensApp.parametrage.service\">SERVICE</span></a>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"col-sm-9 content\">\n            <form name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #registerForm=\"ngForm\" data-toggle=\"validator\">\n                <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n                <div *ngIf=\"pageEdition !== constants.SERVICE\">\n                    <jhi-parametre-component [(parametrages)]=\"parametrages\" [(currentLang)]=\"currentLang\"></jhi-parametre-component>\n                    <div *ngIf=\"showAddParametre\">\n                        <button type=\"button\" class=\"btn btn-sectionFor\" data-dismiss=\"modal\" (click)=\"addParametre()\">\n                            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i><span jhiTranslate=\"cadensApp.parametrage.add\">Ajouter</span>\n                        </button>\n                    </div>\n\n                    <h2 jhiTranslate=\"cadensApp.parametrage.piecesJointes\" *ngIf=\"pieces\">piecesJointes</h2>\n                    <jhi-piece-component [(pieces)]=\"pieces\" *ngIf=\"pieces\" [(currentLang)]=\"currentLang\"></jhi-piece-component>\n\n                    <br/><br/>\n                    <h2 jhiTranslate=\"cadensApp.parametrage.questions\" *ngIf=\"questions\">questions</h2>\n                    <jhi-question-component [(questions)]=\"questions\"\n                                            [categorieFormationId]=\"categorieFormationId\"\n                                            [(currentLang)]=\"currentLang\"\n                                            [disabled]=\"uniquementDemandeModif\"></jhi-question-component>\n                    <br /><br />\n\n                </div>\n                <div *ngIf=\"pageEdition === constants.SERVICE\">\n                    <jhi-choix-component [(choix)]=\"services\" *ngIf=\"services\"></jhi-choix-component>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-5\">\n                        <button type=\"submit\" (click)=\"cancel()\" class=\"btn btn-default\">\n                            <span jhiTranslate=\"entity.action.cancel\"> save back</span>\n                        </button>\n                    </div>\n                    <div class=\"col-md-5\">\n                        <button type=\"submit\" class=\"btn btn-primary\">\n                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"entity.action.save\">Save</span>\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n        <!--<div class=\"col-sm-9 content\" *ngIf=\"pageEdition === constants.PIECES\">-->\n            <!--<form>-->\n                <!--<jhi-files-component ></jhi-files-component>-->\n            <!--</form>-->\n        <!--</div>-->\n    </div>\n</div>\n"

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(pieceJointe.id)\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"cadensApp.pieceJointe.delete.question\" translateValues=\"{id: '{{pieceJointe.id}}'}\">Are you sure you want to delete this Piece Jointe?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"pieceJointe\">\n    <h2><span jhiTranslate=\"cadensApp.pieceJointe.detail.title\">Piece Jointe</span> {{pieceJointe.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row\">\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.nom\">Nom</span></dt>\n        <dd>\n            <span>{{pieceJointe.nom}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.conforme\">Conforme</span></dt>\n        <dd>\n            <span>{{pieceJointe.conforme}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.notes\">Notes</span></dt>\n        <dd>\n            <span>{{pieceJointe.notes}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.dateCreation\">Date Creation</span></dt>\n        <dd>\n            <span>{{pieceJointe.dateCreation | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.dateModification\">Date Modification</span></dt>\n        <dd>\n            <span>{{pieceJointe.dateModification | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.dateConformite\">Date Conformite</span></dt>\n        <dd>\n            <span>{{pieceJointe.dateConformite | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.piece\">Piece</span></dt>\n        <dd>\n            <div *ngIf=\"pieceJointe.pieceId\">\n                <a [routerLink]=\"['piece', pieceJointe.pieceId]\">{{pieceJointe.pieceId}}</a>\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.user\">User</span></dt>\n        <dd>\n            {{pieceJointe.userId}}\n        </dd>\n        <dt><span jhiTranslate=\"cadensApp.pieceJointe.candidatureFormation\">Candidature Formation</span></dt>\n        <dd>\n            <div *ngIf=\"pieceJointe.candidatureFormationId\">\n                <a [routerLink]=\"['candidature-formation', pieceJointe.candidatureFormationId]\">{{pieceJointe.candidatureFormationId}}</a>\n            </div>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'piece-jointe/'+ pieceJointe.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n        <h4 class=\"modal-title\" id=\"myPieceJointeLabel\" jhiTranslate=\"cadensApp.pieceJointe.home.createOrEditLabel\">Create or edit a Piece Jointe</h4>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!pieceJointe.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"pieceJointe.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.nom\" for=\"field_nom\">Nom</label>\n            <input type=\"text\" class=\"form-control\" name=\"nom\" id=\"field_nom\"\n                [(ngModel)]=\"pieceJointe.nom\"\n            required />\n            <div [hidden]=\"!(editForm.controls.nom?.dirty && editForm.controls.nom?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.nom?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.conforme\" for=\"field_conforme\">Conforme</label>\n            <input type=\"checkbox\" class=\"form-control\" name=\"conforme\" id=\"field_conforme\"\n                [(ngModel)]=\"pieceJointe.conforme\"/>\n            <label for=\"field_conforme\"><span></span></label>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.notes\" for=\"field_notes\">Notes</label>\n            <input type=\"text\" class=\"form-control\" name=\"notes\" id=\"field_notes\"\n                [(ngModel)]=\"pieceJointe.notes\"/>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.dateCreation\" for=\"field_dateCreation\">Date Creation</label>\n            <div class=\"input-group\">\n                <input id=\"field_dateCreation\" type=\"datetime-local\" class=\"form-control\" name=\"dateCreation\" [(ngModel)]=\"pieceJointe.dateCreation\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.dateModification\" for=\"field_dateModification\">Date Modification</label>\n            <div class=\"input-group\">\n                <input id=\"field_dateModification\" type=\"datetime-local\" class=\"form-control\" name=\"dateModification\" [(ngModel)]=\"pieceJointe.dateModification\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"cadensApp.pieceJointe.dateConformite\" for=\"field_dateConformite\">Date Conformite</label>\n            <div class=\"input-group\">\n                <input id=\"field_dateConformite\" type=\"datetime-local\" class=\"form-control\" name=\"dateConformite\" [(ngModel)]=\"pieceJointe.dateConformite\"/>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label jhiTranslate=\"cadensApp.pieceJointe.piece\" for=\"field_piece\">Piece</label>\n            <select class=\"form-control\" id=\"field_piece\" name=\"piece\" [(ngModel)]=\"pieceJointe.pieceId\" >\n                <option></option>\n                <option [ngValue]=\"pieceOption.id\" *ngFor=\"let pieceOption of pieces; trackBy: trackPieceById\">{{pieceOption.id}}</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"cadensApp.pieceJointe.user\" for=\"field_user\">User</label>\n            <select class=\"form-control\" id=\"field_user\" name=\"user\" [(ngModel)]=\"pieceJointe.userId\" >\n                <option></option>\n                <option [ngValue]=\"userOption.id\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.id}}</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"cadensApp.pieceJointe.candidatureFormation\" for=\"field_candidatureFormation\">Candidature Formation</label>\n            <select class=\"form-control\" id=\"field_candidatureFormation\" name=\"candidatureFormation\"\n                    [(ngModel)]=\"pieceJointe.candidatureFormationId\" >\n                <option></option>\n                <option [ngValue]=\"candidatureFormationOption.id\" *ngFor=\"let candidatureFormationOption of candidatureformations; trackBy: trackCandidatureFormationById\">{{candidatureFormationOption.id}}</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2><span jhiTranslate=\"cadensApp.pieceJointe.home.title\">Piece Jointes</span></h2>\n    <jhi-alert></jhi-alert>\n\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"pieceJointes\">\n        <p-dataTable #table [value]=\"pieceJointes\" [rows]=\"20\" [paginator]=\"true\" tableStyleClass=\"table-striped table-bordered\"\n                     [globalFilter]=\"search\" [rowsPerPageOptions]=\"[20,50,100]\">\n            <p-header class=\"row justify-content-around\">\n                <div class=\"cold-sm-2\">\n                    <label class=\"\" jhiTranslate=\"cadensApp.pieceJointe.total\" translateValues=\"{param: '{{table.totalRecords}}'}\"></label>\n                </div>\n                <div class=\"cold-sm-10\">\n                    <div class=\"input-group\">\n                        <input #search type=\"text\" class=\"form-control\" placeholder=\"{{'entity.action.search' | translate}}\" autocomplete=\"off\">\n                        <span class=\"input-group-addon btn-secondary text-primary\" id=\"search\"><span class=\"fa fa-search\"></span></span>\n                    </div>\n                </div>\n            </p-header>\n\n            <p-column [style]=\"{'width':'55px'}\" field=\"id\" [header]=\"'global.field.id' | translate\" sortable=\"true\"></p-column>\n            <p-column field=\"nom\" [header]=\"'cadensApp.pieceJointe.nom' | translate\" sortable=\"true\" [filter]=\"true\" filterMatchMode=\"contains\">\n                <template let-col let-pj=\"rowData\" pTemplate=\"body\">\n                    <a [routerLink]=\"['/', { outlets: { popup: 'pieceJointe'} }]\">{{ pj.nom }}</a>\n                </template>\n            </p-column>\n            <p-column [style]=\"{'width':'200px'}\" field=\"dateModification\" [header]=\"'cadensApp.pieceJointe.dateModification' | translate\" sortable=\"true\">\n                <template let-col let-pj=\"rowData\" pTemplate=\"body\">\n                    {{ pj.dateModification | date: 'medium'}}\n                </template>\n            </p-column>\n            <p-column [style]=\"{'width':'140px'}\" styleClass=\"col-button\">\n                <template let-pj=\"rowData\" pTemplate=\"body\">\n                    <button type=\"submit\" replaceUrl=\"true\" [routerLink]=\"['/', { outlets: { popup: 'piece-jointe/'+ pj.id + '/delete'} }]\" class=\"btn btn-danger btn-sm\">\n                        <span class=\"fa fa-remove\"></span>\n                        <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                    </button>\n                </template>\n            </p-column>\n        </p-dataTable>\n    </div>\n</div>\n"

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card col-md-12\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <h1><span jhiTranslate=\"cadensApp.referent.home.title\"></span>&nbsp;{{referent?.candidat}}</h1>\n        </div>\n        <jhi-spinner [display]=\"isSaving\"></jhi-spinner>\n\n        <div *ngIf=\"referent\">\n            <form name=\"form\" role=\"form\" (submit)=\"save()\">\n\n                <div >\n                    <p >\n                        {{ referent?.candidat }}\n                        <span jhiTranslate=\"cadensApp.referent.home.how\"></span>\n                    </p>\n                    <div class=\"row\">\n                        <span jhiTranslate=\"cadensApp.referent.formation\"></span>&nbsp;{{ referent.formation }}.\n                    </div>\n                    <div class=\"row\" *ngIf=\"referent.ects > 100\">\n                        <a href=\"{{urlEnSavoirPlusDiplome}}\" target=\"_blank\"\n                           jhiTranslate=\"cadensApp.referent.diplomePlus\"></a>\n                    </div>\n                    <br/>\n                    <div class=\"row\">\n                        <span jhiTranslate=\"cadensApp.referent.details\"></span>\n                    </div>\n                    <br/>\n\n                     <div *ngIf=\"lettreRecommandation !=null\">\n                         <div class=\"row\">\n                             <span jhiTranslate=\"cadensApp.referent.choixFormulaireOuLettre\"></span>\n                         </div>\n\n                         <br/>\n                         <h2  jhiTranslate=\"cadensApp.referent.titreLettre\"></h2>\n\n\n                         <div class=\"form-group col-sm-12\">\n                            <label *ngIf=\"lettreRecommandation.libelleEn || lettreRecommandation.libelle\" class=\"header\">{{ currentLang === 'fr' || lettreRecommandation.libelleEn == null ?\n                                lettreRecommandation.libelle :\n                                lettreRecommandation.libelleEn\n                                }}</label>\n                               <span *ngIf=\"lettreRecommandation.aide != null\"\n                                  (click)=\"openAide(pieceModal, lettreRecommandation)\"\n                                  class=\"fa fa-question-circle-o\"\n                                  title=\"Cliquer\"></span>\n                            <label class=\"subLabel\" *ngIf=\"lettreRecommandation.descriptif != null\"\n                                   [innerHTML]=\"currentLang === 'fr' || lettreRecommandation.descriptifEn == null ? lettreRecommandation.descriptif : lettreRecommandation.descriptifEn\"></label>\n                            <p-fileUpload [name]=\"uploadedFiles[lettreRecommandation.id]?.nom\" url=\"./api/public/upload\"\n                                          accept=\"application/pdf\"\n                                          auto=\"auto\"\n                                          id=\"{{lettreRecommandation.id}}\"\n                                          (onUpload)=\"onFileUploaded($event, lettreRecommandation.id)\"\n                                          withCredentials=\"false\"\n                                          (onBeforeSend)=\"onBeforeSend($event)\"\n                                          (onBeforeUpload)=\"onBeforeUpload($event, lettreRecommandation.id)\"\n                                          (onBeforeRemove)=\"onRemove(this.piecesJointes.find(lettreRecommandation.id)?.id)\"\n                                          [maxFileSize]=\"maxSize\"\n                                          invalidFileTypeMessageDetail=\"invalid pdf type\"\n                                          (onError)=\"onError($event)\"\n                                          chooseLabel=\"{{ 'entity.action.choose' | translate }}\"\n                                          uploadLabel=\"{{ 'entity.action.upload' | translate }}\"\n                                          cancelLabel=\"{{ 'entity.action.cancel' | translate }}\">\n                                <template pTemplate=\"content\" type=\"content\">\n                                    <p *ngIf=\"uploadedFiles[lettreRecommandation.id] != null\" >{{\n                                        uploadedFiles[lettreRecommandation.id].nom }}</p>\n                                    <!--(click)=\"openFile(uploadedFiles[lettreRecommandation.id].nom)\"-->\n                                </template>\n                            </p-fileUpload>\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"lettreRecommandation !=null\">\n                        <br/>\n                        <h2  jhiTranslate=\"cadensApp.referent.titreFormulaire\"></h2>\n                    </div>\n\n                        <div>\n                        <jhi-reponse-component [(questions)]=\"questions\" *ngIf=\"questions\"\n                                               [currentLang]=\"currentLang\"></jhi-reponse-component>\n                    </div>\n                    <br/>\n                    <div *ngIf=\"radios?.length > 0 && radios[0].length > 0\">\n                        <div class=\"table-radios\">\n                            <div class=\"row head\">\n                                <div class=\"col-sm-4 header\" jhiTranslate=\"cadensApp.referent.competences\"></div>\n                                <div class=\"col-sm-1 header\" *ngFor=\"let choix of radios[0]\">{{choix}}</div>\n                            </div>\n\n                            <div *ngFor=\"let question of questions; let idx = index\">\n                                <div class=\"row choice\"\n                                     *ngIf=\"question.typeReponse === 'RADIO' && radios[0].join('|').indexOf(question.reponseComplement) > -1\">\n                                    <label class=\"header col-sm-4\">\n                                        {{ currentLang === 'en' && question.libelleEn != null ? question.libelleEn :\n                                        question.libelle }}\n                                        <span\n                                            [ngClass]=\"isQuestionObligatoire(question) && firstValid && question.reponse == null ? 'text-danger' : 'hidden'\"><i\n                                            class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"Obligatoire\"></i></span>\n                                    </label>\n\n                                    <div class=\"col-sm-1 radios\" *ngFor=\"let choix of radios[0]\">\n                                        <p-radioButton name=\"questions-radios-{{idx}}-{{choix}}\"\n                                                       id=\"questions-radios-{{idx}}-{{choix}}\"\n                                                       [attr.jhiInputRequired]=\"isQuestionObligatoire(question)\"\n                                                       [attr.required]=\"isQuestionObligatoire(question)\"\n                                                       [value]=\"choix\" [(ngModel)]=\"question.reponse\"></p-radioButton>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row how\" jhiTranslate=\"cadensApp.referent.competencesNB\"></div>\n                    </div>\n                    <br/>\n                    <br/>\n                    <div *ngIf=\"radios?.length > 1 && radios[1].length > 0\">\n                        <div *ngFor=\"let question of questions; let idx = index\">\n                             <div class=\"table-radios\"\n                                 *ngIf=\"question.typeReponse === 'RADIO' && radios[1].join('|').indexOf(question.reponseComplement) > -1\">\n                                 <div *ngIf=\"lettreRecommandation !=null && avantDerniereQuestion(question)\">\n                                     <br/>\n                                     <h2  jhiTranslate=\"cadensApp.referent.titreConclusion\"></h2>\n                                     <br/>\n                                 </div>\n                                 <label class=\"header\">{{ currentLang === 'en' && question.libelleEn != null ?\n                                    question.libelleEn : question.libelle }} {{ referent.candidat }} :\n                                    <span\n                                        [ngClass]=\"isQuestionObligatoire(question) && firstValid && question.reponse == null ? 'text-danger' : 'hidden'\"><i\n                                        class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"\n                                        title=\"Obligatoire\"></i></span>\n                                </label>\n                                <div class=\"row how\">{{ currentLang === 'en' && question.descriptifEn != null ?\n                                    question.descriptifEn : question.descriptif }}\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"radios\" *ngFor=\"let choix of radios[1]\">\n                                        <label class=\"col-sm-2 header\">{{ choix }}</label><br/>\n                                        <p-radioButton name=\"questions-radios1-{{idx}}-{{choix}}\"\n                                                       id=\"questions-radios1-{{idx}}-{{choix}}\"\n                                                       [attr.jhiInputRequired]=\"isQuestionObligatoire(question)\"\n                                                       [attr.required]=\"isQuestionObligatoire(question)\"\n                                                       [value]=\"choix\" [(ngModel)]=\"question.reponse\"\n                                                       class=\"col-sm-2\"></p-radioButton>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <br/>\n                    <jhi-alert></jhi-alert>\n\n                    <div class=\"row\" *ngIf=\"referent.savedDate == null\">\n                        <div class=\"col-md-2 offset-md-2\">\n                            <button type=\"button\" (click)=\"cancel()\" class=\"btn btn-default\">\n                                <i class=\"fa fa-ban\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.cancel\">save</span>\n                            </button>\n                        </div>\n                        <div class=\"col-md-2 offset-md-1\">\n                            <button type=\"button\" (click)=\"saveForLater()\" class=\"btn btn-primary\">\n                                <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.saveBackStep\">save</span>\n                            </button>\n                        </div>\n                        <div class=\"col-md-2 offset-md-1\">\n                            <button id=\"transmit\" type=\"submit\" class=\"btn btn-primary\">\n                                <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"entity.action.transmit\">transmit</span>\n                            </button>\n                        </div>\n                    </div>\n                    <br/>\n                    <div class=\"row alert alert-success\" *ngIf=\"referent.savedDate != null\">\n                        <span class=\"fa fa-handshake-o\"></span>\n                        <span jhiTranslate=\"cadensApp.referent.merci\"></span>\n                    </div>\n                </div>\n            </form>\n        </div>\n        <div *ngIf=\"!referent\">\n            <div >\n                <div class=\"row alert alert-danger\">\n                    <span class=\"fa fa-snowflake-o\"></span>\n                    <span jhiTranslate=\"cadensApp.referent.notfound\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<p-confirmDialog width=\"425\" icon=\"fa fa-save\" #cd>\n    <p-footer>\n        <button type=\"button\" pButton icon=\"fa-close\" [label]=\"'entity.action.cancel' | translate\"\n                (click)=\"cd.reject()\"></button>\n        <button type=\"button\" pButton icon=\"fa-check\" [label]=\"'entity.action.valider' | translate\"\n                (click)=\"cd.accept()\"></button>\n    </p-footer>\n</p-confirmDialog>\n"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-md-3\">\n        <span class=\"hipster img-fluid img-rounded\"></span>\n    </div>\n    <div class=\"col-md-9\">\n        <p class=\"lead\" jhiTranslate=\"home.waitaminute\">Veuillez patienter, vous allez bientôt accéder à Cadens</p>\n    </div>\n</div>\n"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-4\">\n            <span class=\"hipster img-fluid img-rounded\"></span>\n        </div>\n        <div class=\"col-md-8\">\n            <h1 jhiTranslate=\"error.title\">Error Page!</h1>\n\n            <div [hidden]=\"!errorMessage\">\n                <div class=\"alert alert-danger\">{{errorMessage}}\n                </div>\n            </div>\n            <div [hidden]=\"!error403\" class=\"alert alert-danger\" jhiTranslate=\"error.403\">You are not authorized to access the page.\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "<footer>\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"footer-top\">\n                    <ul class=\"nav navbar-left\">\n                        <li class=\"nav-item\">\n                            <a class=\"nav-link\" routerLink=\"contact\" jhiTranslate=\"footer.contact\">Contact</a>\n                        </li>\n                        <li class=\"nav-item\">\n                            <a class=\"nav-link\" routerLink=\"faq\" jhiTranslate=\"footer.faq\">FAQ</a>\n                        </li>\n                        <li class=\"nav-item\">\n                            <a class=\"nav-link\" href=\"http://www.ens-lyon.fr/ens-de-lyon/mentions-legales-78868.kjsp\" jhiTranslate=\"footer.legal\">Mentions légales</a>\n                        </li>\n                    </ul>\n                    <div class=\"navbar-right\"><span class=\"logo-footer\"></span></div>\n                </div>\n                <div class=\"footer-bottom\">\n                    <div class=\"copyright\"jhiTranslate=\"footer.copyright\">Copyright © ENS de Lyon 2025</div>\n                    <span class=\"navbar-version\">{{version}}</span>\n                </div>\n            </div>\n        </div>\n    </div>\n</footer>\n<template ngbModalContainer></template>\n"

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<jhi-page-ribbon></jhi-page-ribbon>\n<div id=\"main\" class=\"container\">\n    <div>\n        <router-outlet name=\"navbar\"></router-outlet>\n    </div>\n    <div class=\"\">\n        <router-outlet></router-outlet>\n        <router-outlet name=\"popup\"></router-outlet>\n    </div>\n</div>\n<jhi-footer></jhi-footer>\n"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-light\" role=\"navigation\" id=\"navigation\">\n    <div class=\"container\">\n        <div class=\"navbar-header\">\n            <div class=\"navbar-brand logo navbar-left\">\n                <a class=\"logo-img\" [href]=\"parametrage?.URL.libelle\"></a>\n                <a class=\"title\" routerLink=\"/\">\n                    <span class=\"header-title\">CAD<span class=\"color\">ENS</span> <span class=\"small\">({{parametrage?.ANNEE_UNIVERSITAIRE.libelle}})</span></span>\n                    <span class=\"header-desc\" jhiTranslate=\"global.desc\">CADENS</span>\n                </a>\n            </div>\n            <ul class=\"nav navbar-nav navbar-right row\" [ngSwitch]=\"isAuthenticated()\">\n                <!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here -->\n                <li *ngSwitchCase=\"true\" ngbDropdown class=\"nav-item dropdown pointer hidden\">\n                    <a class=\"nav-link dropdown-toggle\" routerLinkActive=\"active\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"entity-menu\">\n                        <span>\n                            <i class=\"fa fa-th-list\" aria-hidden=\"true\"></i>\n                            <span class=\"hidden-sm-down\" jhiTranslate=\"global.menu.entities.main\">\n                                Entities\n                            </span>\n                            <b class=\"caret\"></b>\n                        </span>\n                    </a>\n                    <ul class=\"dropdown-menu\" ngbDropdownMenu>\n                        <li uiSrefActive=\"active\">\n                            <a class=\"dropdown-item\" routerLink=\"historique\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.entities.historique\">Historique</span>\n                            </a>\n                        </li>\n                        <li uiSrefActive=\"active\">\n                            <a class=\"dropdown-item\" routerLink=\"piece-jointe\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.entities.pieceJointe\">Piece Jointe</span>\n                            </a>\n                        </li>\n                        <!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here -->\n                    </ul>\n                </li>\n\n                <li *ngSwitchCase=\"true\" class=\"nav-item pointer\">\n                    <label id=\"username\" class=\"mt-md-2\">{{username}}</label>\n                </li>\n                <li ngbDropdown class=\"nav-item dropdown pointer\" *ngSwitchCase=\"true\">\n                    <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"account-menu\">\n                      <span *ngIf=\"!getImageUrl()\">\n                        <i class=\"fa fa-fw fa-cog\" aria-hidden=\"true\"></i>\n                        <b class=\"caret\"></b>\n                      </span>\n                    </a>\n                    <ul class=\"dropdown-menu dropdown-menu-right hidden\" ngbDropdownMenu>\n                        <li *ngSwitchCase=\"true\">\n                            <a class=\"dropdown-item\" routerLink=\"settings\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-wrench\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.account.settings\">Settings</span>\n                            </a>\n                        </li>\n                        <li *ngSwitchCase=\"true\">\n                            <a class=\"dropdown-item\" routerLink=\"password\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-clock-o\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.account.password\">Password</span>\n                            </a>\n                        </li>\n                        <li *ngSwitchCase=\"true\">\n                            <a class=\"dropdown-item hidden\" routerLink=\"sessions\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-cloud\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.account.sessions\">Sessions</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li *ngIf=\"isAdminSys \" ngbDropdown class=\"nav-item dropdown pointer\">\n                    <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"admin-menu\">\n                        <span>\n                            <i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i>\n                            <b class=\"caret\"></b>\n                        </span>\n                    </a>\n                    <ul class=\"dropdown-menu\" ngbDropdownMenu>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"user-management\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-user\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.userManagement\">User management</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"jhi-metrics\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-tachometer\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.metrics\">Metrics</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"jhi-health\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-heart\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.health\">Health</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"jhi-configuration\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-list\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.configuration\">Configuration</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"archive\" routerLinkActive=\"active\"\n                               (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-list\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.archive\">Archive</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"audits\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-bell\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.audits\">Audits</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"logs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-tasks\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.logs\">Logs</span>\n                            </a>\n                        </li>\n                        <li>\n                            <a class=\"dropdown-item\" routerLink=\"piece-jointe\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-file-pdf-o\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.pj\">piece-jointe</span>\n                            </a>\n                        </li>\n                        <li *ngIf=\"swaggerEnabled\">\n                            <a class=\"dropdown-item\" routerLink=\"docs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-book\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.apidocs\">API</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active=\"active\" >\n                            <a class=\"dropdown-item\" routerLink=\"entity-audit-event\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-history\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.entity-audit\">Entity Audit</span>\n                            </a>\n                        </li>\n                        <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->\n                        <li *ngIf=\"!inProduction\">\n                            <a class=\"dropdown-item\" href='/h2-console' target=\"_tab\" (click)=\"collapseNavbar()\">\n                                <i class=\"fa fa-fw fa-hdd-o\" aria-hidden=\"true\"></i>\n                                <span jhiTranslate=\"global.menu.admin.database\">Database</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li class=\"nav-item separator\"></li>\n\n                <li *ngSwitchCase=\"false\" class=\"nav-item\">\n                    <button (click)=\"register()\" id=\"register\" class=\"btn btn-primary btn-sm\" jhiTranslate=\"global.menu.account.register\">Register</button>\n                </li>\n                <li *ngSwitchCase=\"false\" class=\"nav-item\">\n                    <button (click)=\"login()\" id=\"login\" class=\"btn btn-default btn-sm\" jhiTranslate=\"global.menu.account.login\">Sign in</button>\n                </li>\n                <li *ngSwitchCase=\"true\" class=\"nav-item\">\n                    <button (click)=\"logout()\" id=\"logout\" class=\"btn btn-default btn-sm\" jhiTranslate=\"global.menu.account.logout\">Sign out</button>\n                </li>\n                <li class=\"nav-item separator\"></li>\n\n                <li class=\"nav-item lang\">\n                    <a *ngFor=\"let language of languages\" [ngClass]=\"language\" [jhiActiveMenu]=\"language\" href=\"javascript:void(0);\" (click)=\"changeLanguage(language);collapseNavbar();\">{{language}}</a>\n                </li>\n\n            </ul>\n        </div>\n    </div>\n</nav>\n<div *ngIf=\"isAuthenticated() && (isEnseignant || isReferent || isGestionnaire || isAdmin || isAdminSys)\" id=\"navbar-backoffice\">\n    <div class=\"spaceHeader\"><a routerLink=\"/\" jhiTranslate=\"global.menu.gestionnaire.main\"></a></div>\n\n    <div class=\"spaceMenus bg-faded\">\n        <ul class=\"nav mr-auto\" *ngIf=\"isAuthenticated()\">\n            <!--<li class=\"nav-item\">-->\n                <!--<a class=\"nav-link\" routerLink=\"home\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.accueil\">accueil</span></a>-->\n            <!--</li>-->\n            <li class=\"nav-item\">\n                <a class=\"nav-link\" routerLink=\"candidature\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.candidats\">candidats</span></a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link\" routerLink=\"reinscription\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.reinscription\">reinscription</span></a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin|| isReferent || isGestionnaire || isAdminSys\">\n                <a class=\"nav-link\" routerLink=\"formation\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.formations\">formations</span></a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys\">\n                <a class=\"nav-link\" routerLink=\"campagne\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.campagnes\">campagnes</span></a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys\">\n                <a class=\"nav-link\" routerLink=\"parametrage\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.gestionnaire.parametres\">parametres</span></a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys\">\n                <a class=\"nav-link\" routerLink=\"user-management\" routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.admin.userManagement\">User management</span>\n                </a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys || isGestionnaire\">\n                <a class=\"nav-link\" routerLink=\"user-echange\" [queryParams]=\"{'typeEtudiant':'0'}\"\n                   routerLinkActive=\"active\"><span jhiTranslate=\"global.menu.admin.userEchange\">User echange</span>\n                </a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys || isGestionnaire\">\n                <a class=\"nav-link\" routerLink=\"user-echange\" [queryParams]=\"{'typeEtudiant':'1'}\"\n                   routerLinkActive=\"active\"><span\n                    jhiTranslate=\"global.menu.admin.userCampagne\">Restriction email</span>\n                </a>\n            </li>\n            <li class=\"nav-item\" *ngIf=\"isAdmin || isAdminSys \">\n                <a class=\"nav-link\" routerLink=\"archive\" routerLinkActive=\"active\"><span\n                    jhiTranslate=\"global.menu.admin.archive\">Archive</span>\n                </a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link\" routerLink=\"aide\" routerLinkActive=\"active\"><span\n                    jhiTranslate=\"global.menu.admin.aide\">Aide</span>\n                </a>\n            </li>\n            <!--<li class=\"nav-item\">-->\n            <!--<a class=\"nav-link\" routerLink=\"user-help\" routerLinkActive=\"active\"><span-->\n            <!--jhiTranslate=\"global.menu.admin.aide\">Aide</span>-->\n            <!--</a>-->\n            <!--</li>-->\n        </ul>\n    </div>\n</div>\n\n<div *ngIf=\"isAuthenticated() && isUser\" class=\"spaceHeader\">\n    <a routerLink=\"/\" jhiTranslate=\"global.menu.candidature.space\"></a>\n    <ul class=\"nav navbar-right\">\n    <li class=\"nav-item\">\n        <a class=\"nav-link\" routerLink=\"faq\" jhiTranslate=\"footer.faq\">FAQ</a>\n    </li>\n    </ul>\n</div>\n"

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"sk-circle\" *ngIf=\"display === true\">\n    <div class=\"sk-circle1 sk-child\"></div>\n    <div class=\"sk-circle2 sk-child\"></div>\n    <div class=\"sk-circle3 sk-child\"></div>\n    <div class=\"sk-circle4 sk-child\"></div>\n    <div class=\"sk-circle5 sk-child\"></div>\n    <div class=\"sk-circle6 sk-child\"></div>\n    <div class=\"sk-circle7 sk-child\"></div>\n    <div class=\"sk-circle8 sk-child\"></div>\n    <div class=\"sk-circle9 sk-child\"></div>\n    <div class=\"sk-circle10 sk-child\"></div>\n    <div class=\"sk-circle11 sk-child\"></div>\n    <div class=\"sk-circle12 sk-child\"></div>\n</div>\n"

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(346);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(347);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(348);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(12);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(22);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(255);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(439);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(444);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(559);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(617);

/***/ }),
/* 473 */,
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var platform_browser_dynamic_1 = __webpack_require__(205);
var prod_config_1 = __webpack_require__(202);
var app_module_1 = __webpack_require__(201);
prod_config_1.ProdConfig();
if (false) {
    module['hot'].accept();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.CadensAppModule);


/***/ })
],[474]);


// WEBPACK FOOTER //
// 7f99d21e4d023f820091.main.bundle.js